export const statesList = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli",
  "Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

export const district = [
  {
    state: "Andaman and Nicobar Islands",
    districts: [
      {
        district: "Nicobar",
        localities: [
          "35 KM Beach",
          "Bananga",
          "Bay of Bengal: 8.0N 91.0E",
          "Bompoka Island",
          "Breakwater Jetty Area, Campbell Bay",
          "Car Nicobar",
          "Chingan-Campbell Bay",
          "Chowra Island",
          "GNBR East-West road",
          "Galathea",
          "Galathea Bay",
          "Govind Nagar Road",
          "Govinda Nagar Tsunami Shelter",
          "Great Nicobar Biosphere Reserve",
          "Jogindarnagar Beach",
          "Kamorta",
          "Kamorta  Island",
          "Katchal, Island",
          "Komath (Little Nicobar)",
          "Kosingdon, Great Nicobar Island",
          "Laxmi Nagar",
          "Magarnala-Chengappa bay",
          "Maggar Nala",
          "Menchal Island",
          "Military Engineer Services (MES)",
          "Murda Khadi",
          "Nancowrie Jetty",
          "Nancowry",
          "PWD Guest House, Great Nicobar",
          "Pilo Milo Island (OBI)",
          "Shastri Nagar",
          "Shastri Nagar Nala",
          "Shastri Nagar Wetland",
          "Teressa Island--General Area",
          "Test Checklist Andaman and Nicobar Islands, IN (7.008, 93.937)",
          "Tillangchong",
          "Trinkat Island",
          "near Great Nic-Bakery",
        ],
      },
      {
        district: "North and Middle Andaman",
        localities: [
          "Aerial Bay Jetty, Diglipur",
          "Andaman-Baratang I.",
          "Austein Strait (near Chengappa bridge)",
          "Austin, Andaman Trunk Road, Mayabunder",
          "Baludera beach mayabunder",
          "Baratang",
          "Barren Island, Andaman IN",
          "Base of Saddle Peak, Lamia Bay",
          "Buchanan Island",
          "Chails Ek, North Andaman Island",
          "Dhaninallah Vill., Rangat, Middle Andaman",
          "Interview Island",
          "Kadamtala",
          "Kalipur Beach",
          "Kalipur Beach, Diglipur",
          "Kalpong River, Khudirampur, Diglipur",
          "Khudirampur",
          "Khudirampur Forest area, Diglipur",
          "Koh Hee Homestay, Webi",
          "Lamiya Bay",
          "Limestone Cave, Baratang",
          "Long Island",
          "Mangrove Walkway Dhanih Nallah",
          "Mangrove Walkway, Dhani Nallah",
          "Middle Andaman (OBI)",
          "Mud Volcano, Baratang",
          "Mud volcano",
          "Narcondam Island",
          "Parnashala Forest Nursery",
          "Pristine Beach Resort",
          "Radha Nagar mangrove creek",
          "Ramnagar Beach",
          "Rangat Bay, Middle Andamans",
          "Rangat to Baratang Road",
          "Range Office Parnasala",
          "Sabari, Middle Andaman",
          "Saddle Peak National park",
          "Saddle peak",
          "Shyamnagar Creek",
          "Smith Island",
          "Smith and Ross Islands",
          "Subashgram, Kalpong River Bank",
          "Webi village",
          "Yeretta, Middle Andaman",
          "shyamkund jetty",
          "way to Yerrata to Long Island",
        ],
      },
      {
        district: "South Andaman",
        localities: [
          "6.2 Mile North on SH1",
          "9 Family Village Rutland",
          "ANET mangroves",
          "ANET to Ghumai (Rd Junction)",
          "ANET to North Wandoor beach",
          "ANIIMS  Campus",
          "Aberdeen Clock Tower, Port Blair",
          "Aberdeen, Port Blair",
          "Andaman Cellular Jail",
          "Andaman College",
          "Andaman Sea",
          "Andaman and Nicobar Environment Team (ANET) Research Station",
          "Andaman sea Twins to Jolly Bouy",
          "Andaman-Mahatma Gandhi Marine National Park",
          "Anidco Petrol pump",
          "Attampahad Wetlands (Near AT Villa)",
          "Austinabad Local Village (Amritography Hotspot)",
          "BSI, Garden, Nayashahar",
          "Bada Balu",
          "Badakhari, Rutland",
          "Bamboo Flats",
          "Bathubasti area",
          "Bichdera",
          "Bidnabad",
          "Brijgunj Campus",
          "Brookshabad Pondicherry University Campus",
          "Burmanallah",
          "Butler Bay Beach",
          "CARI-ICAR Campus",
          "CPWD Government Guest House",
          "Central Island Agriculture Research Institute",
          "Chatham Jetty",
          "Chidiyatapu Biological Park",
          "Chidyatapu Biological Park",
          "Chota Balu Beach",
          "Chouldari Village",
          "Chouldari wetland",
          "Chouldhari wetland",
          "Collinpur",
          "Corbyn's Cove Beach",
          "D&K City",
          "DIET Boys Hostel",
          "Dr. BR Ambedkar IT",
          "Elephant Beach Trail, Havelock Island",
          "Elephant beach",
          "Elephanta Trek Route",
          "Ferragunj forest",
          "Ferrargunj forest",
          "Flag Point, Port Blair",
          "Flat Bay",
          "Forest Department Nursery",
          "Forest Patch, Brookshabad",
          "Gandhi park",
          "Garacharma Inner Wetland",
          "Garacharma Solar Plant",
          "Garacharma Wetland",
          "Govind Nagar Beach",
          "Govindnagar Hotspot (SS Point)",
          "Green Imperial Resort",
          "Grub Island",
          "Guptapara",
          "Haddo Mini Zoo",
          "Harminder Bay",
          "Hathitapu Jetty",
          "Havelock Island",
          "Havelock Island Jetty",
          "Havelock island",
          "Havelock island beach resort",
          "Hornbill Nest Resort",
          "Hornbill Nest Resort Road",
          "Hut Bay beach",
          "Hut bay, Nursery Area",
          "ICAR KVK Krishi Vigyan Kendra",
          "ICMR COMPLEX",
          "Indira Bazar",
          "Jackson Bay, Little Andaman",
          "Jahaji Forest Area",
          "Jalakara",
          "Jawaharlal Nehru Rajkeeya Mahavidyalaya",
          "Jirkatang",
          "Jodhakilan (MA Hotspot)",
          "Jorakaan- Sippighat wetlands",
          "Junglighat Hotspot",
          "Kalapathar",
          "Kalapathar Village",
          "Kalapather Beach",
          "Kalatang Hotspot",
          "Kurmadera",
          "Lighthouse",
          "Little Andaman--General Area (OBI)",
          "Lotus Point (Enroute Farm Tikrey)",
          "Mahatma Gandhi Marine National Park",
          "Malapuram Forest, SA",
          "Malapuram forest area",
          "Manipur Parvat NP",
          "Manjery (Marine national park)",
          "Marina Park, Port Blair",
          "Megapode Island",
          "Megapode-Inhinloe-Coastal",
          "Mount Harriet NP",
          "Munda Pahad Beach",
          "Munda Pahadh",
          "Munda Pahar Beach Road (Forest Area)",
          "Namunaghar",
          "Nature Park and Interpretation Centre, Port Blair",
          "Nayashahar Wetlands",
          "Neil Island",
          "Netaji Subhash Chandra Bose Island",
          "New Wandoor Jetty",
          "North Bay Island",
          "North Wandoor beach",
          "Ograbraj",
          "Ograbraj Wetland 1",
          "Ograbraj Wetland 3",
          "Ograbraj Wetlands",
          "On the way to Chidiya Tapu",
          "Organic Horticulture Farm, Sippighat",
          "Panighat Jetty Mangrove, South Andaman",
          "Pearless hotel garden",
          "Phoenix Bay Jetty",
          "Phongibalu, Mahatma Gandhi Marine National Park",
          "Photo Nalla Wetland , Rutland",
          "Police Lanes",
          "Police training School",
          "Port Blair",
          "Port Blair Harbour",
          "Port Mort Campus, SA",
          "R.K Pur Dam, Little Andaman",
          "Radhanagar beach, Havelock island",
          "Red Skin Island",
          "Road to Chidiya Tapu",
          "Rose Island",
          "Ross Island",
          "Rutland Opp Jolly Bouy",
          "SILVER SAND BEACH RESORT",
          "Salt Marsh, Sippighat",
          "Saltmarsh, sippighat",
          "Science Center",
          "SeaShell Samssara Neil  Resort Backyard",
          "Shadipur Village",
          "Shaheed Dweep",
          "Shoal Bay 19 Beach",
          "Shoal Bay area forest/mangroves",
          "Shoal Bay waste management Spot",
          "Shoal bay",
          "Shoalbay Forest trek",
          "Silver Sand Beach Resort, Wandoor",
          "Silver Sands,Havelock",
          "Sippighat",
          "Sippighat -Shiva Mandira",
          "Sippighat-2",
          "South Bay to Light House Road",
          "South Cinque",
          "Stewartgunj Wetland",
          "Symphony Samudra Beachside Jungle Resort",
          "Tilar Siro Andamans",
          "Tirur Road",
          "Trek route Cobra_Beach to Jahaji_Beach",
          "Veer Savarkar International Airport",
          "Whistling woods - Stargazing Spot",
          "White Surf Waterfall",
          "White surf waterfall",
          "Wild Grass Resort (Main Area)",
          "Wimberlygunj",
          "Wimberlygunj Wetlands",
          "havelock, kala pathhar beach road",
          "kadaka chang wetland, submerge during tsunami",
          "sitapur beach",
        ],
      },
    ],
  },
  {
    state: "Andhra Pradesh",
    districts: [
      {
        district: "Anantapuramu",
        localities: [
          "Allapalle wetland",
          "Amagondapalem Lake",
          "Anantgram Farms",
          "Anantgram Farms Phase 1",
          "Anantgram Farms Phase 2",
          "Anantgram Farms Phase 3",
          "Bevenahalli Lake, Hindupur",
          "Bukkapatnam Reservoir--Bukkapatnam Side",
          "Bukkapatnam wetland",
          "C. Kodige Palli Kere",
          "Charlapalli Dam",
          "Chennakesava Swamy Temple, Siddharampuram",
          "Chennarayunipalli Quarry Canal",
          "Chennekothapalle farmland and scrub",
          "Cherlopalli Wetland",
          "Cheruvu Katta, Ananthapur",
          "Chilamathur wetland 1",
          "Chintalakunta Lake",
          "Chitravathi River--Puttaparthi",
          "Devarapalli",
          "Dharmavaram Junction Railway Station",
          "Dharmavaram Lake",
          "Dwaraka Villas",
          "Gangampalli Forest",
          "Gobarakunta Lake",
          "Gopindevarapalli Lake",
          "Gowrapuram Wetland 2, Andhra Pradesh",
          "Hindupur Railway Station",
          "Jeedipalli Dam",
          "Kalpavalli CCF--Attuva Watchtower",
          "Kambalaparthi Kunta",
          "Kanekal Lake",
          "Kothacheruvu (Bukkapatnam Lake)",
          "Kothapalle Canal Bridge",
          "Lepakshi Temple",
          "Makkajipalli Pond (Quarry), Gutturu",
          "Mid Pennar Reservoir",
          "Mudigubba Lake",
          "Muneppa Cheruvu(Lake)",
          "Mustikovila Dam Area",
          "Mustikovila Dam--Kalpavalli Side",
          "Mutyala Cheruvu",
          "Nagasamudram Lake",
          "Nandi Farm Resort",
          "Navabukota wetland",
          "Obuldevaracheruvu wetland",
          "Old Singanaguttapalli",
          "PABR Dam, Korrakodu",
          "Palasamudram Lake",
          "Panchavati Vilas, Puttaparthi",
          "Panthla Cheruvu",
          "Parnapalli Dam (Chitravathi Balancing Reservoir)",
          "Patakottacheruvu",
          "Pedapalli Check Dam",
          "Pedda Cheruvu (Satarlapalle)",
          "Peddaballe Dam viewing point",
          "Penukonda Fort Road",
          "Prashanthi Nilayam Ashram",
          "Ramapuram Cheruvu Lake",
          "Ramapuram lake(Wetland)",
          "Rangamma Cheruvu",
          "Singanamala Cheruvu",
          "Sreedharaghattu Lake",
          "Sunnampalli Lake",
          "Tekulodu Lake",
          "Thimmamma Marrimanu",
          "Timbaktu Farm",
          "Timbaktu--Kalpavalli Restoration Area",
          "Timbaktu--Office, Chennekothapalli",
          "Vankamaddi Cheruvu, Kadiri",
          "Vankarakunta wetland",
          "Veeraobanapalle wetland",
          "Veerapura",
          "Veerapuram Bird Sanctuary",
          "Vengalammacheruvu",
          "Yenumulapalli Lake",
          "guntakal",
        ],
      },
      {
        district: "Chittoor",
        localities: [
          "ARK Nagar Lake",
          "Agastya International Foundation Campus, Kuppam",
          "Akkarampalle Lake",
          "Annaswamipalle Lake",
          "Annaswamipalli Lake",
          "Attrapalli nallapalli valley",
          "Bhupal housing colony",
          "Bomma Samudram/Marakalakuppam Lake",
          "CMC Vellore, Chittoor campus",
          "Chellore Dam - Sadashivakona",
          "Chennayagunta, Tirupati",
          "Cherlapalle",
          "Cherlo Palli",
          "Chindepalli Lake",
          "Chittoor Mini-Forest",
          "DES's Fergusson Center(Tirupati)",
          "Diguvapalayam",
          "Doracheruvu",
          "Dravidian University (Restricted Access), Kuppam",
          "Elamandyam Lake",
          "Forest trail opposite Arvind Eye Hospital (SV National Park)",
          "Fortune Grand Ridge Lake",
          "Gogarbham Reservoir",
          "Gonupothula Kunta Tank",
          "Gorivimakulapalle Kotha Cheruvu  (గొరివిమాకులపల్లె కొత్త చెరువు)",
          "Gorivimakulapalli fields",
          "Gowri Shankara Kona and Waterfalls (గౌరీశంకర కోన మరియు జలపాతం)",
          "Guravaraju palli Lake",
          "Guthivari Palli Lake",
          "Horsley Hills",
          "IISER Tirupati--Mangalam Campus",
          "IISER Tirupati--Yerpedu Campus",
          "IISER-Tirupati Quarters",
          "IIT Sricity",
          "IIT Tirupati",
          "IIT Tirupati Pond",
          "Inagalur Grasslands",
          "Jangalapalli Lake (yerpedu)",
          "Japali Temple Pathway",
          "Japali Temple(woodland area)",
          "KP Dam Road(restricted), Tirumala",
          "Kaigal Waterfalls",
          "Kailasakona Waterfalls",
          "Kalyani Dam",
          "Karakambadi Lake",
          "Kendriya Vidyalaya 2 School, Tirupati",
          "Kodandarama Temple, Vontimitta",
          "Komati Vaani Cheruvu (lake)",
          "Kondalamadugu to Horsley Hill (Ghat road)",
          "Konkachennaiahgunta Lake 2",
          "Kotala Cheruvu, Kadiri",
          "Kotramangalam Lake",
          "Koundinya WLS--Hanuman Temple",
          "Krea University, Sricity",
          "Krishnampalli Lake (yerpedu)",
          "Kuppam Lake",
          "Kuppam Railway Station",
          "Kurrakalva Lake",
          "Lake opposite IIT Tirupati",
          "Lakshmi nagar Lake",
          "MVR Nilayam, Yerpedu",
          "Madamala Grasslands (మడమల గడ్డి భూములు)",
          "Mahanandeswara Temple (మహానందీశ్వర ఆలయం)",
          "Mallappa Konda Betta",
          "Mallimadugu Reservoir, Golla Palli, Andhra Pradesh",
          "Mamadugu Forest",
          "Mandapampalli Waterfall Trail",
          "Masonic Grounds",
          "Merlapaka Lake",
          "Mittoor village lake and paddy fields",
          "Mudimadugu Hills",
          "Nandakam Rest House",
          "Naniyala Elephant Camp - Koundinya WS (ననియాల ఎలిఫెంట్  క్యాంపు)",
          "Nayanicheruvu tank",
          "Nerabailu-- Bhakarapet-Talakona road (open habitat)",
          "PB Natham Lake",
          "Pagali Village",
          "Palamaner",
          "Palasamudram",
          "Papavinasanam",
          "Peddamandyam Wet lands",
          "Pedderu Project Dam Road, Zunjurupenta",
          "Peepal Grove School",
          "Peethula Cheruvu, Ramakuppam",
          "Pennagadam lake",
          "Perur lake",
          "Pungamma Cheruvu",
          "Rajulapalem Lake (yerpedu)",
          "Regional Science Center, Tirupati",
          "Rishi Valley (General Area)",
          "Rishi Valley--Krishnamurti Sagar",
          "Rishi Valley--School Campus",
          "Rishi Valley--Valley Mouth",
          "S.Gollapalli Cheruvu (స్ గొల్లపల్లి చెరువు)",
          "S.V. National Park -- Canteen(Talakona)",
          "SV Agricultural College & Research Station, Tirupati",
          "SV University, Tirupati",
          "SV Vedic University",
          "SV Veterinary University, Tirupati",
          "SV Zoo Park, Tirupati, Andhra Pradesh",
          "Saamicheruvu, Madanapalle, Chittoor Dt",
          "Sadasiva Kona Trail",
          "Sahasra Lingeshwara Swami Temple (సహస్ర లింగేశ్వర స్వామి ఆలయం)",
          "Science city Lake (yerpedu)",
          "Settipalli lake",
          "Shanthipuram (Palar River)",
          "Shrivari Paadaalu",
          "Siddalagandi Dam",
          "Springdale lake, Karakambadi road, Tirupati",
          "Sreenivasapuram Lake (yerpedu)",
          "Sri Padmavati Women's University, Tirupati",
          "Sri Venkateswara NP (general area)",
          "Sri Venkateswara NP--Dargah Shareef",
          "Sri Venkateswara NP--Mamanduru",
          "Sri Venkateswara NP--Nagara Vanam",
          "Sricity Creek",
          "Talakona Road-- Yerravaripalem",
          "Talakona Waterfalls",
          "Talakona-- Nellakona pool",
          "Talakona-- Siddalagandi Dam road",
          "Tank A, Sri City",
          "Thambalapalle",
          "Thettupalli, Bhakarapeta road, Andhra Pradesh",
          "Thiminaidupalem, Tirupati.",
          "ThimmaiahGunta Lake 1",
          "Thondamanadu Lake",
          "Thukivakam Lake",
          "Tirumala",
          "Tirumala Ghat Rd-1",
          "Tirumala Ghat Rd-2",
          "Trail behind LIC Training Center, Mangalam",
          "Tummalagunta lake",
          "Upparapalem Lake",
          "Vendugampalle Lake",
          "Venkatapuram Lake",
          "Venugopalasamy Swamy Temple",
          "Veterinary Hospital Lake (Renigunta)",
          "Yerpedu large lake",
          "Yerpedu small lake",
          "swarnamukhi river Thandlam chittoor county Andhra Pradesh",
        ],
      },
      {
        district: "East Godavari",
        localities: [
          "AP State Forest Academy, Rajahmundry",
          "Addateegala - Y Ramavaram road",
          "Antarvedi--Light House Beach",
          "Bhadrachalam-Chinturu Highway ( near Marrigudem)",
          "Bhairavapalem Fishing Jetty",
          "Bhupathipalem Reservoir",
          "Chinnayapalem tank",
          "Chinturu--General Area",
          "Chirra Yanam (చిర్ర యానం)",
          "Chollangi Salt Pans",
          "Coringa Wildlife Sanctuary--Walkway & Boat House",
          "Coringa Wildlife Santuary",
          "Coromandel International Ltd",
          "Creek near Coromandel",
          "Dairy Farm Road Wetlands",
          "Dindi : General area",
          "District Police HQ",
          "Donkarayi Dam",
          "Dosakayalpalli Cheravu Wetland",
          "Dumpa valasa Waterfalls Road",
          "Durga Temple Surroundings -- Maredumilli",
          "Godavari MahaPushkara Vanam(Nagaravanam Rajahmundry)",
          "Godavari River Bank, Bhadrachalam (గోదావరి నది ఒడ్డు, భద్రాచలం)",
          "Godavari River--Bhairavapalem Mudflats",
          "Gokavaram Tank",
          "Gudisa road(pullangi)",
          "Gummalla Doddi Lake",
          "Hope Island, Kakinada",
          "Irlavada fields",
          "Kakanvada road, Maredumell",
          "Kakinada Beach Road (towards Uppada)",
          "Kakinada Fishing Jetty (Kumbhabishekam)",
          "Kanivada Road, Banda",
          "Katrenikona Lake (కట్రేనికోన చెరువు)",
          "Kuduru To Woods Trail",
          "Maasaani Tippa/Balusuthippa Mangroves",
          "Magasanitippa Beach",
          "Mallavaram Reserve forest",
          "Mallavaram Tank",
          "Maredumalli-Pamuleru bridge",
          "Maredumilli",
          "Maredumilli -- Sokuleru Vagu view point",
          "Maredumilli--Coffee Plantation",
          "Maredumilli--Jalatarangini Water Fall",
          "Maredumilli--Jungle Star Eco Camp",
          "Maredumilli--Pullangi Road",
          "Maredumilli--Rubber Plantation",
          "Mirthipadu Wetlands",
          "Mothugudem",
          "Mudflats Opposite Coromandel(sea-side), Kakinada",
          "Palivela Bridge",
          "Paloma Holiday Resorts",
          "Pampa Reservoir",
          "Pamuleru Bridge - Maredumilli",
          "Panchaneti Creeks",
          "Papikonda National Park",
          "Pochavaram boating point",
          "Potlavada, Maredumilli, Andhra Pradesh",
          "Pulasa Lanka",
          "Pullangi-Chaparai Route",
          "Pullangi-Gurtedu Road",
          "Punyakshetram",
          "Rajavaram Pond",
          "Samanthakuru Mangroves",
          "Sankaraguptam Canal",
          "Sokuleru Vagu Swimming Point",
          "Sokuleru Vagu View Point and Surroundings",
          "Soodikonda Range Office",
          "Srirampuram Road",
          "Surasaniyanam Marshlands",
          "Thammayya Tank, Near Pithapuram",
          "Tiger Camp, Maredumilli",
          "Uligogula Reserve Forest, Peddipalem",
          "Uttaluru road, Maredumelli",
          "Vanavihari Eco Tourism Centre, Maredumilli",
          "Vijjeswaram",
          "Wetland opposite Coromandel fertilizers",
          "Y Ramavaram - Sesharayi road",
          "Y.Ramavaram - Jyothimamidi forest road",
          "velugubanda",
        ],
      },
      {
        district: "Guntur",
        localities: [
          "Atmakur Lake, Mangalagiri",
          "Budampadu cheruvu",
          "Camp Road, Mangalagiri",
          "Karakatta Road (Near irrigation Warehouse)",
          "Krishna River bridge, Mattapalli",
          "Krishna River--Godavarru",
          "Krishna River--Vallabhapuram",
          "Krishna WLS -- Kothapalem Mangrooves",
          "Krishna WLS -- Kothapalem Village",
          "Krishna WLS -- Uppu Revu Mudflats",
          "Mangalagiri Reserve Forest",
          "Muttayapalem Reserve forest (Bapatla-Suryalanka road)",
          "Nagara banda",
          "Nagaravanam Park (Urban Forest), Gunturu",
          "SRM University AP",
          "Sangameshwara swamy Temple, Kattempudi",
          "Tadikonda Cheruvu (lake)",
          "Templehill Eco-park, AIIMS, Mangalagiri",
          "Uppalapadu Bird Sanctuary",
          "VIT-AP University",
          "Veluru lake",
          "Wetland Near High Court of Andhra Pradesh",
        ],
      },
      {
        district: "Krishna",
        localities: [
          "Ambapuram canal trail",
          "Bhavani Island,Vijayawada (16.516, 80.592)",
          "Brahmalingam Cheruvu",
          "Budameru bridge Uppuluru(16.5055,80.7760)",
          "Chilakalapudi, Machilipatnam",
          "Edupugallu Pond",
          "Elachetladibba",
          "Elaprolu Lake(Gudurupadu)",
          "Fields in Chilakalapudi ( Tavisipudi)",
          "Fields in PNT colony",
          "Fields near Cyclone Detection Radar Station",
          "Gilakaladindi",
          "Gollanapalle hill",
          "Guduru",
          "Hamsaladeevi Marshes Fields (Koduru to KWLS Road)",
          "Jakkampudi Fields",
          "Jeevana Vikasa Vidya Vanam (Restricted)",
          "Kanuru Pond, Vijayawada",
          "Kavuluru Cheruvu (Lake)",
          "Kethanakonda",
          "Kolleru Bird Sanctuary -- Atapaka (కొల్లేరు పక్షి అభయారణ్యం --  ఆటపాక)",
          "Kondapalli Khilla (fort) Ghat Road, Andhra Pradesh",
          "Kondapalli Reserve Forest",
          "Kondapalli Reserve Forest--General Area",
          "Kondapalli Reserve Forest--Trilochanapuram Ash Pond",
          "Kondapavuluru road (next to hill)",
          "Kondapavuluru rural lake",
          "Kothuru Trail (near temple)",
          "Kotturu Lake",
          "Kotturu Reserve Forest Area",
          "Kotturu Tadepalli Lake 2",
          "Kotturu Tadepalli lake",
          "Krishna Karakatta Road",
          "Krishna River--Kasaraneni Vari Palem Marshes",
          "Krishna River--Madduru",
          "Krishna Wildlife Sanctuary (Hamsaladeevi road)",
          "Krishnavaram/Kommuru Lake",
          "Lankapalle",
          "Malakayalanka Mangroves",
          "Manginapudi Beach",
          "Mulapadu - Gaddamanugu Road (G Konduru side)",
          "Mulapadu Forest",
          "Mustabada rural Lake",
          "Nagaravanam(Urban forest), Ambapuram",
          "Nainavaram",
          "Nunna Lake",
          "Nunna Urban Lake",
          "Pangidi Forest And Pond",
          "Paritala Waterfalls",
          "Patamatalanka",
          "Prakasam Barrage,Vijayawada",
          "Prudhveeshwara Swamy Temple",
          "Pydurupadu Lake 1",
          "Pydurupadu Lake 2",
          "Sitaramapuram Village",
          "Sultananagaram, Machilipatnam",
          "Surampalli lake",
          "Vedurupavuluru Fields",
          "Vedurupavuluru Small Lake",
          "Velagaleru Village Lake",
          "Vemavaram lake trail (behind hill)",
          "Vijayawada Junction",
          "Vura Cheruvu Kapileswarapuram",
        ],
      },
      {
        district: "Kurnool",
        localities: [
          "Ahobilam",
          "Alaganuru Reservoir",
          "Diguvametta - Nandyala ghat road",
          "Dornala to Srisailam road",
          "Erragudur Regulator",
          "Gargeyapuram Tank",
          "Gundla Brahmeswaram FD Resthouse and Temple (restricted)",
          "Isukagundam Rest house to GBM Resthouse, Eastern Nallamalai road (restricted)",
          "Jagannatha Gattu Hill",
          "Laxminarasimha Reservoir",
          "Malyala - Srisailam backwaters",
          "NSTR--Sundipenta",
          "Nallamalai Jungle Camp, Pacherla",
          "Nallamalla Jungle Camp Bairluty",
          "Nallamalla Jungle Camp, Pacherla",
          "Nancherla Railway Station",
          "Nandyal Cheruvu",
          "Panchalingala Tungabhadra dam on NH7",
          "Parumanchala Tank",
          "Phala dhara water falls",
          "Pothireddypadu Head Regulator",
          "Rollapadu Wildlife Sanctuary",
          "Rudravaram Forest, Ahobilam",
          "Siddapuram Reservoir",
          "Srisailam Dam View Point",
          "Srisailam Roadbend",
          "Srisailam dam (view point & downstream)",
          "Tungabhadra River--Mantralayam",
          "Velugodu Balancing Reservoir",
          "Vengallam Palle Lake",
        ],
      },
      {
        district: "Prakasam",
        localities: [
          "Bhairavakona",
          "Bhavanasi Lake, Singarakonda",
          "Cumbum Lake Backwaters (South)",
          "Cumbum Tank",
          "Dream Valley Rivulet",
          "Gundamala Beach, Motumala, Prakasam district",
          "Isukagundam FD Resthouse (restricted)",
          "Jamukuladinne Lake (జాముకులదిన్నె చెరువు)",
          "Kallur Lake",
          "Karedu Beach",
          "Mallavaram Dam--Annangi Backwaters",
          "Mallavaram Dam--Gundlakamma River Bridge",
          "Markapur Lake (మార్కాపూర్ చెరువు)",
          "Marlapadu Lake & Surrounds",
          "Nallamala Forest, NSTR",
          "Obulesuni penta to Isukagundam, Eastern Nallamalai road (restricted)",
          "Obulesunipenta FD Resthouse (restricted)",
          "Pelluru Lake,Ongole",
          "Ramathertham Sagar",
          "Santhanuthalapadu Lake",
          "Thummalabailu, NSTR",
          "Thurimella Lake, South Bank",
          "Thurimella lake (Thappetavani Cheruvu)",
          "Valluru Lake, Prakasam district",
          "West Naidupalem Lake",
        ],
      },
      {
        district: "Sri Potti Sriramulu Nellore",
        localities: [
          "Allur Lake",
          "Gudur Junction",
          "Jeellapatur",
          "Kanigiri Reservoir",
          "Krishnapatnam Beach (Arkatpalam)",
          "Kudiri Lake",
          "Narasimha Konda",
          "Nelapattu Bird Sanctuary",
          "Nelapattu Bird Sanctuary-2",
          "Nellore Cheruvu",
          "Nellore Railway Station",
          "Padamatinaidupalle Lake",
          "Padmavati Vidyalaya school, Sullurpeta",
          "Papi Reddy Cheruvu",
          "Peddanna Cheruvu",
          "Penna Estuary",
          "Pidatapoluru Cheruvu",
          "Pulicat Bird Sanctuary -- Attakanitippa",
          "Pulicat Bird Sanctuary -- Buckingham Canal",
          "Pulicat Bird Sanctuary -- Irukkam Island",
          "Pulicat Bird Sanctuary -- Karikadu",
          "Pulicat Bird Sanctuary -- Kurudi Village",
          "Pulicat Bird Sanctuary -- Mangodu Island",
          "Pulicat Bird Sanctuary -- Meezuru",
          "Pulicat Lake (AP section)",
          "Ramanna Tank",
          "Sarvepalli Cheruvu",
          "Somasila Dam",
          "Sri Potti Sriramulu Nellore",
          "Sriharikota Forest",
          "Sullurpeta Lake",
          "Sullurupeta Railway Station",
          "Udayagiri Vellikonda RF Scrub (Restricted Area)",
          "Vangallu Cheruvu",
          "Vasili Lake",
          "Zammavaram Tank",
        ],
      },
      {
        district: "Srikakulam",
        localities: [
          "Arasavilli - Voppangi lake, Srikakulam.",
          "Badabanda Pond, Nandigama",
          "Balliputtuga Lake",
          "Bejjipuram Cheruvu",
          "Budumuru lake",
          "Chinna Karrivani Palem Beach",
          "Donubhai forest",
          "Gelagala Cheruvu",
          "Kalingapatnam Estuary",
          "Kalingapatnam Wetlands",
          "Kalingapatnam(Kokkiliputtuga) Estuary",
          "Karridi Cheruvu (Karrivani Cheruvu)",
          "Kotha Cheruvu (lake)",
          "Kothapalem Lake",
          "Madduvalasa Reservoir",
          "Nagavali River Mouth(PD Palem Beach)",
          "Narsamma cheruvu",
          "Naupada Salt Pans",
          "Naupada Swamps",
          "Nelavanka Estuary",
          "Patrunivalasa Lake",
          "Pedda Cheruvu, Palasa",
          "Pedda Cheruvu, Tekkali",
          "Raghunadhapuram Lake",
          "S Purla Cheruvu(Pathameghavaram)",
          "Smart School, Palasa",
          "Swetha Pushkarini",
          "Sylada Cheruvu",
          "Telineelapuram (తేలినీలాపురం)",
          "Telukunchi Bird Nesting site",
          "Vemulavada lake (Dali Cheruvu)",
          "Vomaravalli-vamsadhara River Bank",
        ],
      },
      {
        district: "Visakhapatnam",
        localities: [
          "28 Town Kotha Road, Visakhapatnam",
          "Adavivaram Cheruvu",
          "Aguru, Andhra Pradesh, IN (18.26, 83.077)",
          "Anandapuram Pond",
          "Anantapuram lake",
          "Ananthagiri Coffee Plantation",
          "Ananthagiri--Thatiguda Waterfalls",
          "Andhra University North Campus",
          "Andhra University, South Campus",
          "Araku Valley--Araku Pinery",
          "Araku Valley--Forest Retreat & Eco Park",
          "Banta Pond",
          "Biodiversity Park -Botanical Garden",
          "Bojjana Konda",
          "Boni Lake",
          "Central Park Visakhapatnam",
          "Chimidipalli Railway Station",
          "Dasapalla Hills",
          "Dolphin's Nose",
          "G.V.P COLLEGE OF ENGINEERING FOR WOMEN",
          "GITAM Deemed University",
          "Gambheeramgadda Reservoir",
          "Gangavaram Beach",
          "Gangavaram Port (Restricted)",
          "Gokada Lake",
          "Gollapallu Pond",
          "Gollapallu Thokada Cheruvu",
          "Gosthani River Mouth North side, Bheemili",
          "Gosthani River Mouth, Bheemili",
          "Gottipalli pond",
          "Haritha Hill Resort Ananthagiri",
          "Indira Gandhi Park, Steel plant",
          "Indira Gandhi Zoological Park",
          "Jungle Bells Trail",
          "Kailasagiri Hills",
          "Kalyanapulova Reservoir , Andhra Pradesh, IN",
          "Kambala Cheruvu",
          "Kambalakonda Eco Park",
          "Kambalakonda Wildlife Sanctuary",
          "Kapuluppada lake",
          "Khambala cheruvu (lake)",
          "Konam Reservoir",
          "Kondakarla Ava",
          "Kuntalam Coffee Plantation",
          "Lambasingi",
          "Lotheru",
          "Mangamaripeta",
          "Marripakalu",
          "Mattam Bhimavaram",
          "Meghadrigedda Reservoir",
          "Meghadrigedda downstream channel (Behind Airport)",
          "Modakondamma Temple Trail (Coffee Plantation)",
          "Modakondamma temple trial coffee plantation",
          "Mudasarlova Reservoir",
          "NSTL",
          "NTPC Ash Ponds",
          "Paderu Ghat road",
          "Padmapuram Garden Arakku",
          "Pandavula pancha",
          "Pavurallakonda, Bheemili",
          "Pedda Cheruvu, Narsipatnam",
          "Podugupalem Lake",
          "Porteco Lake, Bonangi",
          "Potnuru Pond",
          "Raiwada Reservoir",
          "Ramakrishna Mission Beach",
          "Red Sandhills",
          "Revenue Colony Park",
          "Rushikonda suburbs, Visakhapatnam, Andhra Pradesh, IN",
          "SR Gardens backside pond",
          "Sagar Nagar Beach (Coco Arena 7)",
          "Sai Neeranjan Colony, Pendurthi",
          "Saripalli Pond",
          "Sariya waterfalls - Devarapalli",
          "Seethakonda Reserve Forest",
          "Seethapalem Beach, NTPC",
          "Sheela  Nagar Pond",
          "Shivaji Park",
          "Sileru",
          "Sileru Project Dam",
          "Simhachalam",
          "St Ann's College for Women",
          "St. Joseph's College for Women",
          "Thagarapuvalasa Pond",
          "Thandava reservoir",
          "Thanthadi beach",
          "The Park Visakhapatnam",
          "Thimmapuram beach front",
          "Thotalkonda Beach",
          "Thotlakonda",
          "Thunglam Pond",
          "Tyda near Araku, Vishakapatnam, Andhra Pradesh",
          "VPT Mangrove Forest",
          "Visakhapatnam Fishing Harbor",
          "Visakhapatnam International Airport (restricted)",
          "Vizag airport wetland",
          "Vuda Park",
          "Waltair Park (restricted)",
          "Water World Beach Visakhapatnam",
          "Yarada Beach, Visakhapatnam",
          "Yerra Cheruvu",
          "Yerravaram Waterfalls , Narsipatnam Sileru Rd",
          "jodugullapalem beach",
        ],
      },
      {
        district: "Vizianagaram",
        localities: [
          "Aditya Nagar Pond",
          "Amakam Toofan Shelter Building",
          "Andra Reservoir",
          "Ayya Koneru",
          "Ayyanapeta Pond",
          "Ayyanapeta duppada pond",
          "Balarampuram Pond",
          "Bangaramma Temple pond",
          "Bhimasangi stream",
          "Bhogapuram Pond",
          "Bondapalli lake",
          "Chinthalavalasa Pond Vizianagaram",
          "Dasannapeta Pond",
          "Gokapeta Cheruvu",
          "Government Degree College Vizianagaram",
          "Kanapaka Lake",
          "Kandivalasa Cheruvu",
          "Komati Cheruvu",
          "Konada Champavathi Estuary",
          "Koti cheruvu",
          "Natavalasa Pond",
          "Pathakopperla Metta lake",
          "Pedada Lake",
          "Pedathadivada Pond",
          "Polipalle Cheruvu",
          "Pradeep Nagar Tank",
          "Pusapatirega lake (vempadam)",
          "Rajula Thimmapuram Pond",
          "Ramavaram Pond",
          "Sivalayam, Boddam (Araku - Visakhapatnam Road)",
          "Thatipudi Reservoir",
          "Vizi Wildlife sanctuary",
          "Vizianagaram Pedda Cheruvu",
          "Vuda Colony pond",
          "Zilla parishad High School--Konada",
        ],
      },
      {
        district: "West Godavari",
        localities: [
          "Bhimavaram Marshy Lands",
          "Bhimavaram Wetlands",
          "Borrampalem Project (Yerrakaluva Dam Backwaters)",
          "Buttayagudem fields (ONE)",
          "CH.S.D.ST. Theresa's (AUTONOMOUS) College for Women",
          "Denduluru Paddyfield",
          "Gollapalem Island",
          "Goraganamudi, West godhavari, A.P.",
          "Grass lands, Peddameram, Bhimavaram",
          "Gubbala Mangamma Thalli Temple",
          "Guntupalli Buddhist  Caves, Jeelakarragudem  - Forest Habitat",
          "Koderu Godavari river point",
          "Kolleru Bird Sanctuary -- Adavikolanu",
          "Kolleru Bird Sanctuary -- Dosapadu",
          "Kolleru Bird Sanctuary -- Madhavapuram",
          "Kolleru Bird Sanctuary -- Paidichintapadu",
          "Kolleru Bird Sanctuary -- Sayimpalem",
          "Koruturu, Papikondalu.",
          "Kovvali - Mondikodu Road, Eluru",
          "Kulayi Cheruvu, Palakollu",
          "Losarigutlapadu",
          "Madhavapuram - Gudivakalanka Road (Kolleru Lake)",
          "Marritippa",
          "Munjuluru Waterfalls",
          "Pattiseema (Godavari River area)",
          "Pedamaina Vanilanka Beach",
          "Pedamainivanilanka beach",
          "Pedda & Chinna Cheruvu,Elamanchili",
          "Perupalem beach",
          "Perupalem wetlands",
          "Sir C R Reddy College for Women, Eluru",
          "Vadalakunta Main Pond & Washerman Pond",
          "Vasishta Godavari Creek",
          "Yerra Kaaluva Barrage",
        ],
      },
      {
        district: "YSR District (Kadapa)",
        localities: [
          "Badvel Big Tank (Badvel Pedda Cheruvu)",
          "Bethayapalli Cheruvu.",
          "Devuni Kadapa Lake",
          "Gandikota",
          "Gunthapalle fields, Andhra Pradesh, IN (14.74, 79.035)",
          "Jyoti Kshetram",
          "Kadapa Airport",
          "Kadapa New Bus Stand",
          "Kadapa Railway Station",
          "Konarajupalli - Muthukur Road, Muthukur, Andhra Pradesh, IN (14.57, 79.087)",
          "Konasamudram Agri Fields",
          "Kothacheruvu",
          "Kothacheruvu Scrub Area",
          "Lingalakunta",
          "Madapur Lake",
          "Maddur Scrub Forest (Restricted Area)",
          "Manzhumiya Park, Kadapa",
          "Nagisettipalli Cheruvu(నాగిసెట్టిపల్లి చెరువు)",
          "PALAKONDALU WATERFALLS",
          "Pennar River Bank, Vontithatipalle",
          "Pennar River Bridge, Siddavattam",
          "Pottipadu",
          "Prabhalaveedu Lake, Andhra Pradesh",
          "Pullur Cheruvu (Lake)",
          "Puttayapalle Lake",
          "Rajiv Gandhi National Park, Proddatur",
          "Reddipalli Pond",
          "Repalli Cheruvu",
          "Sagileru River Bridge (Badvel - Atlur)",
          "Sangasamudram Cheruvu",
          "Sri Lankamalleswara Wildlife Sanctuary",
          "Sri Pothuluri Veerabrahmendra Swamy (Brahmamsagar) Reservoir",
          "Sri Vontimitta Kodanda Rama Swamy Temple",
          "Thangedupalli Lake",
          "Thummalapalli Lake",
          "Uppavari Palli Cheruvu",
          "Utukuru cheruvu(Lake), Kadapa",
          "Veligallu Reservoir, Galiveedu",
          "Venkatasettipalli Cheruvu",
          "Vontimitta Cheruvu (lake)",
          "Yogi Vemana University",
        ],
      },
    ],
  },
  {
    state: "Arunachal Pradesh",
    districts: [
      {
        district: "Anjaw",
        localities: [
          "Chequenty Bridge",
          "Dong Valley",
          "Hawai",
          "Hayuliang",
          "Hayuliang to Chaglagam Rd",
          "Kaho",
          "Khupa",
          "Kibitho (OBI)",
          "Meshai",
          "Namti",
          "Tidding Bridge & Surroundings",
          "Tilam",
          "Tilam to Tilam Top Road",
          "Walong to Helmet Top Road",
          "Walong--General Area",
          "Walong--Helmet Top",
          "Walong--Tilam Top",
        ],
      },
      {
        district: "Changlang",
        localities: [
          "Changlang (OBI)",
          "Deer Camp Uphill",
          "Govt Higher Secondary School",
          "Manmao",
          "Margherita-Changlang Road (OBI)",
          "Miao--General Area",
          "Miao-Vijaynagar Road--32 Mile",
          "Miao-Vijaynagar Road--38 Mile",
          "Miao-Vijaynagar Road--40 Mile",
          "Miao-Vijaynagar Road--55 Mile",
          "Miao-Vijaynagar Road--Gandhigram",
          "Mpen 10th Mile",
          "Mugaphi--Deer Camp",
          "Namdapha Jungle Camp",
          "Namdapha NP & Surroundings--10 Mile",
          "Namdapha NP & Surroundings--13 Mile",
          "Namdapha NP & Surroundings--22 Mile",
          "Namdapha NP & Surroundings--25 Mile",
          "Namdapha NP & Surroundings--Deban",
          "Namdapha NP & Surroundings--Firmbase",
          "Namdapha NP & Surroundings--General Area",
          "Namdapha NP & Surroundings--Haldibari Camp",
          "Namdapha NP & Surroundings--Hornbill camp",
          "Namdapha NP & Surroundings--M'Pen Bridge",
          "Namdapha NP & Surroundings--Miao-Vijaynagar Road",
          "Namdapha NP & Surroundings--Raja Jheel",
          "Namdapha NP--65th Mile",
          "Namdapha NP--67th Mile (Approx)",
          "Namdapha NP--77th Mile",
          "Namdapha NP--Gachhile-1",
          "Namdapha NP--Gandhigram",
          "Namdapha NP--Hazulu",
          "Namdapha NP--Lashichilo",
          "Namdapha NP--Mugaphi-2",
          "Namdapha NP--Musala-1",
          "Namdapha NP--Musala-2",
          "Namdapha NP--Musala-3",
          "Namdapha NP--Shidiku",
          "Noa Dihing River -- Adjacent to Namdapha Jungle Camp",
          "Pangsau Pass",
          "Vijayanagar",
          "Vijaynagar to Deer Camp",
        ],
      },
      {
        district: "East Kameng",
        localities: [
          "Chayang Tajo",
        ],
      },
      {
        district: "East Siang",
        localities: [
          "ATREE Siang Field Station",
          "Banguk",
          "College Of Horticulture and Forestry, CAU",
          "D'Ering WLS & Surroundings--General Area",
          "Forest (North of D'Ering WLS)",
          "Jawaharlal Nehru College",
        ],
      },
      {
        district: "Kamle",
        localities: [
          "Subansiri Dam- Pragati Setu",
        ],
      },
      {
        district: "Kurung Kumey",
        localities: [
          "Pakdhung Camp",
        ],
      },
      {
        district: "Lohit",
        localities: [
          "Alubari Bridge--Lohit River",
          "Glaw Lake",
          "Kamlang WLS--DFO Office",
          "Kamlang Wildlife Sanctuary & Tiger Reserve",
          "Lohit Valley",
          "Parshuram Kund Bridge--Lohit River",
          "Tezu",
          "Udayak Pass",
          "Wakro",
        ],
      },
      {
        district: "Lower Dibang Valley",
        localities: [
          "Bamjir Bridge",
          "Bamjir Grassland",
          "Dambuk Grassland",
          "Elopa Grassland",
          "IHO view point",
          "Ithun Bridge",
          "Jia Grassland",
          "Maya Hotel",
          "Mehao WLS & Surroundings--General Area",
          "Mishmi Hills - Dibang Valley Jungle Camp",
          "Mishmi Hills--6 km",
          "Mishmi Hills--65 (65 km)",
          "Mishmi Hills--65 km to 12 Gulai",
          "Mishmi Hills--Baramile (12th Mile)",
          "Mishmi Hills--Benders (12 Gulai)",
          "Mishmi Hills--Chikopani Bridge",
          "Mishmi Hills--Coffee House (52 km)",
          "Mishmi Hills--Frogmouth Camp",
          "Mishmi Hills--Mayodia Pass (56 km)",
          "Mishmi Hills--Mehao Lake",
          "Mishmi Hills--Mishmi Hill Camp",
          "Mishmi Hills--Monal Point",
          "Mishmi Hills--Roing-Hunli Road (Forest Gate)",
          "Mishmi Hills--Tiwari Gaon (28 km)",
          "Nizam Ghat Grassland",
          "Open Fields--Jia Grassland Road",
          "Roing Town",
          "Sally Lake",
        ],
      },
      {
        district: "Lower Subansiri",
        localities: [
          "Siikhe Lake",
          "Tale WLS--Pange Camp",
          "Tale WLS--Tale valley",
          "Ziro Valley",
          "Ziro--View Point",
        ],
      },
      {
        district: "Namsai",
        localities: [
          "Arunachal University, Namsai",
          "Golden Pagoda & Surroundings",
          "Kherem",
          "Noa-Dihing Bridge, Namsai",
        ],
      },
      {
        district: "Pakke Kessang",
        localities: [
          "Bhalukpong Ghat",
          "Pakke Jungle Camp",
          "Pakke Tiger Reserve--General Area",
          "Pakke--Blyth's Kingfisher Point",
          "Pakke--Jali Nala",
          "Pakke--Khari",
          "Pakke--Lanka Trail",
          "Pakke--Sukhan Nala",
          "Pakke--West Bank",
          "Reserve Forest (Pakke Outskirts)",
          "Seijosa & Surroundings",
          "Vivekananda Kendra Vidayalaya, Seijosa",
        ],
      },
      {
        district: "Papum Pare",
        localities: [
          "North Eastern Regional Institute of Science & Technology (NERIST)",
          "North Eastern Regional Institute of Science and Technology",
          "Old Sagalee Road initial segment",
          "Rajiv Gandhi University",
          "Rajiv Gandhi university",
          "Toro Hills",
        ],
      },
      {
        district: "Shi Yomi",
        localities: [
          "Menchuka",
        ],
      },
      {
        district: "Tawang",
        localities: [
          "Bumla Pass Reception Center",
          "Jang",
          "Jang Guest House",
          "Jaswant Gad",
          "Nuranang Valley",
          "Nuranang Waterfalls (Jang falls)",
          "Shungetsar Lake",
          "Tawang Monastery",
          "Tawang Numla",
          "Tawang--Ani Gompa Road",
          "Tawang--General Area",
          "Tawang--Khirmu-Geshela Road",
          "Tawang--Ptso Lake Road",
          "Tawang--Urgelling Gompa, Sacred Grove",
          "Zemithang",
        ],
      },
      {
        district: "Upper Dibang Valley",
        localities: [
          "Acheso",
          "Anini Town (only use for Birding in the town)",
          "Anini-Aliney Road",
          "Dibang WLS--Bruni Hot Spring & Surroundings",
          "Dibang WLS--Chigu Waterfall & Surroundings",
          "Dri Afra Campsite",
          "Etalin-Anini Road",
          "Mipi",
          "Mishmi Takin Homestay",
          "Pomo Grassland (Ambrey Ahiko)",
        ],
      },
      {
        district: "Upper Siang",
        localities: [
          "Gobuk",
          "Tuting",
        ],
      },
      {
        district: "West Kameng",
        localities: [
          "1300 Chain PWD Camp",
          "Baisakhi",
          "Banga Jang Gompa",
          "Barchipaam Middle School--Crake Spot",
          "Bhalukpong",
          "Bhalukpong (Assam)",
          "Bomdila Pass",
          "Chug Valley",
          "Dirang - Mandala Road Cliffs (Birding Start Point)",
          "Dirang Tourist Lodge Area",
          "Dirang Village",
          "Dirang-Mandala Road",
          "Doimara",
          "Doimara Bridge",
          "Domkho",
          "Eaglenest WLS  & Surroundings--Above Bompu Camp",
          "Eaglenest WLS & Surroundings--Below Bompu Camp",
          "Eaglenest WLS & Surroundings--Bompu Camp",
          "Eaglenest WLS & Surroundings--Chaku",
          "Eaglenest WLS & Surroundings--Eaglenest Pass",
          "Eaglenest WLS & Surroundings--Khellong",
          "Eaglenest WLS & Surroundings--Lama Camp",
          "Eaglenest WLS & Surroundings--New Khellong",
          "Eaglenest WLS & Surroundings--Sessni",
          "Eaglenest WLS & Surroundings--Sunderview",
          "Eaglenest WLS--Tragopan Track",
          "Elephant Flat",
          "Kamengbari",
          "Kendriya Vidyalaya Dirang",
          "Khandak Nature Stay, Shergaon",
          "Lish village",
          "Lungrom",
          "Mandala",
          "Mandala Lodge and Surroundings",
          "Mandala Village",
          "Mandala-Phudung Road",
          "Nichifu-Nagmandir Road",
          "Rupa",
          "Sangti Valley",
          "Sela Pass",
          "Sessa",
          "Sessa Orchid WLS",
          "Shergaon",
          "Shergaon-Rupa Road",
          "Singchung Bugun Village Community Reserve (SBVCR)",
          "Tenga",
          "Thembang",
        ],
      },
      {
        district: "West Siang",
        localities: [
          "Aalo--DC Office Bungalow & Surroundings",
          "Aalo--General Area",
          "Aalo--RK Mission School and Surroundings",
        ],
      },
    ],
  },
  {
    state: "Assam",
    districts: [
      {
        district: "Baksa",
        localities: [
          "Around Manas Heritage Center",
          "Banasbari Range",
          "Banasbari Range towards Manas Heritage Center",
          "Baralia River",
          "Bornadi WLS",
          "Deomari Forest Camp",
          "Fish Diversity Museum",
          "GLC College Campus",
          "Kokilabari Seed Farm",
          "Manas Chowki, Picnic spot, Baksa, Assam",
          "Manas Maozigendri Ecotourism Society",
          "Manas NP & Tiger Reserve--General Area",
          "Manas NP--Alabari Maozigendri",
          "Manas NP--Banasbari (Central Range)",
          "Manas NP--Banasbari Lodge",
          "Manas NP--Bhuyanpara",
          "Manas NP--Bhuyanpara (Eastern Range)",
          "Manas NP--Bhuyanpara Range Grassland",
          "Manas NP--Bhuyanpara Range Office",
          "Manas NP--Doimary",
          "Manas NP--General Area",
          "Manas NP--Hewali To Dwimary",
          "Manas NP--Komola Bari Area",
          "Manas NP--Lota jhar",
          "Manas NP--Mathanguri",
          "Manas NP--Narayanguri exit",
          "Manas NP--Sewali to Teklai camp",
          "Manas National Park--Kahitama Area",
          "Manas Tiger Reserve--Chowki",
          "Musafir Jungle Resort",
          "Neer Daragao",
          "Pagladia River",
          "The Sikhiri Cottages",
        ],
      },
      {
        district: "Barpeta",
        localities: [
          "BBK College Campus",
          "Barpeta (OBI)",
          "Barpeta Town (OBI)",
          "ITI Titka--Lechera Para",
          "Kapla Beel",
          "Madhab Choudhury College",
          "Pohumara Sapori",
          "Puthimari Beel",
          "Sorbhog Town",
        ],
      },
      {
        district: "Biswanath",
        localities: [
          "Bahumari Beel",
          "Bashbari Beel (wetland)",
          "Behali Wildlife Sanctuary (P)",
          "Bird Sight",
          "Biswanath College-- Assam",
          "Biswanath Ghat",
          "Borgang Riverside",
          "Chaiduar College",
          "Dipara-Mailbazar Ghat",
          "Dipora Ghat",
          "Eastern Range, Gameri ( Mailbazar Ghat)",
          "Forrsa",
          "Gangmouthan",
          "Gopal Jarani",
          "Kaziranga NP-  Central Range (Kathani Bari)",
          "Kaziranga NP--Central Range (Northbank)",
          "Kaziranga NP--Eastern Range (Northbank)",
          "Kaziranga National Park--Dipara (Hatijan)",
          "Kaziranga National Park--Eastern Range Gameri",
          "Kaziranga National Park--Eastern Range Gameri Ghat",
          "Missamari",
          "Nah Beel",
          "Nature Discovery Centre",
          "Nemutenga Beel (wetland)",
          "Rahul Sarma's Residency",
          "Raja Bari",
          "Sarala Beel",
          "Sarala Beel Outskirts",
          "Toltoli",
        ],
      },
      {
        district: "Bongaigaon",
        localities: [
          "Bhosamari Lake",
          "Birjhora Mahavidyalaya",
          "Bongaigaon Town",
          "Dolani Beel",
          "Kakaijona Reserve Forest",
          "Kakoijana Reserve Forest",
          "Kakoijana village and hills",
          "Kanara Beel",
          "Naranarayan Setu",
          "Nayachora beel",
          "Roumari Beel--Malagarh",
          "Singimari",
          "Tamranga Beel",
          "Tulungia",
        ],
      },
      {
        district: "Cachar",
        localities: [
          "Assam University, Silchar",
          "Assam University--Guest House and Surrounds",
          "Barail Wildlife Sanctuary",
          "Bor Jalenga Tea Estate (OBI)",
          "Chatla Haor ( Wetlands)",
          "Chatla Lake",
          "Dilkosh basti (Village)",
          "Don Bosco HS School--Field",
          "Don Bosco HS School--Grassland and wetland",
          "Dwarbond",
          "Gunti Bari Forests",
          "Gurucharan College, Silchar",
          "Jatinga River",
          "Jatinga River-Grassland and wetland",
          "Meherpur",
          "NIT Silchar",
          "Naraincherra--Khashiapunji",
          "Padma Abash Irongmara",
          "Rongpur Lake",
          "Rosekandi Tea Estate",
          "Silchar",
          "Silchar Airport",
          "Silchar Bypass",
          "Silcoorie Tea Estate",
          "Upper Jiri Reserve Forest",
        ],
      },
      {
        district: "Charaideo",
        localities: [
          "Moran Town",
          "Patsaku College Campus",
        ],
      },
      {
        district: "Chirang",
        localities: [
          "Basugaon",
          "Champamati Irrigation Project",
          "Jawahar Navodaya Vidyalaya Kokrajhar",
          "Kuklung Forest Camp",
          "Manas NP--Kalamati",
          "Manas NP--Kuklung Range, Bishnupur",
          "Manas NP--Kuklung Range, Raigajuli",
          "Manas NP--Panbari (Eastern Range)",
          "Manas NP--Raigajuli",
          "Manas Tiger Reserve--Dhola",
          "Manas Tiger Reserve--Kuklung",
          "Phoolkhungri",
        ],
      },
      {
        district: "Darrang",
        localities: [
          "Brahmaputra River--Darrang1",
          "Brahmaputra River--Darrang2",
          "Kopati--Baruabeel",
          "Mangaldai Bus Stand",
          "Mangaldai College Campus",
          "Orang National Park",
          "Pandit Dindayal College Campus",
          "Sipajhar--Bothabeel",
          "The River Land, Soonchali",
        ],
      },
      {
        district: "Dhemaji",
        localities: [
          "Changmai Doloni (Wetland)",
          "Gerukamukh--NHPC Subansiri & Surroundings",
          "ICAR-IARI ASSAM",
          "Jonai Town (Assam)",
          "Nilakh Balijan, Dhemaji",
          "Poba Grasslands",
          "Poba Reserve Forest",
          "Rekha Chapori",
          "Subansiri Eco Camp and Surroundings",
          "Subansiri Grassland",
          "Subansiri Hide",
        ],
      },
      {
        district: "Dhubri",
        localities: [
          "Dhir Beel (lake)",
        ],
      },
      {
        district: "Dibrugarh",
        localities: [
          "Bogibeel Bridge",
          "Dibrugarh Airport",
          "Dibrugarh Town",
          "Dibrugarh University Campus",
          "Dihing Patkai NP--Jeypore (General Area)",
          "Dihing Patkai NP--Jeypore (Kothalguri Camp)",
          "Dihing Patkai NP--Jeypore (Namsang Road)",
          "Dihing Patkai NP--Jeypore (Open fields)",
          "Dihing Patkai NP--Soraipung Paddyfield",
          "Dihing Patkai--Krishna Dorik Homestay",
          "Duliajan",
          "Dumkala Chapori",
          "Horey'ghat Bridge--Burhi Dihing River",
          "Jalana Nagar",
          "Jeypore Reserve Forest--Dillighat",
          "Jeypore--Dihing River",
          "Jeypore--Ranger's Colony",
          "Jokai Botanical Garden",
          "Jokai Reserve Forest",
          "Maijan Marshland",
          "Maijan Tea Estate (OBI)",
          "Merbil-Sasoni Ecotourism Park",
          "Naharkatia Town",
          "Naharkatia--Dihing Kinar (Rhino Reserve Forest)",
          "Naharkatia--Dihing Kinar (View Point)",
          "Nakari Neogchuk Village (OBI)",
          "Tengakhat",
          "Tipam Deosali Hill Track",
        ],
      },
      {
        district: "Dima Hasao",
        localities: [
          "Hampupet trek route,Jatinga",
          "Hengbung",
          "Jatinga, Dima Hasao (OBI)",
          "L&T Longku Site Office",
          "Panimur Waterfalls",
          "Umrangsu, Dima Hasao (OBI)",
        ],
      },
      {
        district: "Goalpara",
        localities: [
          "Dhamar Reserve Forest",
          "Goalpara Town",
          "Goalpara--Dubapara",
          "Hasila Beel",
          "Krishnai",
          "Krishnai Railway Station",
          "Mariumpur Church",
          "Urpad Beel (Lake)",
        ],
      },
      {
        district: "Golaghat",
        localities: [
          "Ageratoli Village",
          "Agoratoli Eco Tourism Resort",
          "Bholaguri Shankar Beel",
          "Bokakhat Town",
          "Bon Habi Resort",
          "Butterfly Valley NRL",
          "Dering Playground",
          "Doyang Guest House",
          "Golaghat Town",
          "Hakhizhe Amur Roost Spot",
          "Haldibari",
          "Hamdai Pathar",
          "Hati Mandir (Hati Pathar)",
          "Hatikhuli Tea Estate",
          "Iora The Retreat, Kaziranga",
          "Jugi beel",
          "Jupuri Ghar Resort",
          "Kaziranga NP & Surroundings--Bhuri Mai",
          "Kaziranga NP & Surroundings--Central Range (Kohora)",
          "Kaziranga NP & Surroundings--Debeswari",
          "Kaziranga NP & Surroundings--Diring Tea Garden",
          "Kaziranga NP & Surroundings--Eastern Range (Agaratoli)",
          "Kaziranga NP & Surroundings--General Area",
          "Kaziranga NP & Surroundings--Hukuma Beel",
          "Kaziranga NP & Surroundings--Kaziranga Beel",
          "Kaziranga NP & Surroundings--Lawdoobi",
          "Kaziranga NP & Surroundings--Panbari Reserve Forest",
          "Kaziranga NP & Surroundings--Western Range (Bagori)",
          "Kaziranga NP--Highway",
          "Kaziranga NP--NH 37 Bokakhat to Bagori",
          "Kaziranga National Orchid and Biodiversity Park",
          "Kohora Chariali",
          "Kohora--Aranya Lodge",
          "Lower Doigrung (Bijuli) R.F, Golaghat",
          "Mandu--Iora Backyards (Forest)",
          "Mandu--Iora Backyards (Paddyfield)",
          "Nambor Doigurung WLS",
          "Negheriting Tea Estate",
          "Nikhekhu village",
          "Numaligarh Refinery Township",
          "Resort Borgos",
          "Sarupathar Town",
          "The Corbett Foundation, Kaziranga",
          "Wild Grass Resort",
        ],
      },
      {
        district: "Hailakandi",
        localities: [
          "Bakri Haor Complex, Hailakandi (OBI)",
          "Buhchangphai--GSa Dil, Phaisen Road",
          "Hailakandi Town",
          "Loharbond Reserve Forest",
          "Matijuri general area",
          "Noxatilla wetlands",
          "Srikishan Sarda College and surroundings",
        ],
      },
      {
        district: "Hojai",
        localities: [
          "Dhalpukhuri, Hojai",
          "Lumding RF",
          "Raja Pukur",
          "Udali RF--Lumding",
        ],
      },
      {
        district: "Jorhat",
        localities: [
          "Assam Agricultural University",
          "Assam Women's University Rowriah Campus",
          "Assam Women's University--Teok Campus",
          "Bor Sola Beel (Wetland)",
          "Bormukoli Pothar",
          "Borsarala Beel (Eastern)",
          "Borsarala Beel (Western)",
          "Chowkhat",
          "DCB Girls' College, Jorhat",
          "Danish Nagar",
          "Fakua Dol Beel",
          "Gibbon Resort & Surroundings",
          "Hoollongapar Gibbon Wildlife Sanctuary",
          "ICFRE-Rain Forest Research Institute",
          "Jhanjimukh Beel Jorhat",
          "Jorhat--Dumping Ground (Tocklai)",
          "Jorhat--Tinikunia Pukhuri",
          "Kadomani Beel",
          "Kohuwa Sapori",
          "Kokilamukh Beel",
          "Missamari Beel",
          "Molai Island",
          "National Institute of Design--Assam",
          "Nemati wetlands",
          "Nimati Ghat - Majuli ferry",
          "North East Institute of Science and Technology Campus",
          "ONGC Avian Park",
          "Potiya Sarala Beel",
          "Solmora Beel, Malow Pathar",
          "Teok Town",
          "Thengal Village",
          "Tocklai Tea Estate",
        ],
      },
      {
        district: "Kamrup",
        localities: [
          "Brahmaputra River Bank--Kamrup",
          "Chandubi Eco-Camp",
          "Chandubi Lake--General Area",
          "Dadara",
          "Digholi Beel (lake)",
          "Dora Beel (Wetland)",
          "Duramari Beel (Lake)",
          "Duramari Grassland",
          "Galli Beel (lake)",
          "Guimara ispar sunset view point",
          "IIT Guwahati Old guest House",
          "J.N. College, Boko",
          "Jengdia beel (lake)",
          "Jiakur Reserve and surroundings",
          "Kamalpur-Puthimari Wetland",
          "Mandakata Village",
          "Mirza Town",
          "Puthimari river bank",
          "Rajapara",
          "Rampur Anchalic College",
          "Rangmahal",
          "Rani RF--Assam-Meghalaya border",
          "Rani RF--Vulture Breeding Centre",
          "Rani Reserved Forest--General Area",
          "Rani Reserved Forest--Kopili",
          "Sualkuchi Beel",
          "Sualkuchi Village",
        ],
      },
      {
        district: "Kamrup Metropolitan",
        localities: [
          "Amchang WLS--General Area",
          "Arya Vidyapeeth College",
          "Assam Don Bosco University",
          "Assam Don Bosco University Azara Campus",
          "Assam Downtown University Campus",
          "Assam Engineering College",
          "Assam Royal Global University",
          "Assam State Zoo Cum Botanical Garden",
          "B. Borooah College",
          "Bamunimaidan Buddha Bihar",
          "Borsola Beel",
          "Brahmaputra Jungle Resort",
          "Brahmaputra River Heritage Centre",
          "Chandrapur Forest, near Guwahati (OBI)",
          "College of Veterinary Science, Khanapara",
          "Cotton University",
          "Deepor Beel--Azara",
          "Deepor Beel--Chakardoi",
          "Deepor Beel--General Area",
          "Deepor Beel--Khanamukh",
          "Deepor Beel--Pamohi",
          "Deepor Beel--Tetelia",
          "Deepor Beel--Waste Management Plant",
          "Deepor Beel--Watch Tower (Wildlife Sanctuary Area)",
          "Deeporbeel--AEC Road",
          "Dharapur River Bank",
          "Digholi Pukhri",
          "Dimoria College, Durang, Khetri, Assam, IN (26.118, 92.075)",
          "Gandhi Mandap",
          "Garbhanga Reserve Forest",
          "Garbhanga--Basistha",
          "Garbhanga--Pamohi",
          "Garbhanga--Satargaon",
          "Gauhati University Campus",
          "Gauhati University Campus--Botanical Garden",
          "Gauhati University Campus--RCC5",
          "Gauhati airport marsh",
          "Gita Mandir Hill",
          "Guwahati (OBI)",
          "Guwahati Airport (Lokpriya Gopinath Bordoloi International Airport)",
          "Guwahati College",
          "Guwahati Medical College",
          "Guwahati Medical College Campus-Kamrup (OBI)",
          "Guwahati Planetarium",
          "Guwahati Railway Station",
          "Guwahati Waste Disposal--New",
          "Guwahati--4th Battelion gate",
          "Guwahati--Islampur",
          "Guwahati--Lankeswar",
          "Guwahati--Paltan Bazar",
          "Guwahati--Santipur",
          "IASST Campus Guwahati",
          "IIT Guwahati",
          "IIT Guwahati--Grassland near Hospital",
          "IIT Guwahati--Wetland Opposite to Brahmaputra Hostel",
          "IIT Guwahati--Wetland Opposite to Core 4",
          "IOC Refinery Township",
          "Indian Institute of Entrepreneurship",
          "Indian Institute of Technology (IIT) Guwahati--Hill top",
          "Iora Food Court",
          "Jalukbari (OBI)",
          "Kamakhya Temple",
          "Kambhrenga Beel",
          "Kharguli--Hatisil",
          "Krishna Kanta Handique State Open University",
          "Maloibari Village",
          "Maloibari--Swamp",
          "Mon Vikas Kendra, DakhinGaon",
          "Nabagraha, Guwahati",
          "National Law University and Judicial Academy, Assam",
          "Pragjyotish College Campus",
          "Pygmy Hog Research and Breeding Centre (Restricted Access)",
          "Regional Science Centre",
          "Rehabari",
          "S.B Deorah College, Guwahati",
          "Silsako Lake",
          "Soonchali Road",
          "The Greenwood Resort",
          "Uzan Bazar Brahmaputra Riverside",
          "Wetland opposite to Core-4",
        ],
      },
      {
        district: "Karbi Anglong",
        localities: [
          "Bhelughat Waterfalls",
          "Biodiversity cum Recreation Park",
          "Chapanala Water Falls",
          "Dikrong Grassland",
          "Dikrutpi Waterfalls",
          "Don Bosco Junior and Degree College",
          "Kaipholangso Waterfall",
          "Kangthilaso Waterfall",
          "Langkar-Om Eco Park",
          "Mikir Hills",
          "Terang's Home Stay",
          "Thong Nokbe College",
        ],
      },
      {
        district: "Karimganj",
        localities: [
          "Dosdewa Forest",
          "Dosdewa Forest Trail",
          "Dosdewa Forest Trail-1",
          "Dosdewa Forest Trail-2",
          "Dosdewa Karimganj",
          "Dosdewa Village",
          "Dosdewa Village (North)",
          "Hathikhira Tea Estate",
          "Hathikhira Tea Estate (E)",
          "Makunda Christian Hospital",
          "Nilambazar Railway Station",
          "Patharia Hill RF (OBI)",
          "Secondary Forest Near Dosdewa Village",
          "Soidewa Forest",
          "Sonbeel (Wetland)",
          "Sreerampur Forest, Karimganj (OBI)",
          "Srirampur",
        ],
      },
      {
        district: "Kokrajhar",
        localities: [
          "Abhayakuti",
          "Bodoland University",
          "Bodoland University Campus",
          "Chakrashila Forest IB",
          "Chakrashila Wildlife Sanctuary",
          "Chakrashila, Dhir, Diplai and Dakra Complex IBA",
          "Diplai Beel (lake)",
          "Gaurang Park",
          "Jomduar Forest IB",
          "Jomduar--Sankosh River",
          "Kokrajhar Town",
          "Manas Tiger Reserve--Jharbari",
          "Manas Tiger Reserve--Ultapani",
          "Pepsu Riverbank",
          "Raimona NP--Central range",
          "Rideline 5",
          "Rideline 7--Hel River Road",
          "Rideline 8--Bongaon Bamuni Road",
          "Rideline 9 & 10--Firing Road",
          "Rideline 9--Mach Bhandar",
          "Sarpang Riverbank--Saralpara",
          "Sona Bhandar",
          "Ultapani Forest IB",
        ],
      },
      {
        district: "Lakhimpur",
        localities: [
          "Bagalijan Grassland",
          "Bogoli Reserve Forest",
          "Dhakuakhana (OBI)",
          "Dikrong Grassland",
          "Dulung Reserve Forest",
          "Dulung Reserve Forest--Dulung Hide",
          "Dulung River Bridge",
          "Kakoi Reserve Forest",
          "Khabolu Ghat",
          "LTK College Campus",
          "Na-Aali Wetland",
          "North Lakhimpur College Campus",
          "Ranga RF (Bogoli)--Tesia Camp",
          "Satajaan Bird Sanctuary",
          "Subansiri--Gagoldubi",
          "Subansiri--Khaga Kanakpur",
          "Subansiri--Sumdirimukh",
        ],
      },
      {
        district: "Majuli",
        localities: [
          "Bongaon",
          "Dakhinpat Satra, Majuli",
          "Forest Reserve, Near Auniati Satra",
          "Garamur Satra Road",
          "Kamalabari Ghat",
          "Katimora beel (Wetland)",
          "Magurmari",
          "Majuli - Thoni ghat",
          "Majuli Island",
          "Majuli--Ghutahula",
          "Majuli--Kamalabari",
          "Majuli--Mohkhuti Jaan",
          "Majuli--Puhardia",
          "Near Kamalabari Ghat",
          "Niribili Homestay, Kamalabari Satra Road",
          "River Bank, Near Auniati satra",
          "Sakuli Beel (Wetland)",
          "Soraichung",
          "Vereki beel (Wetland)",
        ],
      },
      {
        district: "Morigaon",
        localities: [
          "Dharamtul",
          "Dharamtul to Bhalukaguri road",
          "Dharamtul--Kapili River Bridge & Surroundings",
          "Hatiutha Dol (Swamp)",
          "Jagiroad College",
          "Kachari Village",
          "Kholahat Reserve Forest",
          "Maibong Eco resort",
          "Manaha Gaon--Swamp and Agricultural land",
          "Manaha Village",
          "Mayong (OBI)",
          "Morakolong, Morigaon",
          "Morigaon (OBI)",
          "Morigaon College Campus",
          "Narasingha Mandir",
          "Pobitora Wildlife Sanctuary",
          "Tambuli Doba Wetland",
        ],
      },
      {
        district: "Nagaon",
        localities: [
          "Amsoi Village",
          "Amsoi-Amtreng Road",
          "Anandaram Dehkial Phookan Bridge, Nagaon",
          "Assam Cooperative Jute Mills",
          "Bali Chara Dalani (Swamp)",
          "Batadraba Village",
          "Bordowa Temple",
          "Burapahar",
          "Chapanala Picnic Spot",
          "Chapanala Reserve Forest",
          "College of Education Nagaon Campus",
          "DC Office Campus",
          "Dewbali Jalah (Swamp)",
          "Dol Mandir (Temple)",
          "Gnathang Valley View Point",
          "Hahila Beel",
          "Jakhalabanda--Outskirts",
          "Jasingfaa Aqua Tourism Resort",
          "Jiajuri Tea Estate",
          "Joysagar Doloni (Wetland)",
          "Kamakhya Temple Silghat",
          "Kandhulimari Village",
          "Kaziranga NP & Surroundings--Burapahar Nahrubasti",
          "Kaziranga NP & Surroundings--Burapahar Range (Ghorakati)",
          "Kaziranga NP & Surroundings--Kanchanjhuri Rhino View Point",
          "Kaziranga NP & Surroundings--Pup Deopani",
          "Laokhowa Wildlife Sanctuary",
          "Laokhowa Wildlife Sanctuary--Rowmari Beel",
          "Morikolong and Borghat Point areas",
          "Nagaon Girls College Campus",
          "Nagaon Town",
          "Nagoan Bypass",
          "Nehru Yuva Kendra",
          "Nowgong Law College Campus",
          "Palasoni Village",
          "Paradise Lake, Kathalguri, Nagaon",
          "Raha",
          "Ranthali Village",
          "Samaguri Beel,Samaguri,Nagaon,Assam",
          "Sankar Mission Campus",
          "Soong Loong Tea Estate",
          "Swang Reserve Forest",
          "Trishuldhari Temple, Silghat",
        ],
      },
      {
        district: "Nalbari",
        localities: [
          "Baramboi Borpukhuri",
          "Barkapla Beel",
          "Belsor Village",
          "Nalbari Brahmaputra River (OBI)",
          "Nalbari Railway Station",
          "Tihu College",
          "Tihu Town",
        ],
      },
      {
        district: "Sivasagar",
        localities: [
          "ASTC Sivasagar",
          "Charaideo (Group of Maidams)",
          "Demow Town",
          "Gourisagar Tank",
          "Jhanji",
          "Joysagar Tank",
          "Nazira Bor Baruah pukhuri",
          "Nazira Colony",
          "Nazira, Assam, IN (26.905, 94.729) Bor Baruah Pukhuri",
          "ONGC Colony Sivasagar",
          "Ongc colony",
          "Panidihing Bird Sanctuary",
          "Pohu Garh (Wetlands)",
          "Purani Pukhuri",
          "Rang Ghar",
          "Rudra Sagar (Jerenga Pothaar)",
          "Sibsagar University Campus",
          "Sivasagar Tank",
          "Sivasagar--Dumping Ground",
          "Sivasagar--K. P Chariali Road",
          "Tolatol Ghar",
          "Ward No 2, Bishnu Jyoti Path,Nazira Town Assam, IN (26.906, 94.735)",
        ],
      },
      {
        district: "Sonitpur",
        localities: [
          "Adabari Tea Estate",
          "Army Residential Colony (restricted access)",
          "Baligora Eco Camp",
          "Balipara Town",
          "Bamuni Hill",
          "Base Hospital Rd, Tezpur-- Assam",
          "Bhitor Porowa Gaon--Marshland",
          "Borbhagia",
          "Burhachapori WLS",
          "Burhachapori WLS--Dhania IB",
          "Eastern Himalayan Botanic Ark",
          "Gaikhuti Beel (wetland)",
          "Greenhub, Tezpur, Assam",
          "Hazara Pukhuri",
          "Hospital Tezpur",
          "Jamugurihat",
          "Jia Bharali (Kameng) River",
          "Jia Bharali River -- Potasali",
          "Jia Bharali river",
          "Jia Bhoroli Wildlife Camp",
          "Kamengbari--Assam",
          "Kanyaka",
          "Kari Beel (wetland)",
          "Kaziranga NP--Western Range (Northbank)",
          "Kolia Bhomora Bridge",
          "Lake Brahmaputra & Surroundings (South of Koliabhomora Bridge)",
          "Nameri Eco Camp Road",
          "Nameri National Park",
          "Nameri National Park & Surroundings",
          "Nameri--Range Forest Office & Surroundings",
          "Puthimari",
          "Pygmy Hog Pre-release Centre (Restricted Access)",
          "Rafting Point",
          "Sapoi Tea Farm",
          "Sokighat",
          "Sonai-Rupai WLS--Range Office",
          "Tezpur University Campus",
          "Tezpur, (OBI)",
          "Tezpur--Bhairab Nagar",
          "Tezpur--Padum Pukhuri",
        ],
      },
      {
        district: "Tinsukia",
        localities: [
          "Amarpur",
          "Barekuri Village (OBI)",
          "Bherjan Gaon",
          "Bherjan WLS & Surroundings",
          "Borajan WLS & Surroundings",
          "Dehing Patkai NP",
          "Dhadum Pathar & Surroundings",
          "Dholla Ghat",
          "Dibru-Saikhowa NP & Surroundings--Balijan Camp",
          "Dibru-Saikhowa NP & Surroundings--General Area",
          "Dibru-Saikhowa NP & Surroundings--Kunda Ghat Camp",
          "Dibru-Saikhowa NP (Outskirts)--Baghjan Grassland",
          "Dibru-Saikhowa NP (Outskirts)--Koliapani Grassland",
          "Digboi College Campus",
          "Digboi Reserve Forest (Under Digboi Wildlife Division)",
          "Digboi Tourist Lodge",
          "Digboi Town",
          "Digboi--DFO Office Campus",
          "Digboi--IOCL Staff Quarters",
          "Digboi--India Club",
          "Digboi--Matri Mandir",
          "Digboi--Noloni Reserve Forest",
          "Digboi--Oil Field",
          "Digboi--Oil Museum",
          "Digboi--Pengri Reserve Forest",
          "Digboi-Pengeri Road",
          "Dihing Patkai NP--Soraipung (Buffer area)",
          "Dihing Patkai NP--Soraipung (Core area)",
          "Dihing Patkai NP--Soraipung (Ranger's Office)",
          "Dirok Range (Under Digboi Wildlife Division)",
          "Doom Dooma College Campus",
          "Doom Dooma Reserve Forest",
          "Guijan Ghat & Surroundings",
          "Guijan Town",
          "Hahkhati Reserve Forest",
          "Jalan T.E. Estate--Bamboo Patch",
          "Jhumur Farmstay",
          "Kachijan Reserve Forest",
          "Kakojan Reserve Forest",
          "Kakopathar Town",
          "Kakopathar--Kumchang Tea Estate",
          "Kherjan Forest--Balijan, Borjan Beat",
          "Koliapani Ghat",
          "Laina",
          "Lakhipathar Rangsongi Forest",
          "Ledo Airfield",
          "Lohit River--Dr. Bhupen Hazarika Setu",
          "Maguri Beel (Maguri Wetland)",
          "Maguribeel--Embankment",
          "Maguribeel--Grassland",
          "Maguribeel--Maguri Eco Camp",
          "Mounglang Buddhist Monastery",
          "Namdong Resort",
          "Notun Rangagorah Ecotourism Village",
          "Padumoni WLS & Surroundings",
          "Panitola, Assam (OBI)",
          "Rangajan LP School",
          "Ronga Dolong--Marshland",
          "Sadiya (OBI)",
          "Sadiya--Saikhowa Ghat (River Crossing)",
          "Tingrai Reserve Forest (Under Digboi Wildlife Division)",
          "Tinsukia College Campus",
          "Tinsukia Town",
          "Upper Dihing (East Block)",
          "Wathoi Habi Bridge--Marshland",
        ],
      },
      {
        district: "Udalguri",
        localities: [
          "Barnadi WLS",
          "Barnadi WLS--Alongjhar",
          "Barnadi WLS--Bogamati",
          "Barnadi WLS--Forest Office",
          "Barnadi WLS--Outskirts",
          "Barnadi WLS--Rajagarh",
          "Bhairavkunda Picnic Spot",
          "Bogamati Picnic Spot",
          "Orang-Mazbat Road",
          "Tangla Town",
        ],
      },
      {
        district: "West Karbi Anglong",
        localities: [
          "Ashim's Bird Home",
          "Hemtap",
          "Khandajan",
          "Nawaibil",
          "Sildubi Beel",
          "Umru village",
        ],
      },
    ],
  },
  {
    state: "Bihar",
    districts: [
      {
        district: "Araria",
        localities: [
          "Parman River Araria, Bhagat Tola Rd",
        ],
      },
      {
        district: "Begusarai",
        localities: [
          "Barauni Railway Station",
          "Jaimangla Garh Forest Rest House",
          "Kanwar Jheel Lake (IBA)",
          "Kanwar Lake--Jaimangla Garh Side",
          "Kawar lake Outskirt",
        ],
      },
      {
        district: "Bhagalpur",
        localities: [
          "3 Number Thokar Bochahi",
          "Digambar Jain Mandir",
          "Ganga River--Manik Sarkar Ghat",
          "Ganga River--Shankarpur Diyara",
          "Jagatpur Lake, Bhagalpur",
          "Jay Prakash Udyan Bhagalpur",
          "Kalabaliya Dhar, Dhruvganj Area",
          "Karari Tintanga",
          "Katiya Dhar Fields & Wetlands",
          "Makandpur-Thuthabore",
          "Meerachak Ghat",
          "Pakra",
          "Radio Station (Restricted)",
          "River Ganga- Hanuman Ghat",
          "Sonwarsha Ghatora",
          "Sundervan Forestr Department  Campus, Barari Rd. Bhagalpur",
          "T M Bhagalpur University Campus",
          "TNB College, Bhagalpur",
          "Tintanga Diyara",
          "Vikramshila Gangetic Dolphin Sanctuary",
          "Vikramshila Setu, Bhagalpur",
        ],
      },
      {
        district: "Bhojpur",
        localities: [
          "Ara Railway Junction (Bhojpur, Bihar)",
        ],
      },
      {
        district: "Darbhanga",
        localities: [
          "Atahi Village Wetalnd (Chaur)",
          "Baghauni",
          "DMCH Campus",
          "Fulbaari, Chataria",
          "Kherajpur Chaur, Darbhanga",
          "Kusheshwar Sthan",
          "Pandasarai Wetland",
          "Piproulia",
          "Purani Durga Mandir Baheri, Lilkhon",
        ],
      },
      {
        district: "Gaya",
        localities: [
          "Bodhgaya",
          "Central university of South Bihar",
          "Falgu River at Kesapi, GT Road Gaya, Bhadeya",
          "Gautam Buddha WLS--Babhandev Jungle",
          "Gautam Buddha WLS--Barandih",
          "Gautam Buddha WLS--Barbadih",
          "Gautam Buddha WLS--Bhadeya Village",
          "Gautam Buddha WLS--Falgu River Bridge, Bhalua",
          "Gautam Buddha WLS--General Area (Bihar Side)",
          "Gautam Buddha WLS--Tikwa Nala",
          "Gautam Budha WLS--Sugasot",
          "Itwan",
          "Naili--Brahmayoni Hill",
        ],
      },
      {
        district: "Gopalganj",
        localities: [
          "Gandak River--Bisunpur-Mangalpur Bridge",
        ],
      },
      {
        district: "Jamui",
        localities: [
          "Chanantar Temple Road",
          "Devanaahar",
          "Dhamna Aahar, Dhamna, Bihar, IN (24.848, 86.36)",
          "Dighra Aahar, Dhamna, Bihar, IN (24.873, 86.356)",
          "Nagi Bird Sanctuary--Plantation & Scrub",
          "Nakti Bird Sanctuary",
          "Pailbajan",
          "Raja Aahar, Chhapa, Bihar, IN (24.838, 86.387)",
          "Semi-Dry Grassland (B/W Nagi and Nakti)",
          "Tola Barajor Scrubland",
          "Tola Belatanr",
        ],
      },
      {
        district: "Kaimur",
        localities: [
          "Karmanasa Railway Station, Kaimur (Bhabua), Bihar",
        ],
      },
      {
        district: "Katihar",
        localities: [
          "Gogabil Lake, Manihari (Amdabad Block)",
          "Gogabil Pakshi Vihar (IBA)--Baghar Bil",
          "Gogabil Pakshi Vihar (IBA)--Jangli Tal",
          "Korha Kothi, Musapur, Katihar",
          "Kursela Dhab",
        ],
      },
      {
        district: "Khagaria",
        localities: [
          "Koshi-Ganges Floodplains--Bharat Khand Railway Station",
        ],
      },
      {
        district: "Kishanganj",
        localities: [
          "Jhulan Mandir Santosh Marg",
        ],
      },
      {
        district: "Lakhisarai",
        localities: [
          "Ashtghatti Pokhar, Lakhisarai, Bihar, IN (25.158, 86.09)",
          "Balguddar Pokhar, Balgudar, Bihar, IN (25.194, 86.086)",
          "Bela Pokhar (Railway Pond), Lakhisarai",
          "Digha Pokhar, Lakhisarai, Bihar, IN (25.189, 86.081)",
          "Dumari Halt Railway Station",
          "Gangta Pond, Lakhisarai, Bihar",
          "Harohar River, Lakhisarai, Bihar, IN (25.238, 86.067)",
          "Kiul Railway Junction, Lakhisarai",
          "Luckeesarai Junction",
          "Pond Near Ashokdham Road, Balgudar, Bihar, IN (25.188, 86.076)",
          "Rampur Pond, Bihar, IN (25.183, 86.152)",
          "Rampur Wetland, Bihar, IN (25.186, 86.144)",
          "Sansar Pokhar Pachna Road, Lakhisarai,Bihar, IN (25.167, 86.088)",
        ],
      },
      {
        district: "Madhepura",
        localities: [
          "Bainadih",
        ],
      },
      {
        district: "Madhubani",
        localities: [
          "Benoa Chaur",
          "Bhachhi",
          "Madhubani Sugauna",
        ],
      },
      {
        district: "Munger",
        localities: [
          "Jamalpur Railway junction, Bihar",
          "Vikramshila Gangetic Dolphin Sanctuary",
        ],
      },
      {
        district: "Nalanda",
        localities: [
          "Begampur Lake (Gidhhi Lake)",
          "Bihar Sharif, Railway station",
          "Chandi Hospital, Nalanda",
          "Dasturpar,Bihar",
          "Deepnagar,Pnachane Riverbank",
          "Diya,Biharsharif",
          "Ekangar Dih,Nalanda",
          "Ghora-Katora Lake, Forest Trail",
          "Ghora-Katora Lake-Rajgir Wildlife Sanctuary",
          "Hiran Safari - Herbivore Safari, Rajgir",
          "Horticulture College, Noorsarai",
          "Jai Prakash Udyan Park, Rajgir NH",
          "Jara Devi, Forest Stream, Rajgir, Nalanda",
          "Kheban Bigha, Noorsarai",
          "Leopard safari-Rajgir Zoo Safari",
          "Manik Pur,Noorsarai",
          "Marshy Area, Sangat, Noorsarai",
          "Muzzafarpur Village, Noorsarai",
          "Nalanda Archaeological Site",
          "Nalanda College of Engineering",
          "Nalanda College, Bihar Sharif,Nalanda",
          "Nalanda Ordnance Factory -- Dhamm Sarovar",
          "Nalanda University Campus, Pilkhi, Rajgir",
          "Noorsarai Village",
          "Panchane River Deepnagar Stadium",
          "Panchane River--Triveni Sangam Sthal",
          "Pandu Pokhar Park",
          "Pant (Rajgir) WLS--Ghora Katora Lake & Eco Park",
          "Pant (Rajgir) WLS--Jathian Road",
          "Pant (Rajgir) WLS--Telia Mahan",
          "Pant (Rajgir) WLS--Telia Mahan Water Hole",
          "Pawapuri Water Tank & Jain Temple",
          "Pawapuri jal mandir ( Temple )",
          "Pawapuri temple , Pawapuri jal mandir",
          "Pushkarni Lake (Gidhhi Lake), Surajpur, Nalanda",
          "Rajgir (Pant) WLS - Basoori Talab",
          "Rajgir (Pant) WLS - Deer Park",
          "Rajgir (Pant) WLS - Jara Devi Temple Area, Rajgir",
          "Rajgir (Pant) WLS- Forest trail - Ghora-Katora",
          "Rajgir Zoo Safari",
          "Rajgir Zoo Safari Plaza",
          "Sangat Middle School, Noorsarai",
          "Venu Vana and Circuit House, Rajgir",
        ],
      },
      {
        district: "Nawada",
        localities: [
          "Panchane River -- Birding Hotspot, Giriyak, Bihar",
        ],
      },
      {
        district: "Pashchim Champaran",
        localities: [
          "Bettiah Wetlands",
          "Gandak River--Dhanaha Ratwal Ghat Bridge",
          "Ghoraghat",
          "Harinagar Railway Station",
          "Kunariya Masan Wetland",
          "Madanpur Range , Valmiki Tiger Reserve",
          "Masan River Grasslands",
          "Triveni Nahar (Canal), Ramnagar",
          "Udaipur WLS",
          "Valmiki Tiger Reserve -- Gobardhana --Raghia Range",
          "Valmiki Tiger Reserve -- Gobardhana Range",
          "Valmiki Tiger Reserve--Bhikhna Thori",
          "Valmiki Tiger Reserve--Champapur Gonauli Forest Fringes",
          "Valmiki Tiger Reserve--General Area",
          "Valmiki Tiger Reserve--Gobardhana Range (6 Number)",
          "Valmiki Tiger Reserve--Hanging Bridge & Koleshwar Temple",
          "Valmiki Tiger Reserve--Raghia Range",
          "Valmiki Tiger Reserve--Someshwar Trail",
          "Valmiki Tiger Reserve--Valmikinagar",
          "Vulture Point Chiutaha,Nautanwa",
        ],
      },
      {
        district: "Patna",
        localities: [
          "Anta Ghat, Patna",
          "Bajitpur, Digha",
          "Bihar Veterinary college",
          "Danapur Cantonment (IBA)",
          "Danapur Railway Station",
          "Eco Park",
          "Ganga River--Aunta",
          "Indian Institute of Technology (IIT Patna)",
          "Jayprakash Narayan Airport",
          "Mahendru",
          "Mangal Talab",
          "National Institute of Technology (NIT Patna)",
          "Old Secretariat",
          "Patliputra Junction",
          "Patna Golf Club",
          "Patna Railway Station",
          "Raja Bazar, Patna",
          "Sanjay Gandhi Biological Park",
          "St Michael's High School (Restricted)",
          "Tarumitra Ashram (Restricted)",
          "Vrindavan Colony, Patna",
          "Zoological Survey Of India",
        ],
      },
      {
        district: "Purba Champaran",
        localities: [
          "Moti Jheel, Motihari",
          "Pataura Tola Jheel Oxbow Lake",
          "Pipra Maan Oxbow Lake",
          "Rulahi Maan Oxbow Lake, Motihari",
          "Sadahi Maan Oxbow Lake",
          "Sarotar Khetar (Dangari)",
          "Sirsa Maan (Sirsamal) Oxbow Lake",
          "Turkaulia Maan",
        ],
      },
      {
        district: "Purnia",
        localities: [
          "Purnea College",
        ],
      },
      {
        district: "Rohtas",
        localities: [
          "Kaimur Hills",
          "Karamchat/Durgawati Dam",
        ],
      },
      {
        district: "Saharsa",
        localities: [
          "Simri Jheel",
        ],
      },
      {
        district: "Samastipur",
        localities: [
          "Samastipur Railway Station",
        ],
      },
      {
        district: "Saran",
        localities: [
          "Chhapra Railway Station",
          "Sabbalpur Diara",
        ],
      },
      {
        district: "Sitamarhi",
        localities: [
          "Manha Pul Wetland, Belsand, Bihar, IN (26.452, 85.407)",
        ],
      },
      {
        district: "Siwan",
        localities: [
          "Siwan Railway Station",
        ],
      },
      {
        district: "Vaishali",
        localities: [
          "Baraila Lake (Salim Ali Zubba Shani Bird Sanctuary)",
          "Hajipur Railway Station",
          "North Shahi Colony, Vaishali, Bihar",
        ],
      },
    ],
  },
  {
    state: "Chandigarh",
    districts: [
      {
        district: "Chandigarh",
        localities: [
          "Butterfly Park, Sector 26",
          "Capitol Complex",
          "Chandigarh Botanical Garden, Chandigarh",
          "Chandigarh Bus Terminus",
          "Children Traffic Park",
          "Corner of Sector 49-C",
          "Dhanas lake",
          "Forest in Sector 43-C, Chandigarh",
          "Forest in front of CIHM",
          "Fountain of Rock Garden",
          "Fragrance Garden",
          "Green Belt Park, Sector 48D",
          "Himachal Bhavan",
          "IN-Chandigarh-Sector 31B (30.7024,76.7828)",
          "Japanese Garden, Chandigarh, IN (30.704, 76.783)",
          "Kaimbwala",
          "Kishangarh",
          "Lake Reserved Forest, Chandigarh",
          "Leisure Valley",
          "Leisure Valley Park Mohali",
          "Manimajra Fields and Open Land",
          "Near New Lake in Sector 42",
          "PGIMER Campus",
          "PGIMER Community Centre",
          "Panjab University",
          "Park 42",
          "Park--Sector 31B",
          "Poinsettia And Ixora Garden, Sector 11, Chandigarh",
          "Punjab University Botanical Garden",
          "Rose Garden",
          "Sahibzada Ajit Singh Nagar--New Park",
          "Sector 37",
          "Sector 39-B,Chandigarh",
          "Shanti Kunj Park",
          "Sukhna Lake",
          "Sukhna Lake--Regulatory End",
          "Sukhna Lake--Reserve Forest & Nagar Van",
          "Village Tohgan, District Sahibzada Ajit Singh Nagar",
        ],
      },
    ],
  },
  {
    state: "Chhattisgarh",
    districts: [
      {
        district: "Balod",
        localities: [
          "Bordi Dam",
          "Environment Park",
          "Gondli Dam",
          "Jagannathpur Dam Balod",
          "Kharkhara Dam",
          "Onakona",
          "Tandula Dam",
        ],
      },
      {
        district: "Baloda Bazar",
        localities: [
          "170 Talab",
          "Balsamund Talab Palari",
          "Baranwanpara WLS -Furfundi Forest Camp",
          "Barnawapara -- Bar Dabara Pond",
          "Barnawapara Buffer Chhattisgarh, IN (21.432, 82.419)",
          "Barnawapara WLS",
          "Barnawapara WLS --  Rampur Nistari Pond",
          "Barnawapara WLS -- Balar Reservoir",
          "Barnawapara WLS -- Barbaspur Gate",
          "Barnawapara WLS -- Bhalupani Pond",
          "Barnawapara WLS -- Bilaspuriha Pond",
          "Barnawapara WLS -- CN- FD115 Banskatti Pond",
          "Barnawapara WLS -- CN-103 Pond",
          "Barnawapara WLS -- CN-103 Pond(2)",
          "Barnawapara WLS -- CN-86 Pond",
          "Barnawapara WLS -- CN155 Pond",
          "Barnawapara WLS -- CN165 Pond",
          "Barnawapara WLS -- Chana Ghutkuri Pond",
          "Barnawapara WLS -- Devgaon Dam",
          "Barnawapara WLS -- Dond Pond",
          "Barnawapara WLS -- Girodpuri Pond",
          "Barnawapara WLS -- Gudagarh Pond",
          "Barnawapara WLS -- Hawayi Patti Pond",
          "Barnawapara WLS -- Jamahi Pond",
          "Barnawapara WLS -- Kachardih Dam",
          "Barnawapara WLS -- Kachhardih Pond 2",
          "Barnawapara WLS -- Kantara Pond",
          "Barnawapara WLS -- Khairchaapar Pond",
          "Barnawapara WLS -- Khudmudi Pond",
          "Barnawapara WLS -- Latadadar Pond",
          "Barnawapara WLS -- Manjhi Pond",
          "Barnawapara WLS -- N Gudagarh Pond",
          "Barnawapara WLS -- Rampur Chhote Pond",
          "Barnawapara WLS -- Rawan",
          "Barnawapara WLS -- Sanctuary Pond",
          "Barnawapara WLS -- Sidhar Pond",
          "Chhuiya Dam Balouda Bazar",
          "Devhill Resort Road Chhattisgarh, IN (21.428, 82.557)",
          "Dewgaon Dam Charoda, Chhattisgarh, IN (21.33, 82.44)",
          "Government College Lawan",
          "Govt. G.N.A. P.G. College Bhatapara",
          "Hareli Eco Resort, Barnawapara WLS",
          "Jonk River Amodi",
          "Jonk River Bhata oppsite  Giroudpuri Chhattisgarh, IN (21.599, 82.549)",
          "Karda Tank",
          "Muba's Machaan Resort",
          "Parytak Gram Barnawapara",
          "Sikari Dand Talab",
          "Urjaa Sarovar, Sirpur Road",
        ],
      },
      {
        district: "Balrampur",
        localities: [
          "Haritima Nursery",
          "Kusmi Rd, Shankargarh",
          "Pavai Faal",
        ],
      },
      {
        district: "Bastar",
        localities: [
          "Aamcho Ladi",
          "Adawal Naaka Jagdalpur",
          "Arshiya Sky",
          "BASTAR ACADEMY OF DANCE, ART & LITERATURE (BADAL)",
          "Bajawand",
          "Bajawand Tank",
          "Baliguda Para Primary School",
          "Bastar Birds Nest",
          "Bastar Cafe",
          "Bastar Greens Eco Stay",
          "Bastar Jungle Resort Village Kurandi Jagdalpur",
          "Bastar University",
          "Chitrakoot Waterfall",
          "DANDAK CAVE KANGER VALLEY NATIONAL PARK JAGDALPUR",
          "Dalpat Sagar",
          "Dandami Luxury Resort",
          "Dasapal Dam",
          "Delhi  Public School, Jagdalpur",
          "Forest Training School, Jagdalpur",
          "Ganesh Bahar Nala",
          "Ganesh Bahar Nala--Kurandi",
          "Ganga Munda Pond",
          "Jagdalpur",
          "Jamawada",
          "Jamawada Tank",
          "KVNP - Darbha",
          "Kailash Gufa",
          "Kanger Valley NP",
          "Kanger Valley NP--Kanger Dhara",
          "Kanger Valley NP--Kotumsar Cave",
          "Kanger Valley National Park--Butterfly Garden",
          "Karkaguda, Chhattisgarh, IN",
          "Kosartenda Dam",
          "Kumarawand",
          "Kumarawand Village",
          "Kurandi Road, Billori, Jagdalpur",
          "Machkot",
          "Machkot Tiriya Forrest",
          "Manjipal bamboo rafting",
          "Mendir - Ghumar Waterfall",
          "Milkudwada Park",
          "Puspal",
          "Rajnagar",
          "Salemeta",
          "Sargipal",
          "Tirathgarh Waterfall",
        ],
      },
      {
        district: "Bemetara",
        localities: [
          "Bird Interpretation Center Nagdha",
          "Enamshahi Tank",
          "Gidhwa Tank",
          "Gidhwa Wetland, Tank 2",
          "Govt Polytechnic Berla Campus",
          "Kalalbod Tank",
          "Murkuta Tank",
          "Parsada Tank",
          "Pond at Mohbhatta Road, Bemetara Chhattisgarh",
          "Somnath Forest Area",
        ],
      },
      {
        district: "Bijapur",
        localities: [
          "Bhopalpatnam",
        ],
      },
      {
        district: "Bilaspur",
        localities: [
          "Arpa River, Bilaspur",
          "Banka High School, Bilaspur",
          "Belmundi",
          "Bhaisajhar",
          "Boirpadav Picnic Spot",
          "Chakarbhatha",
          "Chilhati",
          "Delhi Public School",
          "Dyke2 , Rakhardam, Ntpc",
          "GGU - Kaali Mandir Pond No. 1",
          "Ghongha Jalashay, Bilaspur",
          "Guru Ghasidas University Campus, Bilaspur",
          "Kathakoni",
          "Kathakoni Village (OBI)",
          "Keonchi, Chhattisgarh",
          "Khutaghat Dam, Ratanpur",
          "Kopra Dam",
          "Kori Dam, Kota, Bilaspur",
          "Marahi Mata Mandir, Bhanwartonk",
          "Mohanbhata, Bilaspur",
          "NTPC, Seepat, Bilaspur",
          "Near Smriti Van, Rajkishor Nagar",
          "Rakhad Dam, NTPC, Sipat, Bilaspur",
          "Shivsagar Pond Bilaspur",
          "Sipat Thermal Power Station (OBI)",
          "Smriti Van, Rajkishornagar",
          "Smritvan Rajkishore Nagar Bilaspur",
          "Sukhripali Rakhad Dam , NTPC , Seepat",
        ],
      },
      {
        district: "Dantewada",
        localities: [
          "Badebedma, Dantewada",
          "Binjam Primary School Campus Area",
          "Dandami Resort, Chitrakut",
          "Jhodiyabadam School Campus",
        ],
      },
      {
        district: "Dhamtari",
        localities: [
          "BRP Govt. Polytechnic College -- Dhamtari",
          "Bhakhara Waterbody",
          "Dhamtari",
          "GAD colony, Kurud, Dhamtari IN-CT 20.83927, 81.70899",
          "Gangrel Dam (forest area)",
          "Govt. Girls College -- Dhamtari",
          "Kurud Nagar Road, Kurud IN-Chhattisgarh (20.8318,81.7161)",
          "Madamsilli Dam",
          "Near Rice mill, Kurud",
          "Sant Guru Ghasidas Govt. P. G. College Campus Kurud",
          "Sant Guru Ghasidas Govt. P. G. College Campus, Kurud, Chhattisgarh, India",
          "Sant Guru Ghasidas PG College, Kurud",
          "Sitanadi Wildlife Sanctuary",
          "Sondhur Dam",
          "Suncity, Kurud,  IN-Chhattisgarh (20.8341,81.7142)",
        ],
      },
      {
        district: "Durg",
        localities: [
          "Achanakpur Wetland",
          "Ahiwara Road, Hingna",
          "Avenue- A, Sector 6, Bhilai",
          "Belaudi Tank, Chhattisgarh, IN (21.011, 81.457)",
          "Bhaata Behind Nandani Airstrip, Chhattisgarh, IN (21.286, 81.382)",
          "Bhilai, Durg (OBI)",
          "Chicha wetland",
          "IIT Bhilai",
          "Indian Institute of Technology Bhilai",
          "Maitri Baag Zoo, Bhilai",
          "Minakshinagar Grassland",
          "Mines Area Ahiwara, Chhattisgarh, IN (21.359, 81.407)",
          "Oxyzone Sankara",
          "Rungta College Of Engineering and Technology (RSR)",
          "Santra Tank, Matang, Chhattisgarh, IN (21.052, 81.462)",
          "Semri Dam, Patan Chhattisgarh, IN (21.025, 81.488)",
          "Talpuri Biodiversity Park Bhilai",
          "Tarighat Temple Backside, Patan",
          "Villa California by AKS Infratech, Amleser",
        ],
      },
      {
        district: "Gariaband",
        localities: [
          "Awanish Farm House, Chichiya, NH 130C, Gariyaband IN-CT 19.94606, 82.56139",
          "Bhejipadar Bridge Nawapada",
          "Deobhog, Chhattisgarh, India",
          "Gariyaband Circuit House",
          "Ghatarani - Jatmai Matha Road, Junwani, Chhattisgarh, IN (20.809, 82.068)",
          "Lachkera",
          "Sikaser Dam",
          "Udanti Sitanadi TR",
          "Urtuli Road, Gariyaband",
          "collage campus",
        ],
      },
      {
        district: "Janjgir-Champa",
        localities: [
          "Chaitanya Science and Arts College, Pamgarh",
          "Crocodile Park, Kotmi Sunar, Janjgir-Champa",
          "Indira Udyan, Akaltara",
          "Lake of Lagra",
          "Pamgarh",
          "Rojhandih Waterbody Area (RWBA)",
          "khisora forest",
        ],
      },
      {
        district: "Jashpur",
        localities: [
          "Luikona, Jashpur",
          "Neemgaon Dam",
          "Saitangartoli School",
        ],
      },
      {
        district: "Kabirdham",
        localities: [
          "Achanakmar WLS",
          "Badal Pani Waterfall Kawardha",
          "Bhojali Talab, Kawardha",
          "Bhoramdeo WLS",
          "Bhoramdev To Chilphi  Road, Chhattisgarh, IN (22.119, 81.155)",
          "Bhoramdev Wildlife Sanctuary",
          "Bhoramdev Wildlife Sanctuary, Chhattisgarh, IN (22.104, 81.139)",
          "Bodalpani Area , Near Chilphi Ghat",
          "Chhirpani Reservoir - Kabirdham",
          "Energy Park, Kawardha",
          "Fisheries College, Sawaikachhar, Kawardha",
          "Kunda",
          "Mandaghat Forest Area Maharajpur - Bhoramdev",
          "Narmdeshwar Mahadev Mandir, Jhirna",
          "Newari Dam",
          "Panch Dev Mandir",
          "Pidhaghat, Kabeerdham",
          "Rani Dahra Water Fall",
          "Sant Kabir College of Agriculture and Research Station",
          "Saroda Dadar Bhoramdev Forest Range",
          "Sarodhadadar, Kawardha, Chhattisgarh",
          "Sodha Reservoir Kawardha",
          "Sudha Vatika Garden",
          "limo village kabeerdham chhattisgarh",
          "sarodha reservoir kawardha",
        ],
      },
      {
        district: "Kanker",
        localities: [
          "Pichekatta Dam",
          "Prayas School--General Area",
          "Rofra village Bewarti",
          "Rofra village Khamdhodgi",
        ],
      },
      {
        district: "Kondagaon",
        localities: [
          "Kondagaon",
          "Masora Jalasay",
        ],
      },
      {
        district: "Korba",
        localities: [
          "Chaiturgarh",
          "Kendai Waterfall, Bilaspur - Ambikpur Road",
          "Minimata Bango Dam",
          "Nakti bandha",
          "Nunera",
        ],
      },
      {
        district: "Korea",
        localities: [
          "Gej Dam",
          "Gobribandh Reservoir, Katkona",
          "Guru Ghasida TR",
          "Jhumka Dam",
          "Khairi Dam,Patna Chhattisgarh",
          "Schoolpara, baikunthpur, koriya, Chhattisgarh",
        ],
      },
      {
        district: "Mahasamund",
        localities: [
          "Barnawapara WLS -- Paasid Reservoir",
          "Bhalu Chuwa Reservoir",
          "Birkoni, forest nursury",
          "Five Lotus Indo German Nature Cure Centre",
          "Govt. Primary Health Centre Khallari",
          "Kachhardih Pond",
          "Keshwa Reservoir",
          "Kodar Reservoir",
          "Lakshman Mandir, Sirpur",
          "Lamkeni Dam",
          "Maharaji - Arjuni",
          "Pasid Reservoir",
          "Pendrawan Dam (Sirko)",
        ],
      },
      {
        district: "Mungeli",
        localities: [
          "Achanakmaar Tiger Reserve -- Shivtarai Gate",
          "Achanakmar Tiger Reserve",
          "Gidhwa Pahad",
          "Khuriya Dam",
          "Madku Dweep",
          "outskirts of Achanakmar Tiger Reserve (OBI)",
        ],
      },
      {
        district: "Narayanpur",
        localities: [
          "Binjali Dam",
          "DFO Office Narayanpur",
        ],
      },
      {
        district: "Raigarh",
        localities: [
          "Kelo river, Marine drive, SECL Road, Raigarh, Chhattisgarh, IN (21.881, 83.405)",
          "OP Jindal Airport, Raigarh",
          "OP Jindal University (Restricted)",
          "Paryavaran Park, Raigarh, Chhattisgarh",
        ],
      },
      {
        district: "Raipur",
        localities: [
          "Akoli  Bandha Chhattisgarh, IN (21.385, 81.683)",
          "Anupam Nagar",
          "Anupam Nagar, Raipur",
          "Avani Vihar Colony",
          "Ayurvedic College - Herbal Garden",
          "Badhani Dam Adsena",
          "Bangoli Water Dam",
          "Barbanda Pond and Surroundings",
          "Bendri Lake",
          "Bhata Behind Amity University, Chhattisgarh, IN (21.401, 81.898)",
          "Bhata behind Cheriya Lake",
          "Bhatagaon Filter Plant",
          "Block 22 campus, Naya Raipur",
          "Boriya Talab",
          "Budera Pond And Sarround",
          "CG Academy of Administration",
          "CSPDCL Rest House Campus, Gudhiyari",
          "Canal near DPS school",
          "Chhattisgarh Science Centre, Raipur",
          "College Of Agriculture Raipur",
          "Deortilda Dam",
          "Doma",
          "FES Chhattisgarh Raipur Office Env",
          "Firstcry Intellitots Choubey Colony",
          "Floral City and Surroundings",
          "GSD WRS, Raipur, Chhattisgarh, IN (21.286, 81.654)",
          "Ghughuwa Tank Otagan",
          "Gudhiyari Wetlands, Raipur",
          "IIM Raipur",
          "IIT Raipur",
          "Indian Institute of Management (IIM) Raipur",
          "Indira Gandhi Agricultural University (IGKV)",
          "Indira Smriti Van, Raipur",
          "JSPL Quarters, Raipur",
          "Jalso Tank",
          "Kanger Valley Academy Campus",
          "Kathadih Farmhouse, Kathadih, Chhattisgarh, IN (21.178, 81.625)",
          "Khudiya Dam, Naya Raipur",
          "Khuteri Pond",
          "Kosrangi Dam",
          "Kosrangi High School",
          "Kurud Tank, Mandir Hasaud",
          "Kushabhao Thakrey Journalism University, Raipur",
          "LIG 1219 Sector-8 Saddu, Raipur Chhattisgarh",
          "MSB Educational Institute",
          "Mahant Ghasidas Sangrahalaya, Raipur",
          "Mandhar Primary School Campus",
          "Mandhar Talaab",
          "Marsh Land Near Khilora Village",
          "Maruti Lifestyle",
          "Metro Greens, Saddu",
          "Middle School Bharuwadih Kala",
          "Mohrenga Nature Trail",
          "Nahardih Dam and Sarround",
          "Nandanvan Jungle Safari, Nava Raipur",
          "National Institute of Technology (NIT) Raipur",
          "Naveen Primary School",
          "Naveen Primary School Mohrenga",
          "Naya Raipur - Khanduwa - Back Waters of Jungle Safari",
          "Naya Raipur -- Jhanjh Lake",
          "Naya Raipur -- Jungle near Jhanjh",
          "Naya Raipur--Cheriya Lake",
          "Naya Raipur--Courser Bhaata",
          "Naya Raipur--General",
          "Naya Raipur--Jungle Safari",
          "Naya Raipur--Sendh Lake",
          "Near Diamond Tree Apartments, Daldal Seoni Road, Mowa",
          "New Raipur Sector 27 Residential Complex Campus Block 21 - 26",
          "P22, Sec 1, Avanti Vihar (Restricted)",
          "PTS Mana, Raipur",
          "Parsulidih Dam",
          "Pathari - Mangsa Mine",
          "Pikaridih",
          "Pond Near Gatapar Village, Abhanpur",
          "Prayas Hostel Campus",
          "Pt .J N Medical College",
          "Puja Garden",
          "Purkhouti Muktangan",
          "RVH Fields Area Raipur",
          "Raheja Arth, Labandhi Fields Area",
          "Rajiv Smriti Van & Urja Park",
          "Rajkumar College",
          "SIRD Nimora",
          "Samoda Dam",
          "Science College Ground",
          "Serikhedi",
          "State Forest Research and Training Centre, Barauda Raipur",
          "State Forest Research and Training Institute",
          "Swami Vivekanand Sarovar, Budha Talab",
          "Swami Vivekananda Airport, Raipur",
          "Tank at Tor, Chhattisgarh, IN (21.371, 81.743)",
          "The Great India School",
          "Tila Anicut",
          "WRS Colony, Raipur",
          "Water Tank - Dam, Keotara, Chhattisgarh, IN (21.494, 81.893)",
        ],
      },
      {
        district: "Rajnandgaon",
        localities: [
          "Baghnadi",
          "Bamleshwari Devi Temple",
          "Cross Hill",
          "Dhara Dam Dangbora Near Dongargarh",
          "Dongargarh",
          "Kauhapani",
          "Maa Bamleshwari Temple Campus",
          "Mangata Park, Chhattisgarh, IN (21.187, 81.157)",
          "Matiyamoti Dam",
          "Mongra Dam",
          "Pailimeta Dam Area- Rajnandgaon",
          "Paneka",
          "Paniyajob Dam, Chhattisgarh, IN (21.207, 80.667)",
          "Pipariya Jalashay, Khairagarh",
          "Rani Sagar Talab",
          "Ruse Waterbody",
          "Sierpur Dam, Chabuknallah, Chhattisgarh, IN (21.076, 80.468)",
        ],
      },
      {
        district: "Sukma",
        localities: [
          "KGBV Ranibahal",
          "Potacabin Balatikra",
          "Potacabin Murtonda",
          "Sukma town",
          "Tungal Dam",
        ],
      },
      {
        district: "Surajpur",
        localities: [
          "Batara Dam , Datima",
          "Mayurbhanj Dam Area Surajpur Chhattisgarh -23.15172,83.09993",
          "Morbhanj, Ajabnagar",
          "Songara Jungle, Banaras Road",
          "Songara Jungle, Banaras Road,Chhattisgarh, IN (23.357, 83.087)",
        ],
      },
      {
        district: "Surguja",
        localities: [
          "Ghaghi Waterfalls, Darima, Chhattisgarh, IN (22.919, 83.26)",
          "Jalpari Point, Mainpat",
          "Lalmati, Luchki Ghat, Raigarh Road, Ambikapur",
          "Mainpat Ghats ,Chhattisgarh, IN (22.895, 83.338)",
          "Mudesa, Chhattisgarh, IN (23.084, 83.099)",
          "Pond Behind Sainik School, Ambikapur",
          "Sanjay Park , National Highway 343, Ambikapur, Chhattisgarh, IN (23.144, 83.206)",
          "Tiger Point, Mainpath",
          "kuwarpur dam",
        ],
      },
    ],
  },
  {
    state: "Dadra and Nagar Haveli",
    districts: [
      {
        district: "Dadra & Nagar Haveli",
        localities: [
          "BBA Polytechnic College Campus",
          "Bedpa",
          "Bonta Nature Trail",
          "Butterfly Park, Dadra and Nagar Haveli",
          "Dadra and Nagar Haveli WLS",
          "Khadoli Outskirts",
          "Luhari Hills",
          "Madhuban Dam Forest",
          "Madhuban Dam Riverside",
          "PRABIR",
          "Tinoda Forest Trail",
          "Umarkui Waterfalls",
          "Vasona",
        ],
      },
    ],
  },
  {
    state: "Daman and Diu",
    districts: [
      {
        district: "Daman",
        localities: [
          "Daman Beach (Devka)",
          "Moti Daman Old Lighthouse",
        ],
      },
      {
        district: "Diu",
        localities: [
          "Betawadi-Dagachi Pond",
          "Diu",
          "Diu Airport",
          "Diu--General Area (OBI)",
          "Fudam Bird Sanctuary",
          "Gandhipara Lake",
          "Gangeshwar Mahadev (OBI)",
          "Ghoghla Beach",
          "Ghoghola, Diu",
          "Government College, Diu",
          "Krishna Beach Resort",
          "Saudwadi Lake",
        ],
      },
    ],
  },
  {
    state: "Delhi",
    districts: [
      {
        district: "Central Delhi",
        localities: [
          "Ambedkar University Delhi, Kashmere Gate Campus",
          "Asita West",
          "Delhi School of Social Work, University of Delhi",
          "Delta on yamuna bank",
          "Department of Geology, Delhi University",
          "Hansraj College, Delhi",
          "Hindu College, Delhi",
          "Indraprastha College for Women",
          "Jagatpur Khadar",
          "Janki Devi Memorial College",
          "Kamla Nehru Ridge",
          "Miranda House Delhi",
          "New Delhi Railway Station",
          "Nigambodh ghat",
          "Old Delhi Railway Station",
          "Raj Ghat, Delhi",
          "Raj Ghat--Yamuna Bank",
          "Red Fort, Delhi",
          "Roshanara Bagh",
          "SGTB Khalsa College",
          "Sabhapur Pushta Khader (Sonia Vihar)",
          "St. Stephen's College",
          "St. Stephen's Hospital, Tis Hazari",
          "University of Delhi, North Campus",
          "Yamuna Biodiversity Park--Phase 2",
          "Yamuna Biodiversity Park--Phase I",
          "Yamuna Khadar (Sunder Vihar Colony)",
          "Yamuna Khadar (Wazirabad)",
          "Yamuna Khader, Usmanpur (OBI)",
          "Yamuna River, Delhi (OBI)",
          "Yamuna-- Asita",
        ],
      },
      {
        district: "East Delhi",
        localities: [
          "Amrut Biodiversity Park ,CWG Complex, NH-24, Delhi",
          "Anand Vihar",
          "Commonwealth Games Village Sports Complex",
          "DDA Park IP Extension",
          "Ghazipur dumpyard",
          "Sanjay Jheel(Lake) Mayur vihar",
          "Smriti Van Mayur Vihar Phase 3",
          "Vasundhara Enclave",
          "Yamuna Bank Depot",
          "Yamuna Khadar,Geeta Colony IN/DL",
        ],
      },
      {
        district: "New Delhi",
        localities: [
          "AES New Delhi Campus (Private Access)",
          "Aerocity complex",
          "Aravalli Biodiversity Park",
          "Aryabhatta College/Ram Lal Anand College (RLA)",
          "Ashok Hotel, Delhi",
          "Buddha Jayanti Park",
          "Delhi Cantt",
          "Delhi Gymkhana Club DL/IN",
          "Delhi Public School R.K.Puram DL/IN",
          "Delhi, India (OBI)",
          "Dwarka Sector 22 Park",
          "GD Goenka School Vasant Kunj-Delhi",
          "India Gate",
          "Indira Gandhi International Airport, Delhi",
          "Jantar Mantar, New delhi",
          "Jawaharlal Nehru University (JNU) Campus",
          "Jesus and Mary college Delhi-IN",
          "Laxmi Bai Nagar",
          "Leela Ambience Hotel, Gurugram",
          "Lodhi Gardens",
          "Malcha Marg Jungle",
          "NIPGR, Vasantkunj",
          "National Agricultural Science Museum",
          "National Rail Museum",
          "Nehru Memorial Museum and Library",
          "Nehru Park",
          "Paschimabad Checkdam",
          "Purana Qila",
          "Pusa campus--Rajindernagar",
          "Rugby ground Vasantkunj",
          "Safdarjung Tomb",
          "Sarojini Nagar IN/DL",
          "Shankar Vihar",
          "Sri Venkateswara College, Delhi",
          "TERI University Campus",
          "Tripura Bhawan",
          "United Service Institution of India Subroto park",
          "University of Delhi--South Campus",
          "WWF Lodhi Colony IN/DL",
        ],
      },
      {
        district: "North Delhi",
        localities: [
          "Ambedkar University Delhi--Dheerpur Campus",
          "Bajitpur Thakran pond",
          "Bhalswa Horsehoe Lake",
          "Dada Maldev Pond",
          "Delhi Technical University (DTU) Main Gate",
          "Dheerpur Wetland Park (DWP)",
          "Dhirpur (AUD new campus)",
          "Dhirpur Wetland",
          "Japanese park",
          "Sungarpur",
        ],
      },
      {
        district: "North East Delhi",
        localities: [
          "Garhi Mandu",
          "Garhimandu City Forest",
          "Usmanpur Village",
          "Yamuna Flood plains Burari Ghat",
          "Yamuna Vanasthali,New Delhi",
        ],
      },
      {
        district: "North West Delhi",
        localities: [
          "Ambedkar University Delhi (AUD), Rohini Campus",
          "Ambedkar University, Rohini Campus DL/IN",
          "District Park--Pitampura",
          "District Park--Shalimar Bagh",
          "Jaunti Temple pond",
          "Kanjhawala wetlands Karnal",
          "Ladpur Wetland",
          "Pratap Vihar Lake",
          "Qutabgarh Nursery",
          "Sawda Wetland DL/IN",
        ],
      },
      {
        district: "Shahdara",
        localities: [
          "CBD Shahdara Scrub",
          "GTB Hospital--Dilshad Garden",
          "Institute of Human Behaviour and Allied Sciences Hospital (OBI)",
          "Karkardooma",
          "Karkardooma Park",
          "Yamuna Sports Complex",
        ],
      },
      {
        district: "South Delhi",
        localities: [
          "Aarambh (Restricted Access)",
          "Arjangarh",
          "Bhatti Mines",
          "Garden of Five Senses",
          "Gargi College, Delhi",
          "Green Park",
          "Hauz Khas Forest",
          "Hauz Khas--Deer Park",
          "Hauz Khas--Lake",
          "IIT Delhi",
          "Indira Gandhi National Open University, (IGNOU)",
          "Jahanpanah City Forest",
          "Jirkhod Dera mandir, Dera Mandi,",
          "Ma Sarada Park hauz khas Del-ind",
          "Malviya Nagar (OBI)",
          "Mehrauli Archaeological Park ND/IN",
          "NCERT Campus, New Delhi",
          "Neela hauz Vasantkunj",
          "Qutub Minar",
          "RK Puram--Sector 3",
          "Rose Garden IN/DL",
          "Sanjay Van",
          "Satpulla Lake Complex",
          "Shaheed Bhagat Singh College",
          "TARA Centre of Excellence (Ghitorni Campus)",
          "The Mother's International School",
          "Tilpath Valley Biodiversity Park",
          "b5 park Safdarjung Enclave",
          "chandrabhaga check dam jnu delhi",
        ],
      },
      {
        district: "South East Delhi",
        localities: [
          "AIIMS Campus",
          "Acharya Narendra Dev College (ANDC)",
          "Ambedkar University Delhi, Lodhi Road Campus",
          "Asola Wildlife Sanctuary",
          "Chilla Khadar--Mayur vihar",
          "Delhi Golf Club IN/DL",
          "Deshbandhu College, Delhi",
          "Dyal Singh College",
          "Hazrat Nizamuddin Railway Station",
          "Holy Family Hospital, Okhla",
          "Humayun's Tomb",
          "Jamia Millia Islamia University (JMI)",
          "Kalindi Kinj Park",
          "Lotus Temple DL/IN",
          "PGDAV College Campus, Delhi",
          "Ramanujan College, University of Delhi",
          "Sadiq Nagar Park",
          "Sunder Nursery, Nizamuddin",
          "Tughlakabad",
          "Tughlaqabad Biodiversity Park",
          "Zoological Park",
        ],
      },
      {
        district: "South West Delhi",
        localities: [
          "DDA Water Body--Sector 23 Dwarka",
          "District Park, Dwarka Sector 19-B IN/DL",
          "Guru Gobind Singh (GGS) Indraprastha University",
          "Hotel Radisson Blu, Dwarka",
          "Mitraon city forest IN-DL",
          "Najaf Garh Drain--Dhansa Barrage",
          "Najaf Garh--Galibpur village",
          "Najafgarh Drain--Dwarka",
          "Najafgarh Jheel Area",
        ],
      },
      {
        district: "West Delhi",
        localities: [
          "Ambedkar University Delhi, Karampura Campus",
          "B 1 Park Paschim Vihar",
          "Deen Dayal Upadhyaya College, Delhi",
          "District Park, Paschim Vihar",
          "IARI Pusa Campus",
          "Integrated Law Course (ILC), Faculty of Law",
          "Janakpuri District Park, B1",
          "Kalindi College, University of Delhi",
          "Manohar Lal Arora community Park",
          "Netaji Subhas University of Technology",
          "Rajdhani College",
          "Vikaspuri, F-Block DDA Park",
        ],
      },
    ],
  },
  {
    state: "Goa",
    districts: [
      {
        district: "North Goa",
        localities: [
          "Adulshe, Borim",
          "Agacaim Tidal mudflats",
          "Aldona fields",
          "Amberem hills",
          "Amona Fields",
          "Amritara Aura Resort & Spa",
          "Anjuna Beach",
          "Ansabhat, Mapusa",
          "Arabian Sea",
          "Arabian Sea: 15.5N 73.5E",
          "Arabian Sea: 15.5N 73.6E",
          "Arabian Sea: 15.5N 73.7E",
          "Arabian Sea: 15.5N 73.8E",
          "Arabian Sea: 15.6N 73.6E",
          "Arabian Sea: 15.6N 73.7E",
          "Arambol",
          "Arambol Beach",
          "Arambol Mountain & Sweet Lake",
          "Arannya Environment Research Organisation- CEC",
          "Arpora Saltpans",
          "Arpora Woods",
          "Ashvem Beach",
          "Assagao Village",
          "Azossim Fields and Wetlands",
          "Baga",
          "Baga Fields",
          "Baga Hill, Goa, India",
          "Baga River",
          "Bainguinim",
          "Bambolim Beach",
          "Bambolim forest- Aldeia De Goa, Pod 7",
          "Banastari Wetlands",
          "Barazan Plateau Mopa",
          "Barazan Plateau,Mopa",
          "Batim Lake",
          "Beira Mar Hotel, Baga",
          "Betki, Khandola",
          "Bhatulem-Taligaon Communidade Land",
          "Bicholim & Surrounding areas",
          "Bondla Wildlife Sanctuary",
          "Bondla Wildlife Sanctuary- Tourist Dormitory",
          "Bondvol/ Bondava Lake, St Cruz",
          "Borim marshlands and paddyfields",
          "Butterfly Conservatory of Goa",
          "Calangute Beach",
          "Calangute Fields",
          "Calvim Island, Aldona",
          "Campal Children's Park",
          "Candolim Beach",
          "Candolim Marshes",
          "Cansarvornem hill",
          "Carambolim Lake & Surroundings (IBA)",
          "Carambolim- Dhado Wetland Complex- IBA",
          "Caranzalem",
          "Caranzalem- Beach (Children's Park Area)",
          "Chapora Estuary",
          "Chapora Fort",
          "Chapora River, Goa (OBI)",
          "Chapora River, North Goa (OBI)",
          "Chapora riverside",
          "Chidambar trail",
          "Chimbel lake",
          "Club Mahindra Assonora (Restricted Access)",
          "Club Mahindra Resort - Assonora, Goa",
          "Cumbarjua Canal",
          "Curca Saltpans",
          "Darghalim, Goa (OBI)",
          "Dashi lake",
          "Devlay- Khandola, Marcela",
          "Dhamshe Village",
          "Dhargalim, Pernem, Goa.",
          "Dhempe College of Arts & Science",
          "Divar Island",
          "Divar island",
          "Dona Paula Beach",
          "Dona Paula Jetty",
          "DoubleTree by Hilton - Panaji",
          "Farmagudi Plateau",
          "Fort Aguada",
          "Ganjem Junction and Ganjeshwari Temple",
          "Ganjem bridge",
          "Ganpat Parsekar College of Education",
          "Gaunem Marshes And Surroundings",
          "Goa College of Engineering",
          "Goa Institute of Management Campus (GIM), Sanquelim",
          "Goa State Biodiversity Board Campus",
          "Goa University Campus",
          "Goa University Guest house",
          "Goa Velha Mangroves",
          "Government College of Arts, Science & Commerce",
          "Government High School, Ambedem",
          "Grand Hyatt, Goa",
          "Harvelim, Sanquelim",
          "IT Park Dona Paula, Panjim",
          "Kala Academy Environs",
          "Karapur, Sanquelim",
          "Karna Farm, Codal",
          "Korgao village",
          "Krishi Vigyan Kendra Campus",
          "Krishnadas Shama State Central Library",
          "Kudapwada Wetland and Marshes",
          "Kudchire-Bicholim",
          "Kudzyar Ground Road",
          "La Goa Azul and surrounding area(Restricted Area)",
          "MHADEI BIO REGION",
          "Madei WLS(IBA)--Codal Trail",
          "Madei WLS(IBA)--Nonorem Ground",
          "Madkai - Kundaim Road",
          "Maina Wetlands",
          "Mandrem Beach",
          "Mangeshi Temple and Surroundings",
          "Mayem Lake, Bicholim",
          "Meadow and hilly grasslands near sports stadium,Vadi Talaulim",
          "Merces Marshland",
          "Mhadei WLS(IBA)--Barazan Waterfall Surla",
          "Mhadei WLS(IBA)--Satrem",
          "Mhadei WLS- Chorla Ghat Section (IBA)",
          "Mhadei WLS--Kuntal-Krishnapur Trail",
          "Mhadei WLS--Satre Road",
          "Mhadei WLS--Surla Plateau (IBA)",
          "Mhadei Wildlife Sanctuary (IBA)",
          "Mhovacho Guno",
          "Milroc Ribander Retreat (Housing Society)",
          "Miosal Dam and Surroundings",
          "Miramar- Caranzalem Beach",
          "Mojigao",
          "Morjim Beach",
          "Morle Gad Foothills",
          "Nagalli-Caranzalem Pond",
          "Nandan's ODK Hide (Restricted Access)",
          "Narve-Tikhazan Marsh South",
          "National Institute of Oceanography",
          "Navelim Wetlands (IBA)",
          "Nerul River pathway",
          "Neura Wetlands",
          "New Goa International Airport, Mopa, Goa",
          "North bank - Zuari River",
          "Odxel",
          "Old Goa",
          "Outside Bondla Wildlife Sanctuary",
          "Ozarim pond",
          "Ozran Beach",
          "PES College of Arts and Science",
          "PM Shri Kendriya Vidyalaya",
          "Padeli--Mandovi River Bridge",
          "Paitona Fields",
          "Paliyem Plateau",
          "Paliyem village",
          "Panaji KTC Bus Stand",
          "Panarim Fields",
          "Patacho Vhal Bridge, Ibrampur, Goa, India",
          "Pernem Hills",
          "Pernem village",
          "Pether Tank",
          "Pilerne Fields",
          "Pilerne Lake",
          "Pilerne Plateau",
          "Ponda Electricity Department",
          "Poraskade marshlands, Pernem",
          "Porvorim Goa Housing Board and Journalist Colony",
          "Querim Beach",
          "Querim village",
          "Ragada River bridge",
          "Ribandar Causeway, Panjim",
          "Rock Valley Studios",
          "Sahakari Spice Plantation",
          "Saligao Fields",
          "Saligao Plateau",
          "Saligao Zor (springs)",
          "Salim Ali Bird Sanctuary,Chorao",
          "Salvador Do Mundo Forest",
          "Salvador do Mundo Creek",
          "Salvador do Mundo Fields",
          "Santa Cruz Wetlands, Panaji",
          "Santa Cruze Wetland (South End)",
          "Santo Minguel High School",
          "Shikeri Rock Beach",
          "Shirgao Creek",
          "Shiroda Mangroves",
          "Shri Lakshmi Narasimha Temple",
          "Shri Siddhanath Temple, Borim",
          "Sinquerim Beach",
          "Sinquerim Fort Seawatch Point",
          "Siolim Fields",
          "Siolim Hills",
          "Siridao Beach",
          "Socorro Fields",
          "Socorro Plateau",
          "Sonesta Inns",
          "St Estevam fields",
          "St Inez Creek & Surrounding, Panjim",
          "Storii ITC Riviera Moira Goa",
          "Sulabhat Lake,Pilar",
          "Swami Vivekanand Vidyaprasarak Mandals College of Commerce",
          "Swapnagandha Resort, Chorla Ghat",
          "Swapnagandha resort Chorla, Goa",
          "Talaulim-Tiswadi",
          "The Fern Kadamba Hotel & Spa,Velha,Goa",
          "The Our Lady On The Mount Chapel, Old Goa",
          "The Postcard Velha",
          "Tikhazan-Narve Marshes (West)",
          "Tiracol",
          "Torxem Wetlands",
          "Toyaar Lake",
          "Tropical Spice Plantation, Ponda Keri",
          "Ucassaim Fields and Wetlands",
          "Vanxim Island",
          "Wildernest Resort",
          "Wildflower villas eco resort",
          "olaulim backyard",
          "reis margo fort rd",
        ],
      },
      {
        district: "South Goa",
        localities: [
          "Agonda Beach GOA/IN",
          "Arabian Sea: 15.1N 73.7E",
          "Arabian Sea: 15.1N 73.8E",
          "Arabian Sea: 15.2N 73.7E",
          "Arabian Sea: 15.2N 73.8E",
          "Arabian Sea: 15.3N 73.6E",
          "Arabian Sea: 15.3N 73.7E",
          "Arabian Sea: 15.3N 73.8E",
          "Arabian Sea: 15.4N 73.5E",
          "Arabian Sea: 15.4N 73.6E",
          "Arabian Sea: 15.4N 73.7E",
          "Arabian Sea: 15.4N 73.8E",
          "Arossim Beach",
          "Arrossim (Cansaulim) Lake & Surrounding",
          "Aximaddi Cacora Curchorem- Goa",
          "Aximaddi Cacora playground",
          "BITS Pilani KK Birla Goa Campus",
          "Bacbhat fields & surroundings",
          "Backwoods Camp, Tambdi Surla",
          "Baida, Chinchinim,Salcete,Goa",
          "Bamanbudo Falls",
          "Barabhumi High School",
          "Benaulim Beach",
          "Benaulim Wetlands",
          "Betal Temple Road",
          "Betalbatim",
          "Betul Beach, South Goa",
          "Betul Fort",
          "Betul lighthouse",
          "Bhagwan Mahaveer WLS & Mollem NP (IBA)",
          "Bhagwan Mahaveer WLS and NP(IBA)",
          "Bhagwan Mahavir WLS(IBA)--Dudhsagar Waterfalls",
          "Bhati,Sanguem",
          "Biodiversity park--Mollem National Park",
          "Bogmalo, Goa",
          "Bolkarne,Surla",
          "Bomshal, Maina-Curtorim",
          "Borim bridge",
          "Butterfly Beach- Approach Trail",
          "Cabo Serai",
          "Cabo-De-Rama Fort",
          "Camorlim Marshes",
          "Canacona Wetland Ecosystem",
          "Canacona wetland ecosystem",
          "Cansaulim Beach",
          "Caravela Beach Resort",
          "Carmel College",
          "Carmona Naval Firing Range",
          "Cavelossim Beach",
          "Chandreshwar Hill,Gudi,Paroda",
          "Chapoli",
          "Chicolna, Vasco da Gama",
          "Chicolna/Bogmalo",
          "Chinchinim Hill",
          "Church lake,Curtorim",
          "Club Mahindra Acacia Palms, Colva",
          "Club Mahindra Varca, Goa",
          "Codli Forest Area",
          "Cola Beach",
          "Cola Beach Plateau",
          "Collem Railway station environs",
          "Colva Beach",
          "Colva Dry fish wholesale market",
          "Cortalim Flood Waters",
          "Cotarli,Salaulim Canal",
          "Cotigao WLS (IBA)--Bela Lake",
          "Cotigao WLS -- Tirwal Road",
          "Cotigao WLS(IBA)--Edda",
          "Cotigao WLS(IBA)--Edda-Nadke Road",
          "Cotigao WLS(IBA)--Hattipaul Gate",
          "Cotigao WLS(IBA)--Nadke",
          "Cotigao WLS(IBA)--Tree Top Rooad",
          "Cotigao WLS(IBA)--Tulshimol",
          "Cotigao Wildlife Sanctuary (IBA)",
          "Cuncolim United HSS Campus",
          "Curpem Forested patch and surrounding areas",
          "Dabel Bridge",
          "Daddy's Home of Joy for Elderly and Surroundings",
          "Dando Plateau, Curtorim VP, Salcete, Goa.",
          "Dharge",
          "Dive Site- The Suzy",
          "Don Bosco College of Agriculture",
          "Dudhasagar Plantations",
          "Durga Lake & Surounding Chinchinim",
          "Edda Waterhole",
          "Fatrade Beach",
          "Fields next to Assolna-Cavelossim Bridge",
          "GHS Balli",
          "Galgibag Beach",
          "Goa Cruise Terminal",
          "Goa International Airport, Dabolim",
          "Gogol (OBI)",
          "Government College of Arts Science & Commerce, Quepem",
          "Govt. College, Quepem",
          "High Grounds - Green Space",
          "Hills around Froggyland, Nuvem",
          "Igramol Quepem",
          "Jungle Trails Homestay, Talde",
          "Kulem (Colem)",
          "Kumtolem Wetland",
          "Kurdi Dam",
          "Kuske Trail",
          "Lalit Golf & Spa Resort",
          "Local Boat Trips -- Agonda, Goa",
          "Loliem Plateau",
          "Loliem wetland",
          "Lotlee Marshes & Surrounding",
          "Lotoulim-Borim Bridge,Lotoulim",
          "Loutolim Khazans",
          "Macazana lake",
          "Madel Trail, Uguem",
          "Madgaon Bus Terminal",
          "Madgaon Railway Station",
          "Maimollem Lake, Vasco",
          "Maina wetlands",
          "Maina-Raia Wetlands",
          "Maitolle Lake & surrounding,Curtorim",
          "Majorda Beach",
          "Marmagoa Port, Vasco-da-gama (OBI)",
          "Mirabag Dhadem road",
          "Mobor Beach",
          "Mount Mary Higher Secondary School, Chinchinim-- Goa",
          "NV Ecofarm, Dabal",
          "Nagoa Fields",
          "Nanda Lake",
          "Naquerim,South Goa",
          "Natures Nest",
          "Natures Nest & Surrounding",
          "Netravali Bubbling Lake",
          "Netravali WLS",
          "Netravali WLS(IBA)--Saljini",
          "Netravali WLS(IBA)--Savri Waterfall",
          "Netravali WLS(IBA)--Verle-Saljini Road",
          "Nuvem Bypass Junction",
          "Our Lady of Rosary Church, Davorlim",
          "Pale velsao",
          "Palolem",
          "Parvatibai Chowgule College",
          "Patnem Beach",
          "Paulancho Khuris",
          "Pedda Junction",
          "Pelagic trip off the coast of Goa (OBI)",
          "Polem Beach",
          "Quitla Plateau",
          "Rachol Bund",
          "Ragada River Bridge ,Sancordem",
          "Raitollem Lake",
          "Rajbag Beach",
          "Rivona",
          "Rock Carving Usgalimal, Rivona",
          "Rohan Heights- Holy Cross Colony",
          "Sacorda udalshem",
          "Sadolxem Bridge",
          "Sadolxem Mangroves and Fields",
          "Salauli Dam, Valkini",
          "Salaulim Dam Garden",
          "Saleri River",
          "Sancordem Bridge",
          "Sancordem, BMWLS",
          "Santimol",
          "Sarzora lake",
          "Savonem-Udo wetland & surroundings, Raia",
          "SeaMist Colva village pond",
          "Seraulim Pond area",
          "Sernabatim Beach",
          "Sernabatim Fields",
          "Seven Temples, Veroda, Goa.",
          "Shabu Tollem, Velim, Salcete, Goa",
          "Shree Mallikarjun College Canacona",
          "Shri Barabhumi Devasthan",
          "St Judes High School",
          "St. Thomas High School",
          "Stone Water Eco Resort",
          "Surla, Sacorda",
          "THE KING'S SCHOOL",
          "Tallya-bandh, Igramol",
          "Talpona",
          "Tambdi Surla- Mahadev Temple and Surroundings",
          "Tanshikar Spice Farm",
          "The Postcard Hideaway",
          "The St. Regis Goa Resort",
          "Three Kings Chapel hill, velsao ,goa",
          "Tilamola Wetlands",
          "Trinity Beach approach Wetland",
          "Tudal-Gaodongrim Fields",
          "Udear Springs",
          "Uguem-Zuna",
          "Utroda Beach",
          "Varca Beach",
          "Varca-Fatrade Beach Road, Goa",
          "Vasco da Gama (OBI)",
          "Velim Marsh",
          "Velsao Beach",
          "Velsao Wetland & fields",
          "Verna Ambulor Lake",
          "Verna Industrial Estate Plateu",
          "Verna, South Goa (OBI)",
          "Veroda Bridge",
          "Veroda, Cuncolim, Salcete, Goa",
          "Xeldem Lake",
          "Xelvon, Quepem",
          "ZAC Reservoir & Surrounding",
          "Zalor Beach, South Goa",
          "Zuari River",
          "offshore waters, Goa, India (OBI)",
        ],
      },
    ],
  },
  {
    state: "Gujarat",
    districts: [
      {
        district: "Ahmedabad",
        localities: [
          "ATIRA - Ahmedabad Textile Industry's Research Association",
          "AUDA GARDEN",
          "Adani Shantigram Residential Area",
          "Ahmedabad Cantonment",
          "Ahmedabad University",
          "Ambli road, Bopal",
          "Asalgam",
          "Asarwa Lake",
          "Astronomy Club",
          "Bagodara (OBI)",
          "Bavla",
          "Bavla Old Mill OBI",
          "Bhavan’s Sheth R A College of Science",
          "Bhogawo River near Fedara",
          "Bodakdev Van Chetna Kendra",
          "C.N. College Of Fine Arts Campus",
          "CEPT University, Ahmedabad (Restricted)",
          "Centre for Environment Education (CEE)",
          "Changodar",
          "Chittvan Society",
          "Civil Hospital Ahmedabad",
          "Dafnala",
          "Devpujan Apartment",
          "Divan Ballubhai High School campus",
          "Divan Ballubhai Secondary School",
          "Doordarshan , Ahmedabad",
          "Eklavya School",
          "Empty Plot near Hiraba Farm",
          "Gangasar Lake Viramgam",
          "Garden Residency 3",
          "Gopi Vallabh Avenue",
          "Gotila Auda Garden",
          "Government Polytechnic, Ahmedabad",
          "Greenvalley Flats",
          "Gujarat Cancer Society Medical College, Ahmedabad (OBI)",
          "Gujarat University",
          "Gujarat University (Upasana Amphitheatre)",
          "Gujarat University Boys Hostel",
          "Gujarat commerce college",
          "IIM, Ahmedabad (OBI)",
          "ISRO Colony, Vastrapur",
          "Indian Institute of Management Ahmedabad (Restricted)",
          "Kalhaar Blues and Greens Golf CLub",
          "Kamla Nehru Zoo",
          "Kankaria Lake",
          "Kankaria Lake--Zoo Gate",
          "Karnavati Club",
          "Khan Talav, Dholka",
          "Kocharab Ashram",
          "Koteshwar Temple near Sabarmati River",
          "Lakshmi Lake",
          "Lalbhai Dalpatbhai Museum",
          "Lalit Kala",
          "Lapkaman (OBI)",
          "Law Garden",
          "Lilapur Pond",
          "M. G. Science Institute",
          "Madhav Residency",
          "Manekbaug Society Garden",
          "Manipur Lake",
          "Monarch City 2",
          "Moti Kishol",
          "Moti Kumad",
          "Moti Kumad, Viramgam",
          "Nal Sarovar (to Merge)",
          "Nal Sarovar Bird Sanctuary",
          "Nal Sarovar Chowkdi, Kitli",
          "Nal Sarovar Outskirts- Nani Kathechi",
          "Nalsarovar Outskirts",
          "Nalsarovar Outskirts--Adroda",
          "Nalsarovar Outskirts--Aniyali",
          "Nalsarovar Outskirts--Shahpur",
          "Nalsarovar--Boating Point",
          "Nalsarovar--Chaurathali",
          "Nalsarovar--Chokdi",
          "Nalsarovar--Flamingo Sankul",
          "Nalsarovar--Garden",
          "Nalsarovar--Vekariya Village Pond",
          "Nirma University",
          "Nisarg, near Sanand (OBI)",
          "Outskirts of Ahmedabad (OBI)",
          "Parimal Garden",
          "Paritosh, GN Farms",
          "Physical Research Laboratory (PRL) Thaltej Campus",
          "Physical Research Laboratory Hostel Campus, Navrangpura",
          "Pond near Shela",
          "Pond, Bhavnagar-Pipali Highway, Before Velavadar NP Turn",
          "Rachana School Campus",
          "Rasala Nature Park",
          "Ratna Lake",
          "Riverfront Flower Park, Ahmedabad",
          "Riverfront Park",
          "Ruhapur Lake",
          "SAC-ISRO Bopal Campus",
          "SKUM School Campus",
          "SOBO Centre",
          "SPIPA Campus",
          "Sabarmati Ashram",
          "Sabarmati BG",
          "Sabarmati River near Motera Stadium",
          "Sabarmati Riverfront near Buddha Statue, IN (23.055, 72.577)",
          "Sabarmati Riverfront--Usmanpura",
          "Sabarmati Riverfront--Vasna Barage B1",
          "Saint Xaviers School",
          "Sakshat Apartments",
          "Sanathal Chota Talab",
          "Sanmukh Apartments",
          "Sardar Patel Institute Of Economic And Social Research (SPIESR)",
          "Sardar Vallabhbhai Patel Airport Ahmedabad",
          "Sardar Vallabhbhai Patel National Memorial",
          "Sarkhej Roza",
          "Saroda village (OBI)",
          "Satyagrah Chhavani",
          "Science City, Ahmedabad",
          "Shela Godhavi Canal",
          "Shela Pond",
          "Shela Tank",
          "Sheth C.N. Vidyavihar",
          "Shilaj Village (OBI)",
          "Shiyawada",
          "Shreyas Foundation",
          "Shreyas Tekra (OBI)",
          "Silver Gardenia, Gota",
          "Sivanta Apartments",
          "Smarana",
          "Someshwar Row House-1",
          "Space Application Centre-ISRO",
          "St Kabir School, Memnagar",
          "St. Xaviers College (Autonomous)",
          "Sundarvan Nature Discovery Centre",
          "Suprabh Apartment",
          "Swareet Apartments",
          "Sweet Home Society (OBI)",
          "Symphony Forest Park",
          "Tatwatirth Ashram",
          "Tea Factory",
          "The Calico Museum of Textiles and surrounding garden",
          "Thori Mubarak",
          "Upardal lake",
          "VASCSC",
          "Vaagad, Kutch (OBI)",
          "Vagad, Kutch (OBI)",
          "Van Chetana Kendra",
          "Vasai Wetland",
          "Vastrapur Lake Garden",
          "Vejalpur, Ahmedabad (OBI)",
          "Vikram Nagar Housing Colony",
          "Viramgam Panjrapol",
          "Viramgam, Ahmedabad (OBI)",
          "Virpur Panjrapol Carcass Dump",
          "Vulture Point",
          "Wetland Near Vasana",
          "Zamp, near Sanand (OBI)",
          "way to Thol from Nalsarovar (OBI)",
        ],
      },
      {
        district: "Amreli",
        localities: [
          "Ambardi Safari Park, Dhari",
          "Dhari-Amreli Rd",
          "Dhatarwadi Dam",
          "Facharia Dam",
          "Gir Retreat Resort, near Dhari (OBI)",
          "Gir Sanctuary & NP--Shemardi Checkpost",
          "Hanuman Gala Temple",
          "Khambha",
          "Khavda Road, near Vekariya (OBI)",
          "Khodiyar Dam",
          "Mitiyala (OBI)",
          "Ramnath Mahadev Temple",
          "Saladi Tank",
          "Saladi Village, Amreli (OBI)",
          "Saltpans near Jafrabad",
          "Thebi Dam",
          "Thordi Lake",
          "Victor Saltpans",
          "Zinzuda Dam",
        ],
      },
      {
        district: "Anand",
        localities: [
          "Anand Junction",
          "Baroque Pharma (OBI)",
          "Bhaikaka University",
          "Botanical Garden - Sardar Patel University",
          "Bridge on Sabarmati River, Vataman-Tarapur Rd",
          "Dabhou - Malataj Rd",
          "Dabhou Lake",
          "Devataj",
          "FES Campus",
          "Gulf of Khambhat (OBI)",
          "IRMA Campus",
          "Jinaj Pond",
          "Juni Akhol",
          "Kaneval Lake",
          "Khambhat (OBI)",
          "Lambhvel Tank",
          "Mahi Check Dam at Sindhrot",
          "Mahi River-Art of living",
          "Mahisagar River Bed, Vadodara (OBI)",
          "Mahisagar Riverbank, Valvod",
          "Malataj Lake",
          "Mogri Talav",
          "NDDB Campus",
          "Navagam Bara",
          "Navagam Bara (Khambhat)",
          "Rel",
          "Rohni",
          "Rustic Villa ( Mogar )",
          "Sardar Patel University",
          "Sherpura pond, Petlad",
          "Surajba Park",
          "Tarakpur Dam",
          "Varasda Lake",
          "Vishal's birding ditch",
        ],
      },
      {
        district: "Aravalli",
        localities: [
          "Katkuva",
          "Limbhoi Lake",
          "Meswo Reservoir",
        ],
      },
      {
        district: "Banaskantha",
        localities: [
          "Adivasi Ashram School",
          "Aravaali trails",
          "Bajothiya Panjrapol",
          "Balaram Ambaji WLS",
          "Dantiwada Dam (OBI)",
          "Dasha Ma Talab, Gadh",
          "Hathindra (OBI)",
          "Jasara",
          "Jessore Sloth Bear Sanctuary",
          "Mahajan Gaushala (OBI)",
          "Moral village",
          "Nadabet Wetland Complex--Jagmal Beyt Lake 1 and 2",
          "Nadabet Wetland Complex--Jagmal Beyt Tower",
          "Nadabet Wetland Complex--Opp. Tourism",
          "Nadabet Wetland Complex--Padan 2",
          "Nadabet Wetland Complex--Wo Dam",
          "Patan (OBI)",
          "Ranitook, Dantiwada (OBI)",
          "Ranitunk Mahadev Temple",
          "Sardarkrushinagar Dantiwada Agricultural University",
          "Sipu dam",
          "Tharad (OBI)",
          "Vav (OBI)",
          "behind Banas Dairy, Banaskantha (OBI)",
        ],
      },
      {
        district: "Bharuch",
        localities: [
          "Ankleshwar, Bharuch (OBI)",
          "Bharan, Ankleshwar,",
          "Bhoothnath Mahadev Temple, Dahej",
          "Dahej Port",
          "GNFC lake",
          "Gelani Kuva, Bharuch",
          "Juna Diva Road",
          "Kabirvad",
          "Kabirvad--Jetty Point",
          "Kavi Beach",
          "Kosamdi Talav",
          "Matariya Talav",
          "Narmada river, Shuklatirth",
          "Reva Aranya, Bharuch",
        ],
      },
      {
        district: "Bhavnagar",
        localities: [
          "Airport road, Bhavnagar, Gujarat, IN (21.76, 72.175)",
          "Along Gopnath Beach",
          "Avaniya Lake",
          "Avaniya Thorny Forest",
          "Bhavnagar University",
          "Blackbuck Safari Lodge, Rajgadh",
          "Bor Talav (Gaurishankar Lake)",
          "Daripara Dam",
          "Gangajalia Talav (Lake)",
          "Gautam Sarovar",
          "Gopnath",
          "Gorad Smashan",
          "Haathab Beach",
          "Haathab Bunglow Rd",
          "Hamirpara Dam",
          "Hills surrounding Malnath Mahadev Temple",
          "Juna Bandar (Old Port)",
          "Kareda Dam",
          "Khodiyar Dam near Rajpara",
          "Kobadi-Ukharala Rd",
          "Koliyak Beach",
          "Krishnakunj Lake",
          "Kuda Beach",
          "Kuda Sikotarma, Kuda, Gujarat, IN (21.627, 72.298)",
          "Kumbharwada wetland",
          "Lake near Bhavnagar University",
          "Lakhanka Dam",
          "Lal Mer no Vadlo",
          "M.K. Bhavnagar University, Department of Life Sciences",
          "Madhiya Wetland",
          "Malan Bandhara",
          "Maleshri Overbridge (Bhv-Ppl Highway)",
          "Manas Wetland Complex (Samadhiyala Bandhara)",
          "Nagdhanimba Dam",
          "Nava Bandar (New Port) Rd",
          "New Port Lake",
          "Nikol Bandhara",
          "Palitana Hill",
          "Pingaleshwar Beach near Mahuva",
          "Pond on Nawa Bandar- Airport Rd",
          "Prabudas Talav",
          "Purna Talav",
          "Saltpans on Ghogha Rd",
          "Samdhiyala Bandhara--Manas wetland",
          "Shetrunji Dam",
          "Sonariya Lake",
          "Tank near Ravechimata Temple",
          "The Blackbuck Lodge",
          "Vankiya Hanuman Ashram Vicinity",
          "Velavadar NP",
          "Velavadar NP--Alang River",
          "Velavadar NP--Creek",
          "Velavadar NP--Forest Lodge",
          "Victoria Park",
          "Wetland in Velavadar NP",
          "m.k.bhavnagar university, Bhavnagar, Gujarat, IN (21.754, 72.132)",
        ],
      },
      {
        district: "Botad",
        localities: [
          "Botad Lake",
          "Rasnal Vidi",
        ],
      },
      {
        district: "Chhota Udaipur",
        localities: [
          "Bhabhar Village",
          "Jambughoda WLS",
          "Jambughoda WLS--Targol Range",
          "Kevdi Eco Campsite",
          "Moti Khandi --Hill Range",
          "Sukhi Dam",
        ],
      },
      {
        district: "Dahod",
        localities: [
          "Dahod (OBI)",
          "Dahod Forest Cultivation Area",
          "Dasla wetland",
          "Kali Dam",
          "Limkheda Outskirt",
          "Muvalia Dam",
          "Naldha Campsite",
          "Navjivan Science College, Dahod (NSCD)",
          "Rampura Grasslands",
          "Ratanmahal WLS",
          "Ratanmahal WLS--Kanjeta",
          "Sursheela Retreat And Farm",
          "Wankleshvar Dam",
        ],
      },
      {
        district: "Dang",
        localities: [
          "Breeding Centre, North Dang",
          "Dand Forest--Bhenskatri",
          "Dang Forest--Bardipada",
          "Dang Forest--Gira-Kudkas Rd",
          "Dang Forest--Maa Shabri Farm House and Resort",
          "Dang forest--Koshmal",
          "Devinamal Eco Campsite",
          "Don Hill Station",
          "Girmal Waterfall",
          "Kilad Campsite",
          "Mahal Campsite",
          "Purna River",
          "Purna WLS",
          "Saputara, Gujarat (OBI)",
          "Vansda NP",
          "Waghai",
          "Waghai -- Gira Falls",
          "Waghai outskirts",
          "Waghai--Botanical Garden",
        ],
      },
      {
        district: "Devbhumi Dwarka",
        localities: [
          "Aniyari Pond",
          "Barda WLS--Kileshwar Temple",
          "Beyt Dwarka",
          "Beyt Dwarka Beach--Dunny Point",
          "Beyt Dwarka--Sundarvan",
          "Bhimgaj Talav, Nageshvar",
          "Bhimrana (OBI)",
          "Bhogat Beach Forest Area",
          "Charkhala Salt Pans",
          "Dwarka Beach",
          "Ghee Dam",
          "Gojines Revenue Area",
          "Gojinesh Beach revenue area",
          "Gomati River Brackish Water, Dwarka",
          "Gomti River Bank",
          "Gopi Talav",
          "Gulabsagar Dam",
          "Harivan Farmstay, Shivrajpur",
          "Jepur (Sanidam) Forest Area",
          "Lamba Revenue Area",
          "Marine NP--Poshitra Beach",
          "Marine NP--Poshitra Lakku Point",
          "Masked Shrike Point",
          "Mayasar Wetland",
          "Mendha Creek--Dwarka I",
          "Mendha Creek--Dwarka II",
          "Mithapur (Tata Chemicals) Township",
          "Mojapa",
          "Mulvel Wetland",
          "Nageshwar",
          "Narara Marine NP",
          "Okha Madhi Beach",
          "Okha, near Dwarka (OBI)",
          "Pindara",
          "Pindara Revenue Area",
          "Rajpara Wetland",
          "Ranjitpur Tank",
          "Ranjitpur Village Pond",
          "Raval Forest Area",
          "Rukmani Temple, Dwarka",
          "Saltpans near Vadinar",
          "Samlasar Saltpans",
          "Sani Dam",
          "Sani Dam ( Dudhiya )",
          "Satsagar Dam",
          "Shivrajpur Beach",
          "Sinhan Dam",
          "Toran Totel, Dwaraka",
          "Vadatra Tank",
          "Vartu I Dam",
          "Vartu II Dam",
          "Veradi I Dam",
          "Veradi II Dam",
          "Virpur Lushari Forest Area",
          "Virpurlushari Forest Area",
        ],
      },
      {
        district: "Gandhinagar",
        localities: [
          "Adalaj Stepwell",
          "Akshardham Temple",
          "Aranya Udhyan",
          "Butterfly park",
          "DA-IICT",
          "DAIICT Campus",
          "Dabhla Panjarapole",
          "GEB Ash Pond, Pethapur",
          "Gatehara",
          "Gatehara Lake",
          "Gopal Lake",
          "Government Science College, Gandhinagar",
          "Govt. School Gandhinagar",
          "Gujarat Forest Research & Training Institute",
          "Indian Institute of Technology (IIT) Gandhinagar, Palaj campus",
          "Indroda Nature Park",
          "Indroda Nature Park--Cactus Garden",
          "Indroda Nature Park--Office",
          "Jaspur Lake",
          "Karai Canal Syphone",
          "Karai near Sabarmati river",
          "Khodiyar village pond, Ahmedabad",
          "Koba, Gandhinagar",
          "Lodra Lake",
          "Matulya farm",
          "NID Gandhinagar",
          "NIF-Gandhinagar",
          "Narmada Canal",
          "Narmada Canal (Sarkhej-Gandhinagar Hwy)",
          "Narmada Canal, Karai",
          "Nilkanth Mahadev",
          "Ograj, Lapkaman (OBI)",
          "PDEU, Gandhinagar",
          "PDPU Bridge",
          "Panchvati Plains",
          "Pandit Deen Dayal Energy University, Gandhinagar",
          "Pandit Deendayal Petroleum University Campus, Raysan",
          "Pandit Dindayal Park",
          "Pashu Jaivik Sanstha",
          "Punit Van",
          "Rancharda Lake",
          "Rancharda--Indus University Scrub Area",
          "Sabarmati Bank near PDPU",
          "Sabarmati River near IIT Palaj Campus",
          "Sabarmati River--Basan",
          "Sabarmati River--Indira Bridge",
          "Sabarmati dam - Indroda Nature Park",
          "Sant Sarovar Dam",
          "Sardar Bag",
          "Shanti Botonica, Raysan, Gandhinagar",
          "Sherisa Outskirts",
          "The Serenity Library",
          "Vayushaktinagar",
          "Wetland opposite Adhana Village pond",
          "Zala Darbar Pond",
        ],
      },
      {
        district: "Gir Somnath",
        localities: [
          "Aranya - a nature's paradise",
          "Asiatic lion lodge",
          "Creek near Diu Entry",
          "Dam near Jalundra Mahadev Temple",
          "Fishery Harbour Area-Somnath",
          "Gir Birding Lodge",
          "Gir Forest--Bhojde",
          "Gir Gadhada Rd",
          "Gir Interpretation Zone (Devaliya Park)",
          "Gir Wildlife Sanctuary--Batheshwar Campsite",
          "Gir Wildlife Sanctuary--General",
          "Gir Wildlife Sanctuary--Jamvala outskirts",
          "Gir Wildlife Sanctuary--Kamleshwar Dam only",
          "Gir Wildlife Sanctuary--Kankai Temple",
          "Gir Wildlife Sanctuary--Route 6/2",
          "Gir Wildlife Sanctuary--Sasan",
          "Gir Wildlife Sanctuary--Tulsishyam Temple",
          "Hadmtiya Gir",
          "Hiran River",
          "Hiran River near Hotel Anil Farm",
          "Hiran River, Madhuram",
          "Jamvala to Girgadhada road",
          "King's Kraft River Side Resort - Sasan Gir",
          "Lake, Una",
          "Lion Safari Camp",
          "Mandorna, Gir",
          "Mul Dwarka",
          "Naliya Mandvi Wetlands",
          "Nanavada Wetlands",
          "Panch Pandav Caves- Pandav Gufa",
          "Prashnavada Wetland",
          "Reserve forest behind GIZ-Devaliya",
          "Shingoda Dam",
          "Simar",
          "Sinhsadan",
          "Somnath Beach",
          "Sutrapada",
          "Tal, near Una (OBI)",
          "Triveni Sangam",
          "Velan Beach",
          "Velan Wetlend (Kodinar)",
          "Veraval Beach",
          "Wetland on Diu - Una Rd",
          "Wild Jai Farm, Gir National Park",
        ],
      },
      {
        district: "Jamnagar",
        localities: [
          "Balachadi Beach",
          "Balambhadi Dam",
          "Bedi Port Rd",
          "Beyt Dwarka--Ferry Point",
          "Churi Aai Temple",
          "Dhichda",
          "Dhinchada Lake",
          "Dhuvav lake",
          "Digvijay Saltpans",
          "Fulnath Temple",
          "Fulzar 2 Dam Daltungi",
          "Gagva Saltpans",
          "Hadmatiya",
          "Hazrat, Santury Salt Works",
          "Jhankhar Lake",
          "Kharaberaja Dam",
          "Khatiya Vidi",
          "Khijadiya Bird Sanctuary",
          "Khijadiya Bird Sanctuary--Part 2--Flamingo Watchtower",
          "Laher Talav, Naghedi",
          "Lakhota Lake",
          "Mahakaleshwar Temple, Sadodar (OBI)",
          "Marine NP--Pirotan Island",
          "Nageshwar-Momai Mata Temple Road (OBI)",
          "Nana Panchdevda Dam",
          "Naranpura Samana Road",
          "New Port",
          "Pancheshwar tower road",
          "Pond near Amran",
          "Rangmati Dam",
          "Rangpar Lake, Jamnagar",
          "Ranjitsagar Dam",
          "Ranjitsagar Dam--Garden",
          "Reliance Industries Limited, Jamnagar (Restricted)",
          "Rozi Island, Jamnagar (OBI",
          "Ruparel Dam",
          "Rupavati Dam",
          "Sachana",
          "Sachana Beach",
          "Sadodar Village (OBI)",
          "Saltpans near Okha",
          "Saltpans on INS Valsura Rd",
          "Samana Road - Khatiya",
          "Sapda Dam",
          "Sapda, Jamnagar",
          "Sasoi Dam",
          "Swaminarayan Nagar",
          "Und I Dam",
          "Und II Dam",
          "Valsura Road (OBI)",
          "Vantara",
          "Vibhapar",
          "Vijarakhi Dam",
          "Vodisang Dam",
          "Wetland near Jamnagar Railway Station",
        ],
      },
      {
        district: "Junagadh",
        localities: [
          "Amipur Dam--Part II",
          "Aramness Safari Lodge, Gir, Junagrah",
          "Balaji Park Society",
          "Bushland Reserve, Chuldi",
          "Chikhalkuba Campsite--East Dhari",
          "Dadhichi Lake",
          "Dhandhusar - Ambaliya Road, Dhandhusar, Gujarat, IN (21.541, 70.364)",
          "Dhrafad Sinchai Yojana",
          "Gir Arboretum & Birding Point, Sasan",
          "Gir National Park",
          "Gir Sanctuary & NP--Lilapani Forest Office",
          "Girnar Forest--Chikhaliya Farm",
          "Girnar Forest--Jatashankar",
          "Girnar Forest--Jungle Safari",
          "Girnar Forest--Kashmiri Bapu ashram",
          "Girnar Forest--Lal dhori",
          "Girnar Forest--Narayan Dharo",
          "Girnar Forest--Velnath",
          "Girnar Forest--Zinabava ni madhi",
          "Girnar Ropeway top end",
          "Girnar WLS",
          "Junagadh (OBI)",
          "Junagadh Agricultural University Campus",
          "Madhuvanti Dam",
          "Narsinh Mehta Lake",
          "Nataliya Vidi",
          "Ozat Reservoir",
          "Pond near Pipardi Timbo",
          "Sakkarbaug Zoological Park",
          "Sarkhadiya Hanuman Temple",
          "Sodam Bandhara, Velan",
          "Uben River -- Zalansar",
          "Upperkot Fort",
          "Vadla Lake",
          "Willingdon Dam",
        ],
      },
      {
        district: "Kachchh",
        localities: [
          "Adesar Bridge",
          "Anjar Municipalty Garden",
          "Asar Mata Temple Beach",
          "Babiya Lake",
          "Balapar Pond and Marshes",
          "Balasar Heronry",
          "Banni Gateway",
          "Banni Grassland",
          "Banni Grasslands--Hodka",
          "Banni Grasslands--Hodka-Dhordo Rd",
          "Banni Grasslands--Lodai",
          "Banni grassland--Bhagadiya Thath",
          "Bhachau, Kutch (OBI)",
          "Bhadreshwar Beach",
          "Bhed Mata Scrub Forest",
          "Bhimasar Lake",
          "Bhimsar Lake",
          "Bhuj Anjar Road (OBI)",
          "Bhuj Greenland",
          "Bhuj--General Area",
          "Bhuj-Khavda Road (OBI)",
          "Bhukhi Dam",
          "Bhukhi river bridge, Devisar",
          "Center for Desert and Ocean (CEDO)",
          "Centre for Desert and Ocean, Kutch (OBI)",
          "Chadva Rakhal",
          "Chapadada Dargah, Sedata",
          "Chavadka Dam",
          "Chhachhla That (Lake)",
          "Chhari Dhandh Conservation Reserve",
          "Chhatardi Lake",
          "Dam near Mothala",
          "Devisar Tank",
          "Devisar village and Khandavara pir,Banni,Kutch",
          "Devsar Dam",
          "Dhamma Sindhu Vipassana Meditation Centre",
          "Dhaneti Lake",
          "Dhinodhar Hill",
          "Dhinodhar Hill and Tropical Thorn Forest",
          "Dholavira - Fossil Park",
          "Dholavira Homestay- Amarapar",
          "Dholavira Sunset Point",
          "Dhonsa Lake",
          "Dhordo Road, near Khavda (OBI)",
          "Dhrabudi Beach",
          "Dhrang-Lodai Road",
          "Dhunaraja Dam",
          "Dilip Khatau's vadi (farm), Nani Aral (OBI)",
          "Epicenter Homestay, Lodai, Gujarat",
          "Fatelo Talav, Bhuj (OBI)",
          "Fot Mahadev Scrub Forest",
          "Fulay, Kutch",
          "Full Moon View Point, Dholavira",
          "GRK Near Kutch Fossil Park",
          "Gadhsisa",
          "Gorasar Tank",
          "Great Rann of Kachchh--Dholavira",
          "Great Rann of Kachchh--Dhordo",
          "Great Rann of Kachchh--Khadir Beyt Rd",
          "Gujarat Institute of Desert Ecology",
          "Gulf of Kutch (OBI)",
          "Hamirsar Lake",
          "Hobay-Lodai Road",
          "IOCL WRPL Mundra",
          "Infinity Resort",
          "Jadura Hills",
          "Jakhau",
          "Jakhau salt pans",
          "Jakhav - Kutch",
          "Jatawada (OBI)",
          "Kachchh--Bhuj",
          "Kadol",
          "Kalo Dungar (OBI)",
          "Kalo Dungar--Walking trail",
          "Kasvati Dam",
          "Kharai Water Tank 1",
          "Khari Nadi, Bhuj (OBI)",
          "Khatri Talab",
          "Khavda Road, Kutch (OBI)",
          "Khavda-Dholovira Road",
          "Khirjog Dhandh",
          "Khorai Water Body",
          "Kukma lake",
          "Kunathiya (OBI)",
          "Kunj Homestay and Surroundings",
          "Kutch Fossil Park",
          "Kutch Safari Resort",
          "Lakhapur, Gujarat",
          "Lakhpat Fort",
          "Langopir Dargah Talab",
          "Lanki Hill Complex",
          "Ler Dam",
          "Little Rann of Kachchh",
          "Little Rann of Kachchh--Bajana Entry",
          "Little Rann of Kachchh--Kharaghoda entry",
          "Little Rann of Kachchh--Kuda",
          "Little Rann of Kachchh--Melak Beyt",
          "Little Rann of Kachchh--Nanda Bet",
          "Little Rann of Kachchh--Pung Beyt",
          "Little Rann of Kachchh--Surajbari Bridge",
          "Little Rann of Kachchh--Vachchhraj Beyt",
          "Little Rann of Kachchh--West Part",
          "Little Rann of Kachchh--Zainabad Edge",
          "Luna Jheel",
          "Luni Coastline",
          "Madhapur, Kutch (OBI)",
          "Mandvi Beach",
          "Mata no Madh",
          "Mata no Madh Dam",
          "Mitti Dam",
          "Modhva Beach",
          "Modhva Road",
          "Moti Aral",
          "Moti Virani (OBI)",
          "Moti-Virani, Kutch (OBI)",
          "Mundra Port/coast",
          "Mundra--General Area (OBI)",
          "Nadabet",
          "Nadabet Wetland Complex -- Radhanesda",
          "Nadabet Wetland Complex--19R",
          "Nadabet Wetland Complex--Asarva",
          "Nadabet Wetland Complex--Boriyabet",
          "Nadabet Wetland Complex--Dhanbet",
          "Nadabet Wetland Complex--Dharnidhar BOP",
          "Nadabet Wetland Complex--Limboni BOP",
          "Nadabet Wetland Complex--Mangur BOP 2 Tower",
          "Nadabet Wetland Complex--Nadeshwari BOP",
          "Nadabet Wetland Complex--Padia Pir",
          "Nadabet Wetland Complex--Radosan",
          "Nadabet Wetland Complex--Sunil BOP",
          "Nadabet--Zero Point road",
          "Nagasar Lake",
          "Nakhatrana--General Area",
          "Naliya Grasslands",
          "Naliya Grasslands--Kunathiya",
          "Nanda Bet",
          "Nani Aral, Moti Aral, Gichado village, and Layari river side, Banni",
          "Nara Dam",
          "Narayan Sarovar",
          "Ningal Lake and Nursery",
          "Nirona Dam",
          "Outskirts of Bhuj (OBI)",
          "Paddhar Lake 1",
          "Paddhar Lake 2",
          "Pakhado Hill",
          "Peregrine Point, Bajana",
          "Pingleshwar Beach",
          "Piyoni Mahadev",
          "Piyoni Village, Nakhatrana (OBI)",
          "Pond near Kothara",
          "Pond near Navi Chobari",
          "Pond on Kharoi-Bharudiya Rd",
          "Port Gate, Mandvi",
          "Ramble",
          "Rampar Hill",
          "Rann of Kutch Lake",
          "Ratnal Dam -- Anjar",
          "Ratnal Tank",
          "Rava Bityari, Kutch (OBI)",
          "Rawalpir Dargah Thorn Forest",
          "Rodasar, Kutch (OBI)",
          "Roha Fort Forest",
          "Rudramata Bridge",
          "Rudramata Dam",
          "Rukmavati River",
          "Saiyadpar Rakhal",
          "Samanda",
          "Samatra Tank",
          "Sang River",
          "Sapeda Lake",
          "Shakoor lake",
          "Sharan Nath Temple",
          "Shinay Lake",
          "Sun Temple, near Lodai (OBI)",
          "Swayambhu Hanuman Mandir and surroundings, Bhuj",
          "Tapkeshwari Temple",
          "Than Jagir",
          "Topansar Lake",
          "Vaghura Dam",
          "Van Chetna, Bhuj",
          "Vandhay Tank",
          "Vang, Kutch (OBI)",
          "Vighakot Fort",
          "Vijay Sagar Dam",
          "Vijay Vilas Palace",
          "Vijay Vilas Palace Beach",
          "Village Phulai, near Moti Virani (OBI)",
          "coast of Kutch (OBI)",
          "kashi Vishwanathe Beach, Mandvi",
          "near Jatavira, Kutch (OBI)",
        ],
      },
      {
        district: "Kheda",
        localities: [
          "Bherai Wetland",
          "Chanor--General Area (OBI)",
          "Damri Lake",
          "Gobarapura Reservoir",
          "Goblej Vadala",
          "Heranj Lake",
          "Kathana",
          "Khareti (OBI)",
          "Khari Catchment Wetland",
          "Kheda (OBI)",
          "Kheda- Nagarpalika Office",
          "Kheda--Shekhupur (OBI)",
          "Limbasi Pond",
          "Limbasi-Vastana Rd",
          "Mahelaj (OBI)",
          "Mahisagar River - Galteshwar Mahadev Temple",
          "Malarpur",
          "Matar Outskirts",
          "Meldi Mata Temple",
          "Nagarama TT",
          "Narda Wetland",
          "Navagam Bari",
          "Navagam Matar Rd",
          "Outskirts of Kheda (OBI)",
          "Pariej Lake",
          "Pariej--Ecotourism Center",
          "Pariej--Sayla",
          "Pariyej Lake extantion",
          "Salla, Traj village",
          "Shekhupur, (OBI)",
          "Traj Lake",
          "Tranja--Kathoda Lake",
          "Vatrak Bridge Gadvel",
          "Wagh Bakri Tea Factory",
        ],
      },
      {
        district: "Mahisagar",
        localities: [
          "Joraver Villa",
          "Kadana Hill View",
          "Kaleshwari Temple, Lavana",
          "Kanjara Wetland",
          "Near CEE Campsite, Bakor",
        ],
      },
      {
        district: "Mehsana",
        localities: [
          "Becharaji Park",
          "Bhalusana Bhuvneshwar Van",
          "Dabhala (OBI)",
          "Dharoi Dam--Malana",
          "Kanjari Deer Sanctuary",
          "M. N. College, Visnagar",
          "Modhera Sun Temple River side",
          "Outskirts of Ahmadabad (OBI)",
          "Rushivan Sant Samadhi Dham, Pilvai",
          "Saldi Lake",
          "Shankus waterpark",
          "Taranga Hill Wildlife Sanctuary",
          "Thol Bird Sanctuary",
          "Thol Bird Sanctuary- ( Near checkpost)",
          "Thol Bird Sanctuary--South Observation Point",
          "Thol Lake View, Dipeshwari Temple",
          "Thol--Kanjari Canal",
          "Village Kadi Road (OBI)",
        ],
      },
      {
        district: "Morbi",
        localities: [
          "Garida Dam",
          "Grassland near Machu Dam 1",
          "Jogad Camp Site",
          "Little Rann of Kachchh--Jogad",
          "Lunsar Reservoir",
          "Machhu Dam",
          "Machu  Dam 2",
          "Machu Dam 1",
          "Nani Barar",
          "Paneli Vidi (OBI)",
          "Pond on Navlakhi Port Rd",
          "Rampara Wildlife Sanctuary",
          "Saltpans on Navlakhi Port Rd",
          "Samantsar Lake, Halvad",
          "Thikariyala Talav",
          "near Morbi (OBI)",
        ],
      },
      {
        district: "Narmada",
        localities: [
          "Gadhar",
          "Gujarat Forest Rangers College Campus",
          "Mandan Lake",
          "Rajpipla Ashram",
          "Sardar Patel Zoological Park",
          "Sardar Sarovar dam",
          "Shoolpaneshwar WLS",
          "Shoolpaneshwar WLS--Junaraj",
          "Shoolpaneshwar WLS--Kokam Hanuman Temple",
          "Shoolpaneshwar WLS--Sagai Eco Campsite",
          "Shoolpaneshwar WLS--Vishal Khadi Eco Campsite",
          "Shoolpaneshwar WLS--Zarvani Range",
          "Statue of Unity",
          "Zarwani Waterfall",
        ],
      },
      {
        district: "Navsari",
        localities: [
          "Aat gam to Dandi",
          "Abrama Talav, Navsari",
          "Anklachh",
          "Chhapar substation (GETCO)",
          "Chikhali (OBI)",
          "Devdha Dam",
          "Devsar",
          "Gandeva",
          "Gandevi",
          "Handhiyo Dungar",
          "Kotha Talav",
          "Nani Kakrad",
          "Nani Kakrad Wetland",
          "Nani Kakrad--back side Wetland",
          "Navsari Agricultural University (NAU)",
          "Navsari Railway Station",
          "Onjal Beach, Navsari",
          "Rameshwar Mahadev temple lake",
          "Sanjay Farm",
          "Soldhara, Valsad (OBI)",
          "Sultanpur Wetland",
          "Tavdi",
          "Torangam River bank",
          "Vadi Lake",
          "Vansda NP-- Outskirts",
          "Vansda--Gadhvi & Jamanpada Area",
        ],
      },
      {
        district: "Panchmahal",
        localities: [
          "Bamankuva",
          "Bhat Ecocamp",
          "Dem Dam Wetland Complex--Moti Ranbhet",
          "Dev Dam Wetland Complex--Gariyal 1",
          "Dev Dam Wetland Complex--General Area",
          "Dev Dam Wetland Complex--Mota Ankediya",
          "Dev Dam Wetland Complex--Nani Ranbhet",
          "Dev Dam Wetland Complex--Sudhra",
          "Dev Dam Wetland Complex--Vaghbod",
          "Godhara, Gujarat (OBI)",
          "Gupteshwar Mahadev Track",
          "Jambudi Village Pond",
          "Jambughoda Palace",
          "Jambughoda WLS--Bhat",
          "Jambughoda WLS--Kada Dam Camp Site",
          "Jambughoda--Kada Dam Tent Site",
          "Jay AMBE Industries",
          "Khuneshwar Mahadev",
          "Leopard's Den Home Stay",
          "Malav Talav",
          "Mandvi Nature Education Campsite",
          "Palli Forest",
          "Pavagadh Hills",
          "Pavagadh Hills--Sultanpura",
          "Rameshwar Talav",
          "Shivam Society",
          "Vada Talav",
          "Vadatalav Lake",
          "kakanpur instructional farm Anand Agril University",
        ],
      },
      {
        district: "Patan",
        localities: [
          "Dharpur--General Area (OBI)",
          "GMERS Medical College Campus",
          "Garamadi (OBI)",
          "Garamadi Wetland",
          "Jaska Talab",
          "Khokhla Talav",
          "Kilana Lake",
          "Little Rann of Kachchh--Koddha",
          "Masali (OBI)",
          "Modhera Lake",
          "Rani ki Vav",
          "Siddhapur (OBI)",
          "Sidhada Village Tank",
          "Tank near Tekariya Hanumanaji Temple, Shankheshwar",
        ],
      },
      {
        district: "Porbandar",
        localities: [
          "Amipur Dam--Part I",
          "Barda WLS--General",
          "Barda WLS--Khambhala Gate",
          "Barda WLS--Satvirda Nes",
          "Bardasagar Dam--Part I",
          "Bardasagar Dam--Part II",
          "Bhadarbara Wetland",
          "Chhaya Rann wetland",
          "Fodara Dam",
          "Gokul Aashram, Madhavpur",
          "Javar Village",
          "Javar Wetland",
          "Kadiya Plot",
          "Kalindri Dam",
          "Khageshri Grassland (Reserved Forest)",
          "Kuchdi, Porbandar (OBI)",
          "Kuchhadi",
          "Madhavpur Beach",
          "Mendha Creek--Coastal",
          "Mendha Creek--Porbandar",
          "Mokarsagar Wetland Complex--Dharampur",
          "Mokarsagar Wetland Complex--General",
          "Mokarsagar Wetland Complex--Karli",
          "Mokarsagar Wetland Complex--Vanana",
          "Mokarsagar--Dharampur Vanana",
          "Mokarsagar--Gosabara Coast",
          "Mokarsagar--Karly I (City)",
          "Mokarsagar--Karly II",
          "Mokarsagar--Mokar 1",
          "Mokarsagar--Mokar II",
          "Mokarsagar--Mokar III",
          "Mokarsagar--Shiroda I",
          "Mokarsagar--Shiroda II",
          "Mokarsagar--Shiroda III",
          "Mokarsagar--Temple to Lushala",
          "Navi Bandar",
          "Porbandar (OBI)",
          "Porbandar Beach",
          "Porbandar Bird Sanctuary",
          "Rajvi Party Plot Beach",
          "Subhashnagar wetland",
        ],
      },
      {
        district: "Rajkot",
        localities: [
          "Aalan Sagar Dam",
          "Aji-1 Dam",
          "Aji-2 Dam",
          "Aji-3 Dam",
          "Ambaradi Dam",
          "Anandpar Lake",
          "Baghi swamps",
          "Bedi Gam",
          "Bhadar 2 Reservoir",
          "Bhadar Check Dam-Atkot",
          "Bhadar Dam",
          "Bhichari Temple",
          "Bhima tank- Sajadiyali",
          "Bhola Vidi",
          "Bhootnath Mahadev Temple",
          "Bushland Reserve, Zalansar",
          "Causeway on Nyari river & Khambhala Lake",
          "Dungareshwar Mahadev and Jain Caves",
          "Fofal Dam",
          "Fofal Dam--Canal",
          "Fofal Dam--Kuvadva",
          "Fofal River--Ambardi",
          "Fofal River--Sajadiyali",
          "Gadhaka lake, Rajkot",
          "Hanuman Vidi, Vadali",
          "Hanumandhara Temple",
          "Hingolgadh Nature Education Sanctuary",
          "Indubhai Parekh School of Architecture, Rajkot",
          "Ishwariya Lake",
          "Khambhala Vidi",
          "Khirasara",
          "Khirasara Vidi",
          "Khodiyar Ghuno",
          "Khodiyar Vidi, Vadali",
          "Lalpari Lake",
          "Mespar Vidi",
          "Moj Reservoir",
          "Mota Bhadra Hill",
          "Nyari River, Rajkot (OBI)",
          "Nyari-1 Dam",
          "Nyari-2 Dam",
          "Nyari-Khirasara Birding Corridor",
          "Patanvav Hills",
          "Pradhyuman Zoological Park",
          "RK University Campus",
          "RK University Campus, Tramba",
          "Rajkot, Gujarat (OBI)",
          "Rajkot--Ishwaria (OBI)",
          "Randarda Lake",
          "River, Sajadiyali",
          "Sardhar Lake",
          "Saurashtra University Campus",
          "Shakti Van - Khodaldham Garden",
          "Shree Mahakali Temple - Bhankh",
          "The Hera Weekend House",
          "Thorala Reservoir",
          "Umath Vidi, Hingolgarh",
          "Vadodar Tank",
          "Vagudad Grassland",
          "Vagudad Road",
          "Valadungra Reservoir",
          "Vanapari-Dondi River",
          "Vavdi Wetland, Dhoraji",
          "Vekri Dam Reservoir",
          "Venu 2 Dam",
          "Veri Dam",
          "Vihot Mata Mandir Vidi",
          "Wetland near Gondal, Rajkot (OBI)",
          "Zinzurizar Caves",
        ],
      },
      {
        district: "Sabarkantha",
        localities: [
          "Adam's Nature Retreat",
          "Ashapura Mataji Temple, Vadali",
          "Chikhla Lake",
          "Dharoi Dam",
          "Gadhada Lake",
          "Guhavi River Bed, Kukadia",
          "Idar (OBI)",
          "Markandeshwar Mahadev Pond",
          "Polo Forest",
          "Polo Forest--Abhapur",
          "Polo Forest--Harnav Dam",
          "Poshina (OBI)",
          "Rani Lake",
          "Sabarkantha--Idar (OBI)",
          "Sabarmati River--Lank bridge",
          "Shri Vireshwar Mahadev",
          "Unchi Dhanal lake",
        ],
      },
      {
        district: "Surat",
        localities: [
          "Ahuranagar society",
          "Arogya Seva Mandir",
          "Ashwini Kumar Rd",
          "Barbodhan Lake",
          "Bhulka Vihar School",
          "Canal Road",
          "Damka",
          "Department Of Biosciences, VNSGU",
          "Dumas Beach",
          "Eco Farm (NCS)",
          "Gaviyer Lake",
          "Isar Dam",
          "Kavi Kalapi Lake Garden",
          "Kevdi Eco tourism site",
          "Khajod (OBI)",
          "Kumkotar Forest",
          "Kumkotar Forest -- Bridge over Koskhadi River",
          "Magdalla Port Surat",
          "Maya Talav",
          "Mora Lake",
          "N.G. Patel Polytechnic Campus",
          "P.T  Science",
          "Port Surat",
          "Raghipura Forest",
          "Rajgari, Suvali",
          "SMC Multi- Activity Zone",
          "Sarthana Nature Park and Zoo",
          "Satkeval Temple Hill, Goddha",
          "Sindhvai farm, Mandvi",
          "Steneshwar Mahadev Temple, Tena",
          "Surat International Airport",
          "Suvali Beach",
          "Tapi River--Athwa",
          "Tapi River--Causeway Road",
          "Tapi River--General",
          "Tapi River--Pal Umra Bridge",
          "Tapi River--Shree Chandrashekhar Azad Bridge",
          "Tapi River--Swami Vivekanand Bridge (Makai Pool)",
          "Tena Lake",
          "Tena-Hazira Rd",
          "Veer Narmad South Gujarat University Campus",
          "Vibrant School of Excellence",
          "Waste Disposal Site, Khajod",
        ],
      },
      {
        district: "Surendranagar",
        localities: [
          "Airport Vidi",
          "Baldana Lake",
          "Bhaskarpara Narmada Canal Area",
          "Bhaskarpura Wetland",
          "Chhabali Pond",
          "Chotila Reservoir",
          "Dharam Talav",
          "Dhrangadhra Cantt",
          "Falku Reservoir",
          "Gamera Pond",
          "Hebatpur, Gujarat",
          "Kamlapar Village Tank",
          "Kharva Village (OBI)",
          "Kholdiyad Lake",
          "Little Rann of Kachchh--Bajana Creek",
          "Little Rann of Kachchh--Bhavna Resort & Farm",
          "Little Rann of Kachchh--Chikasar",
          "Little Rann of Kachchh--Desert Coursers",
          "Little Rann of Kachchh--Mithaghoda",
          "Little Rann of Kachchh--Nava Talav",
          "Little Rann of Kachchh--Patdi Lake",
          "Little Rann of Kachchh--Vachharadada Temple",
          "Little Rann of Kachchh--Zinzuwada entry",
          "Nagbai Ma Temple outskirts",
          "Nalsarovar Bird Sanctuary",
          "Nalsarovar--Fishing Point",
          "Nalsarovar--Laxmisar",
          "Nalsarovar--Ranagadh",
          "Nayakpur Saran Wetland",
          "Nayka Dam",
          "Nimaknagar",
          "Nimbhani Dam",
          "Olak",
          "Randal Mandir, Moti Moldi",
          "Rann Riders, Dasada",
          "Reshamiya",
          "Surapura dada, Thala Rd",
          "Vadala Dam",
          "Vadla Dam (Sukhdisar Bird Migration Point)",
          "Vithalgadh (OBI)",
          "Wadhwan (OBI)",
          "Wild Ass Sanctuary Office",
        ],
      },
      {
        district: "Tapi",
        localities: [
          "Govad Dev Temple--Kanjan",
          "Govaldev area, Kaanjan Village (OBI)",
          "Kevdi forest, Mandvi",
          "Madhi ni Khamani, Bajipura",
          "Satkashi",
          "Ukai Dam View Point",
          "Ukai Reserve Forest",
          "Vansda NP--Lasanpore",
        ],
      },
      {
        district: "Vadodara",
        localities: [
          "Amodar Village Lake",
          "Ankhol Lake",
          "Ankodiya lake, Vadodara",
          "BK Patel Arts & LM Patel Commerce College",
          "Balaji Township",
          "Central University of Gujarat (CUG)",
          "Chhani Lake, Amin Nagar",
          "Fajalpur Mahi Riverside",
          "GSRTC ST Depot",
          "Gujarat Engineering Research Institute",
          "Hanumanpura Lake",
          "Harni Tank",
          "Historical Place Vadodara",
          "Jarod Wetlands",
          "Javla Lake",
          "Kalp Pavitra Apartment",
          "Kirti Mandir",
          "Kotna beach, vadodara",
          "Lukshmi Vilas Palace",
          "Maharaja Sayajirao University (MS University) Campus",
          "Maharaja Sayajirao University (MS University)--Cricket Ground",
          "Mahi River Bridge, Kotna",
          "Manilakshmi Tirth",
          "Misriote Homestay",
          "Navrachana University Campus",
          "Orsang Gamdi Resort",
          "Prince Ashokraje Gaekwad School",
          "Qutubuddin Tomb",
          "Ravines Eco Park",
          "Rayaka Riverwalk",
          "Sai Villa Apartment",
          "Sayaji Baug",
          "Sevasi Step Well",
          "Sherkhi Hideout",
          "Sindhrot Nature Education Park",
          "The Maharaja Sayajirao University of Baroda",
          "Timbi Lake",
          "Timbi Point 1",
          "Vadhavana Lake, Dabhoi",
          "Vadodara (OBI)",
          "Valvod Island",
          "Vasundhara Park Society",
          "Vishwamitri--Sama",
          "Vyas Bet",
          "Zankeshwar, near Dabhoi (OBI)",
        ],
      },
      {
        district: "Valsad",
        localities: [
          "Ambavadi, vashiyar",
          "Atul Colony",
          "Bhagal",
          "Bilimora-Valsad Coastal Hwy",
          "Daman Ganga River, Dadra",
          "Dharasana (OBI)",
          "Dharasana Wetland (OBI)",
          "GMERS Medical College, Valsad",
          "Goima",
          "Kalai Beach",
          "Kalai Lake",
          "Lilapore Lake",
          "Maganlal Residency-1 Tithal Road",
          "Mangalayam Meadows",
          "Pardi Grassland",
          "Parnera Hills",
          "Shiv Mandir",
          "Udvada Beach",
        ],
      },
    ],
  },
  {
    state: "Haryana",
    districts: [
      {
        district: "Ambala",
        localities: [
          "Ambala Cantt",
          "Ambala Cantt Railway Station",
          "Matheri Sheikhan Village",
        ],
      },
      {
        district: "Charki Dadri",
        localities: [
          "Birhi Kalan, Bhiwani IN/HR",
        ],
      },
      {
        district: "Faridabad",
        localities: [
          "Amipur faridabad IN-HR",
          "Asola Wildlife Sanctuary (Bharadwaj Lake)",
          "Badhkal Lake",
          "Bhardwaj Lake,Asola Sanctury",
          "Eros Garden, Faridabad",
          "Faridabad Railway Station",
          "Kant Enclave, Faridabad",
          "Leisure Valley Park, Faridabad",
          "MANGAR 5 MONITORING IN-HR",
          "Mangar Bani",
          "Mangar mohit farm",
          "Mangar village",
          "Manjawali Seikhpor",
          "Nagli-Bahrampur Noida yamuna bank",
          "Shekhpur",
          "Surajkund",
          "Town Park Trail",
          "Yamuna River--Khader",
        ],
      },
      {
        district: "Gurugram",
        localities: [
          "Amity University, Gurgaon",
          "Amity University--Herbal Garden",
          "Aravali Biodiversity Park",
          "Badshahpur Forest Corridor, Gurgaon Hr/In",
          "Basai Wetland",
          "Bhondsi",
          "Bhondsi Nature Park",
          "Budhera Water Treatment Plant",
          "Butterfly Park",
          "CRPF Academy, Gurgaon",
          "Chakkarpur Bundh Gurgaon IN/HR",
          "Chandu (Mankrola pond)",
          "Chandu (Sahibi Basin)",
          "Chandu Reed Beds",
          "DLF Phase 1, Gurugram",
          "Damdama Lake",
          "Damdama hill, Faridabad, HR/IN",
          "Damdama lake surroundings, faridabad  HR/IN",
          "Dharampur (Najafgarh) Gurgaon",
          "Eco Restoration Wazirabad Bundh Hr/IN",
          "GD Goenka Education City",
          "Ghata Gaon -- Sector 56 Gurugram",
          "Golden Creepers Farm Retreat gurgaon  HR/IN",
          "Gurgaon (OBI)",
          "Karma Lakelands, Gurgaon",
          "Karma lake land, Manesar",
          "Kheda Jhanjhrola",
          "Malibu Towne, Pine Drive",
          "Manesar Hill IN-Haryana",
          "NSG Manesar",
          "National Brain Research Centre (NBRC)",
          "Pathway School Gurugram",
          "Pathways World School",
          "Sakatpur",
          "Sakatpur Aravali Scrub",
          "Sector 109, Gurugram",
          "Shikshantar School Gurgaon",
          "Shiv Nadar School",
          "Sikandarpur Pond",
          "Sultanpur Flat Bee-eater area",
          "Sultanpur Flats",
          "Sultanpur National Park",
          "Sultanpur National park and  Flats",
          "Sushant University",
          "Tau Devilal park",
          "The Shriram School, Gurgaon",
          "Trident Hotel, Gurgaon",
          "dlf,phase 2 Gurgaon",
          "jalvayu towers society",
          "leopard trail",
        ],
      },
      {
        district: "Hisar",
        localities: [
          "Blue Bird Lake, Hisar",
          "Chaudhary Charan Singh Haryana Agricultural University (HAU)",
          "Guru Jambheshwar University",
          "Haryana Agricultural University",
          "Hisar--Kaimri Pond",
          "Niyana Village Pond",
        ],
      },
      {
        district: "Jhajjar",
        localities: [
          "Badli bridge (Sahibi crossover)",
          "Badli, Haryana",
          "Bhindawas Bird Sanctuary",
          "Chhochhi, Dhigal  IN/HR",
          "Dighal",
          "Ismailpur (Pokhar)",
          "Jhajjar, Haryana",
          "Jhajjar--Dhaur Village",
          "Jhajjar--Jharli village",
          "Jhajjhar--Bhindawas",
          "Mandothi",
          "Matanhale Jhajjar",
          "Mundakhera Flat -- Jhajjar",
          "NTPC Jharli",
        ],
      },
      {
        district: "Jind",
        localities: [
          "Jind city",
          "Jind--Kalwan village",
        ],
      },
      {
        district: "Kaithal",
        localities: [
          "Chacha Nehru Children Park (Bidkyar Lake)",
          "R.K.S.D College",
          "Thana--Kaithal",
        ],
      },
      {
        district: "Karnal",
        localities: [
          "Karna Lake, Karnal",
          "Karnal Railwsy Station",
          "NDRI Karnal",
          "Padha Village Tank, Karnal",
        ],
      },
      {
        district: "Kurukshetra",
        localities: [
          "Brahma Sarovar",
          "Kurukshetra University (Restricted)",
          "Thana Lake",
        ],
      },
      {
        district: "Mahendragarh",
        localities: [
          "Dhosi, Narnaun IN/HR",
          "Madhogarh Fort HR/IN",
        ],
      },
      {
        district: "Nuh",
        localities: [
          "Hasanpur Tauru, Manesar",
          "Nuh village",
          "Surjivan Resort",
        ],
      },
      {
        district: "Palwal",
        localities: [
          "KG Wetland, Palwal",
          "Mandkaula Wetlands",
          "Mandnaka Village (OBI)",
          "Palwal, Haryana (OBI)",
        ],
      },
      {
        district: "Panchkula",
        localities: [
          "Beerh Shikargarh WLS",
          "Berwala Bird Sanctuary",
          "Command Hospital Chandimandir Haryana",
          "Morni Hills",
          "Nandpur Forest",
          "Nepli Reserved Forest",
          "Panchkula-- water treatment plant",
          "Panchkula--Beerh Ghaghar",
          "Panchkula--Cactus Garden",
          "Panchkula--Ghaggar River-- Opposite Herbal Park",
          "Panchkula--Pir Muchhaila",
          "Panchkula--Recreational Park",
          "Panchkula--Thappli Nature Park",
          "Pinjore--Haryana",
          "Pinjore--Kaushalya Dam",
          "Pinjore--Yadavindra Gardens",
          "Suketri, Chandigarh",
          "Sukna Wildlife Sanctuary--General Area",
          "Thapli",
        ],
      },
      {
        district: "Panipat",
        localities: [
          "Panipat Oil Refinery Eco Farm",
          "Panipat Railway Station,",
          "Thermal Station panipath IN/HR",
        ],
      },
      {
        district: "Rewari",
        localities: [
          "Husainpur, Rewari",
          "Manethi, Rewari",
          "Masani Barrage",
        ],
      },
      {
        district: "Rohtak",
        localities: [
          "Baland Rohtak",
          "Baland--Firani Road",
          "Dighal--Scrub Forest",
          "Ghudan, Rohtak",
          "Rohtak--Karor Village",
          "Sampla",
          "Tilyar Lake",
        ],
      },
      {
        district: "Sirsa",
        localities: [
          "CDLU Campus (Restricted)",
          "Jamal, Sirsa",
          "Ludesar",
          "Ottu Head",
          "Ottu Lake",
        ],
      },
      {
        district: "Sonipat",
        localities: [
          "Abbas pur Sonipat  Hr/IN",
          "Ashoka University",
          "Bahalgarh IN/HR",
          "DRAIN NO 8 Gudha Hr/IN",
          "Gohana Canal haryana",
          "Mohamedabad Marsh",
          "OP Jindal Global University, Sonipat",
          "Rishi Chaitanya Ashram",
          "Samboli Village",
          "Sonipat Railway Station",
        ],
      },
      {
        district: "Yamunanagar",
        localities: [
          "Ch. Devi Lal Herbal Nature Park",
          "Hathni Kund Barrage IN/HR",
          "Jagadhri, Yamuna Nagar",
          "Kalesar National Park",
        ],
      },
    ],
  },
  {
    state: "Himachal Pradesh",
    districts: [
      {
        district: "Bilaspur",
        localities: [
          "Bamta, Himachal Pradesh, IN (31.354, 76.76)",
          "Barmana village",
          "Gobind Sagar Lake, Bilaspur",
          "Govt. College Bilaspur",
          "Hotel Hill Top, Swarghat",
          "Kehloor Restaurants and Surroundings",
          "Kharsa Changar, Bilaspur",
          "Naina Devi WLS",
          "Nangal Lake (Govind Sagar)",
          "Samletu",
        ],
      },
      {
        district: "Chamba",
        localities: [
          "Bairagarh to Satrundi",
          "Bathri Nullah (stream)",
          "Chamera Reservoire, Dalhousie",
          "Dainkund Peak",
          "Dalhousie (OBI)",
          "Dharwas",
          "Forest Rest House, Chamba",
          "Grand View Hotel",
          "Holi (1,800m) (OBI)",
          "Hotel Dalhousie Heights",
          "Kalatop WLS",
          "Kalatop Wildlife Sanctuary",
          "Khajjiar",
          "Khajjiar Lake",
          "Khajjiar range (Kalatop Khajjiar wls)",
          "Kholpukhar Forest",
          "Panchpula Waterfalls, Dalhousie",
          "RK Hotel, Tissa",
          "Saho, Chamba (OBI)",
          "Satrundi, near Sach Pass (OBI)",
          "Sural Tai",
          "Tundah Wildlife Sanctuary (OBI)",
          "Upper Bakrota, Dalhousie",
          "near Kalatop WS",
        ],
      },
      {
        district: "Hamirpur",
        localities: [
          "AE PWD office and surroudings, Chouri",
          "National Institute of Technology, Hamirpur",
        ],
      },
      {
        district: "Kangra",
        localities: [
          "Aghanjar Mahadev Temple, Dharamsala",
          "Aima (Ghuggar) Palampur, Himachal",
          "Andretta, Palampur",
          "Araiya Norwood heights Resort, Palampur",
          "Asia Health Resorts and Spa",
          "Bhadroya",
          "Bhagsunag Waterfall, McLeodganj",
          "Billing, Kangra",
          "Bir Forest",
          "Chohla - Thatri Road",
          "Clouds End Villa Cottages, Dharmshala",
          "Dal Lake, Mcleod Ganj",
          "Dehra Gopipur",
          "Dev Bhoomi Farms and Cottages",
          "Dharamkot",
          "Dharamshala (OBI)",
          "Dharamshala City",
          "Dharmashala Tea Estate",
          "Dragon Resort, Naddi",
          "Gaggal, near Dharamshala (OBI)",
          "Gallu Devi Temple",
          "Gallu-Dharamkot Trek Path",
          "Gopalpur Zoo",
          "Guna Devi Mandir Trek",
          "HOSTAN Hike, Bundla, Palampur",
          "HP Govt Timber Depot (Jangle Thapkore)",
          "Health and Wellness Centre & Surroundings, Magzine",
          "Heaven's View B&B",
          "Him Sagar Hotel, Awal",
          "Jawali (OBI)",
          "Kandbari",
          "Kangra Fort",
          "Kasba-Bagiarra Road, Palampur",
          "Kasumber Devta Temple, Dharmshala",
          "Lamrin Norwood Green Resort, Palampur",
          "Little Mastiff Pong View, Dharamshala",
          "Lunj",
          "Maharana Pratap Sagar (Pong Dam)",
          "Masroor Rock- Cut Temple,Lahalpur",
          "McLeod Ganj",
          "McLeod Ganj -- Forest Below Skyway",
          "Naddi (OBI)",
          "Nagrota Surian Forest Complex",
          "Nalle Road Ghugar, Palampur, Himachal Pradesh",
          "Narwana Village",
          "Norbulingka tibetan institute, Kangra",
          "Nurpur Fort",
          "Palampur, Himachal Pradesh",
          "Para-gliders Landing Spot",
          "Pathankot (OBI)",
          "Pong Dam -- Goglara",
          "Pong Dam Lake WLS--Ransar Island",
          "Pong Dam Lake--Dehar Khad",
          "Pong Dam--Chatta Watchtower",
          "Pong Dam--Dhameta",
          "Pong Dam--Nagrota Surian",
          "Pong Dam--Shah nehar barrage",
          "Pong Dam-Raur Dibber",
          "Pongdam",
          "Prakriti Aalay, Dharamshala",
          "Rakkar, Himachal Pradesh",
          "Rakkar-Tang Road",
          "Rancer the Island",
          "Reserve Jangal Solda",
          "Sadwan",
          "Sansarpur Terrace",
          "Shah Nehar Barrage Ponds",
          "Shar Nehar Barrage Lake",
          "Shiva Cafe, Bhagsu Nag Waterfall",
          "Shree Jakhani Mata Temple and Surroundings",
          "Silh village",
          "St John Church, McLeodGanj",
          "Sthana, near Shah Nehar Barrage Lake",
          "Sugghar, Palampur, Himchal Pradesh",
          "Tangroti Khas",
          "Taragarh Palace Hotel, Aweri",
          "Thala Riverside Walk, Bundla, Palampur",
          "The Kutumb Home Stay, Palampur",
          "The Sojourn (Gulmohar Cottage)",
          "Tihri Village (OBI)",
          "Trail Waterfall-Triund",
          "Triund (OBI)",
          "Triund Trek",
          "Uhal Dhar village trail",
          "Uparli Dar Paragliding Fields",
          "Vindhyavasini Mata Mandir",
          "Wah Tea Estate",
          "War Memorial, Dharamshala",
          "garli",
        ],
      },
      {
        district: "Kinnaur",
        localities: [
          "Baspa Nadi--Kuppa Dam",
          "Baspa Valley (OBI)",
          "Bhaba Valley",
          "Brelingi",
          "Chitkul, Himachal Pradesh",
          "Chitkul, Nargu Camp",
          "Happy Waterfall, Shilani",
          "Jeera Farm, Sangla",
          "Kalpa Village",
          "Kalpa, Kinnaur (OBI)",
          "Nako village",
          "Pooh village",
          "Puh (OBI)",
          "Rakchham",
          "Rakchham-Chhitkul Road",
          "Reckong Peo",
          "Rupi Bhaba Wildlife Sanctuary",
          "Sangla (OBI)",
          "Sangla Kanda",
          "Sangla Valley",
          "Spillow Village",
          "Sumra village",
          "The Monk Cottages, Kalpa",
          "Wangtu",
        ],
      },
      {
        district: "Kullu",
        localities: [
          "Aleo",
          "Anjani Mahadev Temple",
          "Bah Village, Kullu dt",
          "Bahu Lake",
          "Bandrol",
          "Basu Campsite",
          "Beas Hotel, Manali",
          "Bhuntar to Garsa road",
          "Bhunter town",
          "Bihar",
          "Chanderkhani",
          "Chandrakini Pass snowline (OBI)",
          "Darakhali, Mobile Point, GNHP, Tindar",
          "Dhundi village, Kullu Dt",
          "Dungri, Manali (OBI)",
          "Forest Colony Dhalpur, Kullu",
          "GB Pant Institute, Mohal",
          "GNHP--Rolla  Gate",
          "Ghoshal Village",
          "Grahan Village",
          "Great Himalayan NP",
          "Great Himalayan NP Pekhri",
          "Great Himalayan NP--Choidwari",
          "Great Himalayan NP--Dengha Pool",
          "Great Himalayan NP--Dhel camp",
          "Great Himalayan NP--Forest Rest House--Mashyar",
          "Great Himalayan NP--Forest Rest House--Sainj",
          "Great Himalayan NP--Guishaini",
          "Great Himalayan NP--Gumtro camp",
          "Great Himalayan NP--Nada",
          "Great Himalayan NP--Rakundi Top",
          "Great Himalayan NP--Rolla camp",
          "Great Himalayan NP--Roopa",
          "Great Himalayan NP--Shilt",
          "Gulaba--General Area (OBI)",
          "Hadimba Devi Temple, Manali",
          "Haripur Village",
          "Jagatsukh",
          "Jagatsukh Forest Area, Near Gojra",
          "Jalori Pass (OBI)",
          "Jana Forest",
          "Jibhi (OBI)",
          "Jibhi Waterfalls",
          "Kais Dhar Trek",
          "Karjan Village",
          "Kasol",
          "Kasol Youth Hostel Base Camp",
          "Kheerganga trail",
          "Khokhan WLS",
          "Klath Village",
          "Kothi",
          "Kullu Bus stand",
          "Manali Wildlife Sanctuary",
          "Manali Wildlife Sanctuary ( near Old Manali)",
          "Manali-General Area",
          "Manali-Solang valley",
          "Manikaran",
          "Marhi, Himachal Pradesh",
          "Naggar Village",
          "Nature Park, Mohal",
          "Old Manali",
          "Pekri Cheer Pheasant point",
          "Quality Inn Suites (Rennest River Country Resort)",
          "Raison Village",
          "Raju Bharti's Guest House",
          "Rhotang Pass Kulu Slope",
          "Rohtang Pass-Summit",
          "Rolla To Great Himalayan NP Gate, Chippni",
          "Rustic Wood House, Bini",
          "Seobagh, Kullu Dt",
          "Shai Ropa Forest Complex",
          "Shanag Village",
          "Shangarh Forest Area",
          "Shangarh Village",
          "Sojha (OBI)",
          "Solang Valley",
          "Solang-Gulaba trek",
          "Somvan Forest - Haripur",
          "Sonaugi Homestead",
          "Soyal Village--General Area",
          "Span Resort, Manali (OBI)",
          "Sunset Inn Tosh",
          "The Blue Sheep Hostel (Tirthan)",
          "The Himalayan Trout House",
          "The Igloo Village Sethan",
          "Tinder Village",
          "Tirthan Kuteer",
          "Tirthan Travel Nest Homestay",
          "Tirthan Valley, Himachal Pradesh",
          "Tirthan Valley, Nagini",
          "Trail - Goshaini to Rolla camp",
          "Van Vihar, Manali",
          "Vashist",
          "Veterinary Hospital Burwa",
        ],
      },
      {
        district: "Lahaul and Spiti",
        localities: [
          "B/W Gondla & Kyelang",
          "B/W Kyelang & Gondla",
          "B/W Kyelang & Jispar",
          "B/W Sissoo  and  Koksar",
          "B/W Sissoo & Gondla",
          "Baralacha La Bridge",
          "Baralacha Pass",
          "Batal, Lahaul, Himachal",
          "Chandra Taal (Chandra Lake)",
          "Chatadu, Lahaul, Himachal",
          "Chhatru",
          "Chicham Bridge",
          "Chicham Village",
          "Chinab River Bed, Udaipur",
          "Chomoling, Kibber, Spiti",
          "Confluence of Spiti and Pin River",
          "Dandak",
          "Darcha, Lahaul",
          "Demul Village, Spiti",
          "Dhankar",
          "Dhankar Lake, Spiti",
          "Dumla, Chicham, Spiti",
          "Forest Rest House, Udaipur",
          "Futi Runi",
          "Gemur (Cimur)",
          "Gete Village, Spiti",
          "Gimur Spring",
          "Gondla",
          "Gondla (Chandra Valley)",
          "Gue village",
          "Hurling Village, Spiti, Himachal",
          "Jahalman Village",
          "Jispa",
          "Jispa (Bhaga River)",
          "Juniper Forest",
          "Juniper Forest (Kyelang to Darcha)",
          "Juniper Forest of Keylong",
          "Karcha",
          "Kaza",
          "Kaza ( River bed)  Spiti",
          "Kee village",
          "Key Monastery",
          "Keylong",
          "Khangsar",
          "Khoksar village",
          "Kibber Village, Spiti",
          "Kinlung Yunnan River",
          "Komic Monastery",
          "Komic, Village",
          "Kunzum Pass, Spiti",
          "Lahul",
          "Lalung village",
          "Langza, Spiti",
          "Lari village",
          "Lidang village",
          "Lingti plain between Phalang Danda and Kinlung",
          "Lingti village",
          "Losar village, Spiti",
          "Mud Village, Bridge, Pin Valley",
          "Muling (Minling)",
          "Narbu Sumdo",
          "PWD Rest House, Udaipur",
          "Pangmo village",
          "Patsio, Lahaul",
          "Patsoi-river bed",
          "Pin Valley NP",
          "Pin Valley NP--Dhar Togseluganwa",
          "Poh Village, Spiti, Himachal",
          "Rama village",
          "Rangrik Na",
          "Rohtang Pass (foot) Chandra River",
          "Rohtang pass",
          "Salung village",
          "Sarchu ( near police post)",
          "Sarchu Village",
          "Sarchu--Tsarab River",
          "Segiya Dangsa",
          "Shego village, Spiti",
          "Shigri Glacier",
          "Shukto Village",
          "Sissu village",
          "Sumdo, Spiti",
          "Suraj Tal Lake",
          "Tabo Monastery",
          "Tabo Village",
          "Tara House Homestay, Pin Valley",
          "Tashigang, Spiti",
          "Tharcha camping ground (Takcha)",
          "Tindi, Tandi-Kishtwar Road",
          "Yurnath",
          "Zingzingbar",
        ],
      },
      {
        district: "Mandi",
        localities: [
          "Aut",
          "Bandli Wildlife Sanctuary",
          "Barot/Multhan",
          "Beas River (Near Victoria Bridge)",
          "Beas River Near GPS Khaliar Sadar -1",
          "Bhangotu village",
          "Bhiuli, Mandi",
          "Chaprot road",
          "Dadour Village",
          "Dohandi Village",
          "HPFA",
          "HPFA forest",
          "HPFA-Cedar-Keran-NAC Trambri HP",
          "IIT Mandi",
          "Janjehli Village",
          "Joginder Nagar",
          "Kandi-Bagi",
          "Karsog",
          "Katanda FRH",
          "Mandi town",
          "Motipur, Mandi HP",
          "Nalsar",
          "Nalsar Lake",
          "Nargu Sanctuary",
          "Ner chowk town",
          "Parashar Lake",
          "Rahla",
          "Ranger training institute, Sundernagar",
          "Rewalsar Lake",
          "Shikari Devi Wildlife Sanctuary",
          "Sundernagar Lake",
          "Tatapani Hot Springs",
        ],
      },
      {
        district: "Shimla",
        localities: [
          "Annadale Ground",
          "Bharari Rd",
          "Cedar Villas, Baldeyan",
          "Chanshal Pass",
          "Daranghati Wildlife Sanctuary -- Rakhani",
          "Deodar Cottage, Kotgarh",
          "Dhantheras Thach",
          "Glen Nature Trails",
          "GreenHub Western Himalayas",
          "Hanuman Temple, Jakhoo Hill",
          "Hatu Mata Temple",
          "Hatu Peak, Narkanda",
          "Hatu Road",
          "Hatu Valley Homestay Narkanda",
          "High Court Shimla",
          "Himalayan Forest Research Institute (HFRI)",
          "Himalayan Nature Park, Kufri",
          "Hotel Snowflake",
          "Indian Institute of Advance Study",
          "Jakha Village",
          "Jiskun",
          "Kharapathar temple",
          "Kingni Hill Top, Sarahan",
          "Kotgarh (OBI)",
          "Koti",
          "Koti, Chail",
          "Kotla",
          "Litham Camp Site",
          "Mandhol, Jubbal (OBI)",
          "Nareil",
          "Narkanda",
          "Narkanda Temple",
          "National Academy of Audit & Accounts",
          "Potter Hill",
          "Prem Nagar, Kumarsain",
          "Rajkiya Kanya Mahavidyalaya (RKMV)",
          "Rampur, Himachal Pradesh",
          "Sai-Narkanda Road",
          "Sarahan Pheasantry area",
          "Sarahan Village",
          "Seri Village",
          "Shali Devi Temple",
          "Shimla",
          "Shimla Water Catchment WLS",
          "Shoghi",
          "Snow Trail Resort by Gilgo",
          "Summer Hill, Shimla (OBI)",
          "Tanni Jubbar Lake",
          "Tethys Ski Resort, Narkanda",
          "Thanedar (OBI)",
          "Theog",
          "Theog Outskirts Trail (Near Taj Hotel)",
          "Trail - Dofda to Sharai Koti Temple via Daran Village",
          "Trail- Ranot to Nau Shaani temple,Rampur,Himachal Pradesh,India",
        ],
      },
      {
        district: "Sirmaur",
        localities: [
          "Chudhar WLS",
          "Dakpathar Barrage",
          "Deedag",
          "Giri River near Badlech",
          "Haripurdhar Himachal Pradesh",
          "JRL Resorts",
          "Mist-n-Meadows (Restricted access)",
          "POP Hotel Universe View, Sarahan",
          "Rajgarh",
          "Rajgarh Trail",
          "Renuka Lake",
          "Renukaji WLS",
          "Salana Forest Area, Rajgarh",
          "Simbalbara NP",
          "Thanoga Forest Area1",
          "Thanoga Forest Area2",
          "Thanoga Rajghar",
          "Villa Round, Nahan",
        ],
      },
      {
        district: "Solan",
        localities: [
          "Amaya Homes",
          "Baikunth Resorts",
          "Bamboo Pine, Himachal Pradesh, IN (30.895705, 77.022084)",
          "Banota, Bashel",
          "Bara Village, Kumarhatti",
          "Bhoj Nagar and Surroundings",
          "Bhoj Nagar- Chakki Mod Rd-2",
          "Bhoj Nagar-Chakki Mod Rd 3",
          "Bhojnagar- Chakki Mod Rd 4",
          "Chail Wildlife Sanctuary, Solan",
          "Chakki Mod Cafe",
          "Chakki Mod Rd",
          "Chakki Mod Rd 1",
          "Chakki Mod--Picnic spot",
          "Chakki Modh Waterfall",
          "Dagshai - Dharampur Rd",
          "Dr. Y. S. Parmar University of Horticulture",
          "Dr. Y.S Parmar University, Nauni",
          "Gilbert's Nature Trail",
          "HPPWD Guest House & PWD office, Kasauli",
          "Ishwar Cafe & Birding Point",
          "Jabli, Himachal Pradesh",
          "Jagjit Nagar",
          "Jangeshu, Solan",
          "Kasauli",
          "Kasauli Club",
          "Mashobra, Kasauli",
          "Nayagram, near Banasar Fort, Himachal Pradesh",
          "Sadhupul-Chail Rd",
          "Shamral",
          "Sharma Dhaba, Datyar, Parwanoo",
          "Subathu, Solan",
          "Sunset Point, Dagshai",
          "Tanwar Guest House, Chakki Mod-Bhojnagar Rd",
          "Timber Trail Heights & Terraces",
          "Timber Trail Resort, Parwanoo (lower)",
        ],
      },
      {
        district: "Una",
        localities: [
          "Bhadwar",
          "Gobind Sagar--Raipur Maidan",
          "Monkey Sterilization Centre, Baul,Una",
        ],
      },
    ],
  },
  {
    state: "Jammu and Kashmir",
    districts: [
      {
        district: "Anantnag",
        localities: [
          "Achabal Garden",
          "Arshan Valley",
          "Aru",
          "Bentes Lodge",
          "Betab Valley Pahalgam",
          "Club Garden, Pahalgam",
          "Hassanpora , Anantnag",
          "ITC Pine N Peak",
          "Island Park",
          "Jawahar Tunnel, North Point",
          "Kokernag",
          "Lavender Park, Pahalgam.",
          "Lidder Valley (OBI)",
          "Nunwan Base Camp",
          "Overa-Aru Wildlife Sanctuary, Anantnag, Kashmir",
          "Pahalgam",
          "Panzmullah",
          "Phalagam--Mini Zoo",
          "Rajparian Wildlife Sanctuary",
          "Sinthan Top",
          "Sparrow resort",
          "Titanic View Point",
          "Vir Siran",
          "Yanner Bridge",
        ],
      },
      {
        district: "Bandipora",
        localities: [
          "Arin",
          "Barar",
          "Dawar, Gurez Valley, J&K",
          "Gurez",
          "Mountain Livestock Research Institute, SKUAST-K, Manasbal",
          "Sumbal, Bandipora-J&K",
          "Vishnusar Lake",
          "Wular Lake",
          "Zainul lank",
        ],
      },
      {
        district: "Baramulla",
        localities: [
          "Dangiwacha",
          "Drung Waterfall",
          "Frozen Lake Gulmarg",
          "Gulmarg",
          "Gund Khaleel",
          "Haigam Wetland Reserve",
          "Kajinag NP",
          "Kandi Forest Range",
          "Kongdoori",
          "Lachipora Wildlife Sanctuary",
          "Limber WLS",
          "Mirgund Wetland",
          "Naseem Bagh A Sopore",
          "NowPora NHPC Colony",
          "Uri-iind Power Project",
          "Wular lake -Botingu",
          "khilanmarg (OBI)",
        ],
      },
      {
        district: "Budgam",
        localities: [
          "AAA Memorial Degree College Bemina",
          "Awanpora",
          "Badgam",
          "Bemina flood canal",
          "Chadoora",
          "Dhoodh Pathri",
          "Doodhpathri",
          "Flood Channel Alamdar colony",
          "Hokersar Wetland",
          "Narkara Wetland Badgam",
          "Rajbagh (OBI)",
          "Rambagh flood chennel",
          "Ryan Enclave--Badgam",
          "Ryan enclave",
          "Shivpora, Kashmir (OBI)",
          "Srinagar (OBI)",
          "Srinagar Airport",
          "Yousmarg Forest Area",
          "Yusmarg",
          "near Yusmarg (OBI)",
        ],
      },
      {
        district: "Doda",
        localities: [
          "Bhaderwah Campus, University of Jammu",
          "Bhaderwah Padri Road",
          "Doda City",
          "GDC Thathri",
          "Guldanda, Bhaderwah",
          "Gupt Ganga, Bhaderwah",
          "Jai Ghati",
          "Nandni village, Behota",
          "Phalshore (33.217, 75.671)",
          "Phalshore (33.219, 75.671)",
          "Rainda, Bhaderwah",
        ],
      },
      {
        district: "Ganderbal",
        localities: [
          "Astanmarg",
          "Baba Dariya Din",
          "Baltal",
          "Baltal Wildlife Sanctuary",
          "Central University of Kashmir, Ganderbal",
          "Chaterhama",
          "Dargah Hazratbal Shrine",
          "Gund, Kangan",
          "Kangan",
          "Manasbal Lake",
          "Mata Khir Bhawani Jee Temple",
          "Nainsukh",
          "Naranaag",
          "SKUAST Campus Shuhama",
          "SKUAST-Faculty of Forestry, Benhama",
          "Shuhama (OBI)",
          "Sindh View Park, Kangan",
          "Sonamarg",
          "Sonamarg Vishansar Trek",
          "Sonamarg to Pandsore Trek",
          "Sonamarg--Thajiwas Glacier",
          "Wakura",
          "Zojila Pass",
        ],
      },
      {
        district: "Jammu",
        localities: [
          "Akhnoor",
          "Bagh E Bahu",
          "Bari Brahmana, Jammu",
          "Bharda Kalan",
          "CSIR- Indian Institute of Integrative Medicine (CSIR-IIIM, Jammu",
          "CSIR-IIIM, Jammu",
          "Central University of Jammu",
          "Chak Majra",
          "Chatha",
          "Chowadhi",
          "Domel",
          "Dul (OBI)",
          "Environment Park,Raika",
          "Forest Guard Training School Doomi",
          "Gharana Wetland & fields",
          "Gharana wetlands ( East) Jammu",
          "Gharana, RS Pura",
          "Gorah Patan",
          "Goverment Degree College R S Pura",
          "Government Degree College Marh",
          "Govt. MAM PG College, Jammu",
          "IIIM Jammu",
          "Indian Institute of Technology, Jammu",
          "Jammu City",
          "Jourian",
          "Jourian Akhnoor",
          "Mahamaya Forest",
          "Makwal Kukrian Wetland",
          "Nikki Tawi 4th Bridge",
          "Pargwal",
          "Poshana, Jammu (OBI)",
          "Ramnagar Wildlife Sanctuary",
          "SFRI Nursery ,Sidhra",
          "SKUAST--Jammu",
          "Satthar, Nardi",
          "Science College, Jammu",
          "Sohanjana",
          "Suhanjina",
          "Sunjwan Forest Jammu",
          "Surinsar",
          "Surinsar Mansar Wildlife Sanctuary",
          "Surinsar- Chalanah Forest",
          "Suryaputri Tawi Arti Ghat",
          "Tawi River (Near Amar Mahal), Jammu",
          "Tawi-Ring Road",
          "University of Jammu",
        ],
      },
      {
        district: "Kathua",
        localities: [
          "Baggan, Billawar",
          "Darung",
          "Galak",
          "Jammu Jasrota",
          "Kothi Farnata",
          "Mandli - Kishenpur Road",
          "Nangala , Machhedi",
          "Nangala lake and surroundings",
          "Ranjit Sagar Dam, Kathua",
          "Sanoja",
          "Sarthal",
          "Thein, Kathua",
          "Ujh Barrage, Kathua",
          "billawar",
        ],
      },
      {
        district: "Kishtwar",
        localities: [
          "Bhandarkote, Kishtwar (OBI)",
          "Chenab Nagar, DPS, Kishtwar",
          "Dulhasti Power Station, Kishtwar, Trigam",
          "Kishtwar (OBI)",
          "Kishtwar Garbage Dump",
          "Kwar (OBI)",
          "Lednie-Birding Hotspot",
          "Sarkoot (OBI)",
          "Zambran",
        ],
      },
      {
        district: "Kulgam",
        localities: [
          "Aharbal Waterfall",
          "Hirpora WLS",
          "Hirpora Wildlife Sanctuary",
          "Peer Ki Gali",
          "Qazigund",
          "Wanpoh",
        ],
      },
      {
        district: "Kupwara",
        localities: [
          "Bungas valley",
          "Govt Degree College Sogam Lolab",
          "Kuligam",
          "SKUAST--Wadura",
        ],
      },
      {
        district: "Mirpur",
        localities: [
          "Mahaseer National Park, Kotli AJK",
          "Mangla Dam Lake",
          "Mendhar",
          "Mendhar Forests",
        ],
      },
      {
        district: "Muzaffarabad",
        localities: [
          "Jagran, Neelum Valley",
          "Pearl Continental, Muzaffarabad (34.349, 73.47)",
        ],
      },
      {
        district: "Poonch",
        localities: [
          "Bandichechian",
          "Banjosa Lake",
          "Buffliaz",
          "Dera Ki Gali",
          "Dhokri, Poonch View",
          "Jhulass, Poonch",
          "Kalamound",
          "Mangnar Top",
          "Mendhar",
          "Poonch Bridge",
          "Poonch City Forest",
          "Rawalakot",
          "Shamsabad, Rawalakot",
          "Toli Peer",
          "Toli Peer National Park",
          "Vikran singh Dheri",
        ],
      },
      {
        district: "Pulwama",
        localities: [
          "Chatlam Wetland",
          "Chatlam Wetland Reserve",
          "Khrew",
          "Kranchoo--Pampore",
          "Lethipora",
          "Manbough Pampore",
          "Pampore Wetlands",
          "Pampore wetlands",
          "Wuyan Pampore",
        ],
      },
      {
        district: "Rajouri",
        localities: [
          "Baba Ghulam Shah Badshah University, Rajouri",
          "Govt. Degree College (GDC), Kalakote",
          "Manwa Mata Mandir",
          "Shiv Khori,Ransoo",
        ],
      },
      {
        district: "Ramban",
        localities: [
          "Batote (OBI)",
          "Chilla",
          "JKTDC--Banihal",
          "Nachlana",
          "Patnitop",
          "Patnitop-Nathatop Road",
          "Sanasar Lake and around",
        ],
      },
      {
        district: "Reasi",
        localities: [
          "Bhavan, Vaishno Devo Shrine",
          "Dewal",
          "Katra--The White Hotel",
          "Panshi Point",
          "Purana Daroor",
          "SMVDU Campus",
          "Vaisho Devi Shrine Area in Bhavan ,Katra",
        ],
      },
      {
        district: "Samba",
        localities: [
          "Basantar Devak Course",
          "Birpur",
          "Central University Of Jammu, Samba campus",
          "Chhajwal",
          "Government Degree College, Samba",
          "Patti ,Smailpur Villages",
          "Shiv Temple, Purmandal",
          "Surinsar Mansar Sanctuary",
          "Vijaypur--Jammu",
        ],
      },
      {
        district: "Shopian",
        localities: [
          "Rambiara",
        ],
      },
      {
        district: "Srinagar",
        localities: [
          "Anchar Lake",
          "Bod dal",
          "Botanical Garden",
          "Boulevard Road, Srinagar (34.092, 74.87)",
          "Brain Nishat Srinagar",
          "Brein Nishat",
          "Chasme Shahi (mughal gardens)",
          "Dachigam National Park (general area)",
          "Dachigam National Park--Dagwan",
          "Dachigam National Park--entrance",
          "Dal Lake",
          "Dal Lake, Shrinagar",
          "Emporium Garden",
          "Foreshore Road",
          "Harwan Garden",
          "Inner Dal Lake Road",
          "Inner lake road",
          "Manibugh Wetland, Pampore (OBI)",
          "NIT Srinagar",
          "Nallah Amir",
          "Nigeen Lake",
          "Nishat",
          "Nishat Garden",
          "Pari Mahal Garden",
          "SKUAST--Shalimar",
          "Sarband Lake",
          "Shalimar Bagh",
          "Shallabugh Wetland Reserve",
          "Shankaracharya Hill, Srinagar",
          "Shankaracharya Reserved Forest (Zaberwan Forest)",
          "Shri Adi Shankaracharya Temple",
          "Sonwar--Srinagar",
          "Srinagar",
          "Srinagar--Shankaracharya Forest",
          "University of Kashmir",
          "Vivanta/Taj Hotel, Srinagar",
          "Zabarvan Hills (OBI)",
          "Zabarwan Hills",
        ],
      },
      {
        district: "Udhampur",
        localities: [
          "Dumping ground Udhampur",
          "Khaned, Basantgarh",
          "Kud",
          "Mall Road Kud",
          "Mansar Forests",
          "Mansar Lake",
          "Mantalai",
          "Naag Temple--Patnitop",
          "Sudh Mahadev",
          "Udhampur",
          "Udhampur Railway Station",
        ],
      },
    ],
  },
  {
    state: "Jharkhand",
    districts: [
      {
        district: "Bokaro",
        localities: [
          "Bokaro Ispat Vidyalaya Sector 6A surroundings",
          "Chandankiyari Forest Office",
          "City Park",
          "Cooling Pond 2",
          "Cooling pond 1",
          "Garga Dam",
          "Jawaharlal Nehru Biological Park",
          "Konar Dam",
          "Scrubland behind Surya Mandir",
          "Tenughat Reservoir",
        ],
      },
      {
        district: "Chatra",
        localities: [
          "Basaria Forest",
          "Lawalong WLS-General Area",
          "Mcluskie Ganj",
        ],
      },
      {
        district: "Deoghar",
        localities: [
          "Ajay Barrage",
          "Nandan Pahad",
          "Tapovan Hill, Deoghar",
          "Trikut Parvat",
        ],
      },
      {
        district: "Dhanbad",
        localities: [
          "Amtal Forest Patch",
          "Council of Scientific and Industrial Research",
          "Damodarpur Hill",
          "Dhanbad  Railway Station",
          "Dhokra Grassland",
          "Dhokra--Palash Forest",
          "Maithon Dam Jharkhand side",
          "Panchet Dam Jharkhand side",
          "Topchanchi WLS",
          "Workshop Colony",
        ],
      },
      {
        district: "Dumka",
        localities: [
          "Bhalka",
          "Diguli",
          "Masanjore Dam",
        ],
      },
      {
        district: "East Singhbhum",
        localities: [
          "Amlagora Forest",
          "Bada Banki Grassland (Hurlung)",
          "Beldih Club (restricted access)",
          "Bhatia Park",
          "Bhilai Pahari - Bagro Water Fall",
          "Burudi Dam",
          "Centenary Park",
          "Chota Banki Dam",
          "DAV Public School (Restricted access)",
          "Dalma WLS--General Area",
          "Dalma WLS--Hill Top",
          "Dalma Wildlife Sanctuary",
          "Dharagiri Falls",
          "Dimna Lake",
          "Galudih Barrage",
          "Hata Grasslands",
          "Hudco Park",
          "Jayanti Sarovar",
          "Jubilee Park",
          "Jungle Trail Park",
          "Kankrajhore/Kanimahuli--Shiv Mandir",
          "Kharkhai River Bank",
          "Kharkhai Subarnarekha Sangam",
          "Mango--Subarnarekha River Bank",
          "Nutandih--Subarnarekha River Bank",
          "Tata Steel Zoological Park",
          "Tatanagar Railway Station",
          "Tubemakers Club (restricted access)",
          "Uliyan Pond",
          "XLRI--Subarnarekha River Bank",
        ],
      },
      {
        district: "Giridih",
        localities: [
          "Chongakhar",
          "Giridih Railway Station",
          "ISI Farm",
          "Khandoli Reservoir",
          "Parasnath Station",
          "Parasnath WLS-- Gautam Swami Tonk",
          "Parasnath WLS--Base Of Main Hill",
          "Parasnath WLS--Chandraprabhu Tonk",
          "Parasnath WLS--Gandharva Nala",
          "Parasnath WLS--General Area",
          "Parasnath WLS--Jal Mandir",
          "Parasnath WLS--Kalikund Mandir and 1st Hill",
          "Parasnath WLS--Parasnath Tonk",
          "Parasnath WLS--Sheetal Nala",
          "Shikharji Town",
        ],
      },
      {
        district: "Gumla",
        localities: [
          "Palkot WLS--General Area",
          "Upper Sankh Dam",
        ],
      },
      {
        district: "Hazaribagh",
        localities: [
          "Ambacola",
          "Canary Hill",
          "Chadwa Dam",
          "Chameli Waterfall",
          "Chandwa Dam",
          "Gonda Dam",
          "Hazaribagh Jheel",
          "Hazaribagh NP",
          "Hazaribagh Pinjrapole Gaushala",
          "Hazaribagh Wildlife Sanctuary",
          "Hurhuru Pond",
          "Lotwa Dam",
          "Mount Carmel School",
          "Parsatari",
          "Pathalgarwa",
          "Rajderwa Bird Sanctuary",
          "Salparni Wildlife Sanctuary",
          "Sitagarh Hill",
        ],
      },
      {
        district: "Jamtara",
        localities: [
          "Parvat Vihar",
        ],
      },
      {
        district: "Khunti",
        localities: [
          "Bhagwan Birsa Mrig Vihar",
          "Timra",
          "Torpa Rural Development Society for Women [TRDSW]",
        ],
      },
      {
        district: "Koderma",
        localities: [
          "Koderma WLS--General Area",
          "Piprahi",
          "Tilaiya Dam",
        ],
      },
      {
        district: "Latehar",
        localities: [
          "Barwadih Railway Station",
          "Betla NP--General Area",
          "Garu Gumla Forest Range--Kobarwa Nala",
          "Garu Gumla Forest Range--Kujrung Core Area",
          "Garu Gumla Forest Range--Maromar Guest house",
          "Garu--North Koel River Bank",
          "Kechki Sangam",
          "Lodh Falls",
          "Mahuadanr Wolf Sanctuary",
          "Netarhat Forest",
          "Netarhat Villlage",
          "Palamu Fort",
        ],
      },
      {
        district: "Lohardaga",
        localities: [
          "Nandani Dam",
        ],
      },
      {
        district: "Palamu",
        localities: [
          "Malay Dam",
        ],
      },
      {
        district: "Ramgarh",
        localities: [
          "Chainpur Railway Station  Grassland",
          "Dohakatu",
          "Kendriya vidyalaya ramgarh cantt",
          "Patratu Dam",
          "Ranchi Road Station Wetland",
        ],
      },
      {
        district: "Ranchi",
        localities: [
          "Army Golf Course",
          "Bariatu Hill",
          "Bhagawan Birsa Biological Park",
          "Birla Institute of Technology",
          "Birsa Agricultural College",
          "Birsa Munda Airport",
          "Boreya--Jumar River",
          "Central Institute of Psychiatry",
          "Dhurva Chota Dam",
          "Dhurwa Chota Dam",
          "Dhurwa Dam",
          "Dhurwa Dam- Bandratoli",
          "Dhurwa Dam--Sembo",
          "Doranda",
          "Dr.shyama Prasad Mukherjee University (DSPMU)",
          "Getalsud Dam",
          "Getulsud Dam--View Point",
          "Gossner College",
          "Hapatbera Hill",
          "Hatia Dam",
          "Hindalco Colony",
          "Horhap FRH",
          "Horhap Forest--General Area",
          "Horhap Forest--River bank",
          "Horhap Forest--Waterfall",
          "Hundru Waterfall",
          "ITBP Hill",
          "Institute of Forest Productivity",
          "Jarga Hill",
          "Jarga Jungle Valley",
          "Jonha",
          "Jonha Falls",
          "Jumar River Mini Dam",
          "Kanke Dam",
          "Latratu Dam",
          "Pahari Temple",
          "Pusu Hill",
          "Rajendra Park",
          "Ranchi College",
          "Ranchi Lake",
          "Ranchi Railway Station",
          "Ranchi Veterinary College",
          "Rarha,Pithauriya",
          "Rukka Dam",
          "Rukka Dam--Hatwal",
          "Rukka Dam--Subarnrekha Bridge",
          "Salhan--Subernrekha Bridge",
          "Sidhu Kanhu Park",
          "Sita Falls",
          "Tigra",
          "Vulture Centre",
        ],
      },
      {
        district: "Sahibganj",
        localities: [
          "Pachanandapur River Islands",
          "Sahibganj Ghat",
          "Udhwa Bird Sanctuary--Berhale Jheel",
          "Udhwa Bird Sanctuary--Pataura Lake",
        ],
      },
      {
        district: "Saraikela-Kharsawan",
        localities: [
          "Aasanbani Hillock",
          "Chandil Dam--Dimudih",
          "Chandil Dam--General Area",
          "Dalma WLS--Aasanbani",
          "Dalma WLS--Checkdam Area",
          "Dalma WLS--Forest Rest House",
          "Dalma WLS--Makula Kocha",
          "Dobo",
          "Dobo Dam",
          "Hotel Madhuban",
          "Kharkai Chhath Ghat Majhitola",
          "NIT Jamshedpur",
          "Purisili Pond",
          "Sitarampur Reservoir",
          "Taal Lake",
        ],
      },
      {
        district: "Simdega",
        localities: [
          "Kelaghat Dam",
        ],
      },
      {
        district: "West Singhbhum",
        localities: [
          "Baraiburu FRH",
          "Chiriya",
          "Gindung",
          "Hirni Falls",
          "Kiriburu",
          "Kiriburu Forest Rest House",
          "Makranda",
          "Nakti Dam",
          "Noamundi",
          "Pachpaia",
          "Rabangda",
          "Saranda,Chaibasa Forest",
          "Tambo",
          "Tholkobad Forest Guest House",
          "Toebo waterfall",
          "Toybo",
        ],
      },
    ],
  },
  {
    state: "Karnataka",
    districts: [
      {
        district: "Bagalkote",
        localities: [
          "Agastya Kere & Badami Caves ಅಗಸ್ತ್ಯ ಕೆರೆ ಮತ್ತು ಬಾದಾಮಿ ಗುಹೆಗಳು",
          "Alamatti Backwaters--Beerkabbi ಆಲಮಟ್ಟಿ ಹಿನ್ನೀರು--ಬೀರಕಬ್ಬಿ",
          "Alamatti Backwaters--Herkal  ಆಲಮಟ್ಟಿ ಹಿನ್ನೀರು--ಹೆರ್ಕಲ್",
          "Alamatti Backwaters--Koppa SR ಆಲಮಟ್ಟಿ ಹಿನ್ನೀರು--ಕೊಪ್ಪ ಎಸ್ಆರ್",
          "Alamatti Backwaters--Rolli ಆಲಮಟ್ಟಿ ಹಿನ್ನೀರು--ರೊಳ್ಳಿ",
          "Alamatti Backwaters-Anagawadi, ಆಲಮಟ್ಟಿ ಹಿನ್ನೀರು-ಅನಗವಾಡಿ",
          "Almatti Dam, Bagalkot ಆಲಮಟ್ಟಿ ಡ್ಯಾಂ, ಬಾಗಲಕೋಟೆ",
          "Almatti Reservoir--Solapur Highway ಆಲಮಟ್ಟಿ ಜಲಾಶಯ --ಸೋಲಾಪುರ ಹೆದ್ದಾರಿ",
          "Arshibidu Kere ಅರ್ಶಿಬೀಡು ಕೆರೆ",
          "Badami ಬಾದಾಮಿ",
          "Bagalkot Railway Station ಬಾಗಲಕೋಟೆ ರೈಲು ನಿಲ್ದಾಣ",
          "Benakatti West Hillock ಬೆನಕಟ್ಟಿ ಪಡುವಣ ಗುಡ್ಡ",
          "Benakatti ಬೆನಕಟ್ಟಿ",
          "Budihal Tq. Badami ಬೂದಿಹಾಳ ತಾ. ಬಾದಾಮಿ",
          "Chinkara WLS--Bilgi  ಚಿಂಕಾರ ವನ್ಯಧಾಮ-ಬೀಳಗಿ",
          "Didaga Waterfalls and Pool ದಿಡಗ ಜಲಪಾತ ಮತ್ತು ಕೊಳ",
          "Ghataprabha River Bank, Bagalkote Town ಘಟಪ್ರಭಾ ನದಿ ದಂಡೆ, ಬಾಗಲಕೋಟೆ ಪಟ್ಟಣ",
          "Ghataprabha River Bridge, Mudhol  ಘಟಪ್ರಭಾ ನದಿ ಸೇತುವೆ, ಮುಧೋಳ",
          "Guledagudda Kere ಗುಳೇದಗುಡ್ಡ ಕೆರೆ",
          "Guledagudda Road Railway Station ಗುಳೇದಗುಡ್ಡ ರಸ್ತೆ ರೈಲು ನಿಲ್ದಾಣ",
          "Halakurki Kere ಹಲಕುರ್ಕಿ ಕೆರೆ",
          "Handekolla Hanamappa Forest ಹಂಡೆಕೊಳ್ಳ ಹನುಮಪ್ಪನ ಕಾಡು",
          "Handekolla Hanamappa Kere ಹಂಡೆಕೊಳ್ಳ ಹನುಮಪ್ಪನ ಕೆರೆ",
          "Haveli ಹವೇಲಿ",
          "Hirekeri ಹಿರೆಕೆರಿ",
          "Hosuru Kere, Eshwar Nagar ಹೊಸೂರು ಕೆರೆ, ಈಶ್ವರ ನಗರ",
          "Hotel Mayura Chalukya, Badami",
          "Industrial Area (Lakes on both sides of the road) ಕೈಗಾರಿಕಾ ಪ್ರದೇಶ (ರಸ್ತೆ ಬದಿಯ ಎರಡೂ ಕೆರೆಗಳು)",
          "KJSEM School, Sameerwadi ಕೆ.ಜೆ.ಎಸ್.ಇ.ಎಂ. ಶಾಲೆ, ಸಮೀರವಾಡಿ",
          "Katti Keri, Jamkhandi ಕಟ್ಟಿ ಕೆರಿ, ಜಮಖಂಡಿ",
          "Kovalli Nursery ಕೋವಳ್ಳಿ ನರ್ಸರಿ",
          "Kudala Sangama ಕೂಡಲ ಸಂಗಮ",
          "Mahakoota Ancient Temple ಮಹಾಕೂಟ ಪ್ರಾಚೀನ ಮಂದಿರ",
          "Mahalingapur Kere ಮಹಾಲಿಂಗಪುರ ಕೆರೆ",
          "Mallapur Island ಮಲ್ಲಾಪುರ ನಡುಗಡ್ಡೆ",
          "Mallapura Railway Bridge ಮಲ್ಲಾಪುರ ರೈಲು ಸೇತುವೆ",
          "Muchakandi Kere ಮುಚಕಂಡಿ ಕೆರೆ",
          "Murudi Rocky Scrub ಮುರುಡಿ‌ ಕಲ್ಲಿನ ಕುರುಚಲು‌ ಕಾಡು",
          "Pattadakal ಪಟ್ಟದಕಲ್ಲು",
          "Picheli's Farm House, Mudhol ಪಿಚೇಳಿ ಫಾರ್ಮ್ ಹೌಸ್, ಮುಧೋಳ",
          "Rangasamudra Dam--Mangalagudda Bridge  ರಂಗಸಮುದ್ರ ಆಣೆಕಟ್ಟು- ಮಂಗಳಗುಡ್ಡ ಸೇತುವೆ",
          "S Nijalingappa Medical College ಎಸ್ ನಿಜಲಿಂಗಪ್ಪ ವೈದ್ಯಕೀಯ ಮಹಾವಿದ್ಯಾಲಯ",
          "Shivayoga (Govinakki)  Mandira  ಶಿವಯೋಗ -ಗೋವಿನಕ್ಕಿ ಮಂದಿರ",
          "Shri Nattadavi Naganatha Temple  ಶ್ರೀ ನಟ್ಟಡವಿ ನಾಗನಾಥ ಮಂದಿರ",
          "Siddeshwara Temple Lake ಸಿದ್ದೇಶ್ವರ ಮಂದಿರ ಕೆರೆ",
          "Yadahalli ಯಡಹಳ್ಳಿ",
        ],
      },
      {
        district: "Ballari",
        localities: [
          "Allipura",
          "Ankasamudra Bird Sanctuary ಅಂಕಸಮುದ್ರ ಪಕ್ಷಿಧಾಮ",
          "Bellary Fort",
          "Bhandri Dodda Kere ಬಂಡ್ರಿ ದೊಡ್ಡ ಕೆರೆ",
          "Bhandri Sanna Kere ಬಂಡ್ರಿ ಸಣ್ಣ ಕೆರೆ",
          "Brise Stables",
          "Dandanayakana Kere ದಂಡನಾಯಕನ ಕೆರೆ",
          "Daroji Bear Sanctuary--Sitarama Tanda ದರೋಜಿ ಕರಡಿ ಧಾಮ--ಸೀತಾರಾಮ ತಾಂಡ",
          "Daroji Bear Sanctuary--Upparahalli ದರೋಜಿ ಕರಡಿ ಧಾಮ--ಉಪ್ಪಾರಹಳ್ಳಿ",
          "Daroji Forest Guest House ದರೋಜಿ ಅರಣ್ಯ ಅತಿಥಿಗೃಹ",
          "Daroji Kere ದರೋಜಿ ಕೆರೆ",
          "Daroji Sloth Bear Sanctuary ದರೋಜಿ ಕರಡಿಧಾಮ",
          "Forest Guest house, Kamalapur (OBI)",
          "Gudekote Bear Sanctuary",
          "Halli Kere ಹಳ್ಳಿಕೆರೆ",
          "Hampi ಹಂಪಿ",
          "Hampi--Jungle Lodges ಹಂಪಿ--ಜಂಗಲ್‌ ಲಾಡ್ಜೆಸ್‌",
          "Hampi--Kannada University  ಹಂಪಿ--ಕನ್ನಡ ವಿಶ್ವವಿದ್ಯಾಲಯ",
          "Hampi--Matanga Hill ಹಂಪಿ--ಮಾತಂಗ ಪರ್ವತ",
          "Hampi--Nimbapura ಹಂಪಿ--ನಿಂಬಾಪುರ",
          "Hampi--Royal Enclosure  ಹಂಪಿ--ರಾಜಾಂಗಣ",
          "Hampi-Hotel Mayura Bhuvaneshwari ಹಂಪಿ--ಹೋಟೆಲ್‌ ಮಯೂರ ಭುವನೇಶ್ವರಿ",
          "Hirekeriyaginaha Kere (ಹಿರೇಕೇರಿಯಾಗಿನಹ ಕೆರೆ)",
          "Huvinahadagali, BRC center",
          "Kamalapur--General Area (OBI)",
          "Kamalapura Kere ಕಮಲಾಪುರ ಕೆರೆ",
          "Kannada University Kere ಕನ್ನಡ ವಿಶ್ವವಿದ್ಯಾಲಯ ಕೆರೆ",
          "Kolagal Kere ಕೊಳಗಲ್ಲು ಕೆರೆ",
          "Kotturu Kere ಕೊಟ್ಟೂರು ಕೆರೆ",
          "Malavi Dam View Point ಮಾಲವಿ ಜಲಾಶಯ ವೀಕ್ಷಣಾ ತಾಣ",
          "Malyavanta Raghunatha Temple, Hampi ಮಾಲ್ಯವಂತ ರಘುನಾಥ ದೇವಸ್ಥಾನ, ಹಂಪಿ",
          "Mariammanahalli ಮರಿಯಮ್ಮನಹಳ್ಳಿ",
          "Nandibanda Kere ನಂದಿಬಂಡ ಕೆರೆ",
          "Obulapura Kere ಓಬಳಾಪುರ ಕೆರೆ",
          "Papinayakanahalli Betta ಪಾಪಿನಾಯಕನಹಳ್ಳಿ ಬೆಟ್ಟ",
          "Raw Water Pond, Vidyanagar Township ಕಚ್ಚಾ ನೀರಿನ ಕೊಳ, ವಿದ್ಯಾನಗರ ಪಟ್ಟಣ",
          "SSR Park and surrounds, Northern Hosapete",
          "Sitarama Tanda ಸೀತಾರಾಮ ತಾಂಡಾ",
          "Sovenahalli Kere ಸೋವೇನಹಳ್ಳಿ ಕೆರೆ",
          "Sri AB Vajapayee Zoological Park, Kamalapur ಶ್ರೀ ಎಬಿ ವಾಜಪೇಯಿ ಜೂಯಾಲಾಜಿಕಲ್‌ ಪಾರ್ಕ್‌, ಕಮಲಾಪುರ",
          "Sri Vijay Vitthala Temple Area ಶ್ರೀ ವಿಜಯ ವಿಠ್ಠಲ ದೇವಸ್ಥಾನ ಪ್ರದೇಶ",
          "Swamimalai Forest Range- -Kumaraswamy Temple ಸ್ವಾಮಿಮಲೈ ಅರಣ್ಯ ವಲಯ- -ಕುಮಾರಸ್ವಾಮಿ ದೇವಸ್ಥಾನ",
          "Thimmalapura ತಿಮ್ಮಲಾಪುರ",
          "Tungabhadra Backwaters--Bannigola ತುಂಗಭದ್ರಾ ಹಿನ್ನೀರು--ಬನ್ನಿಗೋಳ",
          "Tungabhadra Backwaters--Nakaralu Tanda ತುಂಗಭದ್ರಾ ಹಿನ್ನೀರು--ನಕರಾಳು ತಾಂಡಾ",
          "Tungabhadra High Level Canal--Tejaswiloka  ತುಂಗಭದ್ರಾ ಮೇಲ್ಮಟ್ಟದ ಕಾಲುವೆ--ತೇಜಸ್ವಿಲೋಕ",
          "Tungabhadra High-level Canal ತುಂಗಭದ್ರಾ ಮೇಲ್ಮಟ್ಟದ ಕಾಲುವೆ",
          "Tungabhadra Reservoir ತುಂಗಭದ್ರಾ ಜಲಾಶಯ",
          "Tungabhadra Reservoir- Munirabad Bridge, ತುಂಗಭದ್ರಾ ಜಲಾಶಯ- ಮುನಿರಬಾದ್ ಸೇತುವೆ",
          "Tungabhadra Reservoir-Gunda Tree Park ತುಂಗಭದ್ರಾ ಜಲಾಶಯ -ಗುಂಡಾ ಸಸ್ಯೋದ್ಯಾನ",
          "Tungabhadra Right Canal--Kamalapur ತುಂಗಭದ್ರಾ ಬಲದಂಡೆ ಕಾಲುವೆ--ಕಮಲಾಪುರ",
          "Tungabhadra backwaters--Varadapura ತುಂಗಭದ್ರಾ ಹಿನ್ನೀರು--ವರದಾಪುರ",
          "Vidyanagar Township, Toranagallu ವಿದ್ಯಾನಗರ ಟೌನ್‌ಶಿಪ್, ತೋರಣಗಲ್ಲು",
        ],
      },
      {
        district: "Belagavi",
        localities: [
          "Angol  Kere",
          "Aravali Check Dam ಅರವಳಿ ಚೆಕ್‌ ಡ್ಯಾಂ",
          "Belagavi Golf Course ಗಾಲ್ಫ್‌ ಕೋರ್ಸ್, ಬೆಳಗಾವಿ",
          "Belagavi Railway Station ಬೆಳಗಾವಿ ರೈಲು ನಿಲ್ದಾಣ",
          "Belgaum--General Area (OBI)",
          "Bhimgad Adventure Camp, Katgali Rd ಭೀಮಗಡ ಅಡ್ವೆಂಚರ್‌ ಕ್ಯಾಂಪ್‌, ಕಟ್ಗಳಿ ರಸ್ತೆ",
          "Bhimgad Wildlife Sanctuary--Hemmadaga ಭೀಮಗಡ ವನ್ಯಧಾಮ--ಹೆಮ್ಮಡಗಾ",
          "Bidi Minor Irrigation Tank ಬಿಡಿ ಕಿರು ನೀರಾವರಿ ಟ್ಯಾಂಕ್",
          "Bilakundi Kunte ಬಿಲಕುಂದಿ ಕುಂಟೆ",
          "Chikhale village ಚಿಕಲೆ ಗ್ರಾಮ",
          "Chikkabudanur Kere ಚಿಕ್ಕಬೂದನೂರು ಕೆರೆ",
          "Dhupdal IB Garden ದುಪ್ಪದಾಲ್ ಐಬಿ ಗಾರ್ಡನ್",
          "Ghataprabha Bird Sanctuary ಘಟಪ್ರಭಾ ಪಕ್ಷಿಧಾಮ",
          "Godachinmalki Falls ಗೊಡಚಿನಮಲ್ಕಿ ಜಲಪಾತ",
          "Godageri Kere ಗೊಡಗೇರಿ ಕೆರೆ",
          "Gogte Institute of Technology ಗೋಗಟೆ ತಾಂತ್ರಿಕ ಸಂಸ್ಥೆ",
          "Gokak Falls ಗೋಕಾಕ ಜಲಪಾತ",
          "Handibadanganath Mutt ಹಂಡಿಬಡಂಗನಾಥ ಮಠ",
          "Hanumapur Kere ಹನುಮಾಪುರ ಕೆರೆ",
          "Hidkal Backwaters --Jinaral ಹಿಡಕಲ್ ಹಿನ್ನೀರು--ಜಿನರಾಳ",
          "Hidkal Backwaters- Gudanahatti",
          "Hidkal Dam--Viewpoint ಹಿಡಕಲ್ ಆಣೆಕಟ್ಟು--ವೀಕ್ಷಣಾ ಸ್ಥಳ",
          "Hirebudanur Kere ಹಿರೇಬೂದನೂರ ಕೆರೆ",
          "Hulikatti Kere ಹುಲಿಕಟ್ಟಿ ಕೆರೆ",
          "Jamboti  ಜಂಬೋಟಿ",
          "KLEU Campus ಕೆಎಲ್ಇಯು ಆವರಣ",
          "Kamal Basadi ಕಮಲ್ ಬಸದಿ",
          "Kankumbi ಕಣಕುಂಬಿ",
          "Kaparatti Kere ಕಪರಟ್ಟಿ ಕೆರೆ",
          "Kaujalgi Kere ಕೌಜಲಗಿ ಕೆರೆ",
          "Kittur Fort ಕಿತ್ತೂರು ಕೋಟೆ",
          "Lolasur Bridge ಲೋಳಸುರ ಸೇತುವೆ",
          "Malagali Kere ಮಳಗಲಿ ಕೆರೆ",
          "Malaprabha Backwater Nayanagar, Bailhongal",
          "Malaprabha River, Kesarkoppa ಮಲಪ್ರಭಾ ನದಿ, ಕೆಸರಕೊಪ್ಪ",
          "Malaprabha River--Jamboti Bridge ಮಲಪ್ರಭಾ  ನದಿ--ಜಂಬೋಟಿ ಸೇತುವೆ",
          "Mhadei Research Center ಮಹದಾಯಿ ಸಂಶೋಧನಾ ಕೇಂದ್ರ",
          "National Institute of Traditional Medicine ರಾಷ್ಟ್ರೀಯ ಪಾರಂಪರಿಕ ಚಿಕಿತ್ಸಾವಿಜ್ಞಾನ ಸಂಸ್ಥೆ",
          "Navilutheertha Dam ನವಿಲುತೀರ್ಥ ಆಣೆಕಟ್ಟು",
          "Near Belgaum--General Area (OBI)",
          "Ramnagar (OBI)",
          "Renukasagar Reservoir ರೇಣುಕಾಸಾಗರ ಜಲಾಶಯ",
          "Savadatti Jackwell ಸವದತ್ತಿ ಜಾಕ್ವೆಲ್",
          "VTU ವಿಟಿಯು",
          "Vaccine Depot ಲಸಿಕೆ ಕೇಂದ್ರ",
          "Vadakahole Mutt, Naviluteertha ವಡಕಹೊಳೆ ಮಠ, ನವಿಲುತೀರ್ಥ",
          "Vajrapoha Falls, Jamboti  ವಜ್ರಪೋಹ ಜಲಪಾತ, ಜಾಂಬೋಟಿ",
          "Vishveshwara Nagar (Near Golf Club) ವಿಶ್ವೇಶ್ವರ ನಗರ",
        ],
      },
      {
        district: "Bengaluru Rural",
        localities: [
          "Ardeshanahalli Kere",
          "Avathi Kere",
          "Avathi Rocky Outcrop",
          "Bannimangala Kere (ಬನ್ನಿಮಂಗಳ ಕೆರೆ)",
          "Bashettihalli Kere (ಬಾಶೆಟ್ಟಿಹಳ್ಳಿ ಕೆರೆ)",
          "Benakana Halla Forest Patch",
          "Bengaluru Airport (Kempegowda International Airport)",
          "Bettakote Kere",
          "Budigere Kere",
          "Centre for Research and Education in Science and Technology",
          "Channarayapatna Kere",
          "Chikkarayappanahalli Kere",
          "Chikkasanne Kere",
          "Devanahalli, Bangalore",
          "Dibbagiri Swamy Betta",
          "Dod Belvangala Kere",
          "Dodda Tumakuru Kere",
          "Doddaballapur--Railway station",
          "Doddaballapura Kere",
          "Doddabommasandra",
          "Doddasanne Kere",
          "EL Domo Hill View",
          "Gundamagere Lake (ಗುಂಡಮಗೆರೆ ಕೆರೆ)",
          "Gunjur Kere",
          "Halu Chilume Gange",
          "Hanabe Lake",
          "Happy Valley, Makalidurga",
          "Hegganahalli / Nagamangala Kere",
          "Hessaraghatta--Hessaraghatta Grassland",
          "Hill Jain Temple",
          "Hoopinkai's Farm Retreat",
          "Hoskote / Hosakote Kere",
          "Hoskote Kere (western path only)",
          "Hoskote--Chikka Amani Kere",
          "Hulukadi Hillock (ಹುಲುಕಡಿ ಬೆಟ್ಟ)",
          "Jalige Kere",
          "Junnasandra Mini Forest",
          "Kanchiganala Lake ಕಂಚಿಗನಾಳ ಕೆರೆ",
          "Kannamangala kere, ಕನ್ನಮಂಗಳ ಕೆರೆ",
          "Karenahalli Tank",
          "Kesturu Kere (ಕೆಸ್ತೂರು ಕೆರೆ)",
          "Kollur Kere (Lake)",
          "Kuligere Kere, (ಕೂಲಿಗೆರೆ ಕೆರೆ)",
          "Kuluvanahalli Kere",
          "LM Wind Power Campus, Dabaspete",
          "Lingapura Lake (ಲಿಂಗಾಪುರ ಕೆರೆ)",
          "Madhure Kere",
          "Makalidurga",
          "Mallanayakanahalli Kere (ಮಲ್ಲನಾಯಕನಹಳ್ಳಿ ಕೆರೆ)",
          "Mallepura Kere",
          "Maragondanahalli Kere (ಮರಾಗೊಂಡನಹಳ್ಳಿ ಕೆರೆ)",
          "Maralenahalli Kere (ಮಾರ್ಲೆನ ಹಳ್ಳಿ ಕೆರೆ)",
          "Meiosys Biotech Pvt. Limt. Field Station 1",
          "Melekote Kere, ಮೇಲುಕೋಟೆ ಕೆರೆ",
          "Muddalinganhalli Kere",
          "Mugabala Cultivation",
          "Muttur Lake (ಮುತ್ತೂರ್ ಕೆರೆ)",
          "Nalluru Tamarind Grove, Devanahalli",
          "Narasapura Kere",
          "Nature Knots Resort",
          "Nelamangala Kere--1",
          "Nelamangala Kere--2",
          "Nelamangala Taluk (OBI)",
          "Nrityagrama",
          "Our Native Village resort",
          "Rajaghatta Kere (ರಾಜಗಟ್ಟ ಕೆರೆ)",
          "Sadahalli Kere",
          "Sanne Amanikere",
          "School of Ancient Wisdom, Bangalore",
          "Shivagange Betta",
          "Shivapura Kere",
          "Singavara Betta, Huralagurthi",
          "Sonnenahalli",
          "Sulakunte Pond (ಸುಲಕುಂಟೆ ನೀರಿನ ಕುಂಟೆ)",
          "T Begur Chikka Kere",
          "T Begur Dodda Kere",
          "Thavarekere",
          "Thimmarayanaswamy Betta",
          "Thippagondanahalli (TG Halli) Reservoir",
          "Thippasettihalli Kere",
          "Thippuru Kere (ತಿಪ್ಪೂರು ಕೆರೆ)",
          "Thyamagondlu Amanikere",
          "Vederahalli Kere",
          "Veerapura Lake (ವೀರಾಪುರ ಕೆರೆ)",
          "Venkagirikote Kere",
          "Vijayapura Kere",
          "ಕಾನೇಕಲ್ಲು ಕೆರೆ (Kanekallu Lake)",
        ],
      },
      {
        district: "Bengaluru Urban",
        localities: [
          "AECS Layout - C Block, 749",
          "AECS Layout Brookefields",
          "ATREE",
          "Aagara-BM Kaval Kere (near Valley School)",
          "Abandoned quarry, Vabasandra",
          "Abbigere Lake",
          "Adde Vishwanathapura kere",
          "Adigondanahalli Wetlands--Handenahalli Bridge Marshes",
          "Adugodi Police Grounds",
          "Agara Kere (HSR Layout)",
          "Aivarakhandapura Kere",
          "Ajmera Stone Park",
          "Akshara Montessori School",
          "Akshayanagara Kere",
          "Al-Ameen Collage Campus",
          "Allalasandra Kere",
          "Allalasandra/Judicial Layout",
          "Alliance University-- Central Campus",
          "Amanikere (Avalahalli lake) Singanayakanahalli",
          "Ambalipura Kere",
          "Amruthahalli Lake",
          "Anchepalya Kere",
          "Anekal Dodda Kere",
          "Anjanapura / Avalahalli Kere",
          "Anjanapura Central Park",
          "Arashinakunte Kere",
          "Area 83 Adventure Resort",
          "Arekere Kere",
          "Arkavathy river bridge",
          "Art of Living, Kanakapura campus",
          "Attur Lake",
          "Augusta Golf Course",
          "Aurobindo marg,Jayanagar 5th block",
          "Avalahalli Forest--West Tank",
          "Avalahalli Lake -- adjoining areas",
          "Azim Premji University",
          "Azim Premji University (APU)--UG Campus",
          "B M Kavalu",
          "B Narayanapura Lake, ಬಿ ನಾರಾಯಣಪುರ ಕೆರೆ",
          "B. Hosahalli Kere",
          "BBMP Park",
          "BBMP Park HBR Layout",
          "BDA Park, Banashankari 6th Stage",
          "BEL Estate Office",
          "BEML Layout, RajaRajeshwari Nagar",
          "BHCS Layout Park",
          "BK & Sir MV Layouts, Thindlu",
          "BMP park, 34th cross, 18th main, Jayanagar",
          "BMP park, 38th cross, 18th main",
          "Backside of DMart (Agricultural fields)",
          "Bagaluru Kere (Lake)",
          "Bagmane Lake",
          "Banagiri Park",
          "Banashankari",
          "Banaswadi Mini Forest",
          "Banaswadi Railway Station",
          "Bandekodigehalli Kere",
          "Bandemutt",
          "Bangalore International Center (BIC)",
          "Bangalore Life Science Cluster (BLiSC)",
          "Bangalore University Campus",
          "Bangalore University--Jnanabharathi Campus ( DCCDE)",
          "Bannerghatta Hilltop",
          "Bannerghatta National Park",
          "Bannerghatta National Park--Badger Field Station",
          "Bannerghatta National Park--Bear Rescue Centre",
          "Bannerghatta National Park--JLR Camp",
          "Bannerghatta Zoo",
          "Basapura Kere--1",
          "Basapura Kere--2",
          "Basaveshwara circle",
          "Begur grazing grounds",
          "Behind Turahalli Tree Park",
          "Bellandur Kere",
          "Bendiganahalli Kere",
          "Bendiganahalli, Karnataka 562107",
          "Benniganahalli Lake",
          "Bharathnagar Lake",
          "Bhattrahalli Kere",
          "Bhoomi College",
          "Bidaraguppe Lake",
          "Bidarahalli Kere",
          "Bidre Kere",
          "Bikkanahalli Lake / Bikkanahalli Kere",
          "Bilwaradahalli",
          "Bingipura Lake",
          "Bommasandra Kere",
          "Bommenahalli Kere",
          "Brigade Exotica",
          "Brigade Meadows",
          "Brigade Millennium",
          "Brigade meadows- Pipeline Rd",
          "Budigere Cross, Bommenahalli (ಬಡಿಗೇರೆ ಕ್ರಾಸ್, ಬೊಮ್ಮೇನಹಳ್ಳಿ)",
          "Bugle Rock Park",
          "Buragunte Savannah",
          "Byalkere Lake (now dry)",
          "Byapanahalli railway/metro station",
          "Byatarayana Doddi Kere",
          "Byatha Lake",
          "Byatha Scrub Forest",
          "Byrasandra BMP park, Jayanagar",
          "Byrasandra Kere",
          "Byrohalli Village",
          "CK Palya-1 Kere",
          "CK Palya-2 Kere",
          "CRPF Campus Yelahanka",
          "CRPF- Dog School (Restricted Access)",
          "Canara Bank Layout",
          "Cantonment Railway Station",
          "Cariappa Park, Bangalore",
          "Carmelaram Railway Station",
          "Centre for Human Genetics (CHG)",
          "Chaithanya Greenfort 1",
          "Champaca Bookstore",
          "Chandapura Kere",
          "Channasandra Marsh",
          "Cheemsandra Mound",
          "Chelekere Lake",
          "Chikka Begur Kere--1",
          "Chikka Begur Kere--2",
          "ChikkaNagamangala Kere",
          "Chikkabanavara Kere",
          "Chikkabellandur Kere",
          "Chikkajala Kere",
          "Chikkajala scrub forest",
          "Chikkakammanahalli Pond",
          "Chikkanekkundi Grassland",
          "Chikkatogur Lake",
          "Chikkona Kere, kethohalli",
          "Chikkona kere",
          "Chinnappanahalli Kere",
          "Chinnayyanapalya Silk Farm Bus Stop",
          "Chokkanahalli Forest",
          "Chokkanahalli Kere",
          "Choodsandra Kere,",
          "Christ University Kengeri Campus",
          "Christ University--Main Campus",
          "Chunchugatta Kere",
          "Citrus Trail, Shivanahalli",
          "City Railway Station (SBC)",
          "Claret Niwas",
          "Classic Orchards Layout",
          "College of Fine Arts (Chitrakala Parishath) Kengeri Campus",
          "Concorde Silicon Valley",
          "Cubbon Park, Bangalore",
          "Dayananda Sagar College of Engineering",
          "Dayananda Sagar Institutions",
          "Deepanjalinagar Kere",
          "Deer Park, Bangalore",
          "Delhi Public School Bangalore North",
          "Devar Kere",
          "Devara Kere / ISRO Layout Lake",
          "Devarabisana halli lake",
          "Devasandra Lake",
          "Dhaneshwari Paradise Apts",
          "Dodda Aalada Mara (Big Banyan), ದೊಡ್ಡ ಆಲದ ಮರ",
          "Dodda Begur Kere",
          "Dodda Thimmasandra Road, Bengaluru, Karnataka, IN (12.863, 77.797)",
          "Dodda gubbi",
          "Doddabidara Kallu Kere",
          "Doddabommasandra Kere",
          "Doddagubbi Kere",
          "Doddajala Kere",
          "Doddakallasandra ground",
          "Doddakammanahalli Lake",
          "Doddanekundi Kere",
          "Doddathoguru Pond",
          "Doddibetta Trek--Shivanahalli (Restricted Access)",
          "Dore Kere",
          "Dore Kere Hill Spot",
          "Doresanipalya forest campus",
          "Durga Rock",
          "Durga Rock--Quarry View Point",
          "ESI Rajaji Nagar",
          "Eagle Ridge Layout",
          "Elita Promenade Phase B",
          "Embassy Riding School, Bangalore",
          "Evershine Greenwood Premises",
          "FERAL",
          "Ferns Meadows",
          "Ferns Residency",
          "Fireflies - off Kanakpura road, Bangalore",
          "Foundation for the Revitalization of Local Health Traditions (FRLHT)",
          "Friends of Camphill India",
          "GBJ quarters( HAL), marathahalli",
          "GKVK Campus",
          "GKVK Campus--Botanical Garden",
          "Ganapathihalli kere",
          "Ganapathihalli kere ಗಣಪತಿಹಳ್ಳಿ ಕೆರೆ",
          "Ganapathipura Kere, ಗಣಪತಿಪುರ ಕೆರೆ",
          "Gangondanahalli Kere",
          "Gantiganahalli Kere",
          "Garvebhavi Palya Kere",
          "Global Village Tech Park",
          "Gold Coins Club & Resort",
          "Good Earth Enclave",
          "Good Earth Malhar",
          "Gottigere Kere",
          "Goudanakere",
          "Gruhalakshmi Layout",
          "Gubbalala Lake",
          "Guddahatti Kere (Western) ಗುಡ್ಡಹಟ್ಟಿ ಕೆರೆ (ಪಶ್ಚಿಮ)",
          "Gulakamale Kere",
          "Gulakmale Kere",
          "Gundanjeneya Swamy Temple",
          "Gunduru Kere",
          "Gunjur Kere",
          "Gunjur Palya Kere",
          "Gunjur Palya Reserve Forest",
          "HAL coconut grooves, yemalur",
          "HP Enterprise (HP STSD), Mahadevpura",
          "Hadosiddapura Lake",
          "Hal Office quarters (near Hal market)",
          "Halagevaderahalli Kere",
          "Halanayakanahalli Kere",
          "Hanumagiri Hill",
          "Haragadde Kere",
          "Haraluru",
          "Haraluru Kere",
          "Haraluru Lake",
          "Harohalli Kere (North)",
          "Hasiru Holidays",
          "Hebbagodi Kere ಹೆಬ್ಬಗೋಡಿ ಕೆರೆ",
          "Hebbal Kere",
          "Hennagara Lake",
          "Hennur Bamboo Forest",
          "Hennur Lake Biodiversity Park",
          "Herohalli Kere",
          "Hessaraghatta Kere",
          "Hessaraghatta--Hessaraghatta Scrub Forest",
          "Hessaraghatta--ICAR area",
          "Hessaraghatta--Mathkur Area",
          "Hessaraghatta--Nrityagram Road",
          "Hinnaki Kere",
          "Home terrace",
          "Honnasandra Kere",
          "Honniganahatti Kere",
          "Hoodi Lake",
          "Horamavu Agara Kere",
          "Horamavu Kere",
          "Hosa Kere",
          "Hosakere (M Krishnasagar)",
          "Hosakerehalli Kere",
          "Hulimangala Kere",
          "Hulimangala, Bangalore",
          "Hulimavu Kere",
          "Hulimavu Lake--rock area",
          "Hunasamaranahalli Lake",
          "Huskur Kere",
          "ICTS Campus",
          "IDBI Layout Kere, Gottigere",
          "IISc Bangalore",
          "IISc Bangalore--Department of Aerospace Engineering",
          "IISc Bangalore--Gymkhana",
          "IISc Bangalore--Jubilee Gardens",
          "IISc Bangalore--Nursery",
          "IISc Bangalore--Southeast Forest",
          "ISRO Layout Lake (Deverakere)",
          "Iblur Lake",
          "Iggalur Kere",
          "Indian Institute Of Management–Bangalore (IIM–Bangalore)",
          "Indian Institute for Human Settlements (IIHS) Kengeri Campus",
          "Indian Institute of Astrophysics",
          "Indian Institute of Horticultural Research",
          "Indian Institute of Horticultural Research (IIHR) Farm",
          "Indian Institute of Management (IIM)-Bangalore, New Campus",
          "Indira Gandhi Musical Fountain Park, Bangalore",
          "Infosys Electronic City Kamath FoodCourt",
          "Institute of Bioinformatics & Applied Biotechnology (IBAB)",
          "Institute of Public Health (IPH)",
          "Institute of Wood Science and Technology",
          "Inventure Academy, Bangalore",
          "JCR Layout Marsh",
          "JFWTC, Whitefield",
          "JP Park and Lake",
          "Jaipurdoddi",
          "Jakkur Airfield",
          "Jakkur Kere",
          "Jakkur Lake",
          "Jakkur--GKVK Layout and Nursery",
          "Jalahalli, Bangalore",
          "Jalvayu Towers (JVT) - Apartment Complex",
          "Jarakbandekaval",
          "Jarakebande Kavalu Butterfly Park/ Avalahalli State Forest",
          "JavaregowdanaDoddi",
          "Jawaharlal Nehru Centre for Advanced Scientific Research (JNCASR)",
          "Jayanagar Bavi Park (Green Walkers Park), Bangalore",
          "Jigala Lake (tank)",
          "Jigani Kere",
          "Jogi Kere",
          "Judicial layout--BBMP Park",
          "Jyothipura",
          "K R K Enclave, Tavarekere",
          "K R Puram (Krishnarajapuram) Kere",
          "KIOCL Colony",
          "Kachohalli Kere",
          "Kada Agrahara paddy fields",
          "Kadabagere Kere",
          "Kadathanamale Kere (ಕಡತನಮಲೆ ಕೆರೆ)",
          "Kadiranapalya Kere",
          "Kadugodi (OBI)",
          "Kadugodi Tree Park",
          "Kaggadasapura Kere",
          "Kaggalipura Kere",
          "Kaikondrahalli Kere / Kaikondanahalli Kere",
          "Kakolu Kere",
          "Kakolu Scrub Forest",
          "Kalkere Kere",
          "Kalkere State Forest",
          "Kalyan Nagar Bus stop, Ring road, Bangalore",
          "Kammasandra Kere",
          "Kammgondahalli Lake",
          "Kannahalli Kere",
          "Kannamangala",
          "Kannamangala Kere",
          "Kannamangala lake",
          "Kannuru Kere",
          "Karnataka Golf Course (Restricted access)",
          "Karnataka Veterinary Animal and Fisheries Sciences University, Hebbal",
          "Kasavanahalli Kere",
          "Kasturi Nagara Kere",
          "Kattamanallur Kere",
          "Kattigenahalli Kere",
          "Kembathhalli Kere",
          "Kempambudhi Kere",
          "Kengeri Kere",
          "Kengeri Upanagara Kere",
          "Kithaganur Kere",
          "Kithiganahalli Attikere Lake",
          "Kodathuru Kere",
          "Kodigehalli Railway Station",
          "Kogilu Kere",
          "Kommaghatta Kere",
          "Kommasandra Lake",
          "Konanakunte (Doddakallasandra) Kere",
          "Konasandra Kere",
          "Koramangala 3rd block",
          "Koramangala 3rd block park",
          "Kowdenahalli Kere",
          "Krishna Nagar (Kothnur) Kere",
          "Krishnarajapuram Railway Station",
          "Krishnarajapuram--ITI Colony",
          "Kuduregure Kere",
          "Kudusiddanapalya Grassland ಕಾಡುಸಿದ್ದನಪಾಳ್ಯ ಹುಲ್ಲುಗಾವಲು",
          "Kumar Urbana iLife",
          "Kumara Park West",
          "Kumaraswamy Layout Water Tank",
          "Kundalahalli Kere",
          "Kyalasanahalli kere ಕ್ಯಾಲಸನಹಳ್ಳಿ ಕೆರೆ",
          "L&T Raintree Boulevard",
          "Lakshmipura State forest, ಲಕ್ಷ್ಮೀಪುರ ರಾಜ್ಯ ಅರಣ್ಯ",
          "Lalbagh Botanical Gardens",
          "Lalbagh Botanical Gardens--Lalbagh Lake",
          "Lewis Glorious Apartments",
          "Lingadeeranahalli Kere (Pavamanapura)",
          "Linganahalli Seasonal Pond",
          "Lower Ambalipura Kere",
          "M.S. Ramaiah City",
          "MN Krishna Rao Park, Bangalore",
          "Maaramma Temple",
          "Madhavan Park, Bangalore",
          "Madivala Kere",
          "Mahadev Kodigehalli (Gummanahalli) Kere",
          "Mahadevpura Kere",
          "Malathahalli lake",
          "Mallasandra, Bangalore",
          "Mallathahalli Kere",
          "Manchappanahalli Kere (Kotnathevaru Kere)",
          "Mango & Coconut Orchard, Chanasandra",
          "Manipal Academy of Higher Education (Restricted)",
          "Mantapa Kere",
          "Maragondanahalli Kere",
          "Maralakunte (M Hosahalli) Kere",
          "Marasandra Amaanikere",
          "Marasandra Lake",
          "Marenahalli Bande Lake",
          "Marenahalli, Bangalore",
          "Margosa Avenue, Bellanduru",
          "Marsur Lake",
          "Mayasandra Lake, ಮಾಯಸಂದ್ರ ಕೆರೆ",
          "Meenakunte Kere",
          "Mekhri Circle",
          "Mini Lalbagh, Kanamangala",
          "Mitganahalli Lake",
          "Monkey Park-Basaveshwaranagar,  ಕೋತಿ ಉದ್ಯಾನವನ- ಬಸವೇಶ್ವರ ನಗರ",
          "Mount Carmel College",
          "Mount Carmel College (MCC)",
          "Mugalur Kere",
          "Mullur Kere",
          "Mullur Kere, ಮುಳ್ಳೂರು ಕೆರೆ",
          "Mullur kere , ಮುಳ್ಳೂರು ಕೆರೆ",
          "Muncipal Corporation Layout, Forest Patch",
          "Munnekolala Kere",
          "Muthanallur Kere",
          "Muthanallur Sports Ground (Sachin Tendulkar Cricket Ground)",
          "Muthanallur village",
          "Muthyalamaduvu",
          "Mutturaya",
          "Mylappanahalli lake",
          "Mylasandra Kere",
          "Mysore Road Satellite Bus Station",
          "NCF, Banashankari",
          "NIMHANS",
          "Nagaruru Kere",
          "Nagawara Kere / Nagavara Kere",
          "Nallurhalli Kere",
          "Narasipura Kere",
          "National Center For Biological Sciences -- Mandara Housing Complex",
          "National Gallery of Modern Art (NGMA)",
          "National Games Village, Koramangala",
          "National Institute of Advance Studies (NIAS)",
          "Nayandanahalli Kere",
          "Nelaguli Kere",
          "Neralu Organic Orchards",
          "Neraluru Lake",
          "Nice link road",
          "Nimbekaipura Kere",
          "Nosenoru Kere, Jigani",
          "OB Chudanahalli kere",
          "OMBR Layout, Banaswadi",
          "Olde Bangalore Resort",
          "Omkar Hills Forest",
          "PES Institute of Technology (PESIT) South Campus",
          "PES University",
          "Palanahalli Kere",
          "Parangi Palya, HSR Layout",
          "Pattanduru Agrahara Kere",
          "Pearl Valley Dam",
          "People for Animals, Bangalore (PFA)",
          "Poornaprajna park",
          "Prakruti Farms",
          "Pramiti School",
          "Prani - The Pet Sanctuary",
          "Prestige Augusta",
          "Prestige Garden Bay",
          "Prestige Shantiniketan and surrounding area",
          "Pride Pristine Apartments",
          "Pu Ti Narasimhachar park",
          "Purva Highlands",
          "Purva Venezia",
          "Pushpanjali Park",
          "Puttenahalli Kere (North)",
          "Puttenahalli Kere (South, Puttakere)",
          "R V College of Engineering",
          "RAGI KANA AT SRI RAMAKRISHNA SAMAGRA SIKSHANA kendra, Kalena Agr",
          "RMV Extension, Bangalore",
          "RMZ Ecospace, Bangalore",
          "RNS College Campus",
          "RNS Vidyaniketan Campus",
          "RV University",
          "Raastra Kavi Kuvempu Park",
          "Rachenahalli Kere",
          "Radha Kunj Kere",
          "Ragihalli, Bangalore",
          "Ragihalli--Lotus Pond",
          "Ragihalli-Shivanahalli View point",
          "Rajiv Gandhi Nagar, Bangalore",
          "Ramagondanahalli Kere",
          "Ramakrishna Matha, ಶ್ರೀ ರಾಮಕೃಷ್ಣ ಮಠ",
          "Ramakrishna mission",
          "Ramakrishnapura Lake",
          "Raman Research Institute",
          "Ramohalli / Bheemanakuppe Kere",
          "Rampura-Kalkere Lake, Bangalore",
          "Ravugodlu Betta (Mutturaya Swami Temple side)",
          "Rayaradoddi Hillock",
          "Rayarakere Lake",
          "Rayasandra Kere",
          "Road to Lotus Pond",
          "Royal Lakefront Residency Phase III",
          "SG Palya",
          "SMILEE greens",
          "ST Bed extension, Koramangala",
          "Sadaramangala Kere",
          "Sadashivnagar",
          "Sadashivnagar Park, Bangalore",
          "Sadenahalli Kere (ಸಾದೇನಹಳ್ಳಿ ಕೆರೆ)",
          "Sahakaranagara Park, Bangalore",
          "Sahakaranagara, Bangalore",
          "Sakalvara-1 Kere",
          "Sakalvara-2 Kere",
          "Sampigehalli Kere",
          "Samvriddhi Gardenia",
          "Sangam \"The Land\", Silvepura",
          "Sankey Tank",
          "Sapthagiri Splendour",
          "Sarakki Kere",
          "Sarakki Lake",
          "Sarala Birla Academy",
          "Sarjapura Curries Farm",
          "Sarjapura Doddakere",
          "Satanur Kere",
          "Satisha Sarakki Hide, Tataguni",
          "Saul Kere / Sowl Kere",
          "Scalex Loop",
          "Seegehalli Kere",
          "Seegehalli Kere (Basavanapura)",
          "Seeta circle (Old IPH Office)",
          "Seetharamapalya Kere",
          "Sena Vihar",
          "Settahalli",
          "Shanitpura, Electronic City Phase -2",
          "Sheelavantha Kere",
          "Shivakote Kere",
          "Shivanahalli, Bangalore",
          "Shivpura kere  ಶಿವಪುರ ಕೆರೆ",
          "Shri Mutturaya Swamy Temple PGP3+M6J  Kanakapura Rd",
          "Siddapura Lake",
          "Silvepura Lake",
          "Singanayakanahalli (Nagadasanahalli) Kere",
          "Singapura Lake",
          "Singapura Lake Park",
          "Singasandra Kere",
          "Singena Agrahara",
          "Sobha Orchid",
          "Sobha Suburbia Apartment complex",
          "Somanahalli Kere",
          "Somapura",
          "Sompura Kere, NICE Road",
          "Sompura, Bangalore",
          "Sondekoppa Kere",
          "Sonnenahalli Fodder Land (Restricted Access)",
          "Sree Narayana Nagar--Weaver Pond",
          "Sreenivasa Garden",
          "Srigandhakavalu Park",
          "Srinivaspura Cross Lake Park",
          "Srinivaspura Kere",
          "St. John's Medical College Hospital",
          "St. Joseph's College",
          "St. Patrick's Church and surrounding areas",
          "State Poultry Farm Grassland",
          "Subramanya lake",
          "Subramanyapura Kere",
          "Sulikere, Kenchanapura",
          "Sunkadakatte",
          "Sunkalpalya Kere",
          "Suradhenupura Kere (ಸುರದೇನಪುರ ಕೆರೆ)",
          "Suvidha Retirement Village",
          "Swamy Vivekananda BBMP Park",
          "T Dasarahalli Kere",
          "Tammanayakanalli, BNP",
          "Tarahunise Lake",
          "Tata Elxsi",
          "Tatteguppa",
          "Tavarakere Park, Bangalore",
          "Thalaghattapura Kere",
          "Tharalu Kere",
          "Thattaguppe/Mariapura Kere",
          "The Big Barn Farm",
          "The Martin Farm, Chikkabellandur, Bangalore",
          "The Outback Farm",
          "Thigalarapalya Lake",
          "Thimmasandra Kere",
          "Thippenahalli",
          "Thirumenahalli Kere--1",
          "Thirumenahalli Kere--2",
          "Thottikallu Falls",
          "Thubarahalli Lake",
          "Thyavakanahalli",
          "Timber Trail - Air Force Command Hebbal (Restricted Access)",
          "Trans Indus",
          "Turahalli BBMP Water Tank",
          "Turahalli Forest Periphery",
          "Turahalli State Forest, Bangalore",
          "Turahalli Tree Park",
          "Turahalli--Karishma Hills Side",
          "Udayapur--MTR Restaurant",
          "Ullal Kere",
          "Ulsoor Kere",
          "Uttarahalli Kere",
          "Vadena Kere (Kaleshwari Lake)",
          "Vaikuntha Hill",
          "Vajram Essenza Road",
          "Vakil Encasa",
          "Vakil Garden City",
          "Valley School",
          "Varasandra / Hemmigepura Kere",
          "Varthur - Gunjur  Grass Lands",
          "Varthur Kere",
          "Vasanth Nagar",
          "Vasanthpura Lake (Janardhana kere)",
          "Veerasagara Kere",
          "Veerasandra Kere ವೀರಸಂದ್ರ ಕೆರೆ",
          "Veerayodharavana Park/Lake",
          "Velankani tech park",
          "Venkattapa Art Gallery",
          "Vibhutipura Kere",
          "Vikasa Soudha",
          "Vishwa Vihar, CV Raman Nagar",
          "Vishwaneedam Kere  ವಿಶ್ವನೀಧಮ್ ಕೆರೆ",
          "Visthar",
          "Vrishabhavati River",
          "Waterbody beside PESIT/APU (Overlflow of Konappana Agrahara lake)",
          "Whitefield Mini Forest",
          "Wildlife Rescue And Rehabilitation Centre (WRRC), Bannerughatta",
          "Wipro EC4, Electronic City",
          "Wipro Kodathi Campus",
          "Wipro SJP Campus",
          "Yediyur Kere",
          "Yelachenahalli lake (Annappana kere)",
          "Yelahanka Air Force Base (Restricted Access)",
          "Yelahanka Kere Back Gate Parking",
          "Yelahanka Kere--Main Entrance Nr Temple",
          "Yelahanka Kere--Northwest Entrance",
          "Yelahanka Railway Station",
          "Yelenahalli lake",
          "Yellamallappa Chetty (Yele Mallappa Shetty) Kere",
          "Yellamallappa Chetty (Yele Mallappa Shetty) Kere--North",
          "Yerappanahalli Kere",
          "Yeshwanthpur",
          "Yeswanthpur Railway Station",
          "Zed Earth (ಜ಼ೆಡ್ ಅರ್ಥ್)",
          "tharalu",
          "ಬೈರಾಪುರ ಕೆರೆ (Byarapura Lake)",
          "ಶಾನುಭೋಗನಹಳ್ಳಿ ಕೆರೆ (Shanubhoganahalli Lake)",
        ],
      },
      {
        district: "Bidar",
        localities: [
          "Behind MPS, Muchalamb",
          "Bidar Fort ಬೀದರ್ ಕೋಟೆ",
          "Bidar Grasslands--Airport Area ಬೀದರ್ ಹುಲ್ಲುಗಾವಲು--ವಿಮಾನ ನಿಲ್ದಾಣ ಪ್ರದೇಶ",
          "Bidar Railway Station ಬೀದರ್ ರೈಲು ನಿಲ್ದಾಣ",
          "Bidar--Airport Area ಬೀದರ್--ವಿಮಾನ ನಿಲ್ದಾಣ ಪ್ರದೇಶ",
          "Bidar--Chidri ಬೀದರ್--ಚಿದ್ರಿ",
          "Bidar--Ring Road near Zamistanpur ಬೀದರ್ --ವರ್ತುಳ ರಸ್ತೆ ಜಮಿಸ್ತಾನಪುರ",
          "Blackbuck Resort  ಕೃಷ್ಣಮೃಗ ಸಂರಕ್ಷಣಾಧಾಮ",
          "Chondi Grassland ಚೊಂಡಿ ಹುಲ್ಲುಗಾವಲು ಪ್ರದೇಶ",
          "Chulki Naala Dam, Mustapur ಚುಳಕಿ ನಾಲಾ ಜಲಾಶಯ, ಮುಸ್ತಾಪುರ",
          "Deva Deva Vana",
          "Forest Training Centre, Naubad",
          "Janawad ಜನವಾಡ",
          "Karanja Backwaters--Ranjolkheni ಕಾರಂಜಾ ಹಿನ್ನೀರು--ರಂಜೋಳಖೇಣಿ",
          "Karanja Reservoir ಕಾರಂಜಾ ಜಲಾಶಯ, ಬೀದರ",
          "Karanja Reservoir--Hilalpur ಕಾರಂಜಾ ಜಲಾಶಯ--ಹಿಲಾಲಪುರ",
          "Markhal Kere, Bawalpur ಮಾರ್ಕಲ್‌ ಕೆರೆ, ಬಾವಲ್ಪುರ",
          "Nidwancha‌ ನಿಡವಂಚಾ",
          "Nittur Grassland ನಿಟ್ಟೂರು ಹುಲ್ಲುಗಾವಲು ಪ್ರದೇಶ",
          "Papnash Lake Forest ಪಾಪನಾಶ ಕೆರೆ ಅರಣ್ಯ",
          "Shri Channabasaveshwar Kere, Bhalki ಶ್ರೀ ಚನ್ನಬಸವೇಶ್ವರ ಕೆರೆ, ಭಾಲ್ಕಿ",
          "Shri Mahisasura Mardini Mata Temple, Saidapur ಶ್ರೀ ಮಹಿಸಾಸುರ ಮರ್ದಿನಿ ಮಾತಾ ಗುಡಿ, ಸೈದಾಪುರ",
          "Shri Manik Prabhu Temple, ಶ್ರೀ ಮಾಣಿಕ ಪ್ರಭು ದೇವಸ್ಥಾನ",
          "Tiparanta kere ತಿಪ್ರಾಂತ ಕೆರೆ",
        ],
      },
      {
        district: "Chamarajanagara",
        localities: [
          "Agara-Mamballi Kere",
          "Amble, Chamarajanagara",
          "Anisha Farms ಅನಿಷಾ ಫಾರಂ",
          "Arepalya, ಅರೆಪಾಳ್ಯ",
          "Ayyanapura camp",
          "BR Hills",
          "BR Hills ಬಿ ಆರ್‌ ಹಿಲ್ಸ್--Biligiri Rangaswamy Temple Tiger Reserve ಬಿಳಿಗಿರಿರಂಗನಾಥಸ್ವಾಮಿ ಹುಲಿ ಅಭಯಾರಣ್ಯ",
          "BR Hills ಬಿಳಿಗಿರಿರಂಗನಾಥಸ್ವಾಮಿ ಹುಲಿ ಅಭಯಾರಾಣ್ಯ -KGudi ಕೆ ಗುಡಿ",
          "BR Hills--ATREE field station",
          "BR Hills--Belavatta katte,  ಬೆಲವತ್ತ ಕಟ್ಟೆ",
          "BR Hills--Boodipadaga",
          "BR Hills--Gorukana Eco Wellness Centre",
          "BR Hills--Gumballi checkpost",
          "BR Hills--Gundal Reservoir",
          "BR Hills--Hondarabalu checkpost",
          "BR Hills--Honnametti coffee estate",
          "BR Hills--IPH field station",
          "BR Hills--K-gudi Inspection Bungalow",
          "BR Hills--Keredimba Podu",
          "BR Hills--Krishnaina Katte",
          "BR Hills--PWD IB",
          "BR Hills--VGKK",
          "Badanaguppe ಬದನಗುಪ್ಪೆ",
          "Bandalli Forest",
          "Bandigere Kere, ಬಂಡಿಗೆರೆ ಕೆರೆ",
          "Bandipur -- Himavad Gopalaswamy Temple Lake",
          "Bandipur NP, ಬಂಡೀಪುರ ರಾಷ್ಟ್ರೀಯ ಉದ್ಯಾನವನ",
          "Bandipur NP--Forest Headquarters",
          "Bandipur NP--Gopalswamy Betta",
          "Bandipur NP--Mangala Village",
          "Bandipur NP--Mangala Village Road East of Mangala",
          "Bandipur NP--Mangala Village Road West of Mangala",
          "Bandipur NP--Safari campus",
          "Bandipur Safari Lodge",
          "Bedguli-Kaddigere",
          "Belachavadi Kere ಬೆಳಚವಾಡಿ ಕೆರೆ",
          "Bendaravadi Gowri Kere,  ಬೆಂಡರವಾಡಿ ಗೌರಿ ಕೆರೆ",
          "Berambadi Kere",
          "Bharachukki Falls ಭರಚುಕ್ಕಿ ಜಲಪಾತ",
          "Cauvery WLS--Bheemeshwari Fishing & Nature Camp",
          "Cauvery WLS--Gopinatham",
          "Cauvery WLS--Palar Bridge",
          "Chamarajanagara town",
          "Chikkahole Reservoir, Chamarajanagara Dt",
          "Deenabandhu Trust-Boys' Home",
          "Dhole's Den",
          "Doddarayapete Lake",
          "Dugatti Dodda kere",
          "Duggatti Chikkere, Yelandur",
          "Edahalli Doddi",
          "Garbage Dump",
          "Giridarshini Homestay, BR Hills",
          "Gopinatham Mystery Trails ಗೋಪಿನಾಥಂ ನಿಗೂಢ ಜಾಡು",
          "Gumballi Kere, Yelandur",
          "Gumballi PHC",
          "Gundlupet",
          "Guruvegowdanhundi Lake",
          "Hangala Kere",
          "Hanur",
          "Haradanahalli district forest",
          "Hiri Kere (Lake)",
          "Hirikere",
          "Hogenakkal Falls",
          "Hubbe Hunse Dam",
          "Huligana Maradi Betta, ಹುಲಿಗನ ಮರಡಿ ಬೆಟ್ಟ",
          "Irasavadi Kere ಇರಸವಾಡಿ ಕೆರೆ, Chamarajanagara ಚಾಮರಾಜನಗರ",
          "K. Gudi, B.R. Hills",
          "Kakkanahalla, Bandipura",
          "Kalkatte Reservior",
          "Kanakagiri Hilltop",
          "Kesthuru Kere",
          "Kollegal",
          "Kollegal--Agrahara Kere",
          "Kollegal--Kunagalli",
          "Kollegal--Mudigundam bridge",
          "Kollegal--Mudigundam kere",
          "Kollegal--Sathyagala bridge",
          "Kunagalli kere",
          "Kunthuru Kere",
          "Kurubana Katte Road",
          "MM Hills Ghat, Kokkuvere Village",
          "MM Hills Nature Centre",
          "MM Hills WLS- Ajjipura Safari Zone",
          "MM Hills WLS- PG Palya Safari Zone",
          "Mahadeshwara Temple",
          "Malai Mahadeshwara Wildlife Sanctuary ಮಲೆ ಮಹದೇಶ್ವರ ವನ್ಯಜೀವಿ ಧಾಮ",
          "Male Mahadeshwara Betta ಮಲೆ ಮಹದೇಶ್ವರ ಬೆಟ್ಟ",
          "Maleyur",
          "Mamballi, Chamarajanagara",
          "Morarji Desai Residential School, ಮೊರಾರ್ಜಿ ದೇಸಾಯಿ ವಸತಿ ಶಾಲೆ",
          "Mukanapalya Kere",
          "Mulluru Kere",
          "Nagavalli Kere",
          "Nalluru kere",
          "Parvathi Betta ಪಾರ್ವತಿ ಬೆಟ್ಟ",
          "Ponnachi",
          "Ramana Gudde Dam",
          "Ranganatha Lake",
          "Santemarahalli",
          "Saragur--Cauvery river bank",
          "Sargur Kere",
          "Sri Malai Mahadeshwara Temple, Malavalli",
          "Sri Veerabadhra Swamy ( Sone Veerabhadra) Betta,ಶ್ರೀ ವೀರಭದ್ರ ಸ್ವಾಮಿ ಬೆಟ್ಟ( ಸೋನೆ ವೀರಭದ್ರ)",
          "Sulakattae, Berambadi State Forest, Karnataka, IN (11.797, 76.43)",
          "Suvarnavathi Backwaters - Kulluru/ಕುಳ್ಳೂರು",
          "Teramballi",
          "Thanglittina Mallappana Betta",
          "The Serai Bandipur",
          "Tondekere",
          "Triyambakapura",
          "Udigala",
          "Uppinamole Kere, Yelanduru",
          "Vijayapura Amani Kere. Gundlupete",
          "Y K Mole",
          "Yelachatti Kere",
          "Yelandur Kere ಯಳಂದೂರು ಕೆರೆ",
          "Yelandur--Aalakere agrahara",
          "Yelandur--Bannisarige",
          "Yelandur--Vadagere",
          "Yenkana Kere, Jodemellahalli",
          "Yeragamballi channel road",
          "Yeriyuru Kere",
          "yelekere",
        ],
      },
      {
        district: "Chikkaballapura",
        localities: [
          "ATREE-Bagepalli Field Station",
          "ATREE-Chikkaballapura FS",
          "Achaganapalli",
          "Achaganapalli Hill",
          "Achaganapalli Kere",
          "Adiyogi Sadhguru Sannidhi",
          "Ajjakadirenahalli ಅಜಕಡೈರ್ನಾಹಳ್ಳಿ",
          "Amma Cheruvu Kere",
          "Ammana Kere, Sidlaghatta",
          "Ammanakere Scrub and Fields",
          "Anemadagu Scrub ಆನೆಮಡಗು ಕುರುಚಲು",
          "Anjaneya Swami Temple",
          "Anjani extension (Tank bund road)",
          "Avalabetta",
          "Baiyannagarapalli",
          "Bandahalli Scrub",
          "Bandollapalli Kere",
          "Bannigana Kere/Peresandra lake",
          "Bhairasagara Kere",
          "Bodaguru Kere",
          "Boyipalli Kere",
          "Chandur kere",
          "Chennagiri",
          "Chintopu, near Achaganapalli",
          "Chitravathi River Reservoir",
          "Chowdasandra ಚೌಡಸಂದ್ರ",
          "College of Sericulture, Chintamani",
          "Dandiganahalli Reservoir",
          "Darinaikanapalya (DN Palya) Kere",
          "Devaguttahalli Kere (ದೇವಗುಟ್ಟಹಳ್ಳಿ ಕೆರೆ)",
          "Devarabetta Reserve Forest",
          "Eagaletpalli Cheruvu",
          "Eegaletihalli Kuntte (on hillock)",
          "Ganjigunte Kere",
          "Gantal Mallamma Forest",
          "Gauribidanur--Penneru bridge",
          "Geggiralahalli Kere",
          "Gopasandra Kere,Chintamani",
          "Gudibande Fort",
          "Gudihalli Kere (ಗುಡಿಹಳ್ಳಿ ಕೆರೆ)",
          "Gudisihalli Kere",
          "Gullutummanahalli Kere",
          "Gulur Lake",
          "Guruthatha Bhavi (Achaganapalli)",
          "Handiganala,  ಹಂಡಿಗನಾಳ",
          "Haristhala Lake",
          "Hosapete (Venkatapura) Kere",
          "Itakattepalli Kere (ಇಟುಕಟ್ಟೆಪಲ್ಲಿ ಕೆರೆ)",
          "Jilarjirlu Village and surroundings",
          "Kadehalli Kere",
          "Kadumalleshwara Swamy Hill (Chintamani)",
          "Kaiwara",
          "Kaiwara Kere",
          "Kalavarahalli Betta (Skandagiri Betta)",
          "Kalkunte kere (near Ballagere)",
          "Kamat Upachar, Chikkaballapur",
          "Kambalahalli Hills ಕಂಬಾಲಹಳ್ಳಿ ಗುಡ್ಡ",
          "Kanampalli Kere",
          "Kannampalli Lake and Hillock",
          "Kethanahalli Waterfalls (ಕೇತನಹಳ್ಳಿ ಜಲಪಾತ)",
          "Kurboor Lake",
          "Lanjja Cheruvu",
          "Makireddypalli",
          "Mallahalli Pond (ಮಲ್ಲಹಳ್ಳಿ ನೀರಿನ ಕುಂಟೆ)",
          "Mallasettihalli Kere (ಮಲ್ಲಶೆಟ್ಟಿಹಳ್ಳಿ ಕೆರೆ)",
          "Malligurki Kere",
          "Manchanabele Kere (North Bangalore)",
          "Manchenahalli Kere",
          "Meruvappalli",
          "Moodachintapalli",
          "Mustoor Kere",
          "Nalamachanahalli Kere (ನಲಮಾಚನಹಳ್ಳಿ ಕೆರೆ)",
          "Nallapareddypalli Kere",
          "Nandi Hills",
          "Nandi Hills--Trail from Sultanpet village to top",
          "Nandi hills--Foothills",
          "Narasimha Devara Betta Forest--Kethabyraveshwara Temple",
          "Narasimha Devara Betta Forest--Pavandahalli",
          "Narasimha Devara Betta Forest--Sri Kanive Veeradhimmamma Temple",
          "Nilagumba Pond",
          "Papagni - Sri Durga Devi Temple",
          "Papagni Math",
          "Parikrma Oxygen",
          "Pidachalahalli Scrub",
          "Pond near Anjaneya Swami Temple, Ramapatna Rd",
          "Poolakuntahalli Kere (ಪೂಲಕುಂಟಹಳ್ಳಿ ಕೆರೆ)",
          "Sabbanahalli (Vatadahosahalli) Kere",
          "Sabbanahalli Hills",
          "Sadali Lake (ಸದಲಿ ಕೆರೆ)",
          "Setticheruvu",
          "Settikere Kere",
          "Shetahalli Lake (ಶೆಟಹಳ್ಳಿ ಕೆರೆ)",
          "Sidlaghatta town",
          "Silver Oak Farm, Sultanpet Village",
          "Soma Vineyards, Sonnenahalli",
          "Sonnapura",
          "Sree Sunkalamma Devi Temple, ಶ್ರೀ ಸುಂಕಲಮ್ಮ ದೇವಿ ದೇವಸ್ಥಾನ",
          "Srinivasa Sagara, Nallakadirenahalli",
          "Talakayila Konda Kere",
          "Thalakayala Betta (ತಲಕಾಯಲ ಬೆಟ್ಟ)",
          "Thondebhavi",
          "Timmasandra Cheruvu",
          "Tondebavi Railway Station",
          "Vaizakuru Lake, ವೈಜಕೂರು ಕೆರೆ",
          "Varlabetta Fort,Varlakonda",
          "Venkatapura Ridge",
          "Yadaralahalli Kere",
          "Yerramaranahalli to Avalabetta Forest Road",
          "ದಿಣ್ಣೆಹೊಸಹಳ್ಳಿ ಕೆರೆ  (Dinnehosahalli Lake)",
        ],
      },
      {
        district: "Chikkamagaluru",
        localities: [
          "Allampura, ಅಲ್ಲಂಪುರ",
          "Arabica Valley Homestay",
          "Ayyana Kere",
          "Bababudan Giri Peak",
          "Bababudan Hills--Kemmanagundi",
          "Bababudan Hills--Lingdahalli Kemmanagundi Road",
          "Bababudan Hills--overall hotspot",
          "Bababudangiri Road",
          "Balehalli Kere, ಬಾಳೆಹಳ್ಳಿ ಕೆರೆ",
          "Balehonnur",
          "Balur Estate (Linger)",
          "Balur Estate- Coffee Heritage Homestay (ಬಾಳೂರು ಎಸ್ಟೇಟ್ ಕಾಫೀ ಪರಂಪರೆ ತಂಗುದಾಣ)",
          "Basur Kaval",
          "Bettagudda Retreat, Mularahalli",
          "Bhadra Backwater, ಭದ್ರ ಹಿನ್ನೀರು",
          "Bhadra Backwaters- Menasuru Bridge",
          "Bhadra Buffer & Backwaters, Saluru, Narasimharajapura",
          "Bhadra Reservoir",
          "Bhadra River, Kudremukh NP",
          "Bhadra Tiger Reserve - Muthodi Safari Zone, ಭದ್ರಾ ಹುಲಿ ಸಂರಕ್ಷಿತ ಪ್ರದೇಶ - ಮುತ್ತೋಡಿ  ಸಫಾರಿ ವಲಯ",
          "Bhadra Wildlife Sanctuary",
          "Bhadra Wildlife Sanctuary ಭದ್ರಾ ಅಭಯಾರಣ್ಯ -Muthodi ಮುತ್ತೋಡಿ",
          "Bhadra Wildlife Sanctuary--Lakkavalli",
          "Bhadra Wildlife Sanctuary--Lakkavalli Forest Area",
          "Bhadra Wildlife Santuary",
          "Bidare Kere",
          "Bowline Nature Stay, Moolarahalli",
          "Charmadi Ghat",
          "Chikkamagaluru--GOPALA COLONY",
          "Chikmagalur",
          "Chikmagalur Golf Club",
          "Coffee Gudda Estate",
          "Coffee Valley Homestay",
          "Dantaramakki Kere, ದಂಟರಮಕ್ಕಿ ಕೆರೆ",
          "Datthapeetha- Bababudan Giri",
          "Divine Homestay",
          "Durgadahalli",
          "Ettina Bhuja",
          "Farmlands, Kedigere - ತ್ಯಾವರ ಹೊಲಗಳು, ಕೇದಿಗೆರೆ",
          "Flameback Lodges",
          "Foothills Homestay Coffee Estate",
          "Forest Homestay - Maradi",
          "Forested India",
          "Gaaligandi Village",
          "Galikere,  ಗಾಳಿಕೆರೆ",
          "Ganganahalli Cross",
          "Ganganahalli Kere",
          "Giri Elite Homestay",
          "Gokatte- Allampura,  ಗೋಕಟ್ಟೆ- ಅಲ್ಲಂಪುರ",
          "Goudakatte, Allampura  ಗೌಡಕಟ್ಟೆ, ಅಲ್ಲಂಪುರ",
          "Gowdahalli Forest",
          "Halelakya",
          "Hireammajji Kere, Narasimharajapura",
          "Hirekolale Kere",
          "Horanadu",
          "Hulikhan Estate",
          "Inam Datthapeeta to Galikere,   ಇನಾಂ ದತ್ತ ಪೀಠ - ಗಾಳಿಕೆರೆ",
          "Jammatige",
          "Kambaragodu Homestay",
          "Kambihalli Estate (Halli Berri)",
          "Kartikeya Coffee Plantations",
          "Kedigere",
          "Kedigere  kere, ಕೆದೀಗೆರೆ ಕೆರೆ",
          "Kedigere-Basur Road, ಕೇದಿಗೆರೆ-ಬಾಸೂರು ರಸ್ತೆ",
          "Kemmangundi Road",
          "Kere Eri Lake (Magadi Lake)",
          "Keremane Homestay",
          "Kesave, Koppa",
          "Konana Katte, Basur Kaval ,ಕೋಣನ ಕಟ್ಟೆ, ಬಾಸೂರು ಕಾವಲು",
          "Koove",
          "Kote kere",
          "Kottigehara ಕೊಟ್ಟಿಗೆಹಾರ",
          "Kudremukh Peak Trek APC",
          "Kudremukha NP--Bhagavathi Nature Camp",
          "Kudremukha NP--Gangadikal Peak",
          "Kudremukha NP--General Area",
          "Kudremukha NP--KIOCL Township",
          "Kudremukha NP--Peak and thereabouts",
          "Kudremukha National Park",
          "Kuduremukha range-Kurinjal Peak",
          "Kuteera Home Stay",
          "Kuvempu University Shravan",
          "Lakya Dam and Surroundings",
          "Madagada Kere",
          "Malligehani Estate",
          "Malligere Kere, ಮಲ್ಲಿಗೆರೆ ಕೆರೆ",
          "Mandagadde Bird Sanctuary, Shimoga, Karnataka",
          "Mullayangiri",
          "Mullodi Home Stay",
          "Nalluru Kere",
          "Nanya Bhairaweshwara Temple, Bhairapura",
          "Narasimharajapura - Bhadra WLS",
          "Pandaravalli",
          "Primrose Villas",
          "Rain Tree Homestay",
          "Ranganabetta",
          "Rani Jhari Viewpoint, Bandaje Waterfalls",
          "River Tern Lodge",
          "Rivermist Resorts, Madugundi, ರಿವರ್ಮಿಸ್ಟ ರೆಸಾರ್ಟ್",
          "Sampigekatte-Haluvalli (Kalasa-Balehonnuru Rd)",
          "Shanthi kunnj Homestay",
          "Shanubhoganahalli, Ajjampura- ಶಾನುಬೋಗಹನಹಳ್ಳಿ, ಅಜ್ಜ೦ಪುರ",
          "Shola Heights,Baamikonda",
          "Silent Valley Resort, Kuduremukha",
          "Sitalayyanagiri Temple",
          "Sringeri",
          "St Mary's ISC",
          "St Mary's PU College",
          "Suvarnavana (Tree park), Narasimharajapura",
          "Tea Estate Samse",
          "The Great Escafe",
          "The Mellows Homestay",
          "The Serai Chikmagalur",
          "Thotadahalli Estate",
          "Tigerwoods Homestay",
          "Trivik Hotels and Resorts",
          "Urvinkaan Estate",
          "Valley of Birds Homestay",
          "Vatakodige, Balehonnuru,",
          "Vismita County",
          "Weekender Homestay",
          "Z Point Path",
          "ನಿರುತ್ತರ, ಮೂಡಿಗೆರೆ",
        ],
      },
      {
        district: "Chitradurga",
        localities: [
          "Aimangala Scrubland ಐಮಂಗಲ ಕುರುಚಲು",
          "Belaguru Kere",
          "Beliyakal Ranganatha Swamy Temple, Belagur",
          "Challakere grasslands",
          "Chandravalli,",
          "Chitradurga Fort,   ಚಿತ್ರದುರ್ಗ ಕೋಟೆ",
          "Chitradurga Pond",
          "Gavi Ranganatha Swami Hillock",
          "Gayathri Jalashaya",
          "Gonur Kere",
          "Government Science College (GSC)",
          "Gulialu",
          "Halekallahalli Kere",
          "Holalkere Lake",
          "IISc TDC Challakere",
          "Indian Institute of Science, Challakere",
          "Ingaladal  ಇಂಗಲಧಲ",
          "Jogimatti Forest--Forest Guest House",
          "Jogimatti Wildlife Sanctuary ಜೋಗಿಮಟ್ಟಿ ವನ್ಯಧಾಮ",
          "Katral lake",
          "Kudurekanive Reserve Forest",
          "Mallapura Lake",
          "Muttigarahalli",
          "Nagaramgere Lake",
          "Sangenahalli Lake",
          "Shivaganga Lake",
          "Sri Veerapratapa Anjaneya temple, Belaguru",
          "Vani Vilasa Sagara Dam (Marikanive dam)",
        ],
      },
      {
        district: "Dakshina Kannada",
        localities: [
          "Aadi Subramannya, ಆದಿ ಸುಬ್ರಮಣ್ಯ",
          "Addu, Mangaluru",
          "Adyapady Forests",
          "Adyar, Mangalore",
          "Ajjisana Area",
          "Alva's Bird Park",
          "Alva's Institute of Engineering and Technology",
          "Alva's Institute of Engineering and Technology--Naturapathy Treatment Centre",
          "Alvas College For Graduate And Post Graduation",
          "Aruvalu",
          "Balnadu, Puttur",
          "Beeramale Hill",
          "Beluvai",
          "Bengre, Mangalore",
          "Biladwara, Subramanya",
          "Boremaru, bantwal",
          "Borugudde",
          "Car Street",
          "Chelairu Wetlands",
          "Chitrapu Estuary, Mulki",
          "Govinda Dasa Degree College",
          "Gundya Forest I.B",
          "Gundya Nature Camp",
          "Gurupur River, Mangalore",
          "Gurupura Kaikamba Electric Sub-station, Kandavara, Mangalore",
          "Guruvayana Kere",
          "Guruvayanakere, ಗುರುವಾಯನಕೆರೆ",
          "Hosabettu Beach area, Suratkal",
          "Hosabettu Beach junction, suratkal",
          "Infosys Mangalore",
          "JLR Phalguni River Lodge",
          "Jokatte",
          "K S Hegde Academy",
          "Kadalakere, moodabidre",
          "Kadri park spot #2, Mangalore",
          "Kanaka Majalu, Puttur",
          "Kandrappady",
          "Kanyana, Hebri",
          "Karinjeshwara temple area, bantwala",
          "Kateelu and surroundings",
          "Kavoor Wetlands (Kunjathbail)",
          "Kelanjimale, Vittal",
          "Kenjar Wetlands, Mangalore",
          "Koila, Uppinangadi",
          "Kolambe",
          "Kolambe, Bajpe area",
          "Kollamogaru, Subramanya",
          "Kolli View Point, Belthangady",
          "Kongur Mutt Area, Mangalore",
          "Kottara",
          "Kudremukha NP--Yelneeru Waterfall",
          "Kulai Thokur Inner Road",
          "Kulshekar chowki",
          "Kumaraparvatha - ಕುಮಾರಪರ್ವತ",
          "Maidaadi Hills",
          "Manchi, Mangalore",
          "Mangalore Institute of Technology and Engineering (MITE) College Campus, Mijar",
          "Mangalore Railway station",
          "Mangalore University quarters area 1, Mangaluru",
          "Mangalore University--Admin Forest",
          "Mangalore University--Administrative Block Forest",
          "Mangalore University--Arboretum",
          "Mangalore University--BCM Hostel",
          "Mangalore University--Botanical Garden",
          "Mangalore University--Boys Hostel",
          "Mangalore University--Boys Hostel Forest",
          "Mangalore University--Forest behind Library",
          "Mangalore University--Journalism Block",
          "Mangalore University--Kallugundi",
          "Mangalore University--Konaje End",
          "Mangalore University--MUEC co-op society",
          "Mangalore University--Main Campus",
          "Mangalore University--Mangalore to Mudipu Road",
          "Mangalore University--Zoology Block",
          "Mangalore--General Area (OBI)",
          "Mangaluru Port",
          "Mangaluru--PVS Circle",
          "Manjalpaade, Mangalore",
          "Moodambailu school, vitla",
          "Mudipu",
          "Mudipu Ira Road, Mangaluru",
          "Munchur Wetlands, Surathkal",
          "NITTE University--New Campus",
          "NITTE University--Paneer Campus",
          "National Institute of Technology (NITK), Surathkal",
          "Navuru Forest IB",
          "Navuru trekking path",
          "Netravathi river bridge area",
          "Nettana Forest Depot",
          "Nitte Institute of Professional Education",
          "Off the Mangalore Coast",
          "Old Mangalore Port (Dakke)",
          "Old Port Road, Bunder",
          "Padenkallu Surroundings",
          "Padushedde Road",
          "Padushedde Wetlands, Mangalore",
          "Paduvannur,",
          "Pallakere Wetlands",
          "Panjikallu",
          "Pathaje",
          "Pavanje River Left Bank, Pavanje",
          "Pelagic HotSpot, Arabian Sea, IN (12.90, 74.65)",
          "Pelagic HotSpot, Mangalore , Arabian Sea: 12.8N 74.5E",
          "Pelagic HotSpot, Mangalore , Arabian Sea: 12.8N 74.6E",
          "Pelagic HotSpot, Mangalore , Arabian Sea: 12.8N 74.7E",
          "Pelagic HotSpot, Mangalore , Arabian Sea: 12.9N 74.4E",
          "Pelagic HotSpot, Mangalore , Arabian Sea: 12.9N 74.5E",
          "Pelagic HotSpot, Mangalore , Arabian Sea: 12.9N 74.6E",
          "Pelagic HotSpot, Mangalore , Arabian Sea: 12.9N 74.7E",
          "Pelagic HotSpot, Mangalore , Arabian Sea: 12.9N 74.8E",
          "Pelagic HotSpot, Mangalore , IN (12.85, 74.71)",
          "Pelagic HotSpot, Mangalore , IN (12.85, 74.79)",
          "Pelagic HotSpot, Mangalore Offshore, Arabian Sea - 12.77N x 74.75",
          "Pelagic HotSpot, Mangalore Offshore, Arabian Sea - 12.96N x 74.50",
          "Pelagic HotSpot, Mangalore, Arabian Sea: 12.6N 74.4E",
          "Pelagic HotSpot, Mangalore, Arabian Sea: 12.7N 74.5E",
          "Pelagic HotSpot, Mangalore, Arabian Sea: 12.7N 74.6E",
          "Pelagic HotSpot, Mangalore, Arabian Sea: 12.8N 74.8E",
          "Pelagic HotSpot, Mangalore, Arabian Sea: 12.9-74.6",
          "Pelagic HotSpot, Mangalore, Arabian Sea: 12.9-74.7",
          "Pelagic HotSpot, Mangalore, Arabian Sea: 12.9N 74.5E",
          "Pelagic HotSpot, Mangalore, Arabian Sea: 12.9N 74.6E",
          "Pelagic HotSpot, Mangalore, Arabian Sea: 12.9N 74.7E",
          "Pelagic HotSpot, Mangalore, Arabian Sea: 13.0N 74.5E",
          "Pelagic HotSpot, Mangalore, Arabian Sea: 13.0N 74.6E",
          "Pelagic HotSpot, Mangalore, IN: 12.8-74.4",
          "Pelagic HotSpot, Mangalore, In: 12.9-74.5",
          "Permude, Mangalore, Karnataka",
          "Pilikula Arboretum",
          "Pilikula Nisarga Dhama",
          "Polali--Tankaulipady, Mangalore",
          "Punjalkatte",
          "Sammilan Shetty's Butterfly Park, Belvai - 13.124x74.994",
          "Sasihithlu Vehicle Parking Lot",
          "Sasihitlu -- Beach and Estuary",
          "Savanalu, Belthangady",
          "Shishileshwara Temple, Shishila.",
          "Sholakili Spot",
          "Someshwara Ullal beach, Mangaluru",
          "Soorinje",
          "Sri Chowdeswari Temple and Surroundings",
          "Sri Venkataramana Swami College",
          "Srinivas Institute of Technology, Valachil",
          "St Agnes College (Autonomous) Mangalore",
          "St Aloysius College, Mangalore",
          "St Aloysius Institute of Management and Information Technology (AMIT)",
          "St. Joseph Engineering College (Restricted Access)",
          "Stream of Joy Homestay, Arasinamakki",
          "Surathkal Beach",
          "Taanirbavi, mangalore",
          "Tagore Park, Mangaluru, Karnataka, IN (12.872, 74.844)",
          "Taj Mahal Cafe",
          "Tannirbavi Beach",
          "Thokur Wetland, Mangaluru",
          "Ucchila transient estuary, Mangalore",
          "Uppukallu Viewpoint",
          "Vivekananda College Campus, Puttur",
          "Yedapadavu, mangalore",
          "Yekkar",
          "Yenepoya Ayurveda College",
          "Yenepoya Institute of Arts, Science, Commerce & Management, Yiascm Kulur Campus (12.92, 74.829)",
          "Yenepoya Medical & Dental College Campus",
          "Zoology Dept, Mangalore University",
          "kannadikatte",
          "sampaje-urubail road",
          "uruvalu, uppinandgadi",
          "~18 km off the coast of Mangaluru (OBI)",
        ],
      },
      {
        district: "Davanagere",
        localities: [
          "Anagodu Forest",
          "Anagodu Park",
          "Anaji Lake",
          "Avaragere kere, ಅವರಗೆರೆ ಕೆರೆ",
          "Bathi Kere, Harihara Road",
          "Bheemeshwar Temple",
          "Bukkambudhi Kere -Bukkaraya Kere (Karkikere)",
          "Davangere University",
          "Devarabelakere",
          "Forest guest house, Rangaiahnadurga Kondukuri Wildlife Sanctuary",
          "Hadadi kere ಹದಡಿ ಕೆರೆ",
          "Hallikere Lake",
          "Harihar--Tungabhadra bridge",
          "Hire Keri Lake (Harapanahalli)",
          "Hire Kogalur Lake",
          "Hiremegalagere Lake",
          "Holesirigere kere",
          "Kalkere",
          "Kalleshwara Temple ( Ancient)",
          "Kalleshwara Temple,Bagali",
          "Kamalapura Kere",
          "Kariganuru",
          "Kelagote, Jagalur",
          "Kondajji Kere",
          "Kondajji Kere ಕೊಂಡಜ್ಜಿ ಕೆರೆ",
          "Kondukuri Wildlife sanctury, Jagaluru, Davangere",
          "Kunduwada Lake",
          "Nitturu, ನಿಟ್ಟೂರು",
          "Rangaiahnadurga Kondukuri (Four Horned Antelope) Wildlife Sanctuary",
          "SOOLEKERE (SHANTHI SAGARA)",
          "Savalanga Kere (Lake)",
          "Shree Theertha Rameshwara Betta",
          "Siddiveerappa Badavane",
          "Small Arecanut Plantaion near Yakkegondi Village",
        ],
      },
      {
        district: "Dharwad",
        localities: [
          "APMC Hubblli ಎ.ಪಿ.ಎಂ.ಸಿ. ಹುಬ್ಬಳ್ಳಿ",
          "Bhagwat's Home",
          "Chinnadakere Pond ಚಿನ್ನದಕೆರೆ ಕೊಳ",
          "Devara Hubballi Kere ದೇವರ ಹುಬ್ಬಳ್ಳಿ ಕೆರೆ",
          "Devaragudihal Kere ದೇವರಗುಡಿಹಾಳ್‌ ಕೆರೆ",
          "Dharwad Railway Station",
          "Dori Kere, ದೋರಿ ಕೆರೆ",
          "Eco Village, Haliyal Road ಇಕೋ ವಿಲೇಜ್‌, ಹಳಿಯಾಳ ರಸ್ತೆ",
          "Gamanagatti Ind Estate, Hubballi ಗಾಮನಗಟ್ಟಿ ಕೈಗಾರಿಕಾ ಎಸ್ಟೇಟ್, ಹುಬ್ಬಳ್ಳಿ",
          "Hemans Farm, Mandihal",
          "Heman’s Farm",
          "Herekeri Tank",
          "Honnapura Kere ಹೊನ್ನಾಪುರ ಕೆರೆ",
          "Hubballi Airport, ಹುಬ್ಬಳ್ಳಿ ವಿಮಾನ ನಿಲ್ದಾಣ",
          "IIT Dharwad ಐಐಟಿ ಧಾರವಾಡ",
          "Indian Institute of Technology, Dharwad",
          "JSS Campus ಜೆಎಸ್‌ಎಸ್ ಕ್ಯಾಂಪಸ್",
          "Jayanagara Kere",
          "Joga Yellapur Hillocks",
          "Junjanbail Kere ಜುಂಜನಬೈಲ್ ಕೆರೆ",
          "Kalakeri ಕಲಕೇರಿ",
          "Kalkeri Forest ಕಲಕೇರಿ ಅರಣ್ಯ",
          "Karnataka College (KCD) ಕರ್ನಾಟಕ ಕಾಲೇಜ್‌ (ಕೆಸಿಡಿ)",
          "Karnataka Forest Academy, Gungaragatti ಕರ್ನಾಟಕ ಅರಣ್ಯ ಅಕಾಡೆಮಿ, ಗುಂಗರಗಟ್ಟಿ",
          "Karnataka State Forest Academy, Gungargatti ಕರ್ನಾಟಕ ರಾಜ್ಯ ಅರಣ್ಯ ಅಕಾಡೆಮಿ, ಗುಂಗರಗಟ್ಟಿ",
          "Karnataka University ಕರ್ನಾಟಕ ವಿಶ್ವವಿದ್ಯಾಲಯ",
          "Kelgeri Kere ಕೆಲಗೇರಿ ಕೆರೆ",
          "Kudalagi Kere ಕುಡಲಗಿ ಕೆರೆ",
          "Lakamanahalli Fields--Navaloor Side",
          "Mavinakoppa Lake",
          "Mayur colony (Morey Layout)",
          "Mugad Kere  ಮುಗದ ಕೆರೆ",
          "Mugad, ಮುಗದ",
          "Narendra Kere ನರೇಂದ್ರ ಕೆರೆ",
          "Navaloor Kere ನವಲೂರು ಕೆರೆ",
          "Navaloor ನವಲೂರು",
          "Naveen Park ನವೀನ್‌ ಪಾರ್ಕ್‌",
          "Navloor Somapur Road",
          "Neera Sagar Reservoir ನೀರಸಾಗರ ಜಲಾಶಯ",
          "Nigadi Kere ನಿಗದಿ ಕೆರೆ",
          "Nrupatunga Betta  ನೃಪತುಂಗ ಬೆಟ್ಟ",
          "Nuggikeri Hillock",
          "Nuggikeri Kere ನುಗ್ಗಿಕೇರಿ ಕೆರೆ",
          "SK Arts & Kotambri Colleges, Hubballi  ಎಸ್.ಕೆ. ಆರ್ಟ್ಸ್‌ ಮತ್ತು ಕೋತಂಬ್ರಿ ಕಾಲೇಜುಗಳು, ಹುಬ್ಬಳ್ಳಿ",
          "Sadhanakeri Lake",
          "Salakainakoppa Lake",
          "Salumarada Timmakka Nagara Vana",
          "Shaneshwara Temple Kere ಶನೇಶ್ವರ ದೇವಸ್ಥಾನದ ಕೆರೆ",
          "Shanti Nagar Mission Compound",
          "Somanakoppa ಸೋಮನಕೊಪ್ಪ",
          "Someshwar Kere ಸೋಮೇಶ್ವರ ಕೆರೆ",
          "Tolankere ತೋಳನಕೆರೆ",
          "University of Agricultural Sciences  ಕೃಷಿ ವಿಜ್ಞಾನ ವಿಶ್ವವಿದ್ಯಾಲಯ",
          "Unkal Kere ಉಣಕಲ್‌ ಕೆರೆ",
        ],
      },
      {
        district: "Gadag",
        localities: [
          "Akkigund Tanda Forest Area ಅಕ್ಕಿಗುಂದ ತಾಂಡಾ ಅರಣ್ಯ ಪ್ರದೇಶ",
          "Bhishma Kere ಭೀಷ್ಮ ಕೆರೆ",
          "Binkadakatti Zoo ಬಿಂಕದಕಟ್ಟಿ ಮೃಗಾಲಯ",
          "JT College Campus Gadag",
          "Khanapur ಖಾನಾಪುರ",
          "Laxmeshwar ಲಕ್ಷ್ಮೇಶ್ವರ",
          "Magadi Bird Sanctuary ಮಾಗಡಿ ಪಕ್ಷಿಧಾಮ",
          "Mulgund ಮುಳಗುಂದ",
          "Shettikeri Kere ಶೆಟ್ಟಿಕೇರಿ ಕೆರೆ",
          "Singatalur Dam, Hammigi ಸಿಂಗಟಾಲೂರು ಜಲಾಶಯ, ಹಮ್ಮಿಗಿ",
        ],
      },
      {
        district: "Hassan",
        localities: [
          "Adaravalli",
          "Arsikere Lake",
          "Attihalli",
          "Balaganchi Doddakere",
          "Bedaiganahalli/Seebahalli Kere",
          "Bediganahalli Kere",
          "Bisle Ghat Checkpost",
          "Bylahalli Kere",
          "Changadihalli kere",
          "Channapura Ranganbetta Road",
          "Channarayapatttana kere",
          "Chigaluru Kere (Lake)",
          "Chikka Anekere,",
          "Coffee nasu",
          "Daivi Vana",
          "Dindaguru Kere",
          "Forest Patch, Bugadalli",
          "Gangoor, Ramnathpura, Hassan",
          "Gendekatte forest",
          "Hale Mane Homestay",
          "Harley Estate, ಹಾರ್ಲೆ ಎಸ್ಟೇಟ್",
          "Hemavathi Backwaters- Nagavara",
          "Hemavathi Backwaters- Ulivala",
          "Hemavathi Backwaters-Shettihalli",
          "Hemavathi Reservoir ಹೇಮಾವತಿ ಜಲಾಶಯ  Gorur ಗೋರೂರು",
          "Hemavathi backwater-Madihalli",
          "Hosakere, Changadahalli",
          "Hosamane Colony, Sakleshpur",
          "Hosur Estate-Sakaleshpura",
          "Hoysala Village Resort",
          "Hoysaleshwara Temple",
          "Hulugundi",
          "Hunasina Kere",
          "Isiri Coffee, Maragadi, Karnataka",
          "Jambur Amanikere",
          "Janivara Kere",
          "Kaanana Home Stay",
          "Kadumane Estate--General Area",
          "Kadumane Estate--KT and KDM",
          "Kadumane Estate--MH",
          "Kadumane Estate--Near Entrance (includes canteen, factory, Sinna Dorai Bungalow)",
          "Kadumane Estate--VG (including VG-MG Road and Doraigundi)",
          "Kirkatte Kere, Jambur",
          "Kodanahalli",
          "Kottaragandi Kaadu, Kiruhunse",
          "Kumbarahalli - Sakleshpur",
          "Linger, Camrose, Sakleshpura",
          "Linger, Varshini Estate",
          "Lotus Pond (Sakleshpur-Hassan Road)",
          "Maharaja Park, Hassan",
          "Manjarabad Fort",
          "Mugilu Homestay",
          "Mulugade Pradesha (Submerged Area), Magalu",
          "Nagapuri Forest",
          "Navilahalli",
          "Neervana Resort, Sakleshpura",
          "Neharu Nagara circle area,Belur",
          "Nidanur Kere",
          "Patla Betta Trek",
          "Rachenahalli Kere",
          "Rosetta Resorts, Belluru",
          "Rudrapatna",
          "Sakleshpur",
          "Sakleshpura",
          "Sakleshpura Railway Station",
          "Shanthrigama Kere",
          "Shravanabelagola Temple",
          "Somapura Kere-Doddakanagal Road",
          "Thavarekere, Near Jambur",
          "The Karle Homestay",
          "Thotada Goodu Homestay, Sakleshpur",
          "Vajarahalli",
          "Vishnu Samudra (Bistammana Kere)",
          "Vishnu Samudra Kere",
          "Yagachi Dam",
          "Yagachi Reservoir, Belur",
          "stakeout White-bellied Woodpecker, Agalatti Rd (2025-12)",
        ],
      },
      {
        district: "Haveri",
        localities: [
          "Adavisomapur Kere ಅಡವಿಸೋಮಾಪುರ ಕೆರೆ",
          "Airani Fort, Hirebidari ಐರಣಿ ಕೋಟೆ, ಹಿರೇಬಿದರಿ",
          "Anekere, Hangal ಆನೆಕೆರೆ, ಹಾನಗಲ್",
          "Bankapur Peacock Sanctuary ಬಂಕಾಪುರ ನವಿಲುಧಾಮ",
          "Bankapura Peacock Sanctuary",
          "Durgadevi Kere ದುರ್ಗಾದೇವಿ ಕೆರೆ",
          "Galageshwara Temple, Galaganath ಗಳಗೇಶ್ವರ ದೇವಸ್ಥಾನ, ಗಳಗನಾಥ",
          "Gangajala Kere, Ranebennur ಗಂಗಾಜಲ ಕೆರೆ, ರಾಣೆಬೆನ್ನೂರು",
          "Heggeri Kere  ಹೆಗ್ಗೇರಿ ಕೆರೆ",
          "Kaginele Kere ಕಾಗಿನೆಲೆ ಕೆರೆ",
          "Kudrihal Lake ಕುದ್ರಿಹಾಳ ಕೆರೆ",
          "Mukteshwara Temple, Chaudayyanapura ಮುಕ್ತೇಶ್ವರ ದೇವಸ್ಥಾನ, ಚೌಡಯ್ಯನಪುರ",
          "Ranebennur Blackbuck Sanctuary ರಾಣಿಬೆನ್ನೂರು ಕೃಷ್ಣಮೃಗ ಅಭಯಾರಣ್ಯ",
          "Ranebennur Blackbuck Sanctuary--Medleri Kere ರಾಣಿಬೆನ್ನೂರು ಕೃಷ್ಣಮೃಗ ಅಭಯಾರಣ್ಯ--ಮೆಡ್ಲೇರಿ ಕೆರೆ",
          "Salu Marada Thimmakka Nature Park",
          "Savanur Kere ಸವಣೂರ ಕೆರೆ",
          "Someshwara Temple, Haralahalli ಸೋಮೇಶ್ವರ ದೇವಸ್ಥಾನ, ಹರಲಹಳ್ಳಿ",
          "Tadas ತಡಸ",
          "Timmarpur Kere ತಿಮ್ಮಾಪುರ ಕೆರೆ",
          "Tungabhadra River Bridge ತುಂಗಭದ್ರಾ ನದಿ ಸೇತುವೆ NH48, Harihar",
          "Varada River--Hosaritti ವರದಾ ನದಿ--ಹೊಸರಿತ್ತಿ",
        ],
      },
      {
        district: "Kalaburagi",
        localities: [
          "Appana Kere, Kalaburagi ಅಪ್ಪನ ಕೆರೆ, ಕಲಬುರಗಿ",
          "Belakota Kere ಬೆಳಕೋಟ ಕೆರೆ",
          "Bennethora Reservoir -- Nagoora",
          "Bennethora Reservoir--Harsur-Sathkhed  ಬೆಣ್ಣೆತೊರಾ ಜಲಾಶಯ--ಹರಸೂರು-ಸಾತ್‌ಖೇಡ್",
          "Bennethora Reservoir--Yankanchi ಬೆಣ್ಣೆತೊರಾ ಜಲಾಶಯ--ಯಂಕಂಚಿ",
          "Bheema River--Sannati Bridge ಭೀಮಾ ನದಿ--ಸನ್ನತಿ ಸೇತುವೆ",
          "Bhosga Kere ಭೋಸ್ಗಾ ಕೆರೆ",
          "Buddha Vihar ಬುದ್ಧ ವಿಹಾರ",
          "Central University of Karnataka ಕರ್ನಾಟಕ ಕೇಂದ್ರೀಯ ವಿಶ್ವವಿದ್ಯಾಲಯ",
          "Chandapur ಚಂದಾಪುರ",
          "Chandrampalli Dam ಚಂದ್ರಂಪಳ್ಳಿ ಜಲಾಶಯ",
          "Chincholi Wildlife Sanctaury Area",
          "Chincholi Wildlife Sanctuary--Gottamgotta ಚಿಂಚೋಳಿ ವನ್ಯಜೀವಿಧಾಮ--ಗೊಟ್ಟಂಗೊಟ್ಟ",
          "Chincholi ಚಿಂಚೋಳಿ",
          "Gangapura ಗಾಣಗಾಪುರ",
          "Gulbarga Fort ಗುಲ್ಬರ್ಗಾ ಕೋಟೆ",
          "Gulbarga University ಗುಲಬರ್ಗಾ ವಿಶ್ವವಿದ್ಯಾಲಯ",
          "Kagina River Bridge, Dandoti ಕಾಗಿಣಾ ನದಿ ಸೇತುವೆ, ದಂಡೋತಿ",
          "Khaja Kotnoor Lake ಖಾಜಾ ಕೊಟ್ನೂರು ಕೆರೆ",
          "Ladlapur ಲಾಡ್ಲಾಪುರ",
          "Lower Mullamari Reservoir ಮುಲ್ಲಾಮಾರಿ ಕೆಳದಂಡೆ ಜಲಾಶಯ",
          "Narona Tanda No 1",
          "Nimbarga ನಿಂಬರ್ಗಾ",
          "Nirchalma ನಿರ್ಚಲ್ಮಾ",
          "Rajapur Road--Koranti Hanuman Temple ರಾಜಾಪುರ ರಸ್ತೆ--ಕೋರಂಟಿ ಹನುಮಾನ್‌ ದೇವಸ್ಥಾನ",
          "Sangama (Bhima-Amarja Sangama), Ganagapura,",
          "Uplaon Tree Park",
          "Vaijapur Lake, ವೈಜಾಪುರ್ ಕೆರೆ",
          "Wadi ವಾಡಿ",
        ],
      },
      {
        district: "Kodagu",
        localities: [
          "Abbey (Abbi) Falls",
          "Aloka  Homestay",
          "Amanvana Spa Resort",
          "Anantara Zanti Resort & Spa",
          "Anekad Forest,Herur",
          "Anekad Forest- Athuru Grama",
          "Anekad Forest- Panchalingeshwara Temple",
          "Badagarakeri, ಬಡಗರಕೇರಿ",
          "Begur to Ayyappan Kavu watch tower trek",
          "Belur Golf Club, Somwarpet, Kodagu (Coorg)",
          "Bhadrakali Temple, Galibeedu",
          "Bird Song (Coorg Nature Retreat)",
          "Birunani--Barapole River Eastern Bridge",
          "Birunani--Marenad High School & Surrounds",
          "Bison Manor Country Retreat",
          "Blue Ridge Cottage",
          "Brahmagiri WLS - Makkutta",
          "Brahmagiri WLS Peak",
          "Cauvery Resort",
          "Chiklihole Reservoir",
          "Chingaara - Honey Valley's Estate House",
          "Club Mahindra Resort, Virajpet",
          "Club Mahindra, Coorg",
          "College of Forestry, Ponnampet",
          "Coorg Cliffs Resort",
          "Coorg Hills Resort",
          "Coorg Marriott Resort and Spa",
          "Coorg Raga - Nature Preserve",
          "Coorg Wild Walk- CGH Earth Saha",
          "Coorg Wilderness Resort",
          "Devara Kolli, Sampaje",
          "Doddaththur, Kodagu Dt",
          "Dream Acres",
          "Dubare Elephant Camp",
          "Ela Glamping",
          "Elephant Corridor Homestay",
          "Forest near FMC Ground",
          "Forestdale,Chembebellore",
          "Galibeedu",
          "Gateway Coorg",
          "Gonikoppal",
          "Green Pastures, Somawarpet",
          "Gudloor",
          "Harangi Backwaters- Yedavare",
          "Harangi Dam",
          "Harangi Elephant Camp & Tree Park",
          "Harangi backwaters--Herur",
          "Hathur Government Primary School",
          "Heggala",
          "Hemavathi Backwaters- Umblibetta",
          "Heroor Estate",
          "Hilldale Resort",
          "Honey Valley Estate ಹನಿವ್ಯಾಲಿ ಎಸ್ಟೇಟ್‌, ಕೊಡಗು",
          "Hornbills Nest, Parvathi Valley Estates",
          "Hotel Mayura Valley View",
          "Ibbani Kadu Estate",
          "Institute of Wildlife Veterinary Research",
          "Iruppu waterfall ಇರುಪ್ಪು ಜಲಪಾತ",
          "Jungle Mount Adventures",
          "Kabbe Hills",
          "Kadagadal",
          "Kadama kolli, ಕಡಮಕೊಳ್ಳಿ",
          "Kallehebballa beat Antrasantnthe",
          "Kannanda Bane",
          "Karada Village",
          "Kaveri Bridge, Hebbale-Sulekote Road",
          "Kaveri Nisargadhama",
          "Kaveri Nisargadhama--Birdpark",
          "Kirgoor",
          "Kodagu's Cuckoo Field Station",
          "Kodagu's Cuckoo field station",
          "Kote Abbe Falls",
          "Kote Betta",
          "Kote Kadu Resort",
          "Kotebetta",
          "Kunjalageri",
          "Kushalnagar--General Area (OBI)",
          "Kutta--General Area (OBI)",
          "Lakshmana Teertha Bridge (Balele-Nittur)",
          "Linger, Chettimani",
          "Luckunda Estate,Thaila",
          "Machaan Lodge",
          "Machaan Wilderness Lodge, Nagarhole",
          "Madapura",
          "Madikeri East Reserve Forest",
          "Madikeri Misty, Coorg",
          "Madikeri, Coorg",
          "Madikeri--General Area (OBI)",
          "Maggula ಮಗ್ಗುಲ, Virajpete ವೀರಾಜಪೇಟೆ",
          "Magnolia Estates & Resort",
          "Magnolia Mist",
          "Makkala Gudi Betta",
          "Maldare Bus Stop",
          "Mallalli waterfall trail",
          "Mallur Kere, ಮಲ್ಲೂರು ಕೆರೆ",
          "Mandalpatti",
          "Misty Woods Resort",
          "Mojo Plantation Rainforest Retreat",
          "Monnengeri",
          "Monstrose Golf Resort and Spa",
          "Mountwood Nature Stay, Tadiandamol",
          "Murudeshwara Temple",
          "Nagarahole (Murkal)",
          "Nagarahole NP ನಾಗರಹೊಳೆ ರಾಷ್ಟ್ರೀಯ ಉದ್ಯಾನವನ -General Area ಜನೋಪಯೋಗಿ ಪ್ರದೇಶ",
          "Nagarahole NP--Mathigodu Elephant Camp",
          "Nagarahole National Park, Safari",
          "Nagarahole Range Forest Office, Nagarahole",
          "Nagerhole--Kutta",
          "Nalknad Palace",
          "Namma Kadu Estate, ನಮ್ಮ ಕಾಡು ಎಸ್ಟೇಟ್",
          "Neerkatte Camp, Kallahalla Range",
          "Neerkatte camp, Kallahalla Range",
          "Neerkatte camp, Kallahalla range",
          "Nidtha Forest - Alur-Banavara Road",
          "Nidtha Kere",
          "Nishanimotte trek route",
          "OB Pipit (OBI)",
          "Old Kent Estates (Horoor Estate)",
          "Orange Country Resort, Coorg",
          "Orange Resort, siddapura, Kodagu",
          "Palace estate",
          "Patte Paare",
          "Perambadi ಪೆರಂಬಾಡಿ",
          "Poomale Estate",
          "Prakash Estate",
          "Pudhukolli Estate Valley",
          "Purple Palms Resort",
          "Pushpagiri Reserve Forest-Maandalapatti",
          "Pushpagiri Wildlife Sanctuary",
          "Raja's Samadhi, Madikeri",
          "Royal Woods, ರಾಯಲ್ ವುಡ್ಸ್",
          "SAI sanctuary",
          "Sampaje",
          "Sampige Guest House",
          "Sand Banks Homestay",
          "Saphali Family Restaurant",
          "Shri  Naramaneshwara Temple",
          "Shri Krishna Balarama Temple",
          "Siddapura (general area)",
          "Skyline Homestay",
          "Somwarpet--General Area",
          "Suntikoppa, Madikeri, Karnataka, IN (12.434, 75.74)",
          "Suntikoppa, ಶುಂಟಿಕೊಪ್ಪ",
          "Surlabbi Waterfalls",
          "Tadiandamol Forest Check Post",
          "Tadiandamol Hill base, Yevakapadi",
          "Taj Madikeri Resort & Spa",
          "Talakaveri Wildlife Sabctuary--Talakaveri Temple",
          "Talakaveri Wildlife Sanctuary",
          "Tavare Kere,Kushalnagar",
          "Thadiyandamol Betta",
          "Thakeri Rapids",
          "The Ibnii,  ದಿ ಇಬ್ಬನಿ",
          "The Nest Homestay",
          "The Tamara Coorg",
          "Theralu",
          "Thithimathi",
          "Thithimathi Timber Depot",
          "Thunthuru Eco Farm",
          "Tithimathi-Konnankatte Road, ತಿತಿಮತಿ-ಕೋಣನಕಟ್ಟೆ ರಸ್ತೆ",
          "Vanandhaara, ವನಾಂಧಾರ",
          "Vate Abbi, Kodagu (Coorg), Karnataka",
          "Virajpete, Karanataka",
          "WEST ELERI (131,14,8)",
          "Woodland Bungalow",
          "Yedehally Estate",
        ],
      },
      {
        district: "Kolar",
        localities: [
          "Ammerahalli lake",
          "Angidappa Kunte",
          "Antara Gange",
          "Avanibetta",
          "BEML Golf Course",
          "Bachubetta Scrub Forest,  ಬಾಚುಬೆಟ್ಟ ಕುರುಚಲು ಕಾಡು",
          "Bangaradhagani, KGF",
          "Bangarpet Railway Station",
          "Bengaluru North University, PG Center, Mangasandra",
          "Bethamangala Reservoir-- Hangala",
          "Bethamangalam Reservoir, Kolar Dt",
          "Bethmangala Outskirts Lake",
          "Byrandalli Kere (ಬೈರಂಡಹಳ್ಳಿ ಕೆರೆ), Kolar",
          "Chinnapura Sewage Treatment Plant",
          "Coromandel",
          "Cyanide mountains",
          "Devarayasamudra Kere",
          "Doddakere",
          "Doddakere--Patalamma Temple path (water canal)",
          "Dyapasandra Tank",
          "Ekalavya Residential School, Gangannagaripalli",
          "Gajaldinne Forest",
          "Gandhi circle, Malur",
          "Hanumanahalli Betta/Kere",
          "Holali Lake (ಹೊಲಲಿ ಕೆರೆ)",
          "Holur Forest",
          "Honnasetthalli lake",
          "Hosakere Lake (ಹೊಸಕೆರೆ)",
          "Hudukula Lake",
          "Hulimangala Kere",
          "KGF grasslands",
          "Kaji Kalla Halli Betta",
          "Kamasamudra Kere",
          "Kashettipalli Kere ಕಸೆತ್ತಿಪಲ್ಲಿ ಕೆರೆ",
          "Kolaramma lake",
          "Kotaballapalli Forest ಕೋಟಬಲ್ಲಪಲ್ಲಿ ಕಾಡು",
          "Kotilinga lake",
          "Lakshi Sagara Lake",
          "Lakshmipura Kere",
          "Madarankapalli Tank",
          "Malleshwaraswamy hills, kamasamundra",
          "Malur Railway Station",
          "Mango Orchards, Kotaballapalli ಮಾವಿನತೋಟ ಕೋಟಬಲ್ಲಪಲ್ಲಿ",
          "Markandeya Hills ಮಾರ್ಕಂಡೇಯ ಬೆಟ್ಟ",
          "Mulbagal (OBI)",
          "Mushtaralli Lake Kolar Dist Karnataka",
          "Mustrahalli Nagesh Dam",
          "Nandikamanahalli Hill",
          "Narsapura Kere, Kolar Dist",
          "Perjenahalli Lake",
          "Ramasagar Lake--Northern bank",
          "Ramasagara Lake",
          "Rayalpad",
          "S Agrahara Kere, Kolar (ಎಸ್‌.ಅಗ್ರಹಾರ ಕೆರೆ)",
          "Sonappanahatti Lake",
          "Srinivaspura",
          "Thimmanayakahalli",
          "Thirumalahatti",
          "Venkatapura",
          "Vokkaleri Chikkere",
          "Ysandra",
          "dyapasandra",
          "dyapasandra tank",
        ],
      },
      {
        district: "Koppal",
        localities: [
          "Banni Koppa Railway Station",
          "Bukkasagara Bridge, Hampi ಬುಕ್ಕಸಾಗರ ಸೇತುವೆ, ಹಂಪಿ",
          "Hampi’s Feathers Resort",
          "Hemagudda Kere ಹೇಮಗುಡ್ಡ ಕೆರೆ",
          "Hulikere ಹುಲಿಕೆರೆ",
          "Irkalgada Kere ಇರ್ಕಲ್ಗಡ ಕೆರೆ",
          "Kanakagiri Kere ಕನಕಗಿರಿ ಕೆರೆ",
          "Mahadeva Temple, Itagi ಮಹಾದೇವ ದೇವಾಲಯ, ಇಟಗಿ",
          "Malakasamudra Kere, Yelaburga ಮಲಕಸಮುದ್ರ ಕೆರೆ, ಯಲಬುರ್ಗಾ",
          "Male Mallappa Temple ಮಳೆ ಮಲ್ಲಪ್ಪ ದೇವಸ್ಥಾನ",
          "Mixed Fields and Scrub - Hatti (North) ಮಿಶ್ರ ಜಾಗ ಮತ್ತು ಕುರುಚಲು - ಹಟ್ಟಿ (ಉತ್ತರ)",
          "Navabrindavana ನವ ಬೃಂದಾವನ",
          "Nidasheshi Grasslands & Fields ನಿಡಶೇಷಿ ಹುಲ್ಲುಗಾವಲು ಮತ್ತು ಹೊಲಗಳು",
          "Nidasheshi Kere ನಿಡಶೇಷಿ ಕೆರೆ",
          "Sanapur Lake",
          "Venkatagiri Kere ವೆಂಕಟಗಿರಿ ಕೆರೆ",
        ],
      },
      {
        district: "Mandya",
        localities: [
          "Abalawadi kere",
          "Adichunchanagiri peacock sanctuary",
          "Aladahalli (Gajanur)",
          "Ananka Farm Stay,Karekura",
          "Arakere, Srirangapattana",
          "Aretippur ಅರೆತಿಪ್ಪೂರ್",
          "Avverahalli, ಅವೆರಹಳ್ಳಿ",
          "Bachahalli",
          "Balmuri falls surroundings",
          "Bangara Doddi",
          "Bangarasannidhi Farm",
          "Baremegala Koppalu",
          "Belakavadi Kere  ಬೆಳಕವಾಡಿ ಕೆರೆ",
          "Belur Kere ಬೇಲೂರು ಕೆರೆ",
          "Betarayana Koppulu, Chinakurli",
          "Bheemeshwari Adventure and Nature Camp",
          "Bhoo Varaha Swamy Temple, Kallahalli",
          "Boppagowdanapura kere",
          "Boregowdana Koppalu",
          "Brindavan Garden, KRS",
          "Bukanakere",
          "Byrasandra Hills",
          "Cauvery WLS- Muthathi",
          "Cauvery Wildlife Sanctuary",
          "Chandagalu kere",
          "Chandravana Road (Guri Thittu)",
          "Chikka Ankanahallikere ಚಿಕ್ಕ ಅಂಕನಹಳ್ಳಿ ಕೆರೆ",
          "Chikkaballi Kere",
          "Chikkaiahana Kaatte",
          "Chikkonahalli, ಚಿಕ್ಕನಹಳ್ಳಿ",
          "Chinakurali Outskirts",
          "Chukki Mane Resort",
          "Chunchagahalli- Kabbare Kere",
          "College Of Agriculture VC Farm",
          "Dadaga Kere",
          "Danaguru High School",
          "Dari Daulat Bagh Srirangapatanam",
          "Dasanakere ದಾಸನಕೆರೆ",
          "Dodda Byadarahalli Savannah",
          "Dodda Chikkanahalli kere",
          "Dodda Gosai Ghat",
          "Doddamakali ದೊಡ್ಡಮಾಕಳಿ",
          "Dyabasandra Kere",
          "Gaganachukki Falls",
          "Galibore nature camp",
          "Gende Hosalli Kere",
          "Gendehosalli Islands, Srirangapatna",
          "Gowdagere ಗೌಡಗೆರೆ, ಮಂಡ್ಯ",
          "Grace Farm",
          "Guthalu Kere",
          "Halaguru kere",
          "Hallegere kere",
          "Hardanahalli kere",
          "Hatna Wetland",
          "Hemagiri, KR Pete Taluk",
          "Honnagala Kere",
          "Honnakatte Kere",
          "Hosa koppalu lake",
          "Hosabudanuru Kere",
          "Hosaholau kere ಹೊಸಹೊಳಲು ಕೆರೆ",
          "Hosamane Colony Pond",
          "Huralikyathana Halli",
          "KR Pete Kere",
          "KRS Backwaters - Basadi Hosakote",
          "KRS Backwaters - Heraganahalli",
          "KRS Backwaters - Malligere",
          "KRS Backwaters - Shri Bahubali Theertha Kaveri Dhaama",
          "KRS Backwaters - Triveni Sangameshwara Gudi",
          "KRS Backwaters- Sri Venugopalaswamy Temple, ಕೆ ಆರ್ ಎಸ್  ಹಿನ್ನೀರು -ಶ್ರೀ ವೇಣುಗೋಪಾಲಸ್ವಾಮಿ ದೇವಸ್ಥಾನ",
          "KRS Reservoir- -Downstream Bridge",
          "Kadalagere",
          "Kalkuni Kere",
          "Kannali kere ಕನ್ನಲಿ ಕೆರೆ",
          "Karadya lake",
          "Karekura",
          "Karighatta",
          "Karsasawadi Kere, Mandya",
          "Kaveri River near Shrirangapatna Station",
          "Kaveri Riverine ಕಾವೇರಿ ನದಿ, Srirangapattana ಶ್ರೀರಂಗಪಟ್ಟಣ",
          "Keregodu kere 2",
          "Keregodu kere ಕೆರೆಗೋಡು ಕೆರೆ",
          "Kharadya Tank ಖರಡ್ಯ ಕೆರೆ, Nagamangala ನಾಗಮಂಗಲ ತಾಲ್ಲೂಕು",
          "Kikkeri Kere ಕಿಕ್ಕೇರಿ ಕೆರೆ",
          "Kirganduru Kere, Mandya",
          "Kirugavalu kere ಕಿರುಗಾವಲು ಕೆರೆ",
          "Kokkare Bellur ಕೊಕ್ಕರೆ ಬೆಳ್ಳೂರು",
          "Koorgalli--Power Grid Corporation of India Limited",
          "Koppa Kere   ಕೊಪ್ಪ  ಕೆರೆ",
          "Koudle Kere ಕೌಡ್ಲೆ ಕೆರೆ, Maddur ಮದ್ದೂರು ತಾಲ್ಲೂಕು",
          "Krishnaraja Sagar -confluence of River Kaveri, Hemavathi & Laxmanathirtha, Mandya & Mysore Dts",
          "Kunthi Betta ಕುಂತಿ ಬೆಟ್ಟ, Pandavapura Taluk",
          "Madduru kere ಮದ್ದೂರು ಕೆರೆ",
          "Madduru--Kadalur lake",
          "Mahadevapura Bridge ಮಹದೇವಪುರ ಕಾವೇರಿ ಸೇತುವೆ",
          "Malavalli Kere ಮಳವಳ್ಳಿ ಕೆರೆ",
          "Malavalli town",
          "Maramgere ಮಾರಂಗೆರೆ, Maddur Taluk",
          "Marehalli Kere ಮಾರೆಹಳ್ಳಿ ಕೆರೆ",
          "Markalu Kere ಮಾರ್ಕಲ್  ಕೆರೆ",
          "Mayura River View",
          "Melkote Temple Wildlife Sanctuary ಮೇಲುಕೋಟೆ ವನ್ಯಜೀವಿಧಾಮ",
          "Melkote Town",
          "Mellahally Kere",
          "Mogarahalli, Mysore",
          "Molekoppalu (ಮೊಳೆಕೊಪ್ಪಲು), Mandya",
          "Mudigere Kere",
          "Mysore Bird Atlas 40B, Basthipura",
          "Mysore Bird Atlas 40C, Ilavala Hobli",
          "Mysore City Bird Atlas 1A, BEML -Infosys midway",
          "Mysore City Bird Atlas 1B, Adjoining Emerald Enclave, behind Infosys",
          "Mysore City Bird Atlas 1C, BEML & KIADB Area",
          "Mysore City Bird Atlas 2A, HPCL behind, Hebbala",
          "Mysore City Bird Atlas 2B,  Hebbal Industrial Area",
          "Mysore City Bird Atlas 34B, Avverahalli",
          "Mysore City Bird Atlas 35A, KRS Road, Hulikere",
          "Mysore City Bird Atlas 35B",
          "Mysore City Bird Atlas 35C, Near Belagola Sub-Station, Kuppedada",
          "Mysore City Bird Atlas 35D",
          "Mysore City Bird Atlas 36A, Belagola",
          "Mysore City Bird Atlas 36B,Hosananduru Main Rd",
          "Mysore City Bird Atlas 36C",
          "Mysore City Bird Atlas 36D",
          "Mysore City Bird Atlas 37A, Pump House",
          "Mysore City Bird Atlas 37B, public road",
          "Mysore City Bird Atlas 37C, next to' I can; school",
          "Mysore City Bird Atlas 38B, about a klm from Mysore-Bangalore jun",
          "Mysore City Bird Atlas 39A",
          "Mysore City Bird Atlas 41B, Belawadi",
          "Mysore City Bird Atlas 42A",
          "Mysore City Bird Atlas 42B",
          "Mysore City Bird Atlas 42C",
          "Mysore City Bird Atlas 42D",
          "Mysore City Bird Atlas 5B, Sujaya Industries surroundings",
          "Mysore City Bird Atlas Second 34 A, Beechanakuppe Abandoned Quarry",
          "Mysore City Bird Atlas Second 34 D",
          "Mysore City Bird Atlas Second 34C Mydanahalli",
          "Mysore City Bird Atlas Second 40 A",
          "Mysore City Bird Atlas Second 40 D",
          "Mysore City Bird Atlas Second 44B, Public road",
          "Nagarakere",
          "Naguvanahalli",
          "Narayana Durga, Rayasamudra ನಾರಾಯಣ ದುರ್ಗ",
          "Narayanapura Kere ನಾರಾಯಣಪುರ ಕೆರೆ",
          "Palahalli",
          "Palkere Reservoir",
          "Pandavapura Kere ಪಾಂಡವಪುರ ಕೆರೆ",
          "Ranganathittu Bird Sanctuary ರಂಗನತಿಟ್ಟು ಪಕ್ಷಿಧಾಮ",
          "Rayasamudra Kere",
          "Rudrakshi Pura Kere",
          "Shivanasamudra- Canal view point",
          "Shree Swaminarayan Gurukul International School",
          "Shyadanahalli, Mysore",
          "Srirangapatna",
          "Srirangapatna Nimishamba temple",
          "Srirangapatna Sangama",
          "Sule Kere ಸೂಳೆ ಕೆರೆ",
          "Sule Kere, near Nagamangala",
          "TRC Worldwide Engineers Pvt Ltd.",
          "Tailuru Kere ತೈಲೂರು ಕೆರೆ",
          "Tonnuru Kere ತೊಣ್ಣೂರು ಕೆರೆ",
          "Valagere Menasa (Dodda kere)",
          "Vasanthapura or Dasanapura Kere bordering Melkote Sanctuary",
          "Wasi Cottage lake",
          "Yedumuri walking trail",
          "Yoga Dhaama Retreat,  Bommuru Agrahara ಯೋಗ ಧಾಮ ರಿಟ್ರೀಟ್, ಬೊಂಮ್ಮೂರು  ಅಗ್ರಹಾರ",
          "karadanalli",
        ],
      },
      {
        district: "Mysuru",
        localities: [
          "4th Stage, Vijaynagar",
          "Abbur kere",
          "Adiganahalli Kere,  ಅಡಿಗನಹಳ್ಳಿ ಕೆರೆ",
          "Ahalya Grama-Scrub patch",
          "Ahalya Kere, ಅಹಲ್ಯಾ ಕೆರೆ",
          "Ajjayyanahundi Kere ಅಜ್ಜಯನಹುಂಡಿ ಕೆರೆ, Ring Road",
          "Alada Hesrukatte",
          "Alanahalli Forest Tree Park",
          "Aloka Palace scrub jungle, Mysore",
          "Ananduru KRS Backwaters, ಆನಂದೂರು",
          "Andolana circle",
          "Antharsanthe Kere, ಅಂತರಸಂತೆ ಕೆರೆ",
          "Arabithittu Wildlife Sanctuary    ಅರಬಿತಿಟ್ಟು ವನ್ಯಜೀವಿ ಧಾಮ",
          "Arasanakere Gudda ಅರಸನಕೆರೆ ಗುಡ್ಡ",
          "Arasanakere ಅರಸನಕೆರೆ",
          "Arivu Vidhya Samsthe, ಅರಿವು ವಿದ್ಯಾ ಸಂಸ್ಥೆ",
          "Arkeshwara Temple (Yadathore)",
          "Aswal Kere  ಆಸ್ವಾಳ ಕೆರೆ",
          "Ayurvedic hospital, Arogyashrama",
          "Bandipur tiger reserve--Moliyur range",
          "Bandipur-Kabini Perifery",
          "Bannur Canal",
          "Bannur Heggere ಬನ್ನೂರು ಹೆಗ್ಗೆರೆ",
          "Baradanpura (ಬರಡನಪುರ)",
          "Basappana Katte,Manadavadi Road, Mysore",
          "Basavanahalli",
          "Basavapatna village",
          "Bettada Mata ML Hundi",
          "Bettada beedu Scrub Forest , Mahadevapura beat",
          "Bettada beedu Scrub Forest , Mandahalli beat",
          "Bettadabeedu-Chikkanahalli scrub forest ಬೆಟ್ಟದಬೀಡು- ಚಿಕ್ಕನಹಳ್ಳಿ ಕುರುಚಲು ಕಾಡು",
          "Bettadahalli kere ಬೆಟ್ಟದಹಳ್ಳಿ ಕೆರೆ",
          "Bettadapura Lake",
          "Bilikere Kere ಬಿಳಿಕೆರೆ",
          "Bilikere Watershed Project",
          "Bilugali Kabini Bridge - North Side",
          "Bilugali-Jodihariharapura Farmlands and Trails",
          "Bison Wildlife Resort, Kabini, Karnataka, IN (11.938, 76.244)",
          "Bommanahalli Kere",
          "Bommenhalli Lake , ಬೊಮ್ಮೇನಹಳ್ಳಿ ಕೆರೆ",
          "Bopanahalli kere",
          "Bylakuppe",
          "Chamanahalli Kere ಚಾಮನಹಳ್ಳಿ ಕೆರೆ",
          "Chamundi Hill Nandi Temple",
          "Chamundi Hill Uttanahalli Road",
          "Chamundi Vana ಚಾಮುಂಡಿ ವನ",
          "Cheluvamba Park, Mysore",
          "Chidravalli Kere",
          "Chikka Harohalli kere ಚಿಕ್ಕ ಹಾರೋಹಳ್ಳಿ ಕೆರೆ, ಹೆಚ್‌ ಡಿ ಕೋಟೆ ರಸ್ತೆ",
          "Chikkabaragi, Ankupura, Karnataka, IN (11.826, 76.442)",
          "Chikkammana Kere, Arasinakere  ಚಿಕ್ಕಮ್ಮನ ಕೆರೆ",
          "Chimili Kere",
          "Chittanahalli Lake, Hemmige",
          "Chowdenahalli Kere, ಚೌಡೇನಹಳ್ಳಿ ಕೆರೆ",
          "Chowkahalli Kere",
          "Coconut Farm, Bilugali, Karnataka, IN - ಐಸಿರಿ ತೆಂಗಿನ ತೋಟ (12.183, 76.821)",
          "D B Kuppe",
          "Dadadahalli Kere (ದಡದಹಳ್ಳಿ ಕೆರೆ)",
          "Dadadahalli fields    ದಡದಹಳ್ಳಿ ಮೈದಾನ",
          "Daithyana Kere  ದೈತ್ಯನ ಕೆರೆ",
          "Daivivan park",
          "Dammanakatte-Taraka Road",
          "Dasanapura Kere ದಾಸನಪುರ ಕೆರೆ",
          "Deputy Commissioner's Residence, Mysore",
          "Deputy Drugs Control Office Vijayanagar 4 Stage  Mysore  Karnataka IN",
          "Devalapura pond",
          "Devarakere, Hinkal",
          "Devirammanahalli Hundi ದೇವೀರಮ್ಮನಹಳ್ಳಿ ಹುಂಡಿ, Nanjanagudu",
          "Dindagadu, Kodagu Dt",
          "Dodda katuru Lake , ದೊಡ್ಡ ಕಾಟೂರು ಕೆರೆ",
          "Doddakanya",
          "Doora Hosakere  ದೂರ ಹೊಸಕೆರೆ",
          "Doora Kere ದೂರ ಕೆರೆ",
          "Dornahalli Kere",
          "GSSS Institute of Engineering and Technology for Women",
          "Gaddige-Hunsur : Chowdi katte",
          "Gaddige-Hunsur : Devi Kere",
          "Gaddige-Hunsur : Santhe Kere",
          "Gadijogihundi Kere",
          "Galigarahundi",
          "Garike Katte  ಗರಿಕೆ ಕಟ್ಟೆ",
          "Giribettada Kere ಗಿರಿಬೆಟ್ಟದ ಕೆರೆ",
          "Golden Landmark Resort",
          "Gommatgiri, Bettadur, Karnataka",
          "Government House, Mysore",
          "Great Banyan Tree, Manasa Gangotri Mens Hostel, Mysore",
          "Guddada Shri Muthurayaswamy Temple,ಗುಡ್ಡದ ಶ್ರೀ ಮುತ್ತುರಾಯ ಸ್ವಾಮಿ ದೇವಸ್ಥಾನ, Madagalli",
          "Gudumanahalli Kere ಗುಡುಮಾನಹಳ್ಳಿ ಕೆರೆ",
          "Gujjegowdanapurada  kere ಗೆಜ್ಜೇಗೌಡನಪುರದ ಕೆರೆ",
          "Gundupatna Kere, Lingapura ಲಿಂಗಾಪುರ (Kirangoor Lake)",
          "HPO and RMS Layout",
          "Hadinaru Kere ಹದಿನಾರು ಕೆರೆ",
          "Hairige  ಹೈರಿಗೆ",
          "Halalu ಹಲಾಳು",
          "Halekamana Koppalu, Karnataka",
          "Hampapura ಹಂಪಾಪುರ",
          "Hanumatharayana kere  ಹನುಮಂತರಾಯನ ಕೆರೆ",
          "Haradur Lake, Karnataka, IN (12.486, 76.107)",
          "Harathale Kere, Nanjanagudu (ಹರತಲೆ ಕೆರೆ)",
          "Harave Kere ಹರವೆ ಕೆರೆ",
          "Harohalli kere, Bannur Road",
          "Hebbal 3rd Stage, Mysore",
          "Heggadapura Lake",
          "Himadeepa Farms",
          "Hinkal",
          "Honnapura",
          "Hulimavu Gudda  ಹುಳಿಮಾವು ಗುಡ್ಡ",
          "Hullahalli Dam/ Hathwal Katte ಹುಲ್ಲಹಳ್ಳಿ / ಹತ್ವಾಲ್ ಕಟ್ಟೆ",
          "Hullahalli Nale (water canal)",
          "Hunsur--Lakshmana Tirtha bridge",
          "Huyilalu, Karnataka",
          "Hyrige kere,Manandavadi Road",
          "Immavu Industrial Area-KAIDB ಇಮ್ಮಾವು ಕೈಗಾರಿಕಾ ಪ್ರದೇಶ",
          "Inchara -Park, Mysuru",
          "Indavara Enclave Surrounding, Kemmannupura",
          "Indraprastha ಇಂದ್ರಪ್ರಸ್ಥ",
          "Infosys Campus, Mysore",
          "Ingalakere, Piriyapattana Tk",
          "JC Golf Club, Mysore",
          "JLR Kings Sanctuary,Nagarahole",
          "JSS Academy of Higher Education and Research",
          "JSS College of Arts, Commerce and Science Campus",
          "Jodi Aaladamara kere   ಜೋಡಿ ಆಲದಮರ ಕೆರೆ",
          "K Hemmanahalli  ಕೆ ಹೆಮ್ಮನಹಳ್ಳಿ",
          "K R S Nisarga Badavane (12.385, 76.514)",
          "KAAV Safari Lodge",
          "KC Layout, Mysore",
          "KRS Backwaters - Kallahalli",
          "KRS Backwaters - Marchahalli",
          "KRS Backwaters - Thippuru",
          "KRS Backwaters- Degganahalli Bridge",
          "KRS Backwaters- Husainpura Bridge  ಕೆ ಆರ್ ಎಸ್ ಹಿನ್ನೀರು -  ಹುಸೇನಪುರ ಸೇತುವೆ",
          "Kabini Backwaters",
          "Kabini Backwaters-Bidarahalli",
          "Kabini Dam View Point",
          "Kabini Mysore--OBI",
          "Kabini Reservoir",
          "Kabini River Resort, Karapura",
          "Kabini River Safari (ಕಬಿನಿ ನದಿ ಸಫಾರಿ)",
          "Kabini River lodge",
          "Kabini River, Nanjangudu nr Srikanteshwara temple",
          "Kabini backwater viewpoint",
          "Kabini backwaters, Nerale",
          "Kadanahalli Gudda ಕಾಡನಹಳ್ಳಿ ಗುಡ್ಡ",
          "Kaggalipura Kere ಕಗ್ಗಲೀಪುರ ಕೆರೆ",
          "Kalalavadi Canal & Fields, ಕಳಲವಾಡಿ ನಾಲೆ ಹಾಗೂ ಮೈದಾನ",
          "Kalalavadi Farms and Fields ಕಳಲವಾಡಿ ತೋಟ ತುಡಿಕೆ, ಮೈಸೂರು ನಗರ ಹೊರವಲಯ",
          "Kalale Kere, Nanjangud (ಕಳಲೆ)",
          "Kalale--Kerehundi, Karnataka, IN (12.061, 76.664)",
          "Kalbetta Forest",
          "Kalihundi, Karnataka, IN (12.065, 76.696)",
          "Kallur Kere ಕಲ್ಲೂರು ಕೆರೆ",
          "Kamana kere hundi (Kesare Doddakere) Mysore City Bird Atlas 10B ಕಾಮನಕೆರೆ ಹುಂಡಿ",
          "Kampalapura Kere  ಕಂಪಲಾಪುರ ಕೆರೆ",
          "Kaniyanahundi Kere",
          "Kapila River Bridge, Hullahalli",
          "Kapila River--Madapura to Chikkadevammana betta",
          "Karadilakkana Kere, Kushalnagar",
          "Karanji Kere ಕಾರಂಜಿ ಕೆರೆ",
          "Karapur Village (OBI)",
          "Karehundi Kere",
          "Karigala Forest",
          "Karigala Kere  ಕರಿಗಾಲ ಹೆಗ್ಗೆರೆ",
          "Karigala-Scrub patch",
          "Karimuddanahalli Kere, ಕರಿಮುದ್ದನಹಳ್ಳಿ ಕೆರೆ Gaddige",
          "Karnataka Silk Industries Corporation Ltd (KSIC) TN Pura",
          "Katte Malalawadi Check Dam",
          "Katte thore  ಕಟ್ಟೆ ತೊರೆ",
          "Kaveri Bridge, Bannur",
          "Kempanahally",
          "Kempannana Kere ಕೆಂಪಣ್ಣನ ಕೆರೆ",
          "Kenchanakere ಕೆಂಚನಕೆರೆ, Hunsur ಹುಣಸೂರು",
          "Kiranalli Kere, ಕೀರನಲ್ಲಿ ಕೆರೆ",
          "Kodagalli Kere (ಕೊಡಗಳ್ಳಿ ಕೆರೆ)",
          "Kokkarehundi/Devvada halla (Near Bonthagahalli)",
          "Konanur Kere, ಕೊಣನೂರು ಕೆರೆ",
          "Konanur Scrub & Grass Land, ಕೊಣನೂರು ಕುರುಚಲು ಮತ್ತು ಹುಲ್ಲುಗಾವಲು",
          "Koodanahalli Outskirts",
          "Koorgalli",
          "Kudakuru Lake",
          "Kunteri kere, Kalale, Nanjanagudu",
          "Kutwadi Kere ಕುಟವಾಡಿ ಕೆರೆ, Gaddige-Hunsur",
          "Kyathanahalli kere (Harathale)",
          "Lingambudhi Kere--Main Entrance. ಲಿಂಗಾಂಬುಧಿ  ಮುಖ್ಯ ದ್ವಾರ",
          "Lingambudhi Kergalli view",
          "Linganakatte, Pillahalli (ಲಿಂಗನ ಕಟ್ಟೆ)",
          "Lingapura Forest Gate",
          "MUDA Park, Jodi Bevina Mara, Dattagalli",
          "Madagalli, ಮಡಗಲ್ಲಿ",
          "Madduru Kere or Vadavina Katte, ಮದ್ದೂರು ಕೆರೆ / ವಡವಿನ ಕಟ್ಟೆ",
          "Madduru sanna kere",
          "Madhava Manthri Dam, Talakadu ಮಾಧವಮಂತ್ರಿ ಅಣೆಕಟ್ಟು",
          "Madhava park 5th cross, R K  Nagar",
          "Makanahundi, Mysore",
          "Malleshwara Gudda, ಮಲ್ಲೇಶ್ವರ ಗುಡ್ಡ",
          "Manchedevanahalli Lake",
          "Marallu Oni, Gopalagowda Nagara ಮರಳು ಓಣಿ ಗೋಪಾಲಗೌಡ ನಗರ  (12.267, 76.708)",
          "Maraluru",
          "Marasettihalli",
          "Maratikyathana Halli Kere",
          "Marballi Kere, ಮಾರ್ಬಳ್ಳಿ ಕೆರೆ",
          "Marur lake ಮರೂರು ಕೆರೆ",
          "Matakere",
          "Mathru mandali circle",
          "Meenakshipura Backwaters",
          "Metagalli, Mysore",
          "Metikuppe",
          "Moolepettlu Village, ಮೂಲೆಪೆಟ್ಲು",
          "Mudalakoppalu",
          "Muddahalli, Nanjangud Taluka ಮುದ್ದಹಳ್ಳಿ",
          "Muddahalli--Mooganakere ಮುದ್ದಹಳ್ಳಿ--ಮೂಗನಕೆರೆ",
          "Mudran Nagar, Mysore",
          "Mudukuthore hill",
          "Mullur Kere",
          "Muthur Chikkere",
          "Mydanahalli kere, ಮೈದನಹಳ್ಳಿ ಕೆರೆ",
          "Mysore Bird Atlas 53D, Madapura",
          "Mysore Bird City Atlas 57A, Gurur",
          "Mysore City Bird Atlas  44A, Public road",
          "Mysore City Bird Atlas 10A, Opp Narayana Hrudayalaya",
          "Mysore City Bird Atlas 10C, Devnur tank",
          "Mysore City Bird Atlas 10D, Rajiv Nagar",
          "Mysore City Bird Atlas 11A, Beh KSRTC bus depot, VNagar 4th stage",
          "Mysore City Bird Atlas 11B, Vijayanagar 3rd Stage",
          "Mysore City Bird Atlas 11C, Vijayanagar 4th Stage",
          "Mysore City Bird Atlas 11D, Hinkal kere, Vijayanagar 3rd Stage",
          "Mysore City Bird Atlas 12A, Kodava Samaja surroundings, Vijayanagar 1st Stage",
          "Mysore City Bird Atlas 12B, MUDA Sports Ground",
          "Mysore City Bird Atlas 12C, SJCE Cricket Ground",
          "Mysore City Bird Atlas 12D, Law School, UOM",
          "Mysore City Bird Atlas 13A, Gokulam 1st Main Road",
          "Mysore City Bird Atlas 13B, Vivekananda Road, Yadavagiri",
          "Mysore City Bird Atlas 13C, Valmiki Road",
          "Mysore City Bird Atlas 13D location name",
          "Mysore City Bird Atlas 14A location name",
          "Mysore City Bird Atlas 14B location name",
          "Mysore City Bird Atlas 14C location name",
          "Mysore City Bird Atlas 14D location name",
          "Mysore City Bird Atlas 15A location name",
          "Mysore City Bird Atlas 15B location name",
          "Mysore City Bird Atlas 15C KSRP Police quarters",
          "Mysore City Bird Atlas 15D location name",
          "Mysore City Bird Atlas 16A, Sathgalli, DTS Rao Layout, Mysore city",
          "Mysore City Bird Atlas 16B, VTU behind marsh Waterbody",
          "Mysore City Bird Atlas 16C, Yeraganahalli village & farms, Mysore City",
          "Mysore City Bird Atlas 16D, KSFC Layout",
          "Mysore City Bird Atlas 17A, Deepa-Tranquail",
          "Mysore City Bird Atlas 17B, Bogadi Kere. ಬೋಗಾದಿ ಕೆರೆ",
          "Mysore City Bird Atlas 17C, People for Animals, RR Nagar, Mysore City",
          "Mysore City Bird Atlas 17D, Thibbegowda Farm, Bapuji Layout, Mysore City",
          "Mysore City Bird Atlas 18A, RIE campus, Manasa Gangothri, Mysore City",
          "Mysore City Bird Atlas 18B, Manasagangothri,Physics Dept. Mysore University",
          "Mysore City Bird Atlas 18C, CFTRI Layout, Mysore City",
          "Mysore City Bird Atlas 19A, Kukkarahalli kere  ಕುಕ್ಕರಹಳ್ಳಿ ಕೆರೆ",
          "Mysore City Bird Atlas 19B University Oval Grounds",
          "Mysore City Bird Atlas 19C, Saraswathipuram Park, Mysore",
          "Mysore City Bird Atlas 19D, Manuvana Park",
          "Mysore City Bird Atlas 1D, L & T -Infosys-DFRL complexes",
          "Mysore City Bird Atlas 20A, Sayyaji Rao Road",
          "Mysore City Bird Atlas 20B, Hotel Siddartha Road",
          "Mysore City Bird Atlas 20C, MG Rd, Agrahara, Mysore",
          "Mysore City Bird Atlas 20D, Race Course Road, Mysore",
          "Mysore City Bird Atlas 21A Around Postal Training Centre",
          "Mysore City Bird Atlas 21B, Yaraganahalli",
          "Mysore City Bird Atlas 21C, Horse Park",
          "Mysore City Bird Atlas 21D location name",
          "Mysore City Bird Atlas 22A, Teresian College surroundings",
          "Mysore City Bird Atlas 22B location name",
          "Mysore City Bird Atlas 22C Lalitha Mahal ಲಲಿತ ಮಹಲ್",
          "Mysore City Bird Atlas 22D location name",
          "Mysore City Bird Atlas 23A, Badagalahundi, Jayapura Hobli, Mysore",
          "Mysore City Bird Atlas 23B, Sharada Public School, Kanakadasa nagara, Mysore",
          "Mysore City Bird Atlas 23C, Kergalli kunte downstream, Mysore",
          "Mysore City Bird Atlas 23D, Somanatha Nagar, Mysore",
          "Mysore City Bird Atlas 24A, Nagalinga -Deshalingeshwara Temple surroundings",
          "Mysore City Bird Atlas 24B A&B Block adj Vishwamanava Double Road",
          "Mysore City Bird Atlas 24C, Two inlet feeders to Lingambudhi",
          "Mysore City Bird Atlas 24D, RK Nagar, behind Ganesh Temple drain",
          "Mysore City Bird Atlas 25A,  Kaveri School and Twin Parks",
          "Mysore City Bird Atlas 25B, Jayanagar railway line, Mysore",
          "Mysore City Bird Atlas 25C",
          "Mysore City Bird Atlas 25D, Railway Quarters, Mysore",
          "Mysore City Bird Atlas 26A, SJH Rd, Vidyaranya puram, Mysore",
          "Mysore City Bird Atlas 26B, Harischandra Ghat Crematorium, Mysore",
          "Mysore City Bird Atlas 26C, Burial Ground, Mysore",
          "Mysore City Bird Atlas 26D, Ooty Road, behind IOC bunk",
          "Mysore City Bird Atlas 27A, Chamundi Hill-North west",
          "Mysore City Bird Atlas 27B, Chamundi Hill-North",
          "Mysore City Bird Atlas 27C, Chamundi Hill- Around Temple ಚಾಮುಂಡಿ ಬೆಟ್ಟ ದೇವಸ್ಥಾನ",
          "Mysore City Bird Atlas 27D, Chamundi Hill -Shiva Temple",
          "Mysore City Bird Atlas 28A, Chamundi Hill-Horsetrack Lalitadripura Rd Jn",
          "Mysore City Bird Atlas 28B, Nethaji Nagar South",
          "Mysore City Bird Atlas 28C, Chamundi Hill - western side of Lalitadripura",
          "Mysore City Bird Atlas 28D, Lalitadripura western part",
          "Mysore City Bird Atlas 29A South of Water Tank RT Nagar",
          "Mysore City Bird Atlas 29B, RT Nagar",
          "Mysore City Bird Atlas 29C, Behind Yedahalli Village",
          "Mysore City Bird Atlas 29D, Off Yedahalli Road, KBL Layout, Mysore",
          "Mysore City Bird Atlas 2C, Hebbal kere, ಹೆಬ್ಬಾಳ ಕೆರೆ",
          "Mysore City Bird Atlas 2D location name",
          "Mysore City Bird Atlas 30A, Lingambudhi kere ಲಿಂಗಾಂಬುಧಿ ಕೆರೆ",
          "Mysore City Bird Atlas 30B, Srirampura 2nd Stage",
          "Mysore City Bird Atlas 30C, Areca Grove, Behind Rajaji Layout",
          "Mysore City Bird Atlas 30D, Sacred Grove, Parasaiyyana Hundi",
          "Mysore City Bird Atlas 31A, Devayyana Hundi, Mysore",
          "Mysore City Bird Atlas 31B, JP Nagar, Opp Brigade",
          "Mysore City Bird Atlas 31C, Mahadevapura, Behind CSRTI, Mysore",
          "Mysore City Bird Atlas 31D, JP Nagar, Koppalur, Mysore",
          "Mysore City Bird Atlas 32A, Link Main Road, Visveshwara Nagar, Mysore",
          "Mysore City Bird Atlas 32B, Chamundi Hill- South west - Prasunayakana Kere western side",
          "Mysore City Bird Atlas 32C, Dalvoy Kere, Mysore ದಳವಾಯಿ ಕೆರೆ",
          "Mysore City Bird Atlas 32D,Farmland across from Dalvoy kere, Mysore",
          "Mysore City Bird Atlas 33A, Chamundi Hill -South",
          "Mysore City Bird Atlas 33B, Chamundi Hill South-East",
          "Mysore City Bird Atlas 33C, Near Utanahalli,",
          "Mysore City Bird Atlas 33D, Uthanahalli Temple",
          "Mysore City Bird Atlas 37D, Public road with agricultural land",
          "Mysore City Bird Atlas 38A, Laxmipura Village",
          "Mysore City Bird Atlas 38D, Public road, Naganahalli main road",
          "Mysore City Bird Atlas 39B",
          "Mysore City Bird Atlas 39C",
          "Mysore City Bird Atlas 39D",
          "Mysore City Bird Atlas 3A Mogarahalli",
          "Mysore City Bird Atlas 3B, Shyadana halli",
          "Mysore City Bird Atlas 3C, Bharuka Triveni Industries",
          "Mysore City Bird Atlas 3D, RBI Note Press",
          "Mysore City Bird Atlas 41A",
          "Mysore City Bird Atlas 41C, Hale Kesare",
          "Mysore City Bird Atlas 41D, near Nishabda Farm",
          "Mysore City Bird Atlas 43A",
          "Mysore City Bird Atlas 43C",
          "Mysore City Bird Atlas 43D",
          "Mysore City Bird Atlas 44C, Pond",
          "Mysore City Bird Atlas 44D, Rammanahalli Christian Cemetery",
          "Mysore City Bird Atlas 45A, Area behind Sharmada Farm",
          "Mysore City Bird Atlas 45B, Basaveshwara Badavane, M.U.D.A Park",
          "Mysore City Bird Atlas 45C, Madagalli Doddakere Eastern area",
          "Mysore City Bird Atlas 45D, Manasa Serene Public Road",
          "Mysore City Bird Atlas 47A, Ganagarahundi",
          "Mysore City Bird Atlas 47B, Trendz East",
          "Mysore City Bird Atlas 47C, Maratikyathanahalli",
          "Mysore City Bird Atlas 47D, Dasanakoppalu",
          "Mysore City Bird Atlas 48D Bhugathagalli - Bota Farm - Pama Enclave",
          "Mysore City Bird Atlas 49A, Kemmannupura Kunte & Marshes",
          "Mysore City Bird Atlas 49B, Kamadhenu Layout, Badagalahundi",
          "Mysore City Bird Atlas 49C Ramanahundi Brick Factory & Layout",
          "Mysore City Bird Atlas 49D Nanjarajanahundi Fields",
          "Mysore City Bird Atlas 4A, Nagahanahalli Paddyfields",
          "Mysore City Bird Atlas 4B, Behind Kasthuri Nivas hotel",
          "Mysore City Bird Atlas 4C, Dattatreya Mutt surroundings",
          "Mysore City Bird Atlas 4D, KR Mills behind",
          "Mysore City Bird Atlas 50A: Thippayyana kere ತಿಪ್ಪಯ್ಯನ ಕೆರೆ",
          "Mysore City Bird Atlas 51A Muganahundi Kere Backwaters",
          "Mysore City Bird Atlas 51B South Of Ramanahundi",
          "Mysore City Bird Atlas 51C: Mugana Hundi Kere & Down stream ಮೂಗನ ಹುಂಡಿ ಕೆರೆ",
          "Mysore City Bird Atlas 51D: M hundi Village S-W",
          "Mysore City Bird Atlas 52A: Chamundi Hill- Uttanahalli Lalitadripura Road",
          "Mysore City Bird Atlas 52C: Uttanahalli Kere",
          "Mysore City Bird Atlas 52D, Wetlands Near Sarkari Uttaralli",
          "Mysore City Bird Atlas 53A Farmland (12.266, 76.712)",
          "Mysore City Bird Atlas 53C: Yandahalli kere, Mysore",
          "Mysore City Bird Atlas 54A, Open Layout Devagalli",
          "Mysore City Bird Atlas 54B",
          "Mysore City Bird Atlas 54C, Pond Dhanagalli",
          "Mysore City Bird Atlas 54D",
          "Mysore City Bird Atlas 55A, Nagarthahalli",
          "Mysore City Bird Atlas 55B, Halalu",
          "Mysore City Bird Atlas 55C",
          "Mysore City Bird Atlas 55D, Kenchalagudu",
          "Mysore City Bird Atlas 56B, Near Manandavadi Road",
          "Mysore City Bird Atlas 56C, Kalalavadi",
          "Mysore City Bird Atlas 56D, Farmland Behind Rayana Kere",
          "Mysore City Bird Atlas 57B, Gejjagalli",
          "Mysore City Bird Atlas 57C,  Rayana Kere ರಾಯನ ಕೆರೆ",
          "Mysore City Bird Atlas 57D, Along Varuna Canal, Near Srinagara",
          "Mysore City Bird Atlas 58A, Gejjagalli( near Varuna Canal)",
          "Mysore City Bird Atlas 58B,Gudumadanahalli",
          "Mysore City Bird Atlas 58C, Mandakalli",
          "Mysore City Bird Atlas 58D,Mandakalli kere or Shetty Kere ಮಂಡಕಳ್ಳಿ ಕೆರೆ",
          "Mysore City Bird Atlas 59A",
          "Mysore City Bird Atlas 59B, Hadjana.",
          "Mysore City Bird Atlas 59C, Makanahundi",
          "Mysore City Bird Atlas 59D, Chikkagowdana Hundi.",
          "Mysore City Bird Atlas 5A, Besides Hyundai Showroom",
          "Mysore City Bird Atlas 5C, Belwadi Village",
          "Mysore City Bird Atlas 5D, Housing Board Colony",
          "Mysore City Bird Atlas 60A, Hadajana Kere",
          "Mysore City Bird Atlas 60B, Farmland",
          "Mysore City Bird Atlas 60C - Hadjana  Farms & Fields",
          "Mysore City Bird Atlas 60D, Maresettihalli",
          "Mysore City Bird Atlas 6A, Around Rane Madras factory complex",
          "Mysore City Bird Atlas 6B, Bommanahalli Kere & BEML staff quarters",
          "Mysore City Bird Atlas 6C, in and around Hootgalli 220 KV subsustaion",
          "Mysore City Bird Atlas 6D, BEML plantations",
          "Mysore City Bird Atlas 7A, Hebbala 1st stage, kalyana mantapa",
          "Mysore City Bird Atlas 7B, Kumbara koppalu Tollgate area",
          "Mysore City Bird Atlas 7C, Gen Thimmaiah Road, Vijayanagar 1st stage",
          "Mysore City Bird Atlas 7D, Vidhya vardhaka",
          "Mysore City Bird Atlas 8A, Near GRS Fantasy Park.",
          "Mysore City Bird Atlas 8B BMS NAGAR",
          "Mysore City Bird Atlas 8C, PK Sanitorium, KRS Road",
          "Mysore City Bird Atlas 8D, Around IOCL  complex",
          "Mysore City Bird Atlas 9A: Ring Road, Siddiqui Nagar West, Mysore",
          "Mysore City Bird Atlas 9B, Kesare Sewage Treatment Plant, Mysore",
          "Mysore City Bird Atlas 9C, Bannimantapa -Balabhavan",
          "Mysore City Bird Atlas 9D, Shobha Gardens",
          "Mysore City Bird Atlas Second 38C, next to railway line",
          "Mysore City Bird Atlas Second 43B",
          "Mysore City Bird Atlas Second 46A Sathagalli - Vardhamannagar - Hanchya",
          "Mysore City Bird Atlas Second 46B Hanchya - Huralikyathanahalli Road & Surroundings",
          "Mysore City Bird Atlas Second 46C Galigarahundi - BSNL Layout - Ashrithanagar",
          "Mysore City Bird Atlas Second 46D Parashuramanagar - LIC Colony - GSS Kaveri",
          "Mysore City Bird Atlas Second 48A Paradise Enclave - Vidya Vikas College - KBL Layout",
          "Mysore City Bird Atlas Second 48B Sri Betaleshwari Temple - Padmini Enclave - Delhi Public School",
          "Mysore City Bird Atlas Second 48C Nandini Layout 2nd Stage - Vasanthanagar",
          "Mysore City Bird Atlas Second 50B Prakruthi Layout - Bhugathagalli/Chikkahalli Road & Surroundings",
          "Mysore City Bird Atlas Second 50C Police Layout - JSS Layout 2nd Stage",
          "Mysore City Bird Atlas Second 50D Chikkahalli - MyCEM College & Surroundings",
          "Mysore City Bird Atlas Second 52B,  Shreesha Hill View Layout, Lalithadripura",
          "Mysore City Bird Atlas Second 53 B, Varuna Canal Near Yandalli Lake",
          "Mysore City Bird Atlas56A, Kote Hundi",
          "Mysore City Brid Atlas 18D, RTTC & surroundings, TK Layout, Mysore",
          "Mysore Palace",
          "Mysore University",
          "Mysore University--University Agriculture Farms",
          "Mysore Zoo, Mysore City",
          "Mysore outskirts (OBI)",
          "Mysore--General Area (OBI)",
          "Mysure Suburb Bus Stand ಮೈಸೂರು ಗ್ರಾಮಾಂತರ ಬಸ್‌ ನಿಲ್ದಾಣ",
          "Mysuru Airport",
          "N Begur range--Bandipura TR",
          "N. Begur range",
          "NRH farm",
          "Naganahalli Kere, H D Kote",
          "Nagappayyana kere",
          "Nagarahole Forest Checkpost",
          "Nagarahole National Park--Kabini ನಾಗರಹೊಳೆ ರಾಷ್ಟ್ರೀಯ ಉದ್ಯಾನವನ--ಕಬಿನಿ",
          "Nandigunda Seasonal Lake and Scrub patch",
          "Nanjanagud Kabini river",
          "Nanjanagudu Bus Station",
          "Nanjangud--General Area (OBI)",
          "Narasambudhi, Nanjangud (ನರಸಾಂಬುಧಿ)",
          "Nature Conservation Foundation office",
          "Nugu Backwaters ನುಗು ಹಿನ್ನೀರು",
          "Nursery, Dhanvanthri Arogyashrama Nanjangudu",
          "Olakere Chikkakeryuru Mysuru, Karnataka, IN (12.14, 76.382)",
          "Omkar range--Bandipur TR",
          "Orange County, Kabini",
          "PHC Hadinaru",
          "Padma Farm",
          "Periyapatna",
          "Periyapattana Chikere ಪಿರಿಯಾಪಟ್ಟಣ ಚಿಕ್ಕೆರೆ",
          "Piriyapattana kere ಪಿರಿಯಾಪಟ್ಟ್ನ ಕೆರೆ",
          "RIE MYSURU",
          "Railway Health Unit, Ashokapuram",
          "Ramakrishna Institute of Moral and Spiritual Education (RIMSE) & RKM Vidyashala",
          "Ramakrishnanagar Mysore",
          "Ramanuja road - Yele thota circle",
          "Rangachari Hundi Kere",
          "Ravandur Kere ರಾವಂದೂರು ಕೆರೆ",
          "Red Earth, Kabini",
          "Regional Museum of Natural History",
          "Regional Museum of Natural History (RMNH), Siddartha Layout",
          "Residence Bidadi, Ramakrishna Nagar H Block",
          "Ring road, Narayana Hrudalaya Hospital, Mysore",
          "Roopa Nagar - Amritha kripa Hospital",
          "SMB layout",
          "Sagarakatte  Bridge, ಸಾಗರಕಟ್ಟೆ ಸೇತುವೆ",
          "Saligrama Kere, ಸಾಲಿಗ್ರಾಮ ಕೆರೆ",
          "Salumarada Thimmakka Park",
          "Sanskrit Patashala, New Sayaji Rao Road , Mysuru, Karnataka, IN (12.299, 76.653)",
          "Sathi Lake",
          "Shakthi Nagar, Mysuru, Karnataka, IN (12.32, 76.697)",
          "Sharada Devi Nagara",
          "Shettanakere, Jantahalli",
          "Shree Bheereshwara Temple ಶ್ರೀ ಬೀರೇಶ್ವರ ಗುಡಿ, Nanagalli ನನಗಳ್ಳಿ",
          "Shree Gluco Biotec",
          "Sidilu Mallikarjuna Betta- Bettadapura,ಸಿಡಿಲು ಮಲ್ಲಿಕಾರ್ಜುನ ಬೆಟ್ಟ- ಬೆಟ್ಟದಪುರ",
          "Silent Shores Resort & Spa",
          "Sindhuvalli, Nanjanagudu (ಸಿಂಧುವಳ್ಳಿ)",
          "Somanathapura",
          "Sri Dharmasthala Manjunatheshwara Institute for Management Development  (SDMIMD)",
          "Sri Lakshmi Venkateshwara Swamy Temple, Yedahalli,  ಶ್ರೀ ಲಕ್ಷ್ಮಿ ವೆಂಕಟೇಶ್ವರ ಸ್ವಾಮಿ ದೇವಸ್ಥಾನ, ಯಡಹಳ್ಳಿ",
          "Sri Omkareshwara Temple Surroundings, Uppinahalli",
          "Subedar kere (Subbayyana kere) ಸುಬೇದಾರ್‌  ಕೆರೆ",
          "Sulekerekaval ಸೂಳೆಕೆರೆಕಾವಲ್",
          "Suttur Kabini Bridge",
          "T Katuru Kere",
          "TVS Factory Campus",
          "Talakadu Kaveri River beach",
          "Talakadu Kaveri River bed ತಲಕಾಡು ಕಾವೇರಿ ನದಿ ಪಾತ್ರ",
          "Talakadu Sethuve Bridge",
          "Talakadu ತಲಕಾಡು",
          "Taraka Reservoir",
          "Tata Mines (Abandoned) Doddakanya",
          "Thavarekatte Lake",
          "Tirumakudalu Narasipura",
          "Ukkalagere kere",
          "Undbuthi Kere (Island Lake) ಉಂಡಬುತ್ತಿ ಕೆರೆ",
          "V-lead, 3rd Main Road, Mysuru, Karnataka, IN (12.354, 76.614)",
          "Vaddagere, Choganahalli",
          "Vaddaragudi Kere ,Gaddige - Hunsur ವಡ್ಡರಗುಡಿ ಕೆರೆ",
          "Vadgal Ranganathaswamy Betta ವಡ್ಗಲ್‌ ರಂಗನಾಥಸ್ವಾಮಿ ಬೆಟ್ಟ",
          "Varakodu Scrub Jungle ವರಕೊಡು ಕುರುಚಲು ಕಾಡು",
          "Varuna Canal Grasslands",
          "Varuna kere (ವರುಣಾ ಕೆರೆ)",
          "Vijaya bank circle to kamakshi hospital",
          "Vijayanagar 4th. stage Mysore",
          "Vijayanagar Extension, Mysore (OBI)",
          "Viveka Tribal Center for Learning Hosahalli, Beeramballi Post, H",
          "Wadiyar Centre For Architecture",
          "Yelwala, Karnataka",
          "Yoga narsimha temple, Vijay nagar Mysore",
          "Yuvarajas College, Mysuru",
          "chidralli lake",
          "hosakamanakoppal ಹೊಸಕಾಮನ ಕೊಪ್ಪಲು",
          "varakodu lake",
          "ಮಾರಮ್ಮನ ಗುಡಿ ಬೀದಿ, ಹದಿನಾರು.",
          "ಹುಯಿಲಾಳು ಕೆರೆ  Huyilalu Lake",
        ],
      },
      {
        district: "Raichur",
        localities: [
          "Antaragangi ಅಂತರಗಂಗಿ",
          "Bedar Karlkunti ಬೇಡರ ಕಾರ್ಲಕುಂಟಿ",
          "Bolmanadoddi Temple ಬೋಳಮಾನದೊಡ್ಡಿ ದೇವಸ್ಥಾನ",
          "CEO ZP Residence ಜಿಪಂ ಸಿಇಒ ನಿವಾಸ",
          "Chandana Kere ಚಂದನ ಕೆರೆ",
          "Chikka Kotnekal ಚಿಕ್ಕ ಕೊಟ್ನೆಕಲ್",
          "Don Bosco School Road, Devadurga ಡಾನ್‌ಬಾಸ್ಕೊ ಶಾಲೆ ರಸ್ತೆ, ದೇವದುರ್ಗ",
          "Googal Bridge ಗೂಗಲ್‌ ಸೇತುವೆ",
          "Gundalbanda Falls ಗುಂಡಲಬಂಡಾ ಜಲಪಾತ",
          "Gurgunta Amareshwara Temple Area ಗುರುಗುಂಟಾ ಅಮರೇಶ್ವರ ದೇವಸ್ಥಾನ ಪ್ರದೇಶ",
          "Huligudda Kere ಹುಲಿಗುಡ್ಡ ಕೆರೆ",
          "Ishwara Temple, Bolmanadoddi Road ಈಶ್ವರ ದೇವಸ್ಥಾನ, ಬೋಳಮಾನದೊಡ್ಡಿ ರಸ್ತೆ",
          "Kolanki ಕೊಳಂಕಿ",
          "Krishna River--Naradagadde island ಕೃಷ್ಣಾ ನದಿ--ನಾರದಗಡ್ಡೆ ದ್ವೀಪ",
          "Krishna river bridge",
          "Lingsugur Kere ಲಿಂಗಸಗೂರು ಕೆರೆ",
          "Maliyabad Gowshala Scrub ಮಲಿಯಾಬಾದ್‌ ಗೋಶಾಲೆ ಕುರುಚಲು ಕಾಡು",
          "Maliyabad Kere ಮಲಿಯಾಬಾದ್ ಕೆರೆ",
          "Mallayyana Gudda, Maski ಮಲ್ಲಯ್ಯನಗುಡ್ಡ, ಮಸ್ಕಿ",
          "Manslapur Kere ಮನ್ಸಲಾಪುರ ಕೆರೆ",
          "Maski Nala Dam ಮಸ್ಕಿ ನಾಲಾ ಜಲಾಶಯ",
          "Mavina Kere ಮಾವಿನ ಕೆರೆ",
          "Merched Kere ಮರ್ಚೇಡ್‌ ಕೆರೆ",
          "N Ganekal Jalashaya ( Bangarappa Kere), ಎನ್ ಗಣೆಕಲ್ ಜಲಾಶಯ (ಬಂಗಾರಪ್ಪ ಕೆರೆ)",
          "Narayanapura Dam ನಾರಾಯಣಪುರ ಆಣೆಕಟ್ಟು",
          "Potgal grasslands ಪೋತಗಲ್ ಹುಲ್ಲುಗಾವಲು",
          "Potnal ಪೋತ್ನಾಳ್",
          "Raichur Bypass Rd, Eklaspur ರಾಯಚೂರು ಬೈಪಾಸ್ ರಸ್ತೆ, ಏಕ್ಲಾಸಪುರ",
          "Raichur Railway Station ರಾಯಚೂರು ರೈಲು ನಿಲ್ದಾಣ",
          "Raichur University",
          "Rajolibanda Diversion Scheme Canal Bridge (Rajalbanda Barrage) ರಾಜೋಳ್ಳಿಬಂಡಾ ತಿರುವು ಯೋಜನೆ ಕಾಲುವೆ ಸೇತುವೆ",
          "Rampur Kere ರಾಂಪುರ ಕೆರೆ",
          "Sanjeevraya betta, ಸಂಜೀವರಾಯ ಬೆಟ್ಟ",
          "Shaktinagar Ash pond",
          "Shaktinagar KPCL quarters",
          "University of Agricultural Sciences ಕೃಷಿ  ಮಹಾವಿದ್ಯಾಲಯ",
          "Yargunti kere ಯರಗುಂಟಿ ಕೆರೆ",
          "ಗವಿ ರಂಗಯ್ಯ ಮಂದಿರ ಕುರುಚಲು ಗುಡ್ಡಗಾಡು / Gavi Rangayya Temple Hillock scrub",
        ],
      },
      {
        district: "Ramanagara",
        localities: [
          "Arkavathi Reservoir",
          "B V Halli Kere, ಬಿ ವಿ ಹಳ್ಳಿ ಕೆರೆ",
          "B.Hosur lake",
          "Bannerghatta NP--Bilikal State Forest Entry Gate",
          "Bannerghatta National Park--Bilikal State Forest, Kodihalli range",
          "Banthimari Betta",
          "Belaguli Hills",
          "Bhimenahalli lake",
          "Bidadi--General Area (OBI)",
          "Bidadi-Kenchanakuppe",
          "Bilikal Rangaswamy Betta",
          "Byjapura Scrub and Grassland",
          "Byramangala Lake, Bangalore",
          "Camp Gee Dee / Vishnu Farm, Ragihalli - 12.721x77.559",
          "Cauvery WLS--Arkavathi Bridge (Sangama)",
          "Cauvery WLS--Benagodu Scrub",
          "Cauvery WLS--Bommasandra",
          "Cauvery WLS--Galibore",
          "Cauvery WLS--General Area",
          "Cauvery WLS--Hegeneru State Forest",
          "Cauvery WLS--Mekedatu",
          "Cauvery WLS--Sangama",
          "Cauvery WLS--Scrub forest east of Arkavathi Bridge (Sangama)",
          "Centre for Learning (CFL), Bengaluru",
          "Chalamasandra",
          "Chamundipura Lake",
          "Channapatna",
          "Channapatna--Kunniru katte",
          "Chiguru Farms",
          "Chikka Byramangala",
          "Chikkondanahalli Kere",
          "Chowkahalli lake",
          "Chulukanabetta, ಚುಳುಕನಬೆಟ್ಟ",
          "Chunchi Falls",
          "Dabbaguli",
          "Doddibetta Peak, Near Bannerghatta Forest",
          "Downstream of Maralwadi Dam",
          "Dubguli Road",
          "Gabbadi Kere",
          "Gabbadi Nursery",
          "Ganaladoddi kere",
          "Gollaradoddi",
          "Gopalpura Kere",
          "Gullahatti Kaval Kere, ಗುಲ್ಲಾಹಟ್ಟಿ ಕಾವಲ್ ಕೆರೆ",
          "Gundemaranahalli Dodda Kere",
          "Halagur, near Kanakapura (OBI)",
          "Handigundi Betta ಹಂದಿಗುಂಡಿ  ಬೆಟ್ಟ",
          "Harohalli (South) Kere",
          "Harohalli Kere",
          "Helligehalli Checkdam  (Yellamma Gulaganji Dam) ಹೆಲಿಗೆಹಳ್ಳಿ ಅಣೆಕಟ್ಟು",
          "Hombalammanapet Kere",
          "Honganuru Kere",
          "Huyalappanahalli",
          "Jalamangala Karnataka",
          "Jalasiddheshwara Betta",
          "KabbalDurga",
          "Kaggalahalli Bande",
          "Kaggalahalli Kere",
          "Kallahalli Kere",
          "Kamat Lokaruchi restaurant, Ramanagara",
          "Kanakapura, Bangalore",
          "Kanakapura--Gadasalli Kere",
          "Kanakapura-Arkavathi River",
          "Kanva Reservoir",
          "Kanva Reservoir North Side",
          "Kengel Hanumanthaiah Tree Park",
          "Keralalusandra Kere",
          "Kudulur Kere, ಕೂಡುಲೂರು ಕೆರೆ",
          "Kumbalagodu lake",
          "Madiwala Shivanankareshwara Temple, Dodda koppa, Kanakapura",
          "Magadi Lake",
          "Managallu Rocky Hillock ಮಾನಗಲ್ಲು ಬೆಟ್ಟ",
          "Manchanabele Reservoir, Bangalore",
          "Maralebekuppe Kere",
          "Maralwadi Dam, ಮರಳವಾಡಿ ಜಲಾಶಯ",
          "Mavathur Kere, Kanakapura",
          "Mudagere",
          "Muninagara Kere & Surroundings",
          "Muthurayapura",
          "Mutturayanaswami Betta ಮುತ್ತುರಾಯಸ್ವಾಮಿ ಬೆಟ್ಟ",
          "Narayanagiri Betta, Jalamangala",
          "Nayakanahalli--The Backyard Camp",
          "Nayakanapalya Lake",
          "Nelligudde Kere",
          "Nelligude Kere--Kakramanahalli side",
          "Nethenahalli Kere  ನಿತನಹಳ್ಳಿ ಕೆರೆ",
          "Odakae Kere",
          "Pyramid Valley",
          "Ragihalli",
          "Ragihalli Sunrise Point",
          "Ramamman Kere, ರಾಮಮ್ಮನ  ಕೆರೆ",
          "Ramanagara Tree Park ಅರಣ್ಯ ಇಲಾಖೆ ಉದ್ಯಾನವನ",
          "Ramanagara--Powlidoddi kere",
          "Ramdevara Betta, Ramanagara",
          "Ramdevara Betta, Ramanagara--Ramanagar Climbing Spot",
          "Ravagodlu Betta",
          "Ravuthenahalli Lake",
          "Sangama - Mutthatthi Road",
          "Savanadurga Forest - Manchanabale Road",
          "Savanadurga Peak",
          "Savanadurga State Forest",
          "Savanadurga State Forest--Thagachaguppe Landscape (ತಗಚಗುಪ್ಪೆ)",
          "School of Engineering and Technology - (SET JU)",
          "Seshagirihalli lake",
          "Shree Gavi Ranganathaswami Gudi",
          "Shri Bettada Thimmappa Swamy Temple",
          "Shri Lakshmi  Narasimhaswamy Betta, Bachahalli",
          "Shri Siddeshwara Siddapaji Temple, Udarahalli",
          "Shyanumangala Kere, ಶ್ಯಾನುಮಂಗಲ  ಕೆರೆ",
          "Siddadevarabetta State Forest",
          "Sri Flora Farm",
          "Sri Revanasideshwara (SRS) Hills",
          "Suddakatte Kere",
          "Suvarnamukhi Reservoir",
          "Thattekere Lake",
          "Thenginakallu State Forest , ತೆಂಗಿನಕಲ್ಲು ಸ್ಟೇಟ್ ಫಾರೆಸ್ಟ್",
          "Thippasandra Lake, Ramnagara Dist.",
          "Thorn forest before bridge (White-naped Tit)",
          "Uyyamballi Kere (Temple on Lake)",
          "Vaade Malleshwara Betta, ವಾಡೆ ಮಲ್ಲೇಶ್ವರ ಬೆಟ್ಟ",
          "Vadakekatte Village Pond",
          "Vaderahalli tank, off Kanakapura Road",
          "Vrishabhavathi River Viewpoint",
          "Yadamaranahalli Lake",
          "stakeout European Bee-eater, Budiguppe (2024-11)",
        ],
      },
      {
        district: "Shivamogga",
        localities: [
          "Agumbe Rainforest Research Station (ARRS)",
          "Agumbe--Grassland",
          "Agumbe--Jogi Gundi Waterfall",
          "Agumbe--Onake Abbi Trail",
          "Agumbe--Rural & Surrounding",
          "Ambligola Reservoir",
          "Araballi",
          "Beguvalli Lake",
          "Bharathipura, Yadagudde",
          "Bypass Bridge, Bhadravathi",
          "Daralagodu",
          "Fish Breeding Centre, Singanamane",
          "Gaani Kere, Anandapuram",
          "Gajanur State Forest",
          "Gondi Checkdam, kaiga",
          "Gowri Kere",
          "Gudavi Bird Sanctuary",
          "Gudavi Bird Sanctuary, Karnataka",
          "Harnahalli",
          "Heggodu",
          "Hidlumane Falls",
          "Hingaara - The Nature Stay",
          "Hire Kere ಹಿರೇ ಕೆರೆ",
          "Hire kere",
          "Hosanagara",
          "Hosanagra",
          "Hutta Riverside , Bhadravathi",
          "Ikkeri bellur",
          "JLR, Sakrebyle",
          "Jog Colony-ಜೋಗ ಕಾಲೋನಿ",
          "Jog Falls ಜೋಗ ಜಲಪಾತ",
          "Kadekal Forest ಕಡೆಕಲ್ ಅರಣ್ಯ",
          "Kalinga Centre for Rainforest Ecology",
          "Kavaledurga Fort",
          "Kavaledurga Kere",
          "Keladi Hire Kere",
          "Khaji Garden Park",
          "Kodachadri Nature Retreat",
          "Kodachadri, Kaarekatte",
          "Kundadri Hills",
          "Kuntinamadu ಕುಂಟಿನಾಮದು",
          "Kuppali",
          "Kuvempu University Campus",
          "Mahalakshmi Temple, Indavara",
          "Malanduru",
          "Matthur Village",
          "Mattur kere, ಮತ್ತೂರು ಕೆರೆ",
          "Muduvalli",
          "Mukthi Hariharapura ಮುಕ್ತಿ ಹರಿಹರಪುರ",
          "Muppane, Shimoga",
          "Nagara fort",
          "Narasipura kere, ನರಸೀಪುರ ಕೆರೆ",
          "Navilkall",
          "Neechadi",
          "NeeralaKoppa, Bhadravathi",
          "Nilskal, Hosanagara",
          "Nittur",
          "Othighatta Kere, ಓತಿಘಟ್ಟ ಕೆರೆ",
          "Paradise Wild Hills Resort",
          "Play ground highschool",
          "Prashanta Vanam",
          "Purdal Dam",
          "Sagara",
          "Sakrebyle Elephant Camp",
          "Seebina Kere, Thirthahalli",
          "Sharavathi Adventure Camp, Jungle Lodges and Resorts",
          "Sharavathi Wildlife Sanctuary",
          "Sharavati Valley WLS",
          "Sharavati Valley WLS--KB Circle",
          "Shivamogga Airport ಶಿವಮೊಗ್ಗ ವಿಮಾನ ನಿಲ್ದಾಣ",
          "Shri Gutti Renukamba Devi Temple, Agrahara ಶ್ರೀ ಗುತ್ತಿ ರೇಣುಕಾಂಬ ದೇವಿ ಮಂದಿರ",
          "Singara Madilu ಸಿಂಗಾರ ಮಡಿಲು",
          "Sogane Kere ಸೋಗನೆ ಕೆರೆ",
          "Sudurugaate, ಸುಡುರುಗಾಟೆ",
          "Talakalale Balancing Reservoir, Sagara",
          "Thimmanayakana kere",
          "Thunga River -Kushavati , ತುಂಗಾ ನದಿ -ಕುಶಾವತಿ",
          "University of Agricultural and Horticultural Sciences--Guest House area, Shivamogga",
          "University of Agricultural and Horticultural Sciences--IFS Unit, Shivamogga",
          "highschool garden THIRTHAHALLI",
        ],
      },
      {
        district: "Tumakuru",
        localities: [
          "Aladamaradapalya Kere (ಆಲದಮರದಪಾಳ್ಯ ಕೆರೆ)",
          "Albur Kere",
          "Amaani Kere, Tumkur",
          "Amruthur Chikka Kere ಅಮೃತೂರು ಚಿಕ್ಕೆರೆ",
          "Anchepalya Kere",
          "Arakere Kere (ಅರಕೆರೆ ಕೆರೆ)",
          "Aramanekallu Betta",
          "Baddihalli kere",
          "Ballekere",
          "Bamboo Forest, Devarayandurga",
          "Bheemasandra Kere, Tumkur",
          "Borana Kanive (Lakkenahalli Kere)",
          "Bugudanahalli",
          "Bukkapatna Chinkara Wildlife Sanctuary (restricted access)",
          "Bukkapatna Chinkara Wildlife Sanctuary--Base of Fan Road (restricted access)",
          "Bukkapatna Chinkara Wildlife Sanctuary--Fan Road Kere (restricted access)",
          "Bukkapatna Chinkara Wildlife Sanctuary--Siddapura Kere",
          "Byadarahalli Lake",
          "Bylanjaneya Swamy Temple  Koratagere",
          "Camp Shristi, Kamalapura",
          "Channarayana Durga Fort",
          "Chikkabidare Kere",
          "Chikkasandra State Forest",
          "Chikkayalkur Lake",
          "Chinaga Betta",
          "Cholenahalli Kere",
          "Deepambudhi Lake",
          "Devarayanadurga State Forest--Namada Chilume",
          "Devarayanadurga- Foothills,  ದೇವರಾಯನದುರ್ಗ- ತಪ್ಪಲು",
          "Deverayanadurga State Forest",
          "Doddaguni lake",
          "Doddasaggere Botanical Garden",
          "Doddenahalli",
          "Dodmallur Lake",
          "Echanuru Tank",
          "Forest Guest House, Bukkapatna Range",
          "GK Hostel, ಜಿಕೆ ಹಾಸ್ಟಲ್",
          "Gangadareshwara Kere (Lake), Koratagere",
          "Gangasandra kere ಗಂಗಸಂದ್ರ ಕೆರೆ",
          "Gangsandra tank",
          "Girigondanahalli",
          "Goobalagutte Kere",
          "Gubbi Lake",
          "Gubbi--Mukanahallipatna Kere",
          "Guleharavi kere",
          "Hebbaka Kere (ಹೆಬ್ಬಾಕ ಕೆರೆ)",
          "Hebbaka Reservoir (ಹೆಬ್ಬಾಕ ಜಲಾಶಯ )",
          "Honnamachanahalli Lake",
          "Horticultural Area Lake",
          "Huliyurudurga, Kungal Taluk, Tumkur Dt",
          "Hunaseghatta Kere",
          "Hutridurga",
          "Indiahikes Camp--Channarayana Durga Fort",
          "Irakasandra",
          "JK Memorial Central School Road",
          "Jayamangali Blackbuck Conservation Reserve ಜಯಮಂಗಲಿ ಕೃಷ್ಣಮೃಗ ಸಂರಕ್ಷಣಾ ಪ್ರದೇಶ",
          "Jayamangali River",
          "K Palasandra",
          "Kadaba Lake (Ambarapura)",
          "Kaggaladu Bird Sanctuary",
          "Kallembella Kere",
          "Kannughatta Kere",
          "Karadi Kere",
          "Kardi, Tumkur",
          "Kestur lake",
          "Kodi Lakkamma Devi Temple",
          "Konthihalli Lake",
          "Kothagere Kere (13.053, 77.027)",
          "Kotta Lake",
          "Kunigal Dodda Kere ಕುಣಿಗಲ್‌ ದೊಡ್ಡಕೆರೆ",
          "Kunigal Stud Farm",
          "Kunigal--Begur Amanikere",
          "Lakkenahalli Lake",
          "Machaghatta",
          "Madhugiri Betta",
          "Madhugiri Scrub Forest",
          "Malapanahalli Betta Voddagere",
          "Mallaghatta Lake",
          "Malleshapura",
          "Mandaragiri/Basadi Betta",
          "Maralenahalli Kere (ಮಾರ್ಲೇನಹಳ್ಳಿ ಕೆರೆ)",
          "Maralur kere",
          "Markonahalli Reservoir ಮಾರ್ಕೋನಹಳ್ಳಿ ಜಲಾಶಯ",
          "Mavathuru Lake",
          "Mayasandra Kere",
          "Mayasandra Paddyfields",
          "Melekote lake, Tumkur",
          "Muthurayana Kere ಮುತ್ತುರಾಯನ ಕೆರೆ,  Tumkur Dt",
          "Mydala Kere",
          "Mydala Reserve Forest",
          "Nonavinakere",
          "Nonavinakere Paddyfields, Tiptur Taluk",
          "Palavalli Thanda Grassland",
          "Pavagada",
          "Ramadevara Betta",
          "Rangaswamy Bettada Kaval Forest ರಂಗಸ್ವಾಮಿ ಬೆಟ್ಟದ ಕಾವಲು ಪ್ರದೇಶ",
          "Road to Yednambeel Kere (Checkdam)",
          "Salakatte, ಸಾಲಕಟ್ಟೆ",
          "Salapura Kere",
          "Seebi Forest ಸೀಬಿ ಆರಣ್ಯ",
          "Seebi Narasimhaswami Temple ಸೀಬಿ ನರಸಿಂಹಸ್ವಾಮಿ ದೇವಸ್ಥಾನ",
          "Siddara Betta, ಸಿದ್ದರ ಬೆಟ್ಟ",
          "Sira Fort",
          "Soolanaikanahalli  ಸೂಲನೈಕನಹಳ್ಳಿ",
          "Srirampura Lake",
          "Srirampura lake--Puravara to ID Halli Road",
          "Suli Kere",
          "Suttu Kanive, Chikkanayakanahalli",
          "TVS School, Pandithanalahalli, Tumkur",
          "Talakere",
          "Theetha Kere",
          "Theja Farm",
          "Thimmalapura lake (ತಿಮ್ಮಲಾಪುರ ಕೆರೆ)",
          "Thimmegowdanapalya ತಿಮ್ಮೇಗೌಡನಪಾಳ್ಯ",
          "Thimmlapura Wildlife Sanctaury",
          "Thippanahalli kere (ತಿಪ್ಪನಹಳ್ಳಿ ಕೆರೆ)",
          "Thippapura Cross",
          "Tiptur",
          "Tiptur (OBI)",
          "Tumbadi Kere",
          "Turuvekere--Chikkapura",
          "Turuvekere--Hulikere",
          "Yadavani, ಯಡವಾಣಿ, Tumkur Dt",
          "kunigal chikkere ಕುಣಿಗಲ್‌ ಚಿಕ್ಕೆರೆ",
        ],
      },
      {
        district: "Udupi",
        localities: [
          "Aanejari Butterfly Camp - JLR",
          "Agasana Kere",
          "Agumbe--Barkana View Point",
          "Ancestral Naga Temple and surrounds - Badagabettu",
          "Anejari Butterfly Camp ಆನೆಝರಿ ಚಿಟ್ಟೆ ಕ್ಯಾಂಪ್‌ -Mookambika WLS ಮೂಕಾಂಬಿಕಾ ವನ್ಯಜೀವಿಧಾಮ",
          "Anekere Lake, Karkal, Karnataka",
          "Arasinagundi Falls trekking/jeep track",
          "Asare Beach",
          "Babbukudru Island",
          "Bachanabailu Grasslands",
          "Badagabettu",
          "Badanidiyoor-Paddy fields-Wetlands",
          "Badthingale Trail",
          "Baggu Panjurli Daivasthana Road",
          "Bailakere Paddyfields",
          "Bailur high school, Karkala",
          "Baje Dam",
          "Bankerkatta Paddyfields",
          "Bantakal (OBI)",
          "Barkur Wetlands ( ಬಾರ್ಕೂರು)",
          "Barkur Wetlands -- Bobbarya Temple",
          "Barkur Wetlands--Saasthana ( ಬಾರ್ಕುರು)",
          "Basil Cafe, manipal",
          "Belman",
          "Belmar -- General",
          "Bhandarkeri Matha, Barkur",
          "Bobbarya Paade Devastana",
          "Brahmalingeswara Temple, Seethanadi",
          "Byndoor Village",
          "Chak Paade, Kalmady",
          "D'Sa Camp Site- Unnamed Road, Moodalkatte, Karnataka, IN (13.611, 74.725)",
          "Dalantre Lake, Yallur, Mudarangadi",
          "Dasharath Nagar -- Arbi Falls side",
          "Dashrath Nagar",
          "Dashrath Nagar - MIT laterite slope",
          "Dr. B R AMBEDKAR RESIDENTIAL SCHOOL",
          "Durga Reserved Forest - temple area, Karkala",
          "Durga Village, Karkala",
          "Durga Water Falls",
          "Durga-Ambha Bhavani Temple Road, karkala, Karnataka",
          "Eedu, Kudremukh NP, Karnataka",
          "Eshwar Nagar - Kela Perkala",
          "Eshwar Nagar, Manipal",
          "Gangoli",
          "Golikatte",
          "Gujjarbettu Beach",
          "Gujjarbettu Paddyfields",
          "Gundibailu Paddyfields",
          "Gundmi Village -- General",
          "Gundupade Hill and surrounds, Marne",
          "Heradi-wetlands (ಹೇರಾಡಿ)",
          "Herga",
          "Herga Temple Road, Herga",
          "Herikere",
          "Herooru (ಹೇರೂರು) Wetlands",
          "Hirebettu Road",
          "Hoode - Kodi Bengare Road - Delta Beach",
          "Hoode beach",
          "Hoothale Bird View Point, Koni, Kundapura",
          "Hoovinakere Vadiraja Mata",
          "Hosala, Barkur.",
          "Indrali Temple Road",
          "Irvatthur",
          "Kabbinale",
          "Kadekar Grasslands",
          "Kallianpur Bridge, ಸಂತೆಕಟ್ಟೆ ಸೇತುವೆ",
          "Kallianpura, Udupi",
          "Kalmady Bridge, Udupi-Malpe road",
          "Kambala Katta Trail, Havanje",
          "Kanda (Paddyfields), Kemthoor",
          "Kanthavara Forest Basecamp",
          "Kapu (Kaup) Beach",
          "Karkala--Durga Harihareshwara Temple",
          "Karkala--General Area (OBI)",
          "Karwal Dumping Yard",
          "Kasturba Medical College",
          "Kathyayani Nagar (ಕಾತ್ಯಾಯನಿ  ನಗರ)",
          "Keelanje Mahavishnu Mahalingeshwara Temple, ಕೀಳಂಜೆ ಮಹಾವಿಷ್ಣು ಮಹಾಲಿಂಗೇಶ್ವರ ದೇವಸ್ಥಾನ",
          "Kelanejar Paddyfields",
          "Kemmannu -- Gujjarabettu Paddyfields",
          "Kemthoor -- Hanging Bridge and Check Dam",
          "Kemthur Jelly Crusher Area",
          "Kemthur-PaduAlevoor Gadi (Border), Udupi",
          "Kerebail-  Dabbekatte, Halady Road",
          "Keshavanatheshwara Temple, Keradi",
          "Kidiyoor Garadi and surroundings",
          "Kodi Beach",
          "Kodi Bengare--Delta Point",
          "Kodi Delta Point & Sea Walk ಕುಂದಾಪುರ ನದಿ ಸಾಗರ ಸಂಗಮ ಪ್ರದೇಶ",
          "Kodi bengre-Kemmannu , Udupi, Karnataka",
          "Kodi--Kundapura",
          "Kolachekambala Mulki",
          "Kome -- General Area",
          "Koodluthirtha (Seetha Falls) , Someshwara, Karnataka",
          "Kudremukh -- Kurinjal Peak",
          "Kudremukha NP--Maala Village",
          "Kundapur Coast (OBI)",
          "Kundapura Inland Jetty ಕುಂದಾಪುರ ಒಳಬಂದರು",
          "Kurkal (Kurkalu) -- River",
          "Kurkalu Reserve forest, Udupi, Karnataka, IN (13.285, 74.775)",
          "Kurkalu temple, Udupi",
          "Magadha Vana, Pernoli",
          "Mahatma Gandhi Memorial College, Udupi",
          "Makodi - shirur",
          "Malebettu, Durga Village, Karkala, Karnataka",
          "Malpe New Port",
          "Malpe port, Udupi, Karnataka",
          "Malpe, Town Area",
          "Malpe-Mattu Road (spot 2), Mattu",
          "Malyadi lake, Kundapura",
          "Manchi Road",
          "Manchikere",
          "Mande Chavadi",
          "Manipal Campus--Library Surroundings",
          "Manipal Institute of Communication",
          "Manipal Institute of Technology",
          "Manipal Lake",
          "Manipal Pre University College (aka MJC)",
          "Manipal--End Point",
          "Manipal--General Area (OBI)",
          "Maravanthe beach, kundapura",
          "Mattu -- Bridge Area",
          "Mattu Beach",
          "Mepalkere  ಮೇಪಲಕೆರೆ",
          "Mookambika Temple, Kollur",
          "Mookambika Wildlife Sanctuary",
          "Mother Teresa Memorial School",
          "Mudradi Water Stream",
          "Muniyal, Karkala (OBI)",
          "Naila Paade Bridge",
          "Nakre - Karkala",
          "Narnadu Madaga, Ammunje",
          "Neelavara Mahishamardini Temple Rd",
          "Neramballi Krishna Mutt",
          "Nitte",
          "Padubidri End Point",
          "Padukere Beach",
          "Pancha gangavalli",
          "Pandeshwara, Sasthana",
          "Parari, Manipal",
          "Parkala — Garson Junction",
          "Parkala-Devasthanabettu",
          "Peace Beach",
          "Pelagic HotSpot, Udupi Coast, Karnataka, IN (13.35, 74.66)",
          "Pelagic HotSpot, Udupi, In: 13.4-74.1",
          "Pelagic HotSpot, Udupi, In: 13.4-74.2",
          "Pelagic HotSpot, Udupi, In: 13.4-74.3",
          "Pelagic HotSpot, Udupi, In: 13.4-74.4",
          "Pelagic HotSpot, Udupi, In: 13.4-74.5",
          "Pelagic HotSpot, Udupi, In: 13.4-74.6",
          "Perampalli Marga -- Manipal",
          "Perupade Rock Point (ಪೆರುಪಾದೆ, ನಡುಅಲೆವೂರು) Alevoor, Udupi",
          "Pethri",
          "Pilarkhana, Shirva ಪಿಲಾರುಖಾನ",
          "Pithrody Village Grasslands",
          "Pithrody village",
          "Pottu Kere",
          "Pragathi Nagar",
          "Preethi Farms",
          "Quarters, Near A2 Flats, MIT Campus, Manipal",
          "Rajeev Nagar School Road - Manipal",
          "Ramasamudra , karkala",
          "SDM Ayurvedic College Campus, Udupi",
          "SIBM -- vicinity",
          "Sagri Nole Paadi",
          "Sankesha Mandir Road",
          "Saralebettu, Manipal",
          "School of Life Sciences--Manipal Campus",
          "Sea Walk Gangoli",
          "Seethanadhi Nature camp, Someshwara WLS, Karnataka",
          "Shanthi Nagar - Navarra Colony",
          "Shanthi Nagar -- Laterite Patch",
          "Sharadanagar",
          "Sharmada near Babbuswamy Temple",
          "Shettybettu 1 -- Bobbarya Sthana temple side",
          "Shettybettu 2",
          "Shettybettu 3 Parkala School Side",
          "Shirva--General Area (OBI)",
          "Shravani Homestay",
          "Someshwara - Byndoor",
          "Someshwara Wildlife Sanctuary - Byndoor",
          "Souparnika River-- Sampre Shri Ganapathi Temple",
          "Sri Bhuvanendra College, College Road, Karkala, Karnataka",
          "Sri Bobbarya Temple, Ankadakatte",
          "Sri Narasimha Temple, Narsinge",
          "St Mary's Island",
          "St. Mary's Island, Udupi",
          "TAPMI Campus",
          "TAPMI Road",
          "Tallur Mangrove Patch",
          "The Concerned for Working Children Namma Bhoomi, Kundapura",
          "Thodalli village, ತೋಡಲ್ಲಿ",
          "Turtle Bay Beach Resort",
          "Udupi Bus Station",
          "Udupi--General Area (OBI)",
          "Upper Durga Village, Karkala, Karnataka",
          "Uppoor",
          "VK Shetty Bird-bath, Hebri",
          "Vaada Bandhar, Baputhota - Malpe",
          "Valley Flats and Marena Slope",
          "Vanake Abbey falls (foot)",
          "Varanga Jain temple tank",
          "Vedvyasanagar, Udyavar, Karnataka, IN (13.313, 74.743)",
          "Vidyarathna Nagar --  Behind Nakshatra Apartments",
          "Vidyarathna Nagar -- Acharya Compound",
          "Vinayak Temple, Manipal",
          "Yerlapady",
          "Yerlapady, Karkala",
          "kunjibettu, near MGM college",
          "yerlapady, Karakala",
        ],
      },
      {
        district: "Uttara Kannada",
        localities: [
          "AMARA Homestay, Kariyadi, Karnataka",
          "APMC Siddapura",
          "ARS Paddyfields, Sirsi",
          "Aghanashini Estuary - Jetty ಅಘನಾಶಿನಿ ಜೆಟ್ಟಿ",
          "Aghanashini Estuary- Betkuli Gazani ಬೆಟ್ಕುಳಿ ಗಜನಿ",
          "Aghanashini Estuary- Gokarna--Sanikatta-  ಸಾಣಿಕಟ್ಟಾ",
          "Aghanashini Estuary- Masur Wetlands (ಮಾಸೂರು ಜೌಗುಪ್ರದೇಶ), Kumta",
          "Aghanashini Estuary- Tadadi",
          "Aghanashini Estuary-Bargi Gazani ಬರ್ಗಿ ಗಜನಿ",
          "Aghanashini Estuary-Chittekambi ಚಿಟ್ಟೆಕಂಬಿ",
          "Aghanashini Estuary-Jestapura  Baada  ಜೇಷ್ಟಾಪುರ ಬಾಡ",
          "Aghanashini Estuary-Nushikote Mangroves ನುಶಿಕೋಟೆ ಕಾಂಡ್ಲಾ",
          "Aghanashini Estuary-Taribagilu, Hegde",
          "Aligadda Beach, Karwar",
          "Amarde, Dandeli",
          "Anagod Reserve Forest",
          "Angadibail",
          "Anmod",
          "Anshi NP",
          "Anshi Nature Camp",
          "Areca County",
          "Aresami Lake and surroundings",
          "Arre Laterite Plateau (ಅರೆ ಲ್ಯಾಟರೈಟ್)",
          "Asnoti",
          "Attiveri Bird Sanctuary",
          "Bada Kanshirada Lake, Dandeli",
          "Badagani River Wetlands (ಬಡಗಣಿ ನದಿ ಜೌಗು ಪ್ರದೇಶ)",
          "Baithkol Harbour , uttarakannada",
          "Barki Bridge",
          "Bekkinajaddi",
          "Belekeri Beach - ಬೇಲೆಕೇರಿ ಬೀಚ್",
          "Belekeri Laterites (Restricted Area-NAVY) ಬೇಲೇಕೇರಿ",
          "Bhattarakeri (Battagere)",
          "Binaga, ಬಿನಗ",
          "Birds Paradise",
          "Bison River Resorts",
          "Bommanahalli Reservoir",
          "Boribaag (Siddar - Kinnar Road)",
          "CGH Earth Gokarna",
          "Camp Riveredge Paradise -ಹೊಳೆದಂಡೆ ಸ್ವರ್ಗ ಬಿಡಾರ",
          "Castle Rock",
          "Castle Rock Forest Range",
          "Chapakhand Village",
          "College of Forestry",
          "Dandeli",
          "Dandeli Jungle Safari",
          "Dandeli Kali Jungle Stay",
          "Dandeli Milind's Hideout, Kondapa, Dandeli, Karnataka, IN",
          "Dandeli WLS, Karnataka",
          "Dandeli Wildcraft Resort Trail",
          "Dandeli Wildlife Sanctuary ದಾಂಡೇಲಿ ವನ್ಯಜೀವಿಧಾಮ",
          "Dandeli Wooden Cafe Homestay",
          "Dandeli, Anshi WLS, Karnataka",
          "Dandeli--Circuit House",
          "Dandeli--Timber Depot",
          "Dept of Marine Biology, Kodibag, uttarakannada",
          "Devbag Beach",
          "Devbag Creek",
          "Devbagh -- Devbagh Beach Resort (Jungle Lodges)",
          "Devbagh--Mudflats",
          "Devinilaya,Sirsi",
          "Devkar Falls",
          "Dharma Reservoir",
          "Dhobighat Road (Hill trail)",
          "Dr AV Balliga College Of Arts And Science",
          "Duggur ದುಗ್ಗೂರು",
          "E.I.D Parry Sugars (India) Campus, Alolli, Haliyal [Restricted Access]",
          "Eco Beach Kasarkod",
          "Flycatcher Adventures & Resorts, Dandeli",
          "Ganeshgudi Jungle Lodge",
          "Ganeshgudi village",
          "Gavegali, ಗವೇಗಾಳಿ",
          "Gersoppa",
          "Ghadiyal Lake",
          "Gokarna Beach",
          "Gokarna Main Beach",
          "Gopashitta, Karwar  ಗೋಪಶಿಟ್ಟ",
          "Gore Laterites, ಗೋರೆ ಮುರಕಲ್ಲು",
          "Gotegali Pond",
          "Gotegali- Butterfly Park",
          "Govt. Arts & Science College, Karwar",
          "Green World Resort",
          "Gudnapura lake,Sirsi-Banavasi Road,Karnataka",
          "Halga and Ulaga village, Kaiga",
          "Haliyal",
          "Haliyal Kote (Fort)",
          "Halkar ಹಳಕಾರ್",
          "Handigon Beach and Grasslands (ಹಂದಿಗೋಣ)",
          "Hanumanth Pond, E.I.D Parry (India) Campus, Alolli, Haliyal [Restricted Access]",
          "Haranoda, Dandeli",
          "Haroor",
          "Hartuga",
          "Hawgi Kere, Haliyal",
          "Hawgi/ Haliyal  Kere",
          "Hayagreeva Samudra, Sonda",
          "Hebbal, Bird Watch Tower",
          "Heepalli, Sirsi, Karnataka",
          "Hegale-  Siddapur Road,  ಹೆಗಲೆ- ಸಿದ್ದಾಪುರ ರಸ್ತೆ",
          "Hegde, Kumta",
          "Heggarani",
          "Honnavar (OBI)",
          "Honnavar -Tolasani Road",
          "Honnavara  Railway Station",
          "Honnavara--Kellengere",
          "Honnavara--Pavinakurve Paddyfields",
          "Honnavara--Ramteertha",
          "Honnavara--Royalkeri",
          "Honnavara--Vilayti",
          "Hornbill Dust Bath Site",
          "Hornbill River Resort",
          "Hornbill River Resorts",
          "Hosad Forest, Kumta",
          "Hosalli Kere",
          "Hotegali Dam",
          "Idgundi-Kaiga road",
          "Irpage, Kaiga",
          "Isloor Forest, Sirsi",
          "Isloor Kere",
          "Jackwell, Near Supa Dam, Ganeshgudi",
          "Jamba",
          "Jamba Road",
          "Jatayu Teertha",
          "Jungle Lodges and Resort, Dandeli",
          "Kaadumane Honey Park, ಕಾಡುಮನೆ ಜೇನುತುಪ್ಪ ವನ  Joida",
          "Kaankere",
          "Kadathoka (ಕಡತೋಕ)",
          "Kadra  Dam Road, Kaiga, karnataka",
          "Kadra Dam",
          "Kadra Depot",
          "Kadra Park",
          "Kadumane Homestay",
          "Kadumane Homestay, Dandeli",
          "Kaduvinakatte Dam",
          "Kagal, kumta",
          "Kaiga",
          "Kaiga Township",
          "Kaiga Township, Kaiga",
          "Kaiga cross, Check post",
          "Kaiga power  station, kaiga",
          "Kailasa Gudda Road (ಕೈಲಾಸ ಗುಡ್ಡ ರಸ್ತೆ)",
          "Kali Adventure Camp, Dandeli",
          "Kali Estuary, Karwar",
          "Kali River (white water rafting)",
          "Kali River Bridge, Badgund",
          "Kali Tiger Reserve",
          "Kali Tiger Reserve--Kulgi",
          "Kali Tigre Reserve",
          "Kanasgiri",
          "Kapageri Deciduous Forest (ಕಪಗೇರಿ ಪತನಶೀಲ ಕಾಡು)",
          "Karikana Forest Range, Honnavara",
          "Karwar Beach - Garden",
          "Karwar Beach - Pavilion Area, uttarakannada",
          "Karwar Beach - South End",
          "Karwar Beach--General Area (OBI)",
          "Karwar Beach--North End",
          "Karwar Post Office, uttarakannada",
          "Kasarwadi, ಕಾಸರವಾಡಿ",
          "Kasurkud (OBI)",
          "Katgar Koppa  ಕಾಟ್ಗಾರ್ ಕೊಪ್ಪ",
          "Kavadikere lake, Magod falls road, Sirsi",
          "Kavalwada Kere",
          "Kavla Caves",
          "Kelaginakeri Wetlands and Paddyfields",
          "Kelaginuru Laterite Plateau (ಕೆಳಗಿನೂರು ಲ್ಯಾಟರೈಟ್)",
          "Kerakai Forest --Sirsi",
          "Kerwadi",
          "Kerwadi Lake, Kaiga",
          "Keshava Temple, Hulase  ಹುಳಸೆ",
          "Khandagara Village,  ಖಂಡಗಾರ",
          "Kharge Joog",
          "Kirawatti Timber Depot (ಕಿರವತ್ತಿ ಟಿಂಬರ್ ಡೆಪೋ)",
          "Kodasalli Reservoir",
          "Kodibag Jetty",
          "Kodibag forest office, karwar",
          "Konekarwada, Karwar",
          "Kota, Anantawadi village",
          "Koti Teertha, Gokarna",
          "Kudle beach,Gokarna,Uttarkannada,Karnataka,India",
          "Kulgi",
          "Kulgi Nature Camp",
          "Kulgi Nature camp",
          "Kulgi nature camp trail",
          "Kumta Beach",
          "Kumta Fish Market",
          "Kumta Mangrove Forest & Wetlands (ಕುಮಟಾ ಕಾಂಡ್ಲಾ ವನ)",
          "Kumta--Arre Grasslands",
          "Kumta--Kadnir",
          "Kumta--Kallabbe Cross",
          "LTM Eco Camp",
          "Maddmakki",
          "Madhuvan Homestay",
          "Madkibail Laterite Plateau (ಮಡ್ಕಿಬೈಲ್ ಲ್ಯಾಟರೈಟ್)",
          "Magod Falls, Sirsi, Karnataka",
          "Majali Pond",
          "Mattighatta",
          "Medini Cross",
          "Mirjan - Khandagar Road, Nagur",
          "Mogli Homestay, Kelaginuru",
          "Morse ಮೊರ್ಸೆ",
          "Mudgeri Dam",
          "Mudgi - Kalave, ಮುಡ್ಗಿ - ಕಲವೆ",
          "Mugali Laterites ಮುಗಳಿ",
          "Mundalli Ara (Laterite landscape)",
          "Mundigekere Bird Sanctuary",
          "Murkwada  kere",
          "Muroor, Kumta",
          "Murudeshwar",
          "Nadimane Cottages, Dandeli ನದಿ ಮನೆ ತಂಗುದಾಣಗಳು  ದಾಂಡೇಲಿ",
          "Nagarakodi",
          "Nagarkodi Pragati Home stay",
          "Nakhuda Beach",
          "Naval Beach Karwar",
          "Neer Honda Cross, Khandagara Road",
          "Nelavanki Laterites ನೆಲವಂಕಿ",
          "Netrani Island",
          "Nilkod - Laterite Patch",
          "Nilkod ನೀಲಕೋಡ್",
          "Nisarga Guest House",
          "Nivli-Shirve",
          "Off The Grid Homestay",
          "Old Magazine House, Ganeshgudi",
          "Old magazine house",
          "Om Beach, Gokarna",
          "Oyster Rocks (Devgad Island)",
          "Paswan Pond, E.I.D Parry (India) Campus, Alolli, Haliyal [Restricted Access]",
          "Pavinkurva South (Hanging Bridge), Karki",
          "Phansoli",
          "Pigeon Island, Murudeshwara",
          "Pragati Home Stay,Nagarkodi",
          "Prashu's Home, Kaiga Township",
          "Rayara Kere and Surroundings",
          "Red Earth - Gokarna",
          "Sahasralinga",
          "Santhe Gadde ಸಂತೆಗದ್ದೆ",
          "Sathoddi Falls",
          "Sathwik Homestay, Sirsi",
          "Seegekeri ಸೀಗೆಕೇರಿ, Yellapura Taluk ಯಲ್ಲಾಪುರ ತಾಲೂಕು",
          "Shantadurga Mineral Industries",
          "Sharavathi WLS--Malemane",
          "Sharavathi Wildlife Sanctuary",
          "Shille, ಶಿಳ್ಳೆ",
          "Shinagudda ಶಿನಗುಡ್ಡ",
          "Shingewadi",
          "Shiraley water falls - Yellapura",
          "Shirali--Neerkanta",
          "Shirve",
          "Siddar-Kinnar Road",
          "Sirsi--Konesar",
          "Sonarkeri Wetland",
          "Sonarwada Baad",
          "Sonda Kere",
          "Subhadra Hotel",
          "Sunkeri Backwaters",
          "Supa Dam, Ganeshgudi",
          "Sykes Point",
          "Syntheri Rocks, Gund, Karnataka, India",
          "Taragodu Deciduous Forest, Kumta (ತಾರಗೋಡು ಪತನಶೀಲ ಕಾಡು)",
          "The Niche - Malnad Farmstay",
          "Tilmati Beach, Karwar",
          "Timber Depot Dandeli",
          "Tonka Beach and Estuaries",
          "Toppalakeri, Karki, Honnavara",
          "Ulvi , Anshi Tiger Reserve",
          "Usoda, road towards Dandeli",
          "Uttarakoppa Forest",
          "Vanalli wetlands",
          "Vibhuthi Falls",
          "Virje, Kaiga, Karnataka",
          "Vrukshagandha, Kaadumane",
          "Vrukshagandha, Kadumane ವೃಕ್ಷಗಂಧ, ಕಾಡುಮನೆ",
          "Wetlands, Behind Sree Kudure Beerappa Temple",
          "Whistling Woodzs - Jungle Resort",
          "Wild Kasarwadi",
          "Yana Caves",
          "Yellapura",
          "Yellapura Garbage Dump",
          "Yeramukh",
          "kuchegar , kaiga",
          "ಗೋಳಿ,  ಶಿರಸಿ (Goli Village, Sirsi)",
        ],
      },
      {
        district: "Vijayapura",
        localities: [
          "Ainapur Tank ಐನಾಪುರ ಟ್ಯಾಂಕ್",
          "Almatti Backwaters--Benal R.C ಆಲಮಟ್ಟಿ ಹಿನ್ನೀರು--ಬೇನಾಳ ಆರ್.ಸಿ.",
          "Almatti Backwaters--Chimmalagi ಆಲಮಟ್ಟಿ ಹಿನ್ನೀರು--ಚಿಮ್ಮಲಗಿ",
          "Almel Kere ಆಲಮೇಲ ಕೆರೆ",
          "Angadageri Kere ಅಂಗದಗೇರಿ ಕೆರೆ",
          "Arakeri Kere ಅರಕೇರಿ ಕೆರೆ",
          "Asangi Kere ಆಸಂಗಿ ಕೆರೆ",
          "Babaleshwar Kere ಬಬಲೇಶ್ವರ ಕೆರೆ",
          "Bableshwar Kere Tq. Sindagi  ಬಬಲೇಶ್ವರ ಕೆರೆ ತಾ. ಸಿಂದಗಿ",
          "Balaganur Kere ಬಳಗಾನೂರು ಕೆರೆ",
          "Banthanal Mahila Vidyapeetha ಬಂಥನಾಳ ಮಹಿಳಾ ವಿದ್ಯಾಪೀಠ",
          "Baratagi Kere ಬರಟಗಿ ಕೆರೆ",
          "Basavana Bagewadi ಬಸವನ ಬಾಗೇವಾಡಿ",
          "Basavasagar Dam ಬಸವಸಾಗರ ಜಲಾಶಯ",
          "Begum Talab ಬೇಗಂ ತಲಾಬ್",
          "Bhima River- -Rodagi  ಭೀಮಾ ನದಿ- -ರೋಡಗಿ",
          "Bhima River--Khedagi ಭೀಮಾ ನದಿ--ಖೇಡಗಿ",
          "Bhima River--Miragi ಭೀಮಾ ನದಿ--ಮಿರಾಗಿ",
          "Bhutnal Kere  ಭೂತನಾಳ ಕೆರೆ",
          "Bommanahalli Kere ಬೊಮ್ಮನಹಳ್ಳಿ ಕೆರೆ",
          "Bommanajogi Kere ಬೊಮ್ಮನಜೋಗಿ ಕೆರೆ",
          "Bommanalli Kere (Devara Hipparagi) ಬೊಮ್ಮನಳ್ಳಿ ಕೆರೆ (ದೇವರಹಿಪ್ಪರಗಿ)",
          "Dawal Malik Dargah, Domanal ದಾವಲ್‌ ಮಲಿಕ್‌ ದರ್ಗಾ, ದೋಮನಾಳ",
          "Deserted Monuments, Ittangihal Rd ನಿರ್ಜನ ಸ್ಮಾರಕಗಳು, ಇಟ್ಟಂಗಿಹಾಳ ರಸ್ತೆ",
          "Devoor Kere ದೇವೂರ ಕೆರೆ",
          "Dhanargi Kere ಧನರ್ಗಿ ಕೆರೆ",
          "Domanal Kere ಡೋಮನಾಳ ಕೆರೆ",
          "Doni River Bridge, Sarwad ಡೋಣಿ ನದಿ ಸೇತುವೆ, ಸಾರವಾಡ",
          "Dudihal Kere ದೂಡಿಹಾಳ ಕೆರೆ",
          "Gagan Mahal ಗಗನ ಮಹಲ್",
          "Garasangi Kere ಗರಸಂಗಿ ಕೆರೆ",
          "Gol Gumbaz ಗೋಳ ಗುಮ್ಮಟ",
          "Govt. ITI, Vijayapura ಸರ್ಕಾರಿ ಐ.ಟಿ.ಐ, ವಿಜಯಪುರ",
          "Hanchinal Kere ಹಂಚಿನಾಳ ಕೆರೆ",
          "Honnutagi Kere ಹೊನ್ನುಟಗಿ ಕೆರೆ",
          "Jalageri Kere ಜಾಲಗೇರಿ ಕೆರೆ",
          "Jambagi-Aheri Kere ಜಂಬಗಿ-ಆಹೇರಿ ಕೆರೆ",
          "Jigajeevani Kere ಜಿಗಜೀವಣಿ ಕೆರೆ",
          "Kadlewad Kere ಕಡ್ಲೇವಾಡ ಕೆರೆ",
          "Kaggod Kere ಕಗ್ಗೋಡ ಕೆರೆ",
          "Kapanimbargi Kere ಕಪನಿಂಬರಗಿ ಕೆರೆ",
          "Karjol Grassland- ಕಾರಜೋಳ ಹುಲ್ಲುಗಾವಲು",
          "Katral Kere  ಕಾತ್ರಾಳ ಕೆರೆ",
          "Kotnal Kere ಕೊಟ್ನಾಳ ಕೆರೆ",
          "Krishna River Bridge, Kolhar ಕೃಷ್ಣಾ ನದಿ ಸೇತುವೆ, ಕೊಲ್ಹಾರ",
          "Lalasangi Kere ಲಾಳಸಂಗಿ ಕೆರೆ",
          "Makhanapur Kere ಮಖಣಾಪುರ ಕೆರೆ",
          "Malghan Kere ಮಲಘಾಣ ಕೆರೆ",
          "Mamadapur Kere (East) ಮಮದಾಪುರ ಕೆರೆ (ಪೂರ್ವ)",
          "Mamadapur Kere (West) ಮಮದಾಪುರ ಕೆರೆ (ಪಶ್ಚಿಮ)",
          "Mannur Kere ಮಣ್ಣೂರು ಕೆರೆ",
          "Nagaradinni Kere ನಾಗರದಿನ್ನಿ ಕೆರೆ",
          "Nagathan Kere ನಾಗಠಾಣ ಕೆರೆ",
          "Nagawad Kere ನಾಗವಾಡ ಕೆರೆ",
          "Padeknur Kere  ಪಡೇಕನೂರು ಕೆರೆ",
          "Rajanal Kere ರಾಜನಾಳ ಕೆರೆ",
          "Sankanal Kere ಸಂಕನಾಳ ಕೆರೆ",
          "Savalsang Grassland ಸಾವಳಸಂಗ ಹುಲ್ಲುಗಾವಲು",
          "Somadevarahatti Kere ಸೋಮದೇವರಹಟ್ಟಿ ಕೆರೆ",
          "Sri Nagalingeshwara Waterbody ಶ್ರೀ ನಾಗಲಿಂಗೇಶ್ವರ ಹೊಂಡ",
          "Sri Revanasiddeshwara Hill, Nagawad ಶ್ರೀ ರೇವಣಸಿದ್ದೇಶ್ವರ ಗುಡ್ಡ, ನಾಗವಾಡ",
          "Srinagar Colony, Vijayapura ಶ್ರೀನಗರ ಕಾಲನಿ, ವಿಜಯಪುರ",
          "State Highway 55--Shegunashi ರಾಜ್ಯ ಹೆದ್ದಾರಿ 55--ಶೇಗುಣಸಿ",
          "Summer Palace ಬೇಸಿಗೆ ಅರಮನೆ",
          "Utnal Bridge ಉತ್ನಾಳ ಸೇತುವೆ",
          "Vijayapura--Shivagiri ವಿಜಯಪುರ--ಶಿವಗಿರಿ",
          "Vijayapura--Yogapur ವಿಜಯಪುರ--ಯೋಗಾಪುರ",
          "Wade Kere ವಾಡೆ ಕೆರೆ",
          "Yakkundi Chikka Neeravari Kere ಯಕ್ಕುಂಡಿ ಚಿಕ್ಕ ನೀರಾವರಿ ಕೆರೆ",
          "ZP Road ಜಿಲ್ಲಾ ಪಂಚಾಯತ್‌ ರಸ್ತೆ",
        ],
      },
      {
        district: "Yadgiri",
        localities: [
          "Balichakkur Hillock ಬಲಿಚಕ್ಕೂರ ಗುಡ್ಡ",
          "Bheema River Bridge--Yadgir ಭೀಮಾ ನದಿ ಸೇತುವೆ--ಯಾದಗಿರಿ",
          "Bhima River Barrage ಭೀಮಾನದಿ ಒಡ್ಡು",
          "Bonal Tank Bird Sanctuary ಬೋನಾಳ ಕೆರೆ ಪಕ್ಷಿಧಾಮ",
          "College of Agricultural Sciences, Bheemarayanagudi ಕೃಷಿ ವಿಜ್ಞಾನ ಮಹಾವಿದ್ಯಾಲಯ, ಭೀಮರಾಯನಗುಡಿ",
          "Dodda Siddapur Kere ದೊಡ್ಡ ಸಿದ್ದಾಪುರ ಕೆರೆ",
          "Gavi Siddalingeshwara Temple ಗವಿಸಿದ್ಧಲಿಂಗೇಶ್ವರ ದೇವಸ್ಥಾನ",
          "Gogi Kere ಗೋಗಿ ಕೆರೆ",
          "Gogikona Kere ಗೋಗಿಕೋನಾ ಕೆರೆ",
          "Gundalgera Tunnel ಗುಂಡಲಗೇರಾ ಸುರಂಗ",
          "Halbhavi Village ಹಾಲಭಾವಿ ಗ್ರಾಮ",
          "Hasnapur Hillock ಹಸನಾಪುರ ಗುಡ್ಡ",
          "Hasnapur Jodu Kere ಹಸನಾಪುರ ಜೋಡು ಕೆರೆ",
          "Hattikuni Dam ಹತ್ತಿಕುಣಿ ಆಣೆಕಟ್ಟು",
          "Khanapur Kere ಖಾನಾಪುರ ಕೆರೆ",
          "Lumbini Park ಲುಂಬಿನಿ ಪಾರ್ಕ್",
          "Madnal Kere ಮದ್ನಾಳ್‌ ಕೆರೆ",
          "Malnoor Kere ಮಾಲ್ನೂರು ಕೆರೆ",
          "Paddy Fields, Naikal ಭತ್ತದ ಗದ್ದೆಗಳು, ನಾಯ್ಕಲ್",
          "Samnapur Dam ಸಮ್ನಾಪುರ ಡ್ಯಾಂ",
          "Shettikera Kere ಶಟ್ಟಿಕೇರಾ ಕೆರೆ",
          "Shettikera Upper Lake ಶೆಟ್ಟಿಕೇರಾ ಮೇಲ್ಮಟ್ಟದ ಕೆರೆ",
          "Shorapur Tree Park, ಶೋರಪುರ ಟ್ರೀ ಪಾರ್ಕ್",
          "Siddhalingeswara Betta ಸಿದ್ಧಲಿಂಗೇಶ್ವರ ಬೆಟ್ಟ",
          "Tinthani Bridge ತಿಂಥಣಿ ಸೇತುವೆ",
          "ಧಬ್ ಧಬಿ ಜಲಪಾತ ಕುರುಚಲು ಚಾರಣ - Dhaba Dhabi Water Falls & Scrub, Karnataka, IN",
        ],
      },
    ],
  },
  {
    state: "Kerala",
    districts: [
      {
        district: "Alappuzha",
        localities: [
          "(9.668, 76.322)Homeyard Karuvayil Bhagom",
          "Aaryad",
          "Alappuzha Beach",
          "Alappuzha KSRTC Bus Station",
          "Alappuzha Railway Station",
          "Alappuzha-Kuttanad Road",
          "Aleppey Backwaters",
          "Andhakaranazhi Beach",
          "Arabian Sea: 9.2N 76.3E",
          "Arabian Sea: 9.2N 76.4E",
          "Arattupuzha beach",
          "Aravukadu",
          "Archana College Of Engineering Road, Palamel",
          "Arookutty - Odampally",
          "Aroor Pally",
          "Arrattuvazhi Wetlands - Vettackal",
          "Arthungal Beach",
          "Arthunkal",
          "Autokast Area - Cherthala (Limited Access)",
          "Ayaparampu",
          "Ayyappanchery",
          "Beach Marari",
          "Bharanikkavu",
          "Bhudhanoor,Thazhamthara",
          "Bishop Moore College, Mavelikara",
          "Budhanoor, Kerala, IN (9.302, 76.555)",
          "CHC Road, Thycattussery, Kerala, IN (9.779, 76.34)",
          "Changappaadam, Venmani",
          "Changaram Wetlands -- Ezhupunna",
          "Chembakasseri Wetlands - Pattanakkad",
          "Chempumpuram",
          "Chengannur Railway Station, Platform 3",
          "Cheppad",
          "Cherthala",
          "Cheruthana",
          "Chettikulangara Temple",
          "Christian College, Chengannur",
          "Christian College--Chengannur",
          "Chunakkara",
          "Chunakkara Wetlands",
          "College of Engineering--Cherthala",
          "Dolphin Beach",
          "Edathua",
          "Elanji Padam, Areeparambu - Cherthala",
          "Elavana Paddyfileds",
          "Elippanam Wetlands -- Mannanchery",
          "Ennakkad",
          "Erpathinaalayriam Kayal Paddyfield (North Kainady)",
          "Gandhi Smrithivanam -- Purakkad",
          "Govimdamuttom",
          "H-block East",
          "Haripad (OBI)",
          "KTR Wetlands, Cherthala",
          "Kadakkarappally",
          "Kainady",
          "Kainady North",
          "Kainakary Kayal",
          "Kainakary North",
          "Kainakary South",
          "Kaithavalappu",
          "Kakkathuruth Island",
          "Kallumala",
          "Kallummoodu",
          "Kandalloor",
          "Kanjippadam",
          "Kannamangalam",
          "Kannamangalam Kayal",
          "Kannanakuzhi",
          "Kannankara Wetlands  - Thaneermukkam",
          "Kareelakulangara",
          "Karikkuzhi Padam - Kanjikkuzhi",
          "Karipuzha",
          "Karthikapally",
          "Karumadi kari",
          "Karur",
          "Karuvatta Railway station",
          "Kattady Kadappuram - Cherthala",
          "Kattanam St. thomas hospital",
          "Kavalam",
          "Kavumpuram",
          "Kayamkulam Railway Station",
          "Keerikkad",
          "Kidangara",
          "Kochurani Padam Illichira",
          "Kodamthuruth Wetlands",
          "Koduppunna",
          "Kommady",
          "Kottamukku",
          "Krishnapuram HIghway Junction",
          "Krishnapuram, Kavalam",
          "Kudassanad - Bharanickavu Road, Padanilam",
          "Kunnuparambu",
          "Kunthirickal",
          "Kurattikadu",
          "Kurattissery",
          "Kurichimuttom",
          "Kuriyannoorkattil",
          "Kuttanad Wetlands--Ayikkara Mukku-Vaniyamkadavu",
          "Kuttanad Wetlands--H-Block",
          "Kuttanad Wetlands--Karingalichal Lake",
          "Kuttanad Wetlands--Karumadi",
          "Kuttanad Wetlands--Karuvatta",
          "Kuttanad Wetlands--Kudavellari",
          "Kuttanad Wetlands--Kunnumma",
          "Kuttanad Wetlands--Mankottachira",
          "Kuttanad Wetlands--Melpadam",
          "Kuttanad Wetlands--Moorthitta",
          "Kuttanad Wetlands--Pandy",
          "Kuttanad Wetlands--Vallomkadavu",
          "Kuttanad Wetlands--Vaniamkadavu",
          "Kuttanad Wetlands-Karippuzha Puncha",
          "Kuttanad Wetlands-Pallippad Parayankari Puncha",
          "Kuttand Wetlands--Thevarkadavu Puthanar",
          "Kuttemperoor",
          "Mahadevikadu",
          "Mambalappadom - Cherthala",
          "Mampra Paadam, Cheriyanad",
          "Manapra",
          "Mangalam",
          "Mannanchery",
          "Mannarasala Sree Nagaraja Temple",
          "Marari Beach",
          "Marari Beach Resort",
          "Marari Beach a CGH Earth Experience",
          "Mavelikkara Railway Station",
          "Mithrakari,Kidangara",
          "Moncompu",
          "Muhamma",
          "Mulakuzha",
          "Mullakkal",
          "Mullakkal kayal",
          "Muttar",
          "NSS College Campus - Cherthala (Limited access)",
          "NTPC Ground",
          "Nadubhagam",
          "Near Private Bus Stand",
          "Nedumudy - Bhoothapandam Kayal",
          "Neendakara Wetlands -- Ezhupunna",
          "Ottamassery",
          "Pallana Beach",
          "Pallathuruthy",
          "Pallathuruthy - Near Houseboat Terminal",
          "Pallathuruthy North -- Alappuzha",
          "Pallimukkam",
          "Pallippad",
          "Pallipuram",
          "Pallithode wetlands -- Thuravoor",
          "Panayil",
          "Pandarakulam",
          "Parakulangara",
          "Parayakad - Kannat wetlands -- Kuthiathode",
          "Parayakkadavu beach",
          "Pattoor",
          "Pavukkara,Karinilath",
          "Perumbalam Island",
          "Perumpally beach",
          "Poyyakkara",
          "Puliyoor",
          "Pullattuveli",
          "Punnakunnam",
          "Punnapra",
          "Purakkad",
          "Purakkad South",
          "Puthenchantha",
          "Puthiyavila",
          "Puthupally",
          "Puthuppally kayal",
          "R Block 14000",
          "R block",
          "R block kuttanad",
          "Rajagiri School Campus Area - Manappuram (Limited Access)",
          "SD College, Alappuzha",
          "SN College, Cherthala(Restricted access)",
          "St. Monica's Church Thuravoor and general area",
          "TKMM College - Haripad",
          "Thaiyil Chira",
          "Thampakachuvadu",
          "Thandanuvila",
          "Thaneermukkom -- Pothamangalam Paddy Fields",
          "Thazhathampalam",
          "Thekkekara",
          "Thinkalamuttam",
          "Thirunallur",
          "Thiruvanvandoor Sugarcane fields",
          "Thonackadu",
          "Thottappally beach",
          "Thottappally east",
          "Thycattussery",
          "Thyckal Beach",
          "Thykkoodam Kadavu",
          "Trikunnapuzha beach",
          "Ulavaipu Wetlands (West Block) - Thykattussery",
          "Ulavaipu Wetlands -- Thykattussery",
          "Vadackal",
          "Vaduthala",
          "Valavanadu",
          "Valiazheekal siva temple",
          "Valiyakulangara",
          "Valiyazheekkal",
          "Vallikkunam",
          "Vallikunnam",
          "Varanad",
          "Varanad Devi temple",
          "Varenickal",
          "Vayalar",
          "Vayalar temple",
          "Vayyankara Chira",
          "Vayyankara chira",
          "Vederaplavu",
          "Veeyapuram",
          "Veeyapuram-Karuvatta Road",
          "Vembanad Wetlands--Narakathara",
          "Vembanad Wetlands--Nedumudy",
          "Vembanad Wetlands--Pallathuruthy",
          "Vembanad Wetlands--Pathiramanal Island",
          "Venattukad",
          "Venmony",
          "Venmony Thazham",
          "Venmony-Kochumuri Kadavu",
          "Vettakkal B Block",
          "Vettampallil",
          "Vettikottu chal",
          "Vidyadhiraja School",
          "chengannur railway station",
          "ilippakulam",
          "kadampur",
          "kallu mala",
          "karakkad",
          "kondailip Resort (limited Access)",
          "kottalappadam wetlands - Pattanakkad",
          "kuttanadu",
          "panoor beach",
          "perumpally beach",
          "pullinkunnu",
          "punnapra beach",
          "venettukad",
        ],
      },
      {
        district: "Ernakulam",
        localities: [
          "Adichilthotty Tribal Colony",
          "Adivad-Oonnukal Rd",
          "Adooparambu--[Sub Cell-56,16,2]",
          "Aikaranad South--Kakkattupara(Subcell 55,11,8)",
          "Alangadu 33kv Substation Area",
          "Alapuram--Elanji-Monippally Rd [51,10,3]",
          "Allungal",
          "Aluva--Edayapuram",
          "Aluva--Edayapuram(West)",
          "Aluva--Elookkara(Madirath Padam)",
          "Aluva--Kadungalloor(Ambady Green Meadows area)",
          "Aluva--Karumalloor",
          "Aluva--Keezhmadu (Thulapadam)",
          "Aluva--Manakkappdy(area)",
          "Aluva--Manappuram",
          "Aluva--Muppathadam--Megalaya Rd",
          "Aluva--Neericode",
          "Aluva--Panayikulam(grass field)",
          "Aluva--Private Bus Stand",
          "Aluva--Rly. Station Area",
          "Aluva--St. Mary's School",
          "Aluva--Thaikatukara(Punja Paadam)",
          "Aluva--U C College",
          "Aluva--Veliyathunadu",
          "Aluva--West Kadungalloor",
          "Ambalamugal--Kodinjur Temple( Subcell -55,9,8)",
          "Ambunadu--Chemmalappady[Sub Cell- 58,10,7]",
          "Ambunadu--Thaqdees Hospital",
          "Anakkayam",
          "Angamaly--Kidangoor",
          "Angamaly--Mookkannoor",
          "Angamaly--Rly. Stn",
          "Anicadu",
          "Arabian Sea: 10.0N 75.9E",
          "Arabian Sea: 10.0N 76.0E",
          "Arabian Sea: 10.0N 76.1E",
          "Arabian Sea: 10.0N 76.2E",
          "Arabian Sea: 10.1N 76.0E",
          "Arabian Sea: 10.1N 76.1E",
          "Arabian Sea: 9.8N 76.2E",
          "Arabian Sea: 9.9N 75.8E",
          "Arabian Sea: 9.9N 75.9E",
          "Arabian Sea: 9.9N 76.0E",
          "Arabian Sea: 9.9N 76.1E",
          "Arabian Sea: 9.9N 76.2E",
          "Arakuzha--Meenkunnam Rd [Sub Cell-54,15,9]",
          "Asamannoor--Cherukunnam(Sub Cell 60,14,2)",
          "Athirappilly--Water Falls",
          "Avolichal(Sub Cell-59,20,6)",
          "Ayavana",
          "Ayroor--Attupuram(Link Rd)",
          "Ayyampuzha--Ezhattumugam Forest Station",
          "Ayyampuzha--Prakruthi Gramam",
          "Ayyampuzha--Uppukallu Jn.",
          "BLUEMARINE Backwaters",
          "Bhoothathankettu--Reservoir",
          "Birds Murmur Camp - Thattekkad",
          "Boothethankettu--Old Dam Path",
          "Bosco RD End View Point",
          "Brahmapuram--Chellipadam Fields",
          "CUSAT--C-Sis",
          "Chalakka-Kuthiathode Rd--Pandiyolichal(wetland)",
          "Chalakkudy--Ezhattumugham",
          "Chambakkara Fish Market(Subcell 55.7.5)",
          "Chelad--St.Gregorios Dental College(near)",
          "Chelamattom Heronry",
          "Chelethe Chera--Kolengad Padam(Sub Cell-53,12,9)",
          "Chellanam--Fishing Harbour",
          "Chembarakky(Sub Cell--59,10,9)",
          "Chenkara",
          "Cheramala",
          "Chottanikkara",
          "Chottanikkara--Atiyakapadam",
          "Chowara - Neduvannore Airport Rd",
          "Chowara--Neduvannoor(Railway Gate)",
          "Chowara--Rly.  Stn",
          "Cochin University, Kalamassery",
          "Divine Park, Kakkanad",
          "Dr. Salim Ali Bird Sanctuary",
          "Dr.Salim Ali Bird Sanctuary--Kallippara",
          "Edakochi--Pampayimoola",
          "Edamalayar Range--Thalippara-Villukuthi-Kappadan [SubCell No.65,27,5]",
          "Edamalayar--Vadattupara Waterfalls",
          "Edapally--AIMS",
          "Edappally",
          "Edavanakkad--Aniyal Beach Road",
          "Eloor-- Pathalam(Regulator Bridge)",
          "Eloor--Forest Depot",
          "Eloor--Udyogamandal(FACT)",
          "Eloor--Vadakumbhagam[Sub Cell-59,6,7]",
          "Eranakulam--South Rly. Station Area",
          "Eravikulam NP -- Eravikulam Hut",
          "Eravikulam NP--Kolukkan",
          "Ernakulam South KSRTC Bus Stand",
          "Ernakulam Town (North) Railway Station",
          "Ernakulam--Cherai Beach",
          "Ernakulam--Queen's Walkway",
          "Ernamulam--Near Kottayilkovilakam Rd",
          "Eroor--Ansal Riverdale",
          "Ezhattumugham--Malayattoor Rd.(Oil Palm Plantation)",
          "Ezhikkara(Sub Cell-60,4,2)",
          "FACT Lake",
          "FACT--Ambalamedu Lake (Restricted Access)",
          "Fort Kochi--Beach Area",
          "Fort Kochi--Ferry Area",
          "Fort Kochi--Pattalam (OBI)",
          "Fort Kochi--Tower Rd(near Koder House)",
          "Govt Arts And Science College, Tripunithara",
          "Hill Palace Museum Area",
          "ICT RD--Mulavukadu Area",
          "IMA House, Palarivattom, Kochi",
          "Idamalayar--Dam",
          "Idamalayar--Idamalayar RD",
          "Idamalayar--Reservoir",
          "Idukki--Edamalakudy",
          "Illithode (Sub Cell-63,13,5)",
          "Inchathotty Suspension Bridge",
          "Inchathotty--Forest Cottage",
          "Iringole Kavu",
          "Irumalappady--Heronry",
          "Jew Town",
          "Jungle Bird Homestay",
          "Kadakodam Thuruthu",
          "Kadamakudy--Thundathumkadavu",
          "Kadamakudy--Valiya Kadamakkudy",
          "Kadambrayar Wetlands",
          "Kadambrayar(Sub Cell-58,9,2)",
          "Kadayirippu--Thonikka Paddy Feilds",
          "Kadayiruppu-- Mazhuvannoor",
          "Kadayiruppu--Indranchira",
          "Kadayiruppu--Spice Villas",
          "Kakkanad -- Chittethukara Wetlands",
          "Kakkanad--Infopark (Restricted Access)",
          "Kakkanad--Rajagiri Valley",
          "Kakkanad--Recca Valley",
          "Kakkanadu--Municipal Ground",
          "Kalady Manjapra RD--Kuzhiampadam",
          "Kalady--Adi Shankara Janmabhoomi Ashram",
          "Kalady--Okkal Thuruthu",
          "Kalady--Sandflats",
          "Kalamaserry Polytechnic Area",
          "Kalamasserry--Palakkamugal",
          "Kalamassery--CUSAT Campus",
          "Kalamassery--HMT Colony (Mattakadu)",
          "Kalamassery--HMT Estate Area",
          "Kalamassery--Peringazha Area",
          "Kalamboor [Sub Cell-52,8,5]",
          "Kalappara(Sub Cell-60,18,8)",
          "Kalappara, Thattekkad Road",
          "Kalappara--Eldhose Birding Lodge (Restricted Access)",
          "Kalappara--Near Eldhose Birding Lodge",
          "Kallekandam--Ayyampuzha",
          "Kallil Bhagavathi Temple, Methala",
          "Kalluvettamada-Elanji RD [Sub Cell-52,9,5]",
          "Kanayannoor-- Eruveli",
          "Kanayannoor--Ayyappa Temple RD",
          "Kanayannoor--Vattakkunnu",
          "Kanayannoor--Vattukkunnu",
          "Kangarappady--Krishibhavan RD",
          "Kanjiramattom--Thundilangadi",
          "Kannamali(near Police Station)",
          "Karicode--Karicode Paadam[Subcell 53,9,9]",
          "Karukutti--Palissery",
          "Keezhmadu--Kuttamassery East Paddyfields",
          "Kizhakombu [Sub Cell-52,11,4]",
          "Kochareekkal Caves",
          "Kochi--Cherai Beach",
          "Kochi--Cheranalloor(Blayikadavu Rd)",
          "Kochi--Chilavannur",
          "Kochi--Elamakkara (Puthukkalavattom RD-Canal Area)",
          "Kochi--Eranakulam Market (Basin RD)",
          "Kochi--ICT RD (Mulavukad)",
          "Kochi--Kandakkadavu Wetland",
          "Kochi--Marine Drive Walkway",
          "Kochi--Mattancherry Palace Area",
          "Kochi--NH47 (Near Lakeshore Hospital)",
          "Kochi--Njarakkal (Matsyafed Fish Farm)",
          "Kochi--Pullepady",
          "Kochi--South Chittoor (Near Aster Medicity)",
          "Kochi--St Albert's College Campus",
          "Kochi--Thoppumpady(Chemmeens)",
          "Kochi--Vaduthala (JM Spot)",
          "Kochirika(Sub Cell-60,6,4)",
          "Kochupurackal Kadavu[Sub Cell-62,15,8]",
          "Kodanadu--Kaprikad",
          "Kodavakad--Kottuvally South",
          "Kolenchery",
          "Kombanad [Sub Cell-62,14,6]",
          "Koonammavu--Kavilnada",
          "Koovappara--SubCell (62,21,4)",
          "Kothamangalam--Elambra ByePass",
          "Kothamangalam--Malayinkeezhu (OBI)",
          "Kothamangalam--Mathirappally(Diana Villa)",
          "Kothamangalam--Mathirappilly",
          "Kothamangalam--Municipal Park",
          "Kothamangalam--Private Bus Stand",
          "Kottackal Nature Inn",
          "Kottapady - Plamudy - Thodakayam RD, Kannakada",
          "Kottappady--Moonnamthode",
          "Kottappady--Moonnamthodu",
          "Kulangarapadi [Sub Cell-52,10,7]",
          "Kulappikavu-Kavilpadi-Onthala Thuruthu Paddyfields",
          "Kulappikavu-kavilpadi-onthala Thuruthu Paddyfield",
          "Kummanodu-East (Sub Cell--58,11,3)",
          "Kundannoor--Willingdon Island RD",
          "Kunjattukara--Near Vettakkorumakan Temple",
          "Kunnukara--Vayalkara",
          "Kurbana Para",
          "Kureekkad",
          "Kuthirakoor Kari",
          "Kuthirakoor Kari--Pandarakari",
          "Kuttamassery--Thumbichal",
          "Kuttampuzha - Mamalakandom RD, Urulanthanni",
          "Kuttampuzha Forest Range--Eettacholayar Area[SubCell-62,25,3]",
          "Kuttampuzha Forest Range--Eettacholayar SubCell  [62,25,3]",
          "Kuttampuzha Forest Range--Eettacholayar area[SubCell 62,25,3]",
          "Kuttampuzha Range--Eettacholayar SubCell (62,25,3)",
          "Kuttampuzha-Mamalakkandam RD",
          "Kuzhuppilly Beach",
          "Kuzhuppilly Beach--Pallathankulangara Beach Road",
          "Maharaja's College",
          "Malavana (Sub Cell-62,5,4)",
          "Malayattoor RF--Edekallana (SubCell 63,16,9)",
          "Malayattoor--Aarattukadavu",
          "Malayattoor--Arattukadavu",
          "Malayattoor--General Area",
          "Malayattoor--MahagonyThottam (Eco Tourism Area)",
          "Malayattoor--Perumthode Forest Station Area",
          "Malayattor RF--[Sub Cell 63,15,4]",
          "Malayattor--Manappattu Chira",
          "Malayattur Division--Bhoothathankettu",
          "Malayattur Division--Eramukom",
          "Malayattur Division--Idamalayar Reserve Forest",
          "Malayattur Division--Kappayam",
          "Malayattur Division--Karimpani",
          "Malayattur Division--Koompanpara (SubCell 61,24,6)",
          "Malayattur Division--Kunchiyar",
          "Malayattur Division--Malakkappara",
          "Malayattur Division--Perinthodu",
          "Malayattur Division--Ponganchodu",
          "Malayattur Division--Therakudi",
          "Malayattur Division--Variyam",
          "Malayidomthuruth--(Pukkattupady-Perumbavoor RD)",
          "Malippara--Punekar's",
          "Mamala--Kakkad General Area",
          "Mamalakkandam",
          "Mambra--Paramada",
          "Maneed--Piravom RD",
          "Mangalavanam Bird Sanctuary",
          "Manikantanchal Area [SubCell 62,22,2]",
          "Manjalloor-Maniyanthiram Hiltop",
          "Manjally--Madhurappuram Wetlands",
          "Manjapra--Puthoorppilly Sreekrishnaswamy Temple Area",
          "Manjummel--Janatha RD",
          "Maradu--Boat Jetty",
          "Maradu--Thamarassery RD",
          "Marampally--MES College",
          "Mattummal",
          "Mazhuvannoor--Kadakkanad Paddies",
          "Memmukhom--Vettikkal Piravom Rd.(Subcell 53,11,8)",
          "Memmury--(SubCell 54,13,4)",
          "Memury--Kayanadu",
          "Moongakunnu",
          "Moonnamthodu--[Sub Cell-61,15,3]",
          "Moozhikkulam--Jaiva Eco Camp",
          "Mudavoor(Sub Cell-57,14,2)",
          "Mudikkal",
          "Mulanthuruthy",
          "Mulanthuruthy--Koramkottu Temple Karinilam",
          "Mulanthuruthy--Pallithazham(Chottanikkara Rd)",
          "Mundamveli--Thonithodu Bridge",
          "Muvattupuzha--Eattappilly(Mookambika Technical Campus)",
          "Muvattupuzha--Karukadom",
          "Muvattupuzha--Kurukkunnapuram Paaadam",
          "NAD wetlands",
          "Nadettuchaal--Charupara",
          "Nadukani",
          "Nayarambalam--Nedungad Wetlands",
          "Nedumbassery Wetlands--Opposite CIAL TradeFair and Exhibition Centre",
          "Nedumbassery--Angamali-Airport Road",
          "Nedumbassery--CIAL Area",
          "Nedumbassery--Ebenezer Plaza Area",
          "Nedumbassery--Maikave",
          "Nedumbassery--Suvarnodyanam",
          "Nellikuzhi(Sub Cell-59,16,4)",
          "Neriamangalam",
          "Neriamangalam(Sub Cell- 58,21,7)",
          "Neriamangalam--Chembankuzhy(Painavu Rd)",
          "Nirmala College Muvattupuzha (Autonomous)",
          "North Paravur--Ezhikkara bridge",
          "North Paravur--Santhivanam",
          "Ooramana--Puthukol Rd",
          "Padamugal--DLF New Town Heights",
          "Padma Junction, Jew St",
          "Paingottoor",
          "Palamattam(Sub Cell-60,19,6)",
          "Pallikkara--Kumarapuram(Sub Cell-57,9,9)",
          "Pallikkara--Vempilly[Sub Cell-57,10,7]",
          "Pallippuram--Kovilakathumkadavu area",
          "Palluruthy--Chirakal",
          "Panambukad(Sub Cell-57,4,3)",
          "Panangad--Madavana",
          "Panangad--SN Jn.(Subcell 53,7,5)",
          "Panayikulam GAIL  Green Belt (Zone 1)",
          "Pandrimala Rd",
          "Panichayam--Heronry",
          "Paniyeli Poru",
          "Paniyeli Poru--Panamkuzhi Kadav",
          "Pathaalam--Kachappilly Farm Field",
          "Pattimattom--Chottupara[Canal Rd-Sub Cell-57,11,8]",
          "Pattoorkunnu",
          "Pavamkulangara",
          "Perumbavoor--Town Area",
          "Perumbavoor--Valyanchirangara",
          "Perumpadappu--Kollassery area",
          "Perumpadavam--[Sub Cell-51,9,9]",
          "Perumpallor--Peringuzha(Sub Cell-55,16,4)",
          "Pindimana(Sub Cell- 60,17,4)",
          "Piravom East [Sub Cell-53,13,2]",
          "Pizhala",
          "Ponjikkara",
          "Pookattupady--Palancherimukal",
          "Pooyamkutty--Bridge",
          "Pooyamkutty--Forest Check Post",
          "Pooyamkutty--Kuttianchal Forest Station",
          "Puliyanam-- Painkavu",
          "Pullikkal Paara",
          "Purva Eternity",
          "Puthuvype--LNG Terminal Area",
          "Puthuvype--Lighthouse Beach",
          "Puthuvype--Mangroves",
          "Puthuvype--Valappu Beach",
          "Rajagiri Hospital area--[Sub Cell-59,9,8]",
          "Rajagiri Valley",
          "Ramamangalam--Valloor-Srikrishna Temple(Subcell 55,13,1)",
          "SCMS (School of Technology & Management)--Muttom Campus",
          "SSUS Campus, Kalady",
          "Sacred Heart Centre for Organic Farming, Ornithology & Biodiversity, Arayankavu",
          "South Kalamassery--Kudili Rd(area)",
          "Sparrow Vale Resort",
          "St. Mary's Church, Nakapuzha",
          "St. Peter's College, Kolanchery",
          "St.Xaviers College for Women, Aluva",
          "Sub Cell No 64,19,7(Thundathil Range)",
          "Sub Cell No 64,20,4(Thundathil Range)",
          "Sub Cell No 64,21,7(Thundathil Range)",
          "Sub Cell No 64,22,6(Thundathil Range)",
          "Sub Cell No 64,23,4(Thundathil Range)",
          "Sub Cell No 65,22,3(Thundathil Range)",
          "SubCell (65,17,4)-Kallala Estate 6th Block",
          "Subhash Bose Park",
          "Thaikoodam--Church Rd",
          "Thamaravattom Backwaters",
          "Thattekad",
          "Thattekad Bird Sanctuary--Urulanthanni",
          "Thattekad--CIAL Signal Station",
          "Thattekad--Kalappara",
          "Thattekad--Punnekkad",
          "Thattekad--Soma Birds Lagoon",
          "Thattekad--Tapovan Green County Resorts",
          "Thattekad--Velielchal",
          "Thattekad--near Hornbill Camp",
          "Thattekkad Bird Sanctuary--General Area",
          "Thattekkad Bird Sanctuary--Kolumba",
          "Thattekkad--Amritara Riverside Luxury Tents",
          "Thattekkad--Bird Songs Homestay",
          "Thattekkad--Jewel Homes",
          "Thattekkad--Keerampara",
          "Thattekkad--The Nest resort",
          "Thekkummala--Piralimattom",
          "Thengod--D D Diamond Valley",
          "Thengod--[Sub Cell-58,8,3]",
          "Thettali",
          "Thevakkal",
          "Thevara--SH College Area",
          "Thirumarayoor [Sub Cell-52,7,5]",
          "Thiruvaniyoor--Varikoli Leprosy Hospital",
          "Thiruvaniyur--Global Public School Area",
          "Thiruvankulam--Kavaleeswaram (Paddy Field)",
          "Thoongali [Sub Cell-61,14,7]",
          "Thoppikkallu- Pattaampilly Forest Road",
          "Thoppikkallu-Itinjakuthu- Kaanjiravalavu (SubCell 63,20,6)",
          "Thoppikkallu-Itinjakuthu- Kaanjiravalavu Area [SubCell 63,20,6]",
          "Thrikkariyoor(Sub Cell-60,16,2)",
          "Thrippunithura--Eroor South",
          "Thripunithura--Maradu(Champakkara Canal banks)",
          "Thripunithura--Pavamkulanagara",
          "Thripunithura--Thattapillikattupuzha Bridge",
          "Thundathil Range--Bhoothathan-Karimpani  Rd [SubCell 62,17,6]",
          "Thuthiyoor(Sub Cell-56,7,6)",
          "Tripunithura--Irimpanam",
          "Tripunithura--Kidangu Rd(Valia Kadu)",
          "URULANTHANNI--Knachary Sree Durga Temple",
          "Udayamperoor",
          "Urulanthanni",
          "Urulanthanni VP1",
          "Urulanthanni VP2",
          "Urulanthanni- Kuttampuzha River shooting point",
          "Urulanthanni--Birds Haven",
          "Vaduthala--Pushpaka Rd",
          "Vaduthala-South Chittoor Bridge",
          "Varapuzha",
          "Varapuzha--Devaswompadam Fish Landing",
          "Varapuzha--Market",
          "Varapuzha--Meen Thodu(Sub Cell-59,5,7)",
          "Vatattupara--Ennakkal Forest Station Area(10.184, 76.721)",
          "Vazhachal - Malkkapara Rd",
          "Vazhachal - Malkkapara Rd.",
          "Vazhachal Malkkapara Rd Subcell : 65,26,7",
          "Veliyathunadu--Thadikkakadavu Jn.",
          "Veliyathunadu[Sub Cell-61,7,4]",
          "Vengola",
          "Vengoor West--Anakallu [Sub Cell-61,13,6]",
          "Vettikuzha Chwruthiruthu Bridge Kochi",
          "Vypeen",
          "Vypin beach road",
          "Vypin--Pallathamkulangara",
          "Vypin-Fort Kochi Junkar service",
          "Zone 1 Panayikulam GaIL Green Belt (10.095, 76.299)",
          "Zone 1 Panayikulam Gail Green Belt (10.095, 76.299)",
          "Zone 2 Panayikulam Gail Green Belt, Kerala, IN (10.101, 76.298)",
          "Zone 3_ Evergreen Belt Of Panayikulam (10.096, 76.304)",
          "mattummal",
        ],
      },
      {
        district: "Idukki",
        localities: [
          "Aanakkayam--near Cooperative Bank",
          "Aanakkoodu Wetlands, Vengalloor, Thodupuzha",
          "Aanakuthivalau",
          "Aanappara Viewpoint, Ezhalloor",
          "Adimali (town)",
          "Adimali Fire Station Area",
          "Alampatty",
          "Amaramkavu Vanadurga Temple, Thodupuzha",
          "Anakkara Wetlands",
          "Anakkara--Chellarcovil",
          "Anamudi Shola NP",
          "Anamudi Shola NP--Kanthaloor",
          "Anamudi Shola NP--Methappu",
          "Anayiragal Dam",
          "Anchiri Paddyfields, Thodupuzha - Aanakkayam Rd.",
          "Anchuruli Tunnel",
          "Ankamvetty Proposed Cricket Ground Site",
          "Arivilamchal, Rajakumari - Mangathotty Rd.",
          "Attukadu Waterfalls",
          "Bamboo Dale Resort, Bison Valley",
          "Bird Song Trail, Periyar",
          "Blackcherry Home Stay,Munnar",
          "Bridge, Chottupaara - Uluppuni Rd.",
          "Camp Lights, Chillithode",
          "CampTop Tent Camping",
          "Carmelia Haven Resorts, Vandanmedu",
          "Cassells Resorts",
          "Chakkupallam - Kumily",
          "Chandy's Windy Woods",
          "Chathamattom-Mullaringad RD",
          "Cheeyappara Waterfalls",
          "Chinnakanal--Club Mahindra Serene RD",
          "Chinnakkanal--Club Mahindra Resort",
          "Chinnaparakudy",
          "Chinnar WLS -- Churulippetty",
          "Chinnar WLS--Aanakkunnu",
          "Chinnar WLS--Alampatty",
          "Chinnar WLS--Champakkadu",
          "Chinnar WLS--Chinnar",
          "Chinnar WLS--General Area",
          "Chinnar WLS--Karimutty",
          "Chinnar WLS--Olikkudi",
          "Chinnar WLS--Palappetty",
          "Chinnar WLS--Thayannankudy Road",
          "Chinnar WLS--Thoovanam Falls",
          "Chinnar WLS--Thoovanam Viewpoint",
          "Chinnar WLS--Vannamthura",
          "Chokramudi--Shola",
          "Chokramudi--Trekpath",
          "Deep Woods Resort",
          "Devikulam--General Area",
          "Dew Drops Resort, Munnar - Mankulam",
          "Echo point",
          "Ecotones Camps",
          "Edavetty Vanam, Thodupuzha",
          "Ela Ecoland -A Nature Retreat",
          "Elappara--Bonami",
          "Ellackal [57,30,3]",
          "Eravikulam NP -- Waterfalls",
          "Eravikulam NP--Checkpost",
          "Eravikulam NP--Eravikulam Hut",
          "Eravikulam NP--General Area",
          "Eravikulam NP--Kolukkan",
          "Eravikulam NP--Parking",
          "Eravikulam NP--Poovar Campshed",
          "Eravikulam NP--Rajamala",
          "Eravikulam NP--Varattukulam",
          "Forest Haven Resort--Kallar",
          "Glenmary Kodua RD",
          "Granby Estate Vandiperiyar",
          "Green Valley Vista Hotel",
          "Gundumalai",
          "Gundumalai Town",
          "Hanging Bridge, Ponmudi",
          "Helipad Viewpoint, Kumily",
          "High Range Club, Munnar",
          "Hill View Park, Idukki",
          "ICAR Krishi Vygyan Kendra, Santhanpara",
          "Idukki Dam--Boating Point",
          "Idukki WLS--Chambakassery thodu",
          "Idukki WLS--Kettuchira",
          "Idukki WLS--Kizhukanam",
          "Idukki WLS--Vakavanam",
          "Idukki WLS--Vellakkamaly",
          "Idukki--Ellapatty",
          "Idukki--GEC Campus",
          "Idukki--Kalvary Mount",
          "Idukki--Valanjamkanam",
          "Ilaveezhapoonchira Hilltop (Idukki Co.)",
          "Irachil Para Water Falls",
          "JPM Arts & Science College, Kanchiyar",
          "Josgiri-Kochuppu [56,31,8]",
          "Jungle Traveller's Hostel, Kallar - Mankulam RD",
          "KFD IB, Munnar",
          "KLDB Farm Kolahalamedu",
          "KLDB farm, Mattupetty",
          "Kajanappara [56,33,5]",
          "Kalaar Bungalow",
          "Kalayanthani Thekkin Koop",
          "Kallar Vattiyar",
          "Kallar Vattiyar Waterfalls",
          "Kallar, Nedumkandam",
          "Kallar--Vattiyar",
          "Kallippara, Santhanpara GP",
          "Kambilikandam-Murickassery Rd [54,29,5]",
          "Kannimala",
          "Kannimalai Chapel, Munnar",
          "Kannimalai Govt UP School",
          "Kanthalloor - Thoppan's Orchard and Farm Stay",
          "Kanthalloor Panchayat Office area",
          "Kanthallor",
          "Kanthaloor",
          "Karadippara View Point--Kallar",
          "Karadippara, Kallar, Munnar",
          "Kathippara",
          "Kattadikkadavu Hills, Vannappuram",
          "Keezhanthoor--Rock N Brook & Surroundings",
          "Kiliyarkandam [52,26,8]",
          "Kolapra Bridge, Kudayathoor, Thodupuzha",
          "Kolapra--Area51",
          "Konnakkamala Viewpoint",
          "Konnathady [55,29,6]",
          "Koompanpara - Mankadavu RD",
          "Kottakamboor",
          "Kovilkadav, Kanthalloor-Marayoor RD",
          "Koviloor",
          "Kulamavu Forest Trail",
          "Kulamavu--Greenberg Jn. in SH33",
          "Kulamavu--Nadukani Pavilion",
          "Kulamavu--Vadakkanar Lake",
          "Kumarikal Mala",
          "Kumily",
          "Kumily -- Spice Village",
          "Kumily--Abad Green Forest Resort",
          "Kundala Reservoir",
          "Kurinjimala Sanctuary--General Area",
          "Kurinjimala Sanctuary--Kadavari",
          "Kurinjimala Wildlife Sanctuary--Neduvarpp",
          "Kurisupara - Kallar-Anakkulam RD",
          "Kuttetan's Birding Lodge",
          "Kuttikkanam Grasslands",
          "Leaf Munnar Resorts",
          "Letchmi",
          "Letchmi Estate Post Office",
          "Lockhart Gap Viewpoint (NP Viewpoint), Munnar-Kumily Hwy",
          "MBC College of Engineering, Peermade [43.24.8]",
          "Madathikandam Paddyfield, Thodupuzha",
          "Malankara Park and Dam",
          "Malayattur Division--Anakkulam",
          "Malayattur Division--Koompanpara",
          "Malayattur Division--Uriyampetty",
          "Manale Tea Bungalow, Devikulam",
          "Manjumala [42.26.2]",
          "Mankulam Forest Division--Kadalar",
          "Mankulam Forest Division--Kallar",
          "Mankulam Forest Division--Kozhiyalakudi",
          "Mankulam Forest Division--Munippara",
          "Mankulam Forest Division--Pambadumpara",
          "Mankulam Forest Division--Urallukuthy",
          "Mankulam Forest Division--Viripara",
          "Marakkanam [55,30,5]",
          "Marayoor--Anakalpetty Sandal Forest",
          "Marayoor--General Area",
          "Marayoor--Karimutty Waterfalls",
          "Marayoor--Nature Tones Mudcamp",
          "Mathikettan Shola NP--Aduvilathan",
          "Mathikettan Shola NP--Pethotty",
          "Mattupetty Dam",
          "Meenuliyan Para, Vannappuram",
          "Meesappulimala--Rhodo Mansion",
          "Meesappulimala--Viewpoint",
          "Memala [44.24.7]",
          "Menonmedu--Chakkupallam",
          "Mist Nest Holiday Cottages, Munnar",
          "Mistletoe Homestay, Iruttukanam",
          "Munnar - Near hotel Dream Palace",
          "Munnar - Top Station Rd.",
          "Munnar -- Bison Valley Road",
          "Munnar 8th mile",
          "Munnar---8th mile Forest Camping Station",
          "Munnar--Blackberry Hills Munnar Resort",
          "Munnar--Camelot Resort",
          "Munnar--Dam Area",
          "Munnar--Deshadan Hills",
          "Munnar--Deshadan Mountain Resort, Pothamedu",
          "Munnar--General Area",
          "Munnar--KDHP Tea Museum",
          "Munnar--KDHP Tea Plantations",
          "Munnar--Kannan Devan Hills Club",
          "Munnar--Letchmi Estate Rd.",
          "Munnar--Meenthotty",
          "Munnar--Monsoon Grande Hotel",
          "Munnar--Nullatanni KFD Dormitory",
          "Munnar--Pallivasal Kurisumala",
          "Munnar--Pallivasal Rd.",
          "Munnar--Pothamedu",
          "Munnar--Tea County Resorts",
          "Munnar--Windermere Estate, Pothamedu",
          "Munnar--near Abad Resort",
          "Munnar-Pulippara - Nature zone resorts Rd",
          "Murickassery [54,28,3]",
          "Muthuvaankudi [56,30,8]",
          "Muttukad--Societymedu [57,33,5]",
          "Naalumala View Point Rd",
          "Nayamakad, Munnar",
          "Near Indo Swiss Project, Munnar-Topstation Rd",
          "Neriamangalam",
          "Neriamangalam Bridge",
          "Odiyappara Forest, Vannappuram",
          "Olive Brook Resort, Pothamedu",
          "PTR--KTDC Lake Palace",
          "Pallivasal--Pipeline View Point",
          "Pampadum Shola NP(2)",
          "Pampadum Shola NP--Bison Log House",
          "Pampadum Shola NP--General Area",
          "Pampupara",
          "Panchalimedu Hills",
          "Panchalimedu--Kappaluvenga",
          "Parunthumpara Viewpoint",
          "Pattayakudy [56,24,8]",
          "Pazhathottam--Koviloor",
          "Peermadu Guest House",
          "Periyakombu Log House",
          "Periyar Tiger Reserve -- Bamboo Raft Trail",
          "Periyar Tiger Reserve- Nature walk trial",
          "Periyar Tiger Reserve--Anchuruli Rd.",
          "Periyar Tiger Reserve--Anjuruli",
          "Periyar Tiger Reserve--Aruvipalam",
          "Periyar Tiger Reserve--Aruviyoda",
          "Periyar Tiger Reserve--Azhutha",
          "Periyar Tiger Reserve--Boat Landing",
          "Periyar Tiger Reserve--Brandipara",
          "Periyar Tiger Reserve--Edapalayam",
          "Periyar Tiger Reserve--Eravangalar",
          "Periyar Tiger Reserve--General Area",
          "Periyar Tiger Reserve--Green Walk",
          "Periyar Tiger Reserve--Interpretation Centre and Dormitory",
          "Periyar Tiger Reserve--Kokkara",
          "Periyar Tiger Reserve--Manakavala",
          "Periyar Tiger Reserve--Manammuttimala",
          "Periyar Tiger Reserve--Mangaladevi Trail",
          "Periyar Tiger Reserve--Medakanam",
          "Periyar Tiger Reserve--Mlappara",
          "Periyar Tiger Reserve--Moolavaiga",
          "Periyar Tiger Reserve--Mullakudi",
          "Periyar Tiger Reserve--Paalkkachimala",
          "Periyar Tiger Reserve--Periyar Lake",
          "Periyar Tiger Reserve--Pugmark Trail",
          "Periyar Tiger Reserve--Sathram",
          "Periyar Tiger Reserve--Thamara",
          "Periyar Tiger Reserve--Thamarakandam",
          "Periyar Tiger Reserve--Thannikkudy",
          "Periyar Tiger Reserve--Thekkady",
          "Periyar Tiger Reserve--Upper Manalar",
          "Periyar Tiger Reserve--Uppuppaara",
          "Periyar Tiger Reserve--Vallakkadavu Range",
          "Periyar Tiger Reserve--Vellimala",
          "Periyavarai bridge",
          "Perunvanthanam-Amalagiri [42,23,7]",
          "Peruvanthanam-Meloram [42.22.8]",
          "Pettimudi",
          "Ponmudi Dam View Point-1",
          "Ponnumpoojary Temple - Attikulam [53,28,7]",
          "Poomala--Njandirukki Waterfalls",
          "Pothamedu--Sree Harsh Rock and Grasslands",
          "Pulikunnu Viewpoint, Manakkadu",
          "Pulimoottil Estates, Munnar",
          "Pullikkanam--DCSMT College",
          "Pullikkanam--Nallathanni Viewpoint",
          "Pullumedu - [46,27,2]",
          "Pullumedu--Pettimudi Checking Station",
          "Punnayar Waterfalls",
          "Puttady Temple area",
          "Rajakkad--Mangathotty Rd -- Kanthippara [55,33,4]",
          "Rajakumari North [56,34,1]",
          "Rajappara, Santhanpara GP",
          "Ramakkalmedu Hilltop",
          "Ramaswami Iyer Headworks Dam",
          "Reen Resorts, Aanavilasam",
          "Santhanpara",
          "Santhigiri",
          "Selliampara--Vellathooval Rd [56,29,6]",
          "Senapathy--Ambalapady [55,34,4]",
          "Sengulam Dam",
          "Silent Valley Road, Munnar",
          "Sleevamala--Vattakkannippara [54,32,8]",
          "Spice Village CGH Earth",
          "Springdale Heritage",
          "St Antony's College, Peruvanthanam",
          "St Augustine's Hospital",
          "St. George CSI Church Pallikkunu",
          "Tea and Tranquility,Vagamon",
          "Tealawn Pool Villa",
          "Thadiyampad [53,27,6]",
          "Thannikadam [52,23,8]",
          "The Tall Trees Resorts",
          "Thekkady--Aranya Nivas",
          "Thekkady--Bamboo Grove Hotel",
          "Thekkady--Cardamom County Resort",
          "Thekkady--Spice Village - CGH Earth",
          "Thekkady--The Wildernest",
          "Thekkady--Vanasree Dormitory",
          "Thodupuzha--Chungam Paaramada",
          "Thodupuzha--Private Bus Stand",
          "Thokkupara [57,29,8]",
          "Thommankuth--Santhikkadu Temple",
          "Thommankuthu Waterfalls--Trek Path",
          "Thommankuthu--Chappathu",
          "Udayagiri [52,27,1]",
          "Uluppuni--Top Station",
          "Uluppuni--Tunnel and Forest",
          "Uppukunnu Viewpoint, SH 41",
          "Upputhode [52,25,9]",
          "Upputhode [53,29,2]",
          "Uravappara Subrahmanya Temple, Thodupuzha",
          "Vagamon--Adventure Zone",
          "Vagamon--General Area",
          "Vagamon--Meadows",
          "Vagamon--Palette People Artists Residency",
          "Vagamon--Town",
          "Vakka City [55,32,5]",
          "Valara Waterfalls",
          "Vallakkadavu Town",
          "Varickamuthen Hill",
          "Vattavada--General Area",
          "Vayanakavu Temple--Kudayathur",
          "Vayanasala Rd [57,31,7]",
          "Veloor Ayyappa Temple",
          "Vibe Resort, Munnar",
          "WTI Field Station, Kannan Devan Hills",
          "Windermere Estate",
          "lakkamkudi",
        ],
      },
      {
        district: "Kannur",
        localities: [
          "Aanakkulam pond & Makkani Urban forest- South Bazar",
          "Adikadalayi Beach",
          "Arabian Sea: 11.8N 74.5E",
          "Arabian Sea: 11.8N 74.6E",
          "Arabian Sea: 11.8N 74.7E",
          "Arabian Sea: 11.8N 74.8E",
          "Arabian Sea: 11.8N 74.9E",
          "Arabian Sea: 11.8N 75.1E",
          "Arabian Sea: 11.8N 75.2E",
          "Arabian Sea: 11.8N 75.3E",
          "Arabian Sea: 11.9N 74.8E",
          "Arabian Sea: 11.9N 74.9E",
          "Arabian Sea: 11.9N 75.0E",
          "Arabian Sea: 11.9N 75.1E",
          "Arabian Sea: 11.9N 75.2E",
          "Arabian Sea: 11.9N 75.3E",
          "Arabian Sea: 11:6N 75.1E",
          "Arabian Sea: 12.0N 75.0E",
          "Arabian Sea: 12.0N 75.1E",
          "Arabian Sea: 12.0N 75.2E",
          "Aralam WLS",
          "Aralam WLS--Ambalappara",
          "Aralam WLS--Chavachi",
          "Aralam WLS--Paripputhodu",
          "Aralam WLS--Valayanchal",
          "Ayyoth",
          "Azhikkal Beach",
          "Bakkalam Vayal",
          "Caltex (Heronry)",
          "Central Nursery,  Cheruvanchery, Kannavam  Range",
          "Chal Beach",
          "Chalode",
          "Chamakkavu",
          "Chathurampuzha",
          "Chavanapuzha",
          "Chemmadam",
          "Chempallikundu",
          "Chempanthotty",
          "Chengoorichal",
          "Chera--Panthottam",
          "Cheruthazham Vayal",
          "Chirakkal Chira",
          "Chirakkuni",
          "Dalil",
          "Dharmadam Beach",
          "Dharmasala",
          "Edakkad",
          "Edakkanam View Point",
          "Edapara Chamundeshwari Kshetram",
          "Elapeedika",
          "Eranholi",
          "Eranholi River Front",
          "Ettikulam Beach",
          "Ezhara Beach",
          "Ezhimala",
          "Ezhome",
          "Government Brennan College, Thalassery",
          "Govt. Ayurveda College Campus, Pariyaram",
          "Iriveri Pulideva Kshetram",
          "Kadamboor",
          "Kakkad",
          "Kakkara",
          "Kallettumkadavu",
          "Kanakamala",
          "Kanayi Kanam",
          "Kanichar",
          "Kanjirakkunnu",
          "Kanjirakolli",
          "Kannoth Reserve Forest--Kolayad Timber Depot",
          "Kannur Forest Division--Ambayathodu - Chokkadanpara",
          "Kannur Forest Division--Chokkadumpara - Perumalmudy",
          "Kannur Forest Division--Kandappunam FS - Ambayathodu",
          "Kannur Forest Division--Parakkadu",
          "Kannur Forest Division--Punneri",
          "Kannur International Airport",
          "Kannur Kandal Project",
          "Kannur Railway Station",
          "Kannur University",
          "Kannur University Campus Mangattuparamba",
          "Kannur University Payyanur Campus",
          "Kannur University, Mangattuparamba",
          "Kannur--Parassinikkadavu--Dharmasala--General Area",
          "Kannur--SBI",
          "Kappimala",
          "Karikkankandichira",
          "Karinkkankandi Chira",
          "Karippal para",
          "Kattaampally--Kattampally Dam",
          "Kattampally",
          "Keecheri Vayal",
          "Keecheri Wetland",
          "Keeriyad",
          "Keezhara",
          "Kizhunna Beach",
          "Kodolipram Vayal",
          "Koduvally  Wetlands",
          "Kokkara Vayal (OBI)",
          "Kolathuvayal",
          "Konginichal Kavu",
          "Kottayam Chira",
          "Kottiyoor RF",
          "Kottukapara",
          "Kunhimangalam Mangroves",
          "Kunnaru",
          "Kunnirikka",
          "Kunniyan Wetland",
          "Kunnumkai",
          "MUZHAPPILANGAD BEACH",
          "Madakkad",
          "Madakkara",
          "Madayi Para",
          "Mambaram",
          "Manekkara",
          "Mangalasseri",
          "Mangatuparambu Neeliyar Kottam",
          "Maniyara",
          "Manjuppalam RD",
          "Mappila Bay",
          "Maryamgalam",
          "Matool Beach",
          "Mayyil",
          "Moidu Bridge",
          "Monthal",
          "Muderikkadav",
          "Mullakkodi",
          "Mundapram",
          "Munderikadavu",
          "Mungam Bridge",
          "Muttilpalam",
          "Muzhappilangad Estuary",
          "Nadal",
          "Naniyoor",
          "Narambil Paara",
          "Narikode Vayal",
          "Neeliyarkottam",
          "Nirmalagiri College",
          "Olackal Estuary",
          "Olavilam",
          "POYILOOR SREE MUTHAPPAN  MADAPPURA",
          "Paalchuram",
          "Paalchuram Falls",
          "Paithalmala",
          "Pala",
          "Paliyeri vayal",
          "Pana Vayal",
          "Panthrandaam Chaal",
          "Pavannur Kadav",
          "Payyambalam Beach",
          "Payyanur College",
          "Payyanur Railway Station",
          "Pazhassi Kovilakam",
          "Pazhassi Reservoir",
          "Pazhayangadi--Kakkara Vayal",
          "Periya Ghats",
          "Podikkalam",
          "Poonamkavil Hills",
          "Poongottukaavu",
          "Poovatharkund Waterfalls",
          "Porora",
          "Poyiloor",
          "Pulloopikadavu",
          "Punnol",
          "Puthoor, Kerala, IN (12.202, 75.223)",
          "SN College",
          "Sir Syed College, Taliparamba",
          "Sir syed college, thaliparamba",
          "Sivapuram (Heronry)",
          "Someswari devi temple, Padappengad",
          "Sooryamudi",
          "Sree Sankaracharya University of Sanskrit  (SSUS RC)",
          "Sreelayam",
          "St. Angelo Fort",
          "Stadium (Heronry)",
          "Thadikadavu",
          "Thadikkadavu",
          "Thalassery Beach",
          "Thavam, Kerala",
          "Thazhe Chovva",
          "Thekkevayal, Kunhimangalam",
          "Thekkumbad",
          "Valayamchal, Aralam Wildlife Sanctuary Entrance",
          "Vattappoyil",
          "Vattoli, Chittariparamba- near Manjeri Mahavishnu temple",
          "Vayakkara Vayal",
          "Vazhamala view point",
          "Wayand North Forest Division--Thirunelli IB to Watch Tower",
          "at sea off the coast of Kannur (OBI)",
          "athirakam",
          "kuniyan wetland",
          "vadukunda temple, madayippara",
        ],
      },
      {
        district: "Kasaragod",
        localities: [
          "A U P School, Mulleria",
          "AUPS, Kuntar",
          "Allakodan Vallappu, Near Pulari Samskarika Kendram, Aravath Vayal, Pallikkara II, Kerala, IN (12.417, 75.041)",
          "Ambiladka Pump House",
          "Ananthan Palla",
          "Ananthapura",
          "Anodi Palla Dam",
          "Arabian Sea: 11.9N 74.5E",
          "Arabian Sea: 11.9N 74.6E",
          "Arabian Sea: 11.9N 74.7E",
          "Arabian Sea: 12.2N 75.1E",
          "Arabian Sea: 12.6N 74.5E",
          "Aranthode",
          "Aravath Vayal",
          "Aravathvayal Wetland",
          "Arayi Kadavu",
          "Arikady",
          "Arikkana",
          "Ariyitupara - Pothamkandam",
          "Attegoli",
          "Atyadka",
          "Ayetti Kavu",
          "Azhithala Beach, Nileshwaram",
          "Bambrana Wetlands",
          "Banam",
          "Bandiyod Heronry",
          "Battekala Wetlands (Vorkady)",
          "Bayar Padavu",
          "Bedur Forest",
          "Bedur-General Area",
          "Bejja",
          "Bekal Beach Park",
          "Bekal Fort",
          "Bengapadav",
          "Beripadav",
          "Bheemanadi Reserve Forest--Plachikkara",
          "Birikulam Kannur RD",
          "Central University of Kerala, Periye",
          "Champilamkai",
          "Chandragiri Estuary",
          "Cheemeni",
          "Cheemeni Ariyittapara",
          "Cheemeni Sacred Grove",
          "Chemmattamvayal",
          "Cherkala",
          "Cheruvathur",
          "Cheruvathur Railway Station",
          "Chithari Estuary",
          "Chithari River",
          "Delampady",
          "Edattumal - Kuniyan Sub",
          "Edattummal",
          "Edayilakkadu Kavu",
          "G H S S Angadimoger",
          "G H S S Kumbla",
          "G H S S, Balanthode (Outside Campus)",
          "G L P S, Peral Kannur",
          "GHS, Thachangad",
          "Gate Way Bekal",
          "Gateway Bekal, Udma",
          "Government Higher Secondary School, Balanthode (Campus)",
          "Govt.College, Kasaragod",
          "Gumpe Hills",
          "Heroor Wetland",
          "Holy Family School, Kumbla",
          "Hosangady Heronry",
          "Janma Kadappuram, Udma",
          "Kaattikkaja-Pulipparamba--Reserve Forest",
          "Kadambar",
          "Kamanabail",
          "Kambar Dam",
          "Kammadam Kavu",
          "Kammadathukavu (Sacred Grove)",
          "Kanathur",
          "Kanhangad Heronry",
          "Kanhangad Railway Station",
          "Kanhirapoyil",
          "Kannankai Wetlands",
          "Kannol Vayal",
          "Kanva Theertha, Manjeshwar",
          "Kanyapadi",
          "Karakka Kavu, Pilicode",
          "Karakode",
          "Karimbinthodi",
          "Karindalam",
          "Kasaragod Forest Division--Mauthom Popular",
          "Kasaragod Forest Division--Parappa (Kanhangad)",
          "Kasaragod Tourist Guest House",
          "Kattipoyil",
          "Katukukke Cell",
          "Kayyur Choottayam Para",
          "Kidoor",
          "Kodlamogaru",
          "Kokkal-Kavvayikayal",
          "Kollangana- Aranthode",
          "Kottancheri Reserve Forest",
          "Koyithatta Para",
          "Kubanoor",
          "Kukkangoodlu",
          "Kulangarapara Kavu---Kolathur",
          "Kumbla-Shiriya Estuary",
          "Kuniya",
          "Kuniyan Wetland-Main",
          "Kunjathur",
          "Kuruvappalli Wetlands",
          "Kuttamath Vayal",
          "LBS College of Engineering Povval",
          "M S C H School, Neerchal",
          "Mandekapu",
          "Mandekolu Reserve Forest (Restricted Access)",
          "Mangalpady",
          "Mangrove Forest-Bannamkulam-Kanchikatte Road.",
          "Manhampothi Hills",
          "Manjeshwar Estuary",
          "Mannikoth-Mundayali_Peralathvayal",
          "Mappittacherry Kavu, Putilothu",
          "Meenja",
          "Model College Madikai",
          "Mogral Estuary",
          "Molothumkavu",
          "Moolakandam",
          "Mulinja",
          "Muroor",
          "Nalanda college perla",
          "Navajeevana School, Perdala",
          "Nehru College, Padanakkad",
          "Nellikatte",
          "Nileshwar",
          "Nileshwaram Railway Station",
          "Odayamchal",
          "Oriyara-Mavillakadapuram",
          "Padannakkad",
          "Padannakkad Hanging Bridge",
          "Pady",
          "Paivalike",
          "Palavayal",
          "Panayal Vayal",
          "Parappa (Mulleria)",
          "Pelthaje",
          "Peralathvayal",
          "Periadka,Bela",
          "Periya Bazar",
          "Permude",
          "Permude Pond-Gumpe Hills",
          "Perne",
          "Poinachi",
          "Poothakkal",
          "Pulimoot Beach",
          "Puthige Wetlands",
          "Puthilot Vayal",
          "Puthiya  Kotta",
          "Puthrakkala - Yethadka",
          "Ranipuram Reserve Forest",
          "Ravaneshwaram Vayal",
          "SDPAUPS,Sajankila,Bayar",
          "SDPHSS,Dharmathadka",
          "Shiribaagilu-Maippady",
          "South Chittari Bridge",
          "Sree Madiyan Koolom Kshethrapala Temple",
          "St. Bartholomeas School, Bela",
          "Sunkathakatte",
          "Talekala",
          "Thachiru Mala, Koliyar",
          "Thaikadapuram",
          "Thalabail Village",
          "Thalpanaje",
          "Theerthankara Pond",
          "Thirthankara",
          "Udinur Vayal",
          "Udinur waterbody",
          "Uliyathadukka",
          "Urmi",
          "Vadake Kadu Island",
          "Valiyaparamba Beach",
          "Valiyapoyil, Cheruvathur",
          "Vana Vidhyalayam SEEK",
          "Vanashree Complex Kasaragod",
          "Varanjoor",
          "Vellakode, Karichery river",
          "Vilakkumadam,Karichery",
          "Wetland--Kalluravi--Kanhangad",
        ],
      },
      {
        district: "Kollam",
        localities: [
          "Aalumpeedika Wetlands",
          "AchanKovil Road Forest",
          "Achankovil Forest Division--Priya Estate",
          "Alumpeedika",
          "Ambanadu- Anachadi RD",
          "Amrita University",
          "Anayadi",
          "Apooppan Kavu",
          "Arabian Sea: 8.7N 76.5E",
          "Arabian Sea: 8.8N 76.1E",
          "Arabian Sea: 8.8N 76.2E",
          "Arabian Sea: 8.8N 76.5E",
          "Arabian Sea: 8.8N 76.6E",
          "Arabian Sea: 8.9N 76.2E",
          "Arabian Sea: 8.9N 76.3E",
          "Arabian Sea: 8.9N 76.4E",
          "Arabian Sea: 8.9N 76.5E",
          "Arabian Sea: 9.0N 76.4E",
          "Arabian Sea: 9.0N 76.5E",
          "Arippa",
          "Arippa - Edapana Forest patch",
          "Ashramam",
          "Ashtamudi Mangroves",
          "Ashtamudi--General Area",
          "Ashtamudi--Kandachira",
          "Ashtamudi--Karali Wetlands",
          "Ashtamudi--Kureepuzha Bridge",
          "Ashtamudi--Munroe Island",
          "Ashtamudi--Thekkumbhagam",
          "Ashtamudi--Vettuvila",
          "Avaneeswaram Railway Station",
          "Ayilara",
          "Ayiravalli Paara",
          "Aylara",
          "Ayyenkoikkal Temple",
          "Azheekal Beach",
          "Azheekal Mangrove Forest",
          "Azheekkal Pulimuttu",
          "Chakkuvalli Chira | ചക്കുവള്ളി ചിറ",
          "Cheeloor Lake",
          "Chelithod Palam, Mannoorkavu | ചെളിത്തോട് പാലം",
          "Chemmana Wetlands",
          "Cherkadavu Check Dam",
          "Chitra, Ashtamudi Backwaters",
          "Chittumala Chira, Kollam",
          "Chungathara",
          "Deerpark,Thenmala",
          "Elamkulam Temple",
          "Ettuvaikodu Vayal,Kudicodu, Kerala, IN (8.924, 76.733)",
          "Fatima Mata National College (FMNC)",
          "Fragrant Nature Paravur",
          "Government Polytechnic College, Punalur",
          "Guhanandapuram Temple",
          "Idimuzhangan Camp Shed",
          "Jatayu Earth Centre",
          "Kadakkal",
          "Kandachira",
          "Kanyarkayam Waterfalls",
          "Karunagappally Railway Station",
          "Kattilappara--Reservoir Edge",
          "Kattilkadavu Backwaters",
          "Kattilkadavu Wetlands (Near Alochana Junction)",
          "Kolabhagam",
          "Kollam Olayil Boat Jetty",
          "Kollam Railway Station",
          "Konni Forest Division--Mannarappaara",
          "Konni Forest Division--Mannarappara",
          "Konni Forest Division--Thura",
          "Koshnakkavu",
          "Kottakayal Lake",
          "Kottarakara",
          "Kottukal Cave Temple",
          "Kudukkathu Para",
          "Kulappadam",
          "Kurumbolil wayal Mynagappally (കുരുമ്പോലിൽ വയൽ )",
          "Kuttikkattu Sree Bhadra Devi Temple",
          "Lal Bahadur Stadium",
          "Maaroothazham Vayal",
          "Madannada Wayal Mynagappally_മാടൻനട വയൽ മൈനാഗപ്പള്ളി",
          "Malamel Rock",
          "Malumel Bund RD",
          "Mambazhathara",
          "Mampazhathara",
          "Manappally West",
          "Manchalloor",
          "Mangadu, Madankaavu Vayal,Kollam, Kerala, IN (8.916, 76.62)",
          "Mangalath Compound",
          "Mannitta Dam (Pavumba Paddy Fields)",
          "Mar Ivanios Bethany School",
          "Mathra, Punalur",
          "Mayyanad Beach",
          "Mayyanad Paddy Field",
          "Miccamine (Karavoor Achankovil Road)",
          "Munroe Thuruth",
          "Munroethututhu Railway Station",
          "NSS College Ground, Nilamel",
          "Nallila",
          "Neduvannoorkadavu--Tenmala Road",
          "Ochira south",
          "Palaravi",
          "Palaruvi",
          "Palaruvi Waterfalls",
          "Pallimon",
          "Pandithitta",
          "Panikkarkadavu",
          "Paravur Lake",
          "Paravur Rail Bridge",
          "Pathimoonnu Kannara Bridge",
          "Pathimoonu Kannara Bridge",
          "Pavubma-Thodiyoor Bridge Road",
          "Pavumba Bridge_Bund Road (പാവുമ്പാ പാലം_ബണ്ട് റോഡ്)",
          "Perinad Railway Station",
          "Perumkulam Ela (പെരുങ്കുളം ഏല )",
          "Perumpuzha-Dullu",
          "Pezhummoodu",
          "Pochapuram Wetlands",
          "Polachira",
          "Polachira--Malayankulam Bridge",
          "Poruvazhy Peruviruthy Malanada Temple",
          "Pozhikkara",
          "Pulikulam",
          "Punalur Railway Station",
          "Punalur Suspension Bridge",
          "Puthiyakavu - Sanghapura Mukku -Kattilkadavu Road, Karunagappally, Kerala, IN",
          "SN College",
          "SN College, Kollam",
          "Saptharshimangalam Temple",
          "Sasthamcotta Lake",
          "Sasthamcotta Lake 2",
          "Schendurney WLS--Kattilapara",
          "Shaktikulangara - Neendakara Fishing Harbour Kollam, Kerala",
          "Shantiniketan International School, Nilamel",
          "Shendurney WLS--Dharbakulam",
          "Shendurney WLS--Forest Information Centre, Kattilappara Station",
          "Shendurney WLS--General Area",
          "Shendurney WLS--Idimuzhangan Para",
          "Shendurney WLS--Kattilappara Picket Station to Kallar Road",
          "Shendurney WLS--Kattilappara-Reservoir Trek Path",
          "Shendurney WLS--Neduvannoorkadavu Kattalappara road",
          "Shendurney WLS--Umayar",
          "Shendurney Wildlife Sanctuary--Kattilappara",
          "Shendurny Wildlife Sanctuary--Pandimotta",
          "Sri Dharmasastha Temple--Achankovil",
          "St Stephen's College, Maloor",
          "St. Gregorius College, Kottarakara",
          "TKM College Of Arts & Science",
          "Tenmala--Assistant Wildlife Warden Office",
          "Tenmala--Dam Entrance",
          "Tenmala--Deer Park Entrance Gate",
          "Tenmala--Deer Park Road",
          "Tenmala--Ecotourism Promotion Society.",
          "Tenmala--Opposite Deer Park",
          "Tenmala--Wildlife Warden Office",
          "Tenmala--Wildlife Warden Office to Deer Park",
          "Thamarakulam Wetlands",
          "Thangassery",
          "Thenmala",
          "Thenmala, Look Out.",
          "Thiruvilangonappan Kavu",
          "Thodiyoor",
          "Thodiyoor Bund (Pavumba road)",
          "Thrikadavoor",
          "Thundil kavu",
          "ThurayilKadavu Wetlands",
          "Umayanalloor Ela",
          "Vallikkavu",
          "Vallikkavu Wetlands",
          "Vavvakkavu East",
          "Vayyanam Grama Panchayath Office",
          "Vellanathuruthu",
          "Yeroor",
          "kottiyam",
          "muttathumannel",
          "pozhikkara",
          "കുറുങ്ങൽ വയൽ Kurungal Vayal",
        ],
      },
      {
        district: "Kottayam",
        localities: [
          "26th mile [42.18.9]",
          "Aanakkallu--Kuzhimavu [39.23.5]",
          "Aanakkulam, Vandanpathal",
          "Aarayiram Kayal paddy field",
          "Aikkaracharil Paddy Fields, Kallumkathra",
          "Ambal Field, Eravinalloor",
          "Arattukadavu Paddyfields",
          "Aravinda School, Pallikkathode",
          "Attipedika",
          "Attipeedika -- Mutherimada",
          "Ayyampara",
          "Baselius College",
          "Boat Jetty RD, Kumarakom",
          "Brahmamangalam",
          "CMS College Kottayam (Autonomous)",
          "Chanakakkulam",
          "Channanikadu",
          "Cheeppunkal",
          "Chempinthuruthu",
          "Chennoth Paddyfield Pravattom",
          "Chirakkadavu-Mannamplavu",
          "Coconut Lagoon",
          "Edakkunnam",
          "Edayazham",
          "Enadi (Near Post Office)",
          "Erattupetta--PWD Rest House",
          "Ezhuvelil gardens, Vazhoor (Restricted Access)",
          "Fire Station RD, Erattupetta",
          "Good Shepherd College",
          "Idukki--Ilaveezha Poonchira",
          "Idukki--Mukkada Rubber Board Nursery",
          "Idukki--Punchavayal--Karisseri",
          "Illikalam Lakeside Cottages (Restricted Access)",
          "Irumpuzhikkara",
          "Kaippally [45.20.8]",
          "Kaipuzha - Chozhiyappara",
          "Kalaketty Sivaparvathy Temple",
          "Kallara - Udayamthara Perumthuruthu Road, Near Pravattom",
          "Kandamkari paadam",
          "Kandamthuruthu RD Thalayazham",
          "Kanjirapally--Parathode",
          "Kanthari Kadavu Ayamkudy",
          "Kapickad-Mundar RD",
          "Kapikkad Paddy - Natakkal, Muttuchira",
          "Karikadu View Point, Vagamon",
          "Kattadikunnu",
          "Kattikkayam Waterfalls,Kottayam",
          "Kidangoor",
          "Kilikulam, Mannam",
          "Kodimattom",
          "Kombukuthi, Near Tribal School",
          "Kondoor",
          "Koratty Old Church [41.20.4]",
          "Kottayam - Cheepunkal, Maniyaparambu RD",
          "Kottayam Changanassery Bypass (Palathra)",
          "Kottayam Medical College Campus",
          "Kottayam--Adichira",
          "Kottayam--Anickadu Sree Bhagavathi Temple",
          "Kottayam--Aruvikuzhy Waterfalls",
          "Kottayam--Chempanthuruthu",
          "Kottayam--Chettuthodu",
          "Kottayam--Eranjal",
          "Kottayam--Erattupetta--Fire Station",
          "Kottayam--Erayilkadavu Bypass RD",
          "Kottayam--KSRTC Bus Stand",
          "Kottayam--Kaippuzhamuttu Cheepunkal Wetlands",
          "Kottayam--Kallara--St. Mathews Church",
          "Kottayam--Kanakappalam Forest",
          "Kottayam--Karimpinthodu",
          "Kottayam--Kariyampaadam",
          "Kottayam--Kooroppada--Kaiyoori",
          "Kottayam--Kottayam Railway Station",
          "Kottayam--Kuravilangad--Kozha Junction",
          "Kottayam--Manarcadu",
          "Kottayam--Mannanam--K.E College",
          "Kottayam--Marmala Waterfalls [47.20.8]",
          "Kottayam--Mattakkara Thuruthipalli Temple",
          "Kottayam--Neelamperoor--Neendakara House",
          "Kottayam--Neelamperoor--Thekkemaliyekkal",
          "Kottayam--Nehru Stadium",
          "Kottayam--PWD Rest House",
          "Kottayam--Parampuzha--Muzhoor Paddy Fields",
          "Kottayam--Private Bus Stand",
          "Kottayam--Puthuppally Church",
          "Kottayam--Puthuppally-Paloorpady road",
          "Kottayam--Thalanad",
          "Kottayam--Thalayazham--Koovam Road",
          "Kottayam--Thalayazham--Panachithuruthel Road",
          "Kottayam--Vechoochira--Nadakkavuvayal",
          "Kottayam--Velloor Paddy Fields - Vettikkattumukku",
          "Kottayam--Velloor--Near Pirvam RD Railway Stn",
          "Kottayam--Veloor Bypass RD",
          "Kumarakom",
          "Kumarakom -- Malikkayal",
          "Kumarakom Bird Sanctuary",
          "Kumarakom--Cheepunkal",
          "Kumarakom--Konchumada",
          "Kumarakom--Vayitharamattom",
          "Kumarokam",
          "Kuriakose Gregorios College, Pampady",
          "Kurinjikkavu Vanadurga Temple (Restricted Access)",
          "Kurinjikoomban",
          "Kurisumala Base [46.21.4]",
          "Kuruvamoozhy [40.19.8]",
          "Kuttanad Wetlands--Ezhumaanthuruthu",
          "Kuttanad Wetlands--Kallara",
          "Kuttanad Wetlands--Kallara--Ayyanadu Puthenkari",
          "Kuttanad Wetlands--Kumarakom Bird Sanctuary",
          "Kuttanad Wetlands--Kuttompuram Bridge",
          "Kuttanad Wetlands--Maniyamthuruthu",
          "Kuttanad Wetlands--Mudakkali Paadam",
          "Kuttanad Wetlands--Perunna Paddy Fields",
          "Kuttanad Wetlands--Poovathumkari",
          "Kuttanad wetlands - Kurichipadam paddy fields",
          "Kuttanad wetlands--Sasthankal",
          "Kuttanadu Wetlands--Kallara--Mudakkali",
          "Kuttanadu Wetlands--Kallara--Paravanthuruthu",
          "Kuttanadu Wetlands-Perumthuruthu Paddy View",
          "Kuzhithadam Paddy Fields, Parackal Kadavu",
          "MG UNIVERSITY",
          "Madappad Vayal, Cheruvandoor",
          "Madukka-Kombukuthy RD",
          "Mahatma Gandhi University Campus - Athirampuzha",
          "Malarikkal",
          "Maniyaparambu",
          "Maniyaparambu, Kottayam",
          "Manjoor South Chamakkala Road - Near Onamthuruthu",
          "Mar Sleeva Medicity Parking Ground",
          "Meenanthara Thevarkunnu Road and Paddy fields",
          "Methran  Kayal",
          "Mukkali",
          "Mundakyam",
          "Mundathanam",
          "Mundupalam, Pala",
          "Munroe Light House Pallam",
          "Narimattam Padam",
          "Near Kattachira Check Dam, Kidangoor, [46,12,4]",
          "Nedumala Estate",
          "Oorvayal",
          "Paipad",
          "Pala - St. Thomas College (Restricted Access)",
          "Pala-Lake near KC Sebastian Square",
          "Palapra",
          "Palathuruthu",
          "Pallikkayal",
          "Pallom Pulinthara Temple Road",
          "Pallom, Nattakom",
          "Pampavalley",
          "Panachikkadu Dakshina Mookambika Temple",
          "Paravanthuruthu Raptor Point",
          "Perumthuruthi Paddy field - Nalukodi",
          "Perumthuruthu, Kallara",
          "Perunna paddy fields,Changanassery",
          "Peruva Paadam, Vadukunnapuzha,",
          "Ponthen Puzha Forest Road, Kottayam",
          "Poonjar--Valathooku",
          "Poovathum Kari - Koduthuruthu, Kallara",
          "Poovathum Kari West - Kallara",
          "Rajiv Gandhi Institute of Technology (RIT)",
          "Ramapuram",
          "SJCET, Choondacherry, Palai",
          "Saint Berchmans College, Changanassery",
          "Saintgits College of Engineering, Kottayam",
          "Sasthankal Paddy fields",
          "St. Thomas Mount, Valavoor",
          "St. Xavier's College, Vaikom",
          "Thaazhathangaady",
          "Thalanadu--Kavumbhagam",
          "Thalayazham - Cherukad",
          "Thalayazham Near Yakshiyambalam",
          "Thambalakad--Thambalakad Ponkunnam Road",
          "Thazhathekuzhi Padam - Neendoor",
          "Thollayiram Chira - Parippu, Chengalam South",
          "Ullasatheeram, Padiyarakadavu",
          "Vaikom",
          "Vaikom--Adoration Convent",
          "Vaikom--Kottarappally",
          "Vaikom--Moothedathukavu Road",
          "Vaikom--T V Puram",
          "Vanam North, Central Bund Road, Thalayazham",
          "Vandanpathal Forest Office",
          "Vayala to Kalikaavu",
          "Velichiyani",
          "Vellikulam Valley",
          "Veloor -- Piney Paddy Fields",
          "Vembanad Lake--Kollam-Kottappuram Waterway",
          "Vembanad Wetlands -- Narakathara",
          "Vembanad Wetlands --The Lake",
          "Vembanad Wetlands --Thollayiram Kayal",
          "Vembanad Wetlands--KTDC",
          "Vembanad Wetlands--Kaippuzha  Muttu",
          "Vembanad Wetlands--Kumarakom Paddy fields",
          "Vembanad Wetlands--Thanneermukkam Bund",
          "Winter Vale Green Stay",
          "a42",
          "koruthodu",
        ],
      },
      {
        district: "Kozhikode",
        localities: [
          "Aavalapandi [108,7,3]",
          "Achilmala Hills, Kavumthara",
          "Akalapuzha",
          "Akalapuzha Chira",
          "Anakkampoyil",
          "Anakkuzhikkara",
          "Annassery",
          "Arabian Sea: 11.2N 75.8E",
          "Arabian Sea: 11:5N 75.5E",
          "Arambram",
          "Arayidathupalam",
          "Auto selected",
          "Avala",
          "Avani Institute of Design, Thamarassery",
          "Balussery",
          "Bavuppara",
          "Beypore Beach",
          "Chakkittapara",
          "Chaliyam",
          "Chathanadath Kadavu",
          "Chelapram",
          "Chelavur Sacred Grove",
          "Chembanoda",
          "Cherandathur",
          "Cheruvennur",
          "Chevarambalam",
          "Chevayur, Calicut",
          "Chullikkaparamba",
          "College of Engineering--Vadakara",
          "Craft Village",
          "East Nadakkavu",
          "Edakkal Beach",
          "Eduthuvacha Paara (Narikode)",
          "Elathur",
          "Elathuruthupandy",
          "Eleyembra Hills",
          "Eliyottumala",
          "Eranhippalam",
          "Feroke",
          "Feroke Bridge",
          "GHSS Madapally",
          "Geo Home, Nellikkapoyil",
          "Government Medical College Campus, Kozhikode",
          "Govt. Arts & Science College, Meenchanda",
          "Govt. College Kodanchery",
          "Housing Board Colony, GMC Kozhikode",
          "IIM Calicut",
          "IPM",
          "JNV Calicut, Maniyur",
          "Kadalundi Bird Sanctuary-Kozhikode",
          "Kadiyangad",
          "Kaithavalappu Wetland, Kadalundi",
          "Kakkadampoyil--Karimbu Road",
          "Kakkayam",
          "Kakkayam Dam VP2",
          "Kakkayam Ghat Road",
          "Kalarimala, Chelannur",
          "Kallayi Estuary",
          "Kallupara, Chombala Harbour",
          "Kambilipadam",
          "Kandamchira",
          "Kannur Forest Division--Narikkodu",
          "Kappad Beach",
          "Kappad--Thuvappara",
          "Kappal Chali",
          "Kariyathumpara (11.536, 75.887)",
          "Kattamvally Birding Area",
          "Kayyelikal, Thamarassery",
          "Kinalur Estate",
          "Koduvally",
          "Kolavi Beach",
          "Koothali",
          "Koovapoyil",
          "Korapuzha Estuary",
          "Kottappalli",
          "Kottappally",
          "Kottappuzha Estuary",
          "Kottooli Wetlands",
          "Koyilandy Harbour",
          "Koyilandy Railway Station",
          "Kozhikode Beach",
          "Kozhikode Central Market",
          "Kozhikode Cyberpark",
          "Kozhikode Forest Division--Anakkampoil",
          "Kozhikode Forest Division--Janakikkad",
          "Kozhikode Forest Division--Kakkad Teak RD Sindicate",
          "Kozhikode Forest Division--Kakkadampoil",
          "Kozhikode Forest Division--Maruthilavu",
          "Kozhikode Forest Division--Pannikkotoor Vayal - Undammoola",
          "Kozhikode Forest Division--Seethappara - Karinkanni",
          "Kozhikode Forest Division--Thusharagiri",
          "Kozhikode Railway Station",
          "Kudakkallu, Atholi",
          "Kundayithode Wetland",
          "Kunduparambu-Eranjikal",
          "Kuniyilkadavu, Atholi",
          "Kuttikkattoor",
          "Kuttyadi",
          "Lokanarkavu Temple",
          "Maanamkunnu",
          "Madavoor",
          "Madoppani Kunnu",
          "Mailadippara",
          "Makkoottam",
          "Malabar Botanical Garden(MGBIPS), Olavanna",
          "Malabar Christian College (Restricted)",
          "Malabar Medical College, Modakkallur, Kozhikode",
          "Malabar WLS - Sankaran Puzha Camp",
          "Malabar WLS--Ampalappara",
          "Malabar WLS--Changarampuzha",
          "Malabar WLS--Choothupara",
          "Malabar WLS--General Area",
          "Malabar WLS--Kakkayam Dam - Devayani Estate",
          "Malabar WLS--Kakkayam Dormitory and Checkpost",
          "Malabar WLS--Kakkayam Dormitory to Urakkuzhi/Dam site",
          "Malabar WLS--Kakkayam Reservoir",
          "Malabar WLS--Raveendra Transact 2",
          "Malabar WLS--Raveendra--Transact 1",
          "Malabar WLS--Sankaranpuzha",
          "Malabar WLS--Surge RD",
          "Mandamala",
          "Mandayad",
          "Mavoor Wetlands",
          "Mavoor, Mananthalakkadavu",
          "Medappara Trekking Route",
          "Meenchanda",
          "Moopan Kuzhi",
          "Mullankunnu",
          "Muthuvannacha",
          "Muthuvattuthazham vayal",
          "NIT Calicut",
          "Naduvannur",
          "Nallalam Wetland",
          "Nanminda Paddyfields",
          "Nayadumpoyil Hill",
          "Nellikunnel-Vellanur",
          "Nirakaithakotta",
          "Nochat Higher Secondary School",
          "North Wayanad FD--Kuttyadi",
          "Olavanna Botanical Garden",
          "Oottukulam vayal - Palath",
          "PARAMBINKAD HILLS, Kavumthara,Kozhikode, IN-KL",
          "Pakranthalam Churam Viewpoint",
          "Palath",
          "Palery",
          "Pallikkara",
          "Pannikkottoor",
          "Pannimukku, Avala",
          "Pantheerankave HSS Ground",
          "Panthirikkara",
          "Parappalli",
          "Payamkutti Mala",
          "Payyoli Railway Station",
          "Perambra",
          "Peruvannamoozhi",
          "Peruvannamoozhi Dam--Chakkittapaara-Narinada Viewpoint",
          "Peruvannamoozhi Dam--Narinada Southern Viewpoint",
          "Peruvannamoozhi Reservoir",
          "Ponkunnu Hill, Kakkur",
          "Poovattuparamba",
          "Providence Women's College",
          "Pulathuruthupandy",
          "Puliyottumukku",
          "Pulparamb",
          "Puthiyapa Beach-South",
          "Puthiyappa",
          "Ramanattukara",
          "Regional Science Centre and Planetarium",
          "Royad Farm-Omassery",
          "Sanketham Wetlands",
          "Sarovaram Biopark, Kottoooli",
          "Shri Ayyappan Kavu, Poovangal",
          "Stone quarry, Kaiveli",
          "Thamarassery",
          "Thamarassery Churam",
          "Thekkeppuram",
          "Thengilakkadavu",
          "Thikkodi Beach",
          "Thikkoti Railway Station",
          "Thorayi Kadavu",
          "Thottathil Kadavu",
          "Ulliyeri, Kozhikode",
          "Unnikulam--Thechi",
          "Vadakara town",
          "Vallikkattu kav",
          "Valook",
          "Vanaparvam",
          "Vanaparvam biodiversity park",
          "Vavul Mala [102.20.9]",
          "Vellarimala",
          "Vilangad",
          "Walkway, Mahé",
          "Westhill",
          "Zamorin's Guruvayurappan College",
          "maruthonkar Chempanoda road",
          "nellikkunnu",
          "veliiyamkallu",
        ],
      },
      {
        district: "Malappuram",
        localities: [
          "Akkachola Road [93,13,1]",
          "Al Shifa College",
          "Alathiyoor Sri Hanuman Swamy Temple",
          "Alungal",
          "Amarambalam",
          "Ambal Mill Road",
          "Ambalapparambu Jn. - Valanchery",
          "Anakkayam Agricultural Research Station",
          "Aneri Mala,Kavanur",
          "Angadipuram",
          "Arabian Sea: 10.7N 75.8E",
          "Arabian Sea: 10.8N 75.7E",
          "Arabian Sea: 10.8N 75.8E",
          "Arabian Sea: 10.8N 75.9E",
          "Arabian Sea: 11.0N 75.7E",
          "Arabian Sea: 11.0N 75.8E",
          "Arabian Sea: 11.1N 75.8E",
          "Arimbrakuth Forest",
          "Aripra [89,14,2]",
          "Athaloor Paddy Fields",
          "Atlas cell [82,4,3]",
          "Atlas cell [82,5,2]",
          "Ayinichira",
          "Ayyappankunnu Temple",
          "Azhinjilam Wetlands",
          "Bharathapuzha Mudflat_Ponnani",
          "Biyyam Kayal",
          "Bungalow Kunnu",
          "Calicut University Campus",
          "Calicut University Campus Botanical Garden",
          "Calicut University Campus--Alakapuri",
          "Chalippadam",
          "Chamravattom Bridge",
          "Chekanoor",
          "Chembancolly",
          "Chembankolly",
          "Chembra",
          "Cherukara",
          "Chungathara",
          "Edupark Road, Pappinippara, Kerala, IN (11.09, 76.079)",
          "Elachola Farm",
          "Elankur-Shappinkunnu Rd [94,14,4]",
          "Erumamunda",
          "Ganapathikallu, Nadukani",
          "Greenara and Eathachira Village",
          "IN-Kerala-Thenhipalam - 11.136x75.891 - 23 Nov 2016 8:46 pm",
          "Irimbiliyam - Valanchery",
          "Iringavoor",
          "KCAET Tavanur Campus",
          "Kadakkattu Para",
          "Kadalundy Estuary (Kadalundi Bird Sanctuary)",
          "Kakkadampoyil",
          "Kakkadampoyil--Kozhippara Waterfalls",
          "Kakkadampoyil--Nilambur Bypass Forest Patch",
          "Kakkadampoyil--Pazhassi Cave",
          "Kakkadampoyil--S Valavu",
          "Kakkadampoyil--Thottappally",
          "Kakkadampoyil--Vendekumpoil",
          "Kalpakancheri",
          "Kalpalli",
          "Kalpuzha--Pacharipadam",
          "Kambanikundu",
          "Kanchippura [86,10,4]",
          "Kandanakam",
          "Karma road, Ponnani, Malappuram",
          "Karulai",
          "Karulai cell",
          "Kavathikkulam Padasekharam",
          "Kavumpuram",
          "Kelappaji College of Agricultural Engineering and Technology",
          "Kettungal Beach",
          "Kizhakkethala",
          "Kizhisseri",
          "Klari MSP Camp",
          "Kodasseri",
          "Kodikuthimala",
          "Kodinhi",
          "Kodumpuzha",
          "Kolaparamba- Mammavil Temple/Olippuzha Roads, Kerala, IN (11.095, 76.258)",
          "Kolappuram",
          "Kole Wetland--Cheravalloor",
          "Kole Wetland--Kattakambal",
          "Kole Wetlands--Beeyam Kayal",
          "Kole Wetlands--Maranchery",
          "Kole Wetlands--Uppungal (Malappuram)",
          "Kollikkara",
          "Konamunda",
          "Kondotty",
          "Kondotty--Moinkutty Vaidyar Smaraka Mappila Kala Padana Kendram",
          "Kottappuram",
          "Kottola",
          "Kottoor",
          "Kozhikode International Airport",
          "Kundukadu, Thalakkassery",
          "Kurumbalangode",
          "Kuttippuram--JTS",
          "Kuttippuram--Railway Station",
          "Kuttippuram--Sandflats",
          "Kuvakkunnu",
          "Kuzhimanna",
          "MES Mampad College (Autonomous)",
          "MES Mampad College Campus",
          "MES Medical College Campus",
          "Mampad, Nilambur",
          "Mampattumoola",
          "Manaliyarkkavu Padam",
          "Manikkinar",
          "Manjeri",
          "Manjeri--Cherani",
          "Mannarmala",
          "Manoor Kayal",
          "Marakkara",
          "Maranchery [80,3,6]",
          "Maravattam [88,10,2]",
          "Melattur",
          "Melattur Railway Station Road",
          "Melattur--Police Station",
          "Melekkavu",
          "Mini Ooty",
          "Mookuthala Temple",
          "Moolepadam",
          "Mukkodu, Karipur.",
          "Mulliakurssi",
          "Mundithodika [92,12,5]",
          "Murukanjiram",
          "Muthrukunnu Temple",
          "Myladi",
          "Nadakkavu",
          "Nadugani Churam",
          "Naduvath",
          "Naduvath--Pottippara",
          "Nannammukku",
          "Naranippuzha Bridge",
          "Nedumkayam--Elephant Kraal",
          "Neerolpalam",
          "Neerolppalam",
          "Nellissery [81.5.6]",
          "Nilambur",
          "Nilambur North Division--Munderi",
          "Nilambur North Division--Vazhikadavu",
          "Nilambur North--Aadyanpaara",
          "Nilambur North--Bhoodanam",
          "Nilambur North--Iruttukuthy",
          "Nilambur North--Meenmutti",
          "Nilambur North--Nadukani",
          "Nilambur North--Nellikuth",
          "Nilambur North--Nilambur",
          "Nilambur North--Olimala",
          "Nilambur North--Olimpara towards Chempumkallu",
          "Nilambur North--Palakkadavu",
          "Nilambur North--Punjakolly",
          "Nilambur North--Vaniyampuzha",
          "Nilambur North--Vellarampuzha",
          "Nilambur South--Atti",
          "Nilambur South--Kariri",
          "Nilambur South--Nedumkayam",
          "Nilambur South--Nedumkayam IB-Towards Kannankara",
          "Nilambur South--Paattakkarimpu -  Saivila",
          "Nilambur South--Panappuzha - Panappuzhamukku",
          "Nilambur South--Panappuzha towards Kidakkamala",
          "Nilambur South--Panapuzha",
          "Nilambur South--Pulimunda",
          "Nilambur South--Singakkallu",
          "Nilambur South--T K Colony",
          "Nilambur South--Vattakkallu",
          "Nilambur--AR Camp",
          "Nilambur--Aaravallikkavu",
          "Nilambur--Chaliyar Mukku",
          "Nilambur--Chaliyar Mukku Atlas Cell",
          "Nilambur--Conolly Plot",
          "Nilambur--DFO's Bungalow",
          "Nilambur--Green Valley Road",
          "Nilambur--Kulakandom",
          "Nilambur--Parakkadavu",
          "Nilambur--Puchakuth",
          "Nilambur--Teak Museum & KFRI",
          "Nilayoram--Nila River",
          "Niramkaithakotta",
          "Odakkayam [97,17,5]",
          "Off Chavakkad",
          "Oravampuram",
          "Othayi [96,12,3]",
          "Ottumpuram Estuary",
          "Ozhur",
          "PSMO College Malappuram",
          "PWD Rest house Areacode",
          "Pachattiri",
          "Paddy field near MES Mampad College Campus.",
          "Pakaravoor shiva temple",
          "Palad",
          "Palakkal",
          "Palemad",
          "Pallipadi [94,13,2]",
          "Panakkad",
          "Panampad",
          "Panampad Kole",
          "Panayi",
          "Pandikkad--Bus Stand",
          "Pandikkad--Kizhakke Pandikkad",
          "Pang [88,12,1]",
          "Pang chendi [88,12,1]",
          "Parappanangadi Heronry",
          "Parappanangadi Town",
          "Parappuram",
          "Parichappilly temple Road",
          "Pattikkad",
          "Perinthalmanna KSRTC Bus Depot",
          "Perunthallur",
          "Ponnani Beach",
          "Pookkarathara",
          "Pullara",
          "Pullippadam",
          "Pulpatta, Karaparamba",
          "Punchapadam",
          "Purathur Estuary",
          "Puthanathani - Athirumada",
          "Puthuparambu",
          "Randathani",
          "Shanthitheeram Park",
          "Silent Valley NP--Sispara towards Bankithapal",
          "Sree Subrahmanya Swami Temple, Eravimangalam",
          "Tanalur",
          "Tanur beach",
          "Tavanur BSNL Telephone Exchange Back Side",
          "Thalappara",
          "Thamalassery Kole",
          "Thattan Thiruthi",
          "Thavanoor",
          "Thavanur--Pappinikavu",
          "Thazhamon",
          "Thekkinkode, Angadippuram",
          "Thenhipalam",
          "Thirumandhamkunnu Temple compound",
          "Thirunavaya Railway Station",
          "Thirunavaya Temple",
          "Thirunavaya--Bandar kadavu",
          "Thiruvaly",
          "Thiruvonamala",
          "Thooval Theeram Bridge, Malappuram",
          "Thrikkannapuram",
          "Thunchan parambu",
          "Thurakkal--Airport jn",
          "Thuvvur Railway Station Area, Thuvvur, Kerala, IN (11.12, 76.283)",
          "Tirur Railway Station",
          "Tripuranthakam Temple",
          "Ullanam Paddyfield",
          "Vadakkangara [92,13,6]",
          "Vakkad Beach",
          "Valamboor",
          "Valanchery",
          "Valarad",
          "Valenchery, Morayoor",
          "Valiya Parappoor Kayal",
          "Valiyakunnu",
          "Valiyaparappur Thamara Kayal (Lotus Lake)",
          "Vallikkunnu [92,3,3]",
          "Vallikkunnu beach",
          "Valluvambram",
          "Vaniyambalam",
          "Varanakkara",
          "Vattamkulam [82.6.1]",
          "Vazhakkad",
          "Vazhayur Hills VP1",
          "Vazhikkadavu",
          "Vazhikkadavu Viewpoint",
          "Vazhoorhills,Vazhayur, Kerala",
          "Velimukku Chali",
          "Veliyankode Estuary",
          "Vendalur",
          "Vengaparatha",
          "Venkulam Water bodies",
          "Vilayil",
          "Vilayil Cell 2",
          "Villathoor, Pathappiriyam",
          "Villoonniyal",
          "Wandoor--Ambalappadi",
          "Wandoor--Bus stand",
          "Wandoor--Kottammal",
          "Wandoor--Puliyakkode",
          "West Chathalloor",
          "Wild Planet devala",
        ],
      },
      {
        district: "Palakkad",
        localities: [
          "1st Stream Birding Patch, Ring road, Malampuzha",
          "1st river feeding Malampuzha dam, Kava",
          "71,26,6 PKM-Anappady",
          "71,27,1 PKM-Anappady",
          "Adakkaputhur",
          "Adichira",
          "Agali",
          "Agali - Sambarcode",
          "Ahalia Campus",
          "Ahalia Campus--Eye Hospital and nearby pond",
          "Ahalia Campus--Pond near IIT hostel",
          "Ahalia Campus--Sculpture Park and Hillock",
          "Akathethara",
          "Alathur Bird City",
          "Alayar East",
          "Alexandria Estate Sub-cell No.  71,22,5",
          "Amayoor",
          "Anaikatti - Sholayoor RD 1",
          "Anaikatti - Sholayoor RD 2",
          "Anakkal Vayal",
          "Anakkal-Malampuzha Range",
          "Anakkappara",
          "Anakkara",
          "Anamada Estate",
          "Anamooly",
          "Ananganadi",
          "Annanthode Palayampallam",
          "Arangottukara Heronry",
          "Arangottukkara",
          "Arikkadu",
          "Arogyampadavu Lake",
          "Ashtamgam Ayurveda Chikitsalayam & Vidyapeedham",
          "Astamgam Ayurveda Vidyapeedham, Vavanoor",
          "Athani Hospital",
          "Athippotta Junction",
          "Attappady--General Area",
          "Ayalamudi",
          "Ayyappanpara Temple, Vellarimedu, Payyalore, Palakkad, IN (10.57, 76.682)",
          "Ayyarmala Thenur Palakkad",
          "Ayyarmala Theruparambu Fig Tree Palakkad, Kerala",
          "Bharatha Puzha Riverbed, Near Mayannur Bridge",
          "Bharathappuzha River Check Dam",
          "Bharathapuzha Thadayana Cheruthuruthy",
          "Bharathapuzha, Pattambi",
          "Bharathapuzha, Velliyankallu, Thrithala",
          "Bhavani River Bridge",
          "Bi-pass jn to Bus stand, Vadakkencherry",
          "Bodichala-Sholayur RD, Kerala",
          "Brahmakulam Tank",
          "Bypass Junction to Bus stand, Vadakkemcherry",
          "Canal RD, Kadampazhipuram",
          "Carmel CMI School, Kallippadam, Shoranur",
          "Centre for Harmonious Living, Kumbidi",
          "Chaalaayi-Playampallam",
          "Chadanamkurissi - Thirunellayi RD",
          "Chambrakulam Tank",
          "Chambrakulam, Nombikode",
          "Chandranagar Bye-pass beginning",
          "Chandranagar Colony",
          "Cheekkuzhi Hills, Akathethara, Palakkad Kerala, IN (10.844, 76.644)",
          "Cheekkuzhi Hills, Akathethara,Palakkad Kerala, IN (10.843, 76.647)",
          "Cheerath Eri, Eduppukulam",
          "Chembalod wetlands",
          "Chembana Hillocks, Malampuzha",
          "Chembana, Kava (Malampuzha) Water Front.",
          "Chengamkunnu River Bed",
          "Cheriya Kutrippallam",
          "Cheriya Walakkad-Kunthi River",
          "Cherottuveli Eri",
          "Cheruthuruthy Bridge",
          "Chillikkal Thodu (Kongad)",
          "Chirankara Pond",
          "Chithali Palam",
          "Chitoor, Attappady",
          "Chokkanatha Puram, Palakkad",
          "Choolanur Peafowl Sanctuary",
          "Choorakkode palam",
          "Chulannur",
          "Chulanur Peafowl Sanctuary (Entrance)",
          "Chulliyar Dam",
          "Chulliyar Dam View Point",
          "Chulliyar Dam, Vellaramkadavu Entry, Kerala, IN (10.589, 76.763)",
          "Chulliyar Dam, Vellaramkadavu Mariamman Temple Entry, IN (10.582, 76.77)",
          "Chulliyar Reservoir",
          "Churupara--Mangalam Dam RF",
          "Churupara--Mangalam RF",
          "College of Avian Sciences and Management Campus , Kerala",
          "DFO Office, Olavakode, Palakkad",
          "Deer Park Walayar",
          "Dhoni hills",
          "Dhonigundu",
          "Eco City, Kousapara",
          "Edathara, Palakkad",
          "Eduppukulam Tank",
          "Elambulasseri",
          "Elappully",
          "Elavanchery",
          "Elival Entry point",
          "Elivalmala",
          "Eruthenpathy RD",
          "Ezhakkad, Kongad, Palakkad",
          "Fig Tree Spot-Nombicode RD",
          "Fig Tree in front of Hemambika Temple, Malampuzha.",
          "Fig Tree, Kannamkulam Canal Bridge, Kadamkode, Palakkad",
          "Gopalakrishna Swamy Temple Pond, Pallanchathanur",
          "Government College, Chittur",
          "Government Orange Farm, Nelliyampathy",
          "Govt Medical College backyard, Palakkad",
          "Govt. Engg College, Mannambatta, Sreekrishnapuram",
          "Holy Trinity School Kanjikode",
          "IRTC Mundoor, Palakkad",
          "Jellippara",
          "Jellippara Range",
          "K.P. Estate",
          "KLDB Dhoni Farm Palakkad",
          "KSEB Walayar 110 KV Sub Station RD",
          "Kaatadikkunnu,Cheekuzhi RD, Akathethara",
          "Kacheriparambu",
          "Kadalakurishi, Palakkad",
          "Kadambazhippuram",
          "Kadamkkode",
          "Kadamkkode, Palakkad",
          "Kadampazhipuram Junction",
          "Kadampazhipuram-Vengasseri Road",
          "Kaikatty Halfway",
          "Kaila's Forest Resort",
          "Kakkayur",
          "Kakkayur II",
          "Kakkupathi Pirivu,  Goolikadavu",
          "Kalchadi",
          "Kalkandy - Bhavani River Bank",
          "Kalladikkodan Foothills, Puthuppariyaram, Near Kottakkundu falls",
          "Kalladikode-Sreekrishnapuram RD",
          "Kallandichalla",
          "Kallepully Paddyfields",
          "Kallipara Camp shed- Paramikulam Tiger Reserve",
          "Kallukoottiyal",
          "Kallukoottiyal, Polpully",
          "Kalluvazhi-Karinchetti RD",
          "Kalluvazhi-Karinchetti RD Paddy Fields",
          "Kalmandapam",
          "Kalmandapam Paddy Fields",
          "Kalmandapam Paddyfields",
          "Kalmandapam Paddyfields, (East of Canal) (10.771, 76.674)",
          "Kalpathy New Bridge",
          "Kalyanapetta",
          "Kambalathara Vengalakkayam Reservoir",
          "Kandancode Paddyfields, Olassery",
          "Kanjikode Railway Station North",
          "Kanjikode West Post Office RD",
          "Kanjirapuzha Reservoir",
          "Kanjirapuzha Reservoir - Irumbakachola",
          "Kanjirapuzha Reservoir - Kornakunnu",
          "Kanjirapuzha Reservoir - Vellathode",
          "Kannadi",
          "Karakkad Railway Station",
          "Karalmanna",
          "Karappara Bus Waiting Shed",
          "Karappara Road 1st Culvert",
          "Karashoori Temple",
          "Karikatti Meenvallom",
          "Karimkulam Tank",
          "Karimpuzha Bridge",
          "Karimpuzha Co-Operative Urban",
          "Karippode Thara",
          "Karippodu junction",
          "Karkidamkunnu--Kara",
          "Karkkidamkunnu",
          "Karuvappara West",
          "Kattukulam Road",
          "Kava (Chembana )  Rock Point.",
          "Kava (Malampuzha) Nightjar Valley Right Side.",
          "Kava (Young Birders' Club) spot - right hand side",
          "Kava East view point",
          "Kava Water Front Hills,  Malampuzha",
          "Kava hillside (Nightjar valley), Malampuzha - (10.832, 76.728)",
          "Kava, Malampuzha, Palakkad",
          "Kavasseri-I",
          "Kawa Forests",
          "Kayyeni Nature Camp",
          "Kazhani Chungam junction",
          "Kerala Medu-Siruvani Forest",
          "Kesavan para, Near AVT Estate",
          "Killikurissimangalam",
          "Kinarpallam",
          "Kinfra Industrial Park Lake, Kanjikode",
          "Kizhakkethala, Near Koymor Padam",
          "Kizhayur Nambram Thadayana- Check Dam",
          "Kodikkunnu",
          "Kodumunda Railway Station",
          "Koduvayoor- Pallassana RD",
          "Koduvayoor--Palakkad RD",
          "Koduvayur-Thrippalur RD (KBA Cell)",
          "Kolakkode",
          "Kollengode Forest Range Office",
          "Kollengode-Kunissery Road (KBA Cell)",
          "Kolluparambu (Verkoli)",
          "Komangalam hill area, Koottanad",
          "Komangalam wetland and adjacent woody zone, Koottanad",
          "Kombidithirivu",
          "Kongakulam Pond, Nombikode",
          "Kongamapara, Behind VV College , Chullimada, Palakkad",
          "Koodam(88,28,9)",
          "Koottanad",
          "Koottilakadavu Bridge",
          "Koottilakkadavu-Elambulasseri RD",
          "Koottupatha",
          "Koottupatha BPL Factory",
          "Kotamutti Falls Road Banyan Tree",
          "Kottamala Ayyappaswamy Temple",
          "Kottamutti Falls Trail, Kerala, IN (10.827, 76.782)",
          "Kottappalam Bridge, Kalippara-Kalleppully, Palakkad",
          "Kottassery Paddyfields",
          "Kottassery South",
          "Kottathara Hillocks",
          "Kottekkad Paddy Fields Areas,Palakkad",
          "Kottekkad Paddyfields",
          "Kozhinjampara Bus Stand",
          "Kozhinjamparambu Paddy Fields",
          "Kozhiyamala,  Chembana, Kava, Malampuzha",
          "Kulamukku Kaayal",
          "Kulappully",
          "Kumaranellur",
          "Kumbidi, Barathapuzha",
          "Kunnam Pitari Reservoir",
          "Kunnamkattupathy",
          "Kunnamkattupathy Bridge",
          "Kuruvanpady",
          "Kuruvattoor",
          "Kuzhalmannam (KBA Cell)",
          "Lakkidi Railway Station",
          "Livestock Research Station, Thiruvazhamkunnu",
          "Local Road, Nhangattiri",
          "Malampuzha -Eagle Owl Point",
          "Malampuzha Gardens",
          "Malampuzha Left RR-Stream Cross Point 1",
          "Malampuzha Main Canal Paddyfields (Historical?)",
          "Malampuzha Reservoir",
          "Malampuzha Reservoir (North side)",
          "Malampuzha Reservoir (North)",
          "Malampuzha Reservoir (North)  Secondary Forest -Breakfast point.",
          "Malampuzha Reservoir (North) Secondary Forest  Area.",
          "Malampuzha Reservoir (West)",
          "Malampuzha Reservoir - Palmyra Point",
          "Malampuzha Reservoir--Anakkal Forest Station Viewpoint",
          "Malampuzha Ring Road (Left hand side)",
          "Malampuzha SW",
          "Malampuzha Spill-way Bridge Roadside",
          "Malampuzha canal Chandranagar Bridge",
          "Malampuzha-Incomplete Bridge Area",
          "Mampad, Kizhakkencherry",
          "Manakkad Mariyamman Kovil, Padoor",
          "Manalaroo Estate Lily Division",
          "Manali",
          "Manappully Bhagavathy/ Ayyappa temple",
          "Mangalam Dam Forest Station",
          "Mangalam Palam",
          "Mangalam RF--General Area",
          "Mangalam Reservoir",
          "Mangalam Reservoir - Earth Dam",
          "Mangalam Reservoir - Kulikadavu",
          "Mangalam palam",
          "Mangalamkunnu",
          "Mangottukavu Temple",
          "Mangottukavu Temple, Tarur",
          "Mankara Railway Station",
          "Mannannur",
          "Mannanur Railway station",
          "Mannarkkad Forest Division--Bommiyampathi towards Doddagatti Colony",
          "Mannarkkad Forest Division--Chundappatti towards Thazhe Mulli",
          "Mannarkkad Forest Division--Mele Mulli towards Dabbakkadavu",
          "Mannarkkad Forest Division--Muthikulam towards Singappara",
          "Mannarkkad Forest Division--Mutikulam - Elivaal",
          "Mannarkkad Forest Division--Puthoor Forest Station - Mallikathottam",
          "Mannarkkad Forest Division--Singappara towards Koodam",
          "Mannarkkad--Cherumkulam",
          "Mannarkkad--Cherumkulam Road Checkpost",
          "Mannathu Kavu",
          "Manthakkad",
          "Maranatty Waterfalls FootHills, Near Goolikadavu Junction",
          "Marutharoad-Kasaba",
          "Maruthi Bhagavathy temple",
          "Mathupully -Peringode-Palakkad",
          "Mathur",
          "Mathur East,  Palakkad",
          "Mathur, Palakkad",
          "Mattumala Hillock",
          "Meenakshipuram",
          "Meenkara Dam Dual Shutters",
          "Meenkara II",
          "Meenkara Reservoir",
          "Meenkara Reservoir ( Muthalamada South)",
          "Meenkara Reservoir.1",
          "Meenvallam Waterfalls",
          "Meera Floor Estates",
          "Meeraflores Estate",
          "Melapunchapadam-Kattukulam Road",
          "Menna Nagar Colony, 20/262",
          "Menonpara Bridge",
          "Mepparamba Paddy Fields",
          "Merryland Resort Front View to stream",
          "Mucheery Road - Keralassery",
          "Mudavannur Sivakshethram",
          "Mukkai Rites Ground",
          "Mukkali Mathruka Forest Station",
          "Mulli",
          "Mundaya",
          "Mundoor junction",
          "Mundur",
          "Mundur IRTC (KBA Cell)",
          "Munsiff Challa",
          "Muringamala Hillock, Chitalipalam, Kerala, IN (10.68, 76.595)",
          "Muthalamada",
          "Muthikulam(87,29,7)",
          "Muthukkurissy",
          "Muthuthala",
          "NSS College Ottapalam, Palappuram",
          "Naragampalli river, Pudusseri",
          "Narasimukku",
          "Near Ullas Nagar",
          "Nehru Colony",
          "Neithala East",
          "Nelliampathy Hills",
          "Nelliampathy Hills--82 Plantations",
          "Nelliampathy Hills--General Area",
          "Nelliampathy Hills--Golden Valley Estate",
          "Nelliampathy Hills--KFRI Seed Station",
          "Nelliampathy Hills--Kaikatty",
          "Nelliampathy Hills--Karimala",
          "Nelliampathy Hills--Lower Nelliampathy",
          "Nelliampathy Hills--Mattumala",
          "Nelliampathy Hills--Nelliampathy Hill Top",
          "Nelliampathy Hills--Pakuthippalam",
          "Nelliampathy Hills--Pothumala",
          "Nelliampathy Hills--Pothundu Estate",
          "Nelliampathy Hills--Rosary Estate",
          "Nelliampathy Hills--Seetharkundu",
          "Nelliampathy Hills--Thoothanpara Estate",
          "Nelliampathy Hills--Victoria",
          "Nelliampathy Hills--Victoria road",
          "Nelliampathy Reserve Forest--Karappara",
          "Nelliampathy--Karappara",
          "Nelliampathy--Minnampara Forests",
          "Nellimedu Colony",
          "Nelliyampathy",
          "Nelliyampathy Forest Reserve",
          "Nelliyampathy Ghat 2nd Bend from Pothundy Dam",
          "Nelliyampathy Ghat Road",
          "Nelliyampathy Hills--Road to Thookupalam",
          "Nelliyampathy Orange Farm",
          "Nemmara Bye-Pass",
          "Nemmara--Ayyappankunnu",
          "Nemmara--Mannam(Nairthara Area)",
          "Nerangampara Hillocks",
          "New Colony, Kalmandapam",
          "Neytharakode",
          "Nightjar Valley (Road Side)",
          "Nochupully, Mundoor",
          "Nombikode Road",
          "Nooradi Brookland Road",
          "Noorady",
          "North of Kadampazhipuram Hospital Junction",
          "North-West of Vakkada",
          "Nursing Home, Pattambi",
          "Nutmeg Valley, Mailampully, Puthuppariyaram, Palakkad",
          "Olavakkod-Dhoni (KBA Cell)",
          "Olavakkode Railway Station Road",
          "Onnampuzha Trail on West Bank, Malampuzha-I, Kerala, IN (10.857, 76.726)",
          "Orukomban Camp Shed",
          "Othalur",
          "Ottapalam",
          "Ottapalam Railway Station",
          "Ozhalapathy",
          "Paalana",
          "Paalanamkurissi Lotus Pond",
          "Padagiri, Nelliyampathy",
          "Paddy Fields, Alangad, Palakkad",
          "Paddy fields near Ilayabhagavathy temple, Kanjikode, Kerala, IN",
          "Padikkal padam",
          "Padukutty",
          "Padukutty River",
          "Paehathuruthu Nallepilly",
          "Pakuthippalam KFDC Estate",
          "Palakkad Forest Division--Chavadippara towards Parappatti",
          "Palakkad Forest Division--Elival towards Paalamala",
          "Palakkad Forest Division--Kanjikkadavu towards Palamala",
          "Palakkad Fort",
          "Palakkad Fort East Yard Bridge",
          "Palakkad Hills - Kava-Right-side of Nightjar Valley.",
          "Palakkad Hills--Dhoni",
          "Palakkad Hills--Elival Foothills",
          "Palakkad Hills--Kava",
          "Palakkad Junction Railway Station",
          "Palakkad KSRTC Bus Stand",
          "Palakkad Ponnani Road, Vadanamkurissy",
          "Palakkuzhi PCA1",
          "Palappuram Railway Station",
          "Palayankad paddyfields, Olassery new bridge area",
          "Palghat Lions School",
          "Pallassana Parakkalam",
          "Pallassana, Palakkad",
          "Pallathery",
          "Palli junction, Tharoor",
          "Pallimedu",
          "Pallippuram Railway Station",
          "Pambampallam-BEML",
          "Pannimada: Kanjikode-Malampuzha Road",
          "Pappadappara",
          "Para",
          "Para (KBA Cell)",
          "Parakkulam hill",
          "Parali Bridge",
          "Parali Kadavath",
          "Parali Railway Station",
          "Parambikulam TR - Koochimudi Camp Shed",
          "Parambikulam Tented Niche",
          "Parambikulam Tiger Reserve- HQ-Anappadi",
          "Parambikulam Tiger Reserve- Pulikkal SO",
          "Parambikulam Tiger Reserve- Tramway - Pulikkal SO",
          "Parambikulam Tiger Reserve--Anapaddy",
          "Parambikulam Tiger Reserve--Bagapallam",
          "Parambikulam Tiger Reserve--General Area",
          "Parambikulam Tiger Reserve--Kuriyarkutty",
          "Parambikulam Tiger Reserve--Muthuvarachal",
          "Parambikulam Tiger Reserve--Orukkombankutti",
          "Parambikulam Tiger Reserve--Parambikulam",
          "Parambikulam Tiger Reserve--Peruvaripallam",
          "Parambikulam Tiger Reserve--Poopara",
          "Parambikulam Tiger Reserve--Thekkady",
          "Parambikulam Tiger Reserve--Thellikkal",
          "Parambikulam Tiger Reserve--Thunakkadavu",
          "Parambikulam-Anappady-Office complex",
          "Paramibikulam Tiger Reserve--Parambikulam Reservoir",
          "Parassery",
          "Pattambi",
          "Pattambi Bridge, Pattambi",
          "Pattambi Bus Stand",
          "Pattambi Guruvayoor Temple",
          "Pattambi Railway Station",
          "Pattambi Town",
          "Pattanchery",
          "Pattikkayal,Thrithala",
          "Pattiyar (88,29,6)",
          "Pazhambalakode jn",
          "Peradikunnu, Pathiripala, Palakkad",
          "Peringodu-Pulapatta Road",
          "Peringodu-Pulapatta Road Junction",
          "Peringottukurissi--Paddy Fields",
          "Perumudiyoor School Woods",
          "Pervampu",
          "Pezhumkara (Mepparamba Kavilpad Bye Pass Road)",
          "Pittupeedika",
          "Pittupeedika, Koduvayur",
          "Plazhy",
          "Poabs Estate, Green Valley Road",
          "Polyclinic Junction",
          "Ponnamkode-Koottilakkadavu Road",
          "Ponnamkode-Koottilakkadavu-Elambulasseri Roads Junction",
          "Poochipara Trek Path",
          "Poochippara 93,22,7 First cell4/4",
          "Poodur-Palakkad (KBA Cell)",
          "Pooncode",
          "Poothani-Perumkulam  Tank",
          "Pothundi gardens",
          "Pothundy Dam Above Bend",
          "Pothundy Reservoir",
          "Pudanur Estate",
          "Puduppariyaram",
          "Pudusseri (KBA Cell)",
          "Pudusseri South",
          "Pudussery",
          "Pulayampara KSEB Sub Station",
          "Pulayanpara, Nelliampathy",
          "PulikkalSO, Parambikulam Tiger Reserve- HQ-Anappadi",
          "Puliyankavu Temple, Karingarapully, Kodumbu",
          "Puliyappatta kayal, Koottanad",
          "Pulpurumannam Paddy Fields.",
          "Punchapadam",
          "Puthiya Road",
          "Puthunagaram town",
          "Puthur",
          "Puthur NH Junction",
          "Puzhakkalthara Road, Nenmara, Kerala, IN (10.588, 76.594)",
          "R V Pudur East",
          "RARS, KAU, Pattambi",
          "Railway Coach Factory Site, Kanjikode",
          "Railway Park, Institute Road",
          "Ramasseri Sivan Kovil Pond, Elappully",
          "Ravanakkunnu Para, Valara",
          "Rayiranalloor",
          "Regional Agricultural Research Station, Pattambi",
          "River Bharathappuzha, Kerala (OBI)",
          "Road behind Indira Gandhi Bus Stand, Palakkad",
          "Rock Garden, Malampuzha",
          "Rosefinch Valley-Nelliyampathy Ghats",
          "SRCM, Kava",
          "SVNP-Mukkali Road",
          "Sai Junction Heronry",
          "Salamath Nagar, Tank",
          "Seethargundu-car parking area",
          "Seetharkundu Waterfalls",
          "Selvapalayam",
          "Service Co-operative Bank, Pengattiri",
          "Sharadambal Temple Premises, Palakkad, Kerala, IN (10.762, 76.679)",
          "Shiva Kshethram",
          "Shokanashini Riverine Wetland",
          "Sholaiyur, Agali Forest Range",
          "Sholayur",
          "Shoranur",
          "Shoranur Railway Station",
          "Silent Valley NP - Karuvara",
          "Silent Valley NP--Anavai - Hawlock",
          "Silent Valley NP--Anavai towards Thodukki",
          "Silent Valley NP--Koomban",
          "Silent Valley NP--Koombanmala",
          "Silent Valley NP--Neelikkal",
          "Silent Valley NP--Neelikkal Hut",
          "Silent Valley NP--Panthamthode towrds Mukkali",
          "Silent Valley NP--Poochappara",
          "Silent Valley NP--Poochippara towards Neelikkal",
          "Silent Valley NP--Poochippara towards Sairandhri",
          "Silent Valley NP--Poonchola",
          "Silent Valley NP--Punnamala",
          "Silent Valley NP--Sairandhri towards Punnamala",
          "Silent Valley NP--Sairandhry",
          "Silent Valley NP--Sispara",
          "Silent Valley NP--Walakkad",
          "Silent Valley NP--Walakkad towards Poochippara",
          "Silent Valley National Park--General Area",
          "Silent Valley National Park--Mukkali",
          "Silent Valley, Chindakki-Treetop Resort",
          "Silent Valley-Mukkali Road",
          "Silent Valley-Panthanthode stream",
          "Silent valley Mukkali gate",
          "Siruvani - Forest Camp/Staion",
          "Siruvani Reserve Forest--General Area",
          "Siruvani Reserve Forest--Karimala",
          "Siruvani Reserve Forest--Koodam",
          "Siruvani Reserve Forest--Kuravampady",
          "Siruvani Reserve Forest--Muthikulam",
          "Siruvani Reserve Forest--Pattiyar",
          "Siruvani Reserve Forest--Singappara",
          "Siruvani Reserve Forest--Siruvani Dam",
          "Soorya Chira Shiva Paarvathy Temple (Pudusseri) surroundings",
          "Srambi",
          "Sreekrishnapuram Central School",
          "Sri Ramanasramam",
          "Sunrise rocks, Malampuzha",
          "Tattamangalam Pond",
          "ThalikaKallu Vellati S1",
          "Thalikakallu Vellatti S2",
          "Thalikakallu Vellatti S3",
          "Thalikakallu Vellatti S4",
          "Thalikakallu Vellatti S5",
          "Thalikakallu Vellatti S6",
          "Thalikakallu Vellatti S7",
          "Thalikakallu Vellatti S8",
          "Thanisseri, Palakkad",
          "Thanneerpandal",
          "Thassarak,  Palakkad",
          "Thathengalam,Mannarkkad",
          "Thathwamasi-Anthimahakalan Kavu",
          "Thavalam, Attappady",
          "Thavalam, Mulli Road",
          "Thekkady Forest Station",
          "Thenari Theerthampadam",
          "Thenidukku",
          "Thenkurisi Paddy Fields, Palakkad",
          "Thenkurissi-Vakkathara (KBA Cell)",
          "Thenkurussi Paddyfields",
          "Thennilapuram, Alathur, Palakkad",
          "Thirumitakode Temple Road, Thirumittacode-I, Kerala, IN (10.782, 76.183)",
          "Thirumullapully Mahadeva Temple--Karalmanna",
          "Thirunellai",
          "Thirunellai Bridge",
          "Thiruvalathur Paddyfields",
          "Thiruvizhamkunnu",
          "Thodukappu Kunnu Eco Tourism",
          "Thottumugham Bridge- Thirumittacode, Kerala, IN (10.784, 76.181)",
          "Thottuvaya Siva Temple Road",
          "Thrippalamunda Mahadeva Temple Road",
          "Thrithala",
          "Thuthampara Estate",
          "Thuthampara Estate (Cell No.  71.23.2)",
          "Toothampara Forest Estate IB",
          "Ullanoor",
          "Vaadapparambu, Thirunellayi",
          "Vadanamkurussi",
          "Valara Kulam",
          "Vallappuzha Railway Gate",
          "Vallapuzha",
          "Vandithode-Paddico",
          "Vannamada",
          "Varagaliar Elephant Camp, Annamalai Wildlife Sanctuary",
          "Varagampadi",
          "Vattapara, Walayar",
          "Veezhumala Hillocks, RF",
          "Veliyampallam Road wih Pottakkulam",
          "Vengalakayam Reservoir (10.667, 76.823)",
          "Vengalakayam Reservoir--East Side",
          "Vengassery",
          "Vengodi-Ramassery Openlands",
          "Venthapalayam",
          "Verkoli",
          "Vettukad, Kulukkallur",
          "Victoria Bus Terminus, Nelliyampathy",
          "Victoria,  Nelliyampathy  Hills",
          "View Point (Near Ayyappan Temple)",
          "Vijnanaramaneeyam, Sri Ramanasramam-Palakkad",
          "Walakkad Section Camp",
          "Walayar Motels Wetland (Historical)",
          "Walayar Reserve Forest",
          "Walayar Reserve Forest--MCL Mines",
          "Walayar Reservoir",
          "Yakkara, Palakkad",
          "malampuzha2",
        ],
      },
      {
        district: "Pathanamthitta",
        localities: [
          "38.29.1 (ptr kochupampa)",
          "38.29.6 Kochupamba",
          "Aangamoozhy-Moozhiyar Road",
          "Achankovil Forest Division--Achankovil",
          "Achankovil Forest Division--Chittar",
          "Achankovil Forest Division--Devarmala",
          "Achankovil Forest Division--Kanayar",
          "Achankovil Forest Division--Kottavasal",
          "Achankovil Forest Division--Toovalmala",
          "Achankovil Forest Division-Nedumkulam CS, Kallar Range",
          "Achankovil Forest Divison--Pulikayam",
          "Adavi echo tourism",
          "Adoor",
          "Adoor KSRTC Bus Station",
          "Anathode-Kochu Pamba road",
          "Angamoozhi",
          "Aranmula -Nalkalikkal Wetland",
          "Azhutha--Sabarimala Traditional Trekking Path",
          "Believers Church Medical College Hospital",
          "Bhagavathithara Temple,Peringanad",
          "Catholicate College, Pathanamthitta",
          "Chengara Hilltop",
          "Chenneerkkara Vayal",
          "Chuttippara",
          "Collectorate Compound",
          "Edathitta Paddyfields",
          "Elicode",
          "Ezhinjillam South",
          "Gavi",
          "Gavi Dam",
          "Gavi, Pattanamthita",
          "Kakki - Goodrickal Forest",
          "Kakki Reservoir--Anathodu Flanking Dam",
          "Kalleli",
          "Kallidamkunnu, Sabarimala Traditional Trekking Path",
          "Karimpanakuzhy",
          "Karingali Puncha, Pandalam",
          "Kaviyoor puncha",
          "Kilivayal, Adoor",
          "Koipuram Thiruvalla",
          "Konni - Kalleli",
          "Konni - Kummannur",
          "Konni - Paadam",
          "Konni Elephant Center",
          "Konni IBA",
          "Konni IBA- Naduvathumoozhy Range",
          "Konni- Kokkathodu",
          "Kumbazha",
          "Laha",
          "MEPRAL - THANANGADU COLONY",
          "Macfast College, Thiruvalla",
          "Manakkode Eala(Trichennamangalam Paddy), Peringanad",
          "Mannady Fields",
          "Mar Thoma College, Thiruvalla",
          "Mavara Puncha",
          "Mini Bridge, Plantation road",
          "Moozhikkal",
          "Moozhiyar - Goodrickal Forest Range",
          "Moozhiyar Top",
          "Mukkuzhy",
          "NSS College, Pandalam",
          "Naalumanikkattu, Kozhenchery",
          "Naduvathumoozhy Forest Station, Manneera",
          "Near Manjinakarra church,Omalloor",
          "Nedumonkavu",
          "Netaji HSS Pramadom",
          "Nilackal",
          "Njalloor",
          "Omallor Wetlands",
          "Paadam Forest Station, Konni",
          "Pamba River, Aranmula",
          "Pandalam",
          "Pannivelichira, Aranmula Wetlands",
          "Periyar Tiger Reserve - Kochupamba",
          "Periyar Tiger Reserve--Aanathodu",
          "Periyar Tiger Reserve--Ezhukamannu",
          "Periyar Tiger Reserve--Kalaradichan",
          "Periyar Tiger Reserve--Meenar",
          "Periyar Tiger Reserve--Moozhickal",
          "Periyar Tiger Reserve--Pamba",
          "Periyar Tiger Reserve--Sabarimala",
          "Perumthenaruvi",
          "Perumthuruthy",
          "Plamthode area",
          "Plappally Forest Station",
          "Pushpagiri Hospital",
          "Puthuval",
          "Ranni IBA- Vadasserikkara Forest",
          "Sabarimala 39,28,4 [1]",
          "Sabarimala_temple",
          "Seethathode",
          "St. Thomas College Kozhenchery",
          "St. Thomas College, Ranni",
          "St.Stephens college",
          "Subcell 32,18,4 Manneera",
          "Thiruvalla Railway Station",
          "Thiruvamanapuram-West Othera",
          "Thonnallur Ela",
          "Thoompakulam, Konni",
          "Ulanadu - Polachira",
          "Ulanadu Chira and associated wetlands",
          "VENPALA, Thiruvalla",
          "Vadakkadathukavu Wetlands",
          "Vallikkodu Paddyfields",
          "Venneervila Wetland (Kaviyoor Puncha )",
          "kuppannur puncha",
          "niranam",
          "pannivelichira",
          "vettuvelipadashekharam randampuncha",
        ],
      },
      {
        district: "Thiruvananthapuram",
        localities: [
          "Adimalathura Beach",
          "Agasthiyamalai",
          "Akathumuri Railway Station",
          "Akkulam Lake",
          "All Saints College Campus",
          "Amballoor Paddy Fields",
          "Ambedkar Bhavan",
          "Ananthapuri Hospitals and Research Institute",
          "Anappara, Vazhayanki, Near Kallar",
          "Anchuthengu Fort",
          "Aniyilakadavu Kattakalam",
          "Arabian Sea: 8.4N 76.8E",
          "Arabian Sea: 8.4N 76.9E",
          "Arabian Sea: 8.5N 76.7E",
          "Arabian Sea: 8.5N 76.8E",
          "Arabian Sea: 8.6N 76.6E",
          "Arabian Sea: 8.6N 76.7E",
          "Arabian Sea: 8.7N 76.6E",
          "Arappuramukku",
          "Arsha Ayurvedic Hospital",
          "Aruvikkara Reservoir",
          "Ashramam RD",
          "Asian School of Business, Trivandrum",
          "Base Camp, Agastyarkoodam Trek Trail, Mannoorkara, Kerala, IN",
          "Bhagavathinada-Peringamala, Vizhinjam",
          "Bonaccord Tea Estate",
          "Bonafalls",
          "Braemore Estate",
          "CSM Nagar",
          "Chemmankala",
          "Chenthi Residents Association (CRA)",
          "Chinmaya Vidyalaya Vazhuthacaud",
          "Christ Nagar International School, Kazhakuttam",
          "Christian College, Kattakada",
          "Chungankadavu",
          "Club Mahindra, Poovar",
          "College of Agriculture, Vellayani",
          "College of Engineering Trivandrum",
          "Cotton Hill Girls Higher Secondary School",
          "Devaswom Board Junction",
          "Domestic Airport, Thiruvananthapuram",
          "Don Bosco School Ground Manvila IN (8.539, 76.891)",
          "EMS Academy",
          "Elamparakode Mala",
          "Elamparakode Temple",
          "Elikkunnam",
          "Embassy Homes (Restricted Access)",
          "Goverment College Hostel For Men, Palayam",
          "Government Ayurveda College, Poojappura",
          "Government College Kariavattom",
          "Government Medical College, Trivandrum",
          "Government Paddy Field, Kesavadasapuam",
          "Government Women's College, Vazhuthacaud",
          "Govt VHSS For Girls, Manacaud",
          "ICAR-Central Tuber Crops Research Institute",
          "IISER Thiruvananthapuram",
          "IIST Thiruvananthapuram Campus",
          "Infosys Campus",
          "Institute Of Animal Health And Veterinary Biologicals - Palode",
          "Iqbal College Peringammala",
          "Jawaharlal Nehru Tropical Botanic Garden & Research Institute",
          "Jersey Farm, Vithura",
          "Judgekunnu",
          "KAU Cropping System Research Center, Nedumcadu",
          "Kachani Ayiravalli",
          "Kadinamkulam Lake-- Perunguzhi",
          "Kadinamkulam Lake--Azhoor",
          "Kadinamkulam Lake--Channankara",
          "Kadinamkulam Lake--Perumathura",
          "Kaithappacha",
          "Kalipara",
          "Kallar",
          "Kallattumukku",
          "Kanakakunnu Palace",
          "Kaniyapuram",
          "Kanjiramkulam",
          "Kannamoola",
          "Kannettuvila Temple",
          "Kappil Beach",
          "Keezhattingal",
          "Kerala Forestry and Wildlife Department-- PTP Nagar",
          "Kerala Public Service Commission",
          "Kerala University of Digital Sciences, Innovation and Technology",
          "Kilimanoor Palace",
          "Kochuveli Beach",
          "Kochuveli Railway Station",
          "Konni",
          "Koonichi Hill Trekking Point",
          "Kovalam",
          "Kovalam (Grove) Beach",
          "Kulamada",
          "Lecole Chembaka",
          "Loyola School",
          "Madavoorpara Ancient Rock Cut Shiva Temple",
          "Mahatma Gandhi College, Thiruvananthapuram",
          "Manchadininnavila",
          "Mar Ivanios College",
          "Marappalam-- Canal Bund RD",
          "Museum Bain's Compound",
          "NCESS Akkulam",
          "NSS College Karamana",
          "Nellikkunnu",
          "Nettayam Moonnammoodu Road",
          "Neyyar Dam",
          "Neyyar WLS--Aananirathy",
          "Neyyar WLS--Athirumala",
          "Neyyar WLS--Kappukadu",
          "Neyyar WLS--Kombai",
          "Neyyar WLS--Meenmutty",
          "Neyyar WLS--Nariyappu",
          "Neyyar WLS--Theerthumkara",
          "Neyyar WLS--Varyattumudi",
          "Noorul Islam College of Dental Sciences",
          "Opposite CRPF camp",
          "Pakalkury Mahavishnu Temple",
          "Palayam",
          "Pallippuram Paddyfields",
          "Pappanamcode Wetlands",
          "Parackal , Koliyakode",
          "Pazhanchira",
          "Peppara Reservoir",
          "Peppara WLS--Bonaccord Picket",
          "Peppara WLS--Pandipath",
          "Peppara WLS--Peppara",
          "Perumathura Beach",
          "Perumkulam Pond",
          "Ponmudi Hills",
          "Poojapura",
          "Poovar Mangroves",
          "Poovar North Beach",
          "Poovar--Backwater",
          "Poovar--Beach (Pozhikkara side)",
          "Poovar--Mangroves",
          "Pozhiyoor Golden Sand Beach",
          "Pulluvila Beach and Estuary",
          "Punchakkari--Raptor Monitoring Vantage Point 2",
          "Putharikandam Maidanam (Green Patch)",
          "Puthenthope",
          "Puthenthope Beach",
          "Puthiyathura Beach",
          "Railway Colony, Thampanoor",
          "Rajadhani Institute of Engineering & Technology, Kerala.",
          "Regional Ayurveda Research Institute For Lifestyle Related Disorders",
          "Rock Cut Cave Temple",
          "SK Hospital",
          "SUT Hospital Pattom",
          "Sacred Groove--Manaccaud Durga Temple",
          "Sainik School Kazhakootam",
          "Sasthamangalam",
          "Shanghumugham Beach",
          "Shasthampara",
          "Sree Gokulam Medical College & Research Foundation",
          "Sree Ulakudayaperumal Kshetram, Kesari Nagar",
          "St. Andrews Beach",
          "State Central Library",
          "State Forest Training Institute Road, Arippa",
          "State Public Health Laboratory",
          "Technopark",
          "Thaannimoodu",
          "The Oxford School Trivandrum",
          "Thempamoodu",
          "Thirumala-Valiyavila Paddyfields",
          "Thirumangalam Lane",
          "Thirupalkadal Sree Krishna Swami Temple",
          "Thiruvananthapuram Cental Railway Station",
          "Thiruvananthapuram Zoo",
          "Trivandrum (OBI)",
          "Trivandrum International Airport",
          "University College, Palayam.",
          "University Student's Center, PMG",
          "University of Kerala-- Kariavattom Campus",
          "University of Kerala--Center for Evolutionary and Integrative Biology",
          "Upper Sanatorium, Ponmudi",
          "VSSC Guest House",
          "VTM NSS College",
          "Valayanki",
          "Valiyathura Beach,Thiruvananthapuram",
          "Varkala Beach",
          "Varkala Beach and Clifftop",
          "Varkala Railway Station",
          "Vayanashala, Thiruvallam",
          "Vazhuvanthol",
          "Veli--Lake and Beach",
          "Vellayani Wetlands--Kakkamoola Lake View",
          "Vellayani Wetlands--Venganoor Lake View Point",
          "Vellayani--Punchakkari Wetlands",
          "Velu Thampi Memorial Nair Service Society College (VTM NSS)",
          "Venpakal--Pond",
          "Victory Vocational Higher Secondary School",
          "Vithura (Theviyode - Bonacaud Road) Thiruvananthapuram",
          "Vizhinjam Bus Stand",
          "Vizhinjam Harbour Mosque (Seawatch Point)",
          "Wireless Monitoring Station",
          "kaithappacha",
        ],
      },
      {
        district: "Thrissur",
        localities: [
          "AXIS College-Thaloopadam",
          "Adat Kole Wetlands",
          "Akalad Beach",
          "Akamala [78,13,8]",
          "Amaballur",
          "Amala Institute of Medical Sciences",
          "Amala Nagar",
          "Anakkayam Forest Station1",
          "Anakkayam Forest Station2",
          "Anapantham APC--Vellikulangara RF",
          "Anapantham [69,17,5]",
          "Andathodu",
          "Annamanada",
          "Apollo Tyres",
          "Arabian Sea",
          "Arabian Sea: 10.1N 75.6E",
          "Arabian Sea: 10.1N 75.8E",
          "Arabian Sea: 10.1N 75.9E",
          "Arabian Sea: 10.2N 76.1E",
          "Arabian sea: 10.1N 75.7E",
          "Aramba Nagar Rd",
          "Arangottukara",
          "Arattukadavu, Koodappuzha",
          "Arewsaram Hill",
          "Ariyannur",
          "Ashtamichira Chalakudi Road",
          "Asthra Kambanikkadav Beach",
          "Athirapally Waterfalls",
          "Athirappilli Road-1",
          "Attoor",
          "Ayanthole--General Area",
          "Ayroor",
          "Ayyanthole--Costford",
          "Behind Sobha City--Puzhakkal Kole Wetlands",
          "C.Achutha Menon Memorial Govt. College",
          "Canara Bank",
          "Chaipankuzhi-Choolakadavu RD",
          "Chaipankuzhy--Vellikulangara RF",
          "Chamakkala Beach",
          "Chandipuli Padam",
          "Charpa Falls",
          "Chatalam Paddy Field",
          "Chattukulam",
          "Chavakkad Beach",
          "Chavakkad Puthan Kadappuram",
          "Chazhoor",
          "Cheeni-- Chimmony Dam",
          "Cheeny Valavu Forest",
          "Cheerakavu",
          "Chelakkara",
          "Chelakode",
          "Chelakode View Point",
          "Chemboothra",
          "Chembukkav--General Area",
          "Chemmanthatta",
          "Chemmanthatta Fields--Eyyal",
          "Chemmanthatta Fields--Koompuzha Bridge",
          "Chemmappilly--General Area",
          "Chempuchira",
          "Chenathu Nadu",
          "Chengaloor-Suryamangalam RD",
          "Chengotta Beach",
          "Chenthrapini",
          "Cheppara Rock",
          "Cheppara--General Area",
          "Cheppilakkode Pulpwood Plantation",
          "Cherakazha",
          "Chermanangad",
          "Cherur--General Area",
          "Chettarickal",
          "Chettuva--Mangrove Forest",
          "Chettuva--Rajah Island",
          "Chicklayi",
          "Chimmini Dam",
          "Chimmini Dam RD",
          "Chimmini WLS--Murikinpuzha",
          "Chimminy WLS--General Area",
          "Chimmony Reservoir",
          "Chimmony WLS--Anapporu",
          "Chimmony WLS--Kanjirappara",
          "Chimmony WLS--Mangalamkavu",
          "Chimmony WLS--Mankuzhi",
          "Chimmony WLS--Mulappara",
          "Chimmony WLS--Murukinpuzha",
          "Chimmony WLS--Payampara",
          "Chimmony WLS--Poomala",
          "Chimmony WLS--Vavala",
          "Chimmony WLS--Virakuthode",
          "Chimmony--General Area",
          "Chirakkakode Paddy Field",
          "Chiramanangad",
          "Chiraparambu",
          "Chitilappilly",
          "Chittanda RF",
          "Chokkana",
          "Choorakkattukara Sree Durga Temple",
          "Chorumthanni",
          "Chowallur--General Area",
          "Chowannur",
          "Chowka",
          "Christ College, Irinjalikuda",
          "Chullikavu Check Dam , Marottichal",
          "Chuloor",
          "Chuvanna Mannu",
          "Civil Station--Heronry",
          "College of Veterinary and Animal Sciences, Mannuthy",
          "Devi Temple, Pazhayannur",
          "Edakkazhiyur Beach",
          "Edakulam Wetland",
          "Elanad",
          "Elanad--General Area",
          "Elanad--West",
          "Elanad-Thenazhi Kulam",
          "Elavally",
          "Elavoor",
          "Ellikkathara Paddy Field",
          "Erayamkudy Fields",
          "Eyyal, Kechery Akkikkavu RD",
          "First Break",
          "Gandhi Nagar-Vadookkara",
          "Gourami Fish Farm",
          "Government Engineering College, Thrissur",
          "Guruvayoor Temple",
          "Guruvayur--General Area",
          "Inchakundu--kumbakulangara--Kodali",
          "Injakund--General Area",
          "Irinjalakkuda Railway Station",
          "Iron Bridge Vazhachal",
          "Jubily Lane--Koratty",
          "KSB MIL Controls Ltd. (Restricted Access)",
          "KSEB Colony--Pandiparambu",
          "Kachithodu",
          "Kachithodu Check Dam",
          "Kadangode",
          "Kadavallur",
          "Kadikkad",
          "Kadukassery",
          "Kadukutty",
          "Kailasanadha Vidya Nikethan School",
          "Kainoor",
          "Kakkinikad",
          "Kalikkal",
          "Kallayai Tekkinkad",
          "Kallayi",
          "Kallayikunnu, Marottichal",
          "Kallettumkara",
          "Kallettumkara Wetland",
          "Kalletumkara, SH61",
          "Kallur",
          "Kammalam",
          "Kanakamala, Perambra, Chalakudy",
          "Kannambra",
          "Kannamkuzhi Thodu [67,18,2]",
          "Kannamkuzhy",
          "Kannankulagara",
          "Kannoth Padam",
          "Karakulathunadu Paddy Filed",
          "Karamuck North",
          "Karanthodu",
          "Kariat",
          "Karikkadavu, Anappantham",
          "Karikulam",
          "Karoor chira,Alur,Thrissur",
          "Karumathra",
          "Karuvankadu--General Area",
          "Karuvannur -- Rajha co.",
          "Kattappuram",
          "Kattilappoovam [76,15,4]",
          "Kattilappoovam-Kundukad Rd [76,14,3]",
          "Kavala",
          "Kavala--Vellikkulangara RF",
          "Kavanaadu--Mattathurkunnu",
          "Kavanad--General Area",
          "Kazhimbram Beach",
          "Kerala Agricultural University--ACCER",
          "Kerala Agricultural University--Arboretum",
          "Kerala Agricultural University--Botanical Garden",
          "Kerala Agricultural University--General Area",
          "Kerala Agricultural University--Krishi Vignyan Kendra",
          "Kerala Forest Research Institute--General Area",
          "Kerala Forest Research Institute--International Guest House",
          "Kerala Institute of Local Administration (KILA)",
          "Kerala Kalamandalam",
          "Kerala Police Academy Campus",
          "Kerala Sahitya Academy",
          "Kerala University of Health Sciences (KUHS)",
          "Killimangalam",
          "Kizhakkumpattukara--General Area",
          "Kizhoore",
          "Kodakara--General Area",
          "Kodungalloor Backwaters",
          "Kodunthirapully",
          "Kolathur - Anandapuram",
          "Kole Wetands --Chenam",
          "Kole Wetands--Paralam",
          "Kole Wetlands -- Annakara",
          "Kole Wetlands Enammavu-II",
          "Kole Wetlands--Adat--General Area",
          "Kole Wetlands--Akamthuruthu",
          "Kole Wetlands--Alapad",
          "Kole Wetlands--Ambakkad",
          "Kole Wetlands--Anthikkad Padasekharam",
          "Kole Wetlands--Aranattukara",
          "Kole Wetlands--Arimbur",
          "Kole Wetlands--Ayanikkad",
          "Kole Wetlands--Chenam",
          "Kole Wetlands--Chiranellur",
          "Kole Wetlands--Chitilappilly",
          "Kole Wetlands--Choorakkattukara",
          "Kole Wetlands--Elthuruth",
          "Kole Wetlands--Enadi",
          "Kole Wetlands--Enamavu",
          "Kole Wetlands--Enamavu Regulator Bridge",
          "Kole Wetlands--Guruvayur",
          "Kole Wetlands--Irimbranallur",
          "Kole Wetlands--Kanjani (Pullu Side)",
          "Kole Wetlands--Kanjani--General Area",
          "Kole Wetlands--Karanchira Paddy Field",
          "Kole Wetlands--Kondhipulam I",
          "Kole Wetlands--Konthipulam II",
          "Kole Wetlands--Konthipulam III",
          "Kole Wetlands--Kuroor Para",
          "Kole Wetlands--Madhukkara",
          "Kole Wetlands--Manakodi",
          "Kole Wetlands--Marekad",
          "Kole Wetlands--Mulloorkayal",
          "Kole Wetlands--Mullurkayal",
          "Kole Wetlands--Muriyad",
          "Kole Wetlands--Murppara",
          "Kole Wetlands--Nedumbal",
          "Kole Wetlands--North Pullu",
          "Kole Wetlands--Padiyam",
          "Kole Wetlands--Padiyur",
          "Kole Wetlands--Palakkal",
          "Kole Wetlands--Pallippuram",
          "Kole Wetlands--Panthode",
          "Kole Wetlands--Parppakadavu",
          "Kole Wetlands--Perumbuzha",
          "Kole Wetlands--Perumbuzha Padam (Enamavu--AWC Site)",
          "Kole Wetlands--Perumpuzha Bridge",
          "Kole Wetlands--Pullazhi",
          "Kole Wetlands--Pullu",
          "Kole Wetlands--Puranattukara",
          "Kole Wetlands--Puzhakal",
          "Kole Wetlands--Puzhakkal",
          "Kole Wetlands--Tholur",
          "Kole Wetlands--Thommana",
          "Kole Wetlands--Thottippal",
          "Kole Wetlands--Uppungal 1",
          "Kole Wetlands--Vallur Padavu",
          "Kole Wetlands--Valoor",
          "Kole Wetlands-Kuttoor",
          "Kole Wetlands-Madhukkara",
          "Kole wetlands - Thommana",
          "Kondayur_Paddy Fields",
          "Kondazhi",
          "Konnakuzhi RD",
          "Konnakuzhy",
          "Konnakuzhy, Chalakudy - Anamala RD",
          "Konoor",
          "Koorikuzhi Beach",
          "Koorkenchery Saw Mill Road",
          "Koranchira",
          "Koratti Angadi Railway Station",
          "Korumbissery Paddy Field",
          "Kotatt Wetlands",
          "Kothakulam Arappa",
          "Kothakulam Beach",
          "Kottapadi",
          "Kottappuram Muziris Fort (Remnants)",
          "Kozhukkulli - Nadathara",
          "Krishnapuram Village",
          "Kulathur",
          "Kulathur-Anandapuram",
          "Kumbalangad",
          "Kumbalangad [78,12,1]",
          "Kunnamkulam",
          "Kunnathara",
          "Kuranjiyoor",
          "Kurinjakkal Thuruthu",
          "Kurumala",
          "Kuthiran",
          "Kuttumuck-Nellankara Paddy Field",
          "Kuttumucku-Nettissery Paddy Field",
          "Kuttumukku--General Area",
          "Lakshmi Kulam",
          "Madakkathara",
          "Mala Town",
          "Mala-Vadama Paddy Fields",
          "Malakkappara",
          "Malakkappara RF--General Area",
          "Malakkappara Town",
          "Malkkappara RD--Aanakkayam Bridge",
          "Mammiyoor--Little Flower College",
          "Manalitara-Punnamparambu",
          "Manathala --Chavakkad Beach RD",
          "Mandikunnu",
          "Mangad Paddyfields Viewpoint",
          "Manjakalpara",
          "Mankidi",
          "Mankuzhi--Chimmony WLS",
          "Mannalamkunnu Beach",
          "Mannuthy--General Area",
          "Marakkad Kadavu",
          "Marathakkara",
          "Marottichal Forest area",
          "Marottichal--Simbo Kunnu",
          "Mathaichira",
          "Mattathur",
          "Mattom",
          "Mayannur",
          "Mayilattumpara",
          "Mechira",
          "Meladoor",
          "Meloor",
          "Meloor-Pallappilli Road",
          "Moonnumuri",
          "Moonnumury-Mattathur",
          "Mudikkode Shiva Temple",
          "Mukkattukara--General Area",
          "Mulagunnathukavu",
          "Mulangue",
          "Mullur Road",
          "Munakakkadavu",
          "Munambam Beach",
          "Munambam--Munakkal Beach",
          "Mundathikkode",
          "Mundathikode",
          "Mundupalam --Near Sakthan bus station",
          "Munippara",
          "Munippara - Chalakudy Athirapilly Rd",
          "Muttukaayal--Karuvannur River Banks",
          "Nalukettu",
          "Nambian Kavu Temple Rd,Madayikonam",
          "Narayanamangalam",
          "Near Insha hotel",
          "Nedumbal",
          "Nehru Park",
          "Nelluwaya",
          "Nelluwaya--Erumapetty",
          "Nuttudumban Waterfalls",
          "Oalakkayam",
          "Olari",
          "Old Tramway Road--Sholayar RF",
          "Ollukkara Paddy Field",
          "Ollukkara--General Area",
          "Ollur -- General Area",
          "Ollur Railway Station",
          "Ollur--General Area",
          "Orukombankutti, Vazhachal",
          "Pachakkad",
          "Paddy Field",
          "Paddy Field--Vidya Nagar",
          "Paddy Fileds--Dhanya Mission Hospital",
          "Palakkal kole wetland pond",
          "Palappally",
          "Palappilly RF--Chennaayikulam",
          "Palappilly RF--Pothumchal",
          "Palappilly Rubber Estate",
          "Palappilly- Kundai",
          "Paliyekkara toll plaza",
          "Pallimanna Siva Temple",
          "Pallippuram-Chenthuruthi",
          "Pallur",
          "Pampadi-Peringottukurissi Rd",
          "Panajikkal Temple",
          "Panangadavu-  Ambalappara IB rd",
          "Pancavadi--Edakkazhiyur",
          "Panchavadi Beach",
          "Pandiparambu",
          "Panthallur",
          "Parakkad",
          "Paralam",
          "Parambikulam Tiger Reserve--Kothala",
          "Parappuram",
          "Parappuram - Kadavallur",
          "Paratha",
          "Parekkattukkara--Alatur",
          "Pariyaram",
          "Pariyaram RF",
          "Pariyaram RF--Injapara",
          "Pariyaram RF--Mullapanakayam",
          "Pariyaram RF--Vettilappara",
          "Parvathi Lane",
          "Pathazakkundu--General Area",
          "Pathazhakundu Dam",
          "Pathiyarkulangara, Parappur",
          "Pattalam Rd",
          "Pattathazham Paddylands",
          "Pattikkad--Chanoth",
          "Pazhambalacode",
          "Pazhayannur Bhagavathi Temple",
          "Pazhayannur--General Area",
          "Pazhul, Kizhakkummuri",
          "Pazhuvil--General Area",
          "Peechi Dam Site",
          "Peechi Reservoir",
          "Peechi Reservoir [73,17,6]",
          "Peechi Reservoir [74,17,2]",
          "Peechi Reservoir [74,18,4]",
          "Peechi WLS--Karadipara",
          "Peechi WLS--Kombazha",
          "Peechi WLS--Mambara East",
          "Peechi WLS--Mampara",
          "Peechi WLS--Moodal",
          "Peechi WLS--Munipara",
          "Peechi WLS--Olakara",
          "Peechi WLS--Palakkuzhy",
          "Peechi WLS--Vazhani",
          "Peechi WLS--Vellikkayam",
          "Peechi--General Area",
          "Peechi-Vazhani WLS -- General Area",
          "Peechi-Vazhani WLS--Varayanpara",
          "Peringandoor",
          "Perumala",
          "Perumbilavu",
          "Peruvanam Chira",
          "Pillappara, Athirappilly Water falls",
          "Ponganamkadu",
          "Poolachuvadu",
          "Poomala Reservoir",
          "Poonilarkavu Bagavathy temple",
          "Poonkody Paddy Filed",
          "Poovathussery, North Poovathusssery - Meladoor Road",
          "Poringal",
          "Poringal Reservoir",
          "Porkulam",
          "Potta",
          "Potta Road--Near Cosmos Club",
          "Pottore",
          "Poyya",
          "Pudukkad-Mannampetta Rd",
          "Puliyala",
          "Puliyani parambu",
          "Pullazhi",
          "Pullu",
          "Pullu Paddy Fields",
          "Pullut",
          "Punnakuzhi Bridge, Tramway rd",
          "Punnamparambu-Manalithara",
          "Punnathur Kotta",
          "Punnayoor (South)",
          "Punnayurkulam",
          "Puranattukkara--General Area",
          "Pushpagiri Agraharam",
          "Puthan Vettuvazhi",
          "Puzhakkal",
          "Puzhakkal Public Library",
          "Quarry near Kodassery Mala Siva Temple",
          "Rajah Company --Arattupuzha Temple Rd",
          "Rajah Island, Chettuva",
          "Raman Chira Temple",
          "Ramavarmapuram",
          "Randukai RF",
          "Rasa Gurukul Resort",
          "Rice Bazar (Ariyangadi)",
          "Sand Quarry on Kiralur-Anjur road",
          "Sanghukulangara Kavu, SN Puram",
          "Sankarankulangara Temple",
          "Shakthan Thampuran Bus Stand",
          "Shobha City",
          "Sholayar",
          "Sholayar Dam View Point",
          "Sholayar Power house",
          "Sholayar RF [68,19,6]",
          "Sholayar RF--Aanakkayam Forest Station",
          "Sholayar RF--General Area",
          "Sholayar RF--Mechappullikuthu Tree Hut",
          "Sholayar RF--Parappanppara medicinal plantation area",
          "Sholayar Reservoir",
          "Sholayar Reservoir Area",
          "Sholayar [66,24,6]",
          "Sholayar [66,25,4]",
          "Sholayar [66,25,6]",
          "Sholayar [67,23,3]",
          "Sholayar [67,24,1]",
          "Sholayar dam gate Rd",
          "Sholayar--Old Tramway Road",
          "Sowhrdhatheeram Park",
          "Sraayilkadavu Paddyfields",
          "Sri Kozhiyorkavu Bhagavathy Temple & Fields",
          "St. Joseph's Higher Secondary School, Pavaratty",
          "Tennis Club",
          "Thachudaparambu Paddy Field",
          "Thaikkad",
          "Thalore Deepthi High School",
          "Thalore Paddyfield",
          "Thalssery RF",
          "Thanikkamunnayam",
          "Thanikkudam--General Area",
          "Thanikudam,Madakkathara",
          "Thanniyam",
          "Thazhaekkaad Kinur Bus Stop",
          "Thejus Engineering College--Adhoor",
          "Thejus Enginnering College",
          "Thekkinkadu Maidanam",
          "Thichoor",
          "Thiruthekad",
          "Thiruvathra",
          "Thiruvilwamala",
          "Thiruwilwamala-Punarjani Rock Faces",
          "Tholur",
          "Thottippal",
          "Thozhiyur",
          "Thrissur Government Medical College",
          "Thrissur KSRTC Bus Stand",
          "Thrissur Railway Station",
          "Thumboor Mozhi",
          "Thumboormuzhi Dam area",
          "Thumboormuzhi Garden",
          "Thumboormuzhy River Garden",
          "Thumboormuzi",
          "Timber Depot",
          "Traffic Police Station",
          "Tramway Road",
          "Tribal Colony--near Mukumpuzha",
          "Trikkur-Kaloor",
          "Ubhayoor Temple",
          "Udalakavu Temple--Adat",
          "Upper Sholayar",
          "Vadakke Chira Lake",
          "Vadakkekad, Koukanapetty Road",
          "Vadakkethara",
          "Vadakkumnatha Sree Mahadeva Temple",
          "Vadanapally Beach",
          "Vadanappalli Beach",
          "Vadanappally",
          "Vadekkekad",
          "Vaduvan chira -- Kallettumkara",
          "Valapad beach",
          "Vallakunne Anandhapuram Rd,Muriyade Wetlands",
          "Vallathol Nagar",
          "Vallathol Nagar Grama Panchayath Office",
          "Vallissery",
          "Vaniyampara",
          "Varadiyam",
          "Varakkara--Behind Church",
          "Varakkara-Pallikkunnu Rd",
          "Varavoor",
          "Vattoli--Attor RF",
          "Vazani Dam",
          "Vazhachal Division",
          "Vazhachal Forest Division - Pukalappara",
          "Vazhachal Forest Division--Anakkayam",
          "Vazhachal Forest Division--Athirapilly",
          "Vazhachal Forest Division--Karanthodu",
          "Vazhachal Forest Division--Kundur Medu",
          "Vazhachal Forest Division--Malakkappara",
          "Vazhachal Forest Division--Poringal",
          "Vazhachal Forest Division--Sholayar",
          "Vazhachal Forest Division--Sholayar Reservoir",
          "Vazhachal Forest Division--Sholayar View Point",
          "Vazhachal Forest Division--Thavalakkuzhipara",
          "Vazhachal Forest Division--Vachumaram",
          "Vazhachal Forest Division--Vazhachal",
          "Vazhachal Forest Divison--General Area",
          "Vazhachal RF--Konnakuzhi Plantation Rd",
          "Vazhachal Riparian Forest",
          "Vazhachal Waterfalls",
          "Vazhachal- Malakkappara Road. Subcell : 65,25,7",
          "Vazhakode Valavu",
          "Vazhani",
          "Vazhani Reservoir",
          "Vazhany Dam Gardens",
          "Vellakkarithadam--General Area",
          "Vellanikkara",
          "Vellanipacha",
          "Vellanipacha Trek Path",
          "Vellarakkad",
          "Vellichamukku",
          "Vellikulangara",
          "Vellikulangara Kuttichira Rd--Pariyaram",
          "Vellkulangara Range Forest Office",
          "Vellukkara",
          "Vellukkara [67,13,3]",
          "Velumampadi",
          "Venganellur Temple Road",
          "Vengassery",
          "Vettikuzi",
          "Vettilappara",
          "Vettingappadam",
          "Vilangan hills",
          "Villadam",
          "Virakuthodu-- Chimmini Dam",
          "Viruppakka",
          "Wadakanchery Railway Station",
          "Wadakanchery Rly Stn",
          "West Fort Junction",
          "Wetlands--Kallettumkara",
          "Wetlands--Valoor",
          "Zoo and Museum",
          "choolissery fields",
          "good earth/anamala farm house",
          "kanakamala kurishumudi",
          "kollathirumedu",
          "kunnathukad",
        ],
      },
      {
        district: "Wayanad",
        localities: [
          "117,24,9",
          "117,25,1",
          "118,23,2",
          "118,25,6",
          "900 woods eco resort",
          "Agustian's Villa,n Periya",
          "Ambalavayal, Kerala, IN (11.62, 76.21)",
          "Ananterra Resorts (Restricted Access)",
          "Anjukunnu",
          "Arattuthara Paddyfield",
          "Banasura Hill Resort",
          "Banasura Sagar Reservoir",
          "Banasura reservoir",
          "Centre for Wildlife Studies--Pookode",
          "Chembra Peak",
          "Coffee Acres Resort, Kalpetta",
          "College of Veterinary and Animal Sciences, Pookode",
          "DM WIMS, Arapetta",
          "Edakkal Caves",
          "Ela Blooms",
          "Elimbilery Estate",
          "Fern Tree Resort, Mananthavady",
          "Flora Vythiri Resort",
          "Forest Watch Base Camp",
          "Forest Watch Base Camp--Ayilamoola",
          "Forestwatch Base Camp",
          "Fringeford Resort",
          "Government Engineering College Wayanad",
          "Govt Medical College, Mananthavady",
          "Govt. College, Mananthavady",
          "Green Gates Hotel (Private Property)",
          "Greenex Farms, Chundale",
          "Gurukula Botanical Sanctuary",
          "Hanumanmala",
          "Heritage Museum, Ambalavayal",
          "Hume Centre Campus , Puliyarmala",
          "Hume Centre for Ecology and Wildlife Biology, Kalpetta",
          "Jungle Retreat--Wayanad",
          "Kalladi (OBI)",
          "Kalloor (OBI)",
          "Kalpetta",
          "Kalpetta KSRTC Bus Depot",
          "Kaniyambetta Site: Kaniyambetta Town",
          "Kaniyaram",
          "Kannur University Mananthavady Campus",
          "Kanthanpaara Waterfalls",
          "Kanthanparai Waterfalls--nearby area",
          "Karapuzha",
          "Karapuzha Earth Dam",
          "Karapuzha Nellarachal",
          "Karapuzha Reservoir--Nathamkuni",
          "Kattikkulam",
          "Kenichira",
          "Kolavalli Wetland",
          "Kottathara",
          "Kottathara Site: Hamsakavala-Kottathara RD",
          "Kunnamangalam Vayal",
          "Kuruva Island",
          "Kuruva Island Resort & Spa",
          "Kuttiyamvayal",
          "Lantern Stay Meppadi (OBI)",
          "M S Swaminathan Botanical Garden",
          "Malabar WLS --Choothupara D2C6",
          "Manikkunnu Mala Adivaram",
          "Manikkunnu Mala Raptor Monitoring VP 2",
          "Manikkunnu Raptor Monitoring VP1",
          "Meenangadi Canal RD",
          "Meppadi",
          "Misty lounge resort",
          "Moolahalla",
          "Morickap Resort",
          "Muthanga Raptor Monitoring  VP2",
          "Muthanga Raptor Monitoring (Ponkuzhi)  VP1",
          "Muthanga Raptor Monitoring VP 1 (Ponkuzhi)",
          "Muttil (OBI)",
          "Nadavayal",
          "Naikatty, Sulthan Bathery (OBI)",
          "Nathamkuni",
          "Niyatma Resort Wayanad Muttil",
          "Noolppuzha - Kerala Border",
          "North Wayanad FD--Boys Town",
          "North Wayanad FD--Chandanathodu",
          "North Wayanad FD--Churuli",
          "North Wayanad FD--Dasankatte (Tholpetty Range)",
          "North Wayanad FD--Kambamala",
          "North Wayanad FD--Kunhome-Churuli Track",
          "North Wayanad FD--Kunnam-Kungichira Route",
          "North Wayanad FD--Kurusumala",
          "North Wayanad FD--Kuttanad Estate (Makkiad)",
          "North Wayanad FD--Periya",
          "North Wayanad FD--Tholpetty",
          "North Wayanad FD--Thrishilery",
          "North Wayanad FD--Valanthode",
          "North Wayanad FD--Valanthode Checkpost",
          "North Wayanad RF--Begur (Tholpetty range)",
          "North Wayanad RF--Tirunelly-Pakshipathalam Route",
          "Olivumala Ayisha Plantation Bungalow, Wayanad County, Kerala, IN",
          "Oorppally",
          "Padinjarethara",
          "Panamaram",
          "Panamaram Heronry",
          "Panamaram cottillam",
          "Panamaram- Panamaram-nadavayal road",
          "Panavally",
          "Payyampalli",
          "Payyampally, kuruva road.",
          "Pepper Trail",
          "Pepper Trail, Mangalam Carp Estate, Chulliyode",
          "Phantom Rock",
          "Pookkode Lake",
          "Pozhuthana",
          "Pulpally",
          "Punchavayal",
          "SCHSS Payyampally",
          "SKMJ School--Vanadevatha Trail",
          "Sarvodaya HSS Echome",
          "Serenity Resort",
          "South Wayanad FD--Kurichiyarmala",
          "South Wayanad FD--Kuttiyamvayal",
          "South Wayanad FD--Lady Smith",
          "South Wayanad FD--Manikunnumala",
          "South Wayanad FD--Naikuppa",
          "South Wayanad FD--Padiri",
          "South Wayanad FD--Parappanpara (Vaduvanchal)",
          "South Wayanad FD--Thollayiram",
          "South Wayanad FD--Vellarimala",
          "South Wayanad--Banasura Peak",
          "Sultan Bathery",
          "THDC",
          "Thalappuzha",
          "Thalappuzha Poyil",
          "Thennal jungle camp",
          "Thirunelli",
          "Thollaryiram kandi trail",
          "Thollayiram Estate",
          "Tholpetty",
          "Tholpetty WLS--Ayyappanpara",
          "Tholpetty WLS--Bavali Station",
          "Tholpetyy, Kerala",
          "Thrikkaipatta-Patch Monitoring Site",
          "Thrissilery",
          "Tranquil Resort",
          "Uruva,trikkaipetta",
          "Valliyoorkavu-Kabini River Bank",
          "Vemom",
          "Villa Tesori",
          "Vythiri Resort",
          "Vythiri Tea Garden Retreat",
          "Vythiri Village Resort",
          "Vythiri, Wynaad, Kerala",
          "WSSS Mananthavady",
          "Wayanad Atlas-107,17,2",
          "Wayanad Silverwoods Resorts",
          "Wayanad WLS (OBI)",
          "Wayanad WLS Punchavayal - Chambaalam",
          "Wayanad WLS--Alathoor Jn - Kurichyat",
          "Wayanad WLS--Begur",
          "Wayanad WLS--Border - Nalloorvayal",
          "Wayanad WLS--Chethalayam",
          "Wayanad WLS--Dasanaghatta",
          "Wayanad WLS--Dasanghatta-Undichira",
          "Wayanad WLS--Doddady",
          "Wayanad WLS--Doddakolassi",
          "Wayanad WLS--General Area",
          "Wayanad WLS--Gumshi Vayal, Kurichyad Range",
          "Wayanad WLS--Kaimaram",
          "Wayanad WLS--Kallumukku",
          "Wayanad WLS--Kuppadi",
          "Wayanad WLS--Kurichithodu - Mangalam kunnu",
          "Wayanad WLS--Kurichyat",
          "Wayanad WLS--Kurichyat - Towards Doddakkulassi",
          "Wayanad WLS--Mangalamkunnu",
          "Wayanad WLS--Mudumala - Nalloorvayal",
          "Wayanad WLS--Muthanga",
          "Wayanad WLS--Muthanga towards Nalloorvayal",
          "Wayanad WLS--Nallathanny",
          "Wayanad WLS--Odappallam",
          "Wayanad WLS--Ottipara",
          "Wayanad WLS--Ottippara",
          "Wayanad WLS--Ottippara - Ethanamudi",
          "Wayanad WLS--Ottippara - Kaithallam",
          "Wayanad WLS--Ottippara - Manjaal vayal",
          "Wayanad WLS--Punchavayal - Begur",
          "Wayanad WLS--Sulthan Bathery",
          "Wayanad WLS--Sulthan Bathery Range",
          "Wayanad WLS--Tholpetty",
          "Wayanad WLS--Tholpetty Range",
          "Wayanad WLS--Towards Thenkuzhi",
          "Wayanad treehouse",
          "Wayanad wild CGH Earth",
          "Wayand North Forest Division--Chandanathode - Pine Plantation",
          "Wayand North Forest Division--Chandanathode MPCA",
          "Wayand North Forest Division--Chirakkara tea factory",
          "Wayand North Forest Division--Churuli",
          "Wayand North Forest Division--Edakkolli - Sooryamudi",
          "Wayand North Forest Division--Kunkichira - Towards Vilangad",
          "Wayand North Forest Division--Kuruva Island",
          "Wayand North Forest Division--Makkimala",
          "Wayand North Forest Division--Neikkuppa",
          "Wayand North Forest Division--Thirunelli Watchtower towards Pakshipathalam",
          "Wayand North Forest Division--Thirunelly - Theerthakkundu",
          "Wayand North Forest Division--Vallakkode Campshed",
          "Wayand South Forest Division--8th mile Peedikappullu",
          "Wayand South Forest Division--900 Acre - Aranmala",
          "Wayand South Forest Division--900 Acre - Nirupama",
          "Wayand South Forest Division--Amba",
          "Wayand South Forest Division--Chembra Watch Tower - Lake",
          "Wayand South Forest Division--Chembra Watch tower towards Akkaalippallam",
          "Wayand South Forest Division--Junglepark EFL - Towards Pannippara",
          "Wayand South Forest Division--Junglepark EFL area",
          "Wayand South Forest Division--Karuvam thodu towrds Vannathimala",
          "Wayand South Forest Division--Kombian",
          "Wayand South Forest Division--Kuricharmala IB - Hilltop",
          "Wayand South Forest Division--Kurichyarmala IB - Pond",
          "Wayand South Forest Division--Mallika - Trans Asia Estate",
          "Wayand South Forest Division--Mallika Towards Mookkan puzha",
          "Wayand South Forest Division--Nellimalam - Manikkunnumala",
          "Wayand South Forest Division--Puthoorvayal - Manikkunnumala",
          "Wayand South Forest Division--Soochippara - Thadaakam",
          "Wayand South Forest Division--Uthiranchery - Elikkal",
          "Wayand South Forest Division--Westland - Kaithakkolli",
          "Wayand WLS--Doddakolussy",
          "Waynad WLS--Begur Forest Station",
          "Waynard Windflower Resort",
          "Wild Planet Resort",
          "Windflower Resorts",
          "Woodside Home-stay",
          "Zostel Plus Chembra Wayanad",
          "ambalavayal bypass road",
          "choottakadavu",
          "sterling wayanad",
          "vaduvanchal",
        ],
      },
    ],
  },
  {
    state: "Ladakh",
    districts: [
      {
        district: "Kargil",
        localities: [
          "Baroo Tsok",
          "Chadar Trek",
          "Damsna Village",
          "Damsna Wetland",
          "Drass, J&K (OBI)",
          "Fotu La",
          "Garkhon Phu",
          "Garkon, Aryan Valley(34.635, 76.431)",
          "Guntung, Kargil",
          "Gurgurdoh, Aryan Valley (34.659, 76.335)",
          "Helipad Thang, Kargil",
          "Hulyal Drass Kargil",
          "Kargil",
          "Kargil War Memorial",
          "Kharbu",
          "Lankerchey",
          "Man Man Top Peak",
          "Mulbekh",
          "Mushko valley",
          "Padum",
          "Panikhar Village",
          "Panikhar-Parkachik Suru valley",
          "Parkachik Village",
          "Penzi La",
          "Rangdum",
          "Rangdum marshes zanskar",
          "Sangrah Thang, Suru valley",
          "Sani Village",
          "Sani lake",
          "Sankoo",
          "Sankoo Village",
          "Sany wetland",
          "Sapi La",
          "Silmo (34.631, 76.33)",
          "Sruray Baar (Lungpa), Garkon, Aryan Valley (34.623, 76.445)",
          "Suru Valley",
          "Taisuru Spang (34.125, 75.961)",
          "Ufti, Pibiting",
          "Yunnan River",
          "Zangla chums",
        ],
      },
      {
        district: "Leh",
        localities: [
          "Agham",
          "Agling",
          "Akher Valley",
          "Alchi",
          "Babusar Top",
          "Bagh, Hanley",
          "Bar valley",
          "Basgo",
          "Bishgari",
          "Blind Lake, Shigar",
          "Bogdan village",
          "Bogdang",
          "Borit Lake",
          "Borith Village",
          "Borith Village and Environs",
          "Butchers Place,Stok Road",
          "Chadar trek zanskar river",
          "Chagar Tso",
          "Chalungkha, Nubra, Ladakh",
          "Chang la pass",
          "Changla Pass",
          "Changthang Cold Desert WLS",
          "Chhamugarh",
          "Chilling village",
          "Chirah-Bagrote",
          "Choglamsar - Indus belt",
          "Choglamsar Village",
          "Choglamsar--Mahabodhi",
          "Choglamsar--Zampa",
          "Choldan House 2",
          "Chuchot Bridge area",
          "Chuchot Marshes",
          "Chumathang",
          "Chumathang Hot Spring",
          "Chushot Yokma",
          "Chushot, Indus belt, Ladakh, India",
          "Chushul",
          "City Park - Skardu",
          "DISKIT",
          "Dah Baar (Lungpa) Aryan Valley (34.642, 76.475)",
          "Dar",
          "Deosai National Park",
          "Digyar",
          "Diskit",
          "Diskit Monastery",
          "Durbuk",
          "Eagle's Nest, Hunza Valley",
          "Enroute to Tso Kar (OBI)",
          "Fairy Meadows NP",
          "Foothills - Naltar Bala",
          "Gangless, Leh",
          "Gata Loops",
          "Geik",
          "Gilgit",
          "Gilgit--General Area",
          "Gulmit",
          "Guphuks Pond, Spituk",
          "Gurudwara Pathar Sahib",
          "Gusounr-Bagrote",
          "Gya",
          "Hanle",
          "Hanle Wetland Complex",
          "Hanupatta",
          "Hapakun Meadows",
          "Haramosh",
          "Harong Wetland (OBI)",
          "Harong Wetland II",
          "Hemis Gompa",
          "Hemis NP (please use more precise location)",
          "Hemis NP--Hankar",
          "Hemis NP--Hankar to Nimaling",
          "Hemis NP--Markha Valley",
          "Hemis NP--Nimaling",
          "Hemis NP--Skiu",
          "Hemis Shukpachan Village",
          "Hemis Shukpachan--Chhaga Che La",
          "Hemis Shukpachan--Juniper Forest",
          "Hemis Shukpachan--Tsermanchan La",
          "Hemya--Rong Valley",
          "Himya",
          "Hopar Glacier",
          "Hotel Tsokar Retreat, Leh",
          "Hunder",
          "Hussaini",
          "Kalaktartar",
          "Kargah Nulla",
          "Kargil-Leh Road",
          "Karimabad/Gilgit",
          "Karu, Leh-Manali highway",
          "Karzok",
          "Karzu Pond--Leh",
          "Khakstet",
          "Khaldo Bagh",
          "Khalsar",
          "Khalsi",
          "Khaltsi",
          "Kharddong village",
          "Khardung La",
          "Khunjerab National Park",
          "Khunjerab Pass",
          "Khunjerab Pass, PK",
          "Kiari",
          "Kidmang",
          "Kongzhi Bagh",
          "Korzok changthang",
          "Kyagar Tso",
          "Kyungyam Dho, Rong",
          "Kyungyam village",
          "Ladakh Eco Resort",
          "LadakhBIRDING Office, Bombguard, Leh",
          "Lake 1, Deosai National Park, Pakistan",
          "Lal Pahari/Ri Marpo Marshes",
          "Lamayuru",
          "Lamayuru Gompa",
          "Latho",
          "Lato Village",
          "Leh",
          "Leh, Ladakh",
          "Likir - Spango Road",
          "Likir Monastery",
          "Lingshed (OBI)",
          "Lingti Plain",
          "Loma Bridge marshes area",
          "Lower Spango Valley",
          "Lukung",
          "Mahe Bridge",
          "Mahe Bridge, Ladakh",
          "Mangue",
          "Matho",
          "Minapin",
          "Miru",
          "Misgar",
          "Mood",
          "Muglib",
          "Nagaral-Naltar",
          "Naltar Riverside Scrub",
          "Naltar Valley",
          "Netherlands Karakoram Expedition Camp 58",
          "Ney",
          "Nimaling",
          "Nimmoo",
          "North Pullu",
          "Nubra Valley",
          "Nubra valley--Panamik",
          "Nubra valley--Sumur",
          "Nurbula top (Hanle plateau)",
          "Nurla",
          "Nyoma",
          "PK: Fairy Meadows NP--Fairy Meadows Trail",
          "PK: Passu Glacier",
          "PK: Shigar Fort",
          "Panamik Hot Springs, Nubra",
          "Pang",
          "Pangong Lake",
          "Pangong Lake, Ladakh, India",
          "Pangong Tso--Man",
          "Pangong Tso--Spangmik",
          "Passu",
          "Peldo karzok",
          "Phey Junction",
          "Photi la Road",
          "Photoksar",
          "Phyang Gonpa, Leh Ladakh, India",
          "Polokong La",
          "Puga",
          "Rhongo",
          "Ri-Marpo, Rongo-Hanle Road",
          "Riverbank opposite Naltar Palace",
          "Rong Valley, Ladakh",
          "Rong Valley--Ligtse",
          "Rong Village",
          "Rumbak Valley",
          "Rumtse",
          "Saboo",
          "Saboo--Leh",
          "Sadpara Lake",
          "Sakti leh",
          "Saspochey",
          "Saspol",
          "Satrangi lake",
          "Serchu Yunnan River",
          "Shang Valley",
          "Shara",
          "Shashi Zampa, Shey",
          "Sheosar Lake",
          "Sher Qila - Gilgit River",
          "Shey Bushes",
          "Shey Smanla",
          "Shey-Holy Fish Pond.",
          "Sinakar",
          "Sindhu Ghat",
          "Skara Spang Tokpo--Leh",
          "Snow Leopard Enclosure environs",
          "South Pullu",
          "Spango Valley",
          "Spituk Marshes",
          "Spituk--Indus roadbridge",
          "Stakspi la",
          "Stanba House, Ranbirpor, Thiksay, Ladakh",
          "Startsapuk Tso",
          "Stok Kangri Base Camp",
          "Stokrange",
          "Sumdo",
          "Tagste/ Tangste (OBI)",
          "Tangang La",
          "Tangste Cafe",
          "Tangtse",
          "Tangyar",
          "Tar",
          "Tarchit Rong",
          "Taru NH",
          "Terchay vilalge",
          "The Grand Dragon, Ladakh",
          "Thiksey",
          "Thiksey Monastery",
          "Thiksey Ringing Centre",
          "Thukjay--Tsokar Lake",
          "Thukje Village & Tso Kar Brackish water region",
          "Tiggur",
          "Tsaka La",
          "Tsala lake",
          "Tsarab Bridge",
          "Tso Kar",
          "Tso Moriri, Ladakh",
          "Tso Moriri--North End",
          "Tsokar",
          "Tsokar Lake",
          "Tukla",
          "Tunah",
          "Turtuk",
          "Uley",
          "Upshi",
          "Wari La Pass",
          "Watch Tower, Tasabuk, Tsokar Lake",
          "Whisky Nala",
          "Yarab Tso",
          "Zingral Transit Check Post",
          "kargyam",
          "merak village",
        ],
      },
    ],
  },
  {
    state: "Lakshadweep",
    districts: [
      {
        district: "Lakshadweep",
        localities: [
          "Agatti Island--General Area",
          "Agatti Island--North",
          "Bangaram Island",
          "Comunidad Yukpa - Las Peñas",
          "Kalpatti Island",
          "Kavaratti Helipad",
          "Kavaratti Island",
          "Komalam beach, Kalpeni Island (South)",
          "Minicoy Island--General Area",
          "Panchayat stage area (Sandbank), Kalpeni Island",
          "Paraly Island--1",
          "Pitti Island (IBA)",
          "Pitti Sandbanks, Kalpeni Island",
          "Tinnakara Island",
        ],
      },
    ],
  },
  {
    state: "Madhya Pradesh",
    districts: [
      {
        district: "Agar Malwa",
        localities: [
          "Ganeshpura Dam, Susner",
          "Kundaliya Dam, Agar Malwa",
          "Maa Baglamukhi Seedhi Peeth Mandir",
          "Moti Sagar Talab, Agar Malwa",
        ],
      },
      {
        district: "Anuppur",
        localities: [
          "Amarkantak",
          "Bhundakona Dam",
          "Damgadh, Amarkantak",
          "Khagrachhari",
          "Mudna Nadi Udgam Sthal, Jaitahari",
          "Sambhu Sarovar",
          "Shaksaiya DAM",
          "Sone Kewai Sangam",
        ],
      },
      {
        district: "Ashoknagar",
        localities: [
          "Amahi Dam",
          "Amraee Rural Resort, Chanderi",
          "Dhakoni Talab, Isagarh",
          "Rajghat Dam, Chanderi",
          "Rajghat Dam--Naderi",
        ],
      },
      {
        district: "Balaghat",
        localities: [
          "Bagh Tola Resort, Kanha",
          "Bagh Villas Jungle Camp",
          "Bagh Villas-- Baherakhar (Lake)",
          "Banda Tola Lake",
          "Banjaar Tola Lodge, Kanha",
          "Banjar River, near Mukki Gate",
          "Basinkhar Lake",
          "Bhimodi Talab",
          "Bisanpura Talab",
          "Camp Dev Vilas",
          "Chitvan Jungle Lodge",
          "Devi Talab Arjunnala, katangi",
          "Digoda, Balaghat Road",
          "Jamunia River, Bhimlat Village",
          "Jamunia dam, katangi, Seoni",
          "Kanha",
          "Kanha Jungle Camp--Mukki gate (Santapur)",
          "Kanha Jungle Lodge",
          "Kanha NP Outskirts--Mukki to Baihar",
          "Kanha NP Outskirts--Mukki to Bhaisanghat",
          "Kanha NP--Mukki Zone",
          "Kanha NP--Supkhar Range",
          "Kanha TR (Core)--Garhi Road",
          "Kanha TR--Bamhni Nature Trail",
          "Kanha TR--Sondar",
          "Kanha TR--Supkhar Rest House & Surroundings",
          "Kanha Tiger Reserve--Adwar Beat",
          "Kanha Tiger Reserve--Khapa Zone (Buffer)",
          "Kanha Tiger Reserve--Mukki Gate",
          "Kanha Tiger Reserve--Rajma Pond",
          "KanhaTR--Khapa (Buffer)--Rajma",
          "Kareli",
          "Khairlanji Ryt",
          "Kinhi village, Balaghat",
          "Ladsa Tal Lanji, Balaghat",
          "Managarh, Balaghat",
          "Manegaon Talab, katangi",
          "Manji tola to Supkhar (Forest Road)",
          "Moti Talab, Balaghat",
          "Mukki Gate, KTR- Kahna",
          "Nahlesara Dam, Katangi, Seoni",
          "Najul Lake, Katangi",
          "Patharwada, katangi",
          "Pench NP",
          "Phen Wildlife Sanctuary",
          "Pond east of Bagh Retreat",
          "Rajiv Sagar Dam (Kudwa), Balaghat",
          "Saccharum Safari Lodge",
          "Sai Temple, Baihar",
          "Salban Homestay, Kanha",
          "Saleteka village, Balaghat",
          "Sarai Kothi",
          "Sarai Kothi Homestay",
          "Sarai Kothi, Kanha",
          "Savangi, katangi",
          "Shergarh Tented Camp",
          "Sihar Paath Mandir, Baihar",
          "Singinawa Jungle Lodge",
          "Sitapathor",
          "Siwanheti forest area",
          "Sondar Talab",
          "Sonewani Reserve Forest (Dist. Balaghat)",
          "Tathastu Kanha Resort",
          "The Bagh A Forest Retreat",
          "Wari Dam, Lanji",
          "kalapani Talab",
          "kamthi Talab",
          "kategaon Pond",
          "khamariya, katangi",
        ],
      },
      {
        district: "Betul",
        localities: [
          "Abandoned Coffee Plantation (Forest), Kukru",
          "Ash Pond, Sarni",
          "BORI SAFARI LODGE",
          "Bakud Reservoir",
          "Betul (OBI)",
          "Betul Railway Station",
          "Bhondyakund Village and River, Kukaru Khamla",
          "Bothi Lake",
          "Chunalohma Forest, Betul",
          "Chunalohma Forest--North of River",
          "Coffee Bagaan & Forest Guest House, Kukru Khamla",
          "Dhamnya--Tapi River Crossing",
          "Dharakhoh, Betul",
          "Forest Guest House, Ladi",
          "Forest Rest House, Sanpna Dam",
          "Gadrajhiri Dam",
          "Ghodadongri Railway Station",
          "Hiran Ghati, Satpura",
          "Khedla Fort",
          "Kosmi Dam",
          "Kuhi Dam",
          "Kursi Jheel",
          "Ladi Lake",
          "Maramjhiri Railway Station",
          "Mathardev Baba Tekri",
          "Muktagiri",
          "Pachdhar Reservoir--Deodongri",
          "Pachdhar Reservoir--Garwha Yog Parisar Temple",
          "Prachin Shiv Mandir, Bhainsdehi",
          "Purna Dam, Andherbaodi (MP)",
          "Rajdoh(Tawa River), Sarni",
          "Ranipur Dam",
          "Ratamati fields",
          "Ratanpur Dam",
          "Ridge trail west of Kukaru Khamla",
          "Sanpna Dam",
          "Satpura Dam, Sarni",
          "Satpura Forest Guest House, Betul",
          "Sipnadarshan Viewpoint (Sunset Point, Kukru)",
          "Sirajgaon Dam",
          "Sunset Point East of Kukru Khamla",
          "Sunset Point near Sirasitand, Kukaru Khamla",
          "Tapti Ghat",
          "Tapti Kund, Multai",
          "VACA School, Athner",
        ],
      },
      {
        district: "Bhind",
        localities: [
          "Forest Guest House, Barahi",
          "Gauri Lake",
          "Harraj Pura Talab",
          "NCS--Akon",
          "NCS--Barhi",
          "NCS--Chilonga",
          "NCS--Gadha",
          "NCS--Gyanpura",
          "NCS--Kacchpura",
          "NCS--Kheda Ajabsingh",
          "NCS--Kherat",
          "NCS--Maghera",
          "NCS--Mahua (Ater)",
          "NCS--Nadgawan",
          "NCS--Nakhloli",
          "NCS--Rama",
          "NCS--Sankari",
          "NCS--Udi Downstream",
          "National Chambal Sanctuary -- Chambal River near Ater Road",
          "National Chambal Sanctuary -- Jaitpur (MP Side)",
        ],
      },
      {
        district: "Bhopal",
        localities: [
          "AIIMS, Bhopal",
          "Ajnar Lake, Bhopal-Raisen Road",
          "Army Golf Course",
          "Bagruada Talaab",
          "Balampur Pond",
          "Barkatullah University",
          "Barkatullah University--Department of Zoology,",
          "Barkheda Salam Talab",
          "Bhadbhada Dam, Bhopal",
          "Bhanpur Pond",
          "Bhoj Wetland",
          "Bhoj Wetland--Bhamori Plantation",
          "Bhoj Wetland--Bhesha Khedi rd",
          "Bhoj Wetland--Bisankhedi",
          "Bhoj Wetland--Boat Club",
          "Bhoj Wetland--Gora Goan",
          "Bhoj Wetland--Van Vihar",
          "Boorvan Park, Upper lake, Bhopal",
          "CAPT, Bhopal",
          "Chinar Park",
          "Habibganj Railway Station, Bhopal",
          "Halali Dam--Khejra Babbar (Bhopal)",
          "Halali Dam--Sukaliya (Bhopal)",
          "Hatai Kheda Lake, Bhopal",
          "Hathaikheda Lake",
          "ICAR-CIAE, Bhopal",
          "IIFM Colony",
          "IIFM, Van Vihar, Bhopal (OBI)",
          "IISER Bhopal",
          "Indian Institute of Forest Management (IIFM)",
          "Institute of Livelihood Research and Training",
          "Ivy Suites",
          "Jagran Lakecity University road, Bhopal",
          "Kaliyasot Dam",
          "Kaliyasot Dam backwater",
          "Karondiya Talab",
          "Kerwa Dam",
          "Kerwa Dam--Kerwa Nursery",
          "MANIT, Bhopal",
          "Maharishi Centre for Educational Excellence, Bhopal",
          "National Law Institute University Campus, Bhopal (OBI)",
          "RIE campus, Bhopal",
          "Rajabhoj International Airport",
          "Regal Town",
          "Sanskaar Valley School Campus",
          "Shahpura Lake, Bhopal",
          "Shri Guru Gobind Singh 'Ekant' Park",
          "Shyampur, Bhopal",
          "Sri Sathya Sai College for Women",
          "UIT-RGPV BHOPAL",
          "Van Vihar NP",
          "WWF India, MP & CG State Office, Bhopal",
        ],
      },
      {
        district: "Burhanpur",
        localities: [
          "Bhagwant Sagar Dam (Sukta Reservoir)",
          "Chirawan Ryt. Talab",
          "Dargah e Hakimi",
          "Dhaba Talab",
          "Ghanshampur Talab",
          "Nagihiri Dam",
          "Rangai Talab",
          "Sajni ryt Talab",
          "Sankarpura Talab",
          "Sonud Village",
          "Tapi River Bridge, Dedtalai",
          "Tapti River Bridge, Burhanpur",
          "Tapti River Old Bridge, Boharda",
        ],
      },
      {
        district: "Chhatarpur",
        localities: [
          "Benisagar Reservior",
          "Buxwaha",
          "Chausath Yogini Temple, Khajuraho",
          "Gandhi Ashram, Chhatarpur",
          "Govt. Maharaja PG College",
          "Greetoe Camp Panna",
          "Hanuman Toriya",
          "Ken Gharial Sanctuary",
          "Khajuraho Temples",
          "Khajuraho--Khodar River",
          "Khajuraho--Shiv Nagar",
          "Lake Vamana Temple, Khajuraho",
          "Panna TR--Ken River--Boating Point",
          "Panna Tiger Reserve--Kakra Seha",
          "Panna Tiger Reserve--Karnavati Interpretation Centre",
          "Radha Madhav Temple Garden, Rajnagar",
          "Ranguwan Dam--Silon side",
          "Sarai at Toria, Madla",
          "Toria Village",
        ],
      },
      {
        district: "Chhindwara",
        localities: [
          "Bichhua Talab",
          "Border Plateau",
          "Chhindwara (OBI)",
          "Chindwada (OBI)",
          "Deokhoh Reservoir",
          "Dharam Tekdi, Chhindwara",
          "Jamtara village",
          "Karaboh Dam",
          "Machagora Dam, Chhindwara",
          "Machagora Dam--Karaghat",
          "Pakhadiya Dam",
          "Pandhurna Railway Station",
          "Patalkot, MP",
          "Pench TR- -Jamtara Wilderness Camp",
          "Pench Tiger Reserve- -Seetaghat",
          "Pench Tiger Reserve--Chhediya",
          "Pench Tiger Reserve--Gumtara Range, Chhindwara dist.",
          "Pench Tiger Reserve--Haldu Tola",
          "Pench Tiger Reserve--Jamtara Rural & Surrounding",
          "Pench Tiger Reserve--Jamtara-Kumbhpani Road",
          "Pench Tiger Reserve--Kumbhpani Buffer Zone",
          "Pench Tiger Reserve--Kumbhpani Lake",
          "Pench Tiger Reserve--Urmighat Beat",
          "Satpura TR--Binora Camp",
          "Satpura TR--Satdhara",
          "Tamia (OBI)",
        ],
      },
      {
        district: "Damoh",
        localities: [
          "Barpati Pond, Damoh",
          "Damoh Circuit Hose",
          "Mangarh, Damoh",
          "Rajnagar Lake",
          "Rani Durgawati WLS",
          "Rani Durgawati WLS--Vultures Point",
          "Singrampur, Jabalpur-Damoh Road",
          "Telan Ghat",
          "Veerangana Durgawati TR--Singhorgarh lake",
        ],
      },
      {
        district: "Datia",
        localities: [
          "Angoori Barrage",
          "Hinotiya",
          "Ramsagar Dam",
          "Sindh River--Mandakani Ghat",
        ],
      },
      {
        district: "Dewas",
        localities: [
          "Chidawad/Bhima Talab, Ujjain",
          "Dhaturiya, Ujjain",
          "Khategau (OBI)",
          "Nemawar, Narmada River (OBI)",
          "Nipaniya Talab, Dhaturiya, Ujjain",
          "Palsawad/Updi, Ujjain",
          "Rajanal lake",
          "Rani Talab, Bhorasa",
          "SPS Jatashankar Campus",
          "Samaj Pragati Sahayog",
          "Shipra River Bridge, Dewas",
          "kheoni Wildlife Sanctuary",
        ],
      },
      {
        district: "Dhar",
        localities: [
          "Mahi Dam--Gondikheda Charan",
          "Mandu",
          "Sagar Lake",
          "Sanjay Jalashay, (Dhar)",
          "Susari, Kukshi",
          "kaal bhairav temple",
        ],
      },
      {
        district: "Dindori",
        localities: [
          "Amarkantak--Kapildhara",
          "Kabir Chabutara, Amarkantak rd",
        ],
      },
      {
        district: "Guna",
        localities: [
          "Bajrangarh Fort",
          "Gopalpura Talab, Guna",
          "Gopi krishna Sagar Dam",
          "Kedarnath Temple & Surroundings, Guna",
        ],
      },
      {
        district: "Gwalior",
        localities: [
          "Ammasahab Ki Chattri",
          "Badhavna (OBI)",
          "Beragarh, Gwalior",
          "Blue lotus lake",
          "Deokho, Gwalior (OBI)",
          "East Park Avenue",
          "Gajra Raja Medical College",
          "Gajraraja Medical College",
          "Ghatigaon WLS",
          "Gwalior (OBI)",
          "Gwalior Fort",
          "Gwalior Railway Station",
          "Jiwaji University",
          "Jiwaji university",
          "KRG College, Gwalior",
          "Murar (OBI)",
          "Pehsari reservoir",
          "Ramaua Dam",
          "Scindia School, Gwalior (OBI)",
          "Sirol Pahadi, Gwalior City Forest",
          "Tapovan (OBI)",
          "Tekanpur Lake",
          "Tighra Dam",
        ],
      },
      {
        district: "Harda",
        localities: [
          "Amakhal Dam",
          "Indira Sagar Reservoir--Karanpura (Harda)",
          "Narmada River--Jogakhurd",
          "Sawalkheda Ryt Talab",
        ],
      },
      {
        district: "Indore",
        localities: [
          "Agriculture College, Indore",
          "Ambajhar Mandir Hill--Patal Pani",
          "Army Public School, Mhow",
          "Ashapur, Madhya Pradesh, IN (22.499, 75.741)",
          "Badgonda Forest Nursery, Mhow",
          "Banedia Talab",
          "Baroda Daulat Village Pond",
          "Bilawali lake",
          "Buranakhedi Wetland",
          "Chhota Bilawali Talab",
          "Chohan khedi Talaab",
          "Choral Dam",
          "Choral River",
          "City Forest--Smiti Van Public Park, Indore",
          "Classic Purnima Park Colony",
          "Daly College campus",
          "Datoda lake",
          "Devi Ahilya Vishwavidyalaya (DAVV), Indore",
          "Devi Ahilyabai Holkar International Airport, Indore",
          "Dhanora Farms",
          "Dhulet Pond",
          "Eco Park, Umrikheda",
          "Forest Campus, Indore",
          "Forest Department Office, Indore",
          "Gandhi Hall, Indore",
          "Golf View, Mhow",
          "Golkheda Talab",
          "Govindram Seksaria Institute of Management & Research (GSIMR)",
          "Govt. Middle School No. 40",
          "Holkar Science College",
          "Horticulture dept Nursery",
          "IIM Indore",
          "Indian Institute of Technology (IIT), Indore",
          "Indian Institute of Technology Indore",
          "Indore Railway Junction",
          "Indore Tennis Club",
          "Indore Zoo",
          "Institute of Engineering and Technology (IET), Indore",
          "Kadwali Khurd Talab",
          "Kajligarh Fort",
          "Kajligarh Fort and surrounding forests",
          "Kajligarh Valley",
          "Kalakund, Mhow",
          "Kanadiya Lake",
          "Khatipiplya Wetland(Buranakhedi)",
          "Kishanpura (Machal) Wetland, Indore",
          "Krishi Vigyan Kendra (KVK) Kasturbagram, Indore",
          "Lake View",
          "Lalbagh Garden",
          "Mahatma Gandhi Memorial (MGM) Medical College",
          "Malendi",
          "Malwa Institute of Technology",
          "Manav Chetna Vikas, Pivday",
          "Medi-Caps University, Indore",
          "Mhow (OBI)",
          "Mhow--Army War College",
          "Military College of Telecommunication Engineering (MCTE)",
          "Mohadi Waterfall",
          "Nahar Jhabua",
          "Nakheri Dam, Mhow",
          "New Digamber Public School (NDPS), Indore",
          "Parmanand Ashram Grasslands",
          "Pipliyapala Lake",
          "RRCAT Colony",
          "Ralamandal Sanctuary",
          "Ralamandal town",
          "Residency Kothi",
          "Semaliya Chau",
          "Semliya Chau Road Pond (Near Buranakhedi)",
          "Shankar Bagh Garden",
          "Shree Bijasan Mata Mandir",
          "Shri Govindram Seksaria Institute of Technology and Science (SGSITS)",
          "Signal Vihar, Mhow",
          "Sirpur Lake",
          "St. Mary's Higher Secondary School, Mhow",
          "Sukhniwas tank, RRCAT, Indore",
          "TINCHA WATER FALL RD TOWARDS UDAYNAGAR",
          "Talawali Chanda Lake",
          "The Daly College",
          "Tillore Buzurg",
          "Yashwant Sagar (Dam side)",
          "Yashwant Sagar--Gulawat",
          "Yashwant Sagar--Pumping Station",
          "Yashwantnagar Lake",
          "machal",
        ],
      },
      {
        district: "Jabalpur",
        localities: [
          "Badera dam",
          "Bagdari Water Fall, Jabapur",
          "Baghraji Forest",
          "Balsagar Lake",
          "Barela Hills",
          "Bargi Dam Bridge",
          "Bargi Dam--Harduli (Jabalpur)",
          "Bargi Reservoir (Jabalpur)--Khamariya",
          "Bargi Reservoir--Gaganda",
          "Bargi Reservoir--Magardha (Seoni)",
          "Bargi Reservoir--Tuniya",
          "Barnu tank, Jabalpur",
          "Basha  Agri fields",
          "Beohar Sarovar, Gandhigram, Jabalpur",
          "Bhedaghat Boating Area",
          "Chattarpur, Jabalpur",
          "Chausath Yogini Temple, Bhedaghat",
          "College of Veterinary Science & Animal, Jabalpur",
          "Deotal, Jabalpur",
          "Dhuadhar Falls, Jabalpur (OBI)",
          "Diwari, Jablpur",
          "Dugargawan",
          "Dumna Nature Reserve Park",
          "Dumna Nature Reserve--Khandari lake",
          "Gandhigram",
          "Gol Bazar, Jabalpur",
          "Hanuman Tal, Jabalpur",
          "Harrai Agro Farm",
          "Hiran Dam",
          "Husain's Farms",
          "ICFRE-TFRI",
          "JNKVV, Jabalpur",
          "Jabalpur (OBI)",
          "Jabalpur Airport ( Dumna Airport)",
          "Jabalpur Railway Station (OBI)",
          "Jalpari",
          "Jalpari lake",
          "Kakartala Pond, Jabalpur",
          "Kaladumar",
          "Kamtiya",
          "Katangi OBI",
          "Kathoda treatment plant, Jabalpur",
          "Kathonda Treatment Plant",
          "Khairani ghat, Jabalpur",
          "Kundwara",
          "Lamheta Ghat, Jabalpur",
          "Lower Gour",
          "MPT, Maikal Resort, Bargi Dam",
          "Madai Kalan",
          "Madai Makhrar",
          "Madai khurd",
          "Madan Mahal Fort, Jabalpur",
          "Mahanadi bridge, Padariya (Kundam)",
          "Marble Rocks, Bedhaghat (OBI)",
          "Mohari Pond, Jabalpur",
          "NSCB Medical College",
          "Narrai Reserve Forest",
          "Narrai, Rani Durgawati Samadhi rd",
          "Nasirabadi's Farm",
          "Nasirabadi's Farm 1, Barkheda, Kundam",
          "Nidan Water Fall",
          "Nunsar",
          "Padariya",
          "Pariyat Dam, Jabalpur",
          "Robertson Lake, Jabalpur",
          "SFRI, Jabalpur",
          "Sangram Sagar Lake, Bajnamath, Jabalpur",
          "Shail Parn Udyan, Jabalpur",
          "Silver Oak Compound, Russel Chowk, Jabalpur",
          "Singod, Jabalpur",
          "Sontalai Water Canal",
          "Tewar, Madhya Pradesh",
          "Thakur Taal, Jabalpur",
          "Tilhari Lake, Bhatauli, Jabalpur",
          "Tindni Lake",
          "Trishul Bhed",
          "Tropical Forest Research Institute (TFRI)",
          "Uma Ghat, Gwarighat",
          "Vijay Nagar, Jabalpur",
          "Yadav Homoeopathic Clinic",
        ],
      },
      {
        district: "Jhabua",
        localities: [
          "Bada Talab, Jhabua",
          "rathamba grasslands",
        ],
      },
      {
        district: "Katni",
        localities: [
          "Surki Tank Katni",
        ],
      },
      {
        district: "Khandwa",
        localities: [
          "Abana Forest Nursery",
          "Aulia, East Kalibhit Forest, Khandwa",
          "Bheem kund",
          "Indira Sagar Reservior--Selda Mal (Khandwa)",
          "Indira Sagar Reservoir",
          "Jaswadi Filter Plant",
          "Kendriya vidyalaya, Khandwa",
          "Nagchun Talab",
          "Sailani island",
          "Selda Mal, Madhya Pradesh, IN (21.945, 76.617)",
          "Shuri FR, Khandwa-Betul road",
        ],
      },
      {
        district: "Khargone",
        localities: [
          "Ahilya Devi Maheshwar Fort",
          "Dejla Dewda Dam",
          "Gagan Talab, Kodlakhedi",
          "Jam Gate, Mhow",
          "Narmada River--Jal Chauki, Barwah",
          "Sahastradhara Waterfalls",
          "Thangaon Talab",
        ],
      },
      {
        district: "Mandla",
        localities: [
          "Aroli-Somp Buffer Forest",
          "Bamni Banjar (OBI)",
          "Banjar River, Chaukitola",
          "Banjar River--Badal Ghoghara",
          "Bargi Reservoir--Deori (Mandla)",
          "Bargi backwaters",
          "Bargi- Papri kalan",
          "Budbudi Nala, Mocha Road",
          "Chhichhari",
          "Dak Bungalow, Kanha-Kisli",
          "Dhauranala, Mandla",
          "Dungariya Baksihar",
          "Flame of the Forest Safari Lodge",
          "Gove Nature Trail from inside Khatia Gate to back of Tuli Resort",
          "Govt. Arts College, Niwas, Harisingori",
          "Hirdeynagar, Mandla (OBI)",
          "Jangal Nala Jelwara",
          "Jhangul Chatanvaale forest",
          "Jungle King Resort, Khatia",
          "KTR--Kanha zone--Mundi dadar",
          "Kanha Interpretation Centre, Kanha Tiger Reserve",
          "Kanha Jungle Camp (Khatiya Gate)",
          "Kanha Kiskindha Resort",
          "Kanha NP--Batwar",
          "Kanha NP--Kanha Zone",
          "Kanha NP--Kisli Zone",
          "Kanha TR--Ghaterakhero Talab",
          "Kanha TR--Jamun Tola Range",
          "Kanha TR--Kisli guest House",
          "Kanha TR--Kisli, Karaighatia road",
          "Kanha TR--Nakti Ghati Anicut",
          "Kanha TR--Narangi Talab",
          "Kanha TR--Raja Kachar Talab",
          "Kanha TR--Talab near Kanha Museum",
          "Kanha Tiger Reserve",
          "Kanha Tiger Reserve--Jamuntola Beat",
          "Kanha Tiger Reserve--Kisli Range--Indra Beat",
          "Kanha Tiger Reserve--Parasatola Protection camp",
          "Kanha Tiger Reserve--Sarhi zone",
          "Kenapi walk, Sarhi",
          "Khairmai Nala Atariya",
          "Kopenala, Chaukitola",
          "Krishna Jungle Resort, Kanha",
          "Kutwahi",
          "Kutwahi to Chownki tola",
          "Luhari Ryt",
          "Mahua Tiger Resort, Mocha",
          "Mandla, MP (OBI)",
          "Matiyari Reservoir",
          "Mogli Resort, Kanha Tiger Reserve",
          "Narmada River--Suryakund Dham (Mandla)",
          "Narrai",
          "Niwas, Mandla",
          "Phen Wildlife Sanctuary",
          "Rathnahipat, Rata, Kanha",
          "Reta Nala, Sarahi",
          "Sahastradhara Fall, Mandla",
          "Sautia Rice Fields, Mocha",
          "Sinali Experience Pvt, Kanha,Tilari",
          "Soulacia Hotel & Resort",
          "Sterling Kanha",
          "Taktauwa forest",
          "Tatri Forest Rest House",
          "Thanwar Reservior--kachari (Mandla)",
          "Tilari Village Area",
          "Tuli Tiger Resort, Kanha",
          "Tuli Tiger Resort, Mocha, Kanha",
          "Village Heerapur Bhurka Pond",
          "Wild Chalet Resort",
        ],
      },
      {
        district: "Mandsaur",
        localities: [
          "GandhiSagar WLS--Taksheshwar Takhaji",
          "Gandhisagar Dam Bridge",
          "Gandhisagar Dam-- Sanjit (Mandsaur)",
          "Gandhisagar Forest Retreat",
          "Gandhisagar WLS--Dhanga",
          "Gandhisagar WLS--Hinglajgarh",
          "Gandhisagar WLS--Malashri Island",
          "Gandhisagar WLS--Sawant Kothadi",
          "Shivna river bridge, Mandsaur",
          "Surya Talab, Hinglajgarh",
          "Teliya Talab",
        ],
      },
      {
        district: "Morena",
        localities: [
          "Chambal River, Morena",
          "Chillaasan Bhabeshwari Devi Mandir, Eshagarh",
          "Jawahar Navodaya Vidyalaya, Joura, Morena",
          "Kotwal Reservior--Kaji Basai",
          "Morena (OBI)",
          "NCS--Atar bridge",
          "NCS--Babu Dev",
          "NCS--Babusingh Gher",
          "NCS--Banthar",
          "NCS--Barotha",
          "NCS--Barsala",
          "NCS--Barvasin",
          "NCS--Bateshwara",
          "NCS--Bharra",
          "NCS--Bhauhari",
          "NCS--Chinnwara",
          "NCS--Chinoni",
          "NCS--Chor Phandni Down",
          "NCS--Chuslai",
          "NCS--Daljit Ka Pura",
          "NCS--Dang Basai",
          "NCS--Gadrai",
          "NCS--Gorkha",
          "NCS--Gudha",
          "NCS--Gurja",
          "NCS--Jaithpur",
          "NCS--Karkoli",
          "NCS--Kenjra/Sahaspura",
          "NCS--Kuraitha",
          "NCS--Kuthiyana",
          "NCS--Lalgir",
          "NCS--Ludhawali",
          "NCS--Moroli",
          "NCS--Palari Banwara",
          "NCS--Puraini",
          "NCS--Raadi",
          "NCS--Rahu Gaon",
          "NCS--Raipur",
          "NCS--Ratan Basai",
          "NCS--Ruar",
          "NCS--Sabda",
          "NCS--Sarsaini",
          "NCS--Sevar Pai Down",
          "NCS--Tigri",
          "NCS--Umretha",
          "NCS--Useth Ghat",
          "National Chambal Gharial Sanctuary--Morena (MP side)",
          "National Chambal Sanctuary--Deori Eco Centre",
          "National chambal sanctuary",
          "Nurabad Railway Station",
          "Pilua Dam",
        ],
      },
      {
        district: "Narmadapuram",
        localities: [
          "Aanwli Ghat, Narmada Banks, Narmadapuram.",
          "Adamgadh Hills",
          "Bija Kheri tank",
          "Bineka",
          "Bison Lodge, Pachmarhi",
          "Bori Wildlife Sanctuary, Bori - STR",
          "Bori Wildlife Sanctuary, Bori-STR -Point 2",
          "Chaar (4) Number Canal (STR Buffer)",
          "Cheetal Resort, Madhai",
          "Chouragarh Temple, Pachmarhi",
          "Dehliya Camp",
          "Denwa Backwater Escape (Pugdundee Resorts)",
          "Forest Department Guest House, Matkuli",
          "Forest Department Office, Mahadeo Road, Pachmarhi",
          "Forsyth Lodge",
          "Forsyth lodge to Madai mudflat",
          "Golf View Resort, Pachmarhi",
          "Gourissa Resort, Madhai",
          "Itarsi (OBI)",
          "Jatashankar Temple",
          "Kulkarni Kendra, Bori WLS--Satpura Tiger Reserve",
          "Lehar Sa Resort, Madhai",
          "Madai Forest Guest House",
          "Mallupura, Tawa Reservoir",
          "Matkuli Forest Guest House",
          "NCBS-TIFR Field Station, Pachmarhi",
          "Narmada Herbal Park, Narmadapuram",
          "Nibhora",
          "Pachmahri--Rajendra Giri Garden",
          "Pachmarhi Biosphere Reserve -- Apsara Vihar",
          "Pachmarhi Biosphere Reserve -- Bee Falls",
          "Pachmarhi Biosphere Reserve -- Dhupgarh",
          "Pachmarhi Biosphere Reserve -- Dutchess Fall",
          "Pachmarhi Biosphere Reserve -- Handi Khoh",
          "Pachmarhi Biosphere Reserve -- Silver Falls",
          "Pachmarhi Lake",
          "Pachmarhi--Overall",
          "Pachmarhi--Pandav Caves",
          "Pachmarhi--Twynam Pool",
          "Pachmari Biosphere Reserve",
          "Panchmarhi (OBI)",
          "Pipariya Railway Station",
          "Reni Pani Jungle Lodge",
          "Road to Bineka",
          "Satpura TR- -Parsapani",
          "Satpura TR--Adi Denwa Camp",
          "Satpura TR--Badkachhar",
          "Satpura TR--Churna",
          "Satpura TR--Denwa River--Kukara",
          "Satpura TR--Denwa River--Madai to Sonbhadra",
          "Satpura TR--Dhava Camp",
          "Satpura TR--Gutti Baba",
          "Satpura TR--Jaharghat Camp",
          "Satpura TR--Kankdi",
          "Satpura TR--Madai",
          "Satpura TR--Nimghan",
          "Satpura TR--Panara",
          "Satpura TR--Paraspani",
          "Satpura TR--Parsapani Range",
          "Satpura TR--Parsapani entrance gate",
          "Satpura TR--Sakot Camp",
          "Satpura TR--Sonbhadra Confluence",
          "Satpura TR--Suplai Pond",
          "Satpura TR--Ticket Counter Madai",
          "Satpura Tiger Reserve--Barbhud",
          "Satpura Tiger Reserve--Dhain",
          "Satpura Tiger Reserve--Overall",
          "Sehra",
          "Silk Plantation- -Pachmarhi",
          "Taku Railway Station",
          "Tava Reservoir--Malani",
          "Tava Reservoir--Mallupura",
          "Tawa Bridge (NH 22)",
          "Tawa Reservoir--General Area (OBI)",
          "Tawa Reservoir--Kotmimal",
          "Tawa Reservoir--Ranipur",
          "Tekapar to Kamti",
          "The Golden Woods Resort lake and forest area",
          "panchmarhi Hill Station",
        ],
      },
      {
        district: "Narsinghpur",
        localities: [
          "Ser River Bridge, Narsinghpur-Jabalpur Road",
        ],
      },
      {
        district: "Neemuch",
        localities: [
          "Barukheda, Neemuch",
          "Besala Talab",
          "CRPF Camp, Neemuch",
          "Chamleshwar Talab",
          "Gandhisagar Dam--Rampura (Neemuch)",
          "Gandhisagar Forest Resthouse",
          "Gandhisagar Sanctuary",
          "Gandhisagar Sanctuary--Chainpuriya Block",
          "Gandhisagar WLS--Chainpuriya Talab",
          "Gandhisagar WLS--Dayli Talab",
          "Gandhisagar WLS--Karanpura Talab",
          "Gandhisagar WLS--Rampura Talab",
          "Hameria Talab",
          "Jaju Sagar Dam",
          "Javi Talab",
          "Jeeran Talab",
          "Kama Kirta Talab",
          "Kherkeda Talab",
          "Morwan Dam",
          "Nilkanth Sagar",
          "Rampura Pathar , Forest RestHouse , Karanpura Block, Madhya Pradesh, IN (24.695, 75.553)",
          "Sukhanand Dam",
          "Water Pond, Khatu tea point",
        ],
      },
      {
        district: "Niwari",
        localities: [
          "Bank of Betwa River (OBI)",
          "Karipadar Patrolling Camp , Orchha Wildlife Sanctuary",
          "Mahua Hill View Homestay, Orchha",
          "Orachha",
          "Orccha--Royal Chhatris",
          "Orchha Wildlife Sanctuary",
          "Raja Mahal, Orchha",
          "Sujanpura Jagir Forest Temple, Orchha",
        ],
      },
      {
        district: "Panna",
        localities: [
          "Bear Valley Camp, Panna",
          "Dharam Sagar Talab",
          "Gahdara Forest Dept. Camp",
          "Harsa Talab",
          "Hinouta Plateau, Panna National Park",
          "Ken River Lodge (OBI)",
          "Ken River and it Valley, Madla, Panna National Park",
          "Lokpal Sagar",
          "Mahuwakhera Talab",
          "NMDC Reservoir, Hinauta",
          "Nirpat Sagar, Panna",
          "Panna (OBI)",
          "Panna TR--Akola Talab",
          "Panna TR--Bagdadi Kalan Pond",
          "Panna TR--Kandwaha Talab",
          "Panna TR--Ken River--Pipartola",
          "Panna TR--Talgaon Talab",
          "Panna TR--kaithi Talab",
          "Panna Tiger Reserve",
          "Panna Tiger Reserve--Gangau Dam",
          "Panna Tiger Reserve--Hinnauta Gate",
          "Panna Tiger Reserve--Madla Gate",
          "Panna Tiger Reserve--Madla Zone",
          "Panna Tiger Reserve--Pandav Caves and Falls",
          "Pashangarh, Taj Safari Lodge, Panna",
          "Ranipur Nature Trail",
          "Sindhysagar Talab",
        ],
      },
      {
        district: "Raisen",
        localities: [
          "Ashapuri Temple and Dam",
          "Bamnai Village Forest",
          "Barkhera Railway Station",
          "Bhimbetka",
          "Bhojpur",
          "Bhoot Palasi Village Forest",
          "Chikod Kalan Lake",
          "Dahod Reservoir",
          "Halali Dam--MPT resort side (Raisen)",
          "Karmodiya dam",
          "Koka kho vilage,Ratapani",
          "Lakhadwar forest beat Kesalwada",
          "Maser Pond",
          "Nasipur village forest",
          "Raisen Fort",
          "Ratapani Sanctuary",
          "Ratapani TR--Ratapani lake (Dam side)",
          "Ratapani TR--Ratapani lake--Forest chauki",
          "Ratapani WLS--Barkhera forest area",
          "Ratapani WLS--Dhundhwani",
          "Ratapani WLS--Jawara _Imlana camp, Jabra Malkhar",
          "Ratapani WLS--Kherwana dham",
          "Sanchi",
        ],
      },
      {
        district: "Rajgarh",
        localities: [
          "Chhawada Talab, Kotra",
          "Chidi Kho Sancturay--Location Kharcha Talab",
          "Narsinghgarh Wildlife Sanctuary (Chidi Kho)",
        ],
      },
      {
        district: "Ratlam",
        localities: [
          "Hanuman Taal, Ratlam",
          "Inaya Garden Resort",
          "Lesser Florican Sanctuary, Sailana, Ratlam",
          "Sailana Wildlife Sanctuary",
          "Vikramgarh VIP Colony",
        ],
      },
      {
        district: "Rewa",
        localities: [
          "APS University",
          "Bela Cement Works Mines area Road side, Sonara, Rewa",
          "Chachai Waterfall",
          "College of Veterinary Science & Animal, Rewa",
          "DFO Office REWA",
          "Gorama Dam",
          "Jaypee Nagar Colony Park",
          "Keoti Waterfall",
          "Purwa Falls",
          "Rewa Fort",
        ],
      },
      {
        district: "Sagar",
        localities: [
          "Bada Talab (Majar Ke Paas) Rahatgarh",
          "Bina river--Madiya Dam",
          "Dr Hari Singh Gour Vishwavidyalaya",
          "Hilgan Dam",
          "Mandir Marg, Sagar",
          "Mardanpur Pond",
          "Mohali Gate--Nauradehi WLS",
          "Nauradehi WLS--Chevla Talab",
          "Nauradehi WLS--Jamraasi Talaab",
          "Nauradehi Wildlife Sanctuary",
          "Nauradehi wild life sanctuary Sagar",
          "Rajghat Dam, Sagar",
          "Veerangana Durgawati TR--Barpani Talab",
          "Veerangana Durgawati TR--Jamraasi Talaab",
        ],
      },
      {
        district: "Satna",
        localities: [
          "Bansagar Dam",
          "Bathiya Kalan",
          "Bharat Ghat, Chitrakoot",
          "Bridge No-2, Kudari Khurd, Amarpatan",
          "Chaupati Park, Satna",
          "Chitrakoot (OBI)",
          "Govt.Ex.Hr.Sec Venkat No-01, Satna",
          "Gupt Godavari Caves",
          "Kamadgiri Parvat, Chitrakoot",
          "Kirhai Pond, Amarpatan",
          "Koihai Wetlands",
          "Kudana Nala",
          "Maihar Bus Station Pond",
          "Maihar Railway Station",
          "Maihar Temple",
          "Maitri Park, Satna",
          "Nadan Sharda Prasad, Maihar",
          "Nayagaon",
          "Satna Railway Station",
          "Unnamed Road, Jura, Madhya Pradesh, IN (24.269, 80.91)",
        ],
      },
      {
        district: "Sehore",
        localities: [
          "Barkatullah University, Bhopal",
          "Forest Chauki, Shahganj road, Sehore",
          "Hoshang Shah Fort",
          "Jehangipura Dam",
          "Jholiapur Reservoir",
          "Khanda Bad Talab",
          "Khari Talaab",
          "Kheoni WLS--Dolatpur",
          "Kheoni Wildlife Sanctuary",
          "Kolar Dam",
          "Kolar Dam--Jhal Pipali",
          "Kolar Dam--Sali kheda",
          "Madhuban Resort By Somaiya",
          "Mid Ghat Shrine (Dargah)",
          "Ratapani WLS--Delawadi",
          "Ratapani WLS--Delawadi Camp",
          "Ratapani WLS--South Mathar",
          "Seep River Dam",
          "Talpura Talab",
          "VIT Bhopal University, Kothri Kalan, MP",
          "Vohra Farm House, Nibu Kheda",
        ],
      },
      {
        district: "Seoni",
        localities: [
          "Amba Mai Temple, Katangi",
          "Bargi Reservoir (Seoni)--Payli",
          "Dulhapur Road, Sitapathor  balaghat mp IN (21.697, 79.64)",
          "Kanhiwada Village, Seoni, MP",
          "Karia Pahad, Singhodi",
          "Lakhnadon",
          "Pench , Turia gate",
          "Pench Jungle Camp, Kohka",
          "Pench TR--Totladoh Reservoir (Alikatta)",
          "Pench Tiger Reserve - - Junewani Lake",
          "Pench Tiger Reserve- -Baaz Jungle Resort",
          "Pench Tiger Reserve- -Baghvan, A Taj Safari",
          "Pench Tiger Reserve- -Chhindimatta",
          "Pench Tiger Reserve- -Dhudhiya Lake",
          "Pench Tiger Reserve- -Khawasa Zone",
          "Pench Tiger Reserve- -Kohka Lake",
          "Pench Tiger Reserve- -Pench Tree Lodge",
          "Pench Tiger Reserve- -Rukkhad Zone",
          "Pench Tiger Reserve- -Tathastu Resort",
          "Pench Tiger Reserve- -The Riverwood Forest Retreat",
          "Pench Tiger Reserve--Bijamatta lake",
          "Pench Tiger Reserve--Bodanala Reservoir",
          "Pench Tiger Reserve--Junewani Lake",
          "Pench Tiger Reserve--Karmajhiri Zone",
          "Pench Tiger Reserve--MP Overall",
          "Pench Tiger Reserve--Malkundam",
          "Pench Tiger Reserve--Telia Buffer",
          "Pench Tiger Reserve--Turia Rural & Surroundings",
          "Pench Tiger Reserve--Turia Zone",
          "Sakata- -Rukhad buffer zone",
          "Seoni (OBI)",
          "Sonewani Wildlife Sanctuary",
          "Tathstu Resort, Pench",
        ],
      },
      {
        district: "Shahdol",
        localities: [
          "Banas River--khari",
          "Radha Govind Taal, Badi Bheet",
          "Tanki Nala Talab",
        ],
      },
      {
        district: "Shajapur",
        localities: [
          "Cheelar Dam",
          "Palsawad Dam",
        ],
      },
      {
        district: "Sheopur",
        localities: [
          "Basundar Ka Tapra, Sheopur",
          "Bawanda Kalitalai, Sheopur",
          "Castaway Cay",
          "Chambal River Boat Tour - Madhya Pradesh Side",
          "Devnarayan Talab, Kalmi forest beat, Goras",
          "Forest Rest House, Sheopur",
          "Hanuman Kheda, Sheopur",
          "Kalmi Forest Beat, Goras, Sheopur",
          "Kuno National Park - Tiktoli Zone",
          "Kuno National Park--Ahera Range",
          "Kuno National Park--Durrendi Forest Camp",
          "Kuno National Park--Palpur",
          "Kuno River--Kurachor Kalan",
          "Kuno River--Kurachor Kalan to Sesaipura",
          "Kuno river -- Nasiyar",
          "Kuno river--Barrend",
          "Mukundpura",
          "NCS--Baroli",
          "NCS--Biloni",
          "NCS--Binjari",
          "NCS--Danteti",
          "NCS--Jamurdi",
          "NCS--Jimarchaa",
          "NCS--Kased",
          "NCS--Liloli",
          "NCS--Nadigaon",
          "NCS--Narwalan",
          "NCS--Nimach (Jhu Jhu)",
          "NCS--Pali confluence",
          "NCS--Rameshwar",
          "NCS--Rijheta",
          "NCS--Saand",
          "NCS--Singan Kacch",
          "NCS--Sirsod",
          "NCS--Tongni",
          "NCS--Triveni Sangam",
          "Rambadi Forest Beat",
          "Rameshwar Ghat, National Chambal Sanctuary",
        ],
      },
      {
        district: "Shivpuri",
        localities: [
          "Happy Days School",
          "Kaketo Dam",
          "Karera Bird Sanctuary",
          "Karera Rockface",
          "Madhav National Park",
          "Madhav TR--Bhojpur Talab",
          "Madhav TR--Gadwaya Pond",
          "Madhav TR--Muharram Wala Talab",
          "Madikheda Dam Backwater--Dongar",
          "P K University, Shivpuri",
          "Sankhya Sagar Lake",
          "Sankhya Sagar, Shivpuri",
          "Shivpuri (OBI)",
        ],
      },
      {
        district: "Sidhi",
        localities: [
          "FH2 Guest House Sidhi Cement Plant",
          "Kusmi, Sanjay Dubri Tiger Reserve",
          "Parsili Resort, Chamradol",
          "Sanjay Dubari (Dubri) Tiger Reserve",
          "Sanjay Dubri NP",
          "Sanjay Dubri TR--Dubri Core",
          "Sanjay Dubri Ticket Counter--Chamradol",
          "Sanjay Dubri Tiger Reserve",
          "Sanjay Dubri Tiger Reserve--Kusmi",
          "Sidhi--General Area (OBI)",
          "Son Gharial Sanctuary",
        ],
      },
      {
        district: "Singrauli",
        localities: [
          "Govind Vallabh Pant Sagar--Gobha",
          "Govind Vallabh Pant Sagar--Karauti",
          "Kulakwar Talab",
          "Rehi Talab",
          "Son River--Kuthuli",
        ],
      },
      {
        district: "Tikamgarh",
        localities: [
          "Mahendra Sagar",
          "Siddh khan talab, Gopalpura Bhata",
        ],
      },
      {
        district: "Ujjain",
        localities: [
          "Gambhir River Bridge, Ujjain-Badnawar Road",
          "Gaowadi pond, Ujjain",
          "Kalidas Academy",
          "Kshipra river bank, near Bhartari Cave, Ujjain",
          "Mangalnaath Mandir, Ujjain",
          "Naulakhi Eco Tourism Park, Ujjain",
          "Navlaki Eco-Park",
          "Sahabkhedi Lake, Ujjain",
          "Ujjain Railway Station",
          "Undasa Lake",
          "Vikram Vatika, Ujjain",
          "Village Sadawal, Ujjain",
        ],
      },
      {
        district: "Umaria",
        localities: [
          "Aranyak Resort, Kuchwahi Village, Bandhavgarh",
          "Bagh Tola Jungle Lodge, Parasi Buffer zone-Bandhavgarh",
          "Bandhav Vilas Resort",
          "Bandhavgarh NP",
          "Bandhavgarh NP- Tala Gate",
          "Bandhavgarh NP--Fort",
          "Bandhavgarh TR--Badwahi Talab",
          "Bandhavgarh TR--Kudarwar Talab",
          "Bandhavgarh Tiger Reserve -- Panpatha",
          "Bandhavgarh Tiger Reserve--Khitauli Gate",
          "Bandhavgarh Tiger Reserve--Khitauli Zone",
          "Bandhavgarh Tiger Reserve--Magadhi gate",
          "Bandhavgarh Tiger Reserve--Magdhi Zone",
          "Bandhavgarh Tiger Reserve--Tala Gate",
          "Bandhavgarh Tiger Reserve--Tala Zone",
          "Bundela Bandhavgarh by Octave",
          "Charanganga river, Tala, Bandhavgarh",
          "Chhap No. 2, Bansagar Dam",
          "Dhamokhar, Bandhavgarh Tiger Reserve",
          "Jungle Lodge, Bandhavgarh (OBI)",
          "Kings Lodge, Bandhavgarh",
          "Mahua Kothi, A Taj Safari Lodge, Bandhavgarh",
          "Monsoon Jungle Lodge, Bhandhavgarh",
          "Nature Heritage Resort, Bandhavgarh Tiger Reserve",
          "Son River--Ramna no. 2",
          "Tathastu, The Lagoon Resort, Bandhavgarh",
        ],
      },
      {
        district: "Vidisha",
        localities: [
          "Chhota Tala",
          "Halali Dam--MPT resort side (Vidisha)",
          "Udayagiri Caves",
        ],
      },
    ],
  },
  {
    state: "Maharashtra",
    districts: [
      {
        district: "Ahmednagar",
        localities: [
          "Ahmednagar Fort",
          "Amardham Crematory",
          "Ancient Vitthal Mandir, Palashi",
          "Bhandardara Lake",
          "Bhatodi Pargaon Dam",
          "Canal Road, Awhane",
          "Chandbibi Mahal",
          "Chas Lake, Ahilyanagar",
          "Daryabhai Velhabai Mandir, Parner",
          "Dongargan Forest",
          "Farah Bagh",
          "Gajadipur, Parner",
          "Gorakshanath Fort",
          "Green Valley Farmhouses, Bypass road",
          "Harishchandragad",
          "Hatti Barav, Darewadi",
          "Jaikwadi Bird Sanctuary",
          "Jaikwadi Bird Sanctuary--Ghevri Pumphouse",
          "Kapurwadi Lake",
          "Katwan Khandoba Rd Bridge",
          "Kektai Grassland",
          "Kumbhephal Bird Park",
          "Loni Pravara (OBI)",
          "MIRC Green",
          "Malpani Health Club",
          "Mhasoba Temple Lake (Nimgaon Wagha)",
          "Mira Wali Pahad, Kapurwadi",
          "Mumbadevi Temple, Ramdoh",
          "Nagar Manmad Highway Bridge, near Hotel Span",
          "Nandan Kanhan Farm",
          "Narayan Doho Lake",
          "Narsimha Temple, Bhatodi Pargaon",
          "Nimblak lake",
          "Nimgaon Wagha Lake",
          "Old Bolhegaon Road",
          "Old Sangam Bridge",
          "Palas Hills",
          "Pansare Nursery",
          "Pimpalgaon Lake, Imampur",
          "Ralegan Therpal  Village",
          "Rasane Nagar",
          "Rashin Outskirts",
          "Rehekuri Blackbuck Sanctuary",
          "Renavikar School (restricted access)",
          "Saiban Agro Tourism Centre",
          "Samarth Jogging Track",
          "Sandhan Valley",
          "Sanjivani College Of Engineering, Kopargaon (Restricted access)",
          "Sarola Baddi Rd",
          "Sharda English Medium School, Kopargaon",
          "Shemara Van Valley, Dongargan",
          "Shimpora - Autewadi Riverfront",
          "Shiv Tirth Temple, Nimblak",
          "Siddheshwar Wadi, Parner",
          "Somaiya Vidya Mandir, Laxmiwadi",
          "Sonewadi Windmills",
          "Sutarwadi Grassland, Parner",
          "Takali Tale lake",
          "Urja Gurukul School campus (restricted access)",
          "Vilad Pond (mini Ladakh)",
          "Walki Lake",
        ],
      },
      {
        district: "Akola",
        localities: [
          "Akot Forest Office",
          "Andura, Near Akola",
          "Bhains River, Balapur",
          "Borgaon Manju Reservoir",
          "Chaitanya's Farmhouse (Restricted access)",
          "Dagadparwa Dam",
          "Dr. Panjabrao Deshmukh Krishi Vidyapeeth, Akola",
          "Dudhani Waterfall",
          "GNA Science and Art College Barshitakli",
          "Kapshi Talav",
          "Karanja, Akola (OBI)",
          "Katepurna WLS",
          "Kumbhari Talav",
          "Kumbhari, Akola",
          "Masa Grassland",
          "Melghat Tiger Reserve--Shahanur",
          "Narnala Fort",
          "Nursery PDKV",
          "Patur Suvarna River",
          "Popatkhed Reservoir",
          "Popatkhed forest area",
          "Ranpise Nagar Open Ground",
          "Shahanur to Narnala Fort Ghat",
          "Shankarlal Khandelwal College",
          "Shiwar Khadan Lake",
          "Sisa Udegaon Lake",
          "Sukali Talaw",
        ],
      },
      {
        district: "Amravati",
        localities: [
          "Bamboo Garden, near Wadali Talav",
          "Basalapur lake, Amravati",
          "Bhimkund View Point, Chikhaldara",
          "Bhiwapur Dam",
          "Bicchan River, Paratwada",
          "Bopapur Dam, Devgaon, Amravati Dt.",
          "Bor River Dam",
          "Bor river Dam",
          "Chatri Lake Surrounding Area",
          "Check Dam, near Khatijapur lake",
          "Chhatri Lake",
          "Chikaldara",
          "Chikhaldara Gardan",
          "Chikhaldara Garden",
          "Dabheri Lake",
          "Dhabhi Lake",
          "Doma Reservoir",
          "Gawilgad Fort",
          "Ghatkhed Dam, Spillway and Reservoir",
          "Gondvihir Reservoir",
          "Gondwagholi Lake, Maharashtra",
          "Government College of Engineering (GCOEA)",
          "Government Polytechnic Amravati",
          "Government Vidarbha Institute of Science and Humanities (GVISH)",
          "Govt Vidarbha Institute Of Science and Humanities",
          "Hari Umri Mata Ghatang Temple",
          "Hiwara Dam",
          "Jalka Lake, Amravati Dt.",
          "Jalka Reservoir, Amravati",
          "Jambhala lake",
          "Jamoda Padav Camp, Chaurakund",
          "Karagolai Forest Camp, Jambu",
          "Karajgaon Dam",
          "Kekatpur Lake",
          "Khatijapur Lake",
          "Mahendri Reserve Forest",
          "Malkhed Reservoir",
          "Melghat Tiger Reserve",
          "Melghat Tiger Reserve -- Harisal",
          "Melghat Tiger Reserve--Amzari Stay",
          "Melghat Tiger Reserve--Dhargad Forest Rest House",
          "Melghat Tiger Reserve--Kolkaz",
          "Melghat Tiger Reserve--Semadoh Forest Rest House",
          "Melghat Tiger Reserve--Wan Sanctuary",
          "Mixed Bamboo Forest, Near Bhulori",
          "Mozari Point, Chikhaldara",
          "Muthwa Community Resource Centre",
          "Old MTDC Resort, Chikhaldara",
          "PR Pote College Amravati",
          "Panchbol Point",
          "Pohra Forest",
          "Pohra Lake",
          "Prof. Ram Meghe Institute of Technogy and Research, Badnera",
          "Pulgaon Bridge and Surrounding Area (Wardha River)",
          "Rajendra Garden",
          "Rajura Lake",
          "Ramana Forest",
          "Rangoli Lawns",
          "Reserve Line Amravati",
          "Samajik Wanikaran, Wadali",
          "Sant Gadge Baba Amravati University",
          "Sant Gadge Baba Amravati University Lake Area",
          "Savanga Lake",
          "Sawardi Reservoir",
          "Shekdari Dam, Gavankund, Maharahtra",
          "Shivneri Colony Ground",
          "Shri Shivaji Science College",
          "State bank of India",
          "Tapi River Birding Spot - Rangubeli",
          "Tapi River Bridge",
          "Tapi River, Rangubeli",
          "Tapi river sangam, Rangubeli",
          "Upper Shewati Lake",
          "Upperwardha Dam, Morshi",
          "Vinayak Vidnyan Mahavidyalaya",
          "Virshi, Amravati Dt",
          "Wadali lake",
          "Wagholi lake",
          "Wazzar Dam",
          "kumagad",
          "paratwada",
        ],
      },
      {
        district: "Aurangabad",
        localities: [
          "Aashiyaana Homestay",
          "Ajanta Caves",
          "Ajanta Caves--Upper View Point",
          "Ajanta Village",
          "Ajanta-andhari dam",
          "Aurangabad Caves",
          "Bibi Ka Maqbara",
          "Botanical Garden (BAMU), Aurangabad",
          "Daulatabad Fort",
          "Dr. Babasaheb Ambedkar Marathwada University",
          "Ellora Caves",
          "Gandheli Dam Aurangabad",
          "Gautala Wildlife Sactuary -- Hiwarkheda",
          "Gautala Wildlife Sanctuary",
          "Gogababa, Aurangabad",
          "Harsul Lake",
          "Himayat Bagh",
          "Janjala Fort",
          "Jayakwadi Bird Sanctuary -- Katpur",
          "Kham Riverside Eco-Park",
          "Khelana Lake",
          "Mahatma Gandhi Mission (MGM) Campus",
          "Mukpath Village",
          "Navkhanda College",
          "Nehru Udyan",
          "Palaskheda dam",
          "Pitalkhora Caves",
          "Salim Ali Lake",
          "Savangi",
          "Shree Ambrishi Mahadev Mandir Road,Sivana",
          "Sillod, Aurangabad Dt",
          "Sukhana Dam, Aurangabad",
          "Wadi Fort",
        ],
      },
      {
        district: "Beed",
        localities: [
          "Beed Dt.",
          "Bendura River",
          "Bindusara Dam",
          "Brahmanath Temple, Yelamb",
          "Chincholi Morachi",
          "Guttewadi Lake",
          "Jogaiwadi Lake",
          "Kalvati Lake, Laman Tanda, Maharashtra, IN (18.769, 76.399)",
          "Khoparnath Mandir lake and surrounding area",
          "Kumbhefal Lake",
          "Manjara Dam",
          "Massajog Lake",
          "Mukundraj Swami Valley, Ambajogai",
          "Mukundraj Valley Ambajogai",
          "Nagapur Dam",
          "Rena dam--Bardapur Poos Rd",
          "Seena Dam, Parodi",
          "Sindphana Dam -- Madhmapuri Trail",
          "Tagadgaon Dam, Shirur (kasar)",
        ],
      },
      {
        district: "Bhandara",
        localities: [
          "Banvantharti Dam, River side",
          "Canal near Vaibhavlaxmi Nagri",
          "Chandpur Dam forest trail",
          "Chargaon Lake",
          "Chichad Village near Indra Sagar Dam",
          "Chicholi wetland",
          "Dongar Mahadev Korambhi",
          "Dongargaon Lake",
          "Ekata Colony, Sakoli",
          "Gadkumbhali Lake Area",
          "Gundhari Reservoir",
          "Indira Sagar Dam - Gosekhurd",
          "Jamnapur Lake, Sakoli",
          "Khandala Wetland",
          "Koka WLS--Khurshipar Reservoir",
          "Koka WLS--Koka",
          "Korambhi-Salebardi Wetland",
          "Kurmuda Lake",
          "Lakhni Lake",
          "Lawari Lake",
          "Nagzira WLS--Jambhali",
          "Nagzira WLS--Pitezari",
          "Nagzira WLS--Umarzari",
          "Nursar Colony Near Bus stand Sakoli",
          "Nursery Khairlanji",
          "Old Railway Track, Ganeshpur",
          "Pajhar Lake (Khatiwali)",
          "Panchgaon Lake",
          "Pindkepar Lake",
          "Rawanwadi Reservoir",
          "Rengepar Reservoir",
          "Right Bank Canal Sub Doors",
          "Samyak Bhondki Reservoir",
          "Satona Lake, Bhandara Ramtek Highway",
          "Sawarla Lake",
          "Selari Forest",
          "Shirsala Lake",
          "Sitepar wetland",
          "Ukara Lake",
          "Umari Lake",
          "Umred Karhandala WLS--Pauni Region",
          "Umred Karhandla WLS- -Backwaters area",
          "Umrer Karhandla WLS--Pauni Gate",
          "Wahi Jalashay",
          "Waijeshwar Shiv Temple, Pauni",
          "Wainganga Protection Wall",
          "Walmazari Lake",
        ],
      },
      {
        district: "Buldhana",
        localities: [
          "Ambabarwa Wildlife Sanctuary",
          "Anand Sagar Jalashay",
          "Borjawala Reservoir",
          "Botha Reservoir and Spillway",
          "Buldhana City",
          "Dyanganga WLS, Buldhana Dt",
          "Dyanganga WLS--Dam",
          "Dynanganga River bridge",
          "Garadgaon Reservoir",
          "Godada Dam, Jalgaon Jamod",
          "Gyanganga Reservoir",
          "Hiwarkhed Reservoir and Spillway",
          "Janephal",
          "Januna Lake, Khamgaon",
          "Khamgaon, Buldhana Dt",
          "Lonar Lake",
          "Malkapur, Buldhana Dt",
          "Mas Reservoir and Spillway",
          "Mehkar (OBI)",
          "Nalganga Reservoir",
          "Nandura Town",
          "Paldhag Reservoir and Spillway",
          "Patoda Dam & Spillway",
          "Pentakli Reservoir and Spillway",
          "Purna River",
          "Shirla Dam",
          "Sindkhed Raja",
          "Tarapur Waterfall Trail",
          "Waghali Temple And Lake",
          "Yelgaon Dam",
        ],
      },
      {
        district: "Chandrapur",
        localities: [
          "Anandwan, Warora",
          "Antargaon Annur Waterfall",
          "Asolamendha Dam",
          "Balharshah Railway Station, Chandrapur",
          "Bhagwanpur lake",
          "Bikli Lake",
          "Chandrapur (OBI)",
          "Chandrapur--General Area",
          "Chargaon Reservoir, Chimur Range",
          "Chimur Talao",
          "Chougan (Chaugaon) lake",
          "Deoli Lake",
          "Dev Talav",
          "Drc Pahadi",
          "Ekara Lake",
          "Ekara lake",
          "Ghodajhari  Lake",
          "Ghodazari Lake",
          "Jatepar Talav",
          "Junona Lake",
          "Kasarla Lake",
          "Katwal lake",
          "Kharabi Lake",
          "Korambi Lake",
          "Lake near Adhyad Hill, Brahmapuri",
          "Lake near Zari Peth Gate",
          "Lawari lake",
          "MTDC Resort, Moharli",
          "Mahua Tola, Tadoba",
          "Mamala Gate",
          "Mindala lake",
          "Mudza lake",
          "Pimpalkhut Lake, Chandrapur",
          "Sarangadh",
          "Sath Bahini Temple Lake",
          "Somnath Prakalp",
          "Sonapur Lake",
          "Tadoba -- Svasara Lodge",
          "Tadoba Andhari Tiger Reserve",
          "Tadoba Andhari Tiger Reserve -- -- Shirkada Gate",
          "Tadoba Andhari Tiger Reserve -- Navegaon-Ramdegi Gate",
          "Tadoba Andhari Tiger Reserve -- Pangdi Gate",
          "Tadoba Andhari Tiger Reserve -- Sirkada Water Reservoir",
          "Tadoba Andhari Tiger Reserve -- Sitarampeth boat camp",
          "Tadoba Andhari Tiger Reserve-- Keslaghat Gate",
          "Tadoba Andhari Tiger Reserve--Agarzari Gate",
          "Tadoba Andhari Tiger Reserve--Agarzari Zone",
          "Tadoba Andhari Tiger Reserve--Alijanza Buffer Zone",
          "Tadoba Andhari Tiger Reserve--Alizanza Gate",
          "Tadoba Andhari Tiger Reserve--Belara Gate",
          "Tadoba Andhari Tiger Reserve--Dewada Buffer Area",
          "Tadoba Andhari Tiger Reserve--Erai Dam",
          "Tadoba Andhari Tiger Reserve--Fuljhari Lake",
          "Tadoba Andhari Tiger Reserve--Junona Gate",
          "Tadoba Andhari Tiger Reserve--Katezari Trail",
          "Tadoba Andhari Tiger Reserve--Khutwanda Gate",
          "Tadoba Andhari Tiger Reserve--Kolara Buffer Zone",
          "Tadoba Andhari Tiger Reserve--Kolara Gate",
          "Tadoba Andhari Tiger Reserve--Madnapur Gate",
          "Tadoba Andhari Tiger Reserve--Moharli Gate",
          "Tadoba Andhari Tiger Reserve--Nimdhela Range",
          "Tadoba Andhari Tiger Reserve--Pandharpawni",
          "Tadoba Andhari Tiger Reserve--Pangadi Gate",
          "Tadoba Andhari Tiger Reserve--Red earth tadoba",
          "Tadoba Andhari Tiger Reserve--TAARU VANN",
          "Tadoba Andhari Tiger Reserve--Tadoba Lake",
          "Tadoba Andhari Tiger Reserve--Telia Lake",
          "Tadoba Andhari Tiger Reserve--Zari Core Gate",
          "Tadoba Andhari Tiger Reserve--Zari Peth Gate",
          "The Bamboo Forest Safari Lodge",
          "Tiger Heaven Resort (Restricted access)",
          "United-21 Tiger Camp Resort, Bhamdeli, Moharli",
          "Warora, Chandrapur Dt.",
          "tigress@ghosri",
        ],
      },
      {
        district: "Dhule",
        localities: [
          "Aarbhuja Mata Mandir",
          "Aner Dam",
          "Dedargaon grassland",
          "Dedorgaon Talaw",
          "Dr. Panjhara Road",
          "Gondur Lake",
          "Gondur Lake Road",
          "Haranmall Lake",
          "Hingane Lake, Pimperkhede",
          "Jamkhedi Dam",
          "Khamkheda Reservoir",
          "Laling Fort Reserve Forest",
          "Laling Reserved Forest",
          "Lamkani Grassland",
          "Nakane lake biodiversity zone",
          "Nimdale Forest",
          "Nimdale Lake",
          "Nimdale Raptor Point",
          "Nimdale Shiwar",
          "Panjhara Sunset Point",
          "Panzara Dam",
          "SBH Government medical college campus, Dhule",
          "SBHGMC campus -- Micro Forest",
          "Sahjeevan Nagar, Malegaon Rd.",
          "Shri Bhaushaeb Hire Government Medical College, Dhule",
          "Sonvad Reservoir, Dhule",
          "Tikhi New Dam",
          "Wadel Grassland",
        ],
      },
      {
        district: "Gadchiroli",
        localities: [
          "Bodali Lake",
          "Bodali Lake 2",
          "Dina dam",
          "Kudakwahi",
          "Lagam Reservoir",
          "Mama Sonsari lake",
          "Mendha Village",
          "Navin Talav Jambhurkheda",
          "SEARCH",
          "Wainganga Bridge",
        ],
      },
      {
        district: "Gondia",
        localities: [
          "Bandh Talav",
          "Bazartola Lake",
          "Bazartola, Gondiya",
          "Bonde Lake",
          "Chulband Dam",
          "Dahegaon, Gondia",
          "Garden Of Samajik Vanikaran Vibhag",
          "Gauri Doh(Pond),Nagzira Outskirt",
          "Ghiwari Lake",
          "Gondia Railway Station",
          "Gonditola Lake",
          "Gothangaon Area",
          "Hanuman Mandir, Kalimati",
          "Itiadoh Dam",
          "Katangtola Talav",
          "Khalbandha Dam",
          "Lohara Lake",
          "Lohara Village",
          "Makadi Lake",
          "Manegoan forest",
          "Nagzira WLS",
          "Nagzira WLS -- Tibet Camp",
          "Nagzira WLS--Chorkhamara",
          "Nagzira WLS--Chorkhamara Dam",
          "Nagzira WLS--Chorkhamra Lake",
          "Nagzira WLS--Nagzira Lake",
          "Navegaon National Park",
          "Navegaon National Park--Dam & surrounding area",
          "Nilaj Lake",
          "Palasgaon Wetland",
          "Pangadi Reservoir",
          "Pindakepar Lake, Nagzira Outskirt",
          "Ramsagar Lake, Tirora",
          "Rengepar Reservoir",
          "Salagtola Lake",
          "Serpur Bird Sanctuary--Paraswada Lake",
          "Sioni Lake",
          "Social Forestry Garden",
          "Soundad Lake",
          "Subhash Garden",
          "Zaliya Talav, Gondia",
          "Zilmili Lake",
        ],
      },
      {
        district: "Hingoli",
        localities: [
          "Audha Nagnath, Hingoli",
          "Bhategaon Dam",
          "Chirag Shash Darga",
          "Chudawa station, Purbhani Dt",
          "Hingoli Railway station",
        ],
      },
      {
        district: "Jalgaon",
        localities: [
          "80 Feet Road Area",
          "Akulkheda Outskirts",
          "Anjani Dam",
          "Anjani river, Erandol",
          "Anubhuti Residential School, Nagziri",
          "BHUSAWAL THERMAL POWER STATION (BTPS )-- ASH BUND",
          "Badgujar Galli",
          "Bahula Dam",
          "Bahula Dam -- Krishna Sagar park",
          "Balya Maruti Temple Lake",
          "Bhalgaon Lake",
          "Bhati Dam, Charthana",
          "Bhavani Mandir, Jamner",
          "Bhokarbari Pond",
          "Bhusaval city",
          "Bhusawal Thermal Power Station (BPTS)--Wetland",
          "Bhusawal Thermal Power Station (BTPS)--500MW Premises",
          "Bhusawal Thermal Power Station (BTPS)--Between 210MW & 500MW",
          "Bhusawal Thermal Power Station (BTPS)--Deepnagar",
          "Bhusawal Thermal Power Station (BTPS)--Ganesh Mandir & 400KV",
          "Bhusawal Thermal Power Station (BTPS)--Ganesh Mandir & EM Building Area",
          "Bhusawal Thermal Power Station (BTPS)--Sewage Treatment Plant",
          "Bor Ajanti Ghat",
          "Chalisgaon--Hatale Dam",
          "Chambhar Dari Dam,Shirsoli",
          "Chandika Devi Mandir Patana",
          "Chavhan Tea Stall, North Maharashtra University Road",
          "College of Social Work, Chopda",
          "Dargah, Lalmati",
          "Dharangaon outskirts",
          "Dharangaon--Teli Talav",
          "Dr. Shyamaprasad Mukharji Garden",
          "Farkande",
          "Fields near Chopda",
          "Forest Nursery, Mohadi, Pachora",
          "Ganesh Tanda Lake",
          "Garbage Depot",
          "Garbage Depot, Shivaji Nagar",
          "Garbage Depot,Shivajinagar",
          "Garbaldi Dam",
          "Girana pumping station, Savkhede Bk.",
          "Girana river banks, Nimkhedi",
          "Girna Dharan Area",
          "Girna River -- Fupanagari",
          "Girna River -- Kuwarkhede",
          "Girna River -- Nandre Bk",
          "Girna River, Kanalda",
          "Girna Riverbanks near Shri Kshetra Sukeshwar Mahadev",
          "Girna river -- Khedi Kh. banks",
          "Girna river bed, Avhane",
          "Golani Complex",
          "Gul Dam",
          "Hadsan Pahan",
          "Hartale Lake",
          "Hatnur Dam (IBA)--Changdev Mandir",
          "Hatnur Dam(IBA)--General",
          "Hatnur Dam(IBA)--Khamkhed",
          "Hatnur Dam(IBA)--Mehun Mukatai Mandir",
          "Hatnur Dam(IBA)--Tandalwadi",
          "Hivra Dam, Khadakdeole",
          "Jambhul Lake, Kurhadade",
          "K. B. Chaudhari North Maharashtra University Jalgaon",
          "Kakanbardi Hill",
          "Kanalada Road, Jalgaon",
          "Kandari, Bhusawal",
          "Kantai Dam",
          "Kanva Ashram, Kanalda",
          "Khadaki River Bridge, Shahapur",
          "Kolhe Hills, Wagh Nagar, Jalgaon",
          "Krushi Vidnyan Kendra,",
          "Kurhadade lake (small)",
          "Kuwarkhede  Bus Stand",
          "Landorkhori Garden",
          "MGSM's Arts, Science & Commerce College. Chopda",
          "Mahadev mala temple area",
          "Mamlade Field (Restricted)",
          "Mamurabad Road, Jalgaon",
          "Manudevi Pazar Lake",
          "Manudevi Temple Forest Area",
          "Manyar Khede",
          "Manyarkheda Lake",
          "Mehrun Lake, Jalgaon",
          "Mhasave Lake, Mhasave",
          "Mohadi Dam, Pachora",
          "Mohjay Talav, Bhusaval",
          "Muktai-Bhavani Conservation Reserve and Wildlife Sanctuary",
          "Nasirabad",
          "Nimbadevi Dam",
          "Ordnance Factory",
          "Ozarkheda Dam",
          "Pal Wildlife Sanctuary--View Point",
          "Pandharpur Nagar Pond",
          "Pimpalgaon Pimpri Lake",
          "Pimprisekam-River Bhogawati",
          "Purna River -- Dui banks",
          "R K Patel Nagar, Amalner",
          "RR Vidyalay",
          "Ramdeowadi Lake,Pachora Rd.,Maharashtra,IN",
          "Samarth Colony",
          "Satpuda Ghat",
          "Seasonal Lake Near Akulkheda",
          "Shahapur Dam birding area",
          "Shelgaon Barrage, Shelgaon.",
          "Shirsoli Lake",
          "Shiv Dam, Kurhe Panache",
          "Shivaji Nagar, Jalgaon",
          "Smruti Udyan (Shivaji Udyan)",
          "Suki Dam--Back Water",
          "Tapi River -- Bhokari banks",
          "Tapi River -- Shiragad",
          "Tapti BTPS Reservoir",
          "Tapti Ghat, Bhusawal",
          "Tapti River Bank, Jalod",
          "Tapti River--Behind BTPS",
          "Tarsod Ganpati temple area",
          "Tembhurbari, Near Nimbadevi Dam",
          "Umale Lake",
          "Velhale Lake",
          "Vyas Mandir",
          "Waghur Dam",
          "Waghur Dam Backwaters, Kandari",
          "Waghur Dam--Hingane",
          "Waghur River -- Sunasgaon river banks",
          "Waghur River -- Tighre",
          "Waghur River, Neri",
          "Waghur river -- Sakegaon",
          "Waghzira Dam",
          "Wakadi Riverside",
          "Warkhed drylands and farms",
          "Wavdade Lake, Shirsoli",
        ],
      },
      {
        district: "Jalna",
        localities: [
          "Dhamana Dam",
          "Jwala Lawns",
          "Moti Talab (Lake)",
          "Nangar Taas Temple",
          "Priyanka Residency",
          "Rajewadi Talav, Jalna",
        ],
      },
      {
        district: "Kolhapur",
        localities: [
          "Adur Birdwatching Area",
          "Amba Forest",
          "Ambeohal Dam",
          "Anuskura",
          "Balikre Lake",
          "Barki",
          "Chandoli National Park",
          "Chandoli National Park--Ambabai Mandir Devrai",
          "Chavare Outskirts",
          "Chhatrapati Shivaji Maharaj University Campus",
          "Dajipur WLS",
          "Danoli Warna dam area",
          "Dhuloba Hill",
          "Gandhi Maidan",
          "Ghatge Lake",
          "Junction Point, Panhala",
          "Kaajva Forest Stay, Gaganbawada kol",
          "Kalamba Reservoir",
          "Kalanidhi Fort",
          "Kalleshwar Talav, Shirol",
          "Kandalgaon Lake",
          "Kandavan Forest",
          "Kurundwad Ghat",
          "Kutwad Marsh",
          "Mahalaxmi Lake",
          "Manoli Dam",
          "Masai Pathar",
          "Mhaisal Dam",
          "Mirwel forest",
          "Mugali Maal",
          "Mugali Outskirts",
          "Nagnath Temple",
          "Nandyal-Mugali Bridge, Chikotra River",
          "Narsoba Wadi Temple",
          "New Palace",
          "New Palace Zoo, Kolhapur",
          "Palsambe Sacred Grove",
          "Panchganga Riverbank",
          "Panhala Fort",
          "Patane--General Area (OBI)",
          "Pawankhind Resort (Restricted access)",
          "Radhanagari WLS",
          "Rajaram Talav",
          "Rankala Lake, Kolhapur",
          "Rankala Lake- Sandhya Math",
          "Rautwadi Waterfall, Radhanagri",
          "Shendri Talav",
          "Shinoli (OBI)",
          "Shivaji University Music Dept Lake",
          "Shri Allamaprabhu Temple",
          "Siddhala Garden",
          "Siddhoba Temple, Kolhapur, Maharashtra",
          "Sri Katyayani Temple",
          "Temblai Mandir Garden",
          "Terani Dam",
          "Tilari Birding Site",
          "Tilari Dam Sindhudurg",
          "Tilari Ghat",
          "Tillari Conservation Reserve--Power Station Area",
          "Tillari power canal road",
          "Tukai Hill",
          "Tulashi Dam",
          "Vedganga Riverbanks, Shengaon",
          "Veer Shiva Kashid statue - surrounding area",
          "Vishnu Lake",
          "Vithalai Hill(विठ्ठलाई डोंगर)",
          "Wild Dajipur Home Stay (Restricted Access)",
          "near Kolhapur (OBI)",
          "near Kolhapur, Karnataka (OBI)",
        ],
      },
      {
        district: "Latur",
        localities: [
          "Hati Lake",
          "Kava Lake",
          "Latur city",
          "Masalga Dam, Latur",
          "Rena Lake",
        ],
      },
      {
        district: "Mumbai",
        localities: [
          "Angriya Cruise , Mumbai",
          "BPT Park, Colaba",
          "Byculla Zoo & Museum Complex",
          "Colaba",
          "D.G. Ruparel College",
          "Gateway of India",
          "Geeta Nagar",
          "Girgaon Beach",
          "Grand Paradi",
          "Guru Nanak Khalsa College of Arts, Science & Commerce",
          "Guru Nanak Khalsa College, Matunga (E)",
          "Haji Ali Dargah",
          "Hanging Gardens",
          "Hindu Colony (Restricted access)",
          "J.J. Hospital Campus--New Establishment Quarters",
          "K J Somaiya Hospital Campus",
          "Kala Ghoda",
          "Mahalaxmi Race Course",
          "Mahim Beach",
          "Mahim Nature Park",
          "Malabar Hill, Mumbai (OBI)",
          "Mantralaya",
          "Marine Drive Jogging Track",
          "Morya Mandir",
          "Nariman Point",
          "Nehru Science Centre",
          "Radio Club",
          "Sassoon Dock",
          "Sewri Jetty, Mumbai",
          "Sewri Mudflat",
          "Shivaji park",
          "Sophia College (Restricted)",
          "TIFR Grounds, Colaba",
          "The Institute of Science, Fort",
          "Veer Mata Jijabai Bhosale Udyan & Zoo",
          "off Mumbai Harbour (OBI)",
        ],
      },
      {
        district: "Mumbai Suburban",
        localities: [
          "Aarey Colony",
          "Aarey Colony--Aarey Guest House",
          "Aarey Colony--Aarey Lake",
          "Aarey Colony--Aarey Picnic Point",
          "Aarey Colony--Chota Kashmir Park",
          "Airoli Marshes, Along National Highway",
          "Aksa Beach",
          "Anushakti Nagar Lake",
          "BEST Staff Quarters, Deonar",
          "BNHS Conservation Education Centre",
          "BPGC, Golf Club (Restricted access)",
          "Bhandup Pumping Station (BPS)",
          "Bhandup Pumping Station--Creek Mudflats",
          "Bhandup Pumping Station--Salt Flats",
          "Bhavan's College, Andheri",
          "Bhavan's College--Lake",
          "Bombay Veterinary College Campus",
          "Chandivali Hill",
          "Charkop koliwada creek",
          "Chikuwadi Jogger's Park, Borivali",
          "Chintaman Rao Deshmukh Udyan",
          "DES Rishi Valmiki Eco School",
          "Dahisar Creek",
          "Devdeshwar Society, Andheri",
          "Erangal Beach",
          "Forest Park, Powai",
          "Ganadhiraj Society, Mulund (E)",
          "Godrej Jetty, Virkoli",
          "Godzilla Park Lake, Mumbai, Maharashtra",
          "Gorai Beach",
          "Gorai Jetty",
          "Gorai Jetty Borivali Side",
          "Govind nagar",
          "Homi Bhabha Centre for Science Education  (HBCSE)",
          "IIT Bombay",
          "Ismail Yusuf College",
          "Janabai Rd",
          "Jogger's Park, Lokhandwala Garden",
          "Juhu Beach",
          "Juhu Jetty",
          "Juhu Lake",
          "Kandarpada Mangroves",
          "Kapol Garden",
          "Lokhandwala Lake",
          "Lokhandwala Lake--Mangroves",
          "Lokhandwala Wetland",
          "M.C.G.M. Nirvana Park",
          "MPT Colony",
          "MTHL Mudflats",
          "Madh Jetty Rd",
          "Maker Kundan Gardens (Restricted access)",
          "Manori Hill",
          "Manori, Mumbai",
          "Marve Beach",
          "Milan Subway",
          "Mindscape, Malad Creek",
          "Mithibai College",
          "Mogara Nallah",
          "Mulund East Saltland",
          "Mumbai Airport",
          "Mumbai University--Kalina Campus",
          "Nahur East (BPS Outskirts)",
          "Parle Tilak English Medium School",
          "Patkar College",
          "Post and Telegraph Colony, Mulund West",
          "Powai Garden",
          "Powai Lake",
          "Powai Lake Boathouse IITB",
          "RD and SH National College and SWA Science College",
          "Riddhi Apartments, Chincholi",
          "Rishi Valmiki Eco School (Restricted access)",
          "Sanjay Gandhi (Borivali) NP",
          "Sanjay Gandhi NP--Dahisar banks",
          "Sanjay Gandhi NP--Jambhulmaal",
          "Sanjay Gandhi NP--Kanheri Caves",
          "Sanjay Gandhi NP--MSEB Trail",
          "Sanjay Gandhi NP--Navapada",
          "Sanjay Gandhi NP--Peacock Point",
          "Sanjay Gandhi NP--Safari Trail",
          "Sanjay Gandhi NP--Shilondha Trail",
          "Sanjay Gandhi NP--Thakurpada - Bhoot Bangla Trail",
          "Sanjay Gandhi NP--Tulsi Lake Rd",
          "Sanjay Gandhi NP--Upper Trail",
          "Sanjay Gandhi NP--Vihar Lake",
          "Shree Dattaguru Cooperative Housing Society, Deonar",
          "Somaiya Vidyavihar University",
          "Suryanagar Hill, Powai",
          "Swatantryaveer Vinayak Damodar Sawarkar Udyan",
          "TISS, Naoroji Campus, Mumbai(Restricted access)",
          "Tarun Bharat Society, Chakala",
          "Tarzon lake",
          "Telecom Colony",
          "Thakur International School",
          "The Retreat Hotel and Convention Centre",
          "U.S. Consulate General, Mumbai (restricted access)",
          "Vashi Creek",
          "Versova Beach",
          "Vissanji Academy(Restricted Access)",
          "Whispering Palms Internal Road (Restricted Access)",
        ],
      },
      {
        district: "Nagpur",
        localities: [
          "AIIMS Campus, Nagpur",
          "Agriculture College Fields",
          "Ajni Van",
          "Ambazari Biodiversity Park",
          "Ambazari Garden",
          "Ambazari Lake, Nagpur",
          "Ambazari Lake--Backwaters, Nagpur",
          "Ambhora Bridge",
          "Bamboo Forest Nature Conservancy",
          "Banvanthadi Dam Tangala",
          "Banwadi Grassland",
          "Bor Tiger Reserve--Adegaon",
          "Central Mine Planning & Design Institute (CMPDI)",
          "Chandrabhaga Dam and Reservoir",
          "Chandrakiran Nagar, Nagpur",
          "Cherry Farm Camp, Ramtek",
          "Chikhali",
          "Children's Traffic Park, Nagpur",
          "Chinchbhuvan canal",
          "Chota Talav",
          "Dahegaon Lake",
          "Deepak Nagar",
          "Degma Forest",
          "Degma, Village",
          "Dhantoli General",
          "Dongargaon Lake",
          "Dr. Ambedkar International Airport",
          "Dudha Lake",
          "Futala Lake",
          "Gandhi Sagar Lake",
          "Go-Vigyan Anusandhan kendra, Deolapar",
          "Gorewada Lake",
          "Gothangaon Outskirts",
          "Govt. Medical College (GMC) Nagpur",
          "Hazaripahad",
          "Isasani road - grassland",
          "Javahar Navodaya Vidyalaya,  Bhivagad",
          "Jhulelal Institute of Technology",
          "Junapani Lake",
          "Kamptee Ash Pond",
          "Kamptee Dry Area",
          "Karhandla Wildlife Lake",
          "Kekra Nala Dam",
          "Khapari Lake",
          "Khapri lake",
          "Kharsoli grassland",
          "Khasarmari Lake",
          "Koradi Lake",
          "Koradi, Nagpur Dt",
          "Lake View Enclave (Restricted access)",
          "Lonara Lake",
          "Ludra Mata Mandir",
          "Madhu Ganga Lake",
          "Maharajbagh Zoo",
          "Makardhokda Dam",
          "Manish Nagar",
          "Mansar Excavation Site",
          "Matkazari Lake",
          "Mihan, Nagpur",
          "Nagpur Outskirts (OBI)",
          "Nagpur Railway Station",
          "Nandera Dam and Reservoir",
          "National Academy of Direct Taxes (restricted access)",
          "National Environmental Engineering Research Institute (NEERI)",
          "Palloti Grassland",
          "Paradgaon Lake",
          "Pench Dam",
          "Pench National Park --  Khubala Gate",
          "Pench National Park -- Saleghat",
          "Pench National Park, Maharashtra",
          "Pench National Park--Bandra Beat",
          "Pench National Park--Chorbahuli Gate",
          "Pench National Park--Khursapar Gate",
          "Pench National Park--Kolitmara",
          "Pench National Park--Mogarkasa Gate",
          "Pench National Park--Salama Check Point",
          "Pench National Park--Sillari Gate",
          "Pench National Park--Totladoh Reservoir",
          "Pench Tiger Reserve--Mansingdeo Temple",
          "Pench Tiger Reserve--Surewani Gate",
          "Pewatha Lake",
          "Police Line Tank, Nagpur",
          "Prabhu Nagar Nala",
          "Raj Bhavan, Nagpur",
          "Rajarshi Chhatrapati Shahu Maharaj E-library",
          "Ramtek, Nagpur Dt",
          "Sahakar Nagar Birding Area",
          "Saiki Lake",
          "Salaimendha Dam And Forest",
          "Sasegaon Lake",
          "Satpuda Botanical Garden",
          "Seminary Hills, Nagpur",
          "Shankarnagar, Nagpur (OBI)",
          "Shivkund",
          "Shri Mathuradas Mohota College of Science",
          "Shri Ramdeobaba College of Engineering and Management (RBU)",
          "Shrikrishna Mandir, Amraipara",
          "Sirpur",
          "Sivana Greens, Kondhali",
          "Sonegaon Lake, Nagpur",
          "Surabardi Lake, Nagpur Dt.",
          "Suradevi pond",
          "Telangkhedi Lake--Agroforestry Side",
          "Telankhedi Garden",
          "Telhara Reservoir, Nagpur",
          "Turagondi lake",
          "Umerda Forest area, Yavatmal (OBI)",
          "Umred Karhandla WLS",
          "Umred Karhandla WLS -- Ranbodi lake",
          "Umred Karhandla WLS--Gothangaon Range",
          "VIMS Hospital area",
          "VNIT Campus",
          "Wadadh Lake 1",
          "Wakeshwar Dam",
          "Wena Dam And Reservoir",
          "Wildlife Conservation Trust campus",
          "Zari",
          "Zilpi Lake And Forest",
        ],
      },
      {
        district: "Nanded",
        localities: [
          "Limbgaon Lake",
          "Mundkhed Station",
          "Nanded Railway Station",
          "Parwa Gav Talav",
          "Patnur Temple",
          "Ratneshwari Temple",
          "Shikhachiwadi",
          "Sitakhandi Lake",
          "Trikut, Nanded",
        ],
      },
      {
        district: "Nandurbar",
        localities: [
          "Toranmal WLS",
          "Toranmal WLS--Kelapani-Kotbandhani Area",
          "Toranmal WLS--Machindranath",
        ],
      },
      {
        district: "Nashik",
        localities: [
          "Amrutdham",
          "Anjaneri Fort Trek",
          "Anjaneri Lake--Wall Side",
          "Ankai Tankai Fort",
          "Bapu Pool",
          "Beze",
          "Borgad Conservation Reserve",
          "Bramhagiri Mountain",
          "Club Mahindra, Hatgad",
          "College road",
          "Deolali Cantonment",
          "Dugarwadi",
          "Dusangwadi lake",
          "ECO Point",
          "Flyash Pond, Eklahare",
          "Gangakath Rop Vatika",
          "Gangapur Dam Back water",
          "Gangapur Dam Far Side",
          "Gangapur Forest Nursery, Nashik",
          "Goda Park",
          "Grape County",
          "Harihar Fort",
          "Harsul Lake",
          "Harsul forest",
          "Kashyapi Dam",
          "Madhyameshwar Maharaj Temple area",
          "Maharashtra University of Health Sciences, Nashik",
          "Mahatma Nagar",
          "Mahiravani Dam",
          "Mamdapur Conservation Reserve, Rajapur",
          "Mangi-Tungi mountains",
          "Maratha Vidya Prasarak Samaj Institutions (restricted access)",
          "Markhandya Fort",
          "Nandur Madhmeshwar Bird Sanctuary--Manjargaon",
          "Nandur Madhmeshwar Bird Sanctuary--Watch Tower 1",
          "Nandur Madhyameshwar Bird Sanctuary",
          "Nashik (OBI)",
          "Panchavati Ghat, Nashik",
          "Pandav Leni Caves",
          "Pandit Jawaharlal Nehru Van Udyan",
          "Pathardi Nashik Annex - II",
          "Pathardi Phata",
          "Pathardi, Nashik Annex - I",
          "Pratap Enclave, Deolali",
          "Rohile Outskirts",
          "Sandip University campus",
          "Tapovan river bank & area",
          "Trambakeshwar",
          "Trimbakeshwar Forest",
          "Vaitarna Dam",
          "Vasantrao Kanetkar Udyan",
          "Vijay Nagar Garden, Dindori Road",
          "Viveda Wellness Resort",
          "Vulture Restaurant, Khoripada",
          "Waghad Dam",
          "Windmill Farm, Sinnar",
          "Yashwantrao Chavan Maharashtra Open University (YCMOU)",
        ],
      },
      {
        district: "Osmanabad",
        localities: [
          "Apsinga-Begad Lake, Tuljapur",
          "Ashta Jahangir Talav",
          "Chandani Dam",
          "Chilim Khada Lake",
          "Dagad-dara Dam, Tuljapur",
          "Dahivadi Lake, Tuljapur",
          "Gangewadi",
          "Hatla Devi Hills",
          "Kalbhairavnath Mandir Dam",
          "Kalegaon Dam, Arali",
          "Kamtha Lake",
          "Katgaon Lake",
          "Kawaldara Dam, Tuljapur",
          "Masala Lake, Tuljapur",
          "Nagnath Mandir, Kasari, Tuljapur",
          "Naldurg Fort, Solapur",
          "Osmanabad Lake",
          "Ramdara Dam, Tuljapur",
          "Ramling station, Yedshi",
          "Ruibhar-Khamaswadi Reservoir",
          "Tata Institute of Social Sciences, Tuljapur",
          "Warwanti Dam",
          "Yamai Devi Lake",
        ],
      },
      {
        district: "Palghar",
        localities: [
          "Arnala Beach",
          "Arnala Jetty",
          "Atmalingeshwar Temple, Shivansai",
          "Bena, Near Suruchi Beach",
          "Bhuigaon Beach",
          "Bhuigaon Village",
          "Burmapada, Near Bhuigoan Beach",
          "Chikhaldongari Wetland",
          "Chikhalgongari, Virar",
          "Chinchani",
          "Chinchani beach",
          "Datiware",
          "Datiware Beach",
          "Gaskopari Wetlands",
          "Ghivali Lake",
          "Gogte Salt Pans",
          "Hira Dongari",
          "Jawhar Ghat",
          "Jyoti Wetlands, Virar",
          "Kelwa Beach",
          "Kurze Dam",
          "Mamachi Wadi Beach, Arnala",
          "Mangrove & Marine Biodiversity Information Center, Marambalpada Jetty",
          "Matrix School, Virar",
          "Merces, Near Suruchi beach",
          "Murba Khadi",
          "Nareshwadi Learning Centre (NLC)",
          "Nirmal Lake, Nalsopara",
          "Padmavati Nagar Wetland, Virar",
          "Papad Khind Dam, Virar",
          "Pelhar Dam",
          "Rajavali Marshes, Vasai",
          "Shirgaon Raypada Talav",
          "Sopara creek,  near Naigaon flyover",
          "Sri Prastha, Virar",
          "Suruchi beach",
          "Takmak Gadh, Sakawar",
          "Tansa WLS--Quaripada",
          "Tarapur Creek",
          "Tungareshwar WLS",
          "Tungareshwar WLS--Waterhole",
          "Umela Wetland, Vasai",
          "Umroli Wetlands",
          "Unbhat Beach",
          "Usarni Beach",
          "Vaitarna Nagar",
          "Vandri Lake",
          "Vasai Fort, Vasai",
          "Virar, Palghar Dist (OBI)",
          "Viva Wetlands, Virar",
          "Wadhvan Beach",
          "Zai Beach",
        ],
      },
      {
        district: "Parbhani",
        localities: [
          "Marathwada agriculture university, Purbhani",
          "Niwali Lake",
          "Purna Junction",
        ],
      },
      {
        district: "Pune",
        localities: [
          "ARAI premises",
          "Aadarwadi",
          "Aamby Valley",
          "Aamby valley -- bharat mata point",
          "Aga Khan Palace",
          "Aghane village,Pune",
          "Agharkar Research Institute Campus",
          "Ahirwade, Maval",
          "Ahupe village",
          "Ambavane Forest Bungalow Compound",
          "Ambavane Pass",
          "Anandvan Mitra Mandal Park",
          "Anandvan jogging tracks",
          "Anandvan, Kondhwa",
          "Anjor Society area (Restricted access)",
          "Area near Agriculture college, Shivajinagar",
          "Army Land",
          "Askarwadi",
          "Aundh Military Camp(Restricted Access)",
          "Autadewadi Lake, Handewadi",
          "Baba Bhide Bridge, Pune",
          "Bagdi to Khamundi Ghat",
          "Baner Hill, Pune",
          "Baneshwar",
          "Bavdhan (PVPIT) ravine",
          "Bavdhan Hill",
          "Bedse Buddhist Caves area",
          "Bhaje Caves, Lonavala",
          "Bhandara Hill",
          "Bharati Vidyapeeth Institute of Environment Education & Research (BVIEER)",
          "Bhatghar Dam -- Basrapur",
          "Bhatghar Dam -- Narhe",
          "Bhegdewadi dam",
          "Bhigwan Bird Sanctuary - Camping Site",
          "Bhigwan--Grasslands",
          "Bhimashakar WLS--Bailghat",
          "Bhimashankar WLS",
          "Bhimashankar WLS--Blue Mormon Hotel",
          "Bhimashankar WLS--Gupt Bhimashankar",
          "Bhimashankar WLS--Hindola",
          "Bhimashankar WLS--Kondava",
          "Bhimashankar WLS--Lahuri dongar (Hill)",
          "Bhimashankar WLS--Machaan",
          "Bhimashankar WLS--Omkar Hotel area",
          "Bhimashankar WLS--Yelavali",
          "Bhoini",
          "Bhor Area",
          "Bhorgiri Fort",
          "Bhose Dam, Chakan",
          "Bhugaon",
          "Bhujbal Township marsh (Restricted Access)",
          "Bhukum, Pune",
          "Bhuleshwar Temple",
          "Bird valley lake, nigadi, pune",
          "Blue Ridge Township",
          "Bopalghar Devrai-Sacred Grove",
          "Bopdeo Ghat, Pune",
          "Botanical Garden, Bopodi, Pune",
          "Bridge near Indradhanush Environment Centre",
          "Bund Garden - Ambedkdar Bridge",
          "CME Campus (Restricted access)",
          "CME periphery (Restricted access)",
          "CME- Ganesh Nagar edge (Restricted access)",
          "CPS  campus",
          "CQAE Aundh Camp (Restricted access)",
          "CTW Lake (Restricted Access)",
          "Camp 365",
          "Casurina Resort Park Aquazone",
          "Cemetery Road, Riverside",
          "Chas Kaman Dam",
          "Chatushrungi Temple and Hill",
          "Chinchani Ghod dam",
          "Chinkara Vanyaparyatan Prakalp",
          "Chinmaya Vibhooti",
          "Chittaranjan Vatika",
          "Christ University Lavasa Campus",
          "Club Mahindra Lonavala",
          "College of Forestry, Ponnampet",
          "DSK Chandradeep (restricted access)",
          "Dahanukar Colony Garden",
          "Damle Path",
          "Dapsare Devrai",
          "Daund",
          "Daund Railway Quarters",
          "Daund Scrubland",
          "David Sassoon Asylum,Navi Peth",
          "Deccan college campus",
          "Defence Institute (Restricted access)",
          "Degaon",
          "Dhammanand Vipassana Center (restricted access)",
          "Dhawalgadh Fort",
          "Dighi Hills",
          "Dingrajwadi - Old Neem Tree",
          "Dive Ghat",
          "Dongerwadi",
          "Dr Salim Ali Bird Sanctuary",
          "Dr. Salim Ali Biodiversity Park",
          "Dr. Salim Ali Bird Sanctuary, Yerwada",
          "Duke's Nose Trek",
          "Durga tekdi (Hill), Pune",
          "Dwarkadheesh Residency (Restricted Access)",
          "Ecological Society Restoration Site, Panshet",
          "Ela Habitat, Jejuri",
          "Elysium Society (Restricted access)",
          "Empress Botanical Garden",
          "Erandawane-Canal Jogging Path",
          "FLAME University",
          "Fergusson College Campus",
          "Fields North of PVPIT",
          "Fields near ANP Atlantis",
          "Firangai Devi Hill",
          "Forest Area Wanowrie",
          "Forest Garden near Omega Retreat, Lonavala",
          "Forest Trails, Saffronstays, Lonavala (Restricted Access)",
          "Forest trails (restricted access)",
          "GH Raisoni International Skill Tech University (restricted access)",
          "Gajar Pat, Pimpri-Pendhar, Junnar",
          "Garudmaachi (Restricted access)",
          "Gavkos Resort",
          "Gawade Ghat, Chinchwadgaon",
          "Ghoradeshwar Hills",
          "Ghoradeshwar Hills Base",
          "Giant Metrewave Radio Telescope",
          "Girawali Observatory - IUCAA",
          "Girivan Glory",
          "Gokulnagar Hill",
          "Gokulnagar Plateau Near NDA",
          "Green Gate Resort, Mulshi (Restricted access)",
          "Green Hills",
          "Gulmohar Orchids",
          "Gurnam Lake (Restricted Area)",
          "Gyaneshwar hindu temple, Kukadi river",
          "Hadashi Surroundings",
          "Hanuman tekdi",
          "High Bliss Society (restricted access)",
          "Hill View Residency, Baner Road (restricted access)",
          "Hilton Shillim Resort",
          "Hinjewadi, Pune",
          "IISER Pune",
          "IMDR Canteen, Pune",
          "IMDR Gate, Fergusson college, Pune",
          "IUCAA-Inter-University Centre for Astronomy and Astrophysics",
          "Indapur RF (OBI)",
          "Indian Institute of Tropical Meteorology",
          "Indrayani Riverside Markal Pune",
          "Indrayani river bridge",
          "Indus School's campus (restricted access)",
          "Infosys DC, Pune",
          "International Institute of Information Technology",
          "Jai Ganesh lake, Pingori",
          "Jalsrushti Island (restricted access)",
          "Jambhulwadi (Asane)",
          "Jambhulwadi Lake, Ambegaon",
          "Jogging Track,Near New Canal Rd, Hingne Khurd",
          "Jovan-Pawna lake environs",
          "Jubilee Park Warje",
          "KPIT Technologies Campus (Restricted access)",
          "Kadave Ghat",
          "Kadbanwadi Grasslands",
          "Kakasaheb Gadgil udyan (garden)",
          "Kaldari",
          "Kalkai Devrai (sacred grove)",
          "Kamala Nehru Park",
          "Kamalini Kutir (Restricted access)",
          "Kanifnath Temple",
          "Kare Ayurveda & Yoga Center",
          "Karkhel, Baramati",
          "Karvenagar Nala",
          "Kasari Vasumala Lake",
          "Kasarsai Dam",
          "Katraj Ghat",
          "Katraj Snake Park Lake (Rajiv Gandhi Zoo)",
          "Kavdi Pat",
          "Kesnand, Wadebolai",
          "Khadakwasla Dam",
          "Khadakwasla Reservoir -- Malkhed area",
          "Khandala Ghat area",
          "Khandoba Maal",
          "Khandoba temple road, Khandoba hills",
          "Kirkat Wadi (OBI)",
          "Kolvan",
          "Kolvihire grasslands",
          "Kondan The Retreat (restricted access)",
          "Kondhanpur",
          "Kothrud, Pune (OBI)",
          "Kshitij Society (Restricted access)",
          "Kudje",
          "Kudje-Mutha Road",
          "Kumar Prerana Society",
          "Kunal Icon (restricted access)",
          "Kundalika View Point",
          "Kurtuwadi Devrai",
          "Kurtuwadi stream",
          "Kusgav Khind",
          "Kusur Plateau (near Thokarwadi Dam)",
          "Lakaki Lake",
          "Lake Gardarewadi, Vadgaon bande",
          "Lavasa Lake",
          "Lavasa Nature Trail",
          "Lavasa Road",
          "Lavasa Tamhini road",
          "Leelangan by Swadhaa",
          "Lohagad Fort forest",
          "Lohagad Visapur Khind Road",
          "Lonavala (OBI)",
          "Lonikand resevoir",
          "Loyola High School and Junior College campus (restricted access)",
          "MES Abasaheb Garware College",
          "MIDC Dry lands and dry deciduous forest",
          "MIT Institute of Design, Loni Kalbhor",
          "MIT World Peace University",
          "Madhe Ghat",
          "Magarpatta City",
          "Mahatma Hill",
          "Mahatma Society, Kothrud",
          "Mahindra United World College of India",
          "Malhar Machi Resort (Restricted)",
          "Malhargad",
          "Manakeshwar",
          "Manas Lake, Bhugaon",
          "Mandvi Riverside Farms",
          "Manikdoh Leopard Rescue Centre (Restricted Access)",
          "Manjari Bridge, Pune",
          "Mastani Lake",
          "Mastani Lake Near Patas",
          "Matoba Lake",
          "Mayureshwar WLS",
          "Mhalunge",
          "Mhatoba Garden",
          "Mhatoba Hill",
          "Modern College of Arts Commerce Science",
          "Mohammadwadi Forest Reserve",
          "Morachi Chincholi",
          "Moraya Gosavi garden, PCMC",
          "Morgaon-Murti",
          "Mugaon lake",
          "Mugawade",
          "Mula Bird Survey Point 5",
          "Mula Mutha River Bank, Kharadi",
          "Mula River",
          "Mula River Bridge, Shantinagar",
          "Mula River--Pimple Nilakh",
          "Mula River--Wakad Bridge",
          "Mula river -- Darawali banks",
          "Mula river Aundh",
          "Mula riverbanks -- Ambedkar bridge, Baner",
          "Mulaai Devrai",
          "Mulkhed",
          "Mulshi, Pune",
          "Munde Garden",
          "Muredha Nala Park",
          "Mutha River, Nanded City",
          "Mutha River--Mhatre Bridge",
          "Mutha riverside road",
          "NCL Colony",
          "NCL School",
          "NDA Hill Valley",
          "NDA Road",
          "NIBM Campus",
          "NIBM Sub Post Office",
          "NSK_Pawna lake area",
          "Nala Park",
          "Nana Nani Park, Nigdi",
          "Nanded City",
          "Nanded City Eco Park",
          "National Centre for Radio Astrophysics, TIFR",
          "National Defence Academy (Restricted Access)",
          "National Insurance Academy's campus (restricted area)",
          "Navegaon National Park--Navegaon Bandh Lake",
          "Nere",
          "Nerhe Hills",
          "Ness Wadia College of Commerce Campus",
          "Netwad Dam",
          "New Ajanta Avenue (restricted access)",
          "Nigade",
          "Nirmiti Zion (restricted area)",
          "Old Aundh Bridge",
          "Osho Teerth Park",
          "P. L. Deshpande Garden",
          "PIECC Garden",
          "Pabe Ghat",
          "Pabe Village",
          "Panawri Ghat (OBI)",
          "Panchawati, near Vetal tekdi",
          "Pandita Ramabai Mukti Mission, Handalwadi",
          "Panshet Dam",
          "Panshet-Khalapur road",
          "Panshet-Lavasa Road",
          "Papal Seminary Woodland Area",
          "Pargaon grasslands",
          "Parinche",
          "Parinche (OBI)",
          "Parvati Temple",
          "Paschimanagari",
          "Pashan Lake",
          "Pashan Lake -- Nilgiri Plantation, DRDO side",
          "Pashan Tekdi",
          "Pasure",
          "Pataleshwar Temple",
          "Patas Lake",
          "Patharwadi Lake",
          "Pawana Backwater",
          "Pawana Lake, Landing zone",
          "Pawana river banks, Kalewadi",
          "Pawana river banks, Thergaon",
          "Peacock Bay, NDA",
          "Peruchi Baug(Guava garden),Kothrud",
          "Peshwa's Katraj Lake",
          "Pimpalgaon Joga Dam--Sanganore Area",
          "Pimpelgaon Joga Dam",
          "Pimple Nilakh",
          "Pingori village(Jejuri)",
          "Pinnacle Farm campus (restricted access)",
          "Pirangut Ghat",
          "Plateaue above Vasistha Guesthouse",
          "Poona Club Golf Course",
          "Poorva Heights (restricted access)",
          "Pouta Lake",
          "Prayagdham",
          "Pune (560m) (OBI)",
          "Pune (General) (OBI)",
          "Pune University",
          "Pune University--Alice Garden",
          "Pune University--Botanical Garden, Botany Department",
          "Pune international Airport",
          "Purandar Fort",
          "Pusane Dam",
          "Pushpawati Riverbanks",
          "Quadron Business Park, Hinjewadi",
          "Race Course",
          "Raj Baug Eco-village, Patharshet",
          "Raja Mantri Udyan(Garden)",
          "Rajewadi Lake",
          "Rajgad Fort",
          "Rajiv Gandhi Zoological Park, Pune",
          "Rajyog Society",
          "Ram-Mula confluence & devrai",
          "Ramdara Temple",
          "Ranbhool Homestay (restricted access)",
          "Rihe Khind",
          "Rihegaon Dam",
          "River Beautification Project Park",
          "Riverside road, Anandnagar",
          "Riyasatkar Heritage Hotel (restricted access)",
          "Roots connect",
          "Rutuparna Society, Baner",
          "SM Joshi Bridge",
          "ST Arnold's Central School",
          "Sadbhav Society (restricted access)",
          "Sahajanand Tekdi",
          "Sahyadri School (KFI)",
          "Sai Farm Urawade",
          "Sakaar Organics, Pavhar BK",
          "Salumbre village,(Mawal Taluka),Pune",
          "Sambhaji Park",
          "Sanewadi Park",
          "Sangamwadi Bridge, Pune",
          "Sant Savatamali Udyan (garden)",
          "Sant Tukaram Bridge, Ravet",
          "Sarasbaug",
          "Saswad, Pune Dt",
          "Saswad-Bhongaleshwar Temple",
          "Saswad-Parinche road",
          "Satalwadi",
          "Savitribai Phule Park",
          "Sawarkar Nagar, Daund",
          "Seven Sands Ville (Restricted access)",
          "Shakti Yogashrama",
          "Shambhoji Mahadeo Devrai",
          "Shaniwar Wada",
          "Shelar Farm Birding Point",
          "Shilim Village",
          "Shirsai Bird Sanctuary",
          "Shirsuphal",
          "Shirsuphal Grassland Safari",
          "Shirsuphal Lake",
          "Shirsuphal Pond",
          "Shivam Hospital, Near Loni",
          "Shive Devrai",
          "Shivneri fort",
          "Shivtirth Nagar, Kothrud",
          "Shree Chintamani Temple, Theur",
          "Shree Shiv Chhatrapati Sports Complex, Balewadi",
          "Shri Dongarachi Aai Mandir",
          "Shriram Society (Restricted access)",
          "Sinhagad Fort",
          "Sinhagad Trekking Route",
          "Sinhagad Valley",
          "Sinhgad College of Engineering campus",
          "Sinhgad Fort",
          "Sipna Jungle",
          "Sonki Lake Resort (restricted access)",
          "Sopan Baug Housing Society",
          "Southern Command",
          "Splendour Country, Pune",
          "Success Towers area (restricted access)",
          "Sumanth Sarovar",
          "Sus Hill",
          "Swami Vivekanand Udyan",
          "Swarali lake",
          "Symbiosis International University -- Viman Nagar Campus",
          "Symbiosis International University, Lavale",
          "Symbiosis International University--Banyan Tree Area",
          "Symbiosis International University--Director's Bungalow",
          "Symbiosis International University--Hill Base Campus",
          "Symbiosis International University--Water Body",
          "Symbiosis college campus -- S.B. road",
          "TR24/TR16",
          "Talegaon Lake",
          "Taleran",
          "Taljai Tekdi",
          "Taljai temple waterbody, Lavale",
          "Tamhini Forest",
          "Tamhini Nature Nest",
          "Tasu Bai Temple, Kalhat",
          "Tata Dam, Lonavala",
          "Tathawade Garden",
          "Tatyasaheb Thorat Udyan",
          "Teak County",
          "Teerth fields and hill",
          "Temghar Dam",
          "The Bishops School, Pune",
          "The Box Studio and Stage",
          "The Hidden Oasis (restricted access)",
          "The London Bridge",
          "The Machan, Lonavla",
          "Thokarwadi Lake, Lonavala",
          "Tikona Fort",
          "Tolani Maritime Institute",
          "Tolani Maritime Institute--Lake",
          "Torna Fort",
          "Trikaya Retreat (Restricted area)",
          "Tropical Camping, Khulshi",
          "Tukaai Temple",
          "Udaan biodiversity park",
          "Udachiwadi",
          "Udaysagar Lake",
          "Udhyog Nagar, Chinchwad",
          "Ujani Dam--Agneepankh",
          "Ujani Dam--Bhandalwadi Lake Bird Sanctuary, Bhigwan",
          "Ujani Dam--Bhigwan Hills, Bhigwan",
          "Ujani Dam--Dalaj",
          "Ujani Dam--Dhumalwadicha Naalaa, Bhigwan",
          "Ujani Dam--Diksal",
          "Ujani Dam--Highway side lake, Bhigwan",
          "Ujani Dam--Indapur",
          "Ujani Dam--Kalewadi",
          "Ujani Dam--Kandalgaon",
          "Ujani Dam--Kranti Flamingo Point",
          "Ujani Dam--Kumbhargaon Bird Sanctuary",
          "Ujani Dam--Shirsodi",
          "Ujani Dam--Takrarwadi-Madanwadi",
          "Uksan Lake",
          "Upper Lake , CME, Pune (Restricted access)",
          "Uruli Kanchan",
          "VTP Leonara (restricted access)",
          "Vadgaon (OBI)",
          "Valley Vista bungalow (restricted access)",
          "Valvan Dam",
          "Vanadevi hill",
          "Vanpuri",
          "Vascon Forest County (restricted access)",
          "Veer Dam--Northern banks",
          "Veer Grasslands, Pune Side",
          "Velhe, Pune (OBI)",
          "Vetal Tekdi (Near ARAI)",
          "Vidya Pratishthan's ASC college baramati",
          "Vishrambaug Wada",
          "Vishrantwadi Lake",
          "Vishwakarma Institute Of Technology, Pune (restricted access)",
          "Vitthal Mandir Riverstretch",
          "Vitthalwadi scrubland",
          "Wadgaon Sheri",
          "Wageshwar Lake",
          "Waghapur",
          "Wahalewadi",
          "Walchandnagar Industries (restricted access)",
          "Walhe, Jejuri",
          "Wardayani Devrai, Kurtuwadi",
          "Warje Hill",
          "Warwadi",
          "Warwand (Victoria) Lake",
          "Wipro Campus Pune",
          "Yedagaon Dam, Junnar",
          "Zurick Equestrian Club (Restricted Access)",
          "bhigwan",
          "poonawala stud farms, theur, hadapsar",
        ],
      },
      {
        district: "Raigad",
        localities: [
          "Akshi Beach",
          "Alibag",
          "Alibag Beach",
          "Alibag Lake",
          "Alibag--Gokuleshwar Lake",
          "Alibag-Pen Road",
          "Aravi Beach",
          "Awalipada, Alibag Taluka (OBI)",
          "Awas Village, Alibaug",
          "Belpada Waterfall",
          "Belpada Wetland",
          "Bhadav birding area",
          "Chahak Bird Sanctuary",
          "Chandore Forest",
          "Chidipada, Alibag Taluka (OBI)",
          "Chirgaon",
          "Dawale bridge",
          "Deoghar village area",
          "Devkund Waterfall Trek",
          "Dhakate Shahapur (OBI)",
          "Dhamandanda",
          "Diveagar Beach",
          "Diveagar mangroves area",
          "Driving Range, Kharghar",
          "Ekvira Devi Mandir, Veshvi",
          "Elephanta Island, Mumbai",
          "Elephanta Jetty",
          "Farms Near Patalganga River",
          "Funde, Uran",
          "Ganesh pond, Sector 37 Kharghar",
          "Garbett Plateau, near Bhutiwali Dongar",
          "Gold Valley",
          "Gotheghar (OBI)",
          "Harigram, New Panvel, Kalundre River",
          "Harihareshwar MTDC & Temple",
          "Iora Cottages",
          "JNPT Area, Near Uran",
          "Jasai, Near Uran",
          "Jaskhar, Uran",
          "Jui Gaon Bandar",
          "Kalamboli Water Body",
          "Kalinje Mangoves Ecotourism",
          "Kalundre River near Rajiv Gandhi Park, Panvel",
          "Kalundre River, Vadghar Panvel",
          "Kankeshwar",
          "Karle Khind (OBI)",
          "Karnala Bird Sanctuary",
          "Karnala Bird Sanctuary--Hariyal trail",
          "Karnala Bird Sanctuary--Kalle",
          "Karnala Bird Sanctuary--Karnala Fort",
          "Karnala Bird sanctuary--Gaarmal_Ransai",
          "Karnala Bird sanctuary--Kalhe Highway Side",
          "Karnala Bird sanctuary--Kalhe Village",
          "Kashid Beach",
          "Kautilya leadership center (restricted access)",
          "Kelyacha Mal",
          "Khalchi Ali area, Nagaon",
          "Khanda Colony Lake",
          "Khanderi Fort",
          "Khargar Hills",
          "Kharghar Bird Watching Area",
          "Kharghar Creek--Sector 1 Wetlands",
          "Kharghar Creek--Sector 10",
          "Kharghar Grasslands and Freshwater Wetlands",
          "Kharghar Tekdi Shiv Mandir",
          "Kharghar Wetlands",
          "Kirki river -- Nandgaon visarjan ghat",
          "Kokandiva Fort",
          "Koproli, Uran",
          "Kurul (OBI)",
          "Kurul Lake",
          "Kusuma Devi Temple Trail",
          "Mandwa Jetty, Alibagh",
          "Mangaon",
          "Matheran",
          "Matheran--Matheran Park",
          "Matheran--Monkey Point",
          "Matheran--Panorama Point",
          "Matheran--Simson Tank",
          "Mora Jetty, Uran",
          "Morapada--General Area (OBI)",
          "Morba (OBI)",
          "Murud Beach",
          "Murud-Janjira Fort",
          "Nadgaon",
          "Nagaon Beach",
          "Navakhar Beach",
          "Navghar Cricket Ground Wetland",
          "Owe dam",
          "Pagote -- Uran",
          "Panje, Uran",
          "Phansad WLS--Chikhalgaan trail",
          "Phansad WLS--Devrai trail",
          "Phansad WLS--Ketakichigaan",
          "Phansad WLS--Supegaon",
          "Phansad Wildlife Sanctuary",
          "Pirkon Devrai",
          "Poyanje",
          "Prabalgad Foothills",
          "Raigad Fort (OBI)",
          "Ramdharneshwar (OBI)",
          "Ramdharneshwar Hill (OBI)",
          "Ramdharneshwar, Alibag",
          "Ransai Reservoir",
          "Rasani Hill",
          "Revas Beach, Alibag",
          "Revdanda Beach",
          "Rocky Shore Alibaug-Varsoli",
          "Roha- Varse",
          "Saaral Beach",
          "Saguna Baug, Neral",
          "Samadhan Pawar Bird Hide, Kalhe Village",
          "SansKruti Suites & Resort (Restricted Access)",
          "Saral Bridge Birding Area",
          "Sarasgad Fort",
          "Sawarkhar Mangrove, Uran",
          "Sector 17, Kharghar",
          "Sector 24, Kharghar",
          "Sector 25, Kharghar",
          "Sector 28, Kharghar",
          "Sector 29 Grasslands, Kharghar",
          "Sector-25,Kharghar",
          "Shilim Lonavala",
          "Shrivardhan",
          "Shrivardhan--Danda Beach",
          "Sudhagad Fort",
          "T.S Rahaman",
          "Taloja Creek",
          "Taloja iNaturalist Foundation Restoration Site",
          "Underi Island",
          "Uran (OBI)",
          "Vadale Lake(Ballaleshwar Lake)",
          "Vadghar, Panvel",
          "Vaijanath (OBI)",
          "Varsoli Beach, Near Alibag",
          "Vedbhoomi, Shirsad",
          "Veshvi, Alibag (OBI)",
        ],
      },
      {
        district: "Ratnagiri",
        localities: [
          "Adishti Temple birding area",
          "Alava Beach, Near Mirya",
          "Amba Ghat",
          "Amrute's Nisarga Sahavas campus (restricted access)",
          "Anjarle Beach",
          "Anjarle Creek Bridge",
          "Aranyavaat Ecostay (restricted accesss)",
          "Arjun Dam",
          "Asagani Forest",
          "Bharne Naka",
          "Bhatye Bridge, Ratnagiri",
          "Bhatye, Ratnagiri",
          "Chandranagar, Maharastra (Historical)",
          "Chikhalgaon birding area",
          "Chiplun",
          "Chiplun-Shiravali",
          "College of Fisheries, Shirgaon",
          "College of Forestry--Nursery, Dapoli",
          "Dairy Dept, KKV, Dapoli",
          "Dapoli (OBI)",
          "District Court, Ratnagiri",
          "Dongarmatha Eco Care Resort",
          "Dr. Balasaheb Sawant Konkan Krishi Vidyapeeth",
          "Fanashi, Ratnagiri",
          "Fansat forest, Ratnagiri",
          "Farm Of Happiness Agro Tourism Homestay",
          "Finolex Academy of Management and Technology, Ratnagiri",
          "Gaimukh, Amba Ghat",
          "Ganesh Visarjan Ghat, Devrukh",
          "Ganeshgule Beach, Ratnagiri",
          "Ganeshgule Stepwell",
          "Ganeshkhind",
          "Garva Agro Tourism",
          "Gavhe - Jalgaon, Dapoli",
          "Golap Grassland",
          "Guhagar Beach",
          "Harnai Beach",
          "Jaigad jetty",
          "Juikar Mohalla, Maharashtra, IN (17.844, 73.093)",
          "Kajirbhati beach, Ratnagiri",
          "Kalavande Outskirts",
          "Kalbadevi Beach",
          "Karde Murud beach",
          "Karde, near Dapoli (OBI)",
          "Kazarghati, Ratnagiri",
          "Kelshi Village, Ratnagiri",
          "Keshavraj Temple",
          "Khau Gali, Ratnagiri",
          "Khed Railway Station",
          "Khedjai-Redjai Mandir",
          "Kodjai Riverbank",
          "Kolkewadi Reserve",
          "Kolthare Beach",
          "Kondye Dam & Forest Area",
          "Konkan Kilbil Holidays (restricted access)",
          "Koyna WLS--Ghatmatha",
          "Kudavale Bhairi Devi Mandir (Sacred Grove)",
          "Kumbharli Ghat",
          "Ladghar Beach",
          "Lote Parshuram Industries Association area, Khed",
          "Mahalakshmi Temple",
          "Maharshi Parashuram College of Engineering, Velneshwar",
          "Mal Naka",
          "Malgund beach",
          "Mandangad Fort",
          "Mandavi Tourist Spot, Ratnagiri",
          "Marathawadi wetland, Anjanvel",
          "Marleshwar Sacred Grove",
          "Modkaghar lake",
          "Nandu's Bird Sanctuary",
          "Narayanmali  Riverbanks",
          "Palande Beach, Dapoli",
          "Parshuram Ghat Bypass Road, Lote",
          "Parshuram Hill, Chiplun",
          "Ram Mandir, Kond-asurde",
          "Ram Teertha Lake",
          "Ratnadurg Fort",
          "Ratnagiri General (OBI)",
          "Ratnagiri Railway Station",
          "Ratnasagar Complex",
          "Red Roof Farmhouse",
          "Riverside area, Pagmala",
          "Samarth Krupa Woodland, Khed",
          "Savanekareen Devi Mandir",
          "Serene Ravine nature retreat campus (restricted access)",
          "Shirgaon Mangroves",
          "Shree Dashabhuj Lakshmi Ganesh Mandir",
          "Someshwar Bridge",
          "Suvaranadurg, Harne (OBI)",
          "Swayambhu Shri Kedarnath Mandir, near BKL Walawalkar Medical Collage",
          "Swim Center, Salve Stop, Ratnagiri",
          "Talakeshwar Lighthouse",
          "Tamastirtha Beach",
          "Tambi lake, Chiplun-Guhagar road",
          "Tawsal Jetty",
          "Tivre-Medhe Viroba Temple",
          "Undi beach",
          "Vaked",
          "Vanand Plateau",
          "Varshavan Nature Villa (Restricted access)",
          "Vashishthi Riverbank, Kaluste",
          "Vashishti Riverbanks, Matwadi",
          "Velas Beach",
          "Velneshwar Beach",
          "Vihang Sanctuary",
          "Vindhyawasini Temple, Chiplun",
          "Ware Beach",
          "Watershed Park Pond",
          "Whistling Farm Agrotourism Centre",
        ],
      },
      {
        district: "Sangli",
        localities: [
          "Aamrai Garden",
          "Annaso Patil Nagar Birding Area",
          "Arundaya Ganpati Mandir",
          "Banewadi lake",
          "Bapat Mala",
          "Bhagyanagar Talav, Sangli, Maharashtra.",
          "Bhose Lake",
          "Bird Song, Haripur",
          "Bridge on Miraj Malgaon road",
          "Chandoli NP -- Monarch Eco Resort area",
          "Chandoli National Park -- Mandur",
          "Chintamanrao College Of Commerce, Sangli",
          "DES Campus (Restricted access)",
          "Dandoba Hills",
          "Dukari bhag, Amanapur",
          "Fields Near Ram Nagar",
          "Gajanan Colony, Haripur Rd",
          "Ganesh Talav, Miraj",
          "Girling Birding Area",
          "Girling Temple, Sangli, Maharashtra",
          "Government Medical College (Restricted area)",
          "Haroli Lake",
          "Ingale Pazar Talav, Palus",
          "Janraowadi Dam",
          "Jay Renewable Energy Pvt. Ltd. campus (restricted access)",
          "Jogalekar Mala Tasgaon",
          "Jogalekar Mala, Tasgaon (Restricted access)",
          "Kali Khan",
          "Kalptaru Colony Birding Area",
          "Kavathe Mahankal",
          "Khanderajuri",
          "Krishna - Warna confluence (sangam)",
          "Krishna River Banks --Amanapur",
          "Krishna River Dam",
          "Krishna Riverbanks, Anugadewadi",
          "Krishna river -- Mai ghat",
          "Kumbhar Mala Birding Area",
          "Kundal Forest Academy",
          "Laxmi Mandir, Santoshgiri",
          "Lingayat Crematorium",
          "Lingnur Lake",
          "MIDC, Miraj",
          "Madhuban Colony",
          "Mallikarjun Hills",
          "Manik Nal Grassland",
          "Mhaisal Lake",
          "Miraj canal",
          "Rajarshi Chatrapati Shahu Maharaj Krushi V V Mahavidyalaya Sangli",
          "Rama Udyan Garden",
          "Ramling Bet-Bahe",
          "Rotary Hall, Vishrambag (Restricted access)",
          "Sagareshwar WLS",
          "Sangli City (OBI)",
          "Sangli Willingdon College",
          "Sangmeshwar Temple Riverbank, Haripur",
          "Sanjay Nagar",
          "Santoshgiri Hills",
          "Shahi A Gat Dam",
          "Shamrao Nagar Ghuntewari, Sangli",
          "Shantiniketan School",
          "Shikhoba Hills",
          "Shree Dargoba Mandir, Pare",
          "Shukracharya  Stream, Banurgad Hills",
          "Siddhewadi (Shingare vasti) Grasslands",
          "Siddhewadi Lake",
          "Swamp near trampoline park",
          "Vaddi Canal",
          "Vinayaknagar, Haripur Rd",
          "Walchand College Engineering",
          "Warna Kath, Haripur",
          "Warnali Sangli",
          "Wolf conservation reserve, Atpadi",
          "Yamgar-Vasti Talav",
          "Yerala Riverbank, Nevari",
        ],
      },
      {
        district: "Satara",
        localities: [
          "Agashiv Hill",
          "Agashivnagar Forest Reserve",
          "Ajinkyatara Fort",
          "Ambamata Mandir Koyana Nagar",
          "Ambheri Ghat",
          "Ambheri Lake, Khatav",
          "Andhali Dam, Satara",
          "Arthur's Seat, Mahabaleshwar",
          "Avakali, Panchgani, Maharashtra",
          "Bhilar Plains",
          "Blue Park Nature resort",
          "Chalkewadi",
          "Chandoli NP--Helwak Range",
          "Chandoli National Park--Khundlapur Gate",
          "Darjai Lake",
          "Dhamani Birding Area",
          "Dhom Dam -- Kondhavali",
          "Dhondewadi Lake",
          "Diamond Hill Resort",
          "Dragon Lake Ranand",
          "Forest Escapes (restricted access)",
          "Forest Trail, Old Mahabaleshwar",
          "Gondavale kh. grasslands",
          "Haroshi Trail, near Lodwick Point parking",
          "Hatti Talav",
          "Janai Malai mountain, Kodoli",
          "Jog Math Datta Mandir",
          "Kaas  Pathar",
          "Kankatre Dam",
          "Karvat Forest Area",
          "Kass Lake",
          "Khinger Ring Rd",
          "Kiraksal -- Dambi Hills",
          "Kiraksal -- Nali grasslands",
          "Kiraksal -- forest area",
          "Kireina Wellness Resort (restricted access)",
          "Koyana WLS",
          "Koyna Dam--Vajegaon",
          "Koyna Stream, near Cold Spot Village Resort",
          "Koyna WLS--Kathi",
          "Koyna WLS--Ozarde Trail",
          "Koyna WLS--Tapola",
          "Koyna Wildlife Sanctuary",
          "Krantisinh Nana Patil College of Veterinary Sciences,Shirwal",
          "Krishna River Banks--Brahmapuri Area",
          "Krishna Riverbanks, Karad",
          "Kukudwad-Agaswadi Forest",
          "Kumbharoshi, Pratapgad",
          "Kumthe Nagache Mountain",
          "Kuroli Reservoir, Varud",
          "Lingmala Waterfall",
          "Lodhawade Lake",
          "Lodwick Point Trail",
          "MRA  Centre Panchgani",
          "MTDC, Koynanagar (Restricted Access)",
          "Mahabaleshwar",
          "Mahabaleshwar--Babington hose trail",
          "Mahabaleshwar--Gureghar Nature Trail",
          "Mahabaleshwar--Robber's cave trail",
          "Mayani bird conservation reserve",
          "Mayureshwar Sanctuary",
          "Nehru Garden",
          "Ner Dam",
          "Nira Bridge",
          "Old Karad-Patan Bridge, Karad",
          "Panchgani",
          "Panchgani paragliding point",
          "Pargaon Talav",
          "Pateshwar Temple, Degaon",
          "Pedgaon Lake",
          "Pingali Lake",
          "Rajewadi Dam",
          "Riverside Inn Resort (restricted access)",
          "Sahyadri Tiger Reserve",
          "Sajjangad, Parali",
          "Sangam Mahuli",
          "Satara (OBI)",
          "Satara District Veterinary Polyclinic",
          "Shirwal Riverside Area",
          "Shri Datta Mandir Math, Bamnoli",
          "Shri Yamai Devi Temple, Aundh",
          "Sindola plateau area-Wilson Point",
          "Sundargad Fort",
          "Sunset Point",
          "Suryachiwadi Lake",
          "Table Land, Panchgani",
          "Tambave Lake",
          "Tarkeshwar, Vaduj",
          "The Club Mahabaleshwar (restricted access)",
          "Thoseghar, Satara",
          "Triveni Sangam,Bamnoli",
          "Umbarde Bhavling Mountain",
          "Vadjal Lake",
          "Valai Grasslands",
          "Valley Point, Old Mahabaleshwar",
          "Van Sanshodhan Kendra",
          "Vardhangad Fort",
          "Veer Dam",
          "Wai birding spot",
          "Wai-Panchgani-Pangari (Satara)",
          "Yeliv Talav",
          "Yerala River, Vaduj",
          "Yeralwadi Dam",
        ],
      },
      {
        district: "Sindhudurg",
        localities: [
          "Aarosbag",
          "Ambekhan Wetland, Vengurla Taluka",
          "Amboli Forest",
          "Amboli Forest Park",
          "Amboli Village",
          "Amboli Waterfall",
          "Baba waterfalls trail",
          "Bhide's hill-top home-stay",
          "Bhogave Beach",
          "Bird's Paradise, Ranbambuli",
          "Bowlekar Wadi",
          "Charathe, Sawantwadi",
          "Chaukul Plateau",
          "Chaukul Road Trail",
          "Chipi Bridge",
          "Chipi Grassland",
          "Chorla Ghat, MH section",
          "Crocodile point, Insuli",
          "Deoolwada, Malvan",
          "Desai wadi Forest",
          "Devbag Beach",
          "Devgad (OBI)",
          "Devsu Birding Area",
          "Dhamapur Lake",
          "Dusankarwadi Grasslands",
          "Gothane outskirts",
          "Hublicha Maal, Nerur Paar",
          "Insuli Ghat",
          "Jamsande, Devgad",
          "Kaleshwar, Nerur",
          "Kalse Forest",
          "Kalyadevachi Vanrai",
          "Kapil Nagar",
          "Khadpade Ghat",
          "Khanoli Grasslands",
          "Kharepatan Fort",
          "Kudal",
          "Kudase",
          "Kumbharli, Sawantwadi",
          "Kumbharmath Swamps, Malvan",
          "Kunkeshwar Mandir",
          "Madkhol Dam",
          "Mahadevgad Point Road",
          "Majgaon, Sawantwadi",
          "Malai Pathar Forest, Amboli",
          "Malvan, Konkan Coast (OBI)",
          "Mandavkar house (restricted access)",
          "Mathewada Road, Sawantwadi",
          "Mirwel Forest",
          "Mondavi Homestay",
          "Moti Lake",
          "Mrugaya Nature Retreat Resort",
          "Narendra Dongar, Sawantwadi",
          "Nayekhol Satbai Campsite",
          "Pangrad Forest",
          "Paradise Lake Resort, Harkul Dam",
          "Parikshit Point, Amboli",
          "Parpoli",
          "Pat Talav (Lake), Malvan",
          "Pednekar wadi",
          "Pendur (OBI)",
          "Pendur Lake",
          "Prabhu Home & Backyard (Restricted access)",
          "Pravin's Blue-eared KF Hide (Restricted Access)",
          "Ramgad fort",
          "Run, Dangmode",
          "Sawantwadi",
          "Sawantwadi Dumping Ground",
          "Sherpe-Napane waterfall area",
          "Shipgram Hotel (Restricted)",
          "Shiroda Bandwada School",
          "Shiroda Beach",
          "Shiroda Salt Pans",
          "Shree Hanuman Mandir, Parpoli",
          "Shree Waghbilleshwar Mandir",
          "Shri Hiranyakeshi Temple",
          "Sindhudurg-nagari Lake",
          "Sindhudurga Fort",
          "Talashil Beach",
          "Talkat",
          "Talkat Vanudyan",
          "Tarkarli Beach, Malvan",
          "The Swift Island ( Vengurla Rocks )",
          "Thukrul house bird-watching area",
          "Tilari Conservation Reserve",
          "Tilari Conservation Reserve--Terwan Medhe Dam",
          "Tilari Hornbill Nest Farmstay (Restricted)",
          "Tilari Reserve Forest, Sindhudurg",
          "Tilari conservation park",
          "Tulas-Ansur-Pal, Maharashtra, IN",
          "Valivande-Desai Wadi",
          "Vanoshi Forest Homestay",
          "Velagar Beach",
          "Vengurla Beach",
          "Vengurla Lighthouse",
          "Whistling Woods Resort (Restricted access)",
          "Wild One Wildlife Field Station and Nature Stay",
          "Wildernest Nature Resort",
        ],
      },
      {
        district: "Solapur",
        localities: [
          "Ashti Lake (Lake of Yeoti)",
          "Boramni Grasslands",
          "Chhatrapati Sambhaji Maharaj Talav",
          "Damani Nagar",
          "Ekruk Lake",
          "Great Indian Bustard Sanctuary, Nannaj",
          "Hiraj Grasslands",
          "Jamshri Realty",
          "Kettur Bridge",
          "Kurnur Dam Chapalgaon",
          "Old Kambar Talav",
          "Padmavati devi temple park",
          "Rampur Lake",
          "Rashin Grasslands",
          "Rupabhavani Plantation Solapur",
          "Siddheshwar Vanvihar",
          "Siddheshwar temple",
          "Siddhivinayak lake",
          "Sonake lake",
          "Suncity Apartments (Restricted access)",
          "Ujani Dam -- Kettur bridge creek",
          "Ujani Dam--Chikhalthan",
          "Ujani Dam--Diksal Flamingo Valley",
          "Ujani Dam--Flamingo Point, Kettur",
          "Ujani Dam--Govt. Resthouse, Bhimanagar (Restricted Access)",
          "Ujani Dam--Goyegaon",
          "Ujani Dam--Kandar Birdwatching Point",
          "Ujani Dam--Khatgaon Bridge",
          "Ujani Dam--Kirteshwar Birding Area",
          "Ujani Dam--Kondar Chincoli (South side)",
          "Ujani Dam--Kondhar Chincholi (North side)",
          "Ujani Dam--Kugaon",
          "Ujani Dam--Mahadik Wasti",
          "Ujani Dam--Sangavi wetland",
          "Ujani Dam--Takali Birding Area",
          "Ujani Dam--Undargaon",
          "Ujani Dam--Vitthalwadi Backwater",
          "Ujani Dam--Wangi No. 1",
          "Ujani dam--Katraj",
          "Vishnupad Temple",
          "Walchand College of Arts",
          "Washimbe",
          "Yamai Lake Pandharpur",
        ],
      },
      {
        district: "Thane",
        localities: [
          "A.E. Kalsekar Degree College of Arts Science and Commerce",
          "Aai Waghjai Devi Temple",
          "Agro Garden, Belapur",
          "Ambaji Gau Shala, CBD Belapur",
          "Ambivli Biodiversity Park",
          "Ambivli Riverside Area, Thane",
          "Atali Forest Area",
          "B.N. Bandodkar College of Science",
          "Badlapur Hills--proposed panvel highway",
          "Bamandev Mandir",
          "Barvi Forest Range",
          "Barvi Lake",
          "Belapur Bush Lake",
          "Belapur, Navi Mumbai (OBI)",
          "Bhayandar creek",
          "Bhimashakar WLS--Gorakhgad",
          "Bhopar Tekadi Area",
          "Bhopar grasslands, Thane",
          "Chikloli Dam",
          "Coastal and Marine Biodiversity Centre",
          "DAKS Lake, Navi Mumbai",
          "DPS Lake",
          "Dahagaon",
          "Dandepada, Chinchani",
          "Dawadi",
          "Dawdi hill",
          "Diva - Kopar Estuary",
          "Diva Dumping Area",
          "Dombivli (OBI)",
          "Flamingo Point, Nerul",
          "Flamingo Watching Point",
          "Gandhari Forest Land",
          "Ganesh Ghat",
          "Ganesh Ghol Mandir, Shilphata",
          "Gaondevi Mandir & Lake, Katai Village",
          "Gavdevi Mandir, Kharad-Malang",
          "Ghansoli Ram Mandir birding area",
          "Gothegar--General Area",
          "Green Valley Park",
          "Haji Malang",
          "Haji Malang Road, DombivlI (OBI)",
          "Harshgiri-Gota Lake",
          "Hidden Village resort (restricted access)",
          "Hill Grange Garden",
          "Jambul Pada, UIhas River",
          "Kachore Hills",
          "Kachore Pond, Kalyan",
          "Kachrali Talav",
          "Kalher Bunder, Bhiwandi",
          "Kalsubai Harischandragad WLS--Valmiki Ashram,Dehene",
          "Kalwa Hills (Mountain next to fast track), Kalwa",
          "Kalyan East Railway Area",
          "Kalyan Gandhari (OBI)",
          "Karave Wetlands",
          "Karnala Devi Kalyan",
          "Kavesar Lake",
          "Kedar Bunglows, D'souza Wadi",
          "Kharghar Hills",
          "Khidkali Lake, Dombivli",
          "Khoni Pond",
          "Khoni Wetland",
          "Kolegaon Nilje Grasslands",
          "Kolshet Creek",
          "Kopar Creek-- Dombivali",
          "Kopar Khairane Mangroves",
          "Kopar Wetlands, Dombivali",
          "Kopargaon",
          "Lake DPS school, Navi Mumbai",
          "Lonad Caves Trail",
          "Lotus Lake",
          "Lotus Pond Ambernath",
          "Mahuli Fort",
          "Mahuli Fort Base",
          "Malshej",
          "Manda Birding Area, Titwala",
          "Mograpada",
          "Mohraan Farms",
          "Mothi Desai Lake",
          "Mothi Desai Village Park (Padle)",
          "Mumbra Hills",
          "Mumbra Mudflats",
          "NAUPADA GREEN PATCH",
          "NMMC Head Office Pond",
          "NMSA Ground",
          "Navi Mumbai (OBI)",
          "Nerul Wetland Flamingo Point",
          "Nilje Lake",
          "Nisarga Mitra Farm area, Badlapur",
          "Ovalekar Wadi Butterfly Garden",
          "Padle Village (OBI)",
          "Pajar Lake",
          "Palu Village, Murbad",
          "Panvel Creek View - Sector 11",
          "Parsik Hills, Thane (OBI)",
          "R K Talreja College of Arts, Science and Commerce",
          "Raheja Complex",
          "Reliance Corporate Park",
          "Reti Bandar Ulhas River Dombivli West",
          "River bridge near Tembha",
          "Rotary Garden",
          "Royal College of Arts, Science and Commerce [Restricted]",
          "SANJAY GANDHI NP - BIRD HIDE NO. 2",
          "Sagar Vihar, Vashi",
          "Sahyadrica Farms",
          "Sanjay Gandhi NP -- bird hide no. 2",
          "Sanjay Gandhi NP--Borivade, Kasarwadawli",
          "Sanjay Gandhi NP--Dongripada",
          "Sanjay Gandhi NP--Nagla Block",
          "Sanjay Gandhi NP--Tiku Ji Ni Wadi",
          "Sanjay Gandhi NP--Yeoor",
          "Sanjay Gandhi NP--Yeoor Hills",
          "Sanpada Mangrove, Navi Mumbai",
          "Satpool Wetlands",
          "Satpool Wetlands--Jetty area",
          "Seawoods Flamingo Refuge",
          "Seawoods Harbour Rd canal",
          "Seawoods Lake on Palm Beach Road",
          "Seawoods, Navi Mumbai",
          "Shahapur, Thane (OBI)",
          "Shendoba Mandir, Vadavali",
          "Siddhagad Fort",
          "Sparrow Park (Chiu Park)",
          "Sulochana Singhania School",
          "Sunshine Elegance - Thakurli (Restricted Access)",
          "T S Chanakya Birding Site",
          "T S Chanakya birding area",
          "Tahuli Foothills, Badlapur",
          "Talao Pali Lake",
          "Talawe Wetlands (OBI)",
          "Tansa Forest Office",
          "Tansa Wildlife Sanctuary",
          "Thakurli Wetlands",
          "Thane (OBI)",
          "Thane Creek",
          "Thane East Saltpans",
          "Thane creek flamingo sanctuary",
          "Titwala Mandir Garden",
          "Ulhas River, Diva, Dombivli",
          "Umbarli Gaon",
          "Umbarli Hills",
          "Unique Farms, Shahapur",
          "Upvan Lake",
          "Uttan Jetty",
          "Vasantdada Patil Marg Sewage",
          "Vashi Creek Toll Naka",
          "Vashi Holding Pond",
          "Vashi Lake",
          "Vashi Mangroves",
          "Xperia Mall Bridge, Dombivali",
        ],
      },
      {
        district: "Wardha",
        localities: [
          "Alodi",
          "Ambazari Lake, Dahegaw (mu) Arvi",
          "Bajaj College of Science",
          "Bajaj Institute of Technology Backside",
          "Bor Tiger Reserve --Manoli",
          "Bor Tiger Reserve--Entry Gate",
          "Borkhedi Talav, Wardha",
          "Dham Riverside, Yelakeli",
          "Dhotewade Dam",
          "Digraj Lake",
          "Dongargaon Dam",
          "Gandhibag Ropvatika, Wardha",
          "Giroli",
          "Government Polytechnic College, Arvi",
          "Hanuman Mandir, Laprasy Foundation, Swastik Colony",
          "Hanuman Tekdi (VJM O2 Park)",
          "Itaki Doh",
          "Kamal Lake, behind Govt. ITI",
          "Kawadi lake",
          "Lal Nalla Reservoir",
          "Lower Wardha  Dam--Borgaon End",
          "Lower Wardha Dam",
          "Madan Dam, Wardha",
          "Madani Dam",
          "Mahavir Co-op Housing Society (Restricted)",
          "Malegaon Theka Dam",
          "Mandala Talav",
          "New Bor WLS",
          "Pavnar River, State Hwy 204",
          "Pothara Dam,Hinganghat",
          "Prakash Nagar open plots",
          "Rotha-I Dam and Resrvoir",
          "Rotha-II Dam and Reservoir",
          "Sarangpuri Lake",
          "Sindhi Meghe, Wardha",
          "Sukali (Ubar), Wardha",
          "Tembhari Talav",
          "Waghdhara Talao वाघधरा तलाव",
          "Waifad Talav",
        ],
      },
      {
        district: "Washim",
        localities: [
          "Chausala Forest Range",
          "Karanja Park",
          "Karanja Sohol Blackbuck Sanctuary",
          "Mandwa Reservoir",
          "Pardi Ekburgi Dam",
          "R.T.O. Office, Washim",
          "Shimpi Vetal, Washim",
          "Washim Railway station",
        ],
      },
      {
        district: "Yavatmal",
        localities: [
          "Ambezari Lake",
          "Amolakchand Mahavidyalaya",
          "Bahiram Hill, Jam Range, Yvatmal",
          "Bembla Dam -- Malapur wetland",
          "Bembla Dam-- Panas",
          "Bembla wetland",
          "Borgaon Dam, Babhulgaon Tahsil",
          "Chapdoh Dam",
          "Chausala Forest Rd",
          "Chintamani Temple, Darwha",
          "Darwha Grasslands",
          "Deogiri parvat, Darwha, Yavatmal",
          "Deulgaon Valsa Van Udyan",
          "Dumnapur Forest Nursery, Yavatmal (OBI)",
          "Durg Forest and Dam",
          "Echori - Jamwadi Rd",
          "Echori Dam and Grasslands",
          "Echori Road Stream",
          "Forest Colony, Darwha",
          "Ghatana Lake, Hiwari",
          "Goki Dam",
          "Heti Spillway and Reservoir (OBI)",
          "Indira Mahavidyalaya",
          "Jamwadi Tank",
          "Joshi Nala Bandh",
          "Karanwadi Dam",
          "Khadaki Talav",
          "Khateshwar",
          "Khateshwar Spillway and Reservoir (OBI)",
          "Lalsare farm, Rajegaon (restricted access)",
          "Mahur Bridge, Painganga River",
          "Mandev Spillway and Reservoir (OBI)",
          "Mucchi Talav (Lake)",
          "Nilona Dam",
          "Nilona Dam--East Side Wetland Area",
          "Nilona Dam--Grasslands",
          "Nilona Dam--North side",
          "Nilona Dam--Wallside",
          "Nilona dam -- West South",
          "Pach Dhara Temple",
          "Painganga WLS",
          "Pandhardevi forest",
          "Pathrad Dam",
          "Pathrad Devi Dam",
          "Pathradgole Spillway and Reservoir (OBI)",
          "Prasha Van",
          "Prayas Van",
          "Saikheda Dam",
          "Shindi Lake",
          "South east area of Nilona dam",
          "Tembhurni Lake",
          "Tipeshwar WLS",
          "Tipeshwar WLS --Singhandov Spillway & Reservoir",
          "Tipeshwar WLS--Mathani Gate",
          "Tipeshwar Wildlife Sanctuary--Jungle Vibes",
          "Umerda Forest Nursery",
          "Van Udyaan, Darwha",
          "Van Vibhag Udyaan",
          "Waghadi river -- Murali village",
          "Wai Talav",
        ],
      },
    ],
  },
  {
    state: "Manipur",
    districts: [
      {
        district: "Bishnupur",
        localities: [
          "Awang Laisoi, Ngaikhong Khunou",
          "Keibul Lamjao NP",
          "Keibul Lamjao National Park",
          "Khoijuman Village (OBI)",
          "Kumbi Pat (OBI)",
          "Loktak Lake",
          "Loktak Lake - Thinungei Mamang",
          "Moirang (OBI)",
          "Nambol (OBI)",
          "Nambol Phoijing (OBI)",
          "Naorem (OBI)",
          "Ningthoukhong Kha Grazing Ground",
          "Phubala (OBI)",
          "Sendra Park Resort",
          "Sungu--Logtak Lake",
          "Takmu Lake",
          "Thoubal Waterpoint",
          "near Saiton (OBI)",
        ],
      },
      {
        district: "Chandel",
        localities: [
          "Indo-Myanmar Road, Senam Village",
          "Tangjeng Pat (OBI)",
        ],
      },
      {
        district: "Churachandpur",
        localities: [
          "Lamdan (OBI",
        ],
      },
      {
        district: "Imphal East",
        localities: [
          "Imphal East District (OBI)",
          "Kangla Fort",
          "Matai village (OBI)",
          "Nishtha Sishu Niketan, Yaral Pat",
          "Nongmaijing Ching (Baruni)",
          "Selloi Langmai Ecological Park",
          "Yaralpat Wetland",
        ],
      },
      {
        district: "Imphal West",
        localities: [
          "Changangei (OBI)",
          "Imphal Airport",
          "Iroisemba (OBI)",
          "Khumbong (OBI)",
          "Lamphelpat",
          "Lamphelpat (OBI)",
          "Lamphelpat Wetland",
          "Lamphelpat Wetlands",
          "Langgol Ridge",
          "Langol Reserved Forest",
          "Lilong Chajing Garden",
          "Manipur University--Main Campus",
          "Mayangimphal-Owl point",
          "National Institute of Technology, Manipur",
          "Phoijing, Manipur (OBI)",
          "Punshilok , Langol",
          "Regional Institute of Medical Sciences",
          "State Orchidarium",
          "Yaiskul Police Lane, Imphal (OBI)",
        ],
      },
      {
        district: "Kakching",
        localities: [
          "Kharung Pat (OBI)",
          "Wabagai (OBI)",
        ],
      },
      {
        district: "Kamjong",
        localities: [
          "Chattrik to Kasung",
        ],
      },
      {
        district: "Kangpokpi",
        localities: [
          "Awang Koubru",
          "Haraorou",
          "Laimaton trek near entry point",
          "Lairambe Temple, Kongba Maru",
          "Sadu Chiru Waterfall",
          "Sadu Chiru waterfalls",
          "Tingkhai Khullen Hill",
        ],
      },
      {
        district: "Senapati",
        localities: [
          "Dzukou, Nagaland",
          "Senapati Dist (OBI)",
          "Tungjoy (OBI)",
        ],
      },
      {
        district: "Tamenglong",
        localities: [
          "Azuram (OBI)",
          "Charinapang (OBI)",
          "Chiulaun (OBI)",
          "Chiuluan Raenngaan",
          "Chiuluan Wetlands",
          "Kotlin",
          "Zeilad Wildlife Sanctuary (OBI)",
        ],
      },
      {
        district: "Tengnoupal",
        localities: [
          "Kwatha",
          "Kwatha Khunou",
          "Thoiba gi Lou manak",
        ],
      },
      {
        district: "Ukhrul",
        localities: [
          "Jessami - Thetsii Valley",
          "Jessami Hume's Pheasant Community Reserve--General Area",
          "Jessami Mishidah Farmlands",
          "Jessami, Manipur",
          "Shirui",
          "Shirui Kashong Range (OBI)",
          "Ukhrul",
        ],
      },
    ],
  },
  {
    state: "Meghalaya",
    districts: [
      {
        district: "East Garo Hills",
        localities: [
          "Alda Nok Resort",
          "Dabalgre Village",
          "Nokrek NP--Darengiri-Jetragiri Route",
        ],
      },
      {
        district: "East Jaintia Hills",
        localities: [
          "East Jaintia Hills (OBI)",
          "Narpuh Reserved Forest",
          "Saibual",
          "Saipung",
        ],
      },
      {
        district: "East Khasi Hills",
        localities: [
          "Arwah Lumshynna Cave",
          "Bishop's Falls",
          "Blueberry Inn Resort",
          "Cherrapunjee Holiday Resort",
          "Cherrapunji (Sohra)",
          "Cherrapunji (Sohra)--Pomsohmen Viewpoint",
          "Dainthlen Falls",
          "Dawki River--Dawki",
          "Dawki River--Shnongpdeng",
          "Dawki River--Shnongpdeng Hanging Bridge",
          "Double Decker Living Root Bridge",
          "Duwan Sing Syiem Viewpoint",
          "Eco Park,Cherrapunji",
          "Elephant Falls",
          "Happy Valley--ARC Hillocks",
          "Highland Camp, Mausnar",
          "ITI Sohra",
          "Itshyrwat Reserved Forest",
          "Kmawanrum Community Conserved Area",
          "Krem Dam, Mawsynram",
          "Kynrem Falls",
          "Kyntoit Khlaw Block F,  Madanryting",
          "Laitkinsew (OBI)",
          "Laitlum Canyons--Smit Valley",
          "Loreto Convent, Don Bosco, Cathedral of Mary Help of Christians",
          "Mawjymbuin Caves",
          "Mawkdok Valley",
          "Mawlynnong",
          "Mawphalang Sacred Forest",
          "Mawphlang Sacred Grove",
          "Mawryngkneng",
          "Mawsmai Cave",
          "Mawsynram",
          "Mhalse Lake",
          "Mynteng--Old Cable Bridge",
          "Mynteng--Single Root Bridge",
          "NEHU--Shillong Campus",
          "NEHU--Shillong Campus--EFL University",
          "NEHU--Shillong Campus--Old Guest House Trail",
          "Nohkalikai Falls",
          "Old Shillong-Guwahati Rd",
          "PDEM Falls",
          "Prut Waterfalls - Laitduh",
          "Seven Sisters Waterfall, Nohsngithiang",
          "Shillong",
          "Shillong Peak Rd",
          "Short Round PF",
          "Sohbar",
          "St. Anthony's Botanical Garden",
          "St. Anthony's College",
          "St. Edmund's College",
          "Thangkharang Park",
          "Trail from Cherrapunji to Double Decker Bridge",
          "Trail from Nongriat to Double Root Bridge/Rainbow Falls",
          "Tripura Castle, Cleave Colony",
          "Upper Shillong PF",
          "Upper Shillong PF--Laitkor Peak",
          "Upper Shillong PF--Lawsohtun",
          "Upper Shillong PF--Lumparing",
          "Upper Shillong PF--Malki",
          "Upper Shillong PF--Rhododendron Trek",
          "Upper Shillong PF--Risa Colony",
          "Ward's Lake and Botanical Garden",
          "Wei Sawdong Falls",
          "Windermere Resort, Shillong",
        ],
      },
      {
        district: "Ri-Bhoi",
        localities: [
          "Byrnihat",
          "Guwahati-Shillong Road (OBI)",
          "Jirang Community Reserve & Amkyrbai Lake",
          "MGU Meghalaya--Byrnihat Campus",
          "Nongkhyllem WLS",
          "Nongkhyllem WS",
          "Rani RF, Meghalaya (OBI)",
          "Ri Shat Sngi Orchid Resort, Umiam",
          "Rosie Homestay, Jyntru",
          "The Sanctuary Song Resort",
          "UCC",
          "Umiam Lake (Dam sait)",
          "Umiam Lake--Nehru Park",
          "Umiam Lake--Orchid Lake Resort",
          "University of Science and Technology Meghalaya",
        ],
      },
      {
        district: "South Garo Hills",
        localities: [
          "Aginma Wari Fish Sanctuary",
          "Baghmara Pitcher Plant Sanctuary",
          "Baghmara--Simsang Bridge",
          "Balpakram NP (general area)",
          "Balpakram Tourist Lodge",
          "Bhowanipur",
          "Karwani",
          "Karwani Village",
          "Nokrek NP (general area)",
          "Nokrek NP--Darangiri to Nokrek Range",
          "Nokrek NP--Darengiri Village",
          "Panda",
          "Pilot Project, Ampanggiri",
          "Siju",
          "Siju Bird Sanctuary",
          "Siju Bridge Trail",
        ],
      },
      {
        district: "South West Garo Hills",
        localities: [
          "Dobol lake, Damalgre",
          "Katuli  Beel (Lake)",
        ],
      },
      {
        district: "South West Khasi Hills",
        localities: [
          "Jakrem Hot Springs",
          "Rangthong",
        ],
      },
      {
        district: "West Garo Hills",
        localities: [
          "Boldorenggre Intake Point",
          "Camp Ora",
          "Chandigre",
          "Darechikgre",
          "Dura Kalakgre road",
          "Forest Complex Dakopgre",
          "Mesak Falls Trail",
          "NEHU--Old Campus (Tura)",
          "NEHU--Tura Campus",
          "NEHU--Tura Campus--Check Dam Area",
          "Nokrek NP--12 Year Rested Jhum",
          "Nokrek NP--Daribokgre (Daribok Village)",
          "Sasatgre",
          "Selbalgre Community Reserve Forest",
          "Tura Peak RF",
        ],
      },
      {
        district: "West Jaintia Hills",
        localities: [
          "Dawki",
          "Dawki River--Darrang",
          "Dawki River--Dawki Bridge",
          "Haven's Cove, Jowai",
          "Ialong park",
          "Khloo Langdoh kur Pyrtuh Sacred Grove",
          "Kopili Dam--Saphai",
          "Krang Shuri Falls",
          "Salaroh, Jowai (OBI)",
          "Tuber (OBI)",
        ],
      },
      {
        district: "West Khasi Hills",
        localities: [
          "Aradonga Picnic Spot",
          "Maweit",
          "Nonghkhnum Island",
          "Ukium Picnic Spot",
        ],
      },
    ],
  },
  {
    state: "Mizoram",
    districts: [
      {
        district: "Aizawl",
        localities: [
          "Aizawl Zoological Garden",
          "Bungbangla",
          "Dilkawn--General Area",
          "Government Tourist Resort, Lengpui (Near Airport)",
          "Hmuifang",
          "Lengpui Airport",
          "Lengpui IB Guest House",
          "Lianthanga Camp Rescue Centre, Sihphir, Mizoram, IN (23.82, 92.73)",
          "Mat Bridge, Serchhip",
          "Mizoram University Campus",
          "Muthi Ram",
          "Pachhunga University College",
          "Sailam",
          "Sailam Bird Sanctuary",
          "Sailam Bird Sanctuary- Birders Cottage",
          "Sailam General Area",
          "Sangau (Outskirts)",
          "Sialsuk",
          "Sialsuk Birding Point",
          "Sihphir",
        ],
      },
      {
        district: "Champhai",
        localities: [
          "E. Khankawn",
          "Farkawn--Lurh Tlang Vavu Sanctuary",
          "Govt. Champhai College",
          "Lengteng Wildlife Sanctuary",
          "Mualkawi-Khawbung-Zawlsei",
          "Murlen NP--Core Area",
          "Murlen National Park--General Area",
          "Murlen village",
          "N Khawbung tlang",
          "Tan Tlang",
          "Zote-Ngur Rd",
        ],
      },
      {
        district: "Hnahthial",
        localities: [
          "Government Colllege Hnahthial",
          "Hnahthial -near Helipad",
          "Khawnglung Sanctuary Entry Point",
          "Pangzawl",
          "Rawpui",
          "South Vanlaiphai Paddyfields",
        ],
      },
      {
        district: "Khawzawl",
        localities: [
          "Khawzawl-ngaizawl",
        ],
      },
      {
        district: "Kolasib",
        localities: [
          "Bairabi",
          "Buhchangphai--Paddyfields",
          "Serlui B--Dam site, Mizoram, IN (24.337, 92.766)",
          "Serlui-B",
          "Serlui-B Dam site",
          "Serlui-B--Old Builum Village, Kolasib, Mizoram, IN (24.255, 92.737)",
          "ZeroPoint to Buhchang",
        ],
      },
      {
        district: "Lawngtlai",
        localities: [
          "Far Pak Forest Rest House--Phawngpui National Park, Mizoram",
          "Phawngpui (Blue Mountain) NP--General Area",
          "Phawngpui (Blue Mountain) National Park",
          "Sangau--General Area",
          "Thaltlang",
          "Thaltlang Community Forest",
          "Treecreeper Ridge",
          "Treecreeper Ridge [Duplicate-to Merge]",
        ],
      },
      {
        district: "Lunglei",
        localities: [
          "Lunglei Tourist Home",
        ],
      },
      {
        district: "Mamit",
        localities: [
          "Ailawng khua",
          "Dampa Tiger Reserve",
          "Dampa Tiger Reserve--Chikha",
          "Dampa Tiger Reserve--Forest Rest House",
          "Dampa Tiger Reseve--Damparengpui",
          "Dampa, Camp Chikha",
          "Dapchhuah Bridge",
          "Khawhlui / YMA Park",
          "Reiek",
          "Reiek Tourist lodge",
          "Salem Boarding",
          "Sesih Zau, Mizoram",
          "Teirei",
          "Teirei Road",
          "Tuisen-Tlabung Forest",
          "West Phaileng to Teirei Road",
          "Zawlnuam--General Area",
        ],
      },
      {
        district: "Saitual",
        localities: [
          "Birding spot- Tawizo",
          "Kawlbem Peng (phuldungsei) to Kawlbem Rd",
          "Mawmrang Tlang, Pawlrang",
          "Tamdil Lake",
          "Ṭawi Wildlife Sanctuary--Maite",
        ],
      },
      {
        district: "Serchhip",
        localities: [
          "Govt. Serchhip College",
          "Thenzawl Tourist Lodge",
          "Tuirihiau Waterfalls",
          "Vantawng Falls View Point",
        ],
      },
      {
        district: "Siaha",
        localities: [
          "Lungpuk Fields",
          "Lungpuk Forest Rest House",
          "Lungpuk Forest Rest House [Duplicate-to Merge]",
          "Lungpuk Old Water Tank Trail",
          "Lungpuk River Side Lookout",
          "Pala Tipo (Palak Dil)--Entrance Area",
          "Pala Tipo [=Palak Dil or Lake]",
          "Phura",
          "Phura Fields",
          "Phura Forest Rest House",
          "Phura [Duplicate-to Merge]",
        ],
      },
    ],
  },
  {
    state: "Nagaland",
    districts: [
      {
        district: "Dimapur",
        localities: [
          "Dimapur (OBI)",
          "Dimapur--Airport",
          "Dimapur--Forest Office",
          "Dimapur--Green Park",
          "Dimapur-Khonoma Road",
          "Medziphema",
          "Nagaland Zoological Park",
          "National Institute of Technology (NIT) Nagaland",
          "Niathu Resort",
          "Rangapahar",
          "Unity College",
        ],
      },
      {
        district: "Kiphire",
        localities: [
          "Bailey Bridge, Likimro",
          "Chomi",
          "Fakim Wildlife Sanctuary",
          "Fakim--Wongtsowang Trail",
          "Forest Yappo",
          "Mount Saramati--Base Camp",
          "Mount Saramati--Overall",
          "Nokh Khet Chang",
          "Pungro--Government Middle School",
          "Pungro--Hanging Bridge",
          "Pungro--Overall",
          "Pungro-Fakim Road",
          "Sanglukhong Yappo",
          "Shennüthsi Vong",
          "Song Vong Transect",
          "Thanamir Village",
          "Thanamir--Guest House",
          "Wuhrihtoh",
        ],
      },
      {
        district: "Kohima",
        localities: [
          "Chaya Residence",
          "Dzukou Valley--Foothills",
          "Dzukou Valley--Guest House",
          "Dzukou Valley--Overall",
          "Dzuleke--2.5km towards Heunambe Village/Benreu",
          "Dzuleke--4kms",
          "Dzuleke--Welcome Signboard",
          "Dzuluke",
          "Forest above Zuvza",
          "Hakhezhe",
          "KNCTS--Dziileriidi Trail",
          "Khonoma Nature Conservation and Tragopan Sanctuary (KNCTS)--Overall",
          "Khonoma Town",
          "Khonoma--Adler Cottage Trail (Merhu Zie)",
          "Khonoma--Govt. High School",
          "Khonoma--Local Ground",
          "Khonoma--Mezoma Trail",
          "Khonoma--NSF Memorial (Monolith)",
          "Khonoma--Native Lodge",
          "Khonoma--Parking Lot to Dzoku Valley Trail",
          "Khonoma--Parking Lot towards Benreu Road",
          "Kohima Town-- Overall",
          "Kohima--Botanical Garden",
          "Kohima--Tragopan Breeding Centre",
          "Mezoma Trail",
          "Mount Japfu--Peak trail",
          "Mount Japvo--Overall",
          "Puliebadze Jotsoma",
          "Puliebadze WLS",
          "Puliebadze--Trek Start Point",
          "Stream between Khonoma & Dzuleke",
          "View Point before Khriesaneisa Memorial",
          "Viswema-Dzukou Trail",
        ],
      },
      {
        district: "Mokokchung",
        localities: [
          "Chuchuyimlong Village",
          "Longkhum Village",
          "Mopungchuket Village",
          "Tuli",
        ],
      },
      {
        district: "Mon",
        localities: [
          "Longwa Village",
          "Thapi Bridge",
          "eastern Nagaland, India (OBI)",
        ],
      },
      {
        district: "Peren",
        localities: [
          "Benru--Tourism Lodge",
          "Benrue--Overall",
          "Hebamlo Village (Bamsiake Lwa)",
          "Southern Nagaland (OBI)",
        ],
      },
      {
        district: "Phek",
        localities: [
          "Below Matikhru village",
          "Kade, Kami Village",
          "Meluri Birding Site",
          "Pfutsero Birding Site",
          "Phek",
          "Thechulumi",
        ],
      },
      {
        district: "Wokha",
        localities: [
          "Chumben Yanthan’s home",
          "Doyang Beat Office, Wokha",
          "Doyang Reservoir--Overall",
          "Doyang Reservoir--Southern Section",
          "Doyang--VKV Campus",
          "Doyang--Zero Point",
          "Pangti Village",
          "Wokha Pankti Highway",
          "Wokha Town",
          "Wokha--Forest Office",
        ],
      },
      {
        district: "Zunheboto",
        localities: [
          "Ghosu Bird Sanctuary",
          "Khiviku CCA",
          "Kivikhu Village",
          "Sukhai",
          "Sukhai CCA",
        ],
      },
    ],
  },
  {
    state: "Odisha",
    districts: [
      {
        district: "Angul",
        localities: [
          "Ambasaramunda (Hatidhara Reserve Forest)",
          "Ambasaramunda Inner (Hatidhara Reserve Forest)",
          "Ananta sayan,sarang",
          "Athmallik Town",
          "Athmallik-Dhalpur Bridge",
          "Dhandatopa RF ଧଣ୍ଡାଟୋପା ସଂରକ୍ଷିତ ଜଙ୍ଗଲ",
          "Dhandatopa RF- Kurab",
          "Dhandatopa Reserve Forest--Taranda (ତରଣ୍ଡା)",
          "Hatidhara RF",
          "Hatidhara RF (ହାତିଧରା ସଂରକ୍ଷିତ ଜଙ୍ଗଲ)",
          "Kasi Biswanath College",
          "Khambeswaripali ( Hatidhara Reserve Forest) (ଖମ୍ବେଶ୍ଵରୀପଲ୍ଲୀ)",
          "Laupal Reservoir",
          "Nuagaon Reserve Forest-- Manjore Dam (ମନଯୋର ବନ୍ଧ)",
          "Purunakote forest guest house",
          "Rantalei",
          "Satkosia NP--Tikarpada Char",
          "Satkosia NP--Tikarpada Nature Camp",
          "Satkosia Tiger Reserve",
          "Satkosia--Baghamunda",
          "Satkosia--Dangadhara Beat (ଡଙ୍ଗାଧର ବିଟ୍)",
          "Satkosia--Karadapada Wetland",
          "Satkosia--Katarang abandoned village",
          "Satkosia--Kulaing",
          "Satkosia--Raigoda Meadow",
          "Satkosia--Tikarpada Range office",
          "Satkosia--Tuluka Village",
          "Savithri Jindal Airport, Angul",
          "Tangianisha Bandha",
          "Tentuloi Pidha, Talcher",
          "Tikarpada Nature Camp & Surrounding Areas",
          "Tikarpada WLS -- George view point",
          "chhotkei nature camp , satkosia",
        ],
      },
      {
        district: "Balangir",
        localities: [
          "Bagjharan MIP",
          "Deogaon Sagar, Deogaon, Balangir",
          "Fuljharan and Taljharan Forests",
          "Jiramaya Sagar",
          "Khujenpali",
          "Krupasindhu Dam",
          "Larkipali Dam",
          "Upper Jiramaya Forest, Balangir",
        ],
      },
      {
        district: "Baleswar",
        localities: [
          "Arabandh Reserve Forest",
          "Balasore Railway Station",
          "Bichitrapur Mangrove Sanctuary",
          "Chandipur Beach",
          "Kuldiha",
          "Kuldiha Wildlife Sanctuary",
          "Panchalingeswar Forest",
          "Pantha Nivas, Chandipur",
          "Rissia Dam",
          "Rissia Nature Camp Gohirabhola",
          "Rissia Nature Camp, Kuldiha",
          "Talasari--Udaypur",
          "Talsari",
        ],
      },
      {
        district: "Bargarh",
        localities: [
          "Ambabhona",
          "Debrigarh Nature Camp",
          "Debrigarh WLS",
          "Debrigarh wildlife sanctuary",
          "Hirakud, Burla",
          "Right Dyke Road",
        ],
      },
      {
        district: "Bhadrak",
        localities: [
          "Chandbali",
          "Pantha Nibasa, Chandbali ghat",
          "Pirahat, Bhadrak",
        ],
      },
      {
        district: "Boudh",
        localities: [
          "Charichak, Boudh",
          "Gopalpur lake",
          "Kantamal, Bauda, Odisha",
          "Nunpanga, Boudh",
        ],
      },
      {
        district: "Cuttack",
        localities: [
          "Anshupa Lake",
          "Atei Reserved Forest, Kendujhar, Odisha, India",
          "Athagarh Fields, Guptamanika Road",
          "Banki",
          "Banki Autonomous College",
          "Berhampura Pata, Banki, Cuttack",
          "Bilipada Pata",
          "CDA SEC 10",
          "Charchika Lake",
          "Charigharia patta",
          "Chhanchunia (ଛାଞ୍ଚୁଣିଆ)",
          "Chhatisa Pato, Odisha, IN (20.541, 85.867)",
          "Cuttack Railway Station",
          "Cuttack Town",
          "Cuttack-Athagarh Rd",
          "Dabarakhola Waterfall, Badamba",
          "Dalijoda Forest (20.633, 85.862)",
          "Dalijoda Forest, Odisha, IN (20.621, 85.87)",
          "Deojhara Waterfall",
          "Dhansar Wetlands, Odisha, IN",
          "Dompara-Arachandi Wetlands, Odisha, IN",
          "Gayala Bank, Banki - Cuttack Road, Odisha",
          "Gayala Banka",
          "Kotadwara (କୋଟଦ୍ଵାର)",
          "Mahalahat, Jagatsinghpur, Odisha",
          "Mahanadi Bridge-- Jobra Anicut",
          "Mundali",
          "Mundali Barrage",
          "Naraj",
          "Naraj Barrage",
          "Nareijani Dam, Badamba",
          "Netaji Subhas Bose Setu, Kathajodi River, Cuttack",
          "Ramachandrapur Pata",
          "Ravenshaw University",
          "Samantaraypur alias Subarnapura,",
          "Sri Sri university",
          "Sukhuakhala Pata",
          "peacock valley road",
        ],
      },
      {
        district: "Deogarh",
        localities: [
          "Nalbandha",
        ],
      },
      {
        district: "Dhenkanal",
        localities: [
          "A3 Waterbody",
          "Borapada",
          "Dandadhara Dam",
          "Jamusara Pond",
          "Kandra reserve forest",
          "Kapilash Zoological Park",
          "Khalpal Reserve Forest",
          "Koriapal School",
          "Mandar Deula Sahi Field",
          "Saptasajya",
          "Shyamcharanpur",
        ],
      },
      {
        district: "Gajapati",
        localities: [
          "Khasada waterfall",
          "Lakhari Wildlife Sanctuary",
        ],
      },
      {
        district: "Ganjam",
        localities: [
          "Ankuli",
          "Bahuda Muhana Sagar",
          "Berhampur University",
          "Bhetanai, Ganjam (Black Buck sighting )",
          "Chilika Lake - Narayani Temple trail, Chhatargarh",
          "Chilika Lake--Rambha",
          "Chilika Lake--Rambha Jetty",
          "Chilika Lake--Swosti Resort",
          "Gahirmatha Marine Wildlife Sanctuary",
          "Ganjam--Potagarh fort",
          "Gopalpur Junction",
          "Gopalpur on sea",
          "Gopalpur-on-Sea (OBI)",
          "IISER Berhampur",
          "Keshpur",
          "Narayani Forest",
          "Old Podampetta Beach",
          "Pangal Dweep (ପଙ୍କାଳ ଦ୍ୱୀପ)",
          "Potagarh",
          "Rushikulya Beach",
          "Rushikulya River mouth",
          "Samala",
          "Satapada-- Sipakuda",
        ],
      },
      {
        district: "Jagatsinghpur",
        localities: [
          "Bandar, Jagatsinghpur, Odisha, India",
          "Devi River Estuary Bandar, Odisha",
          "Dhaltangarh Reserve Forest",
          "Fishing Harbour, Mahanadi River Estuary, Paradeep, Jagatsinghpur,",
          "PPL Plant waterbody, Paradeep, Odisha, India",
          "Paradeep Sea Beach, Paradeep, Odisha, India",
          "Paradeep Town",
          "Tarapur, Jagatsinghpur, Odisha, India",
          "Tirtol",
        ],
      },
      {
        district: "Jajpur",
        localities: [
          "Gokarneshwara Temple",
          "Rachhipur Wetlands -- Jajpur",
        ],
      },
      {
        district: "Jharsuguda",
        localities: [
          "Belpahar, Jharsuguda",
          "Hirakud Dam Reservoir and Mudflats",
          "Pikol, Odisha, IN (21.81, 83.748)",
          "Pump House , Ib Thermal , Odisha, IN (21.694, 83.893)",
          "Singhabaga",
        ],
      },
      {
        district: "Kalahandi",
        localities: [
          "Bhatrajore  Reservoir",
          "Bhatrajore Reservior (Bhatra Dam)",
          "Karlapat WLS",
          "Karlapat WLS--Jakam",
          "Karlapat WLS--Phurlijharan waterfall",
          "Niyamgiri",
          "Vedanta Township",
        ],
      },
      {
        district: "Kandhamal",
        localities: [
          "Belghar",
          "Charichhak, Boudh",
          "Coffee Garden Daringibadi",
          "Coffee Garden, Daringbadi",
          "Mandasaru Nature Camp",
          "Nandini forest",
          "Nature Park, Siripanga, Daringbadi Odisha, IN (19.919, 84.118)",
          "Putudi, Kandhamal, Odisha",
          "belghar nature camp",
        ],
      },
      {
        district: "Kendrapara",
        localities: [
          "Bhitarakanika NP -- Satavaya",
          "Bhitarkanika",
          "Bhitarkanika Mangroves",
          "Bhitarkanika NP--Habalikhati Nature Camp",
          "Bhitarkanika National Park Area",
          "Bhitarkanika, Khola Gate",
          "Bhitarkanika-- Khola",
          "Bhitarkanika--Bagagahan Heronry",
          "Bhitarkanika--Dangamal",
          "Bhitarkanika--Dangamal Jetty",
          "Bhitarkanika--Gupti Jetty",
          "Bhitarkanika--Hansina Bridge",
          "Kendrapara Autonomous College, Kendrapara",
          "Rajnagar, Kendrapara IN-OR (20.52488, 86.77371)",
          "bhitarkanika mangroves",
        ],
      },
      {
        district: "Kendujhar",
        localities: [
          "Daragadisila, Keonjhar, Odisha",
          "Hadagarh wildlife Sanctuary",
          "Jateswar Temple, Waterfall",
          "Kanijhari reservoir -Gobindapur",
          "Kanjhari Reservoir-Badaposi",
          "Kendujhargarh Railway Station",
          "Khandadhar Falls",
          "Kundapitha, Ghatagaon, Keonjhar, Odisha",
          "Remala Reservoir, Kendujhar",
        ],
      },
      {
        district: "Khordha",
        localities: [
          "Anandabana",
          "BJB (Autonomous) College, Lewis Road, BJB Nagar, Bhubaneswar, Od",
          "Barbara forest",
          "Barbera Forest, Salia, Khorda",
          "Barunei Hills",
          "Beguniapada, Daya river bed",
          "Behind Trident Galaxy",
          "Bhubaneswar Railway Station",
          "Biju Patnaik International Airport, Bhubaneswar",
          "Buddha Jayanti Park, Bhubaneshwar",
          "Buddha Statue Park, Bhubaneshwar",
          "C. V. Raman Global University, Bhubaneswar",
          "Centurion University of Technology and Management, Bhubaneswar",
          "Chandaka Reserve Forest, Bhubaneswar, Odisha",
          "Chandaka Reserve Forest--Deras Dam",
          "Chandaka WLS--Deras Dam",
          "Chandaka--Jhumka Dam Road, Godibari, Odisha, India",
          "Chausath Yogini Temple, Hirapur",
          "Chilika Lake - Kansari",
          "Chilika Lake--Barkul",
          "Chilika Lake--Mangalajodi",
          "Chilika Lake-Manglajodi",
          "D.A.V Chandrasekharpur Campus 2",
          "DAV PUBLIC SCHOOL UNIT VIII NAYAPALLI BHUBANESWAR",
          "Daruthenga",
          "Dasapur",
          "Daya River Bridge",
          "Dhauli Shanti Stupa -Peace Pagoda",
          "Forest Park, Bhubaneshwar",
          "Ghanga patana",
          "Godwit Eco Cottage",
          "Govt Primary School, Jamujhari",
          "Hotel Mayfair Lagoon",
          "IIIT, Bhubaneswar",
          "ITER College, SOA University",
          "Indian Institute of Technology (IIT) Bhubaneswar",
          "Jagannath Prasad Hill, Bhubaneswar",
          "Kalinga Stadium",
          "Kapileshwar Wetlands",
          "Kesora-Badagada-Jharpara Wetlands, Bhubaneswar",
          "Khordha Town",
          "Khordha town",
          "Laxmi Vihar, Bhubaneswar",
          "Mangalajodi Nature Camp",
          "Mangalajodi wetland",
          "Mangaljodi Bird Watching Tower and Boating",
          "Manglajodi Eco Tourism",
          "Mukteshwara  Mahadeva Temple",
          "NISER Cricket Ground",
          "NISER Jatni",
          "Nandankanan WLS-- Zoological Park",
          "Nandankanan WLS--Badabanka Open Quarry land",
          "Nandankanan WLS--Badabanka Pata",
          "Nandankanan WLS--Chudanga RF",
          "Nandankanan WLS--Dumping yard",
          "Nandankanan WLS--Hamira Tangi",
          "Nandankanan WLS--Jujhagada",
          "Nandankanan WLS--Kiakani Lake",
          "Nandankanan WLS--SBG Kanjia lake",
          "Nandankanan WLS--Wetland Trail",
          "Omc Colony",
          "Orissa University of Agriculture And Technology",
          "ROTI (Revenue Officers Training Institute) Gothapatana Road",
          "RPRC Botanical Garden (Ekamra Kanan)",
          "Rajarani Temple",
          "Rajdhani College",
          "Rama Devi Women's University",
          "Regional Science Centre",
          "SBI Colony Area, Kesora, Bhubaneshwar",
          "Sundarpada",
          "The DN Wisdom Tree Global School",
          "Udayagiri and Khandagiri Caves",
          "Utkal University",
          "XIMB, Bhubaneswar",
        ],
      },
      {
        district: "Koraput",
        localities: [
          "Amtiguda, Koraput, Odisha, IN (18.782, 82.747)",
          "Balda Caves",
          "Balda western slope",
          "Balda- Western slope",
          "COATS CAMPUS, KORAPUT TOWN",
          "Central University of Odisha (CUO)--Sunabeda Campus",
          "Deomali Hill, Odisha",
          "Duduma waterfalls",
          "Gomalput Lake",
          "Gupteswar",
          "Kalapada",
          "Kotpad",
          "Machkund town",
          "Mendhatadi (belaguda)",
          "Rajuguda Coffee Plantation, Odisha",
        ],
      },
      {
        district: "Malkangiri",
        localities: [
          "Balimela Dam , Chitrakonda, Malkangiri",
          "Gudiyapadar",
          "Satiguda",
          "Satiguda Dam",
          "Udaygiri caves",
        ],
      },
      {
        district: "Mayurbhanj",
        localities: [
          "Amdapani",
          "Asurkhol waterfall",
          "BRAHMANAKUNDA",
          "Badjud Dam, Mayurbhanj",
          "Balidhia dam",
          "Bankabal Dam",
          "Barehipani Nature camp",
          "Baripada",
          "Bhadusole Waterfalls",
          "Brahmnakunda",
          "CREFTDA, Office",
          "Chahala, Simlipal national park",
          "Gurguria pine forest",
          "Gurguria, Simlipal national park",
          "Hatibari Dam- Back Water Point (ହାତୀବାରି  ବନ୍ଧ)",
          "Jambhira (Deuli) dam",
          "Joranda waterfall , simlipal national park",
          "North Odisha University",
          "Palogoda, Simlipal",
          "Pithabata check post, Lulung",
          "Rairangpur",
          "Ramatirtha Crocodile Project",
          "Ranibandha",
          "Salbani Rest House, Forest Department, Odisha",
          "Similipal NP-- Lulung Nature Camp (ଲୁଲୁଙ୍ଗ ରୋଡ଼)",
          "Similipal National Park",
          "Similipal--Jamuani nature camp",
          "Similipal--Pithabata forest check gate",
          "Similipal--Upper Barahkamuda",
          "Simlipal National Park",
          "Simlipal--Barehipani",
          "Simlipal--Joranda",
          "Simlipal--Uski",
          "Simlipal-Khairi River Bed,",
          "Sitakund",
          "Suleipat Dam",
          "ହାତୀବାରି  ଜଳାଶୟ Hatibari Reservoir, Karanjia",
        ],
      },
      {
        district: "Nabarangapur",
        localities: [
          "Ampani Corridor",
          "Nabarangpur Degree College",
        ],
      },
      {
        district: "Nayagarh",
        localities: [
          "Badatasera Jungle, Khandapada",
          "Bhetabara Jungle",
          "Daspalla",
          "Jamuganda ଜାମୁଗଣ୍ଡା  (Khallikote Range)",
          "Jiginipada",
          "Kachera Pata",
          "Kantilo, Odisha, India",
          "Khandapada",
          "Kuanria Dam, Nayagarh, Odisha",
          "Maa Asura Kumari Temple",
          "Mahanadi Wildlife Division",
          "Sana Baghua Dam",
          "Satakosia George WLS",
          "Satkosia Gorge Sanctuary",
          "Satkosia Sands Resort",
          "Satkosia Tiger Reserve",
          "Satkosia Tiger Reserve, Badmul, Nayagarh, Odisha",
          "Sidhamula Nature Camp",
          "Sunamunhin Reservoir,  Khandapada",
        ],
      },
      {
        district: "Nuapada",
        localities: [
          "Naupada Komana Range office",
          "Patora Nature Camp",
          "Pendrawan marsh",
          "Pendrawan marsh,Nuapada, Odisha",
          "Sunabeda Wildlife Sanctuary",
        ],
      },
      {
        district: "Puri",
        localities: [
          "Baliapanda Beach, Puri",
          "Balukhand - Konark Reserve Forest",
          "Brahmagiri Road, Satapada",
          "Chandrabhaga Beach",
          "Chilika Lake",
          "Chilika Lake - Barunkuda",
          "Chilika Lake - Kalijai Temple",
          "Chilika Lake - Parikud",
          "Chilika Lake--Nalabana Bird Sanctuary",
          "Chilika Lake--Nalbana Bird Sanctuary",
          "Chilika Lake--New Sea Mouth",
          "Chilika Lake--Rajhans Island",
          "Chilika Lake--Satapada",
          "Chilika--Nuapada",
          "Dhaudia River Muhana",
          "Dhauligiri",
          "Golara",
          "Jagannatha Temple",
          "Janhikuda, Odisha",
          "Keutakuda",
          "Konark Sun Temple",
          "Manitri, Daya riverbed",
          "Nature Camp, Konark",
          "Puri (OBI)",
          "Puri Beach",
          "Puri Panthanivas, Odisha",
          "Rajhans, Odisha, IN",
          "Satapada",
          "Satapada--Mitakuoo",
          "Shree Jagannath Temple",
          "XIM University (New Campus)",
        ],
      },
      {
        district: "Rayagada",
        localities: [
          "Bissamcuttack",
          "Kankubadi",
          "Kumdabali,Rayagada,Odisha",
          "Kumudabali Bridge",
          "Muniguda Railway Station",
        ],
      },
      {
        district: "Sambalpur",
        localities: [
          "Belapada, Sambalpur",
          "Budharaja Hill",
          "Dhama forest",
          "Fashbuda, Mahanadi River Bank, Sambalpur, Odisha",
          "Hotapal Waterbody",
          "Larasara jungle",
          "Left dike Hirakud",
          "Moulabhanja RF, Rengali",
          "Pardesi Para",
          "Power Channel Road",
          "Ushakothi Wildlife Sanctuary",
          "jamadarpali",
        ],
      },
      {
        district: "Subarnapur",
        localities: [
          "Ainlachhat Jungle",
          "Arjunpur Forest, Kalapathar",
          "Binka, Sonepur, Odisha",
          "Bisagar Bandh, Sonepur",
          "Dahaja Forest Range, Sonepur, Odisha",
          "Gatarkela kukhudamahadev pond",
          "Hikudi Grasslands",
          "Kharapura Jungle",
          "Kukiantat Picnic Spot",
          "Mahanadi River (Pansiali Ghat)",
          "Mahanadi near Godhoneswar Temple",
          "Nandamal",
          "Pansiali area mini jungle",
          "Patali Shreekhetra, Meghnad, Subarnapur",
          "Raptor Land , Sonepur",
          "S patrapali",
          "Singhjuri Jungle, Subarnapur, Odisha",
          "Sonepur Town, Odisha",
          "Tel Nadi",
          "Tel River near Kustapali Subarnapur",
          "Thengo Dam, Subarnapur, Odisha",
        ],
      },
      {
        district: "Sundargarh",
        localities: [
          "Brahmani River Bank, Bonai",
          "Hemgir Forest",
          "Hemgiri Kanika",
          "Kanika, Odisha, IN",
          "Khandadhar, Sundargarh, Odisha",
          "Luakera, Rourkela",
          "NIT Rourkela, Odisha, IN",
          "Rai Baga",
          "Rourkela",
          "Sankara Pokhri",
          "Sankara Pokhri (Lake)",
          "Talsara Rengali Dam",
        ],
      },
    ],
  },
  {
    state: "Puducherry",
    districts: [
      {
        district: "Karaikal",
        localities: [
          "Government High School, Oozhiapathu, Karaikal",
          "Karaikal Beach",
          "Karaikal Beach Mangrove Forest",
          "Karaikal Railway Station",
          "Kottucherry Government Quarters",
          "National Institute of Technology Puducherry (NITPY), Karaikal",
        ],
      },
      {
        district: "Mahe",
        localities: [
          "Mahe",
          "Mahé Beach",
        ],
      },
      {
        district: "Puducherry",
        localities: [
          "Alankuppam Lake",
          "Annai Sivagami Girls Higher Secondary School",
          "Ansari Durai Sami GHSS, Thondamanatham",
          "Arumbarthapuram-Kombakkam Road",
          "Arutchelvi Ayee Ammal GMS, Mutharaiyarpalayam",
          "Bahour Lake--PY Side (பாகூர் எரி--புதுச்சேரி பகுதி)",
          "Bahour Road",
          "Bed Dam Vadukuppam-Pandacholanallur Rd",
          "Bharathi Park",
          "Bharathidasan Government College for Women",
          "Botanical Garden",
          "Botanical Garden (தாவரவியல் பூங்கா)",
          "Chinna Veerampattinam Beach",
          "Chunnambar (சுண்ணாம்பாறு)",
          "Directorate of School Education",
          "District Institute of Education and Training, Lawspet",
          "Embalam Lake (ஏம்பலம் ஏரி)",
          "Government High School, Kalmandapam",
          "Government High School, Pillaichavady",
          "Government High School, Sellipet",
          "Government Middle School, Ariyankuppam",
          "Government Middle School, Kariamanickam",
          "Government Middle School, Pitchaviranpet",
          "Government Primary School, Thengaithittu",
          "Govt. Boys Middle School, Delarshpet",
          "Govt. Girls Primary School, Bahour",
          "Govt. High School, Kanuvapet",
          "Govt. High School, Pillaiyarkuppam",
          "Govt. High School, Sandhai Pudukuppam",
          "Govt. Higher Secondary School, Karayambuthur",
          "Govt. Primary School, Ayyankuttipalayam",
          "Govt. Primary School, Boomianpet",
          "Govt. Primary School, Chinnayampet",
          "Govt. Primary School, Dharmapuri",
          "Govt. Primary School, Gopalankadai",
          "Govt. Primary School, Govindasalai",
          "Govt. Primary School, Indira Nagar",
          "Govt. Primary School, Kamaraj Nagar",
          "Govt. Primary School, Kundupalayam",
          "Govt. Primary School, Meenatchipet",
          "Govt. Primary School, Mettupalayam",
          "Govt. Primary School, Moolakulam",
          "Govt. Primary School, Murungapakkam",
          "Govt. Primary School, Muthupillaipalayam",
          "Govt. Primary School, Odiyampet",
          "Govt. Primary School, Raja Nagar",
          "Govt. Primary School, Sanarapet",
          "Govt. Primary School, Sinnakarayamputhur",
          "Govt. Primary School, Sithangudi",
          "Govt. Primary School, Sulthanpet",
          "Govt. Primary School, Thattanchavady",
          "Govt. Primary School, Vennila Nagar",
          "Indira Gandhi Govt. High School, Katterikuppam",
          "JIPMER (ஜிப்மர்)",
          "Kadaperikuppam Lake (கடப்பேரிகுப்பம் ஏரி)",
          "Kanagan Lake (கனகன் ஏரி)",
          "Karasur Lake (கரசூர் ஏரி)",
          "Karayambuthur Chinna Eri (கரையாம்புத்தூர் சின்ன ஏரி)",
          "Karayambuthur Lake (கரையாம்புத்தூர் ஏரி)",
          "Katterikuppam Lake (காட்டேரிகுப்பம் ஏரி)",
          "Keezh Parikalpattu Lake (கீழ்பரிக்கல்பட்டு ஏரி)",
          "Kirumambakkam Lake (கிருமாம்பாக்கம் ஏரி)",
          "Kodathur Lake (கொடாத்தூர் ஏரி)",
          "Korkadu Lake (கோர்க்காடு ஏரி)",
          "Kudiyiruppupalayam Lake (குடியிருப்புப்பாளையம் ஏரி)",
          "MTVS Govt. High School, Reddiarpalayam",
          "Madagadipet Lake (மதகடிப்பட்டு ஏரி)",
          "Manapattu",
          "Manapet Lake (மணப்பட்டு ஏரி)",
          "Mannadipet Lake (மண்ணாடிப்பட்டு ஏரி)",
          "Mel Sathamangalam Lake (மேல் சாத்தமங்கலம் ஏரி)",
          "Mullodai lagoon (முள்ளோடை கழிமுகம்)",
          "Nallavaadu lagoon",
          "Nallavadu Beach (நல்லவாடு கடற்கரை)",
          "Nallavadu-- Uppanaar Bridge (நல்லவாடு உப்பனாற்றுப் பாலம்)",
          "Nallur Lake (நல்லூர் ஏரி)",
          "Nathamedu Lake (நத்தமேடு ஏரி)",
          "Nettapakkam Lake (நெட்டப்பாக்கம் ஏரி)",
          "OM SAKTHI KOVIL TEMPLE",
          "Old Light House",
          "Our Lady of Lourdes Boys Govt. Aided School, Villianur",
          "Oussudu Lake Birds Sanctuary--PY side (ஊசுடு ஏரி பறவைகள் சரணாலயம்--புதுச்சேரிப் பகுதி)",
          "Ozhandhai Lake (உழந்தை ஏரி)",
          "PEC (Pondicherry Engineering College) Forest Area",
          "Panaiyadikuppam Lake (பனையடிகுப்பம் ஏரி)",
          "Pandachozhanallur Lake (பண்டசோழநல்லூர் ஏரி)",
          "Perunthalaivar Kamaraj Krishi Vigyan Kendra(PKKVK)-பெருந்தலைவர் காமராஜர் வேளாண் அறிவியல் நிலையம்",
          "Pondicherry Harbour and Surrounding",
          "Pondicherry University",
          "Puducherry Bus Stand",
          "Puducherry Entrance- JIPMER",
          "Puducherry Technological University (PTU) புதுச்சேரி தொழில்நுட்பப் பல்கலைக்கழகம்",
          "Puducherry--Old Port Pier (பழைய துறைமுகம்)",
          "Pudukuppam beach",
          "Puraakulam, Katterikuppam",
          "Rajiv Gandhi Institute of Veterinary Education and Research (Restricted Access)",
          "Rock Beach- Puducherry",
          "Rock Beach--Gandhi Statue",
          "Sandunes Beach Resort (Restricted Access)",
          "Sankaradas Swamigal Nagar",
          "Savarayalu Nayagar GGPS, Puducherry",
          "Sedarapet Lake (சேதராப்பட்டு ஏரி)",
          "Silver Jublee birding hotspot",
          "Sivaranthagam Lake (சிவராந்தகம் ஏரி)",
          "Sorapet Lake (சோரப்பட்டு ஏரி)",
          "Sri Aurobindo Ashram",
          "Suthukeni Lake (சுத்துக்கேணி ஏரி)",
          "Suthukeny Otteri (சுத்துக்கேணி ஓட்டேரி)",
          "T.N. Palayam Lake (திம்மநாயக்கன்பாளையம் ஏரி)",
          "Thanthai Periyar Govt. Girls H.S.S, Manavely",
          "The Study L’école Internationale",
          "Thengaithittu",
          "Thengaithittu--Estuary (தேங்காய்திட்டு கழிமுகம்)",
          "Thillaiyadi Valliammai Govt. School (TVGHS), Kathirkamam",
          "Thirubhuvanai Lake (திருபுவனை ஏரி)",
          "Thirukkannur Periya Eri (திருக்கனூர் பெரிய ஏரி)",
          "Thirukkanur Lake (திருக்கனூர் சின்ன ஏரி)",
          "Thiruvandarkoil Lake (திருவாண்டார்கோயில் ஏரி)",
          "Thondamanatham Lake (தொண்டமாநத்தம் ஏரி)",
          "Thuthipet Lake (துத்திப்பட்டு ஏரி)",
          "Uruvaiyar Bridge- Gingee River",
          "Utchimedu Lake (உச்சிமேடு ஏரி)",
          "VVRGTHSS, Lawspet",
          "Vadhanur Lake (வாதானூர் ஏரி)",
          "Vambupet Lake (வம்புப்பட்டு ஏரி)",
          "Veerampattinam (வீராம்பட்டினம்)",
          "Veerampattinam Harbour",
          "Veerampattinam Pier",
          "Velrampet Lake (வேல்ராம்பட்டு ஏரி)",
          "Villianur Railway Station (வில்லியனூர் ரயில் நிலையம்)",
          "le cafe",
        ],
      },
      {
        district: "Yanam",
        localities: [
          "Govt. Primary School, Abishekapakkam",
          "Neelapalli Area",
          "Neelapalli--Island Opp Church",
        ],
      },
    ],
  },
  {
    state: "Punjab",
    districts: [
      {
        district: "Amritsar",
        localities: [
          "AMRITSAR MEHTA ROAD, KHANKOT",
          "Amritsar Cantonment",
          "Company Gardens",
          "Dhanoakalan, Pul Kajri",
          "Fatehpur Rajputan",
          "GUMANPURA, DISTRICT AMRITSAR",
          "Gobindgarh Fort",
          "Golden Temple",
          "Guru Nanak Dev University Campus- Amritsar",
          "Kakkar",
          "Near Attari Border, District Amritsar",
          "Near Kohali on Amritsar-Chogawan Road",
          "Rakh Jhita, District Amritsar",
          "Wagah Gate & Border Stadium India",
        ],
      },
      {
        district: "Bathinda",
        localities: [
          "Bird Sanctuary, Bir Talab, Near Bathinda",
          "Dera Bhiana Sahib",
          "HMEL Township, District Bathinda",
          "Jassi Pauwali Heronry",
          "Nehian Wala",
        ],
      },
      {
        district: "Faridkot",
        localities: [
          "Shaheed Bhagat Singh park, Faridkot",
          "Veere Wala Khurd",
          "bir sikhanwala",
        ],
      },
      {
        district: "Fatehgarh Sahib",
        localities: [
          "Baɖali Maiki",
          "Bhagɽaɳa",
          "Biromajri",
          "Chandumajra Village Pond",
          "Cholti Kheri",
          "Khanpur Village pond, District Fatehgarh Sahib",
          "Sanghol Buddhist stupa ruins",
          "Sirhind Nature Trails",
          "Sirhind Outskirts--Punjab",
          "Sukka Darya Forest",
        ],
      },
      {
        district: "Fazilka",
        localities: [
          "Alamgarh Cricket Ground, Abohar Bypass",
          "Arniwala",
          "Asraf Wala",
          "Khui Khera Wetland",
          "Kundal Wetland--Punjab",
          "Muhar Jamsher",
          "Qdian Canal / (Odian)",
          "Village Odian",
        ],
      },
      {
        district: "Ferozepur",
        localities: [
          "Chak Sarkar",
          "Churia--Harike",
          "Dineke Forest Near Harike",
          "Harike Bird Sanctuary",
          "Harike Bird Sanctuary--Kot Qaim Khan",
          "Harike Bird Sanctuary--Kot Qaim Khan (Left Bank of Sutlej)",
          "Harike Bird Sanctuary--Makhu Canal",
          "Harike Bird Sanctuary--Maujgarh",
          "Mamnewala",
          "Maujgarh near Harike Barrage",
          "Shahed Bhagat Singh University (Restricted)",
          "hussainiwala",
        ],
      },
      {
        district: "Gurdaspur",
        localities: [
          "Gurudaspur--General Area",
          "Jagatpur Kalan--Punjab",
          "KESHOPUR CHHAMB COMMUNITY RESERVE (GURDASPUR)",
          "KESHOPUR CHHAMB COMMUNITY RESERVE-MAGARMOODIAN WETLAND",
          "Keshopur",
          "Keshopur Chhamb Community Reserve",
          "Keshopur wetlands Gurdaspur",
          "NAUSHEHRA MAJJA SINGH (BATALA)",
          "SHALLA PATTAN WETLAND (KESHPUR CHHAMB COMMUNITY RESERVE) GURDASP",
          "Shala Pattan (town)",
          "keshopur Fields",
        ],
      },
      {
        district: "Hoshiarpur",
        localities: [
          "BBMB Office Campus,Talwara",
          "Beas River Conservation Reserve, Chakk Gagrewal",
          "Beas river Hargobindpur",
          "Damsal Dam-- Punjab",
          "Dasuya--Punjab",
          "Jaijon",
          "Jaijon- Hoshiarpur",
          "Kukanet",
          "Maili",
          "Maili Dam",
          "Talwara",
        ],
      },
      {
        district: "Jalandhar",
        localities: [
          "Bachhowal Blue-Tailed Bee-Eater Breeding site",
          "Bhagwanpur--Punjab",
          "Burlton Park",
          "Dr B R Ambedkar National Institute of Technology",
          "Farms, Wadala Road, Jalandhar",
          "Jalandhar",
          "Jalandhar Gymkhanna",
          "Jhandi Peer, Phillaur",
          "Ludhiana Metropolitan Area",
          "Nangal Karar Khan, Jallandhar Cantt. Byepass Road",
          "Phillaur Divisional Forest",
          "Punjab Police Acdemy Complex, Phillaur",
          "Satluj River- Punjab",
          "Sutlej Riverbank, Rajauri",
          "Sutlej riverbank, Phillaur",
          "Urban Estate Area Jalandhar Punjab",
          "Vasant Avenue, Jalandhar",
        ],
      },
      {
        district: "Kapurthala",
        localities: [
          "Beas Conservation Reserve",
          "Beas River Conservation Reserve (Ramsar)--Beas",
          "Chitti Bein - Near Chiheɽu Bridge",
          "Dhilwan Railway Station",
          "Hari ke Pattan-Kapurthala",
          "ITC Factory, JHAL THIKRIWAL",
          "Jalandhar Metropolitan Area",
          "Jhal Thikriwala- Punjab",
          "Kanjli Wetland",
          "Khara--Harike",
          "Mand Kirian--Punjab",
          "Near LPU Phagwara",
          "Rail Coach Factory Kapurthala",
        ],
      },
      {
        district: "Ludhiana",
        localities: [
          "Bholapur Primary School",
          "GHG Khalsa College",
          "Gobindgarh--Ludhiana",
          "Guru Nanak Dev Engineering College(GNE), Ludhiana",
          "Kaind Bridge, Ludhiana-Sangrur Road, District Ludhiana",
          "Khaira Bet",
          "Ludhiana satluj Bed",
          "Mattewara Forest",
          "Nanak Nagar, Karabara Basti",
          "Near Satluj Tennis Academy, Ludhiana West",
          "Neelon",
          "Nehru Rose Garden",
          "Noorpur Bet Ludhiana pond",
          "PAU Ludhiana - Floriculture farm",
          "Pinki Botanical Garden, Lalton",
          "Punjab Agricultural University",
        ],
      },
      {
        district: "Pathankot",
        localities: [
          "KATHLAUR KUSHLIAN WILDLIFE SANCTUARY (PATHANKOT)",
          "Near Turehti, District Pathankot",
          "Phangota",
          "Ranjit Sagar Dam",
          "kathlaur",
        ],
      },
      {
        district: "Patiala",
        localities: [
          "Banur-Patiala",
          "Baradari Garden",
          "Barsat",
          "Beerh Bhadson Wildlife Sanctuary",
          "Environment Park - Civil Lines",
          "Giani Farms, Banur",
          "Jangipur",
          "Kishangarh  birding hotspot",
          "Punjabi University (Restricted)",
          "Rajpura--Patiala",
          "Rampur Kalan, Chatt  Bir Road, District Sahibzada Ajit Singh Nagar",
          "Thapar Polytechnic College",
        ],
      },
      {
        district: "Rupnagar",
        localities: [
          "Anandpur Sahib to Tarapur Road, Dhanera",
          "Anandpur Vidi, near Jasdan (OBI)",
          "Bardar-- Punjab",
          "Bari Mandauli",
          "Ghanauli",
          "Gurudwara Baba Deep Singh Ji Saheed",
          "Haripur",
          "IIT Ropar",
          "Jhajjar Bachauli wildlife",
          "Near Gurdwara Rara Sahib, Nangal",
          "Near Gurudwara Bhibour Sahib, Nangal",
          "Nurpur Bedi Bridge -Sutlej",
          "Paili Khurd, Anandpur sahib-Naina Devi Road",
          "Ropar (OBI)",
          "Ropar, en route Chandigarh (By pass Bridge)",
          "Ropar-Indus Valley Civilization",
          "Rupnagar",
          "The Kikar Lodge",
          "Village Bani,  Anandpur sahib Punjab",
          "Village Sandhuan",
        ],
      },
      {
        district: "Sahibzada Ajit Singh Nagar",
        localities: [
          "Abhipur Pond",
          "Aerocity to Banur-Landran Road",
          "Alamgir, Punjab",
          "Attawa Choe Sector 62",
          "Badmajra",
          "Bari--Punjab",
          "Bir Pir Machhalia--Punjab",
          "Birding in Jawaharpur-Ambala Punjab",
          "Central Park, Sector 69, Mohali",
          "Chandigarh Airport",
          "Chappar Chiri",
          "Chattbir Zoo",
          "Chhatt Beerh",
          "Chhoti Bari Parachh--Punjab",
          "Choti Badi Naggal",
          "City Park Sector 68",
          "DLF Mullanpur",
          "Daffarpur-- Punjab",
          "Dharak Khurd",
          "Fateh Burj Complex, Chhappar Jhirri, Mohali",
          "Forest Hill Golf & Country Club Resort",
          "Ghaggar Barrage",
          "Gudana",
          "Gurudwara Sachkhnad Dwar (Jhanda Sahib)",
          "IISER Basketball Court--Mohali (Restricted access)",
          "IISER Mohali",
          "Indian Institute of Science Education and Research (IISER) Mohali -- AB1",
          "Indian Institute of Science Education and Research (IISER) Mohali--Playground",
          "JLPL Industrial Area, Manauli",
          "Jawaharpur,Derabassi,near Chandigarh",
          "Jawaharpur--Punjab",
          "Jayanti Devi Dam",
          "Karoran",
          "MLA Flats Park, New Chandigarh",
          "Makandpur--Punjab",
          "Manauli Village fields, near Mohali",
          "Mirzapur Check Dam",
          "Mote Majra",
          "Mote Majra Lake",
          "MoteMajra Lake",
          "Mullanpur - Pond near Omaxe",
          "Mullanpur Garibdass",
          "National Institute of Pharmaceutical Education and Research",
          "Near Lakhnaur Sector 90 Mohali",
          "Near Mirzapur Dam, District Sahibzada Ajit Singh Nagar",
          "Near Village Dulwan",
          "Near Village Kambala near Mohali",
          "Near Village Kurrdi",
          "Near Village Mizapur, District Sahibzada Ajit Singh Nagar",
          "Near, Punjab IAS PCS Co-op Housing, New Chandigarh",
          "Palheri Pond",
          "Palheri pond",
          "Parchh Dam",
          "Paroul",
          "Peer Mucha Wala Forest",
          "Perch Check Dam",
          "Raipur--Punjab",
          "Ratwara Sahib Gurdwara Backside",
          "Rivulet Bed,Near Mullanpur, Punjab",
          "Sahibzada Ajit Singh Nagar County, Punjab, IN",
          "Sahibzada Ajit Singh Nagar--Punjab",
          "Sahibzada Singh Nagar",
          "Samgauli-- Punjab",
          "Sector 64, Phase 10",
          "Silvi Park, Sector 64",
          "Siswan",
          "Siswan Dam",
          "Siswan Lake",
          "Siswan-Old Siswan road",
          "Siswan-Siswan forest",
          "Sohali--Punjab",
          "Sukhna WLS--Kansal area",
          "Sukhna WLS--Karoran",
          "Tangori",
          "The Foothills IAS-PCS Society",
          "Togan",
        ],
      },
      {
        district: "Sangrur",
        localities: [
          "Government Senior Secondary School, Mandvi village, District Sangrur",
          "SLIET",
        ],
      },
      {
        district: "Shaheed Bhagat Singh Nagar",
        localities: [
          "Sutlej Riverbank",
          "T-Ballowal sonkri, punjab",
          "sarangpur",
        ],
      },
      {
        district: "Sri Muktsar Sahib",
        localities: [
          "Chauntra (Near Canal)",
        ],
      },
      {
        district: "Tarn Taran",
        localities: [
          "Chamba Kalan Village",
          "Harike Bird Sanctuary--Tarn Taran",
          "RAKH SARAI AMANAT KHAN FOREST",
          "Tarn Taran-- Punjab",
        ],
      },
    ],
  },
  {
    state: "Rajasthan",
    districts: [
      {
        district: "Ajmer",
        localities: [
          "Anasagar Lake",
          "Birla Public School (Restricted Access)",
          "Cattle Breeding Farm, Ramsar",
          "Central University of Rajasthan",
          "Chat Village",
          "Dudhaleswar Mahadev Temple and Surroundings",
          "Foy Sagar Lake",
          "Govindgarh Dam, Pushkar",
          "Gundolav Lake",
          "Hameer Pond",
          "Jawaja Ka Talab",
          "Keetap (General)",
          "Khera Kalan",
          "Kishangarh Darbar",
          "Kumhariya Wetland",
          "Loharwara Pond",
          "Loharwara--Quartz and Mica Mines",
          "Maharishi Dayanand Saraswati (MDS) University",
          "Makreda ka Talab Beawar",
          "Mayo College",
          "Mehendi Khola Temple",
          "Nag Parbat",
          "Nagar Van Udhyan",
          "Near Nasirabad (OBI)",
          "Panchsheel Talab, Ajmer",
          "Pandhi Ka Par (Ramsar Pond)",
          "Paprolli Village",
          "Pushkar Ghat",
          "Pushkar Heritage",
          "Pushkar Lake",
          "Pushkar Resorts",
          "Rajgarh",
          "SPCGCA Campus",
          "Savitri Mata Temple",
          "Shokaliya",
          "Shokliya Agro-Grassland",
          "Shokliya Wetland",
          "Shravan Sagar & Phool Sagar",
          "Snow Yard Kishangarh",
          "Suspension Pond, Mundoti",
          "Tabiji Ka Tala",
          "Varun Sagar Lake, Ajmer",
          "wetland near Sawar (OBI)",
        ],
      },
      {
        district: "Alwar",
        localities: [
          "AAETI (Alwar) RJ/IN",
          "Algual- Sariska Raj.",
          "Astroport Sariska Resort & Spa",
          "Baba Mohan Ram Temple, Kali Kholi, Bhiwadi, Khairthal-Tijara,Rajasthan",
          "Bala Quila/ Bala Fort",
          "Biodiversity Park",
          "Dadhikar Fort Alwar IN/RJ",
          "Ghandka road - Sariska Raj.",
          "Haripura hill Sariska",
          "Haripura temple - Sariska Raj.",
          "Kabri gate- Sariska Raj.",
          "Kali Radi- Sariska Raj.",
          "Kalighati - Sariska Raj",
          "Kankwari valley- Sariska Raj.",
          "Kankwari- Sariska Raj.",
          "Karnakawas hill Sariska",
          "Kundali- Sariska Raj.",
          "Makar-da-pulia - Sariska Raj",
          "Mangalsar Dam, Alwar RJ/IN",
          "Nayapani- Sariska Raj.",
          "Neemrana Fort Palace Area haryana",
          "Pheta-ki-pal- Sariska Raj.",
          "Ramgadh to Jaisalmer Road",
          "Sariska",
          "Sariska - Governor's Road",
          "Sariska - Shankar's exclosure",
          "Sariska NP--Bandipul Forest",
          "Sariska NP--Mansarovar Lake (Mangalsar Dam)",
          "Sariska Sterling Resort (OBI)",
          "Sariska TR--Algual Rd",
          "Sariska TR--Bhaironghati Hill",
          "Sariska TR--Brahmnath",
          "Sariska TR--Budha Hanuman",
          "Sariska TR--Chamari Ka Beda",
          "Sariska Tiger Reserve",
          "Sariska Tiger Reserve--Karna ka Vas",
          "Sili Sedh, edge of Alwar (OBI)",
          "SiliSerh",
          "Tarunda - Sariska",
          "Tehla nallah- Sariska Raj.",
          "Tehla, Sariska HR/IN",
          "Tehla- Sariska Raj.",
          "Tijara Fort Palace",
          "Umri - Sariska Raj",
          "Umri hill- Sariska Raj.",
          "Umri nallah- Sariska Raj.",
          "Utsav Camp Sariska",
          "Vanaashrya",
        ],
      },
      {
        district: "Banswara",
        localities: [
          "Mahi River",
        ],
      },
      {
        district: "Baran",
        localities: [
          "Ramgarh Crater Baran",
          "Shahbad, Baran (OBI)",
          "Sorsan Grassland",
          "Sorsan--Niyana Wetland",
          "Wetland near Ramgarh Village, Baran (OBI)",
        ],
      },
      {
        district: "Barmer",
        localities: [
          "Cheepal Nadi",
          "Gangawas Pond, near Korna",
          "Korna",
          "Korna Village (OBI)",
          "Mala Ji Jaal and Malde Temple",
          "Mekam singh ji Pond",
          "Pachpadra Village (OBI)",
          "Rann of Redana",
          "Siana Lodges and Camps",
        ],
      },
      {
        district: "Bharatpur",
        localities: [
          "Bagh Hotel",
          "Barkhera Jaipur",
          "Bayana Cliffs",
          "Bayana Tank",
          "Bharatpur--Keoladeo Ghana NP",
          "Bharatpur--Keoladeo Ghana NP--Sapan Mori",
          "Bharatpur--Malah Road Marsh",
          "Bharatpur--Pride Kadamb Kunj",
          "Bharatpur--Saras Hotel",
          "Bharatpur-Circular Rd",
          "Bund Baretha WLS",
          "Chak Sakeetra Fields",
          "Dar Barahna",
          "Ghatoli",
          "Jatoli road",
          "Kot Bayana",
          "Kumher area",
          "Malaha Water plants (Keoladeo)",
          "Rarah",
          "Roopvas",
          "Shri Guru madhvanand Pratibha college, Rupbas",
          "outskirts of Bharatpur (OBI)",
        ],
      },
      {
        district: "Bhilwara",
        localities: [
          "Badi Ka Baadiya",
          "Chavandia Pond",
          "Dhandolai",
          "Doalatghar, Charoda ka khera",
          "Gujjaro ki kea pass",
          "Gurla Pond",
          "Gurlan Pond",
          "Guwardi Dam",
          "Hurda Talab",
          "Jaleshwar Pond",
          "Khan Singh ji ki bavdi",
          "Kundaliya band",
          "Ladpura",
          "Sareri Dam, Bhilwara",
          "Shahpura",
          "Shahpura Bagh Hotel",
          "Smriti Van Garden",
          "Teaja ji ki bavdi per",
          "Umaid Sagar (OBI)",
          "Ummed Sagar",
        ],
      },
      {
        district: "Bikaner",
        localities: [
          "Bikaner Sewage Treatment Plant",
          "City Drainage & Sewerage Water, Bikaner, Rajasthan",
          "College of Veterinary and Animal Science Bikaner",
          "Darbari Pond",
          "Dewasar",
          "Gajner",
          "Gajner Bird Sanctuary",
          "Gajner Lake Point 2",
          "Guda",
          "IGNP Escape way - RD 750",
          "Jodbeer",
          "Jorbeed Colony",
          "Jorbeer (to Merge)",
          "Jorbeer Conservation Reserve, Behind Camel Farm, Joharbeer, RJ",
          "Jorbeer Vulture Conservation Centre",
          "Junagarth Fort",
          "Lalgarh Palace Garden",
          "Lunkaransar",
          "Lunkaransar Salt Lake",
          "Maharaja Gangasingh University, Bikaner",
          "RD507 (Wetlands)",
          "RD507 (Woodlands)",
          "Raneri Talaab (km 73 from Bikaner on NH15)",
          "Sacha Soudha Plantation Km81",
          "Seruna, Rajasthan",
          "Shiv Gorakh Mandir, Goyalri",
          "Vallabh Gardens, Bikaner",
          "Vesta Bikaner Palace",
        ],
      },
      {
        district: "Bundi",
        localities: [
          "Abhayapura Wetland",
          "Bardha Dam",
          "Devpura Bundi",
          "Guda Dam",
          "Jet Sagar",
          "Jhar Mahadev",
          "Ram Sagar Jheel",
          "Ramgarh Vishdhari Tiger Reserve, Bherupura",
          "Ramgarh Vishdhari Wildlife Sanctuary",
          "Ramnagar Wetland",
          "Rampuriya",
          "Talwas Ratan Sagaar",
          "Taragarh Fort",
          "near Chambal River, Kota (OBI)",
          "wetland near Ramnagar Village (OBI)",
        ],
      },
      {
        district: "Chittorgarh",
        localities: [
          "Abhaypura Ghata",
          "Amba pani",
          "Badwai Lake",
          "Bassi Fort Palace",
          "Bassi WLS",
          "Bhainsrorgarh WLS--Saddle Dam Rd",
          "Bhupal Sagar lake",
          "Borda Talav/ Borda Lake",
          "Chittorgarh Fort",
          "Chittorgarh fort",
          "Dorai Dam upstream",
          "Gosunda Dam",
          "Keljar Mahadev & Surroundings",
          "Kishan Kareri Bird Sanctuary",
          "Mangalwad/ Mangalwar Lake",
          "Menal",
          "Menal Pond",
          "Menal, Chittaurgarh",
          "Nagawli Talab",
          "Pangarh Lake",
          "Rana Pratap Sagar Dam (OBI)",
          "Rawatbhata--Submersible Bridge",
          "Thukrai Talab",
        ],
      },
      {
        district: "Churu",
        localities: [
          "Charvas Tal, Churu",
          "Charwas Village Pond",
          "Chhapar Village Chowk and Pond",
          "Gousala",
          "Koshi Dhora Temple",
          "Leelki Beed",
          "Naatho Talaab",
          "Padihara Village, Rajasthan",
          "Ratangarh, en route to Tal Chappar (OBI)",
          "Tal Chapper Salt Pans",
          "Tal Chhapar Bypass Road",
          "Tal Chhapar Sanctuary",
          "Tal Chhapar Sanctuary (to Merge)",
          "Tal Chhapar WLS--Gaushala Area",
          "Tal Chhapar WLS--Rampur Range",
          "Tal Chhapar WLS--Salt Pans",
        ],
      },
      {
        district: "Dausa",
        localities: [
          "Abhaneri Village Safari Camp",
          "Chand Baori Stepwell",
          "Ed Zed Balaji",
          "Gatolav Pond",
          "Harshad Mata Temple",
          "Kalakho Dam",
          "Madhogarh",
          "Morel Dam Road",
          "New Colony--Lalsot",
        ],
      },
      {
        district: "Dholpur",
        localities: [
          "Bhola Ghati",
          "Dholpur - Western scrub",
          "Dholpur, Rajasthan (OBI)",
          "Dholpur--Nibhi",
          "Dholpur-Bund Baretha Road",
          "Hotel Raj Niwas Palace, Dholpur",
          "Kesarbagh Sanctuary",
          "Muchhkund",
          "National Chambal Sanctuary--Dhaulpur (RJ side)",
          "National Chambal Sanctuary--Shergarh Fort Dholpur",
          "Pachgaon Wetland",
          "Ramsagar Wildlife Sanctuary",
          "Tagawali STP",
          "Talab Shahi",
          "Van Vihar Hunting Lodge",
        ],
      },
      {
        district: "Dungarpur",
        localities: [
          "Dungarpur Bird Sanctuary and Flower Garden",
          "Gaib Sagar Lake",
          "Kheer Khaiya",
          "Khera Kachawasa",
        ],
      },
      {
        district: "Hanumangarh",
        localities: [
          "Badopal",
          "Dabli Khurd",
          "Manaktheri waterbody",
        ],
      },
      {
        district: "Jaipur",
        localities: [
          "Albert Hall Museum",
          "Amagarh Leopard Reserve",
          "Amber Palace/ Amer Fort",
          "Ambikeshwar Mahadev Temple",
          "Barkhera",
          "Barkhera Wetland, Jaipur, RJ",
          "Bhaskar Enclave 2",
          "Bhasker Enclave 2",
          "Bhuteswar Nath Mahadev Seesyawas",
          "Chak Chamroli",
          "Chaksu Talav/ Chaksu Lake",
          "Chandlai Lake",
          "Chandlai Talav/ Chandlai Lake",
          "Clark's Amer Hotel, Jaipur",
          "Dhantala Meena (OBI)",
          "Dol Ka Badh",
          "Dravyavati Bird Park Jaipur",
          "Ganpati Residency",
          "Grass Farm Nursery",
          "Hawa Mahal, Jaipur",
          "Hotel Highway king, Shahpura",
          "Hotel Jai Palace",
          "Jaigarh Fort",
          "Jaipur (OBI)",
          "Jaipur Grass Nursery Farm",
          "Jaipur International Airport",
          "Jaipur Railway Junction",
          "Jaipur--Amber Palace vicinity",
          "Jaipur--Central Park",
          "Jaipur--Floating Palace",
          "Jamwa Ramgarh WLS",
          "Jantar Mantar",
          "Jawahar Circle Garden",
          "Jawaharnagar Forest Nursery",
          "Jhalana Safari Park",
          "Jobner Krishi Farm",
          "Kaladera, Jaipur (OBI)",
          "Kalakya Mata Mandir, Jhalana",
          "Kanak Vrindavan Park",
          "Kanota Dam",
          "Kanota Dam--Babaji Ki Paal",
          "Kishen Bagh",
          "LN Mittal Bridge",
          "Lake Man Sagar",
          "Mahaveer Udyan",
          "Mahima Nirvana",
          "Manipal University, Jaipur",
          "Maotha Lake",
          "Matera Pond",
          "Mondiya Talab",
          "Monkey Temple",
          "Muhana Grassland",
          "Nahargarh Biological & Zoological Park",
          "Nahargarh Biological Park",
          "Nahargarh Forest",
          "Nahargarh Fort",
          "Nahargarh Fort, Jaipur",
          "Naliasar Lake",
          "Nangal Salt Pans",
          "Nasiya",
          "Nasiya (Manpur Doongri)",
          "Nature Farms (OBI)",
          "Nemi Nagar Extension (OBI)",
          "Neota Dam Eastern side",
          "Neota Talav",
          "Nevata Lake, Jaipur",
          "Outskirts of Jaipur (OBI)",
          "Papad Waley Hanuman ji",
          "Rajasthan University Campus",
          "Rambagh Palace, Jaipur",
          "Ramniwas Garden (OBI)",
          "Ringus Road Jaipur",
          "Rose Garden, Jaipur",
          "SEPTA Golf Course (Restricted)",
          "Sagar Lake, Amber, Jaipur",
          "Sambhar Lake",
          "Sambhar Lake- Shakambhari Mata Temple",
          "Sambhar Lake--South",
          "Sambhar Salt Lake",
          "Samode Haveli",
          "Samode Palace",
          "Saptashakti Nature Park",
          "Sarthala waterbody",
          "Shiksha Sankul",
          "Shivdaspura, Near Jaipur (OBI)",
          "Sitarampura Salt Lake",
          "Sitla Mata, near Chaksu (OBI)",
          "Smriti Van",
          "State Agricultural Research Institute Campus",
          "Sushant City 1",
          "Tal Katora Lake",
          "Tara Niwas Hotel (Restricted)",
          "The Tree of Life Resort & Spa",
          "Todamina, near Jaipur (OBI)",
          "Vastu shree colony Mangyawas",
          "iCED CAG Office",
        ],
      },
      {
        district: "Jaisalmer",
        localities: [
          "Ajasar Water Reservoir",
          "Akal Wood Fossil Park",
          "Amar Sagar",
          "Asoo Ka Tala",
          "Bada Bagh",
          "Basanpeer Juni Talav",
          "Biprasar Talab",
          "Border Home Guards Ground",
          "Chhor Talab, Devikot",
          "DNP & Surroundings-  Point2",
          "DNP--Godawan Garh",
          "DNP--Musa's Desert Nest",
          "Damodara (OBI)",
          "Damodara Gaushala",
          "Dandewala (OBI)",
          "Dandewala, Thar Desert (OBI)",
          "Deghrai Mata Temple",
          "Degray Mata Mandir",
          "Degray Mata Mandir and Surroundings",
          "Desert NP (DNP) & Surroundings--General Area",
          "Desert NP (DNP) & Surroundings--Khuri",
          "Desert NP (DNP) & Surroundings--Sam To Khuri Road",
          "Desert NP (DNP) & Surroundings--Sudasari",
          "Desert NP--Giant Moringa Dune",
          "Desert NP--Sam Sand Dunes",
          "Desert NP--Sam to Sudasari Road",
          "Desert National Park",
          "Desert National Park -Sudasiri Range- Baran",
          "Desert Safari Camp",
          "Gadisar Lake",
          "Gajroop Sagar",
          "Gamnewala (OBI)",
          "Ghotaru (OBI)",
          "Ibhram Fakhir Dargha",
          "International Border, Dandewala (OBI)",
          "Jaisalmer Airport",
          "Jaisalmer Fort",
          "Jaisalmer, Rajasthan (OBI)",
          "Jaseri Pond",
          "Jiya Desar Rai Mandir Talaab",
          "Jiya Desar Rai Temple",
          "Kale Dungar, Jaisalmer (OBI)",
          "Khaba Village",
          "Khabha Fort",
          "Khetolai",
          "Khetolai (OBI)",
          "Khetolai Lake",
          "Khuri (OBI)",
          "Khyala Mutt Lake, Myajlar",
          "Kuldhara",
          "Kuldhara Ruins",
          "Lakhmanon Ki Basti",
          "Loonon ki Basti--Sam",
          "Masjid (Mosque) near Sam market",
          "Mohangarh (OBI)",
          "Murar and surroundings",
          "Nabhdungar",
          "Netsi Lake",
          "Netsi Village",
          "Pokaran Birding Safari",
          "Pokaran Salt Lake",
          "Pokaran, Jaisalmer (OBI)",
          "Ramgarh--General Area (OBI)",
          "Rann of Lanela",
          "Sagron Ki Basti",
          "Sam Desert",
          "Sam Road, Jaisalmer (OBI)",
          "Seuwa",
          "Sonal Desert Camp",
          "Sorhakor Lake",
          "Suján The Serai",
          "Sunset Point and Vyas Chhatari, Jaisalmer",
          "Tanot Mata Dharmshala",
          "Thar Desert (OBI)",
          "Water puddle near Damodara",
          "near Ramgarh, Jaisalmer (OBI)",
        ],
      },
      {
        district: "Jalore",
        localities: [
          "Jagnath WLS (Dhawla Village)",
          "Siyana--Scruby Hills (South of Akoli-Siyana Road)",
        ],
      },
      {
        district: "Jhalawar",
        localities: [
          "Barbela Lake",
          "Barbeli",
          "Binnayaga Caves area",
          "College of Horticulture and Forestry [CHF]",
          "Gagron Fort",
          "Khandiya Wetland (OBI)",
          "Love Kush Vatika Barbela",
          "Love Kush Vatika, Barbela",
          "Mundiya Kheri Lake",
          "Nageshwar Parshwanath Tirth",
          "Pond—CHF",
          "Terrace Garden, Gurha",
        ],
      },
      {
        district: "Jhunjhunu",
        localities: [
          "BITS Pilani",
          "Birla Yoga Kendra",
          "Desert Resort, Mandawa",
          "Jherli Pilani",
          "Jhunjhunu Beed Conservation Reserve",
          "Khetri",
          "Kot Baandh",
          "Pilani Helipad",
          "Roop Niwas Kothi",
          "Surajgarh Rural",
        ],
      },
      {
        district: "Jodhpur",
        localities: [
          "Agolai Talab",
          "Ajit Bhawan Hotel",
          "Akreja Talab",
          "Arna Jharna",
          "Balsamand Lake Palace",
          "Baorli Village Pond",
          "Barli Talav",
          "Bhagat Ki Kothi Railway Station",
          "Bio Waste And Tannery",
          "Bishnoi Village Safari (Jodhpur)",
          "Chandelao Talav/ Chandelao Pond",
          "Dechu",
          "Devi Kunj Guest House",
          "Dhawa Doli WLS",
          "Gehlot Jal Griha",
          "Guda Bishnoiyan, Rajasthan State Highway 68",
          "Guda Vishnoi Conservation Reserve",
          "Herbal Park/ Botanical Park (OBI)",
          "Hotel Park Plaza, Jodhpur",
          "Indian Institute of Technology Jodhpur",
          "Jajiwal Gehlotan Pond",
          "Jaswant Thada",
          "Jodhpur Airport",
          "Jodhpur Carcass Dump",
          "Jodhpur Golf Course",
          "Jodhpur--Vivanta By Taj Hotel",
          "Jojari Bridge, Sojat Road, Basni Benda, Jodhpur",
          "Kailana Lake",
          "Kanasar",
          "Kayalana Lake",
          "Keru Landfill",
          "Kheechan Village (OBI)",
          "Khichan",
          "Khichan--Demoiselle Crane Feeding Station",
          "Khichan--Vijaysagar Lake",
          "Khidrat to Kanji Ki Sird Grasslands",
          "Kolu Pabuji Oran",
          "Korna",
          "Lake near to Machiya Biological Park",
          "Little Taj",
          "Luni (OBI)",
          "Machia Biological Park",
          "Mamaji Temple",
          "Mandore Garden",
          "Meghlasiya Talao",
          "Meglasiya (OBI)",
          "Mehrangarh Fort, Jodhpur",
          "Moti Bagh, Pali Road",
          "Nageshwar Temple, Mehrangarh fort Road",
          "Olvi Pond",
          "Olvi Village and surrounds",
          "Osian (OBI)",
          "Ramasani",
          "Ramasani (OBI)",
          "Rao Jodha Desert Rock Park",
          "Rao Jodha Desert Rock Park, Jodhpur",
          "Sambodhi Lake",
          "Soorsagar Lake",
          "Surani Pond",
          "Umaid Bhawan Palace, Jodhpur",
        ],
      },
      {
        district: "Karauli",
        localities: [
          "Ghanteshwar Mahadev Temple",
          "Kaila Devi Sanctuary",
          "Kalisil Dam",
          "River bed between Keladevi Sanctuary and Ranthambhore NP (OBI)",
        ],
      },
      {
        district: "Kota",
        localities: [
          "Abheda Biological Park",
          "Abheda Mahal Talab",
          "Abhera Wetland",
          "Alania Dam",
          "Borabas",
          "Chambal Gorge (Nr Garadia Mahadev Temple)",
          "Chandraloi  Riverside",
          "Dharampura Road, Kota",
          "Garadia Mahadev Temple",
          "Girdharpura",
          "Government College Kota",
          "Kishore Sagar",
          "Kota Cantonment",
          "Kota--Chambal Gorge",
          "Left Main Canal of Chambal River, Kota (OBI)",
          "Mandirgarh",
          "Mukundara Hills Tiger Reserve, Kota",
          "Nayapura",
          "Outskirts of Kota City (OBI)",
          "Oxyzone Park",
          "Pond at Morpa Village (OBI)",
          "Rajasthan Technical University",
          "Rajgarh Village Wetland (OBI)",
          "Ranpur Wetland, Kota (OBI)",
          "Rawatbhata to Kota (OBI)",
          "Right Main Canal of Chambal River, Kota (OBI)",
          "Sakatpura Pond",
          "Sawan Bhado Dam",
          "Seven Wonder Park, Kota",
          "Sotiya Talai",
          "Udpuria Bird Sanctuary",
          "Udpuriya Village, Kota (OBI)",
          "Udpuriya Wetland",
          "Umedganj Talab",
          "Ummed Gung (Sur Sagar)",
          "Ummed Gung Talav-Southern side",
          "Ummedganj Wetland",
          "University of Kota",
          "Zohrabai Talab (Nr Nanta Rd)",
        ],
      },
      {
        district: "Nagaur",
        localities: [
          "Banwal Mata Hill Tract",
          "Chinpolai Talab, Parbatsar",
          "Didwana Wetland",
          "Goshala beed, Kuchaman City, Rajasthan",
          "Jaroda Pond",
          "Jashbantgarh",
          "Jaswantgarh Flats",
          "Khimsar (OBI)",
          "Kuchaman Salt Lake",
          "Nagaur  Ahichhatragarh Fort",
          "Sambhar Lake--Grassland",
          "Sambhar Lake--Nava Zone",
        ],
      },
      {
        district: "Pali",
        localities: [
          "Bagheera's Camp Lake",
          "Bera Safari Lodge",
          "Chadwas Pond",
          "Chhatra Sagar, Nimaj",
          "Desuri Lake",
          "Ghanerao and surrounds - Kumbalgarh",
          "JAWAI LEOPARD SAFARI LIFE",
          "Jawai Bandh/ Dam",
          "Jawai Dam",
          "Jawai Leopard Hills",
          "Jawai Nature Stay",
          "Jawai--General",
          "Kharda Talab",
          "Kumbhalgarh NP",
          "Leopard hills",
          "Marwar Junction",
          "Megh Malhar Midway",
          "Mihirgarh Fort",
          "Pali Batelav Pond",
          "Phulad Dam",
          "Rajpura Dam",
          "Ranakpur",
          "Ranakpur Jain Temple",
          "Rani Railway Station",
          "Sardar Samand Lake",
          "Sardarsamand",
          "Sena, Pali, Rajasthan",
          "Shivika Lake Resort",
          "Sujan Jawai Camp",
          "Talao",
        ],
      },
      {
        district: "Pratapgarh",
        localities: [
          "Collectorate Pratapgarh",
          "Luv Kush Vatika",
          "Pratapgarh, RJ (OBI)",
          "SItamata Wildlife Sanctuary",
          "Seetamata Forest Reserve",
        ],
      },
      {
        district: "Rajsamand",
        localities: [
          "Club Mahindra Kumbhalgarh",
          "Club Mahindra, Kumbhalgarh",
          "Club Mahindra--Kumbhalgarh",
          "Dariba talab",
          "Eklingji lake",
          "Eklingji temple lake",
          "Kumbalgarh Fort",
          "Kumbalghad Forest",
          "Mataji ka Khera Talab",
          "Rajsamand Lake",
          "Tiger Vally Resort",
          "swadadi B",
        ],
      },
      {
        district: "Sawai Madhopur",
        localities: [
          "Baler Talav",
          "Banas River",
          "Bhagwati Shikshak Prashikshan Mahavidyalay",
          "Bhomiya Ji Maharaj Temple",
          "Castle Jhumar Baori",
          "Chambal River Boat Tour - Rajasthan Side",
          "Delda Sagar",
          "Gangapur (OBI)",
          "Gangapur City Railway Station",
          "Hotel Dev Vilas, Ranathambore",
          "Hotel Tiger Kingdom",
          "Jungle Retreat Resort",
          "Khem Villas Jungle Camp",
          "Khilchipur Village",
          "Lahpur--Ranthambhore National Park",
          "Lakarda, Ranthambore National Park",
          "Lake Mansarovar",
          "MAA Farm (OBI)",
          "Morel Dam",
          "National Chambal Sanctuary--Pali",
          "Nazimwala Talav नाजिमवाला तलब",
          "Pali Farm, Chambal",
          "Pali--Thorny Scrub Forest (Bagh Villas Campsite)",
          "Palighat, Chambal River (OBI)",
          "Ranthambhore Heritage Haveli hotel",
          "Ranthambhore NP--Gilai Sagar Dam",
          "Ranthambhore NP--Zone 3",
          "Ranthambhore NP--Zone 5",
          "Ranthambhore National Park-South East",
          "Ranthambore Jalsa Resort",
          "Ranthambore Kothi Lodge",
          "Ranthambore NP",
          "Ranthambore NP--Ranthambore Fort",
          "Ranthambore NP--Zone 1",
          "Ranthambore NP--Zone 2",
          "Ranthambore NP--Zone 4",
          "Ranthambore NP--Zone 4--Kachida",
          "Ranthambore NP--Zone 4--Rajbagh",
          "Ranthambore NP--Zone 6",
          "Ranthambore NP--entry road & fort",
          "Ranthambore National Park--Khandar Fort",
          "Ranthambore TP--Zone 10",
          "Ranthambore TR--Zone 7",
          "Ranthambore TR--Zone 8",
          "Sawai Madhopur Railway Station",
          "Sawai Mansingh Wildlife Sanctuary",
          "Soorwal Lake",
          "Sujan Sher Bagh",
          "Taj Sawai Ranthambore Hotel",
          "The Oberoi Vanyavilas",
          "The Oberoi Vanyavilas (Restricted)",
          "The Pugmark Hotel",
          "The Ranthambore Bagh",
          "Tiger Den Resort",
          "Tiger Inn Comfort Resort Ranathambore",
          "Tiger Moon Hotel",
          "Tiger Moon Hotel-- Dry Hillock",
        ],
      },
      {
        district: "Sikar",
        localities: [
          "Arawali Veterinary College",
          "Basri Kalan",
          "Chitarwal Balaji Mandir",
          "Chopta (Sikar)",
          "Chopta shiv Temple",
          "Jaipur to Gurgaon Highway (OBI)",
          "Lalolav Balaji",
          "Mody University",
          "Mount Harsh & Surroundings",
          "Nani Bird Park, Sikar",
          "National Highway 52, near Sikar (OBI)",
          "Nechwa, Sikar Road, Rajasthan",
          "Raiwasa Lake & surroundings",
          "Shakambhari (Sakrai)",
          "Sikar--Smriti Van",
        ],
      },
      {
        district: "Sirohi",
        localities: [
          "Aarna Campsite",
          "Achalgarh area",
          "Azim Premji School (Restricted)",
          "Bailey's Nature Trail",
          "Goumukh--Mt.Abu",
          "Guru Shikar Temple",
          "Gurushikhar",
          "Javai--Mt. Abu",
          "Khokri khera Dam, Rajasthan",
          "Mount Abu",
          "Mt. Abu Wildlife Sanctuary",
          "Nakki Lake",
          "Oriya Lake",
          "Oriya Road",
          "Oriya Village",
          "Oriya Village area",
          "Raniya Khera",
          "Salgaon",
          "St. Mary High School Road",
          "Sunset Point area",
          "Swami Vivekanand Institute",
          "Trevor's Tank",
          "Upper Kodra Lake--Mt. Abu",
        ],
      },
      {
        district: "Tonk",
        localities: [
          "Bairwa Talav",
          "Banasthali Vidyapith (Restricted)",
          "Bharni",
          "Bisalpur Dam Water Catchment Area",
          "Mundiya Village, Tonk (OBI)",
          "Ranathambore Zone 9",
          "The Lotus Pond/ Mundiya Pond",
        ],
      },
      {
        district: "Udaipur",
        localities: [
          "Badi Talab",
          "Bagdarah Nature Park",
          "Bharmela Pond Menar",
          "Buddhaeshwar Mahadev Jhok/ Bujh Ka Naka",
          "Chirwa village pond",
          "City Palace, Udaipur",
          "Czar Palace Resort",
          "Dilip Niwas Homestay",
          "Dudh Talai",
          "Fateh Garh by Fateh Collection",
          "Fateh Sagar Lake",
          "Garbage dump near IIM Udaipur",
          "Govardhan Sagar Lake",
          "Gulab Bagh and Zoo",
          "Himmato Ki Bhagal",
          "Hotel Rajmahal Bhindar",
          "Hotel Trident Udaipur",
          "Jaisamand Island Resort",
          "Jaisamand Wildlife Sanctuary",
          "Jhameshwar Mahadev",
          "Jogi Talaab",
          "Jorji ka khera",
          "Kanuwara Bittu Da Dhaba",
          "Karni Mata Temple walking path, Udaipur",
          "Kewra Reserve Forest",
          "Krishi Vigyan Kendra, Bargaon",
          "Kumbalgarh--Bala Vera",
          "Kurra Bokhara",
          "Lake Taj Lake Palace, Udaipur",
          "Lakshman Sagar, Nauwa",
          "MPUAT--College of Community & Applied Sciences (CTAE)",
          "Menar Lake",
          "Mewar Biodiversity Park",
          "Mohanlal Sukhadia University Campus, Udaipur",
          "Nela Pond",
          "Pahada lake",
          "Peace Stop",
          "Pichola Lake, Udaipur",
          "Prakriti Saadhna Kendra, Vidya Bhawan",
          "Purohit Ki Talab",
          "Royal Cemetry",
          "Rundera and surrounds (Near Baroriya)",
          "Sahelion Ki Bari",
          "Sajjangarh WLS- Monsoon Palace",
          "Sajjangarh Wildlife Sanctuary",
          "Salumbar Lake",
          "Shilpgram",
          "Sukhadia Science College, Zoology Department",
          "Swaroop Sagar",
          "Taj Aravali Resort",
          "Tank",
          "Ubeshwar Mahadev",
          "Udai Sagar Lake",
          "Udaipur--Jungle Safari Park",
          "Vallabh Nagar and surrounding area",
          "Vallabhnagar Dam",
        ],
      },
    ],
  },
  {
    state: "Sikkim",
    districts: [
      {
        district: "East Sikkim",
        localities: [
          "15th Mile",
          "Agomlok",
          "Aritar",
          "Aritar--British Graveyard (Cultivation Field)",
          "Assam Lingzey Forest",
          "Baba Harhajan Singh Temple (OBI)",
          "Bedang Tso (Elephant Lake)",
          "Bedang Tso (Elephant Lake) View Point",
          "Budang Gadi Forest",
          "Changey Senti",
          "Changthang",
          "Changthang-Naitam-Pabyuik",
          "Dikling Pacheykhani Forest",
          "Dzuluk (Zuluk)",
          "East Pendam (Karmithang)",
          "Fambong Lho Wildlife Sanctuary",
          "Ganek View Point",
          "Gangtok--Bakthang Waterfall",
          "Gangtok--Banjhakri Waterfalls",
          "Gangtok--Chongay-Tathangchen",
          "Gangtok--Deorali",
          "Gangtok--General Area",
          "Gangtok--Hanuman Tok",
          "Gangtok--Jawaharlal Nehru Botanical Garden",
          "Gangtok--Plant Conservatory",
          "Gangtok--Ranka",
          "Gangtok--Ranka-Parbing",
          "Gangtok--Ridge Park (Chogyal Memorial Park)",
          "Gangtok--Sikkim Himalayan Zoological Park",
          "Gangtok--Tashi View Point (Bojoghari)",
          "Gnathang Valley",
          "Gnathang Valley View Point",
          "Hangu Lake (Tanyek Tso)--Sherathang",
          "Jawaharlal Nehru Botanical Garden",
          "Kashyone Khasmahal",
          "Khimseeka Eco Hut",
          "Khimseekha",
          "Khimsheeka Parkha Reserve Forest",
          "Kue Khola Falls",
          "Kumrek--4 Mile",
          "Kupup, East Sikkim  (OBI)",
          "Kyongnosla Alpine Sanctuary",
          "Lakshman Chowk",
          "Lampokhari Lake",
          "Lingtam",
          "Lower Nandok--Burpeepal Holiday Cottage",
          "Lungchok Top Nature View",
          "Lungthung (Longthu)",
          "Memencho Lake, East Sikkim",
          "Mulukey",
          "Namgyal Institute of Tibetology and Surroundings",
          "Nathu La (Pass)",
          "Nimachen",
          "Old Baba Mandir (Harbhajan Baba Mandir)",
          "Pabyuik Monastery",
          "Pachak Gompa",
          "Padamchen (OBI)",
          "Pakyong",
          "Pakyong--Dugalakha",
          "Pakyong--General Area",
          "Pakyong--Namchey Bung",
          "Pakyong--Samsing",
          "Pakyong--Yakteen Village Homestay",
          "Pangolakha WLS--General Area",
          "Pangolakha Wildlife Sanctuary",
          "Parkha Reserve Forest",
          "Phadamchen",
          "Phusray Lake (Mulkharka)",
          "Rache La (Rachela Pass)",
          "Rango River, Sikkim side.",
          "Rangpo Mining Forest",
          "Rangpo Town",
          "Ranipool--Saramsa",
          "Reshi Khola",
          "Rhenak",
          "Rhenock (OBI)",
          "Rhenock--Saoreni Gaon",
          "Rishi (Bengal-Sikkim border post) KP",
          "Rishikhola",
          "Rolep, East Sikkim (OBI)",
          "Rongli",
          "Rongli--Kalikhola",
          "Rumtek Monastery",
          "Sherathang--Manju Lake",
          "Sikkim University",
          "Sikkim University Guest House",
          "Singtam",
          "Sudunglakha",
          "Sumin Reserve Forest",
          "Tadong--General Area",
          "Tadong--Sikkim Government College",
          "Taj Guras Kutir Resort & Spa (Restricted Access)",
          "Talkharka",
          "Thambi View Point",
          "Thekabung",
          "Treenz Hotels Parking",
          "Tsomgo (Changu Lake)",
          "Voyage Glenz Resort",
          "West Pendam (Sisney Sautar)",
          "Youlas View Point",
          "Zuluk- Phadamchen",
        ],
      },
      {
        district: "North Sikkim",
        localities: [
          "Bakcha Bridge",
          "Bansoi Bridge",
          "Beechu Khedum Forest",
          "Bheem Nala Falls",
          "Chungthang",
          "Dzongu--Upper (Tingbong)",
          "Gurudongmar Army Checkpost",
          "Gurudongmar Lake",
          "Gurudongmar Plateau",
          "Gurudongmar Plateau--Last Point (Restricted Access)",
          "Kabi",
          "Kala Patthar",
          "Lachen",
          "Lachen Choling Monastery",
          "Lachen--Lower (Latong)",
          "Lachen--Zemu Chu Bridge",
          "Lachung",
          "Lachung--Upper (Katao)",
          "Lashar Valley \"Restricted Access\"",
          "Lhonak Valley--Muguthang",
          "Lower Dzongu--Gnon Samdong",
          "Lower Dzongu--Gor Village",
          "Lower Dzongu--Hee Gyathang",
          "Lower Dzongu--Lum Village",
          "Lower Dzongu--Sangtok Village",
          "Lower Dzongu--Tungkyong Dho Biodiversity Park",
          "Mangan",
          "Mangan--Helipad",
          "Meyong",
          "Munlom Nature Resort, Dzongu",
          "Naga Falls",
          "North Sikkim plateau (OBI)",
          "Pakshep-Kazor Forest",
          "Seven Sisters Falls",
          "Shingba Rhododendron Sanctuary",
          "Singhik Reserve Forest",
          "Thangu Valley (OBI)",
          "Thangu Valley--Talam Samdong",
          "Thangu--Lower (13,000 ft)",
          "Thangu--Upper (15,500 ft)",
          "Thangu--Yongdi",
          "Tso Lhamo (Restricted Access)",
          "Tumlong--Phodong",
          "Tung--Naga Falls",
          "Upper Dzongu --Lingthem",
          "Upper Dzongu--Barfok",
          "Upper Dzongu--Be",
          "Upper Dzongu--Khanchendzonga National Park",
          "Upper Dzongu--Laven",
          "Upper Dzongu--Lingdem",
          "Upper Dzongu--Lingdong",
          "Upper Dzongu--Lingzah",
          "Upper Dzongu--Mantam",
          "Upper Dzongu--Namprick",
          "Upper Dzongu--Noom Punong",
          "Upper Dzongu--Passingdang",
          "Upper Dzongu--Pentong",
          "Upper Dzongu--Sakyong",
          "Upper Dzongu--Sangkalang",
          "Yume Samdong (OBI)",
          "Yumesamdong",
          "Yumthang Valley",
          "Zero Point, Sikkim",
        ],
      },
      {
        district: "South Sikkim",
        localities: [
          "Badamtam Forest Range",
          "Barfung--Doling Monastery",
          "Bhaleydhunga - Maenam Wildlife Trail (Near Ropeway station atop)",
          "Borong",
          "Dorop",
          "Indian Himalayan Centre for Adventure and Eco-Tourism",
          "Jorethang",
          "Kewzing",
          "Kewzing--Bon Monastery",
          "Kewzing--Lower (Samsing-Dalep)",
          "Kitam Bird Sanctuary",
          "Kitam Village",
          "Maenam WLS",
          "Maenam Wildlife Sanctuary",
          "Menam Wildlife sanctuary",
          "Mt. Tendong",
          "Namchi (OBI)",
          "Namchi--Char Dham Temple Complex",
          "Namchi--Rock Garden",
          "Namchi--Samdruptse Monastery",
          "Ralong",
          "Rangit Nagar--General Area (OBI)",
          "Ravangla",
          "Ravangla--Barfung",
          "Satmile Village (OBI)",
          "Sipu Pul Bridge, Yangang Rd",
          "Tashiding Lower (Legship)",
          "Tathagata Tsal",
          "Temi--Biodiversity Park",
          "Temi--Damthang",
        ],
      },
      {
        district: "West Sikkim",
        localities: [
          "Barnyak Martam Forest",
          "Barsey Rhododendron Sanctuary",
          "Biksthang",
          "Biksthang (OBI)",
          "Club Mahindra, Baiguney",
          "Daramdin, Sikkim (OBI)",
          "Darap",
          "Dentam--Mangmung Khola",
          "Geyzing, Sikkim (OBI)",
          "Geyzing--Langang",
          "Government College, Geyzing",
          "Hee Burmiok (Hee Patal)",
          "Hilley (OBI)",
          "Hilley-Okhrey Road",
          "Hotel Red Palace",
          "Kaluk",
          "Khangchendzonga Falls",
          "Khangchendzonga NP--Bakhim Camp",
          "Khangchendzonga NP--Bikbari",
          "Khangchendzonga NP--Dzongri Camp",
          "Khangchendzonga NP--Dzongri La (Black Kabru Pass)",
          "Khangchendzonga NP--HMI Base Camp",
          "Khangchendzonga NP--Phedang Camp",
          "Khangchendzonga NP--Rathong Glacier Lake",
          "Khangchendzonga NP--Sachen Camp",
          "Khangchendzonga NP--Tsoka Camp",
          "Khecheopalri Lake",
          "Labdang",
          "Labdang Gangyep Forest",
          "Lamuney Camp (OBI)",
          "Legship Town",
          "Limboo Homestay, Gyalshing",
          "Magpie Pachhu Village Resort",
          "Okhrey",
          "Okhrey-Hilley Road",
          "Pelling (OBI)",
          "Pelling City",
          "Pelling--Pemayangtse Monastery",
          "Pelling--Rabdentse Bird Park",
          "Pelling--Sangachoeling Monastery",
          "Phamrong Falls",
          "Rangeet Dam/ Rangit Nagar Power Station (OBI)",
          "Rimbi Orange Garden",
          "Rinchenpong",
          "Samiti Lake",
          "Soreng Forest Block",
          "Tashiding--Rangit Forest",
          "Thangsing  Trekkers Hut",
          "Uttarey",
          "Yuksam (OBI)",
          "Yuksom",
          "Yuksom--Dubdi Monastery",
          "Yuksom--Kathok Lake",
        ],
      },
    ],
  },
  {
    state: "Tamil Nadu",
    districts: [
      {
        district: "Ariyalur",
        localities: [
          "Arulmozhi Lake அருள்மொழி ஏரி",
          "Elakurichi Lake",
          "Fossil Museum, Ariyalur",
          "Gangai Konda Cholapuram கங்கைகொண்ட சோழபுரம்",
          "Govindaputhur Lake கோவிந்தபுத்தூர் ஏரி",
          "Kandaradhitham Lake",
          "Karaikurichi Lake",
          "Karaivetti Bird Sanctuary கரைவெட்டி பறவைகள் சரணாலயம்",
          "Kollidam River Bridge, Ramanallur",
          "Kollidam river-- Thirumanur",
          "Kuzhumur Big Lake  (குழுமூர் பெரிய ஏரி )",
          "Marungoor East & Surrounds",
          "Palanganatham Lake",
          "Ponneri Lake",
          "Sripuranthan Lake",
          "Sukran Lake, Kamarasavalli",
          "Thamaraipoondi Lake தாமரைப்பூண்டி ஏரி",
          "Thoothur Lake",
          "Venganur Lake வெங்கனூர் ஏரி",
        ],
      },
      {
        district: "Chengalpattu",
        localities: [
          "Acharavakkam Lake",
          "Advanced Institute for Wildlife Conservation (AIWC)",
          "Agaram Village-- Chithamur (Kanchipuram) (அகரம்-- சித்தாமூர்)",
          "Agaramthen Lake",
          "Air Force Station, Tambaram",
          "Alamparai Fort--Estuary",
          "Alanthur RF- trail",
          "Alapakkam Nerkundram road",
          "Alathur Lake,Chengalpattu",
          "Ammanambakkam Panchayat (அம்மனம்பாக்கம்)",
          "Amoor Lake",
          "Arambakkam Lake",
          "Arappedu village (அரப்பேடு)",
          "Arignar Anna Zoological Park (Vandalur Zoo)",
          "Arignar Anna Zoological Park (Vandalur Zoo)-- Birds and Butterflies (அறிஞர் அண்ணா விலங்கியல் பூங்கா)",
          "Arignar Anna Zoological Park (Vandalur Zoo)--Otteri Lake",
          "Art of Living Saltpans",
          "Backwaters near to Kovalam Tollgate, ECR",
          "Balaji Nagar Park, Irumpuliyur",
          "Buckingham Canal",
          "Chengalpattu Medical College",
          "Chennai Mathematical Institute",
          "Chettipuniyum lake",
          "Chettipunniyam Lake",
          "Cheyyur (Town)",
          "Chinnaiyan Thangal",
          "Chitlapakkam Lake",
          "Dakshina Chitra Museum",
          "Dinesh Vihar Marsh",
          "ECR to Kovalam Surf School Bridge",
          "Echoor Lake",
          "Erandamkattalai",
          "Fields behind Mudichur lake",
          "Forest Genetic Resources Tree Park",
          "Gendracheri Lake (கெண்டிரச்சேரி ஏரி) Tamilnadu",
          "Grassland behind ECR Dhaba",
          "Great Salt Lake (opp. SSN college)",
          "GudalurRF2, Nandivaram",
          "Hasthinapuram Lake",
          "Hasthinapuram Lake Canal",
          "Hasthinapuram Lake Road (ஹஸ்தினாபுரம் ஏரி சாலை)",
          "Illalur Lake",
          "Illalur Reserve Forest",
          "Irumbuli Scrub",
          "Irumbuliyur Lake (North tank)",
          "JACANA LAKE-KVKKM",
          "Kadalur Bridge, Palar",
          "Kadaperi lake",
          "Kalavakkam wet lands",
          "Kalpakkam",
          "Kalpakkam Township",
          "Kalpakkam--Bridge",
          "Karadi Malai Camp",
          "Karikili Bird Sanctuary, Kancheepuram",
          "Karikili Birds sanctuary - Pond 2",
          "Kasbapuram",
          "Kattangulathur Lake",
          "Kattangulathur Reserve Forest",
          "Kattur RF",
          "Kattur Scrub Forest",
          "Kattur Thangal",
          "Kattur lake",
          "Kayar Lake",
          "Kayarambedu Chitteri",
          "Kelambakkam",
          "Kelambakkam Backwaters",
          "Kelambakkam Bypass Rd - Wetlands and Salt Pans",
          "Kelambakkam Bypass Road Marsh West",
          "Kilkattalai Lake",
          "Kolapakkam (Vandalur-Kelambakkam Rd.)",
          "Kolapakkam lake (Nedumkunram Otteri)",
          "Kolathur R.F",
          "Kolavai Lake",
          "Kondangi Lake",
          "Koovathur",
          "Kovalam Beach",
          "Kovalam Boominathar temple",
          "Kovalam Surfing Point",
          "Kumizhi Lake, Nallambakkam",
          "Kumizhi Reserve Forest",
          "Kurinji Nagar Play Ground",
          "Lazy Grasshopper Farm Area",
          "Light House-- Mahabalipuram (New)",
          "Light House-- Mahabalipuram (Old)",
          "MCC Campus-- Matriculation Higher Secondary School (Restricted Access)",
          "Madayathur Lake",
          "Madippakkam Lake",
          "Madras Christian College (MCC)",
          "Madras Crocodile Bank Trust",
          "Madurantakam Lake",
          "Madurapakkam Scrub (Reserve Forest)",
          "Mahabalipuram Backwaters",
          "Mahabalipuram Beach",
          "Mahabalipuram Light House",
          "Manampathy Lake",
          "Mannivakkam Lake",
          "Maraimalai Nagar Railway Station",
          "Maruntheeswarar Temple Girivalam Path, Thirukachur",
          "Melakottaiyur Big lake",
          "Melmaruvathur Lake",
          "Milakathamman Pond (மிளகாத்தம்மன் குளம்) Chennai",
          "Mongoose Campsite",
          "Moolacheri Lake",
          "Mudhaliarkuppam- Muttukadu Backwaters - Edaikazhinadu Lagoon",
          "Mudichur Lake",
          "Mudichur lake",
          "Muttukadu Backwaters",
          "Muttukadu Backwaters, Kovalam",
          "Muttukadu Boat House area",
          "Muttukadu Bridge East Side",
          "Muvarasanpattu Eri",
          "Naduthangal Lake",
          "Nandhivaram Lake",
          "Nanmangalam Lake",
          "Nanmangalam Reserve Forest",
          "Nedumgundram Lake",
          "Nemilicheri",
          "Nemmeli Salt Pans",
          "Netrambakkam Eri, Tamil Nadu",
          "New Perungalathur lake",
          "Ninnakarai Lake, Maraimalai Nagar",
          "OMR Kelambakkam Marsh",
          "Odiyur Lake",
          "Odiyur Lake Bridge",
          "Odiyur Lake-- Paramankeni Bridge",
          "Old Perungalathur lake, Perungalathur.",
          "Othivakkam Tank",
          "Ottiyambakkam Big Lake (ஒட்டியம்பாக்கம் பெரிய ஏரி)",
          "Ottiyambakkam Small Lake",
          "Ozhalur Kadaperi",
          "Ozhavetti Eri",
          "Ozone Techno Park, Navalur",
          "PGRIAS - Kattupakkam",
          "Paalar Urban Farms (Restricted Access)",
          "Pachaimalai",
          "Padalam-Vedanthangal Road",
          "Palar Check dam",
          "Palar Estuary - Watching Point",
          "Pallambakkam--Saltpans (பள்ளம்பாக்கம், உப்பளம்)",
          "Pallavaram-Thuraipakkam 200 feet Radial Road (Vels Point)",
          "Pancha Rathas, Mahabalipuram",
          "Paranur Lake",
          "Pathashaala, KFI",
          "Pattaravakkam (Kanchipuram) (பட்டரவாக்கம்)-- near Anjaneyar Temple",
          "Pattipulam wetlands",
          "Periyar Lake, Pallavaram",
          "Perumbakkam Village",
          "Perungalathur",
          "Perungalathur Lake",
          "Perungalathur Openland",
          "Polacheri Lake",
          "Ponmar Thangal",
          "Pooncheri Wetland and Scrub Jungle",
          "Potheri Lake",
          "Pudupakkam, Tamil Nadu, IN (12.791, 80.205)",
          "Pudupattu Lake",
          "Puduthangai Lake",
          "Purvankara Swanlake, Padur, Chennai",
          "Rajakizhpakkam Lake",
          "SIPCOT Pond (Restricted access)",
          "SP Kovil - Hanumanthapuram Road",
          "SRM Lake, Potheri",
          "SRM University Main Campus",
          "SSN Institution",
          "Selaiyur",
          "Selaiyur Lake",
          "Sirudavoor Area",
          "Sirudhavur Lake (சிறுதாவுர் ஏரி)",
          "Sirukalathur",
          "Siruseri Lake",
          "Siruseri-- Eden Park Avenue",
          "Sithalapakkam Lake and Reserve forest (சிதலபக்கம் ஏரி மற்றும் காப்பு காடு)",
          "Sonalur Periya Eri",
          "Sri Nithya Kalyana Prasanna Venkatesa Perumal temple (Restricted access)",
          "Sri Sairam Engineering College",
          "TTK Nagar Ground",
          "Tambaram Sanatorium Railway Station",
          "Thaiyur - Forest Area",
          "Thaiyur Lake",
          "Thaiyur lake",
          "Thazhambur (தாழம்பூர்) Big Lake",
          "The School-KFI campus - (Restricted) - Thazhambur (தாழம்பூர்)",
          "Thirukachur Lake",
          "Thirukalukundram Hill",
          "Thirukazhukundram Lake",
          "Thiruneermalai Periya Eri",
          "Tiger Lily lake",
          "Tiruneermalai",
          "Vadanamelli Village",
          "Vallam Reserve Forest",
          "Vandalur Lake",
          "Vandalur Outskirts",
          "Vandalur Repeater Road",
          "Vedanthangal Bird Sanctuary",
          "Vedanthangal Scrubland (வேடந்தாங்கல் முள் காடுகள்)",
          "Vembedu lake",
          "Venbedu Scrubland & Lake",
          "Vengapakkam--ECR",
          "Venmari Rocky Scrublands",
          "Vinayagapuram RF",
          "Vivanta by Taj",
          "Zamin Endathur",
          "Zoho Corporation",
          "pandur",
          "தேசிய சித்த மருத்துவ நிறுவனம், National Institute Of Siddha, Tambaram Sanatorium, Chennai",
        ],
      },
      {
        district: "Chennai",
        localities: [
          "Adambakkam Lake",
          "Adayar River Trail-- Manapakkam",
          "Adayar River Trail-- Nandambakkam",
          "Adayar River, Cowl Bazar",
          "Adayar River-- Buckingham Canal Junction",
          "Adayar River-- Tharapakkam",
          "Adayaru Creek--Foreshore Estate End",
          "Adayaru Creek--Karpagam Avenue Bridge",
          "Adayaru Creek--South Canal Bank Rd. Junction",
          "Adayaru Estuary",
          "Adayaru--Elphinstone (Old) Bridge",
          "Adayaru--Thiru-Vi-Ka (New) Bridge",
          "Adyar River View point",
          "Adyar River--Saidapet (அடையாறு ஆறு-- சைதாப்பேட்டை)",
          "Adyar river, Back sideof YMCA ground and AU,Kotturpuram.",
          "Akkarai Beach",
          "Amir Mahal, Royapettai",
          "Anna Centenary Library",
          "Anna Salai--LIC Building End",
          "Anna University Campus",
          "Anna Walkers Park, Kodambakkam",
          "Annakkili Amma Research Institute--(Restricted access)",
          "Annanagar Tower Park Pond",
          "Arasankazhani Lake",
          "Arihant marsh",
          "Arupadai Veedu Temple Beach",
          "Ayanavaram Tree Garden",
          "Bay of Bengal: 13.0N 80.7E",
          "Besant Nagar-- 1st Cross Street",
          "Besant Nagar-- Metro Water Grounds",
          "Birla Planetarium, Chennai, Tamil Nadu, IN",
          "Broken Bridge Road, Chennai, Tamil Nadu, IN (13.008, 80.275)",
          "Buckingham Canal Marsh, Sholinganallur",
          "Buckingham Canal, ECR to OMR Road (ISKCON)",
          "Buckingham Canal--Park Town",
          "Butt Road-Paul Wells Road Junction",
          "CLRI Marsh",
          "Chennai Airport-- North-east end",
          "Chennai Airport-- Primary Runway",
          "Chennai Airport-- Secondary Runway",
          "Chennai Airport-- Terminal building",
          "Chennai Snake Park Trust",
          "Chennai--Fishing Harbour-N4 Beach",
          "Chetpet Lake -- Eco park (சேத்துப்பட்டு ஏரி - ஈகோ பூங்கா)",
          "Cooum River Mouth Watching Point",
          "Cowl Bazar",
          "D.G.Vaishnav college",
          "DLF Ramapuram",
          "Deccan Enclave (restricted access)",
          "Dharmambal Polytechnic",
          "Elite School of Optometry",
          "Elliots Beach",
          "Ethiraj College for Women",
          "Gerugambakkam",
          "Gopathi Narayanaswami Park",
          "Government Museum Chennai",
          "Govt Siddha Medical College, Anna Arch Road",
          "Guindy NP",
          "Guindy Snake Park",
          "Herbal Park, Zone 6, Ward 74",
          "IIT Madras (Restricted Access)",
          "IIT Madras--SAC (Restricted Access)",
          "IIT-Madras--Lake (Restricted Access)",
          "IIT-Madras--Velachery End (Restricted Access)",
          "IITM--Madras Avenue",
          "IMU Campus - Uthandi ( Restricted Access)",
          "Independence Day Park (சுதந்திர தின பூங்கா)",
          "Indian Maritime University",
          "Indira Nagar Park (இந்திரா நகர் பூங்கா)",
          "Indira Nagar--Adyar",
          "Injambakkam",
          "Island Grounds, Chennai",
          "Juhu Beach Range, Chennai",
          "KCG College of Technology",
          "Kailash Nagar",
          "Kalakshetra Campus",
          "Kalakshetra Colony",
          "Kalakshetra Foundation",
          "Kallu Kuttai Lake",
          "Kanathur",
          "Karanai Eri",
          "Kasimedu Fishing Harbour",
          "Kazhikundram, Taramani",
          "Kendriya Vidyalaya DGQA",
          "Kendriya Vidyalaya, Meenambakkam",
          "Kottivakkam",
          "Kottivakkam Beach",
          "Kotturpuram Bridge",
          "Kotturpuram Urban Forest",
          "Kovilambakkam Lake",
          "Kumaran Nagar",
          "Lalaji Memorial Omega International School",
          "Leela Palace (restricted access)",
          "Light House-- Chennai",
          "Loyola College",
          "M.CT.M. Chidambaram Chettyar International School",
          "MEASI",
          "Madras Veterinary College-- Boys Hostel (Restricted)",
          "Madras Veterinary College--Department of Wildlife Science",
          "Manali Grounds",
          "Manapakkam-- Marvel Riverview",
          "Marakayar Nagar",
          "Marina Beach, near Dr.MGR Memorial",
          "Medavakkam Eri",
          "Meenambakkam Rly Station",
          "Mylapore--General Area (OBI)",
          "Nanganallur --TNGO Colony Main Road",
          "Napier's Bridge - Swami Sivananda Salai - Opposite Madras University",
          "Narayanapuram Lake",
          "Narayanapuram Lake-- Southern part",
          "Neelankarai",
          "Netaji Nagar Agricultural Layout",
          "Nungambakkam Railway Station",
          "Officers Training Academy",
          "Olcott Memorial School",
          "Opposite La Celeste - Porur",
          "Padmanabha Nagar",
          "Palavakkam",
          "Pallavaram Forest",
          "Pallikaranai -Rajalakshmi Nagar",
          "Pallikaranai Marsh - Eastern",
          "Pallikaranai Marsh-- 200 ft. Radial Road (SH 109)",
          "Pallikaranai Marsh-- 200ft Radial Road -Opposite NIOT",
          "Pallikaranai Marsh-- Eastern side",
          "Pallikaranai Marsh-- Kamakoti Nagar",
          "Pallikaranai Marsh-- Karapakkam-North side",
          "Pallikaranai Marsh-- Kattaboman Kulam",
          "Pallikaranai Marsh-- Land fill",
          "Pallikaranai Marsh-- Ma Po Si Nagar End",
          "Pallikaranai Marsh-- Main - பள்ளிக்கரணை சதுப்பு நிலம்",
          "Pallikaranai Marsh-- Marshland Park (Restricted Access)",
          "Pallikaranai Marsh-- Midlands",
          "Pallikaranai Marsh-- Opposite Balaji Dental college",
          "Pallikaranai Marsh-- Perungudi End",
          "Pallikaranai Marsh-- Sholinganallur End",
          "Pallikaranai Marsh-- Southern End",
          "Pallikaranai Marsh-- Southwest Watchtower",
          "Pallikaranai Marsh-- Viewing Point-1 (roadside access)",
          "Pallikaranai Marsh-- Viewing Point-2 (roadside access)",
          "Pallikaranai Marsh-- Viewing Point-3 (roadside access)",
          "Pallikaranai Marsh-- Viewing Point-4 (roadside access)",
          "Pallikaranai Marsh-- Viewing Point-5 (roadside access)",
          "Pallikaranai Marsh--Karapakkam",
          "Pallikaranai Marshland  - FD Interpretation Centre/Conservatory",
          "Pallikaranai-- Kulattur",
          "Pallikaranai-- Lotus Pond",
          "Pallikaranai-- Temple Pond",
          "Panagal Park--T.Nagar (பனகல் பூங்கா--தியாகராய நகர்)",
          "Panaiyur",
          "Periyapanicheri - Chennai Bypass",
          "Periyar Bridge Chintadripet Station",
          "Perumbakkam Lake",
          "Perungudi lake",
          "Presidency College, Chennai",
          "Puzhuthivakkam Lake,Chennai",
          "Queen Mary's College (ராணி மேரி கல்லூரி)",
          "Ram Nagar Swamps, Madipakkam",
          "Ramakrishna Mission Vivekananda College, Mylapore",
          "Royapettah Clock Tower",
          "Semmancheri--OMR",
          "Semmozhi Poonga",
          "Senganthal Poonga",
          "Sholinganallur Lake",
          "Sholinganallur/Perumbakkam Marsh (Western end)",
          "Sholinganallur/Perumbakkam Marsh-- Embassy Residency end",
          "Sholinganallur/Perumbakkam Marshland- Classic Farms",
          "Sholinganallur/Perumbakkam Marshlands",
          "Shri Ram Chandra Mission, World Headquarters, Chennai",
          "Simpsons Estate, Sembium",
          "Sishya School",
          "Sithalapakkam",
          "St Thomas Mount",
          "Stella Maris College",
          "Taj Coromandel -[restricted access]",
          "Tech Mahindra Campus, Elcot SEZ",
          "Temple Pond, Nanganallur",
          "Thazhambur  Karanai Eri",
          "The Central Park South (restricted access)",
          "The Farm, Semmancheri",
          "The Institute of Mathematical Sciences",
          "Theosophical Society",
          "Theosophical Society-- Damodar Gardens [old \"The School-KFI campus]\"",
          "Thirisulam Railway Station",
          "Thiruvanmiyur",
          "Tholkappiar Ecological Park",
          "Tirusulam Hillock",
          "Tirusulam eri",
          "University of Madras, Chennai",
          "Unnis Ali street",
          "Uthandi - ECR",
          "VOC Nagar",
          "Vadakkupattu Lake",
          "Valmiki Nagar Beach & Thickets",
          "Velachery Lake",
          "Veteran Lines-- No Man's Land",
          "Vettuvankeni",
          "Women's Christian College (WCC)",
          "World University Service Center, Chennai, Tamil Nadu, IN",
          "YMCA Ground (ஒய்.எம்.சி.ஏ. மைதானம்)",
        ],
      },
      {
        district: "Coimbatore",
        localities: [
          "1st HB to Loam's View",
          "Aathupollachi (ஆத்துப்பொள்ளாச்சி)",
          "Aavarangulam (ஆவாரங்குளம்)",
          "Achankulam",
          "Achipatti Region",
          "Agrahara Samakulam (அக்ரஹார சாமக்குளம்)",
          "Air Force Naval Housing Enclave (AFNHE)",
          "Aiyasamy Temple Foothills",
          "Akkamalai forest gate, Valparai",
          "Akkamalai, Valparai",
          "Alanthurai Foothills",
          "Aliyar Dam Viewpoint",
          "Aliyar View Point",
          "Aliyar dam",
          "Allikulam (Annur)",
          "Allikulam(Annur)",
          "Ambarampalayam",
          "Amrita School of Engineering",
          "Amrita Vishwa Vidyapeetham",
          "Anaikatti Ghat section",
          "Anaikatti Road",
          "Anaikatti, Coimbatore",
          "Anaimalai Town",
          "Anally Tea Estate,Valparai (Restricted Access)",
          "Anamalai Orchidarium, Attakatti",
          "Anamalai Tiger Reserve--Topslip",
          "Animals Rehabilitation Centre (Restricted Access)",
          "Anna University Regional Campus, Coimbatore",
          "Annai Ayyammal Nagar, Opposite to SBOA School, Pattanam",
          "Annamalais, Tamil Nadu (OBI)",
          "Annur Lake (அன்னூர் குளம்)",
          "Antara Stay, Vellamadai",
          "Anuvavi Murugan Temple",
          "Ardhanari Palayam, Near Anamalai Tiger Reserve",
          "Aringar Anna Park (அறிஞர் அண்ணா பூங்கா )",
          "Athikadavu River",
          "Attakatti",
          "Attakatti to Waterfalls",
          "Avinashilingam Engineering Campus, Varappalayam",
          "Baralikadu Boat House",
          "Bedathapuram Hill, Karamadai",
          "Belladi Lake",
          "Bharathappuzha River, TN Side",
          "Bharathapuzha -- Ambarampaayam",
          "Bharathi Park",
          "Bharathi Park Area, Saibaba colony",
          "Bharathiyar University (பாரதியார் பல்கலைக்கழகம்)",
          "Bhavani River Bank, Nellithurai",
          "Bilichi Grass Land",
          "Black Thunder Water Park (Restricted Access)",
          "Booluvampatty Area",
          "Botanical Survey Of India-Southern Regional Centre",
          "Bungalow Medu",
          "CMS Engineering college",
          "CSI Matriculation Hr Sec School, Race Course",
          "Central GST Division Office",
          "Chavadippara Cell No. ( 85.34.3)",
          "Cheran Ma Nagar Area",
          "Chettipalayam Grassland",
          "Chettipalayam Scrub Jungle (செட்டிபாளையம் புதர்க்காடு)",
          "Chettipalayam Tank (செட்டிபாளையம் குளம்)",
          "Chinna Kallar, Valparai",
          "Chinna Vedampatti Lake (சின்னவேடம்பட்டி ஏரி)",
          "Chinnakkuttai (சின்னக்குட்டை)",
          "Chinnampathy Road",
          "Cinchona Govt. High School, Valparai",
          "Coconut Research Station, Aliyar",
          "Codissia Shrub Grounds",
          "Coimbatore District Small Industries Association (CODISSIA)",
          "Coimbatore Railway Junction",
          "Compost Yard, Vellalore",
          "Contour Canal Road",
          "Covai S3 retirement community",
          "Devambadi Valasu",
          "Devampalayam Check Dam",
          "Devarayapuram Village",
          "Dhayanur, Anaikatti RF range",
          "Disha A Life School",
          "Disha School Backside",
          "Feeder Canal Road",
          "Flushing Meadows, Globus Garden, Kaikolapalayam, Tamil Nadu",
          "Forest College and Research Institute",
          "Forest Hill Academy",
          "Forest college to Kotagiri 1st HB",
          "GCT college",
          "Gandhavayal, Near Lingapuram, Sirumugai",
          "Ganganarayana Samudram/ Perur Chettipalayam Lake",
          "Gaumara Madalayam",
          "Gopalapuram (Village)",
          "Gopanari Reserve Forest",
          "Government Arts College, Coimbatore",
          "Government Boys Higher Secondary School, Thondamuthur",
          "Government Girls Higher Secondary School, Thondamuthur",
          "Government High School, Sugunapuram",
          "Government Higher Secondary School, Alandurai",
          "Government Higher Secondary School, Arasur",
          "Government Higher Secondary School, Sundappalayam",
          "Govindanur",
          "Govt High School--Rottikadai",
          "Govt. High School, Marappalam",
          "Hornbill View Point",
          "IFGTB, Coimbatore",
          "IOB Colony, Maruthamalai Foothills",
          "Idigarai Outskirts",
          "Irugur Railway Junction",
          "Irugur Railway Station",
          "Isha Home School",
          "Iyerpadi - Balaji Temple Road",
          "Jadayampalayam Pudur Village - Farmlands and Wetlands",
          "Jaganari Slopes",
          "Jayashree Tea Factory Area",
          "Jeevanandha Puram",
          "K'sirs International School",
          "KPR Institute of Engineering & Technology",
          "Kadathur Kulam (கடத்தூர் குளம்)",
          "Kalam Kuttai",
          "Kalangal Grassland",
          "Kalappa Naicken Palayam Grasslands",
          "Kalingarayan / Kondayampalayam Kulam (காளிங்கராயன்/ கொண்டையம்பாளையம் குளம்)",
          "Kaliyaperumal Kuttai (கலியபெருமாள் குட்டை) / Kalapatti wetland",
          "Kaliyapuram Lake",
          "Kallamadai Thottam Grassland",
          "Kallar Horticultural Garden",
          "Kallar Reserve Forest",
          "Kallipalayam Grassland",
          "Kallipalayam lake",
          "Kamatchipuram Grassland",
          "Kammalapatti Kuttai",
          "Kammalapatti Kuttai 2",
          "Kanamanaikanur Outskirts",
          "Kannampalayam Grasslands",
          "Kannampalayam Lake, Coimbatore",
          "Karamadai Kuttai (காரமடை குட்டை)",
          "Karattumedu (கரட்டுமேடு)",
          "Karian Shola Indira Gandhi Wildlife Sanctuary and National Park",
          "Karl Kubel Centre For Education, Anaikatti Road",
          "Karpagam College of Engineering",
          "Karpagam Institutions, Coimbatore",
          "Karumalai Balaji Temple",
          "Karumathampatti",
          "Karunya University",
          "Kasthuri Naickenpalayam Region",
          "Kathira Kuttai",
          "Kaundanur Pond",
          "Kavarkal to Iyerpadi",
          "Keeranatham Tank",
          "Kinathukadavu Grassland",
          "Kittampalayam Grassland",
          "Kolarampathy Lake",
          "Kondanoor, Anaikatti",
          "Kongunadu Arts & Science College, G.N. Mills",
          "Kosuvamadai Village",
          "Kovai Hills Grass Land",
          "Kovai Kutralam",
          "Kowshika River Bridge",
          "Krishnampathi Lake, Seeranaickenpalayam",
          "Krisshna Lake",
          "Kulathuppalayam Kuttai",
          "Kumaraguru College of Technology",
          "Kumaraswamy Lake (Muthannan Kulam)",
          "Kumittipathi River Bridge",
          "Kumran Kundru (குமரன் குன்று)",
          "Kunjapanai GTR school",
          "Kunjapannai Forest RF",
          "Kurangumudi Area",
          "Kurichi Kulam",
          "Kurumbanoor, Tamil Nadu, IN (11.28, 76.924)",
          "LGB Nagar",
          "Loam's view  to Attakatti",
          "Madheswaran Hills Grassland",
          "Madukkarai",
          "Madukkarai Quarry",
          "Malumichampatti Pond",
          "Mannarkkad Forest Division--Kerelamedu towards Siruvani Dam",
          "Mannur Village Area",
          "Marudhamalai Foothills--Temple",
          "Mathipalayam Foothills",
          "Mavuthampathi Mini Forest",
          "Melmudi",
          "Mettupalayam",
          "Mettupalayam (OBI)",
          "Mettupalayam Railway Junction",
          "Monkey Falls",
          "Moolapalayam / Pooluvapatti Foothills",
          "Mudis Pond, Valparai",
          "Mulli Checkpost",
          "Mungilmadai Kuttai",
          "Muniyappan Kovil Kulam",
          "Muthugoundanur Govt High School",
          "NGM college of Arts and Science",
          "NRI Gardens,Cheran MaNagar",
          "Nallamudi View Point",
          "Nallichettipalayam Pond",
          "Nandankarai Check Dam, Sadivayal",
          "Nanjundapuram Area",
          "Narasampathi Lake",
          "Narasipuram Forest Checkpost",
          "Narasipuram--General Area (OBI)",
          "Navamalai Road, Aliyar Dam",
          "Nayakkanur Pond",
          "Nilgiri Biosphere Nature Park",
          "Nirmala College for Women",
          "North Coimbatore Railway Station",
          "Old Valparai Fragment",
          "Othimalai",
          "PAP CANAL",
          "PSBB millennium School",
          "PSG College of Arts & Science",
          "PSG Sarvajana Higher Secondary School, Coimbatore",
          "Pachapalayam Dry Grasslands",
          "Palamalai Hills",
          "Palamalai Trekking path",
          "Pallapalayam Lake",
          "Panapalli",
          "Pappampatti Grassland",
          "Parambikulam Tiger Reserve--Karian Shola",
          "Peelamedu Grasslands",
          "Peelamedu Railway Station",
          "Periya Kuttai",
          "Periyakallar Village",
          "Periyakuttai (பெரிய குட்டை)",
          "Periyanaikanpalyam Railway Station",
          "Perumal Kovil Pathy",
          "Perumal Mudi (Restricted Access)",
          "Perumal malai (Sri Navilkundru Srinivasaperumal Kovil)",
          "Perur-Sundakkamathur Lake/ Perur Puttuveeki Lake",
          "Petthikuttai lake",
          "Podanur Railway Station",
          "Police Recruitment School (PRS)",
          "Pollachi Town Area",
          "Pollachi-Valparai Rd Hairpin bend 38",
          "Ponnuthu",
          "Poochamarathur Eco Tourism Centre, Coimbatore, Tamil Nadu, IN",
          "Poompuhar Nagar, Thudiyalur",
          "Puliyangaradu (புலியங்கரடு)",
          "Puravipalayam Grassland",
          "Puthu Thottam Estate, Valparai",
          "Raakachi Garden",
          "Race Course,Coimbatore",
          "Ramanathapuram Higher Sec School Pollachi",
          "Ramapattinam Village",
          "Rangampalayam, Grass Hills",
          "Ravathur Road Lake",
          "Rottigoundanur Check Dam",
          "Rottigoundanur Village Road",
          "STM Bungalow,Valparai",
          "Sacred Heart Matric Higher Secondary School",
          "Sadivayal Elephant Camp",
          "Salim Ali Centre for Ornithology and Natural History (SACON)",
          "Sappanimadai Kuttai",
          "Satchidananda Jothi Nikethan International School",
          "Selva Chinthamani Kulam (செல்வ சிந்தாமணி குளம்)",
          "Selvampathy Lake",
          "Semisanpalayam Grassland",
          "Semmandampalayam Tank",
          "Sengulam Lake, Coimbatore",
          "Senjerimalai",
          "Sennamalai Murugan Temple",
          "Sethumadai (Town)",
          "Shanthi Social Service Park",
          "Sholayar Dam",
          "Shri Mahathma Vidhyaa Manthir",
          "Singanallur Lake, Coimbatore",
          "Singanallur Railway Junction",
          "Sirikundra Bungalow Area",
          "Siruvani Veethi",
          "Siruvani Water Treatment Plant Surroundings",
          "Sivanadapuram",
          "Solai Malai (சோலை மலை)",
          "Soolakkal Grasshland",
          "Soolakkal River",
          "Special Economic Zone,Coimbatore",
          "Sri Avinashilingam Education Trust Instituitions",
          "Sri Krishna Arts And Science College",
          "Sri Vanamuthumariamman Temple",
          "Stanmore, Valparai",
          "Subbe Gounden Pudur",
          "Sulur Lake, Coimbatore",
          "Sundakkamuthur Area",
          "TNAU Botanical Gardens, Coimbatore",
          "Tahr Trails Bungalow, Sheikalmudi",
          "Tamil Nadu Agricultural University (TNAU)",
          "Tamil Nadu Agricultural University, Coimabtore",
          "Tamilnadu Forest Academy",
          "Thamaraikulam (தமரைக்குளம்)",
          "Thandikai Aranganathar Temple",
          "Thaneerpanthal Anti-poaching camp, Manjoor-Mulli Road",
          "Thappittai Kizhavan Puthur (தப்பிட்டை கிழவன் புதூர்)",
          "The Western Ghats International School, Ettimadai",
          "Thengallkaradu (தெங்கல்கரடு)",
          "Thenmalai Fragment",
          "Thillaiyamman Nagar",
          "Thiruvalluvar Nagar Area",
          "Thudiyalur Railway Station",
          "Thuri Palam",
          "Ukkadam Big Tank, Coimbatore",
          "Ukkulam / Muttathuvayal Lake",
          "Upper Sholayar Dam",
          "Urumandam Palayam Kuttai",
          "VLB Janakiammal Arts And Science College",
          "VOC Park and Zoo, Coimbatore",
          "Vachinampalayam",
          "Vadambacheri Outskirts",
          "Vaidyanatha Swamy Temple Lake,Sulur",
          "Valankulam Lake",
          "Valankulam--Chinna Kulam",
          "Valasu kulam",
          "Valparai Dump yard",
          "Valparai Mount Terrain Resort Area",
          "Valparai Plateau",
          "Valparai--Monica Garden Bungalow",
          "Valparai--Sinnadorai (Rottikadai)",
          "Valparai--Sinnadorai (Upper Paralai)",
          "Valparai--Thalanar Road",
          "Valparai--UPASI",
          "Valparai--Urulikal Checkpost to Manamboli",
          "Valparai--Varattuparai",
          "Vanam Mini Forest",
          "Varagaliyar Elephant Camp",
          "Vedapatti Lake",
          "Vedar Colony",
          "Veerappagoundanur",
          "Vellakinar Village Area",
          "Vellakinar pond",
          "Vellalore Lake",
          "Vellamadai Outskirts",
          "Vellanaipatti Grassland",
          "Velliangiri Temple Path",
          "Venkittapuram Grassland",
          "Vettaikaranpudur (Town)",
          "View point, Pollachi - Valparai Road",
          "Vilankurichi Pond",
          "Walayar Lake-Tamil Nadu side",
          "Walayar Reserve Forest--Chinnampathy",
          "Waterfalls to Kavarkal",
          "Yuvabharathi Public School",
          "Zamin Kaliyapuram Village Area",
          "Zamin Uthukuli Area",
          "​Whispering Falls Resort Area",
        ],
      },
      {
        district: "Cuddalore",
        localities: [
          "Alagappasumudram Lake (அழகப்பாசமுத்திரம் ஏரி)",
          "Annamalai University Campus அண்ணாமலை பல்கலைக்கழக வளாகம்",
          "Athirikuppam Pond (ஆத்திரிக்குப்பம் குளம் )",
          "Bahour Lake--TN Side (பாகூர் ஏரி--தமிழ்நாடு பகுதி)",
          "Behind Villudaiyanpattu Murugan Temple, Vanadirayapuram,",
          "C.A.S. in Marine Biology, Annamalai University",
          "Capper Hills Lake",
          "Chidambaram Bus Stand & Surrounds சிதம்பரம் பேருந்து நிலையம் & சுற்றுப்பகுதி",
          "Ezhumedu Lake",
          "Gadilam Estuary",
          "Government Cuddalore Medical College and Hospital (Rajah Muthiah Medical College and Hospital), Chidambaram",
          "Hayagriva Temple",
          "KSB farms",
          "Kallur Pond",
          "Kandarakottai Lake",
          "Kedilam River--Keezh Arungunam",
          "Kedilam River--Old Bridge (near Panruti Taluk Office)",
          "Kedilam River--Siruvathur Eripalayam",
          "Kedilam River--Thiruvandhipuram Bridge",
          "Kedilam River--Vanamadevi Bridge",
          "Kokkupalayam Lake",
          "Krishnapuram Lake (கிருஷ்ணாபுரம் ஏரி)",
          "Kurinjipadi Lake",
          "Kurungudi Lake",
          "Lakshmi Vilas Hotel, T. Neduncheri",
          "Light house-- Cuddalore",
          "Lighthouse-- Porto Novo",
          "Malattaru-Kedilam River Convergence Point (via Elandhampattu)",
          "Mangalur (மங்களூர்)",
          "Mangrove Bay Ecocamp, Kanakkarapattu",
          "Marudadu Pond",
          "Meedhukudi Road",
          "Muthiah Nagar",
          "Muzhukkuthurai (Killai)",
          "Nallathur Lake (நல்லாத்தூர் ஏரி)",
          "Natham Lake",
          "Pallipattu Lake (பள்ளிப்பட்டு ஏரி)",
          "Parangipettai Fishing Port Area",
          "Perumal Lake (பெருமாள் ஏரி)",
          "Pethanayakkankuppam Lake",
          "Pichavaram Mangrove Forest",
          "Rasapalayam Lake (ராசாபாளையம் ஏரி)",
          "River Vadavaru, Near Veeranam Lake",
          "Sedapalayam Lake",
          "Singarakuppam (நஞ்சைமகத்துவாழ்க்கை)",
          "Sri Chithramuthu Adigalar Aruloli Gnana Nilayam, Kambalikarankuppam (ஸ்ரீ சித்திரமுத்து அடிகளார் அருளொளி ஞான நிலையம்)",
          "Subauppalavadi Beach (சுப உப்பளவாடி)",
          "Then Pennai River--Manamedu Bridge",
          "Then Pennai River--Soriyankuppam Bridge",
          "Then Pennai River--Sornavoor Bridge",
          "Then Pennai River--Vellapakkam Bridge (near Azhagiyanatham)",
          "Tholudhur Checkdam",
          "Thookkanaampaakkam Lake (தூக்கணாம்பாக்கம் ஏரி)",
          "Tiruppanaambakkam Lake (திருப்பணாம்பாக்கம் ஏரி)",
          "Ulleripattu Lake (உள்ளேரிப்பட்டு ஏரி)",
          "Usuppur",
          "Vadavadi Lake, Tamil Nadu, IN (11.56, 79.311)",
          "Vazhuthalampattu Lake",
          "Veeranam Lake (வீராணம் ஏரி)",
          "Veeranam Lake - Vazhakollai",
          "Vellar River Bridge",
          "Vilangalpattu Lake",
          "Wellington Lake, Thittakudi",
        ],
      },
      {
        district: "Dharmapuri",
        localities: [
          "Aalapuram Lake | ஆலாபுரம் ஏரி",
          "Ammapalaiyam Reserve Forest",
          "Annasagaram Lake, Dharmapuri",
          "Baisuhalli Lake",
          "Dharmapuri Lake, Mathikonpalayam",
          "Dhippampatti Lake",
          "Gandhipalayam Lake",
          "Green Park School, Kadathur",
          "Hanging Bridge-- Hogenakkal (ஹேங்கிங் பிரிட்ஜ்-- ஹோகேனக்கல்)",
          "Hogenakal Waterfalls",
          "Hogenakkal-- Children's Park (ஹோகேனக்கல்)",
          "Ilayakkimpatti Lake, Dharmapuri",
          "Kadagathur Lake",
          "Kadathur Lake & Surrounds கடத்தூர் ஏரி & சுற்றுப்பகுதி",
          "Kalrayan Hills",
          "Kalrayan Hills--Sittling Bridge",
          "Kattamedu Social Forestry Centre (and surrounding scrub)",
          "Kesarkuli Dam கேசர்குளி அணை",
          "Kovilur Lake கோவிலூர் ஏரி",
          "Malaiyur Hill",
          "Metturankottai Dam & Surroundings",
          "Modakeri Malai Birding Area",
          "Moongilpatti Area",
          "Nachinampatti Lake (அரூர் பெரிய ஏரி)",
          "Nagamathi Hillock",
          "Nagavathi Reservoir",
          "Nearby Naikuthi Raman Farm, Sittilingi Extension R.F நாய்குத்தி ராமன் தோட்டம் அருகில், சிட்லிங் R.F",
          "Old Thulir Campus",
          "Onaampatti Lake | ஓணாம்பட்டி ஏரி",
          "Panamarathu Lake (Athikarippatii)  பனமரத்து ஏரி (அதிகாரிப்பட்டி)",
          "Panchapalli Dam, Dharmapuri",
          "Paraiyapatti Pudur Lake ( பறையப்பட்டி புதூர் ஏரி)",
          "Pennagaram Lake",
          "Periyanahalli Lake",
          "Puvidham Campus",
          "Settikarai Lake",
          "Sitteri Water Tank, Pappireddipatti சித்தேரி ஏரி, பாப்பிரெட்டிப்பட்டி",
          "Sri Vijay Vidyalaya College of Arts and Science, Balajangamanhalli",
          "Stanley Reservoir--Nagamarai Parisalthurai",
          "Thoppaiyaru Reservoir",
          "Thulir Old Campus, Sittlingi",
          "Valasamalai RF (Iora habitat)",
          "Valathampatti Kombai, Sittilingi Extension R.F வலத்தாம்பட்டி கோம்பை, சிட்லிங் R.F",
          "Vallimadurai Reservoir",
          "Vanapa Natural & Sustainable Farm",
          "Vaniyar Dam வாணியாறு அணை",
          "Vathalmalai Hills, Dharmapuri",
          "Vellaparai Falls, Ammapalaiyam R.F வெள்ளைப்பாறை அருவி, அம்மாபாளையம் R. F",
          "Vellolai Road Forest Area",
          "Venkatasamuthiram Lake | வெங்கடசமுத்திரம் ஏரி",
          "தென்கரைக்கோட்டை ஏரி ( Thenkarai Kottai Lake)",
        ],
      },
      {
        district: "Dindigul",
        localities: [
          "AKKAMAR TEMPLE",
          "Adalur",
          "Adukkam Forest",
          "Akkamar Temple, Ayyampalayam",
          "Alagapuri Dam (அழகாபுரி அணைக்கட்டு)",
          "Alagar Malai",
          "Alagarkovil-- Thethampatti (Western Slopes- 2)",
          "Alagarkovil-- Thethampatti (Western slopes -1)",
          "Alternate Route to Bison valley from Kallalagar Temple",
          "Ambathurai Railway Station(அம்பாத்துரை இரயில் நிலையம்)",
          "Anaadi Gurukulam and Surroundings",
          "Anaipatti kulam",
          "Aranmanai Kulam",
          "Athoor",
          "Attur Kamarajar Sagar Dam",
          "Ayakudi Kulam",
          "Ayallore Area",
          "Ayyalur",
          "Ayyampulli Kulam",
          "Balasamudram Kulam, பாலசமுத்திரம் குளம்",
          "Bear Shola Stream, Kodaikanal",
          "Berijam Lake, Palani Hills",
          "Berijam Range, Kodaikanal Div.",
          "Bharatiya Vidya Bhavan's Gandhi Vidyashram, Kodaikanal",
          "Bodikamanvadi Pond",
          "Bodiya Koundanpatti Lake",
          "Bombay Shola, Kodaikanal",
          "Bryant Park, Kodaikanal",
          "Chettiyar Park",
          "Chinnamalai, Alagarkovil Western slopes",
          "Coaker's walk, Kodaikanal",
          "Dindigul-- Periyur",
          "Dindigul-- Vembarpatti-- Kalathu Kottam-Agriculture Farm",
          "Dindugal Fort",
          "Elephant Valley",
          "Elephant Valley Eco Farm (OBI)",
          "Fairy Falls Road",
          "Forest Rest House Surroundings, Kodaikanal",
          "Fruits n Beans Mountain Resort Area",
          "Grey Wagtail Falls, Palani Hills",
          "Gudalur Sellakulam",
          "Guna Caves",
          "Gundupatti, Palani Hills",
          "Idayakottai",
          "Idumban Kulam, Palani",
          "Indian Grey Hornbill Spot",
          "KIS Guest House (Restricted Access)",
          "Kalari Forest School",
          "Kamarajar Sagar Dam , Palni Hills foothills",
          "Kanalkadu",
          "Kannapatti Tank",
          "Karandamalai General Area",
          "Karungkuttu Karuppanasami Temple Sacred Grove, Natham Dindigul",
          "Kasampatti Veera Koil Sacred Grove ( Veera Bahu Thevar Koil )",
          "Kesavan/ Thesam Koil Kaadu Sacred Grove",
          "Khandige Wildlife Preservation, Sirumalai",
          "Kilisholai parai, Palani Hills",
          "Kodai Foothills",
          "Kodaikanal Lake Road",
          "Kodaikanal Municipality- General area",
          "Kodaikanal Solar Observatory Area",
          "Kodaikanal to Mannavanur road",
          "Kodaikanal-- Kodaikanal International School (Lochend)",
          "Kombai Dam , Palni Hills foothills",
          "Kombaikadu Village",
          "Kombi Ayyanar sacred grove Kathampatti",
          "Kookal Lake",
          "Kookal, Kodaikanal",
          "Kothaimangalam Kulam",
          "Kothaimangalam Wetlands",
          "Kudaganaaru Dam குடகனாறு  அணை",
          "Kudhirayar Dam, Palani Hills",
          "Kumbakarai Falls",
          "M. Vadipatti tank",
          "Madurai Veeran Koil Sacred Grove, Sakkilian Kodai",
          "Mangalamkombu",
          "Manjalparappu, Perumparai (மஞ்சள் பரப்பு, பெரும்பாறை)",
          "Mannavanur / Elumpallam Lake",
          "Maruthanathi Dam , Palni Hills foothills",
          "Maruthuva Nagar,Palani",
          "Mother Teresa Women's University, Attuvampatti",
          "Muthanampatty",
          "Nallammal Errammal Temple Area, Thoopupatti",
          "Nanganji dam near",
          "Nilakottai Tank",
          "Oorkalan Temple Sacred Grove, Odugampatti, Natham'",
          "Paara Kulam, Ayakudi",
          "Palaiyur, Sirumalai",
          "Palani Hills-- 3rd Hairpin bend",
          "Palani Hills-- Palar Dam view",
          "Palani Murugan Temple Hillock",
          "Palani city view point near Poombarai, Palani Hills",
          "Palani-Kodaikanal Hill Road",
          "Palar  Dam, Palni Hills Foothills",
          "Palar Dam View Point",
          "Palaru dam Odai side, பாலாறு அணை ஓடை பகுதி",
          "Pallangi, Palani Hills",
          "Pannapatti Kombai Dam , Palni Hills foothills",
          "Panrimalai",
          "Pantrimalai",
          "Pappakulam",
          "Paraapallar Dam",
          "Parappalaru Forest, Palani Hills",
          "Pattikulam Lake",
          "Peria Aruvi Valley, Transect 2, Alagarkovil range, Natham Taluk,",
          "Peria Aruvi valley, Alagarkoil Hills",
          "Peria aruvi valley, Alagarkoil hills, Natham tk, Dindigul dt",
          "Periyur, Palani Hills",
          "Periyur, on Oddanchatram-Pachalur- Adalur Road",
          "Perumal Malai, Palani Hills",
          "Perumparai",
          "Perumparai Environmental Centre",
          "Pethuparai Valley",
          "Polur Falls (போளூர் நீர்வீழ்ச்சி)",
          "Poombarai Town",
          "Poombarai View Point",
          "Poondi Dam",
          "Pothi Alagar Sacred Grove",
          "Rajalakshmi nagar",
          "Ramayyan Patti Kulam",
          "Sadaiyankulam, Oddanchatram",
          "Sadayandi Temple, Maruthanathi Dam  , Palni Hills foothills",
          "Savarikaddu",
          "School ground,Vellagavi",
          "Sholai School",
          "Sholai School, Kodaikanal",
          "Silambar Valley Transect 1",
          "Silambaru II, above Pazhamuthircholai",
          "Silver Cascade Waterfall",
          "Sirumalai Reserve Forest- General area",
          "Sirumalai--Mavoor Dam",
          "Sivagiripatti--River confluence (Palani)",
          "Sothuparai Dam, Periakulam",
          "Tapovan (Restricted Access)",
          "Thadiyankudisai Area",
          "Thadiyankudisai, Palani Hills",
          "Thalaiyuthu Falls",
          "Thalapathi Veeran Sundaralingam lake",
          "Thandikudi",
          "Thandikudi Forest",
          "Thandikudi to Pannaikadu Road, தாண்டிகுடி - பண்ணைக்காடு ரோடு",
          "Thathala Appuchi Koil Sacred Grove, Sakkilian Kodai",
          "Thattankulam Tank",
          "The Gandhigram Rural Institute, Chinnalapatti",
          "The Tamara Kodai",
          "Thekkanthottam on Palani Ghat Road ( Kodaikanal to Palani Road ), Palani Hills",
          "Upper Shola (Lake view) Road, Kodaikanal",
          "Vaaranam Farm",
          "Vadamalai",
          "Vaiyapuri Tank Palani city",
          "Varathamanathi Dam, Palani Hills",
          "Varathapattinam, Dargah",
          "Vattakanal",
          "Vayalur",
          "Vazhakaatu Odai",
          "Vedasandur Minor Colony Area",
          "Veeramatchi Amman Kovil, Athimarathuvasalu",
          "Veeramudayan Koil Sacred Grove",
          "Veerapannai Medu Continous with Alternate Route to Bison Valley",
          "Vel Farms",
          "Vellagavi - Kodaikanal Trail",
          "Vembarali Forest Bungalow",
          "Vilpati Forest Area",
          "Vilpatti-Palani Rd.",
          "Wetland to the east of rope car station,Palani",
          "aranmanai kulam",
          "tannery kulam",
          "vengadasthirikottai",
        ],
      },
      {
        district: "Erode",
        localities: [
          "Aappakoodal Lake (ஆப்பக்கூடல் ஏரி)",
          "Agastya Academy Campus",
          "Ananthasagar Tank, P. Mettupalayam",
          "Andi Kulam (ஆண்டிகுளம்) Bhavani-AnthiyurRoad",
          "Anthiyur Periya Yeri Lake",
          "Arasannamalai",
          "Arepalayam, Erode",
          "Aruvankorai Lake (அருவங்கொரை குளம்), Kolappalur",
          "Avalpoondurai Lake",
          "Bannari Forest Check Post",
          "Bargur Cattle Research Station",
          "Bargur, Erode Dt",
          "Bejjalatti",
          "Bhavani River, Gopichettipalayam",
          "Bhavanisagar Backwaters, Pethikuttai",
          "Bhavanisagar Dam--Ammapalyam Scrub",
          "Bhavanisagar Dam--Bhavani River Viewpoint",
          "Bhavanisagar Sithankuttai",
          "Brammatheeratha Kulam, Murugatholuvu, Chennimalai",
          "Chennimalai",
          "Chennimalai Murugan Temple Hillock சென்னிமலை முருகன் கோவில் பகுதி",
          "ChettiKuttai (Lakshmanan Kuttai), Emmampoondi",
          "Chettiyampalayam Lake (செட்டியாம்பாளையம் குளம்), Kolapalur",
          "Chinna Goundam Palayam, Gobi",
          "Dhimbam - Bannari Ghat Rd",
          "Dhimbam -- Kottadai",
          "Dhimbham",
          "Elathur Pond (எலத்தூர் குளம்)",
          "Elumathur Hills and Surroundings",
          "Emmampoondi Check Dam, Nambiyur எம்மாம்பூண்டி தடுப்பணை, நம்பியூர்",
          "Ennamangalam lake",
          "Erangattur Lake, Kolathukaadu R.F [Restricted Access]",
          "Erode Railway Junction",
          "Erode Silver Jubilee Bus Stand",
          "Erode--Thangam Nagar",
          "Ethukatti Hillock. Erode",
          "Gethasal, Hasanur",
          "Getti Samudram Lake, Anthiyur கெட்டி சமுத்திரம் குளம், அந்தியூர்",
          "Gobi RTO Office Hill, Polavakalipalayam",
          "Gobichettipalayam Buglowpudur Road",
          "Gobichettipalayam, Avvaiyaar Paalayam",
          "Gobichettipalayam, Kulavikaradu backside",
          "Gobichettipalayam, Lakkampatti",
          "Government Arts & Science College Sathyamangalam (சத்தியமங்கலம் அரசு கலை அறிவியல் கல்லூரி)",
          "Hasanur Range Office",
          "Hassanur",
          "Ittarai",
          "Jalander Lake",
          "Kaalingarayar Dam",
          "Kadambur Range",
          "Kadarai (Small Check Dam), Nambiyur",
          "Kadayampatti Madam, Erode",
          "Kalingarayan Canal, Thirunagar Colony",
          "Kamaraj Matriculation Higher Secondary School",
          "Kanaga Malai (கனகமலை), Elumathur",
          "Kanagapuram Pond (கனகபுரம் குளம்)",
          "Kaniravuthar Lake Inlet Stream (Al-Ameen School Palam)",
          "Kanniamman Kovil Small Pond, Emmampoondi கன்னியம்மன் கோவில் குட்டை, எம்மாம்பூண்டி",
          "Kannimar Malai (கண்ணிமார் மலைக் குன்று), Gangapuram",
          "Karachikorai Forest Check Post--STR",
          "Karanampalayam Checkdam, Kodumudi",
          "Karattadipalayam, Gobichettipalayam",
          "Karungal Palayam",
          "Karuvilparai Valasu Kulam",
          "Kattalai Barrage",
          "Kavulipalayam Lake",
          "Kedarai Check Dam கெடாரை குளம்",
          "Kolathukadu Reservoir (Erangattur Kulam)",
          "Komarapalayam Kuttai, OlalaKoil, Erode",
          "Komarapalayam Small Kuttai, Olalakovil",
          "Kombai Kulam Sempulichampalayam, Nagalur R F",
          "Kongahalli",
          "Kottadai",
          "Kullampalayam Pond(குள்ளம் பாளையம் குளம்)",
          "Kunderipallam Dam",
          "Kuppipalayam Odai (Check Dam), Komangattupalayam, Nambiyur",
          "Kuppipalayam Small Pond (Check Dam), Emmampoondi குப்பிபாளையம் குட்டை, எம்மாம்பூண்டி",
          "LBP Canal Kanuvakkarai",
          "LBP Canal- Palakkarai",
          "LBP Canal- Sellappampalayam",
          "LBP Canal-K K Valasu",
          "Lower Bhavani Project Canal - Nasiyanur Kulam",
          "Lower Bhavani Project Canal - Olapalayam",
          "Lower Bhavani Project Canal - Vadumugam Vellode",
          "Maniyachi Pallam Bridge",
          "Mayar Valley--STR",
          "Mevani",
          "Moonampalli Lake (மூணாம் பள்ளி குளம்)",
          "Mudiyanur Pond",
          "Mullampatti Tank",
          "Nadupalayam Ficus Tree (இச்சி மரம்), Kurumandur",
          "Nagamalai Hillock Forest (எலத்தூர் நாகமலைக் குன்று)",
          "Nambiyur Kulam (நம்பியூர் குளம்)",
          "Nanjanapuram checkdam நஞ்சனாபுரம் தடுப்பணை",
          "Neithalapuram Pond",
          "Nithyavanam, Vellimalai, Erode",
          "Odaikattur Kulam",
          "Odathurai Lake (ஓடத்துறை குளம்)",
          "Odathurai Small Tank (Maarappampalayam Lake) ஓடத்துறை சின்ன குளம் (மாரப்பம்பாளையம் குளம்)",
          "Orathupalayam Dam",
          "Ottakuttai Road, Sathyamangalam",
          "Paariyur Vaaikal Road",
          "Pachai Malai Hill Lock (பச்சை மலை), Gobichettipalayam",
          "Palani Andavar Temple Hillock, Maarappampalayam பழனி ஆண்டவர் கோவில் மலைக்குன்று, மாரப்பம்பாளையம்",
          "Palanigoundan Puthur Lake (Check Dam), Nambiyur, Erode பழனிகவுண்டன் புத்தூர் ஏரி தடுப்பணை, நம்பியூர், ஈரோடு",
          "Palappalayam Stream (பாலப்பாளையம் பள்ளம்)",
          "Palar (Near Banavadi Reserve Forest)",
          "Palar Bridge, Tamil Nadu side (enroute--from Karaikadu Police Check Post till Palar Bridge-5km stretch)",
          "Palar River basin ( Garkekandi Bus -stop)",
          "Palatholuvu Kulam",
          "Panayampalli Grasslands",
          "Pariyur Kovil, Gobichettipalayam",
          "Pavala Malai (பவள மலை), Gobi",
          "Perunthalaiyur Bhavani River (பெருந்தலையூர் பவானி ஆறு)",
          "Pichandampalayam Pond (பிச்சாண்டம்பாளையம் குளம்) Otthakkuthirai",
          "Polavakkalipalayam Pond (பொலவக்காளிபாளையம் குளம்)",
          "Poothimalai Kulam, Erode, Tamil Nadu, IN",
          "Pudubeerkadavu Farmlands",
          "Pudupeerkadavu",
          "Ramabylur Lake, Sathyamangalam",
          "Ring Road Pond",
          "Sampath Nagar, Erode",
          "Sandhana Karuppaswami Temple Pond, Nambiyur சந்தான கருப்பசுவாமி கோவில் குளம், நம்பியூர்",
          "Sathiyamangalam Wildlife Sanctuary--Hasanur",
          "Sathyamangalam Bus Stand",
          "Sathyamangalam TR - APW Watchtower - Thengumarahada",
          "Sathyamangalam Tiger Reserve--Dhimbum-Mavanatham Road",
          "Sathyamangalam Tiger Reserve--Germalam",
          "Sathyamangalam Tiger Reserve--Jeerakahalli",
          "Sathyamangalam Tiger Reserve--Koolithuraipatti",
          "Sathyamangalam Tiger Reserve--Mangalapatti",
          "Sathyamangalam Tiger Reserve--Thalamalai",
          "Siluvakal, Karkaykandi RF East, TPWLS,",
          "Siviyarpalayam Hillock, Sathyamangalam (சிவியார்பாளையம் குன்று), சத்தியமங்கலம்",
          "Sri Karuvannarayar Temple Area--STR",
          "Sri Vasavi College ஸ்ரீ வாசவி கல்லூரி",
          "Sujalkarai",
          "Sungai Lake",
          "SunnaiParai",
          "Talamalai",
          "Thamarakarai",
          "Thamarakarai Lake தாமரைக்கரை குளம்",
          "Thanaka Maram, Malayappalayam",
          "Theerthakumarasamy Temple Hillock (Nagamalai), Arachalur தீர்த்தகுமாரசாமி கோவில் மலைக்குன்று (நாகமலை), அரச்சலூர்",
          "Thindal",
          "Thindal - Karaparai",
          "ThittaMalai (திட்டமலை), Nambiyur",
          "Thottani Pond",
          "Unnamed Pond On Kongu Engineering College - Vaikkalmedu Road, Perundurai",
          "Urathchikottai Malai Hills ஊராட்சிக்கோட்டை மலை",
          "Urathchikottai malai hills ஊராட்சிக்கோட்டை மலை",
          "Vaikal Road, Min Nagar",
          "Vairapalayam Miyawaki forest",
          "Vallipuratham Palayam",
          "Varattu Pallam Dam (வறட்டுப்பள்ளம் அணை) [Restricted access], TPWLS",
          "Vavval Lake, Kattuppalayam வௌவால் ஏரி, காட்டுப்பாளையம்",
          "Vellalapalyam Kuttai, Nambiyur",
          "Vellalar College for Women",
          "Vellampatti APW Camp, Thattakarai  RF, TPWLS",
          "Vellode Bird Sanctuary, Erode வெள்ளோடு பறவைகள் சரணாலயம், ஈரோடு",
          "Vellode Kulam",
          "Vembathi Ari Lake (வேம்பத்தி ஏரி)",
          "Vengampudur",
          "Vettaikarankoil Lake (வேட்டைகாரக்கோவில் ஏரி)",
        ],
      },
      {
        district: "Kallakurichi",
        localities: [
          "AKT Memorial School Campus Kallakurichi",
          "AMC Hospital. Opp. Thennkeeranur Canal",
          "Aandimalai Jain Beds, Sholavandipuram",
          "Aathu Kaadu, Manmalai",
          "Alathur -- Puthanur Road",
          "Alathur Lake, Kallakurichi",
          "Bharathi School Behind Thenkeeranur Lake",
          "Boat House, Kariyalur",
          "Chinnasalem Lake (சின்னசேலம் ஏரி)",
          "CholavandipuramTemple",
          "Emapper Lake, Kallakurichi",
          "Eranji",
          "Eranji Lake",
          "Eravalam Lake",
          "Esandai Lake",
          "Ettiyaaru Falls",
          "Gomuki Dam",
          "Gomuki River Kallakurichi",
          "Government Middle School,Siruvangur",
          "Kalamarudur Lake, Kalamarudur",
          "Kalasamuthiram Yeri",
          "Kallakkurichi-- Uraliyappan Temple-Koondalur-- Sacred Forest",
          "Kallakurichi Lake",
          "Kallakurichi Town",
          "Kallakurichi-- Nagar Iyyannar Kovil Lake",
          "Kottaimedu -- Surroundings",
          "Kottaimedu, Kallakkurichi",
          "Kottaimedu, Kallakurichi",
          "Kuraal Tank குரால் ஏரி",
          "Kurur Lake",
          "Malaikottalam R.F",
          "Malliampadi",
          "Melathayanur Lake",
          "Melnariyappanur Village",
          "Melparigam R.F",
          "Mount Carmel School",
          "Mount Carmel School Road",
          "Neelamangalam Lake, Kallakurichi",
          "Palengur Big Lake",
          "Palengur Small Lake",
          "Panchayath Union Middle Class, Manmalai",
          "Parigam RF Ghat Road",
          "Parigam Road, Gomuki Dam",
          "Pasumaimangalam Road",
          "Periyar Waterfalls பெரியார் நீர்வீழ்ச்சி",
          "Peruvangur Village",
          "Pridivimangalam Lake",
          "Puthagaram lake (புத்தகரம் ஏரி)",
          "Puthur Lake (புதூர் ஏரி)",
          "Rangeppanur R.F",
          "Rishivandiyam Lake, Tamil Nadu, IN (11.806, 79.094)",
          "Sandapet Lake (Periya Yeri)",
          "Sembimadevi Lake (செம்பிமாதேவி ஏரி)",
          "Sinnavaram Tank",
          "Sirunavalur Forest",
          "Siruvangur Village",
          "Sitheri Lake",
          "Sorayapattu Lake, Tamil Nadu",
          "Sri Sooriyamman Temple",
          "Thagarai Forest",
          "Thagarai Lake",
          "Thandalai lake",
          "Thenkeeranur Lake (தென்கீரனூர் ஏரி)",
          "Thirukoilure Temple Area",
          "Thiyagapadi Amman Temple,Gomuki Dam",
          "V. Alambalam Lake",
          "V. Krishnapuram Lake, Tamil Nadu, IN (11.57, 78.904)",
          "Vadakanandal / Vadakanandal Lake",
          "Vaniyanthal Lake (வாணியந்தல் ஏரி)",
          "Vedapoondi",
          "Veerapayangaram Lake",
          "Veerattagaram Lake",
          "Velli Water Falls, Vellimalai வெள்ளி அருவி, வெள்ளிமலை",
          "Vellimalai Forest Guest House, Tamil Nadu, IN (11.808, 78.702)",
          "Vengur Big Lake",
          "Venkatampatty Lake",
          "Vilambaur Lake",
          "Vilambur",
          "Vilandai Lake, Tamil Nadu, IN (11.979, 79.143)",
        ],
      },
      {
        district: "Kancheepuram",
        localities: [
          "Adayar River-- Channel (Neelamangalam)",
          "Adayar River-- Channel (Overbridge)",
          "Adhanur Lake--East",
          "Adhanur Lake--West",
          "Adhanur lake",
          "Amarambedu Lake",
          "Amarambedu Scrub Land",
          "Amarampedu Lake அமரம்பேடு ஏரி",
          "Anakaputhur lake",
          "Athananchery Lake",
          "Chembarambakkam Lake",
          "Chembarambakkam Lake, Irungattukottai",
          "Erumaiyur",
          "Good Earth School",
          "Guduvanchery Lake",
          "Guruvanmedu Eri(Lake)",
          "Irungattukotai Lake -(East side) இருங்காட்டுக்கோட்டை ஏரி",
          "Kancheepuram (OBI)",
          "Karai Lake",
          "Kartampakkam Lake",
          "Kattavakkam Wetlands",
          "Kattrambakkam Small Lake",
          "Kavanur Lake",
          "Kilar (கீழாறு)",
          "Lake Neat VGN Brixton, Mevalurkuppam",
          "Le Chalet Road, Mevalurkuppam",
          "Mahanyam Lake",
          "Malaipattu",
          "Malayankulam Big Lake",
          "Manimangalam Lake",
          "Mannur Lake (மண்ணூர் ஏரி)",
          "Mevalurkuppam",
          "Mevalurkuppam-- VGN Brixton road (13.006, 79.987)",
          "Nathapettai Lake",
          "Nattarasanpattu Lake (நாட்டரசன்பட்டு ஏரி)",
          "Nattarasanpattu-- Arambakkam Road",
          "Neerkundram",
          "Nemili Lake நெமிலி ஏரி",
          "Nemili Twin Lake நெமிலி இரட்டை ஏரிகள்",
          "Oragadam Lake",
          "Pennalur Lake (Behind EB office)",
          "Perunagar (பெருநகர்)",
          "Pillaipakkam/Navalur Lake",
          "Ponneri Lake",
          "Pullalur (புள்ளலூர்)",
          "Serappanachery",
          "Sethupet",
          "Shree Niketan Patasala",
          "Shri Perumbudur Lake",
          "Sittiyambakkam",
          "Sivanthangal Pond, Sriperumputhur",
          "Somangalam",
          "Somangalam Periya Eri",
          "Somangalam Quarry",
          "Sri Venkateswara College of Engineering, Chennai",
          "Sriperumputhur Lake (Thiruvallur Road)",
          "Suramenikuppam Lake",
          "Thandalam Lake (தண்டலம் ஏரி)",
          "Thenneri Lake",
          "Thimmarajampet",
          "Uthiramerur Lake",
          "Uthukadu Pond",
          "Vaiyavoor Lake",
          "Valarpuram Lake",
          "West Tambaram -- Casa Grande Environs",
          "இளநீர்குளம் (Ilaneerkulam)",
          "எழில்வனம் ஸ்ரீபெரும்புதூர்(Ezhilivanam, Sriperumbudur)",
          "தாமல் ஏரி (Damal Lake)",
        ],
      },
      {
        district: "Kanniyakumari",
        localities: [
          "Alur Pond and Paddy fields",
          "Anantya Resort Survey",
          "Andivilai Salt Pans",
          "Anjugramam Pond",
          "Anna Bus Stand",
          "Annathi Lake, Thekkumalai East",
          "Aruvikarai  Water Falls",
          "Asambu",
          "Asaripallam Medical College",
          "Atchankulam Pond",
          "Beemanagari Lotus Pond, Nagercoil",
          "Boothapadi Pond",
          "Chengulam",
          "Chitharal Rock Jain Temple",
          "Chittar Dam 2",
          "Chittar Dam-1",
          "Chittar Dam-2nd point",
          "Chittar dam 1",
          "Chunkankadai Lake",
          "Cinnapatta Malai, Kottavilai",
          "Colachel Harbour",
          "Colachel River",
          "Derisanamcope paddy fields",
          "District Forest Office, Vadasery",
          "Dwarakapathi beach",
          "East Road, Paalkulam",
          "Eco Park, Kanyakumari",
          "Elayanainarkulam Lake",
          "Erachakulam Lake",
          "Eraviputhoor  Lake",
          "Eraviputhoor Paddy fields",
          "Esanthimangalam Paddy Field",
          "GHSS Ottaiyalvilai",
          "Indian Ocean: 8.0N 77.5E",
          "KNSK College, Thadakamalai Foothills",
          "Kalikesam Eco Camp",
          "Kalikesham, Kanyakumari wildlife sanctuary",
          "Kalimalai",
          "Kallukuttam paddy field",
          "Kanniyakumari Beach",
          "Karumparai (Black Rock)",
          "Keezha Puthalam Salt Pans",
          "Kodayar Twin falls",
          "Kothayar Lower Camp Road",
          "Kovalam salt pan",
          "Kumari Dam, Oottuvalmadam",
          "Kumarisalai Pond",
          "Kuthrapaanjan Falls",
          "Kuzhithurai Bridge",
          "Kuzhithurai Cultivations",
          "Kuzhithurai Railway Station, Marthandam",
          "Lemur Beach",
          "Maharajapuram-Kannankulam Ponds, Anjugramam",
          "Mambazhathurayar Reservoir",
          "Manakudi River Mouth",
          "Manakudy Backwater Bridge",
          "Manakudy Beach",
          "Manakudy Beach View Point",
          "Manakudy Mangrove Forest",
          "Manakudy Mangrove Park",
          "Manikaputhery Lake",
          "Marundhuvazh Malai",
          "Marundhuvazh Malai forest",
          "Marungoor Road, Kumarapuram Thoppur",
          "Melapulluvilai Paddy Field",
          "Muhilankudieruppu Beach",
          "Muhilankudiyuruppu paddy field",
          "Mukkadal Dam",
          "Muppandal Wind Farm",
          "Mylaudy Lake",
          "Nagercoil Rly Jn",
          "Nagercoil Town Rly Station",
          "Nagercoil-- Parvathipuram Lake (South)",
          "Nalloor Lake",
          "North Thamarai Kulam Pond 1",
          "North Thamarai Kulam Pond 2",
          "Old Salt Pan, Near Govt.Arts College, Paulkulam Anjigramam Pancjayat",
          "Ozhuginasery Graamam",
          "Paalkulam Pond, Pottaiyadi",
          "Paatu Kulam, Arockiapuram",
          "Paddy fields near New highway",
          "Palkulam lake",
          "Pallakulam Pond",
          "Paloor Lake, Kanjikuzhi",
          "Parai Kulam",
          "Paraikal Beach, Alanchi",
          "Parakkai Lake",
          "Pathukani",
          "Pazhayar River view, Suchindram",
          "Pechiparai Dam",
          "Perimkulam Lake",
          "Periya Kulam",
          "Perunchani Dam",
          "Perunkulam",
          "Ponmanai Dam",
          "Puliangulam Pond",
          "Puthalam Salt Pans",
          "Putheri Lake",
          "Puthukulam",
          "Rajakamangalam Lake",
          "Rasthakaadu Beach",
          "Salt Pans, Swamithoppu",
          "Sankaranputhoor",
          "Sankaranputhoor சங்கரன்புதூர்",
          "Sarada Medical College,Kulashekaram",
          "Shalom Hospital Backyard",
          "South Thamarai Kulam Pond",
          "St Thomas Church, Muzhucode",
          "Suchindram Lake",
          "Sunset Point",
          "Surulode",
          "Thanumalayanputhoor Pond",
          "Thengamputhoor Lake",
          "Therakalputhoor Pond",
          "Theroor Lake",
          "Theroor Lake--East side",
          "Thirumala Temple, Munchira",
          "Thiruvalluvar Statue, Kanniyakumari",
          "Thittuvilai pond",
          "Thoothoor Beach",
          "Thovalai Hills",
          "Thovalai Periyakulam and surroundings",
          "Udhayagiri Fort - Bio-diversity Park, Puliyurkurichi",
          "Ulakkai aruvi",
          "Upper Kodayar",
          "Vaal Kulam",
          "Vaigai Lake",
          "Vallavilai Beach",
          "Valli Chunai  hills",
          "Vattakottai Fort",
          "Vattakottai Fresh Water Lake",
          "Vazhukamparai Pond",
          "Velimalai Rubber Plantation",
          "Velliyakulam Pond",
          "Vembanur Wetland Complex (RAMSAR SITE)",
          "Vivekananda Rock Memorial",
          "Zero Point Forest Checkpost",
          "அழகியபாண்டிப்புரம் பெரிய குளம் (Azhagiyapandipuram Pond)",
        ],
      },
      {
        district: "Karur",
        localities: [
          "Aathupalaiyam Reservoir",
          "Kaatupalayam, Thennilai, Karur",
          "Kalugur Lake",
          "Karur Bus Stand",
          "Karur Railway Station",
          "Kaveri - Amaravathi Sangamam",
          "Kaveri River, Lalapettai",
          "Keelaveliyur Agricultural Lake",
          "Mayanur Check Dam",
          "Noyyal-Cauvery, Noyyal Village",
          "PUPS K.Paramathi",
          "Panjappatty Lake பஞ்சப்பட்டி ஏரி",
          "Pavithiramedu",
          "Ponaniyaru Dam",
          "Puliyur",
          "Rangamalai Organic Farm & Traditional Seed Bank",
          "TNPL Quarters Area",
          "Tharagampatti Lake",
          "Theertha Kumarasamy Murugan Temple",
          "Thozilpettai",
          "Vanagam Ecological Foundation, Kadavur",
        ],
      },
      {
        district: "Krishnagiri",
        localities: [
          "Achettipalli Lake",
          "Aiyur Forest Rest House",
          "Aiyur Reserve Forest",
          "Amman Nagar Lake",
          "Anandavanam Eco Farms",
          "Anebiddahalla, Melagiri Hills",
          "Attibele / Zuzuwadi Lake",
          "Avalapalli Lake",
          "Avathanapatti Lake, Krishnagiri",
          "Bagalur",
          "Bala Kondarayana Swamy Temple",
          "Balakadapallam, Melagiri Hills",
          "Bamboo Rustles Camp",
          "Barur Lake",
          "Barur Tank",
          "Betamugilalam, Melagiri Hills",
          "Bhoomi Organic Ashram, Gummalapuram",
          "Biligundlu, Melagiri Hills",
          "Chandramuki Lake",
          "Chennasandiram",
          "Chinnar Dam, Shoolagiri",
          "Chitrashila Ashrama",
          "Cuckoo Forest School & Surrounds | குக்கூ காட்டுப்பள்ளி & சுற்றுப்பகுதி",
          "DFO OFFICE, Mathigiri",
          "Dabbagauli - Kottaiyur Road, Mallehalli R.F.",
          "Dargah Lake (Chandramkudi Eri)",
          "Devasamudram (Krishnagiri) Lake",
          "Devasamuthiram Lake",
          "Deverbetta, Melagiri Hills",
          "Dheeran Chinnamalai International School, Uthangarai",
          "Dubbagauli",
          "Elephants by the Lake",
          "Farmhill Learning Community",
          "Hidden Valley Estate, Sokkanathapuram",
          "Hosur (OBI)",
          "Jain Farms, Bagalur",
          "Jamedhar Medu, Kaveripattinam",
          "Jowlagiri, Melagiri Hills",
          "Karnoor Lake",
          "Kaveripattinam Lake",
          "Kelamangalam",
          "Kelavarapalli Reservoir",
          "Kodekarai, Melagiri Hills",
          "Kodiyalam",
          "Kondhama (Penugondapuram) Lake",
          "Konganapalli",
          "Kothur Lake",
          "Krishnagiri Dam (KRP Dam)",
          "Krishnagiri New Bus Stand கிருஷ்ணகிரி புதிய பேருந்து நிலையம்",
          "Kullur Nirant Farms Area",
          "Maharajakadai To Veppanapalli Forest Road",
          "Manchi, Melagiri Hills",
          "Maruderi Lake",
          "Maruthi Greenfields",
          "Matham Lake",
          "Mathigiri Cattle Farm",
          "Mathigiri Cattle Farm Lake",
          "Melagiris--General Area",
          "Melur, Melagiri Hills",
          "Mudhuganapalli Lake",
          "Naickanur Lake, Uthangarai",
          "Nallur Lake",
          "Natrampalayam",
          "Navadarshanam",
          "Navadhi Lake",
          "Nedungal Lake",
          "Panai Dam (Akkathangai Eri)",
          "Panchapalli, Melagiri Hills",
          "Pearl Valley (Tamil Nadu Side)",
          "Perandapalli Forest",
          "Ponnaiyar Riverbank, Gobasandiram",
          "Ponnapalli Lake",
          "Ramanaicken Lake, Hosur",
          "Rasimanal",
          "Rathnagiri Fort",
          "Rocky Ridge Farm",
          "Samaa Kuteeram Farm",
          "Samalpatti Railway Station",
          "Samieri, Melagiri Hills",
          "Shanthapuram (Nallur) Lake",
          "Singarapettai Lake",
          "Sulumalai Hillocks",
          "Sundekuppam Lake சுண்டேகுப்பம் ஏரி",
          "Syed Basha Hill (Krishnagiri Fort)",
          "TVS Academy (School)",
          "TVS Factory, Hosur",
          "TVS Motor, Belagondapalli, Hosur",
          "Thally Lake",
          "Thandarai Area",
          "Thattaganapalli Road, Karupalli",
          "Tippalam Lake",
          "Udubaranai Reserve Forest",
          "Uganiyam, Melagiri Hills",
          "Uthengarai",
          "Vadamangalam Lake",
          "Vannamma Kere",
          "Varatanapalli RF",
          "Vasudha Kalapathru",
          "Vilangamudi Lake",
        ],
      },
      {
        district: "Madurai",
        localities: [
          "AIIMS Madurai surroundings",
          "Agricultural College and Research Institute, Madurai",
          "American College, Madurai",
          "Anaiyur Tank, Madurai",
          "Arittapatti",
          "Arittapatti Range, Madurai",
          "Arumbanur Irrigation Tank",
          "Avaniyapuram Lake",
          "Avaniyapuram Reservoir / Iyethanendal Lake",
          "Ayyanar Kovil Dam",
          "Bhoothakudi",
          "Boy's Town, Pulloothu,",
          "Chathuragiri",
          "D. Karisalkulam Tank",
          "Dhan Academy",
          "E. Gopalapuram (Uthapuram) Madurai",
          "Foothills of South Andipatti Hill Range near Vadakkupati",
          "Govt ITI",
          "Grizzled Squirrel WLS--Saptur RF (Shiva temple path)",
          "Grizzled Squirrel WLS--Saptur RF Foothills",
          "Grizzled Squirrel WLS--Yanaikasam to Kannimar Kovil, Saptur RF",
          "Harveypatti Tank",
          "Heritage Hotel, Melakkal Road,  Madurai",
          "Idaiyapatti Neer Kadambam Grove",
          "Irrigation Tank, Airport Ring Road, Madurai",
          "Irrigation tank, ring road ( Airport Tuticorin Rd Jnx)",
          "K.Puliankulam Kanmai, Checkanurani",
          "Kakka Oothu , Nagamalai Hills, Madurai",
          "Kakkan Memorial",
          "Kamaraj College of Engineering & Technology (KCET)",
          "Kambur",
          "Karisal Kulam Tank",
          "Kathakinaru",
          "Keelakuyilkudi Samanar Hill",
          "Kilakuyilkudi Kualm",
          "Kilangulam Tank",
          "Kiluvamalai",
          "Kodikkulam tank, Melakkal, Madurai Dt",
          "Kodikulam Tank",
          "Kombu Thooki Ayyanar Koil Sacred Grove, Kesampatti",
          "Koothiyarkundu Kanmai",
          "Kottamalai",
          "Kovilaru Dam, Karungulam",
          "Kovilpapakudi Tank",
          "Kulamangalam Tank",
          "Kunnathur Tank",
          "Kuruvithurai Guru Bhagwan Temple",
          "Kutladampatti Falls",
          "Lady Doak College",
          "Lake near Jain Vidayalya",
          "Maan Thalai Ayyanar Koil Sacred Grove, Kadumittanpatti",
          "Madakkulam Kanmaai",
          "Madura College",
          "Madurai Airport",
          "Madurai Kamaraj University",
          "Malaiyurani Sacred Grove, Sivarakottai",
          "Malaiyurani, Sivarakottai, Madurai Dist, Tamilnadu",
          "Mallapuram",
          "Manjamalaiyan Kovil, Valayapatti",
          "Maruthur Tank",
          "Mattuthavani Bus Station",
          "Meenakshi Govt. Women's College",
          "Meenakshipuram , Back side of Arittapatti Range",
          "Melakkal Tank",
          "Mettuneerthan Kanmai",
          "Mother Teresa Women's University Research And Extension Center",
          "Mottanuthu General area",
          "Mullakulam Pond (முல்லை குளம்)",
          "NMS nagar",
          "Naagar Theertham",
          "Nagamalai",
          "Nallur Big Tank",
          "Narasingam Tank",
          "Narasingampatti-- Malai Koil, Perumalmalai RF",
          "Neelakandeswarar Temple, Kunnathur",
          "Nesaneri Kanmai",
          "Onthi Malai , Melakuyilkudi",
          "PTR COLLEGE OF ENGINEERING AND TECHNOLOGY",
          "Paravai Kanmai",
          "Perumal Malai Jain Hill Caves and Beds",
          "Perungudi",
          "Peykulam",
          "Poonchunai field range, Tamil Nadu, IN (10.086, 78.28)",
          "Poondi Lake",
          "Pullanari Kanmai , Kokkulam",
          "Pulloothu, Nagamalai Hills, Madurai",
          "Punniyavarsh",
          "Puthur Malai",
          "Railway Colony,Madurai",
          "Railway ground, Arasaradi, Madurai",
          "Samanatham Tank",
          "Samanthi  Poo Street",
          "Samayanallur/ Thodaneri Kulam",
          "Sathaiar Dam",
          "Sellur Kanmai",
          "Sengulam Kanmaai, Kalligudi",
          "Sevugan Nagar open Terrain",
          "Sikkandhar Chavadi Lake",
          "Sivarakkottai",
          "Sivarakottai",
          "Somagiri Malai Range-field",
          "Sourashtra College, Pasumalai",
          "Southern Slopes of Alagarkoil",
          "Sundaram Park Area - Vandiyoor Lake",
          "Suryanagar- ( Irrigation Tank to the east )",
          "T.M.Nagar",
          "THODANERI",
          "TVS Sundaram Higher Secondary School",
          "Tamilnadu Theological Seminary, Madurai",
          "Temporary Sewage collection pond ( ? Kilangkulam ) 8 km south of",
          "Thanakkankulam Kanmai",
          "Thavalaikkulam Kanmai, Maravankulam",
          "The American College - Satellite Campus",
          "Thenkarai Pond, Sholavandan",
          "Thenur Kanmai",
          "Thiagarajar Arts College canteen Pond",
          "Thiagarajar College",
          "Thiagarajar School Of Management (TSM)",
          "Thidiyanmalai Hill",
          "Thirali Tank, near alampati, Thirumangalam, Madurai dist, TN",
          "Thirukoodal malai --Thirupparankundram",
          "Thirumangalam Bus Stand",
          "Thirumoor Lake, (Puthu Thamaraipatti )",
          "Thiruparankundram Tank / Thenkarai Pond",
          "Thiruvathavur Tank",
          "Thodaneri Tank",
          "Thonthi Karuppasamy Kovil, Silambakonpatti, Kottampatti",
          "Thoppur",
          "Thuvarimaan Kanmai, Thuvarimaan, Madurai",
          "Urapanur Kanmaai (உறப்பனூர் கண்மாய்)",
          "Vadakarai Tank, Tamil Nadu 625205, Thirumangalam-Pallapatti Road",
          "Vadakarai tank, Tirumangalam",
          "Vagaikulam Tank",
          "Vaigai River Bank",
          "Vaigai River Bank ( South)  , Arappalayam",
          "Vaigai River Bank, Poondhotam",
          "Vaigai River Sellur",
          "Vaigai Vadakarai",
          "Valandur Kanmai",
          "Vandiyur Lake",
          "Veeran Kovil, Pallapatti",
          "Vellaripatti Irrigation Tank",
          "Vellimalayan Kovil, Kolinchipatti",
          "Vidathakulam Puthumalaikundu Tank",
          "Vidathakulam Tank",
          "Vinnakudi Tank , Poduvarpatti",
          "Viraganoor Regulator/ Dam on River Vaigai",
          "Virathanoor Lake or Tank, Madurai district, Tamil Nadu 625022, SH 195",
          "Vivekananda College, Madurai",
          "Western slopes of Alagarkovil Range from \"Hawa valley Resort \"   - 10.081x78.179",
          "Yaanaimalai Hill (யானைமலை)",
          "mahatma school Baba Building , madurai, tamilnadu 625007",
          "mottanoothu",
          "sundararajanpatti",
        ],
      },
      {
        district: "Nagapattinam",
        localities: [
          "A.V.C College Campus, Mannampandhal",
          "BNHS Bird Migration Study Centre, Kodiyakarai",
          "Keeran Lake",
          "Kodiyakarai Fishing Boat Jetty",
          "Kollidam River, Aanaikaaran Chathiram",
          "Kondal,Sirkazhi",
          "Mallarpettai Village",
          "Manangkondan River",
          "Manangkondan River, Adhanur",
          "Manikkapangu",
          "Melaiyur Village",
          "Muthupettai Lagoon",
          "Nayakkarkuppam",
          "PPN Power Plant",
          "PPN Power Plant, Sea Water Intake Area & Grasslands",
          "Pazhaiyar Beach",
          "Perunthottam Iake",
          "Point Calimere Wildlife Sanctuary",
          "Point Calimere Wildlife Sanctuary--Dry Evergreen forest",
          "Point Calimere Wildlife Sanctuary--Grassland",
          "Point Calimere Wildlife Sanctuary--Mudflats",
          "Point Calimere Wildlife Sanctuary--Muniyappan Lake",
          "Point Calimere Wildlife Sanctuary--Saltpans",
          "Point Calimere-Rettai Thevu",
          "Poompuhar College",
          "Poompuhar College Ground Surrounding",
          "Ramar Patham (இராமர் பாதம்)",
          "Sewage Treatment Plant, Mannampandal",
          "Siruthalaikadu- Saltpans",
          "Thirunagari",
          "Thiruvaalapputhur Area",
          "Thiruvali/Thirunagari Lake",
          "Thiruvengadu",
          "Thondiyakkadu Wildlife Sanctuary",
          "Tirumullaivasal Fishing Harbour",
          "Vaitheeswarankoil-- East Street",
          "Velankanni",
          "Velankanni Railway Station",
          "Vettaikaraniruppu Saltpans",
        ],
      },
      {
        district: "Namakkal",
        localities: [
          "A. K. Samuthiram Tank அனந்தகிருஷ்ணராய சமுத்திரம் ஏரி",
          "Aagaya Gangai Waterfalls ஆகாய கங்கை அருவி",
          "Akkaraipatti Lake",
          "Alavaimalai foothills",
          "Anaipalayam Lake அணைப்பாளையம் ஏரி",
          "Arappaleeswarar Temple அறப்பளீஸ்வரர் திருக்கோயில்",
          "Arasapalyam Lake",
          "Ariyursolai--Kuzhivalavu [RESTRICTED ENTRY] அரியூர்சோலை--குழிவளவு",
          "Ariyursolai--Thegavai [RESTRICTED ENTRY] அரியூர்சோலை--தெகவை",
          "B. Mettur--Nettavelampatti [RESTRICTED ENTRY] நெட்டவேலம்பட்டி, பாலகிருஷ்ணம்பட்டி மேட்டூர்",
          "B. Mettur--Puliyancholai [RESTRICTED ENTRY] (Balakrishnampatti Mettur) புளியஞ்சோலை, பாலகிருஷ்ணம்பட்டி மேட்டூர்",
          "Ellapalayam- Oomayampatti Tank, Mallasamudram",
          "Emappalli Lake",
          "Erikkadu, Oomayampatti Tank, Mallasamudram",
          "Erukkulam Kuttai (எருக்குளம் குட்டை, Namakkal",
          "Erumapatty Lake",
          "Erumappatti--Kokkuvari, Selur [RESTRICTED ENTRY] எருமப்பட்டி--கொக்குவாரி, சேலூர்",
          "Ettukai Amman Temple (எட்டுக் கை அம்மன் கோயில்)",
          "Govt Girls Higher Secondary School, Kalappanaickenpatti",
          "Idumbankulam Tank இடும்பன்குளம் ஏரி",
          "Iluppili Tank இலுப்பிலி ஏரி",
          "Iruttanai Lake",
          "Iruttanai, Namakkal",
          "Jedarpalayam Check Dam",
          "KSR College Of Engineering, Tiruchengode",
          "Kadalaipaliyur Poola Yeri, Padaiveedu",
          "Kalyani Lake கல்யாணி ஏரி",
          "Kamalaya Tank",
          "Kannurpatti Large Tank கண்ணூர்பட்டி பெரிய ஏரி",
          "Karichipalayam Lake",
          "Karumanoor Lake",
          "Kasthuripatti Tank கஸ்தூரிபட்டி ஏரி",
          "Kattipalayam Lake",
          "Kaveri River Bridge, Kumarapalayam",
          "Keerambur Country (கீரம்பூர்)",
          "Keerambur Lake கீரம்பூர் ஏரி",
          "Koattapalayam Lake",
          "Kolangondai-Kottapalayam Lake",
          "Kolangondai-Kottapalayam Lake - Northern Side",
          "Kollapatti Lake",
          "Kolli Hills Road, Karavallicombai R.F",
          "Koneripatti Tank கோனேரிப்பட்டி ஏரி",
          "Koottapalli Eri  (கூட்டப்பள்ளி ஏரி), Tiruchengode",
          "Kupperikkapalayam - Ottai Kulam",
          "Kurukkapuram Lake குருக்கபுரம் ஏரி",
          "Madhiyampatti Tank",
          "Mahendra Engineering College  Mallasamudram",
          "Mallur I--Mamarathu Odai to Anai Pali Mudakku, Bothamalai Road [RESTRICTED ENTRY]",
          "Mallur--Palanthinnipatti [RESTRICTED ENTRY] Kottai Mariamman Kovil Surroundings",
          "Mangalapuram--Karkoodalpatti [RESTRICTED ENTRY] மங்களபுரம்--கார்க்கூடல்பட்டி",
          "Minnakkal Tank and Surrounds மின்னக்கால் ஏரி",
          "Mullukurichi--Nayakkancombai [RESTRICTED ENTRY] முள்ளுக்குறிச்சி--நாயக்கன்கோம்பை",
          "Mullukurichi--Varagur [RESTRICTED ENTRY] முள்ளுக்குறிச்சி--வரகூர்",
          "Naachipudur Tank நாச்சிப்புதூர் ஏரி",
          "Nallipalayam Area",
          "Namagiripettai--Bailnadu North [RESTRICTED ENTRY] நாமகிரிப்பேட்டை--பைல்நாடு வடக்கு",
          "Namagiripettai--Osakaraiyanoothu [RESTRICTED ENTRY] (Orumithithadam Area) நாமகிரிப்பேட்டை--ஒசக்கரையனூத்து (ஒருமித்தித்தடம் பகுதி)",
          "Namakkal Lake",
          "Namakkal New Bus Stand நாமக்கல் புதிய பேருந்து நிலையம்",
          "Namakkal Old Bus Stand Area",
          "Nehru Memorial College",
          "Nehru Park",
          "Oomayampatti Tank ஊமையம்பட்டி ஏரி",
          "Osakaraiyanoothu Tank",
          "Otakuttai Lake, ஓட்டக்குட்டை ஏரி",
          "PGP Educational Institutions",
          "Palayapalayam Big Tank பழையபாளையம் பெரிய குளம்",
          "Palayapalayam Small Tank பழையபாளையம் சின்ன குளம்",
          "Paruthipalli Tank பருத்திப்பள்ளி ஏரி",
          "Pavithram Tank பவித்ரம் ஏரி",
          "Perumal Kovil, Valayappatti",
          "Pudhuchatram Tank புதுச்சத்திரம் ஏரி",
          "Pudhupatti East--Navapali Kinaru [RESTRICTED ENTRY]",
          "Pudhupatti West--Mathiyamadavu Dam [RESTRICTED ENTRY]",
          "Puthur Tank புத்தூர் ஏரி",
          "Samayasangali Agraharam",
          "Sarapalli lake சரப்பள்ளி ஏரி",
          "Sarkar Nattamangalam Tank சர்க்கார் நாட்டாமங்கலம் ஏரி",
          "Selvam Educational Institutions Campus செல்வம் கல்வி நிறுவனங்கள் வளாகம்",
          "Sembampalaiyam Village Kulam",
          "Semmandapatty",
          "Semoor Periya Yeri",
          "Sengarai--Edappulinadu [RESTRICTED ENTRY] செங்கரை--எடப்புளிநாடு",
          "Senthamangalam--Edapakkadu Area [RESTRICTED ENTRY] சேந்தமங்கலம்--எடப்பக்காடு பகுதி",
          "Senthamangalam--Naducombai [RESTRICTED ENTRY] சேந்தமங்கலம்--நடுக்கோம்பை",
          "Senthamangalam--Nainamalai Foothills [RESTRICTED ENTRY] சேந்தமங்கலம்--நைனாமலை அடிவாரம்",
          "Sirunalli Koil Lake",
          "Siththeri Lake சித்தேரி ஏரி",
          "Thalamalai Foothills",
          "Thalamalai South--Vadavathur [RESTRICTED ENTRY] தலமலை தெற்கு--வடவத்தூர்",
          "Thammampatti--Adukkam & Velikkadu [RESTRICTED ENTRY] தம்மம்பட்டி--அடுக்கம் & வேலிக்காடு பகுதி",
          "Thammampatti--Perumal Malai [RESTRICTED ENTRY] தம்மம்பட்டி--பெருமாள் மலை",
          "Thiruchencode Arthanareeswarar Temple Area திருச்செங்கோடு அர்த்தநாரீஸ்வரர் கோவில் பகுதி",
          "Thoosur Tank தூசூர் ஏரி",
          "Thottiyapatty Lake",
          "Thumbalpatti Lake தும்பல்பட்டி ஏரி",
          "Tipramahadevi Lake",
          "Valavanthinadu--Selur [RESTRICTED ENTRY] வாழவந்திநாடு--சேலூர்",
          "Valavanthinadu--Solakkadu & Keezhsolakkadu Area [RESTRICTED ENTRY] வாழவந்திநாடு--சோளக்காடு & கீழ்சோளக்காடு பகுதி",
          "Vandinatham Kulam (வண்டிநத்தம் குளம்) Tiruchengodu",
          "Vennandur Lake",
          "Veterinary College and Research Institute Campus, Namakkal",
          "Vettambadi Tank வேட்டம்பாடி ஏரி",
          "Vivekanandha College of Arts and Sciences for Women, Tiruchengode",
          "அண்ணா நீர்நிலை பூங்கா, Kondichettipatti Lake",
          "கண்டர் காலேஜ் பகுதி Velur",
        ],
      },
      {
        district: "Perambalur",
        localities: [
          "Adaikkampatti Lake அடைக்கம்பட்டி ஏரி",
          "Annamangalam Scurb Forest (RF)",
          "Aranaarai Lake அரணாரை ஏரி",
          "Arumbavur Big Lake அரும்பாவூர் பெரிய ஏரி",
          "Arumbavur Small Lake அரும்பாவூர் சித்தேரி",
          "Avvaiyar Nagar Pond அவ்வையார் குளம்",
          "Devaiyur Lake",
          "Elambalur Lake எளம்பலூர் ஏரி",
          "Eraiyur Lake",
          "Esanai Hills",
          "Esanai Lake எசனை ஏரி",
          "Esanai R.F Road",
          "Kalarampatti Big Lake களரம்பட்டி பெரிய ஏரி",
          "Kannapadi Big Lake கண்ணாப்பாடி பெரிய ஏரி",
          "Kottarai Dam",
          "Kurumbalur Palayam Lake குரும்பலூர் பாளையம் ஏரி",
          "Ladapuram Lake லாடபுரம் ஏரி",
          "Malar Matric School, Kurumbalur",
          "Mangalamedu Lake, Thevaiyur North",
          "Mayil Ootru Waterfalls",
          "Nakkasalem Lake நக்கசேலம் ஏரி",
          "National Fossil Wood Park, Sathanur",
          "Ogalur Lake ஒகலூர் ஏரி",
          "Payir Trust Campus பயிர் அறக்கட்டளை வளாகம்",
          "Peraiyur Lake",
          "Perambalur Big Lake பெரம்பலூர் பெரிய ஏரி",
          "Pillankulam Lake பில்லாங்குளம் ஏரி",
          "Sathanur Lake சாத்தனூர் ஏரி",
          "Sengunam Lake  செங்குணம் ஏரி",
          "Senjeri Lake",
          "Siruvachur to Keezha Kanavai Road",
          "T. Keeranur Lake",
          "T.Kalathur Lake து.களத்தூர் ஏரி",
          "Thanthai Hans Roever College தந்தை ஹேன்ஸ் ரோவர் கல்லூரி",
          "Thenur Lake தேனூர் ஏரி",
          "Thuraimangalam Lake துறைமங்கலம் ஏரி",
          "Vellanthangi Amman Lake வெள்ளந்தாங்கி அம்மன் ஏரி",
          "Visvakudi Dam விஸ்வக்குடி அணை",
          "Visvakudi Small Tank",
        ],
      },
      {
        district: "Pudukkottai",
        localities: [
          "Adappan Kulam, Pudukottai",
          "ECR Road, Kottaippattinam",
          "Kanappettai Kanmai",
          "Kanchathumalai (காஞ்சாதுமலை) Rocky Scrub Forest",
          "Kodiyamunai (கோடியமுனை)",
          "Machuvadi Savannah (Pudukkottai Veterinary Farm)",
          "Manalmelkudi - Kodiyakarai Beach",
          "Marupani Kulam",
          "Maylapatti - Ancient Jain Temple",
          "Muthu Munian Temple Grove",
          "Muthukuda Mangrove forest",
          "Narthamalai Hillock & Forest",
          "Neerpalani Kanmai (நீர்ப்பழனி கண்மாய்)",
          "Oonaiyur Big Tank",
          "Ottangalanchi Kaadu",
          "Paavendar Bharatidasan College of Engineering Campus",
          "Palakudi Kali Kovil",
          "Panangudi Kanmai",
          "Parry Nutraceuticals Campus",
          "Periya Kulam",
          "Ponpethi Lake",
          "Pudhukulam (புதுக்குளம்) Pond",
          "Pudhumanai Street, Aranthangi",
          "Pudukkottai Collectorate",
          "Rayar Kanmai, Oonaiyur",
          "Sri Sulapidari Amman Koil Sacred Grove, Kolluppatti",
          "Sukkanendhal Kulam",
          "Thirumayam Fort",
          "Thirupunavasal lake",
          "Vanniulandanvayal Kanmai",
          "Vellar River",
          "Yemba Kanmai",
        ],
      },
      {
        district: "Ramanathapuram",
        localities: [
          "Alathu Muniyasamy Temple",
          "Ammanpuram Beach",
          "Arichalmunai Beach",
          "Avathandai Kanmai",
          "CMFRI, Mandapam",
          "Chithrankudi Bird Sanctuary",
          "Collector Office Campus, Ramanathapuram",
          "Devaneri",
          "Dhanushkodi Beach",
          "Dhanushkodi-- Point 2",
          "Dhanushkodi-- Point 3",
          "Gulf of Mannar Marine National Park",
          "Kakkilan Kulam, Thondi",
          "Kalathavoor Kanmay",
          "Kanjirankulam Bird Sanctuary",
          "Karankadu Mangroves",
          "Keela kanmai, Pinnalankottai",
          "Kothandaramar Temple (கோதண்டராமர் கோவில்)",
          "Krusadai Island, Rameswaram, Tamilnadu",
          "Marine Museum and Vivekananda Memorial",
          "Melamundhal Beach",
          "Melaparthibanur Tank",
          "Melselvanur-Keelselvanur Bird Sanctuary",
          "Mookaiyur Beach (மூக்கையூர் கடற்கரை)",
          "Mukundaryar Chathiram",
          "Narippaiyur Beach",
          "Narippaiyur Wetlands",
          "Olaikadu Beach, Rameswaram",
          "Olaikuda, Rameswaram, Tamilnadu",
          "Paalai Park (பாலை பூங்கா)",
          "Pamban Bridge",
          "Periya Kanmai",
          "Perumanenthal Tank - 1",
          "Perungarai Tank",
          "Peykarumbu",
          "Pillaimadam",
          "Pudumadam",
          "Pullangudi Saltpans",
          "Ramanathapuram Big Tank",
          "Ramnad New Bus Stand",
          "Sakkarakottai Kanmaai",
          "Sethukarai Backwaters & Thorn Forest",
          "Sevalkaadu (செவல்காடு) Scrub Forest",
          "Sikkal Kanmai",
          "Somanathapuram Wetlands",
          "Thavasikuruchi Tank",
          "Therthangal Bird Sanctuary",
          "Vaigai Tharavai",
          "Vaigai near Thiruvolhiyakalugoorani",
          "Valinokkam, Ramnad Dist",
          "Varahi Amman Temple Surroundings",
          "Vedalai Backwater",
        ],
      },
      {
        district: "Ranipet",
        localities: [
          "Arakkonam Lake",
          "Arakkonam Rly Jn",
          "Arumbakkam Koot Road",
          "Banavaram Reserve Forest",
          "Kaarai Maduvu (காரை மடுவு)",
          "Kalavai Lake",
          "Kaveripakkam Lake",
          "Kuppathu Mottur Kulam (குப்பத்து மோட்டூர் குளம்)",
          "Lakshmi Nagar/Arakkonam Lake",
          "Mahendravadi Lake -West ( மகேந்திரவாடி எரி)",
          "Mangadu Lake (மாங்காடு ஏரி)",
          "Natham-Villapakkam range",
          "Pinji Lake, Ranipet (பிஞ்சி ஏரி, இராணிப்பேட்டை)",
          "Pudu Kesavaram Dam",
          "Sathambakkam",
          "Sathur Eri (சாத்தூர் ஏரி)",
          "Tata Motors JLR, Panapakkam",
          "Thandalam Lake (தண்டலம் ஏரி)",
          "Valayathur Lake",
        ],
      },
      {
        district: "Salem",
        localities: [
          "11th HB--Yercaud",
          "18th HB--Yercaud",
          "19th HB--Yercaud",
          "1st HB--Yercaud",
          "40 Feet Bridge",
          "60 Feet Bridge",
          "6th HB--Yercaud",
          "9th HB--Yercaud",
          "A. N. Mangalam Bats Grove வௌவால் தோப்பு, அ.நா. மங்கலம்",
          "A.E.T. College of Arts & Science",
          "ACSEN Tex Pvt. Ltd. Campus",
          "AVS Arts and Science College, Kanjanayachanpatti",
          "AVS Engineering College",
          "Aachampalli Tank, Vettukkadu, Thangayur ஆச்சாம்பள்ளி ஏரி, வெட்டுக்காடு, தங்காயூர்",
          "Aandikaattu Kuttai, Olakkachinnanur ஆண்டிக்காட்டு குட்டை, ஒலக்கச்சின்னானூர்",
          "Aandikkuttai, Nagiyampatti ஆண்டிக்குட்டை, நாகியம்பட்டி",
          "Aandipatti Lake ஆண்டிப்பட்டி ஏரி",
          "Aariya Kuttai, Koranampatti ஆரிய குட்டை, கோரணம்பட்டி",
          "Aatukkaran Kuttai, Thangayur ஆட்டுக்காரன் குட்டை, தங்காயூர்",
          "Abhinavam Lake அபிநவம் ஏரி",
          "Achampatti Lake, Avaniperur West அச்சம்பட்டி ஏரி, ஆவணிபேரூர் மேற்கு",
          "Agrahara Nattamangalam (A.N. Mangalam) Lake அக்ரஹார நாட்டாமங்கலம் ஏரி",
          "Agriculture Training Center, Salem",
          "Allikuttai Lake (or Thathampatti Lake) அல்லிக்குட்டை ஏரி (தாதம்பட்டி ஏரி)",
          "Amarakundhi Kaathaan Eri அமரகுந்தி காத்தான் ஏரி",
          "Amarakundhi Lake",
          "Amarakundhi Pudhu Eri அமரகுந்தி புது ஏரி",
          "Ammal Tank அம்மாள் ஏரி",
          "Ammampalayam Tank அம்மம்பாளையம் ஏரி",
          "Amman Eri (Lake) அம்மன் ஏரி",
          "Amman Lake near Aathi Kattur அம்மன் ஏரி, ஆதி காட்டூர் அருகில்",
          "Amman Lake, Dadapuram, Edappadi அம்மன் ஏரி, தாதாபுரம், எடப்பாடி",
          "Ammapalayam Lake, Iruppali அம்மாபாளையம் ஏரி, இருப்பாளி",
          "Anaimedu, Tharamangalam",
          "Anaiyampatti Lake ஆனையம்பட்டி ஏரி",
          "Andavar Nagar & Surrounds, Manivilundhan South, Sarvoy Main Road",
          "Annai Indra Nagar & Surrounds",
          "Annamalaiar Temple, Thalaicholai",
          "Appusami Hospital, Gandhi Road, Salem",
          "Aragalur Govt. Higher Secondary School",
          "Aragalur Lake ஆறகளூர் ஏரி",
          "Aragalur Sitheri ஆறகளூர் சித்தேரி",
          "Arasan Kuttai Lake, Konasamudram அரசன் குட்டை ஏரி, கோணசமுத்திரம்",
          "Arathi Agraharam Tank ஆரத்தி அக்ரஹாரம் ஏரி",
          "Ariyampatti Pond அரியாம்பட்டி குட்டை",
          "Ariyapalayam Tank ஆரியபாளையம் ஏரி",
          "Atchengadu",
          "Athanurpatti Lake அத்தனூர்பட்டி ஏரி",
          "Athimarathar Nizhal Farm (Restricted Access)",
          "Attayampatti Tank ஆட்டையாம்பட்டி ஏரி",
          "Attur Lake ஆத்தூர் ஏரி",
          "Attur New Bus Stand, Salem",
          "Avaniperur (West) Chinna Eri ஆவணிபேரூர் (மேற்கு) சின்ன ஏரி",
          "Ayothiyapattinam Tank அயோத்தியாபட்டினம் ஏரி",
          "Ayyampalayam Tank, Kachupalli அய்யம்பாளையம் ஏரி, கச்சுப்பள்ளி",
          "Ayyan Kuttai, Iruppali, Edappadi அய்யன் குட்டை, இருப்பாளி, எடப்பாடி",
          "Ayyanar Kovil Lake அய்யனார் கோவில் ஏரி",
          "Ayyaneri Lake, Avadathur அய்யனேரி, ஆவடத்தூர்",
          "Ayyaneri Tank அய்யனேரி",
          "Ayyasamy Park, Ammapet அய்யாசாமி பசுமைவெளி பூங்கா, அம்மாப்பேட்டை",
          "Ayyathurai Odai, Karumandurai அய்யாத்துரை ஓடை, கருமந்துறை",
          "Balaji Nagar Area & Surrounds, Amarakundhi",
          "BeemanPalayam River Bridge பீமன்பாளையம் ஆற்றுப் பாலம்",
          "Between 40 feet to 60 feet Bridge",
          "Bharathiyar Educational Institutions for Women பாரதியார் மகளிர் கல்வி நிறுவனங்கள்",
          "Blue Valley Estate, Yercaud",
          "Bodinayakanpatti Tank போடிநாயக்கன்பட்டி ஏரி",
          "Bomma Kuttai பொம்ம குட்டை",
          "Bomma Samuthiram Tank, Dadapuram, Edappadi பொம்மசமுத்திரம் ஏரி, தாதாபுரம், எடப்பாடி",
          "Bommidi Sub Road",
          "Boomanoor",
          "CSI Teacher Training Institute, Hasthampatti",
          "Cauvery River--Chettipatty Area காவிரி ஆறு--செட்டிப்பட்டி பகுதி",
          "Check Dam, Yethapur",
          "Chekkanur Small Dam Area, Mettur RS-Poolampatti Road",
          "Chetti Eri, East Rajapalayam, Salem செட்டி ஏரி, கிழக்கு இராஜபாளையம், சேலம்",
          "Chetti Eri, Vedapatti செட்டி ஏரி, வேடப்பட்டி",
          "Chetty Lake, Seshanchavadi செட்டி ஏரி, சேசன்சாவடி",
          "Children's Park (Old), Mohan Nagar",
          "Chinna Mangalam Lake சின்ன மங்கலம் ஏரி",
          "Chinna Mettur Scrub Area சின்ன மேட்டூர் புதர்காட்டுப் பகுதி",
          "Chinna Pethanaickenpalayam Lake or Chinnamasamudram Lake சின்ன பெத்தநாயக்கன்பாளையம் (அ) சின்னமசமுத்திரம் ஏரி",
          "Chinna Pillaiyur Tank சின்ன பிள்ளையூர் ஏரி",
          "Chinna Pudhur Mariyamman Temple Area",
          "Chinna Punalvasal Lake சின்ன புனல்வாசல் ஏரி",
          "Chinna Thambi Valavu",
          "Chinnakavundapuram Lake சின்னகவுண்டாபுரம் ஏரி",
          "Chittoor Tank சித்தூர் ஏரி",
          "Club Mahindra Yercaud (Restricted Access)",
          "DSK Thirumana Mahal",
          "Danishpet Big Lake டேனிஷ்பேட்டை ஏரி",
          "Danishpet Small Lake டேனிஷ்பேட்டை சின்ன ஏரி",
          "Dasagasamudram Tank தாசகாசமுத்திரம் ஏரி",
          "Desavilakku Kaspa Tank தெசவிளக்கு கஸ்பா ஏரி",
          "Deviyakurichi Lake தேவியாக்குறிச்சி ஏரி",
          "District Collector's Office, Salem மாவட்ட ஆட்சியர் அலுவலகம், சேலம்",
          "District Institute of Education and Training (DIET), Salem மாவட்ட ஆசிரியர் கல்வி & பயிற்சி நிறுவனம், சேலம்",
          "Durgai Amman Temple Lake துர்கை அம்மன் கோவில் ஏரி",
          "Earipudur Check Dam ஏரிப்புதூர் காட்டுவளவு ஓடை தடுப்பணை",
          "Edappadi Bus Stand எடப்பாடி பேருந்து நிலையம்",
          "Edappadi Periya Eri எடப்பாடி பெரிய ஏரி",
          "Edappadi Small Tank எடப்பாடி சின்ன ஏரி",
          "Eechampatti Tank ஈச்சம்பட்டி ஏரி",
          "Eenjan Lake, Dadapuram, Edappadi ஈஞ்சன் ஏரி, தாதாபுரம், எடப்பாடி",
          "Egapuram Small Lake ஏகாபுரம் சின்ன ஏரி",
          "Egapuram Tank ஏகாபுரம் ஏரி",
          "Elampillai Tank இளம்பிள்ளை ஏரி",
          "Elavampatti Tank இலவம்பட்டி ஏரி",
          "Elayaramar Temple Tank இளையராமர் கோவில் ஏரி",
          "Eragundappatti Lake எறகுண்டப்பட்டி ஏரி",
          "Eripudur--Paruthikadu",
          "Erumaipatti Tank, Edappadi எருமைப்பட்டி ஏரி, எடப்பாடி",
          "Erumapalayam Tank எருமாபாளையம் ஏரி",
          "Ervadi Tank ஏர்வாடி ஏரி",
          "Etti Kuttai, Thangayur எட்டிக்குட்டை, தங்காயூர்",
          "Etti Kuttai, Vaikundam எட்டிக்குட்டை, வைகுண்டம்",
          "Ettimanickampatti Pond எட்டிமாணிக்கம்பட்டி குட்டை",
          "Ezharaimathikkadu Thumbal Kaattu Pallam Lake ஏழரைமத்திக்காடு தும்பல் காட்டுப் பள்ளம் ஏரி",
          "Ezhuthukkal Seradi Check Dam எழுத்துக்கல் சேரடி சின்ன அணை",
          "Five Roads Area",
          "Four Roads Area, Salem",
          "Gangadharan Pond, Sellapillai Kuttai Panchayat கங்காதரன் குட்டை, செல்லப்பிள்ளை குட்டை ஊராட்சி",
          "Gangavalli Forest Quarters",
          "Geetha Nagar Annex & Surrounds",
          "Gendhiyan Kuttai (or Vannan Kuttai), Olakkachinnanur",
          "Godumalai Foothills (around Perumal Temple)",
          "Godumalai Foothills (via Nadupatti)",
          "Godumalai Foothills (via Sivasakthi Nagar)",
          "Godumalai foothills --Mannayakanpatti",
          "Goodamalai Lake கூடமலை ஏரி",
          "Gorimedu to Yercaud Foothills (enroute)",
          "Government College of Engineering, Salem--Staff Quarters",
          "Government High School, Chekkanur",
          "Government Hospital, Salem",
          "Govindampalayam Lake கோவிந்தம்பாளையம் ஏரி",
          "Govt. Arts College for Women, Salem-8 அரசினர் மகளிர் கலைக்கல்லூரி, சேலம்-8",
          "Govt. Arts College, Salem-7 அரசு கலைக்கல்லூரி, சேலம்-7",
          "Govt. Fruit Farm Lake-01, Karumandurai [Restricted Entry] பலப்பண்னை ஏரி-01, கருமந்துறை",
          "Govt. Fruit Farm Lake-02, Kaikaanvalavu [Restricted Entry] பலப்பண்ணை ஏரி-02, கைக்கான்வளவு",
          "Govt. Head Quarters Hospital Campus, Mettur அரசு தலைமை மருத்துவமனை வளாகம், மேட்டூர்",
          "Govt. Industrial Training Institute (ITI), Salem-7 அரசு தொழில் பயற்சி நிறுவனம், சேலம்-7",
          "Govt. Mohan Kumaramangalam Medical College, Salem",
          "Govt. Primary Health Centre, Kannankurichi, Salem",
          "Govt. Primary Health Centre, Kolathur அரசு ஆரம்ப சுகாதார நிலையம், கொளத்தூர்",
          "Govt. Primary Health Centre, Tharamangalam",
          "Govt. Primary Health Centre, Tholasampatti",
          "Govt. Tribal Residential Middle School, Kunnur",
          "Gundiyampatti Tank குண்டியாம்பட்டி ஏரி",
          "Gundukkal Tank குண்டுக்கல் ஏரி",
          "Hasthampatti Roundana Circle Area",
          "Hillock near A.N. Mangalam Lake",
          "Iluppanatham Tank இலுப்பநத்தம் ஏரி",
          "Inam-Bairoji Tank (Pudhupalayam Tank) பைரோஜி ஏரி",
          "Iruppali Lake (Mettupatti Lake) இருப்பாளி ஏரி",
          "Ismail Khan Tank இஸ்மாயில் கான் ஏரி",
          "Jairam Arts & Science College, Chinna Thirupathi, Salem",
          "Jamboothumalai Area (enroute--from foothills to P.U.P. School and Surrounds)  ஜம்பூத்துமலை பகுதி",
          "K. N. Pudhur Lake கே.என். புதூர் ஏரி",
          "K. N. Pudhur Small Lake கே.என். புதூர் சின்ன ஏரி",
          "K. Vadugapatti Tank வடுகப்பட்டி ஏரி (அ) அய்த்தாக் குட்டை",
          "Kaalaran Kuttai near Nagiyampatti/Ulipuram காலரங்குட்டை, நாகியம்பட்டி/உலிபுரம்",
          "Kaaththaan Kuttai or Veppang Kuttai, Thangayur காத்தான் குட்டை (அ) வேப்பங்குட்டை, தங்காயூர்",
          "Kacharaayan Kuttai, Edappadi கச்சராயன் குட்டை, எடப்பாடி",
          "Kachupalli Tank, Edappadi கச்சுப்பள்ளி ஏரி, எடப்பாடி",
          "Kadathur Tank கடத்தூர் ஏரி",
          "Kailash Nagar, Tharamangalam",
          "Kakapalayam Tank (Kanagagiri Tank) காக்காபாளையம் ஏரி (கனககிரி ஏரி)",
          "Kalikavundanur Kuttai, Vellar காளிக்கவுண்டனூர் குட்டை, வெள்ளார்",
          "Kallanatham Lake கல்லாநத்தம் ஏரி",
          "Kalleri Chokkanathapuram Tank கல்லேரி சொக்கநாதபுரம் ஏரி",
          "Kalleri, Irugalur Panchayat, Sankagiri Union கல்லேரி, இருகலூர் ஊராட்சி, சங்ககிரி ஒன்றியம்",
          "Kalleripatty Lake கல்லேரிபட்டி ஏரி",
          "Kalyanagiri Tank கல்யாணகிரி ஏரி",
          "Kamalapuram Periyeri Tank காமலாபுரம் பெரியேரி",
          "Kamalapuram Tank காமலாபுரம் ஏரி",
          "Kamaneri Lake காமனேரி ஏரி",
          "Kamarajar MPL Girls Higher Secondary School, Manakkadu",
          "Kanakkan Tank கணக்கன் ஏரி",
          "Kandan Valavu",
          "Kandarkula Manickam Tank கண்டர்குல மாணிக்கம் ஏரி",
          "Kandhanvalavu & Narasukkadu Area",
          "Kanjamalai--Sadayan Ootru Malai கஞ்சமலை--சடையன் ஊற்று மலை",
          "Kannamoochi to Ramanpatti Area",
          "Kannankurichi Mookaneri கன்னங்குறிச்சி மூக்கனேரி",
          "Kannankurichi Pudhu Eri (Lake) கன்னங்குறிச்சி புது ஏரி",
          "Kannantheri Tank கன்னந்தேரி ஏரி",
          "Kannimar Odai, Skandasramam Road, Salem, Tamil Nadu, IN",
          "Kapparayan Kuttai or Thoppam Kuttai, Thangayur",
          "Kapparayan Kuttai, Thangayur கப்பராயன் குட்டை, தங்காயூர்",
          "Kapputhi",
          "Karikalan Kuttai, Ulipuram கரிகாலன் குட்டை, உலிபுரம்",
          "Kariya Ramar Temple Area கரிய ராமர் கோவில் பகுதி",
          "Karumalaikoodal Surrounds",
          "Karumandurai Watertank (கருமந்துறை ஏரி)",
          "Karumandurai-Vellimalai Road",
          "Karupana Eri (Lake) கருப்பன ஏரி",
          "Karuppur Tank கருப்பூர் ஏரி",
          "Kasuvarettipatti Lake கசுவரெட்டிபட்டி ஏரி",
          "Katheri Tank கத்தேரி",
          "Kattaampatti Lake, Surapalli காட்டாம்பட்டி ஏரி, சூரப்பள்ளி",
          "Kattinaikanpatti Lake கட்டிநாயக்கன்பட்டி ஏரி",
          "Katttukottay Watertank, Karumandurai காட்டு கொட்டாய் ஏரி, கருமந்துறை",
          "Kavarpanai Tank கவர்பனை ஏரி",
          "Kaveri Bridge & Surrounds காவிரி பாலம் பகுதி",
          "Kaveri River, Mettur -MTPS GATE opposite",
          "Kaveripuram--enroute Kolathur Area to Kottaiyur/Chettipatty Area",
          "Keeraikaadu Creek, Tumbal Extension R.F கீரைக்காடு ஓடை, தும்பல் RF",
          "Keeraipappampadi Tank கீரைப்பாப்பம்பாடி ஏரி",
          "Kiliyur Road to Kiliyur Falls, Yercaud",
          "Knowledge Institute of Technology (KIOT)",
          "Kolanthampatty Lake, Latchumayur கொளந்தாம்பட்டி ஏரி, லட்சுமாயூர்",
          "Kolathukombai RF Checkdam கோலாத்துக் கோம்பை (வனத்துறை) தடுப்பணை",
          "Kolathur Area (after Forest Check Post till Govt. PHC Area via Thanda Four Roads)",
          "Kolathur Area (after Forest Check Post till Kolathur Market via Kolathur Bus Stand)",
          "Kolathur to Pannavadi Road--enroute (after Kolathur Market till Kaveri Amman Temple--5 km stretch)",
          "Kolathur to Thanamoorthikadu (enroute)",
          "Kollapatti Tank, Kachupalli கொல்லப்பட்டி ஏரி, கச்சுப்பள்ளி",
          "Kollapatty Lake/Pond Area, Kolathur",
          "Kombu Thukki",
          "Konda Samuthiram Tank கொண்டசமுத்திரம் ஏரி",
          "Kondayampalayam Lake கொண்டையம்பாளையம் ஏரி",
          "Kondayampalli Tank கொண்டையம்பள்ளி ஏரி",
          "Koneri Valavu Bridge",
          "Kootathupatti Muniyappan Temple Area கூட்டாத்துப்பட்டி முனியப்பன் கோயில் பகுதி",
          "Kootathupatti Tank கூட்டாத்துப்பட்டி ஏரி",
          "Koottathupatti Irattai Kuttai",
          "Korakuttapatti Eri/Kuttai, Kachupalli கோரகுட்டப்பட்டி ஏரி/குட்டை, கச்சுப்பள்ளி",
          "Koranampatti Lake (Nadupatti Lake) கோரணம்பட்டி ஏரி (நடுப்பட்டி ஏரி)",
          "Korapallam Small Dam கோரப்பள்ளம் சின்ன அணை",
          "Kottachedu to Kariya Ramar Temple (enroute)",
          "Kottachedu, Yercaud கொட்டச்சேடு, ஏற்காடு",
          "Kottaimedu",
          "Kottamedu",
          "Kottanathan Tank கொட்டநத்தான் ஏரி",
          "Kottangal Lake கோட்டங்கால் ஏரி",
          "Kottapuliyur Lake, Chettimankurichi கொட்டாப்புளியூர் ஏரி, செட்டிமாங்குறிச்சி",
          "Kottavadi Lake (Belur Kissan Lake) கொட்டவாடி ஏரி (பேளூர் கிசான் ஏரி)",
          "Kovilur near Sri Vanishwaran Temple",
          "Krishnampudur Area",
          "Kullampatti Tank குள்ளாம்பட்டி ஏரி",
          "Kullan Kinaru Pond, Chinthamaniyur குள்ளன் கிணறு குட்டை, சிந்தாமணியூர்",
          "Kumaragiri Tank, Ammapet குமரகிரி ஏரி, அம்மாப்பேட்டை",
          "Kumaranallipalayam New Tank குமரநல்லிபாளையம் புது ஏரி",
          "Kumarapalayam Check Dam near Belur",
          "Kumarapalayam Pond, Manivilundhan குமாரபாளையம் குட்டை, மணிவிழுந்தான்",
          "Kundrivalavu Tank, Kunjandiyur குன்றிவளவு ஏரி, குஞ்சாண்டியூர்",
          "Kuppampatty Kuttai, Surappalli குப்பம்பட்டி குட்டை, சூரப்பள்ளி",
          "Kuppanur Forest Check Post Area",
          "Kuppanur Ghat Road to Soora Muniyappan Temple",
          "Kuppanur Toll Gate to Forest Check Post (enroute)",
          "Kurichi Tank, Belur குறிச்சி ஏரி, பேளூர்",
          "Kurinji Nagar Park and Surrounds",
          "Kurumbapatti Zoo to Danishpet (enroute)",
          "Kurumbapatti Zoological Park குரும்பப்பட்டி உயிரியல் பூங்கா",
          "Lakkampatti Bridge, on the way to Needhipuram (or Thengal Pallam Bus Stop)",
          "Lakshumayur to K.R Thoppur Road",
          "Lathuvadi Lake இலத்துவாடி ஏரி",
          "London Ortho Speciality Hospital",
          "Lourdhu Mary Malai Kovil Church, A.N.Mangalam",
          "M. Chettipatty Lake எம். செட்டிப்பட்டி ஏரி",
          "M. Kalipatti Chinna Eri எம். காளிப்பட்டி சின்ன ஏரி",
          "M. Kalipatti Kuttai எம். காளிப்பட்டி குட்டை",
          "Maangkuttapatti Periyeri Lake மாங்குட்டப்பட்டி பெரியேரி",
          "Maangkuttapatti Small Tank மாங்குட்டப்பட்டி சின்ன ஏரி",
          "Madeshwaran Karadu, Thammanaickenpatty (மாதேஸ்வரன் கரடு, தம்மநாயக்கன்பட்டி)",
          "Mahatma Gandhi Stadium மகாத்மா காந்தி விளையாட்டு மைதானம்",
          "Mahendra College of Engineering, Minnampalli, Salem",
          "Malaiyalapatti Pond மலையாளப்பட்டி குளம்",
          "Mallamoopampatti Tank மல்லமூப்பம்பட்டி ஏரி",
          "Mallikuttai Tank மல்லிக்குட்டை ஏரி",
          "Manakkadu Area, Salem",
          "Manal Lake மணல் ஏரி",
          "Manathal Tank மானத்தால் ஏரி",
          "Mandhakaadu Scrub Patch மந்தக்காடு, புதர்காட்டுப் பகுதி",
          "Manivilundhan Old Tank (Manivizhundhan Lake) மணிவிழுந்தான் பழைய ஏரி",
          "Maniyargundam Lake, Karumandurai மணியார்குண்டம் ஏரி, கருமந்துறை",
          "Manjakuttai View Point, Yercaud",
          "Manmalai Foothills to Mini Waterfalls (enroute)",
          "Marakkottai Lake மரக்கோட்டை ஏரி",
          "Mariyamman Pudur Tank மாரியம்மன் புதூர் குளம்",
          "Masinaickenpatti or Varagampadi Tank மாசிநாயக்கன்பட்டி (அ) வரகம்பாடி ஏரி",
          "Mecheri Lake மேச்சேரி ஏரி",
          "Mecheri Sheep Research Station",
          "Meera Sahib Tank மீரா சாஹிப் ஏரி",
          "Melpoondi Check Dam, Kalvarayan Hills மேல்பூண்டி தடுப்பணை, கல்வராயன் மலை",
          "Mettukotai, Chinnathanda",
          "Mettupatti Tank மேட்டுப்பட்டி ஏரி",
          "Mettur - Cauvery Cross Bridge",
          "Mettur Bus Stand மேட்டூர் பேருந்து நிலையம்",
          "Mettur Dam Park Area மேட்டூர் அணை பூங்கா பகுதி",
          "Micro Forest, Salem",
          "Monnanjcheri Kuttai, Chittoor Bit 1, Edappadi மொன்னஞ்சேரி குட்டை, சித்தூர் பிட் 1, எடப்பாடி",
          "Moolavittam Kuttai, Olakkachinnanur மூலைவிட்டம் குட்டை, ஒலக்கச்சின்னானூர்",
          "Morur Lake",
          "Motturkadu & Elumalaiyan Kadu",
          "Mount Mary Matriculation Higher Secondary School, Salem-8",
          "Muthunaickenpatti Chinneri முத்துநாயக்கன்பட்டி சின்ன ஏரி",
          "Muthunaickenpatti Periyeri Lake முத்துநாயக்கன்பட்டி பெரிய ஏரி",
          "Muttal Foothills to Muttal Waterfalls (enroute)",
          "Muttal Lake முட்டல் ஏரி",
          "Muttal Tank, Manivilundhan முட்டல் ஏரி, மணிவிழுந்தான்",
          "Muyal Karadu Tank, Kaattukkottai முயல் கரடு ஏரி, காட்டுக்கோட்டை",
          "Naachampatti Tank நாச்சம்பட்டி ஏரி",
          "Naachinaampatti Tank நாச்சினாம்பட்டி ஏரி",
          "Naduvalur Periyeri Lake நடுவலூர் பெரிய ஏரி",
          "Naduvalur Sitheri நடுவலூர் சித்தேரி",
          "Naduvaneri Lake நடுவனேரி",
          "Nagalur Water Falls, Kalvarayan Hills  நாகலூர் நீர்வீழ்ச்சி, கல்வராயன் மலை",
          "Nagalur,Yercaud, Salem",
          "Nagasamudram Kuttai, Dadapuram, Edappadi நாகசமுத்திரம் குட்டை, தாதாபுரம், எடப்பாடி",
          "Nagireddipatti Melakarattur Lake நாகிரெட்டிப்பட்டி மேலக்கரட்டூர் ஏரி",
          "Nagiyampatti New Tank நாகியம்பட்டி புது ஏரி",
          "Nalla Thanneer Kuttai, Vaikundam நல்ல தண்ணீர் குட்டை, வைகுண்டம்",
          "Nallathangal Kuttai, Ulipuram நல்லதாங்கல் குட்டை, உலிபுரம்",
          "Nallur Lake நல்லூர் ஏரி",
          "Nangavalli Lake நங்கவள்ளி ஏரி",
          "Narasingapuram Idaiyaneri Tank நரசிங்கபுரம் இடையனேரி",
          "Nathakadu Bharathi Nagar Kuttai நத்தக்காடு பாரதி நகர் குட்டை",
          "Nattar Agraharam Pond நாட்டார் அக்ரஹாரம் குட்டை",
          "Nattarsai Lake",
          "Navakurichi Lake நாவக்குறிச்சி ஏரி",
          "Navalur Lake நாவலூர் ஏரி",
          "Navalur Small Tank நாவலூர் சின்ன ஏரி",
          "Navalur Tank, Thumbipadi நாவலூர் ஏரி, தும்பிபாடி",
          "Needhipuram Lake நீதிபுரம் ஏரி",
          "Neermullikuttai Therkukadu Lake",
          "Nehru Park, Salem Steel Plant நேரு பூங்கா, சேலம் உருக்காலை",
          "Neiyamalai Road, Neyyamalai, Tamil Nadu, IN (11.75, 78.472)",
          "Ninankarai to Nallamathi, Belur South",
          "Nottakaran Kuttai, Thangayur நோட்டக்காரன் குட்டை, தங்காயூர்",
          "Oddapatti Tank ஒட்டப்பட்டி ஏரி",
          "Olaipatti (ஓலைப்பட்டி), Keerappapampadi",
          "Omalur Circle & Bus Stand Area",
          "Omalur Tank ஓமலூர் ஏரி",
          "Omkara Raja Lake (Kanjeri RF Lake), Danishpet ஓம்காரராஜா ஏரி (காஞ்சேரி), டேனிஷ்பேட்டை",
          "Oothumedu Lake, Ramanayakkanpalayam ஊத்துமேடு ஏரி, இராமநாயக்கன்பாளையம்",
          "Othiyathur Tank ஒதியத்தூர் ஏரி",
          "Ottampali, Alagu Nagar, Seelanaickenpatti (ஒட்டம்பாலி, அழகு நகர், சீலநாயக்கன்பட்டி)",
          "Otteri, Kuppandiyur ஒட்டேரி, குப்பாண்டியூர்",
          "P.U.P.S, Mariyamman Pudur",
          "PMP Nagar Tank or P. Nattamangalam Tank",
          "Paapankuttai, P.Naatamangalam பாப்பான் குட்டை, பா.நாட்டாமங்கலம்",
          "Paavayi Kuttai or Paarai Kuttai, Olakkachinnanur பாவாயி குட்டை (அ) பாறைக்குட்டை, ஒலக்கச்சின்னானூர்",
          "Pacchakattu  Vayal",
          "Pachagoundanoor Tank பச்சகவுண்டனூர் ஏரி",
          "Pachakattu Vayal",
          "Pachamalai பச்சமலை",
          "Pachanampatty Moongil Lake பச்சனம்பட்டி மூங்கில் ஏரி",
          "Padmavani Women's College, Salem",
          "Pagoda Point, Yercaud",
          "Pagudupattu Water Tank, Karumandurai பகுடுபட்டு ஏரி, கருமந்துறை",
          "Paithur South",
          "Palamalai Reserve Forest பாலமலை காப்புக்காடு",
          "Palamalai--Guruvareddiyur Foothills to Siddeshwaran Temple Via Periyakulam Settlements",
          "Palamalai--Periyakulam",
          "Palani Kavundan Kuttai, Thangayur பழனி கவுண்டன் குட்டை, தங்காயூர்",
          "Palaniyapuri Tank பழனியாபுரி ஏரி",
          "Pallapatti Tank பள்ளப்பட்டி ஏரி",
          "Pallikondan Parai",
          "Panamarathupatti Lake பனமரத்துப்பட்டி ஏரி",
          "Panamarathupatti--Bothamalai II [RESTRICTED ENTRY] Malaiyalapatti to Jambuthumalai பனமரத்துப்பட்டி--போதமலை II, மலையாளப்பட்டி முதல் ஜம்பூத்துமலை வரை",
          "Panangadu (Pudhu Eri) Lake near Chettimankurichi பனங்காடு ஏரி (புது ஏரி), செட்டிமாங்குறிச்சி அருகில்",
          "Panangadu Tank near Valasaiyur பனங்காடு குளம், வலசையூர்",
          "Panangadu Tank, Seelanaickenpatti பனங்காடு ஏரி, சீலநாயக்கன்பட்டி",
          "Panangattu Eri or Thaai Eri (Chinneri) பனங்காட்டு ஏரி (அ) தாய் ஏரி (சின்னேரி)",
          "Panchayat Union Middle School, A.P. Vattam",
          "Panchayat Union Middle School, Krishnampudur",
          "Panchayat Union Middle School, Latchumayur",
          "Panchayat Union Middle School, Mattayampatti",
          "Panchayat Union Middle School, Sengodanur",
          "Panchayat Union Middle School, Thalavaipatty",
          "Panjanga Kuttai, Olakkachinnanur பஞ்சாங்க குட்டை, ஒலக்கச்சின்னானூர்",
          "Panjukalipatti Lake (Chinthamaniyur Lake) பஞ்சுகாளிப்பட்டி ஏரி (சிந்தாமணியூர் ஏரி)",
          "Pannaikkadu Reserve Forest",
          "Pannapatti Kuttai",
          "Pannappatti Lake பண்ணப்பட்டி ஏரி",
          "Panneermalai Balamurugan Temple Area Scrub Forest பன்னீர்மலை பாலமுருகன் கோவில் புதர்காட்டுப் பகுதி",
          "Pappanaickenpatti",
          "Pappanaickenpatti Kariya Kovil Dam பாப்பநாயக்கன்பட்டி கரிய கோவில் அணை",
          "Papparapatti Tank பாப்பாரப்பட்டி ஏரி",
          "Paravai Kuttai, Mariyamman Pudhur, Valappadi பறவைக் குட்டை, மாரியம்மன் புதூர், வாழப்பாடி",
          "Pattipadi",
          "Pavalathanoor Lake, Tharamangalam பவளத்தானூர் ஏரி, தாரமங்கலம்",
          "Pazhamandi Lake பழமண்டி ஏரி",
          "Peraru, Erumbur, Kalvarayan Hills பேராறு, எறும்பூர், கல்வராயன் மலை",
          "Periya Eri, Olakkachinnanur பெரிய ஏரி, ஒலக்கச்சின்னானூர்",
          "Periya Kadampatti Lake பெரிய காடம்பட்டி ஏரி",
          "Periya Krishnapuram Lake பெரிய கிருஷ்ணாபுரம் ஏரி",
          "Periya Puthur Tank பெரிய புதூர் ஏரி",
          "Periya Urani Lake, Jalakandapuram பெரிய ஊரணி ஜலகண்டாபுரம் ஏரி",
          "Periyakuttimaduvu  Area பெரியகுட்டிமடுவு பகுதி",
          "Periyapatti Lake பெரியபட்டி ஏரி",
          "Periyar University Campus பெரியார் பல்கலைக்கழக வளாகம்",
          "Periyasamy Temple Sacred Grove & Surrounds, Nagiampatty near Thammampatti பெரியசாமி கோவில் பகுதி, நாகியம்பட்டி, தம்மம்பட்டிக்கு அருகில்",
          "Periyeri Tank, Aragalur பெரியேரி, ஆறகளூர்",
          "Periyeri Tank, Sellapillai Kuttai பெரியேரி, செல்லப்பிள்ளை குட்டை",
          "Periyeripatti Lake பெரியேரிப்பட்டி ஏரி",
          "Perumal Kovil Karadu",
          "PerumalMalai, Narasothipatti, Salem",
          "Perunjoor Pond, Karumandurai பெருஞ்சூர் குளம், கருமந்துறை",
          "Pethanaickenpalayam Lake பெத்தநாயக்கன்பாளையம் ஏரி",
          "Peththaampatti Tank பெத்தாம்பட்டி ஏரி",
          "Peththaampatti Tank, Mullichettipatti பெத்தாம்பட்டி ஏரி, முள்ளிசெட்டிப்பட்டி",
          "Pillukurichi Tank, Chittoor Bit 1, Poolampatti பில்லுக்குறிச்சி ஏரி, சித்தூர் பிட் 1, பூலாம்பட்டி",
          "Poimaan Karadu & Kottai Karadu | பொய்மான் கரடு & கோட்டைக் கரடு (Hill of the False Deer & Nazhikkalpatti Fort)",
          "Polapankadai Stream, பொலப்பாங்கடை ஓடை",
          "Pond near Mettur East Canal, Poolampatti மேட்டூர் கிழக்கு கால்வாய்க்கு அருகிலுள்ள குட்டை, பூலாம்பட்டி",
          "Pond opp. to Vaitheeswaran Temple near Indira Nagar Rd, Puliyankurichi",
          "Pongavalli Tank பொங்கவல்லி ஏரி",
          "Ponnankaadu Tank",
          "Ponnu Samudram Tank பொன்னு சமுத்திரம் ஏரி",
          "Poolampatti பூலாம்பட்டி",
          "Poolavari Lake பூலாவரி ஏரி",
          "Poondikaadu Tank, Kumbapadi (பூண்டிக்காடு ஏரி, கும்பப்பாடி)",
          "Pottaneri Tank பொட்டனேரி ஏரி",
          "Pudhukuttai Tank, Senaipalayam, Selliampalayam புதுக்குட்டை ஏரி, சேனைப்பாளையம், செல்லியம்பாளையம்",
          "Pudhukuttai, Manivilundhan Pudhur புதுக்குட்டை, மணிவிழுந்தான் புதூர்",
          "Pudhur Chetti Lake, Veerappampalayam  புதூர் செட்டி ஏரி, வீரப்பம்பாளையம்",
          "Pudhur-Alagappampalayam Tank புதூர்- அழகப்பம்பாளையம் ஏரி",
          "Puliyampatti Karuppusamy Temple & Surrounds",
          "Puliyankurichi Lake புளியங்குறிச்சி ஏரி",
          "Pullagoundampatti Tank புள்ளாக்கவுண்டம்பட்டி ஏரி",
          "Punalvasal Big Lake புனல்வாசல் பெரிய ஏரி",
          "Pungamaduvu Area புங்கமடுவு பகுதி",
          "Pungan Eri/Rangasamudram Lake, Kurumbapatti, Edappadi புங்கன் ஏரி/ரங்கசமுத்திரம் ஏரி, குரும்பப்பட்டி, எடப்பாடி",
          "Puthiragoundapalayam Lake புத்திரகவுண்டபாளையம் ஏரி",
          "Puthirakavundan Street Area, Periya Pudhur புத்திரகவுண்டன் தெரு பகுதி, பெரிய புதூர்",
          "Puthoor Lake புத்தூர் ஏரி",
          "Puzhuthikuttai Dam or Anaimaduvu Reservoir",
          "Raayar Kuttai, Thangayur ராயர் குட்டை, தங்காயூர்",
          "Rakkipatti Pond ராக்கிப்பட்டி குட்டை",
          "Ramakavundan Valavu Kuttai, Kannantheri இராமக்கவுண்டன் வளவு குட்டை, கன்னந்தேரி",
          "Ramanayakkampalayam, Tamil Nadu, IN (11.629, 78.557)",
          "Ramireddipatti Lake near Aarurpatti, Tharamangalam இராமிரெட்டிப்பட்டி ஏரி, ஆரூர்பட்டி, தாரமங்கலம்",
          "Rangan Kuttai, Thangayur",
          "Rangan Kuttai, Thangayur ரங்கன் குட்டை, தங்காயூர்",
          "Rayappan Lake, M. Kalipatti ராயப்பன் ஏரி, எம். காளிப்பட்டி",
          "Reddipatti Kuttai, Chittoor Bit 1, Edappadi ரெட்டிப்பட்டி குட்டை, சித்தூர் பிட் 1, எடப்பாடி",
          "Rose Garden, Yercaud",
          "S.E.M Road Lake",
          "Sadayan Chetti Tank சடையன் செட்டி ஏரி",
          "Sadhasivapuram Ponneri Tank சதாசிவபுரம் பொன்னேரி",
          "Salem Central Bus Terminus (New Bus Stand)",
          "Salem Old Bus Stand Area",
          "Salem Railway Junction",
          "Salem Sowdeswari College & Surrounds",
          "Salem-- Aavin Milk Parlour , Steel Plant Road,  Siththanur",
          "Samba Kuttai Tank, Chinna Vellalapatti சம்ப குட்டை, சின்ன வெள்ளாளப்பட்டி",
          "Samba Nagar Old Lake, Pethanaickenpalayam சம்பா நகர் பழைய ஏரி, பெத்தநாயக்கன்பாளையம்",
          "Sampalli & Moolakkadu Area (enroute)",
          "Samuthiram Panangkuttai Lake சமுத்திரம் பனங்குட்டை ஏரி",
          "Samuthiram Tank behind Periyar University சமுத்திரம் ஏரி",
          "Sandhapatti Tank சந்தப்பட்டி ஏரி",
          "Sandhumalai Area சந்துமலைப் பகுதி",
          "Saniyasimalai R.F.,Trekking Route (Restricted)",
          "Sankagiri Foothills",
          "Sankagiri Fort (சங்ககிரி மலைக்கோட்டை)",
          "Sanyasi Malai road (near Reserve Forest)",
          "Sanyasi Varadar Temple Area, Thalavaipatty",
          "Sarvoy Pudhur Big Lake சார்வாய் புதூர் பெரிய ஏரி",
          "Sathapadi Tank சாத்தப்பாடி ஏரி",
          "Sattur Tank சட்டூர் ஏரி",
          "Sedapatti Tank சேடப்பட்டி ஏரி",
          "Seelaiyampatti Tank சீலையம்பட்டி ஏரி",
          "Selathampatti Tank--Tamarind Tree Area புளிய மரத்து ஏரி, சேலத்தாம்பட்டி ஏரியில் இருந்து பிரிந்த ஒரு பகுதி",
          "Selatthampatti Tank சேலத்தாம்பட்டி ஏரி",
          "Selavadai Tank செலவடை ஏரி",
          "Sellappa Kavundan Kuttai",
          "Selliyampalayam Lake செல்லியம்பாளையம் ஏரி",
          "Semmalai Tank, Tharkadu  செம்மலை ஏரி, தார்காடு",
          "Semmang Kuttai (or Kuttakarai Tank) செம்மங்குட்டை குட்டக்கரை ஏரி",
          "Semmanoor Lake செம்மனூர் ஏரி",
          "Sengadu Lake or Jangama Samudram Lake செங்காடு/ஜங்கமசமுத்திரம் ஏரி",
          "Sengadu, Yercaud (செங்காடு, ஏற்காடு)",
          "Sengalathu Padi, Yercaud",
          "Sengan Kuttai, Vaikundam செங்கன் குட்டை, வைகுண்டம்",
          "Sengkuttai Lake, Konasamudram செங்குட்டை ஏரி, கோணசமுத்திரம்",
          "Sengodanoor",
          "Sengunthar Public School, Tharamangalam",
          "Senkadu to Keeraikadu (Enroute)",
          "Sentharapatti Lake செந்தாரப்பட்டி ஏரி",
          "Settukarankadu Tank செட்டுக்காரன்காடு ஏரி",
          "Shanmuga Hospital, Salem",
          "Shevaroy Hills (camps at varying altitudes)",
          "Shevaroy Temple & View Point, Yercaud",
          "Shri Ram Chandra Mission, Salem",
          "Siddha Rural Dispensary, Chinnathanda",
          "Singarathoppu to Siddeshwaran Temple",
          "Singipuram Tank சிங்கிபுரம் ஏரி",
          "Siruvachur Lake சிறுவாச்சூர் ஏரி",
          "Sittanur Scrub Forest Area சிட்டனூர் புதர்க்காட்டுப் பகுதி",
          "Sivaraj Siddha Medical College Campus, Salem",
          "Sivasankarapuram Lake சிவசங்கராபுரம் ஏரி",
          "Skandasramam Murugan Temple & Surrounds கந்தாஸ்ரமம் முருகன் கோவில் & சுற்றுப்பகுதி",
          "Sokkanur Lake சொக்கனூர் ஏரி",
          "Somampatti Tank சோமம்பட்டி ஏரி",
          "Soora Muniyappan Temple",
          "Soora Muniyappan Temple to Kottachedu (enroute)",
          "Southkadu Pond, Kachupalli தெற்குகாடு குட்டை, கச்சுப்பள்ளி",
          "Sri Amman Matric Higher Secondary School, Vaikuntham.",
          "Sri Angalamman Temple Area, Thirumanimuthar River, Kuppanur Area",
          "Sri Saalaipaarai Muniappan Temple",
          "Sri Seshaas International Public School & Surrounds",
          "Sri Vidya Mandir Matric HSS, Steel Plant",
          "Stanley Reservoir -- Kottumaduvu Area",
          "Stanley Reservoir--16 Gate Ellis Surplus Sluices Bridge, Mettur",
          "Stanley Reservoir--Chinna Mettur Area",
          "Stanley Reservoir--Keerakaranoor",
          "Stanley Reservoir--Koonandiyur",
          "Stanley Reservoir--Kottaiyur Parisalthurai to East Kottaiyur Area",
          "Stanley Reservoir--Masilapalayam",
          "Stanley Reservoir--Mettur Dam View Point",
          "Stanley Reservoir--Moolakkadu Area",
          "Stanley Reservoir--Pannavadi, Mettur",
          "Stanley Reservoir--Sethukkuzhi",
          "Stanley Reservoir--Thalavadi Area",
          "Stanley Reservoir--Thanamoorthikadu (Sub) Area",
          "Stanley Reservoir--Thanamoorthikadu Main Area",
          "Stanley Reservoir--Thelunganur Area",
          "Stanley Reservoir--Thippampatty",
          "Stanley Reservoir--Ukkamparuthikadu Area",
          "Stanley Reservoir--between Chettipatty & Kottaiyur Parisalthurai",
          "Sundar Lodge Bus Stop",
          "Surakkapatti Tank சுரக்காபட்டி ஏரி",
          "Suramangalam-Reddipatti Circle Area",
          "Swetha River--adjacent to Iluppathoppu Bridge on the way to Valasakkalpatti",
          "Swetha River--near Veeraganur Periya Angalamman Area",
          "TANMAG Mine",
          "Thaamarai Kuttai (towards Tharamangalam) தாமரைக் குட்டை",
          "Thaekkampatti Vaaikaal Kuttai Lake தேக்கம்பட்டி வாய்க்கால் குட்டை",
          "Thailaakavundanur Lake தைலாக்கவுண்டனூர் ஏரி",
          "Thalaivasal Lake தலைவாசல் ஏரி",
          "Thalavaipatty Lake (Mettupalayam Tank) தளவாய்பட்டி ஏரி",
          "Thalur Area (தாழூர் பகுதி)",
          "Thambaani Kombai Reserve Forest Area (தம்பானி கோம்பை)",
          "Tharalakuttai Lake தாராளகுட்டை ஏரி",
          "Tharamangalam Bus Stand தாரமங்கலம் பேருந்து நிலையம்",
          "Tharamangalam Lake தாரமங்கலம் ஏரி",
          "Tharamangalam Tank தாரமங்கலம் ஏரி",
          "Tharamangalam-West Car Street",
          "The Central Law College & Surrounds, Salem",
          "Thedavoor (Thedaur) Lake தெடாவூர் ஏரி",
          "Thekkalpatti Lake தேக்கல்பட்டி ஏரி",
          "Thengal Hills, Eripudhur தேங்கல்மலை, ஏரிப்புதூர்",
          "Thenkumarai Tank தென்குமரை ஏரி",
          "Thennampillaiyur Tank தென்னம்பிள்ளையூர் ஏரி",
          "Thennangudipalayam Lake தென்னங்குடிபாளையம் ஏரி",
          "Thethigiripatti Lake தெத்திகிரிபட்டி ஏரி",
          "Thevur Eri Valavu Tank தேவூர் ஏரி வளவு",
          "Thevur Tank தேவூர் ஏரி",
          "Thirumanur Area",
          "Thirumanur To Mamarathu Odai",
          "Thiyaganur Lake தியாகனூர் ஏரி",
          "Tholasampatti Lake தொளசம்பட்டி ஏரி",
          "Thoppalampatti Kattuvadavu",
          "Thottil Lake, Sukkampatti தொட்டில் ஏரி, சுக்கம்பட்டி",
          "Thukkiyampalayam",
          "Thuttampatti Tank, Desavilakku துட்டம்பட்டி ஏரி, தெசவிளக்கு",
          "Umayalpuram Raja Eri உமையாள்புரம் ராஜ ஏரி",
          "Unathur Lake ஊனத்தூர் ஏரி",
          "Universal Matriculation School",
          "Uppathu Odai, Karumandurai உப்பாத்து ஓடை, கருமந்துறை",
          "Utthumalai ஊத்துமலை",
          "VIMS Hospital Campus",
          "Vaathipatti Lake, Surappalli வாத்திப்பட்டி ஏரி",
          "Vaazhakkombai Lake வாழக்கோம்பை ஏரி",
          "Vaazhakuttapatti Tank வாழகுட்டப்பட்டி ஏரி",
          "Vadakumarai Lake வடகுமரை ஏரி",
          "Vadamaneri Big Tank வடமனேரி",
          "Vadapatty Area",
          "Vaikundam Periyeri Lake வைகுண்டம் பெரியேரி",
          "Vaikundam-Hotel Saravana Bhavan Main Road",
          "Vairan Lake, Periyasoragai வைரன் ஏரி, பெரியசோரகை",
          "Vaithiyakavundan Pudhur Tank வைத்தியக்கவுண்டன் புதூர் ஏரி",
          "Valaiyachettipatti Kuttai வளையசெட்டிபட்டி குட்டை",
          "Valaiyamadevi Tank வளையமாதேவி குளம்",
          "Valappadi Pappan Tank வாழப்பாடி பாப்பான் ஏரி",
          "Valasakkalpatti Lake or Veera Ramar Dam",
          "Vanavasi Lake வனவாசி ஏரி",
          "Vaniyambadi (Salem) Small Tank வாணியம்பாடி சின்ன ஏரி, சேலம்",
          "Vannan Kuttai, Thangayur வண்ணான் குட்டை, தங்காயூர்",
          "Vannan Kuttai, Vaikundam வண்ணான் குட்டை, வைகுண்டம்",
          "Varadhappa Kuttai or Kalikavundan Kuttai, Thangayur வரதப்ப குட்டை (அ) காளிகவுண்டன் குட்டை",
          "Varatteri or Periyeri, A. Thalaiyur",
          "Vashishta River near Periyeri, Aragalur",
          "Vashishta River near Thulukkanur",
          "Vattakadu Lake Small Dam வட்டக்காடு ஏரி சின்ன அணை",
          "Vattakadu Lake வட்டக்காடு ஏரி",
          "Veeraganur Lake வீரகனூர் ஏரி",
          "Veeranam Lake வீராணம் ஏரி",
          "Veerapandi Tank வீரபாண்டி ஏரி",
          "Veerappan Kuttai, Thangayur வீரப்பன் குட்டை, தங்காயூர்",
          "Veethan Valavu Area",
          "Velikaathan Karuppu Kovil, Karumandurai (வேலிகாத்தான் கருப்புகோவில், கருமந்துறை)",
          "Vellaiyur Lake வெள்ளையூர் ஏரி",
          "Vellaiyur Panchayat Via Mamarathukkadu Bus Stop",
          "Vellakkalpatti Tank (or Gundan Eri) வெள்ளக்கல்பட்டி ஏரி (அ) குண்டன் ஏரி",
          "Vellalagundam Circle",
          "Vellalagundam Kannimar Temple Area வெள்ளாளகுண்டம் கன்னிமார் கோயில் பகுதி",
          "Vellalagundam Tank வெள்ளாளகுண்டம் ஏரி",
          "Vellalapuram Big Tank வெள்ளாளபுரம் ஏரி",
          "Vellalapuram Big Tank--Paappampadi New Tank Area வெள்ளாளபுரம் பெரிய ஏரி--பாப்பம்பாடி புது ஏரிப் பகுதி",
          "Vellarivelli Tank வெள்ளரிவெள்ளி ஏரி",
          "Vembaneri வேம்பனேரி",
          "Vengikal Lake வெங்கிகல் ஏரி",
          "Veppadi Nallamathi Way & Surrounds",
          "Veppampoondi Tank வேப்பம்பூண்டி ஏரி",
          "Veppanatham Lake (on the way to Ponnoli Nagar) வேப்பநத்தம் ஏரி (பொன்னொளி நகர் செல்லும் வழியில்)",
          "Vetraya Perumal Temple, Soragai Hills வேட்ராய பெருமாள் கோவில், சோரகை மலை",
          "Vettukkadu Small Tank near Danishpet வெட்டுக்காடு சின்ன ஏரி, டேனிஷ்பேட்டை அருகில்",
          "Vilampatti (Arunoothumalai foot hill  RF Area)",
          "Vysya College, Salem",
          "Yercaud Lake, Salem ஏற்காடு ஏரி, சேலம்",
          "Yercaud Road (after Muniyappan Temple)",
          "Yercaud, Salem ஏற்காடு, சேலம்",
          "மோளையனூர்-போதைக்காடு (இடாரப்பன் கோயில்) வனப்பகுதி( Pohaikkadu RF Area)",
        ],
      },
      {
        district: "Sivagangai",
        localities: [
          "6X Sports Academy",
          "Alagappa Model Higher Secondary School",
          "Andakudi Kanmai",
          "Arasanoor TanK",
          "Athalai Kanmai, Karaikudi",
          "Athikadu Thekkur Kulam",
          "Chettinad (OBI)",
          "Chettiyan Kanmai",
          "Kanadukaathan Kanmai கானாடுகாத்தான் கண்மாய்",
          "Kandani Kanmaai",
          "Karai Kanmaai",
          "Karungalikudi Tank",
          "Karuppu Koil Sacred Grove, Keela Vannariruppu, Minnamalaipatti",
          "Kattikulam Lake",
          "Keezhadi Archaeological Excavation Site",
          "Keezhpaththi Kanmai கீழ்பத்தி கண்மாய்",
          "Kondhalaiyamman Kulam",
          "Konthagai Lake",
          "Kuil Thoppu Nursery Garden Area",
          "Kurichi Tank",
          "Manachai Kanmai",
          "Mannakudi Kulam",
          "Maranadu Tank",
          "Maravamangalam Lake (மறவமங்கலம் கண்மாய்)",
          "Mariamman Kovil Tank, Sivagangai",
          "Murugan Chetti Oorani",
          "Nemathanpatti Bus Stop Area",
          "O.Siruvayal Anjanayar Koil",
          "Patharakkudi Lake",
          "Periya Kanmaai",
          "Piravalur Kanmai",
          "Piravalur near Kaadu Kaaval Kali Koil",
          "Sadurvadamangalam Kanmai",
          "Sanjayan Nagar Tank",
          "Seedhali Pond,Tirupattur",
          "Servar Oorani, Kandanur",
          "Sri Sarada Niketan College for Women",
          "Sri Suvara Siddhi Vinayagar Koil, Thiruvelangudi",
          "Sri karuppar Temple, Amaravathi",
          "Thirumalai Sri Malaikountheeswarar Temple",
          "Thirupatur Tank",
          "Thondi, Ramanathapuram",
          "Vadakudipatti Kanmai",
          "Vaigai River Bridge, Sakkudi",
          "Vaiya karuppar koil, Kandanur",
          "Valayan Kanmai, Kundrakudi.",
          "Vettangudi Bird Sanctuary",
        ],
      },
      {
        district: "Tenkasi",
        localities: [
          "AMC Government Higher Secondary School",
          "Adaichani Periyakulam",
          "Amar Seva Sangam",
          "Arunthapatti lake",
          "Attakulam Lake, Kadayanallur",
          "Ayikudi Kulam",
          "Courtallam Eco Park",
          "Courtralam",
          "Elathur Lake",
          "Ilanji Kulam",
          "Ilanji--Varatharaja Perumal Kovil (வரதராஜ பெருமாள் திருக்கோயில், இலஞ்சி)",
          "Ilanthkulam",
          "Kadana Nadhi Dam",
          "Kadayanallur Paddy Fields",
          "Kambley Tank",
          "Kizhla kadaiyam (கீழக்கடையம் குளம்)",
          "Kotta Kulam",
          "Kulasekaraperi Kulam",
          "Kundaru Dam",
          "Maranthai Kulam",
          "Maranthai Lake",
          "Mavadikkal lake",
          "Melappavoor Kulam",
          "Parasakthi Nagar",
          "Puliyur Kulam",
          "Ramanathi dam",
          "Rettaikulam",
          "Shenkottai (செங்கோட்டை)",
          "Sundarapandiyapuram Kulam",
          "Sundaresapuram lake",
          "Surandai",
          "Surandai Kulam",
          "Tenkasi Lake",
          "Thalaiyanai Theerthaparai Falls",
          "Thenpathu Kulam, Kadayam",
          "Thirumalai Kovil",
          "Thondaiman Kulam, Ilanji",
          "Thuppakudi Kulam",
          "Thuppakudi Kulam (துப்பகுடி)",
          "Vaghai Kulam",
          "Virasigamani Periyakulam",
          "aathoor",
        ],
      },
      {
        district: "Thanjavur",
        localities: [
          "A to Z Speciality Hospital Area",
          "Adambai",
          "Allur Lake",
          "Annai Vailankanni Arts and Science College",
          "Chellappanpettai Lake, Thanjavur",
          "Chellikurichi Lake",
          "Don Bosco Matriculation Higher Secondary School, Thanjavur",
          "GReat Trails Riverview Resort",
          "Ganapathi Agraharam - Manalur",
          "Government College for Women, Kumbakonam",
          "Government Hospital & Surrounds, Kabisthalam",
          "Ideal Riverview Resort",
          "Indeco Hotels-- Swamimalai (restricted access)",
          "Iyanar Temple Area, Nanjikottai",
          "Kaatuthottam Farmlands",
          "Kalancheri Village Farmlands",
          "Kallanai Dam",
          "Kallaperambur Lake",
          "Kallikadu",
          "Karambai, Mannankadu",
          "Karuppur Village",
          "Kaveri River Bridge",
          "Kaveri River Trail, Veppathur",
          "Kayavoor",
          "Keezhathottam Mangrove Swamp",
          "Kollidam River, Anaikarai",
          "Kollidam River, Anaikudi",
          "Kollidam River, Govindanattucheri",
          "Kollidam River, Keezharamanallur",
          "Kollidam River, Kudithangi",
          "Kollidam River, Thirupurambiyam",
          "Kollidam River, Thiruvaikavur",
          "Kollidam River, Vazhkai",
          "Korukkai Village",
          "Kudamuruty River Trail, Thirupalaithurai",
          "Kulichapattu Pond",
          "Lake to Innathukkanpatti Road",
          "Lotus Pond, Punnainallur",
          "Manaiyeripatti Lake_1",
          "Manaiyeripatti Scrubland and Lake",
          "Mantra Koodam CGH Earth",
          "Maravakkadu Mangroves",
          "Maravakkadu Salt pan",
          "Maruthakudi Lake",
          "Nanjikotai (KMA Nagar)",
          "Nanjikottai Lake",
          "Nattam Outskirts",
          "Papanasam - Kabisthalam Road, Thanjavur Dt.",
          "Papanasam Railway Station",
          "Parisutham Nagar",
          "Periyakulam Area",
          "Periyar Nagar, Sakkottai",
          "Perumangudi Village Farmlands, Thanjavur Dt",
          "Ponnan Lake",
          "Ponnavarayankkkottai Area",
          "Poovalur",
          "Poovalur- Valuthalaivattam Area",
          "Puthambur Scrub",
          "Radiant School, Thanjavur",
          "Rayamundanpatti Lake",
          "River Thirumalairajan, Papanasam",
          "SASTRA University",
          "Samuthiram Lake, Thanjavur",
          "Saruvanodai and Adampuli Odai, Mannankadu.",
          "Sivagangai Park, Thanjavur",
          "Solagampatti Lake",
          "Solagampatti Scrubland",
          "Solagampatti Scrubland--North",
          "Sorakudipatti Lake",
          "Srinivasa Nagar , Sakkottai",
          "Tamil University Campus",
          "Thanjavur Big Temple",
          "Thanjavur Junction Railway Station",
          "Thanjavur Medical College",
          "Thatumaal Padugai to Kudikadu",
          "Thenperambur Dam",
          "Thiruvisanallur Farmlands, Thanjavur Dt",
          "Veeraiyan Kulam, Atthivetti",
          "Vendakkottai",
          "Veppankulam (Pond), Goburajapuram",
          "Veterinary College and Research Institute, Orathanadu",
        ],
      },
      {
        district: "The Nilgiris",
        localities: [
          "Adasolai Hill",
          "Anaikatty FRH",
          "Aracode",
          "Aravenu",
          "Aravenu Village",
          "Arboretum Tree Garden",
          "Avalanche Forest Guest House",
          "Avalanche Reserve Forest",
          "Avalanche--Upper Bhavani Road",
          "Banagudi Shola",
          "Beramukku Temple",
          "Bhavani Sagar View Point, Neergandi, Sholurmattam,",
          "Bnadipura-Mudumalai border",
          "Boothanatham, Moyar",
          "Botanical Garden, Ooty",
          "Burliyar - Coonoor Rd",
          "Burliyar-- Kurumba Lodge (Restricted Access)",
          "Cairn Hill, Ooty",
          "Catherine Waterfalls",
          "Central Potato Research Institute, Muthorai",
          "Cherambadi",
          "Coonoor Railway Station",
          "Coonoor-- Erin Villa (Restricted Access)",
          "Coonoor--General Area (OBI)",
          "Coonoor-Kotagiri Road",
          "Destiny Farm Resort Area",
          "Devala",
          "Doddabetta Meadow and Bog",
          "Doddabetta Peak",
          "Doddabetta Road",
          "Doddabetta-Kattabettu Rd",
          "Dolphin's Nose View Point",
          "Elk Hill--General Area (OBI)",
          "Fern Hill, Ooty",
          "Fernhill palace, Welcome Heritage Woods Area",
          "Fig Tree -- Bokhapuram Temple",
          "Forestdale",
          "Gauri Farms",
          "Gauri Farms, Gudalur",
          "Geddai Ghat Area",
          "Genepool Ecological Park",
          "Glenmorgan Estate (Restricted access)",
          "Golf Link Road, Ooty",
          "Gori Shola, Ooty",
          "Government Arts College (அரசு கலை கல்லூரி), Ooty",
          "Gudalur Adivasi Hospital area",
          "Gymkhana",
          "Hanging Huts Resort-- (Restricted Access)",
          "Hebron School (Private Property)",
          "Hebron School (Restricted Access)",
          "Horticulture Training Centre---General area",
          "Iduhatty",
          "Idukorai",
          "InnTheWild, Masinagudi",
          "Italian Garden",
          "Kalahatty Ghat Road--Mountain`n' mist",
          "Kalhatty Falls",
          "Kalhatty Jungle Camp",
          "Kappachi Village Area",
          "Karnataka Siri Horticulture Garden",
          "Katteri Lake",
          "Katteri Tea Stall Area",
          "Katteri Valley, Coonoor",
          "Kattery Park",
          "Kattery Park Road",
          "Kenthorai",
          "Ketti Valley (Near Emerald Valley)",
          "Ketti Valley Grasslands",
          "Ketti Valley, Lovedale",
          "Keystone Foundation Campus",
          "Kil Kodappamund, Ooty",
          "Kings Cliff Resort",
          "Kinnakkorai Village",
          "Kodanad--Genepool Area",
          "Kodanadu View Point",
          "Korakundah",
          "Koranur (கொரனூர்)",
          "Kotagiri",
          "Kotagiri - Kodanadu Road Shola, Kotagiri",
          "Kotagiri Road, Ooty (கோத்தகிரி சாலை, ஊட்டி)",
          "Kotagiri--Franciscan Brothers Road",
          "Kotagiri--General Area (OBI)",
          "Kothagiri-Kodanadu Road",
          "Krishu Mala Road, Pandalur",
          "Kundha River Bridge, Geddai Road",
          "Kunjapanai, Mettupalayam-Kotagiri Road",
          "Lamb's Rock, Coonnoor",
          "Lawrence School, Lovedale (லாரன்ஸ் பள்ளி)",
          "Longwood Shola",
          "M. Palada",
          "Mamaram",
          "Mangorange Estate Area",
          "Maravakandi Lake",
          "Marlimund Lake",
          "Masinagudi",
          "Masinagudi Scrub Jungle",
          "Masinagudi Temple Pond",
          "Masinagudi-- Bamboo Banks (Restricted Access)",
          "Masinagudi-- Bokkapuram Road",
          "Masinagudi-- Cheetal Walk (Restricted Access)",
          "Masinagudi-- Garbage Dump",
          "Masinagudi-- Wild Haven (Restricted Access)",
          "Masinagudi--Jungle Hut (Restricted Access)",
          "Mavanalla",
          "Monterosa Colony, Ooty",
          "Moyar",
          "Moyar Dam",
          "Moyar Gorge, Mudumalai",
          "Moyar River, Kallampalayam",
          "Moyar Road, Masinagud",
          "Moyar Village",
          "Mudhumalai Tiger Reserve Interpretation Centre",
          "Mudumalai Forest",
          "Mudumalai NP",
          "Mudumalai Tiger Reserve-- Kargudi -Peacock Dormitory",
          "Mukurthi National Park",
          "Mulloor Village",
          "Murugan Temple, Elk Hill",
          "Murugan Temple, Elk Hill, Nondimedu, Ooty, Tamil Nadu, India",
          "Muthorai--General Area (OBI)",
          "Nadugani Village",
          "Naduvattam Area",
          "Needle Rock View Point",
          "Nelliyalam - Uppatti Road",
          "Nilgiri Hills (OBI)",
          "Oland",
          "Ooty Bus stand",
          "Ooty Garbage Dump",
          "Ooty Lake, Ooty",
          "Ooty-- Fingerpost",
          "Ooty--Accord Highland Hotel",
          "Ooty--General Area",
          "Pandalur",
          "Parsons Valley",
          "Pineforest, Thalakunda Creak",
          "Porthimund Dam",
          "Prakritilaya Nature Homes",
          "Pre-Doddabetta Dawn Trail",
          "Pudumund Village Area",
          "Pykara Falls",
          "Pykara, Masinagudi",
          "Radio Astronomy Centre, Muthorai",
          "Ralliah Dam",
          "Riverdale Vista (Restricted Access)",
          "Rojakandy, Aracode",
          "Rose Garden, Ooty",
          "Saint Monica Lake",
          "Sathyamangalam TR--Kallampalayam (Kelur & Melur)",
          "Satton Estate",
          "Settupettai",
          "Sheep Breeding Research Station, Sandynallah (Restricted)",
          "Sigur Ghat Bridge",
          "Sim's Park, Conoor",
          "Sinclair Ooty",
          "Singara Road",
          "Singaras Coffee Country, Masinagudi",
          "Siriyur",
          "Sri Madurai -- Gudalur",
          "Tan Tea Factory Road, Tiger Hill",
          "Temple Hill Overlooking Ketti Valley",
          "Thaishola Estate Area",
          "Thalaikundha",
          "Thankamala",
          "The Blue Mountains School",
          "Thengumarahada Forest, Nilgiris",
          "Thengumarahada Village",
          "Theppakadu Forest",
          "Theppakadu-Masinagudi Road",
          "Thorappaly Area",
          "Tiger Hill",
          "Upper Bhavani Road",
          "Upper Bhavani, Nilgiris",
          "Upper Nilgiris (Historical)",
          "Uyilatty Water Falls",
          "Valley View, Ooty",
          "Vibudhimalai Murugan Temple Hill",
          "Vijikan View Point",
          "Walmer",
          "Wellington Wetland",
          "Wenlock Downs 9th Mile Shooting Point",
          "Wild Zest Trail",
          "mountain railway",
        ],
      },
      {
        district: "Theni",
        localities: [
          "Adukkam Road, at foothills",
          "Agricultural land, Indira Nagar, Uthamapalayam",
          "Anana Pillayar Kovil, Bodinayakanur",
          "Arasaradi Area - Meghamalai",
          "Aruvikuzhi Waterfalls, Chellarcovil",
          "Bodi Ghat",
          "Bodi Hill West Forest Road",
          "Bodimettu",
          "Chinna Suruli",
          "Chinnamanur Sengulam",
          "Colonel Penny Kuick Bridge, Surulipatti",
          "Dindigul - Theni Hwy Near Parasuramapuram",
          "Endapuli Tank  (நஞ்சாபுரம் குளம்), Periyakulam",
          "Genguvarpatti Lake",
          "Highwavys",
          "John Pennycuick Memorial, Lowercamp",
          "Kailasapati Malai Kovil",
          "Kardana estate,Meghamalai",
          "Karunkattankulam Pond",
          "Kesavapuram Kanmai Nt Patti, Theni",
          "Koduvilarpatty Reserve Forest--Veerappa Ayyanar Temple",
          "Kumily Ghat Road, In between TNSTC bus station and Murugan temple",
          "Kurangani",
          "Kurangani -Top Station Trail",
          "Kurangani Hills",
          "Manjalar Dam, Palani Hills foothills",
          "Manjanuthu Check Post",
          "Meenakshipuram Tank",
          "Meghamalai Dam Road - Mel Manalaar Bridge",
          "Meghamalai View Point Area",
          "Merusamuthira Kulam, Theni",
          "Mullaperiyar River bend near Road",
          "Odappadi Kulam",
          "Ottangulam",
          "Ottukulam",
          "Periya Kulam, Thevaram",
          "Periyakulam Tank",
          "Ramakkalmedu View point",
          "Road to Vannathiparai Rf from Lower Camp",
          "Sri Adi Chunchanagiri Women's College, Cumbum",
          "Sri Thirumalairaya perumal temple ( Commencement of Ramakkalmedu trek path",
          "Suruli Falls",
          "Suruli Falls R.F",
          "Suruli R.F.",
          "Tamil Nadu Forestry college RF",
          "Thamaraikulam Tank, Periyakulam",
          "Thamaraikulam, Ramasamy Nayakkan Patti",
          "Thevaram Mettu",
          "Top Station",
          "Top Station View Point Path",
          "Uthamapalayam ( Cultivated fields to the west )",
          "Uthamapalayam Bypass Road - South",
          "Vaigai Dam",
          "Vaigai River Bridge, Vaigai Dam",
          "Vairavanar, below, Periyar Power station, KeelGudalur, Theni District ( Eagle OWL)",
          "Veera Naicken Kulam",
          "Veerapandi Riverview point",
          "Velimalai forest, Meghamalai Sanctuary",
          "Vellimalai",
          "Woodbriar Group Meghamalai Tea Estate Housingage Area",
          "cumbum mettu road",
        ],
      },
      {
        district: "Thiruvallur",
        localities: [
          "Alamathi Cattle Farm",
          "Alamathi Lake",
          "Ambattur",
          "Ambattur Lake",
          "Annamalaicheri-- Wetland & Grassland [OBI]",
          "Annamalaichery Watch Tower (அண்ணாமலைசேரி கோபுரம்)",
          "Annanur Railway Station Marsh Land",
          "Arani River",
          "Avadi Paruthipattu Lake Green Park",
          "Avadi-- Viraraghavapuram- Marshes",
          "Avoor- I (ஆவூர்-I)",
          "Avoor- II (ஆவூர்- II)",
          "Avurivakkam (அவுரிவாக்கம்)",
          "Ayanambakkam",
          "Ayanambakkam Tank",
          "Ayapakkam Lake",
          "Buckingham canal, Manali",
          "Chennai outer ring road, minjur",
          "Cholavaram Lake (சோழவரம் ஏரி)",
          "Dr MS Swaminathan Wetland Eco Park",
          "Edamani, Tiruvallur",
          "Edoor",
          "Ennore Bridge",
          "Ennore Creek",
          "Ernakuracheri-- Lotus Pond",
          "Erumaivettipalayam RF",
          "GC Avadi CRPF",
          "Giri Nagar, Ramapuram",
          "Guidyam Caves",
          "Kanavanthurai (கனவான்துறை)",
          "Kannadapalayam Lake",
          "Karungali",
          "Kathivakkam Lake",
          "Kattoor Lake -Thiruvallur (காட்டூர் ஏரி - திருவள்ளூர்)",
          "Konimedu Lake",
          "Korattur Lake",
          "Kosasthalai River-- Vayalur (வயலூர்)",
          "Kosasthalaiyar River -Athipattu Main Rd.",
          "Kosathalaiyar River, Kaatupalli",
          "Kovil Kuppam, Tamil Nadu",
          "Krishna Water Canal",
          "Kulathumedu, Andarmadam",
          "Light House-- Pulicat",
          "Livestock Farm Complex Madhavaram",
          "Madhavaram Botanical Garden",
          "Madhavaram Milk Colony",
          "Methur Grasslands",
          "Methur Lake, Vidathandalam",
          "Minjur suburbs",
          "Mittanamalli Lake",
          "Mittanamalli Wetland",
          "Nayapakkam Lake",
          "Neithavayal Lotus Pond",
          "Nemam Lake",
          "Nochimedu Lake (நொச்சிமெடு எரி)",
          "Nolambur",
          "Pallavada Lake",
          "Pandeswaram Lake",
          "Pandur Lake",
          "Peria-Puliyur Reserve Forest",
          "Perunjeri Lake",
          "Polivakkam Lake",
          "Poompozhil Nagar Lake",
          "Poondi Lake",
          "Port Access Road, Puzhuthivakkam",
          "Pulicat Lake-- Annamalaicheri",
          "Pulicat Lake-- Beach Main",
          "Pulicat Lake-- Beach Middle",
          "Pulicat Lake-- Fish market",
          "Pulicat Lake-- Sea mouth",
          "Pulicat Lake-- [TN Section]",
          "Pulicat-- Lake Top Point",
          "Putlur lake",
          "Ramapuram Lake",
          "Red Hills (Puzhal) Lake",
          "Redhills (Puzhal) Lake-- View Point",
          "Redhills (Puzhal) Lake-- West",
          "Retteri Lakewalk",
          "Sadayankuppam Canal",
          "Seganimedu Lake",
          "Sirulapakkam (சிருலபாக்கம்)",
          "Sirulapakkam Lake",
          "Sri Ramachandra Medical College",
          "TVS Avenue Area",
          "Thandurai lake",
          "Thangalperumpulam View Point, Andarmadam",
          "Thanneer Kulam Lake",
          "Thiruninravur (திருநின்றவூர்)",
          "Thirupalaivanam",
          "Thirutani Hill Foot Path way (திருத்தணி மலை நடைபாதை வழி)",
          "Thirutani Hill Road (திருத்தணி மலை பாதை)",
          "Thiruverkadu--Paruthipattu Lake",
          "Tiruverkadu lakeside",
          "Vadaranyeswarar Swamy Temple",
          "Vathattur Lake",
          "Vediyangadu (வேடியன்காடு)",
          "VelTech MultiTech Engineering College & surroundings",
          "Velammal Bodhi Campus, Ponneri [--restricted access]",
          "Vellanur Lake",
          "Vidaathandalam (விடாதண்டலம்)",
          "Vilinjiyambakkam Lake",
          "Wetland Opposite to Toshiba",
          "முல்லைவனம், திருமுல்லைவாயில்",
        ],
      },
      {
        district: "Thiruvarur",
        localities: [
          "Central University of Tamil Nadu",
          "Jambuvanodai",
          "Kannarapettai Lake",
          "Nallur Farmlands",
          "Pulavanallur",
          "Sengankadu",
          "Thirumeni Lake",
          "Thiruthanam Kulam",
          "Udhayamarthandapuram Bird Sanctuary",
          "Vadapathy Village, Near Mannargudi",
          "Vaduvur Bird Sanctuary",
        ],
      },
      {
        district: "Thoothukudi",
        localities: [
          "Alampatti Lake",
          "Aqua Outback Resort Area",
          "Arumugamangalam Lake",
          "Arumuganeri Salt Pans, Thoothukudi Dt",
          "Arunjunai Kaatha Ayyanar Temple Lake",
          "Authoor North Kulam",
          "Chengulam",
          "Eppodhumvendran Lake",
          "Hare Island",
          "Kadambakulam (கடம்பகுளம்)",
          "Kadmbakulam (கடம்பகுளம்)",
          "Karungulam",
          "Kaspa Kulam",
          "Kilavallanadu pond",
          "Kongaraya Kuruchi , Tamirabarani River",
          "Korrampallam Tank (கோரம்பள்ளம்)",
          "Kurumbur Kulam",
          "Kuthukal Mount, Muthur",
          "Lakshmipuram Ooruni",
          "Malai Parvathi Amman Temple, Vallanadu R.F.",
          "Manapad Sea Watching Point",
          "Manjal Neer Kayal",
          "Mel Pudhukudi Sunai",
          "Mel Pudukudi Sunai",
          "Melakulam-- Karungulam (கருங்குளம்)",
          "Moopanpatti Lake",
          "Mudukkumeendanpatti",
          "Nalayiramvudaiyar Kulam",
          "Nallur Pond - West",
          "Nallur Pond-East",
          "Nallur Pond-West",
          "National Engineering College, Nallattinputhur",
          "Padmanabhamangalam Lake",
          "Pattinamaruthr",
          "Pearl City Beach",
          "Peikulam",
          "Periya Puthan Tharavai",
          "Periya Tharuvai",
          "PeriyaTharuvai Kulam (பெரிய தருவை)",
          "Perukulam Lake",
          "Perunkulam",
          "Perur Kulam",
          "Perurani Grasslands",
          "Petmanagaram",
          "Pudukulam",
          "Roche Park",
          "S. Karaiyadiyoor Lotus Lake, Seydunganallur",
          "Sivagalai",
          "Sornamalai, Kovilpatti",
          "Sri Kailasananthar Temple, Murappanadu,",
          "Tenkarai Kulam",
          "Tenkari Kulam",
          "Thamirabarani River Pakkappatti Bridge",
          "Thamirabarani Riverbank, Srivaikuntam",
          "Therikaadu--Arunjunai Kaatha Ayyanar Temple",
          "Therikaadu--Near Karkuvel Ayyanar Temple",
          "Theriku Aathoor Tank",
          "Thiruchendur Area",
          "Thiruchendur Railway Station",
          "Tuticorin Port (தூத்துக்குடி துறைமுகம்)",
          "Vaippar",
          "Valanadu",
          "Valasai Bird Sancturay (வலசை பறவைகள் சரணாலயம்) (திருப்பணிசெட்டிகுளம்)",
          "Vallanadu Blackbuck Sanctuary",
          "Vanaramutti Kulam",
          "Velur Kasba Tank",
          "Vembar Backwaters",
        ],
      },
      {
        district: "Tiruchirappalli",
        localities: [
          "ARK Nagar Area",
          "Alangudimahajanam Lake",
          "Alathudaiyanpatti lake",
          "Andharapatti",
          "Anna Science Centre Planetarium",
          "Annai Kamatchi Amman Kovil, Puthanampatti",
          "Arasangudi Lake",
          "BHEL Nehru Nagar Township",
          "Bharathidasan Institute of Management (BIM) Campus",
          "Bharathidasan University Campus",
          "Bishop Heber College",
          "Devarayaneri Lake",
          "Gundur Lake",
          "IIM Trichy",
          "Inamkulathur Lake",
          "Jamal Mohamed College",
          "K. K. Nagar Area",
          "K.Kallikudy Lake",
          "Kambarasampettai Thaduppanai",
          "Kandhalur Scrub",
          "Kannanur Semi Arid Grasslands,",
          "Kannoothhu Lake",
          "Karattumalai Scrub Forest",
          "Kaveri River Bridge, Thiruchirapalli",
          "Kaveri River, Musiri",
          "Kiliyur Tank",
          "Koothappar Tank",
          "Kottapattu Periyakulam",
          "Kottathur",
          "Kottathur Pond",
          "Kottathur, Gandhi Nagar",
          "Kovandakurichi Pond (கோவந்தகுறுச்சி)",
          "Kumaresapuram Lake",
          "MAM College Of Engineering",
          "MANIGANDAM TANK",
          "Mahadevipudur Tank மகாதேவிபுதூர் ஏரி",
          "Mamarathu Solai, Solamathi",
          "Manapparai - Kadavur Road",
          "Manikandam Lake மணிகண்டம் ஏரி",
          "Marsh Land (Near Cauvery College for Women), Woraiyur",
          "Mavadi Kulam",
          "Melakulam Lake, Mudikandam",
          "Melamangavanam Lake மேலமாங்காவனம் ஏரி",
          "Murungai PHC Area",
          "National Institute of Technology (NIT), Trichy",
          "Navalpattu Lake",
          "Nehru Memorial College",
          "Neiveli Lake, Tiruchirappalli",
          "Padugai Lake",
          "Panjapur Lake",
          "Periyapatti",
          "Perur Lake, Tiruchirappalli",
          "Pillaiyarkulam, Koothappar",
          "Poolangudi Lake",
          "Poongudi Lake",
          "Poovalur Madanam Lake",
          "Prasanna Venkatachalapathi Temple Hill பிரசன்ன வெங்கடாசலபதி கோவில் மலை",
          "Punganur Lake",
          "Punjai Sangenthi Tank",
          "Puthanampatti Lake",
          "Putharchikulam",
          "Railway Mixed Higher Secondary School, Tiruchirappalli",
          "Reddiyarpatti Lake, Eragudi South",
          "Sangendhi Grassland",
          "Sengkurrichi Tank",
          "Settiyarpettai Tank",
          "Sirunganur Scrub and Dry Evergreen Forest Area",
          "Srirangam Railway Station",
          "Subash Nagar Area",
          "Thachankurichi RF",
          "Thinnanur lake",
          "Thiruverumbur Big Tank",
          "Thiruverumbur Lake",
          "Thuraiyur Lake",
          "Thuvakudi Lake",
          "Tiruchirappalli Central Bus Stand",
          "Tiruchirappalli Corporation Sewage Water Treatment Plant",
          "Tiruchirappalli Junction Railway Station",
          "Top Sengattupatti",
          "Tropical Butterfly Conservatory (Butterfly Park)",
          "Uchi Pillaiyar Kovil / Malaikottai / Rock Fort",
          "Upper Anaicut / Mukkombu Dam",
          "Uyyakondan Branch Canal -  Balaji Nagar side",
          "Uyyakondan Canal, Raja Colony",
          "Uyyakondan River",
          "Vadakupatti Lake, Eragudi North",
        ],
      },
      {
        district: "Tirunelveli",
        localities: [
          "Agasthiyamalai Hill top",
          "Agasthiyar Falls",
          "Agasthyamalai Community Conservation Centre, Manimutharu",
          "Alagankulam Pond",
          "Ambasamudram Lake",
          "Anuvijay Township, Chettikulam",
          "Ariyakulam Lake",
          "Ariyanayagipuram Kulam",
          "Ayyappaneri Kulam",
          "Brancherri",
          "Central Excise Office (மத்திய கலால் அலுவலகம்)",
          "Chepparai Nataraja Temple",
          "Chettikulam (OBI)",
          "Devanallur",
          "District Science Center Park",
          "Elanthakulam",
          "Emankulam Tank",
          "Eruvadi",
          "Flood Stream Bridge,  Maruthakulam",
          "Gangaikodan",
          "Gangaikondan Kulam",
          "Government Higher Secondary School, Maruthakulam",
          "Indira Kulam (South Pond)",
          "Itteri Lake",
          "Jayamathapuram Pond and wind farm",
          "Kalakkad Mundanthurai Tiger Reserve",
          "Kalkurichi Lake",
          "Kaluvoor Kulam",
          "Kandan Kulam",
          "Kanganankulam",
          "Karayar Dam",
          "Karungulam-Kabaliparai",
          "Kodumudiyaru Dam",
          "Kolunthu Mamalai",
          "Kompanantaipparai",
          "Konganthanparai  Kulam",
          "Koonikulam, Moolaikaraipatti",
          "Koonthakulam Bird Sanctuary",
          "Koonthankulam Grasslands",
          "Kottai Karungulam",
          "Kottai Karungulam/Vadivamman (கோட்டைகருங்குளம்)",
          "Kottaikarungulam- Nambi Dam Rd",
          "Kovaneri Lake",
          "Kuppakurchi Kulam",
          "Lake Oppsite To Cambridge School,Keel Ambur",
          "Levinjipuram Pond",
          "Madura Coats Colony",
          "Malayala Medu Kulam",
          "Manimuthar Dam",
          "Manimuthar Right Canal road",
          "Manimutharu Forest Guest House",
          "Manjolai Bus Stand Area",
          "Manur Lake",
          "Mela Kadambankulam",
          "Melapattam Hillock (மேலப்பட்டம் மலை)",
          "Melapattam Road, மேலப்பாட்டம் சாலை",
          "Moolakaraipatti Pond",
          "Morukulam-Kannamkulam-Namparchikulam Ponds, Jayamathapuram",
          "Mukkudal Pond (Korung Kulam)",
          "Mundanthurai Forest Guest House",
          "Mundanthurai Tiger Reserve--Forest Rest House",
          "Muthur Kulam (முத்தூர் குளம்)",
          "Muthur Tank",
          "NGO Colony Tank, Thirunelveli",
          "Naalumukku, Singampatti Zamindar Forest",
          "Nainar Kulam, Tirunelveli",
          "Nallur East",
          "Nambi Kovil Road",
          "Nambi dam (நம்பி அணை) (கோட்டைகருங்குளம்)",
          "Nambikurichi Kulam",
          "Nambiyar Dam",
          "Narasinganallur Pond",
          "Nellaiappar Temple",
          "Netturankulam",
          "Oochikulam",
          "Oochikulam Periyakulam",
          "Oosikulam Periyakulam",
          "PSN College Road",
          "PSN College and surrounds",
          "PSN College of Engineering and Technology, Melathediyoor",
          "Paalaamadai Lake",
          "Padmaneri",
          "Palamadai/Rajavallipuram",
          "Palavoor Pond",
          "Pandipathu Forest camp",
          "Paraikulam Lake",
          "Parappadi Lake",
          "Parpanathapuram Tank",
          "Pirancheri Periya Kulam",
          "Ponvizha Nagar (பொன்விழா நகர்)",
          "Poolam Lake and Marshes",
          "Poovarasan Kulam (பூவரசன் குளம்)",
          "Pudhukulam",
          "Rahmath Nagar Bypass Road Pond",
          "Rajapudhur Lake",
          "Rajavallipuram Tank Entrance",
          "Rani Anna College, Gandhi Nagar, Thirunelveli",
          "Reddiarpatti Hill--Sai Baba Temple",
          "Saral Kulam",
          "Sarall Kulam",
          "Seeavalaperi Area",
          "SengalTheri GuestHouse WatchTower, Kalakadu R.F",
          "Sengulam",
          "Sengulam, Tirunelveli",
          "Servalaru Dam",
          "Setruthamarai Kulam, Nanguneri",
          "Shifa Golden City, Tirunelveli (OBI)",
          "Sivandipatti Lake & Grassland",
          "Sivanthipatti Lake",
          "Sivanthipatti Pond",
          "Sivanthipatti Road",
          "Sivanthipatti Tank 1",
          "Soorangudi Tank",
          "Spotted Deer Sanctuary, Gangaikondan",
          "St. Xavier's College, Palayamkottai",
          "TVSM ASRI Farm, Eruvadi",
          "Tamira Bharani River Bridge",
          "Thamirabarani River, Kodaganallur",
          "Thamirabharani River, Near Kasyapanathar Temple, Ambasamuthiram",
          "Tharuvai Grassland",
          "Tharuvai Lake",
          "Thattankulam Kulam",
          "Thinaiyoorani Lake",
          "Thirukurungudi Lake",
          "Thirunelveli Medical College Men's hostel",
          "Thiruppudaimaruthur Conservation Reserve",
          "Thiruvenkatanathapuram (திருவேங்கடநாதபுரம்)",
          "Tirunelveli Medical College Ground",
          "Tirunelveli Railway Station",
          "Vadakkuvalliyur Pond (வடக்குவள்ளியூர்)",
          "Vadukachimathil Pond (Dohnavur)",
          "Valliyur Kulam",
          "Valliyur Railway station",
          "Veinthaan Kulam (Pond), Palayamkottai",
          "Vijaya Achampaadu Kulam (விஜய அச்சம்பாடு குளம்)",
          "Vijaya Achampadu Kulam",
          "Vijayanarayanam Tank",
          "rajavallipuram",
          "rajvllipuram",
        ],
      },
      {
        district: "Tirupathur",
        localities: [
          "Agasthiar Maha Pyramid Kshethram",
          "Alangayam Lake",
          "Aneri Lake",
          "Chennapamalai, Ambur",
          "Ebenezer MHSS",
          "Jalagamparai Water Falls Area",
          "Jolarpet Lake",
          "Jolarpettai Railway Junction",
          "Kailasagiri Hill",
          "Mayilparai Balamurugan temple, Yelagiri Hills",
          "Nilavoor Lake, Yelagiri",
          "Pudukottai Lake",
          "Sacred Heart College, Tirupathur",
          "Singarapettai R.F.",
          "Tirupathur Big Lake - Janaki Ponnusamy School Side",
          "Tirupattur Big Lake - Bus Stand Side",
          "Vainu Bappu Observatory, Kavalur",
          "Vinnamangalam Lake, Ambur",
          "YMCA Camp, Yelagiri",
          "Yelagiri Lake",
          "Yelagiri Nature Park",
          "Yelagiri hills",
          "Yelagiri-- Mangalam Village",
          "Yelagiri--Nilavoor Road",
        ],
      },
      {
        district: "Tiruppur",
        localities: [
          "Aangkovil Kuttai",
          "Alagu Thirumalairaya Perumal Kovil",
          "Alagumalai Temple",
          "Alangiam Canal, Dharapuram",
          "Amaravathi Dam அமராவதி அணை",
          "Amaravathi River, Dharapuram",
          "Amaravathi River, Dharapuram - Alangiyam Road",
          "Amaravathi River, Madathupalayam",
          "Amaravathi River, Peramium",
          "Amaravathi River, Sankarandampalayam",
          "Amaravathy River, New Bypass Road Bridge, Dharapuram.",
          "Amaravathy River, Thillapuri Amman Temple, Dharapuram",
          "Anaikkattu, Amaravathi River, Dharapuram",
          "Andipalayam Lake, Tirupur",
          "Bhagawan Kovil Road, Dharapuram",
          "Cambridge Matriculation Higher Secondary School, Avinashi",
          "Chinna Kodangipalayam Grassland",
          "Chinnar WLS - Tamil Nadu side",
          "Chinnar Wildlife Sanctuary, Tiruppur",
          "Chinnar--Anamalai Tiger Reserve",
          "Dharapuram Windmill Grasslands",
          "Ganapathi Nagar, Dharapuram",
          "Ganapathy Palayam Area",
          "Government High School, Poomalur, Tiruppur",
          "Gudimangalam Road Junction",
          "Jallipatti Lake",
          "Kadathur Archuneswarar Temple and Surrounds",
          "Kaliamman Kovil Pond",
          "Kongur Lake",
          "Kumar Nagar, Tiruppur, Tamil Nadu, India",
          "Kuttapalayam (Village)",
          "LRG Govt Arts College for Women",
          "Lower Bhavani Project Canal, Chennimalai",
          "Manikapuram Kulam மாணிக்கப்புரம் குளம்",
          "Manjampatti Valley--Indira Gandhi National Park",
          "Manjampatti-Chinnar Trek",
          "Nallathangal Odai Reservoir, Dharapuram",
          "Nambiyampalayam",
          "Nanjarayan Tank Bird Sanctuary (Koolipalayam Reservoir) நஞ்சராயன் குளம் பறவைகள் சரணாலயம்",
          "Nanjegoundenputhur Area",
          "Orathupalayam Reservoir",
          "Ottu Kulam, Udumalpet",
          "Periya Kulam, Udumalpet பெரிய குளம், உடுமலைப்பேட்டை",
          "Pongalur Grassland",
          "Ponna puram",
          "Pudhupalayam Tank (புதுப்பாளையம் குளம்)",
          "Pungan Odai, Anamalai Tiger Reserve",
          "Rakkiyapalayam Kulam",
          "Ramaiyampalayam Kulam",
          "Sainik School Amaravathinagar",
          "Sainik School, Amaravathinagar Campus",
          "Samalapuram Kulam",
          "Sarkarai Mandradiar Kazhangu, Muthur ( Private Area Restricted)",
          "Sayapattarai Karadu",
          "Sengulam Lake",
          "Sinnegoundanpudhur Grassland",
          "Thamarai Kulam",
          "Thennampalayam Pond",
          "Thirumoorthy Waterfalls Trail",
          "Thumbalapatti Karadu",
          "Tiruppur Outskirts",
          "Tiruppur Railway Station",
          "Udumalpet Forest Check Post",
          "Uppar Dam உப்பாறு அணை",
          "Uppar Grasslands",
          "Upparu River, Alampalayam, Dharapuram",
          "Uthiyur Hillock",
          "Uthuppalayam Reserve Forest, Dharapuram",
          "V Vellur Pond",
          "Veterinary College & Research Institute, Udumalaipettai, Kozhikuttai",
        ],
      },
      {
        district: "Tiruvannamalai",
        localities: [
          "Adaiyur Lake",
          "Agricultural College, Vazhavachanur",
          "Alathur Lake",
          "Amirthi Forest",
          "Amirthi Forest-- Location 2",
          "Annamalai RF",
          "Aradapattu Lake",
          "Ariyakunjur (Near Sathanur dam)",
          "Arunachaleswara Big Temple, Thiruvannamalai",
          "Arunagiri Park",
          "Aswaragasuranai, Tiruvannamalai",
          "Athipakkam R.F. (அத்திப்பாக்கம் காப்புக்காடு)",
          "Beeman Falls",
          "Desur Lake",
          "Eraiyur lake",
          "Gengampattu Periyakulam Lake",
          "Kannamadai Forest",
          "Kariyanchetti Lake",
          "Karumarpati lake",
          "Kendriya Vidyalaya School-- Tiruvannamalai",
          "Kilnakkarai Lake (Behind Shanmuga College), Thiruvannamalai",
          "Kilnathur Lake",
          "Kilsathamangalam Lake",
          "Kilsirupakkam Lake",
          "Komutteri Lake Park",
          "Konalur Lake",
          "Kootathur Pond",
          "Kujal Pettai Lake, Tiruvannamalai",
          "Kuppanatham Dam",
          "Mahasakthi Nagar",
          "Mamandur Lake",
          "Mangalam Village, Tiruvannamalai",
          "Mangalam Village,Tiruvannamalai",
          "Marudam Farm School",
          "Melpattu Forest Road",
          "Melsirupakkam Lake",
          "Moranam Lake",
          "Mounayogi Vidobanandha Ashram, Kadalaadi",
          "Mountain path Arunachala",
          "Murugan Kovil Hill, Kiliyapattu",
          "Nedungavadi",
          "Nedungavadi lake",
          "Nochimalai Lake",
          "Palayanur Hill",
          "Paliapattu Lake",
          "Parvathamalai Reserve Forest",
          "Perumuttam Forest Road",
          "Polur Lake",
          "Ponnur Lake",
          "Samudram Lake",
          "Samudram Lake West",
          "Sathanur Dam",
          "Shanti retreats (Singing Heart Ashram)",
          "Sonagiri Sacred Grove",
          "Sri Ramanasramam, Thiruvannamalai",
          "Terminalia Arjuna (நீர் மத்தி/மருது)",
          "Thamarai Kulam (Lotus Pond)",
          "Thellar (தெள்ளாறு)",
          "Thenpallipattu Wetland",
          "Thenvanakkambadi (தென்வணக்கம்பாடி)",
          "Theyyar (தெய்யார்)",
          "Thiruvannamalai RF--Skandashram Trail",
          "Vengikkal Lake",
          "Yama Lingam Temple",
          "kendriya vidyalaya",
          "பிஞ்சூர் ஏரி (Pinjur Lake)",
        ],
      },
      {
        district: "Vellore",
        localities: [
          "AMIRTHI WATERFALL",
          "Alamelumangapuram Village",
          "Amirthi forest",
          "Bahadurpalli River, Pernambut",
          "Balamathi Hills, Vellore",
          "Bathalapalli--Malattaru River Bridge",
          "Brahmapuram Marsh",
          "Brammapuram",
          "CMC Eden Garden",
          "Christian Medical College (CMC), Vellore",
          "Christian Medical College Campus, Bagyam, Vellore (OBI)",
          "FRH Campus, Vellore (OBI)",
          "Janullah shah Hill, Pernambut",
          "Kalabairavar Temple",
          "Kalliputtu Kulam, Naickaneri",
          "Karigiri Hospital",
          "Katpadi Lake / Gopal Samuthram",
          "Koundinya Wildlife Sanctuary",
          "Mordhana dam and surroundings",
          "Murukkambattu, Kolaimedu",
          "Palamathi Reserved Forest",
          "Palar River Bridge- Hyderpuram",
          "Palar River, Gudiyatham",
          "Palar River, Shenbakkam, Vellore",
          "Palavanatham , Santhaimedu , K V Kuppam",
          "Pallavansathu Kuppam Lake (பலவன்சாத்துக்குப்பம் ஏரி)",
          "Sathgar Hill,Pernampet",
          "Shenbakkam, Palar River",
          "Sri Theerthagiri Vadivel Subramanyar Temple",
          "TEL Lake, Kunjanur R.F., Vellore",
          "Technology Tower, VIT University",
          "Thuthipet",
          "Vallimalai Hillock",
          "Vallimalai Lake (வள்ளிமலை ஏரி)",
          "Vallimalai Temple pond",
          "Vellore Fort Round Road,",
          "Vellore Institute of Technology Lake",
          "Vellore Institute of Technology Playground",
        ],
      },
      {
        district: "Viluppuram",
        localities: [
          "Aalangkuppam Lake (ஆலங்குப்பம் ஏரி)",
          "Aalathoor Lake (ஆலத்தூர் ஏரி)",
          "Aanaangoor Lake (ஆனாங்கூர் ஏரி)",
          "Aanpaakkam Lake (ஆண்பாக்கம் ஏரி)",
          "Aapirambattu Lake (ஆப்பிரம்பட்டு ஏரி)",
          "Aasaarankuppam Village (ஆசாரங்குப்பம்)",
          "Aathikuppam Lake (ஆத்திக்குப்பம் ஏரி)",
          "Aathikuppam Village",
          "Aathur Lake (ஆத்தூர் ஏரி)",
          "Acharampattu Lake (அச்சரம்பட்டு ஏரி)",
          "Adanapattu Lake (ஆதனப்பட்டு ஏரி)",
          "Adukkam RF",
          "Alamarathukuppam Lake (ஆலமரத்துக்குப்பம் ஏரி)",
          "Ammamamkuppam Village",
          "Andiyarpalayam Lake (ஆண்டியார்பாளையம் ஏரி)",
          "Annamputhur Lake (அன்னம்புத்தூர் ஏரி)",
          "Arakandanallur Lake (அரகண்டநல்லூர் ஏரி)",
          "Aranya Forest and Sanctuary (Restricted Access)",
          "Asappur Lake (அசப்பூர் ஏரி)",
          "Auro Vanam ஆரோ வனம் (Restricted  Access)",
          "Auroville",
          "Auroville Botanical Gardens",
          "Auroville beach",
          "Avarappakkam Lake (அவரப்பாக்கம் ஏரி)",
          "Bommaiyapalayam,Auroville",
          "Botheri Lake, Thindivanam",
          "Brammadesam Lake (பிரம்மதேசம் ஏரி)",
          "Buckingham Canal--Kaipanikuppam",
          "Chettinagar-Kaliankuppam ( Purple Lake )",
          "Elrampattu Lake",
          "Enthur Lake (ஏந்தூர் ஏரி)",
          "Eraiyanur Lake (எறையானூர் ஏரி)",
          "Eraiyanur Sitheri (எறையானூர் சித்தேரி)",
          "Fields, opposite to Kodur lake",
          "Gingee Fort Entrance",
          "Govt. Primary School, Navarkulam",
          "Hotel Purple Lake View, Chettinagar, Koonimedu",
          "Illavampattu Lake (இலவம்பட்டு ஏரி)",
          "Irumbai Agricultural Fields",
          "Irumbai Lake (இரும்பை ஏரி)",
          "K Resort (Restricted Access)",
          "Kaliveli (Kazhuveli) Lake--Koonimedu entrance",
          "Kaliveli (Kazhuveli) Lake--New route",
          "Kaliveli-- (Kazhuveli) Old route",
          "Kallakolathur  Scrub Land",
          "Kappiampuliyur Lake (கப்பியாம்புலியூர் ஏரி)",
          "Karai RF",
          "Karasanur Quary",
          "Kattrampakkam Lake (காட்ராம்பாக்கம் ஏரி)",
          "Kattupaiyur Lake",
          "Kaveripakkam Lake (காவேரிப்பாக்கம் ஏரி)",
          "Kazhiveli Check Dam",
          "Kazhuperumbakkam Lake (கழுப்பெரும்பாக்கம் ஏரி)",
          "Kazhuveli Wetland Birds Sanctuary(கழுவெளி பறவைகள் சரணாலயம்)",
          "Kazhuveli--Puthupet - Monnaiyampet Route",
          "Keezhkoothapaakkam Lake (கீழ்கூத்தப்பாக்கம் ஏரி)",
          "Kiliyanur Periya Eri (கிளியனூர் பெரிய ஏரி)",
          "Kiliyanur Sitheri (கிளியனூர் சித்தேரி)",
          "Kilsithamur Lake (கீழ்சித்தாமூர் ஏரி)",
          "Kodur Iyyanaar Koil Lake (கொடூர் ஐய்யனார் கோவில் ஏரி)",
          "Kodur Lake (கொடூர் ஏரி)",
          "Kodur Lake--Fields",
          "Kolapakkam Lake",
          "Kondamur Lake (கொந்தமூர் ஏரி)",
          "Konjimangalam Lake (கொஞ்சிமங்கலம் ஏரி)",
          "Kothampakkam Lake (கொத்தாம்பாக்கம் ஏரி)",
          "Kottamaruthur Lake",
          "Krishnagiri Fort, Gingee (Senji)",
          "Kulathur Lake (குளத்தூர் ஏரி)",
          "Kunnam Lake (குன்னம் ஏரி)",
          "Kurumbaram Lake (குரும்பரம் ஏரி)",
          "Kurumbaram Reserve Forest (குரும்பரம் காப்புக்காடு)",
          "Lilly Pond( அல்லிக் குளம்) Pakkam, Tamil Nadu, IN (11.857, 79.683)",
          "Maanoor Lake (மானூர் ஏரி)",
          "Madavanthaangal Lake (மடவந்தாங்கல் ஏரி)",
          "Mandagappattu Lake (மண்டகப்பட்டு ஏரி)",
          "Marakkanam",
          "Marakkanam RF--Dry scrub and forest",
          "Marakkanam Reserved Forest",
          "Maruthur Lake (மருதூர் ஏரி)",
          "Miracle Farm and surrounding area",
          "Mudhalur Lake",
          "Munnur Lake (முன்னூர் ஏரி)",
          "Murukkam Lake (முருக்கம் ஏரி)",
          "Murungapakkam Lake (முருங்கப்பாக்கம் ஏரி)",
          "Muttakadu RF",
          "Muttrampet Lake (முட்ராம்பட்டு ஏரி)",
          "Nallapareddy Palayam Lake (நல்லப்பரெட்டி பாளையம் ஏரி)",
          "Nallavoor Lake (நல்லாவூர் ஏரி)",
          "Nesal Lake (நெசல் ஏரி)",
          "Old Alwar Lake south",
          "Omandhur Lake (ஓமந்தூர் ஏரி)",
          "Ottai Lake (ஒட்டை ஏரி)",
          "Oussudu Lake Birds Sanctuary--TN side (ஊசுடு ஏரி பறவைகள் சரணாலயம்--தமிழகப் பகுதி)",
          "Paakkam Lake (பாக்கம் ஏரி)",
          "Padipallam Forest and Hills",
          "Pakkam Lake",
          "Pakkamalai RF",
          "Pallipudhupattu Lake (பள்ளிப்புதுப்பட்டு ஏரி)",
          "Panamalai Lake (பனமலை ஏரி)",
          "Panampet Lake (பானாம்பட்டு ஏரி)",
          "Paranur Lake",
          "Pennaivalam Lake",
          "Peraavoor Lake (பேராவூர் ஏரி)",
          "Perumbakkam Lake",
          "Perumukkal Lake (பெருமுக்கல் ஏரி)",
          "Perungapur Lake",
          "Pinnanur",
          "Pitchandikulam Forest",
          "Poyyapakkam Lake (பொய்யாப்பாக்கம்/பொய்கைப்பாக்கம் ஏரி)",
          "Pudhunagar Lake (புதுநகர் ஏரி)",
          "Pulichapallam Big Tank (புளிச்சபள்ளம் பெரிய ஏரி)",
          "Pulichapallam Lake (புளிச்சபள்ளம் ஏரி)",
          "Putthupattu Beach (புத்துப்பட்டு கடற்கரை)",
          "Rajagiri Hill",
          "Rocky Shrub - Grasslands btw Sitambur and Aruvapakkam",
          "Roya Ottai Lake (இராய ஒட்டை ஏரி)",
          "Royapudupakkam (இராயப்புதுப்பாக்கம் ஏரி)",
          "Salavaadhi Lake (சலவாதி ஏரி)",
          "Semangalam Lake (சேமங்கலம் ஏரி)",
          "Serenity Beach",
          "Singanandhal Lake (சிங்கநந்தல் ஏரி)",
          "Singavaram Temple",
          "Siruvaadi Lake (சிறுவாடி ஏரி)",
          "Siruvadi RF",
          "Sithamburmalai/Periyamoor Forest",
          "Sorappur Lake",
          "T. Konalavadi Lake",
          "T. Kunnathur Lake",
          "T. Pudupalayam Lake",
          "Tailapuram Lake (தைலாபுரம் ஏரி)",
          "Terkunam Lake (தேற்குணம்  ஏரி)",
          "Thamarai Kulam தாமரைக் குளம்",
          "Thazhankadu (தாழங்காடு)",
          "Then Pennai River--Kandarakottai Bridge",
          "Thenkodipakkam Lake (தென்கோடிபாக்கம் ஏரி)",
          "Thennagaram Lake (தென்னகரம் ஏரி)",
          "Thiruchitrambalam lake (திருச்சிற்றம்பலம் ஏரி)",
          "Thookanaampaakkam Lake (தூக்கணாம்பாக்கம் ஏரி)",
          "Tindivanam Big Tank (திண்டிவனம் பெரிய ஏரி)",
          "Tindivanam Thaangal Eri (திண்டிவனம் தாங்கல் ஏரி)",
          "Tindivanam--General Area",
          "Udaiyanatham RF",
          "Ulagaapuram Perumal Lake (உலகாபுரம் பெருமாள் ஏரி)",
          "V. Budhur Lake (புதூர் ஏரி)",
          "V. Mathur Lake (மாத்தூர் ஏரி)",
          "V.Pudupakkam Lake (வி.புதுப்பாக்கம் ஏரி)",
          "VALUDAVUR LAKE (வழுதாவூர்)",
          "Vaakkoor Lake (வாக்கூர் ஏரி)",
          "Vada Aalappakkam Lake (வட ஆலப்பாக்கம் ஏரி)",
          "Vada Kodipakkam Lake (வடகோடிப்பாக்கம் ஏரி)",
          "Vada Kodippaakam Sitheri (வடகோடிப்பாக்கம் சித்தேரி)",
          "Vadamalaiyanur Lake",
          "Vallavanur Lake (வளவனூர் ஏரி)",
          "Valudavur Lake (வழுதாவூர் ஏரி)",
          "Vanaduragai Amman Temple Hill",
          "Vandipalayam -- Marakkanam road",
          "Vandipalayam Bridge",
          "Vanur Lake (வானூர் ஏரி)",
          "Vazhukam Parai Lake (வழுக்கும் பாறை ஏரி)",
          "Veedur Dam (வீடூர் அணை)",
          "Vengai Lake (வேங்கை ஏரி)",
          "Vepperi Big Tank (வேப்பேரி பெரிய ஏரி)",
          "Vepperi Sitheri (வேப்பேரி சித்தேரி)",
          "Vilvanatham Big Tank (வில்வநத்தம் பெரிய ஏரி)",
          "Vilvanatham Small Tank (வில்வநத்தம் சின்ன ஏரி)",
          "Yedaiyanthittu Estuary (இடையன் திட்டு கழிமுகம்)",
        ],
      },
      {
        district: "Virudhunagar",
        localities: [
          "Alathan Kulam, Rajapalayam",
          "Alathur Lake, Virudhunagar",
          "Anaikottam Reservoir, Sivakasi",
          "Anaikuttam Dam",
          "Arulmigu Angala Eeswari Temple, Mamsapuram",
          "Ayodhiram Nagar",
          "Ayya Nadar Janaki Ammal College",
          "Ayyanar falls , Rajapalayam",
          "Chenkulam Kanmai, Sundarapandiam",
          "Chinmaya Vidyalaya PACRR Matric HS School",
          "Chinnakulam,Sivakasi",
          "Chinnavalikulam Rd",
          "Devathanam South Kulam",
          "Dry Lands, Singammalpuram",
          "Golwarpatti Reservoir",
          "Grizzled Squirrel Wildlife Sanctuary, Srivilliputhur",
          "Inamkarisalkulam Tank",
          "Irukkankudi Reservoir",
          "KVS Matriculation Higher Secondary School",
          "Kadamankulam (Thoppupatti)",
          "Kalangaperi, Tamil Nadu, IN (9.44, 77.59)",
          "Kalasalingam Academy of Research and Education",
          "Karungulam Lake",
          "Katalagar Temple Nupura Gangai Theertham",
          "Katalagar Waterfalls, Srivilliputhur Grizzled Squirrel Sanctuary",
          "Kizhavankovil Karuppasamy Kovil",
          "Kondaneri Lake, Rajapalayam",
          "Koomapatti Lake",
          "Kousiga River, Virudhunagar",
          "Krishnappery",
          "Kullursandai Reservoir",
          "Maamarathu Keni, Sastha Koil, Settur RF",
          "Melapattam Karisalkulam",
          "Mepco Schlenk Engineering College",
          "Minerva Public School",
          "Mudhaliarkulam",
          "Muthukudi Fourway Lake",
          "New Bus Stand Lake, Rajapalayam",
          "PAC Ramasamy Raja Polytechnic College",
          "Pachaiyar Estate",
          "Padikkasu Vaithanapatti Kulam",
          "Palavanatham - Gopalapuram Road",
          "Patchaimadam (Thoppupatti)",
          "Patchaimadam Lake",
          "Perali Road",
          "Periyakulam",
          "Pilavakkal Dam",
          "Puliyamkulam",
          "Puthukulam Lake",
          "Rajapalayam Railway Station",
          "Rajapalayam Rajus' College",
          "Rajapalayam Water Reservoir",
          "Rakatchi Amman Kovil, Valaikulam RF",
          "Rakatchi Amman Kovil, near Srivilliputhur GSWS",
          "Ramco Institute of Technology",
          "Sappaniparambu",
          "Sathakovil Dam",
          "Seithur Kulam",
          "Sengulam Lake, Thiruthangal",
          "Senkulam Lake",
          "Shenbagathoppu",
          "Sivagnanapuram Kanmai",
          "Solaicheri Wetland",
          "Sri Mathi Lingammal Ramarajhu Matriculation HSS",
          "Sundarapandiam kanmai (Watrap Lake)",
          "Suryankallu Camp",
          "Tambathan Urani",
          "Thaaniparai, Virudhunagar Dt",
          "Twin Tank / Puliyan Kulam, Rajapalayam",
          "Urinjakulam Tank, Thiruthangal",
          "Valaikulam Reservoir",
          "Valukuparai",
          "Vellaichamy Nadar Polytechnic College",
          "Vendurayapuram",
          "Virudhunagar Hindu Nadars' Senthikumara Nadar College (VHNSN)",
        ],
      },
    ],
  },
  {
    state: "Telangana",
    districts: [
      {
        district: "Adilabad",
        localities: [
          "ALV lake (Kajjarla)",
          "Balampur lake",
          "Bandemragad Reservoir",
          "Bazarhatnoor lake",
          "Belsari Rampur Reservoir",
          "Bheempoor wetland complex",
          "Birsaipet forest lake",
          "Birsaipet large lake",
          "Birsaipet village lake",
          "Boath Reservoir",
          "Bondadi lake",
          "Chintalabori Reservoir",
          "Danthanpalle Reservoir",
          "Danthanpalle lake 2",
          "Danthanpalle lake 3",
          "Devapur lake 1",
          "Devapur lake 2",
          "Dubbaguda lake",
          "Dubbaguda lake 2",
          "Gangannapet Cheruvu",
          "Gollaghat Wetland",
          "Gollapur Reservoir",
          "Gopal Cheruvu (Utnur Wetland)",
          "Ichoda lake",
          "Jamdapur Lake",
          "Jhari lake",
          "Kandli lake",
          "Kantegaon Reservoir",
          "Kapparla Large lake",
          "Kapparla Small lake",
          "Kottur Reservoir",
          "Kowtha Buzurg lake",
          "Lachampur lake",
          "Malkapur Reservoir",
          "Mallapur(D) lake",
          "Marlapalle Wetland",
          "Mavala Park",
          "Nandigaon Lake",
          "Pallebuzurg lake 1",
          "Palodi Lake",
          "Pipri Wetlands complex",
          "Pochampally Lake",
          "Purushothampur lake",
          "Rampur Reservoir",
          "Ruyyadi lake",
          "Sawargaon Wetland",
          "Seetagondi Reservoir",
          "Sirichalma lake 1",
          "Sirichalma lake 2",
          "Sunkidi Reservoir",
          "Talamadugu New Tank",
          "Tamsi Palodi lake",
          "Tandra lake",
          "Waddadi Cheruvu (Tamsi)",
          "Wadgalpur Buzurg wetland",
          "Waghapur Lake 1",
          "Waghapur Lake 2",
          "Yamaikunta lake",
          "Yenka Wetland",
        ],
      },
      {
        district: "Bhadradri Kothagudem",
        localities: [
          "Bandirevu, Bhadrachalam",
          "Chintiryal Cheruvu",
          "HWPM Colony",
          "Kavadigundla Forest Range, Telangana",
          "Kinnerasani Dam",
          "Manuguru",
        ],
      },
      {
        district: "Hyderabad",
        localities: [
          "A.V. College of Arts, Science and Commerce",
          "Andhra Pradesh Horticulture Department",
          "Aryan Arts Academy",
          "Birla Mandir",
          "Bowrampet",
          "Chacha Nehru Park",
          "East Maredpally Park",
          "English and Foreign Languages University",
          "Golconda Fort",
          "Hakimpet Kunta",
          "Home - Trident Apartments, behind Brand Factory, Attapur",
          "Hussain Sagar, Hyderabad",
          "Indira Park",
          "Jubilee Hills, Hyderabad",
          "Kasu Brahmananda Reddy NP, Hyderabad",
          "Kasu Brahmananda Reddy NP--Chiran Lake",
          "Kinnera Hostel (Backside Trail)",
          "Krishna Kanth Park, Hyderabad",
          "Lotus Pond",
          "Malakpet, Hyderabad",
          "Masab Tank (OBI)",
          "Naya Quila",
          "Nehru Zoological Park",
          "Osmania University",
          "Osmania University -- English and Foreign Languages",
          "Qutb Shahi Tombs",
          "Sanjeevaiah Park",
          "St.Ann's College For Women",
          "State Bank Staff College",
          "Takshasila public school",
          "The Hyderabad Public School, Begumpet",
          "domalguda",
        ],
      },
      {
        district: "Jangaon",
        localities: [
          "Chagal Cheruvu",
          "Ghanpur Cheruvu",
          "Jangaon Cheruvu",
        ],
      },
      {
        district: "Jayashankar",
        localities: [
          "Kaleshwaram -- Godavari Ghat",
          "Kaleshwaram Project -- East Canal",
        ],
      },
      {
        district: "Jogulamba Gadwal",
        localities: [
          "Anantapuram to Basapur(fields)",
          "Basapur Krishna River Bed",
          "Beechupalli Krishna Pushkar Ghat",
          "Bhimpuram Fields & River bed(ONE)",
          "Bijwaram Lake",
          "Guntipally Fields (ONE)",
          "Guntipally Krishna River Bed",
          "Handloom Park(ONE), Gadwal",
          "Jammichedu Fields(ONE)",
          "Jogulamba Temple",
          "Jurala Project - Right Canal Side",
          "Jurala Pushkar Ghat (South)",
          "Pedda Chintarevula (Pushkar Ghat)",
          "Pedda Chintharevula Fields & River Bed",
          "Pedda Chintharevula to Bhimpuram (Fields & Scrubplots)",
          "Rekulapally Dam",
        ],
      },
      {
        district: "Kamareddy",
        localities: [
          "BIBIPET BACK WATER",
          "Chukkapoor Forest",
          "Machareddy Wetlands",
          "Mysamma Temple, Gidda Sirnapally",
          "Nizamsagar Lake",
        ],
      },
      {
        district: "Karimnagar",
        localities: [
          "Lower Manair Reservoir",
          "Manair Backwaters",
          "Manair River",
          "Manair River- Kazipur",
        ],
      },
      {
        district: "Khammam",
        localities: [
          "Bendalapadu",
          "Government Degree College for Women, Khammam",
          "Nagarjun Sagar Canal split Lal Bahadur Canal",
          "lakaram lake",
        ],
      },
      {
        district: "Kumuram Bheem Asifabad",
        localities: [
          "Ada Urban Park,  Komaram Bheem Reservoir",
          "Bejjur Reserved Forest",
          "Gundala Waterfalls",
          "Gundepalle, Penchikalpet",
          "NTR Sagar",
          "Sarsala cheruvu, Penchikakpet",
        ],
      },
      {
        district: "Mahabubabad",
        localities: [
          "Bheemuni Paadam Waterfalls--Gudur FR (Mahabubabad)",
          "Bheemunipadam Lake -- Gudur FR(Mahabubabad)",
          "Bheemunipadam lake",
          "Bhupathipet Ralla Cheruvu",
          "Botla Chelima Route -- Pandem FR (Mahabubabad)",
          "Damera Cheruvu",
          "Gangaram Forest Office",
          "Green Hills Camping Site (Madaguda) -- Pandem FR (Mahabubabad)",
          "Mamidi Thogu -- Gangaram FR (Mahabubabad)",
          "Pandem Forest Range",
          "Puli Madugu -- Gudur FR(Mahabubabad)",
          "Rampur Watch Tower -- Kothaguda FR(Mahabubabad)",
          "Road to Bheemuni Paadam Waterfalls",
        ],
      },
      {
        district: "Mahabubnagar",
        localities: [
          "Appanapally Lake-Pochanikunta Avva Temple",
          "Devarakadra Cheruvu",
          "Koilsagar Reservoir",
          "Pedda Cheruvu Jadcherla",
        ],
      },
      {
        district: "Mancherial",
        localities: [
          "Buggaguda Lake",
          "Godavari Bridge Indaram, Ramagundam",
          "Godavari bank, Mancherial",
          "Gollavagu Project, Chennur",
          "Jogapur Reservoir",
          "KWLS - Kadem Left Canal Road",
          "KWLS -- Barthanpet Kunta",
          "KWLS -- Bison Kunta",
          "KWLS -- Dongapalle",
          "KWLS -- Forest Guest House",
          "KWLS -- Ganasheti Kunta",
          "KWLS -- Maisamma Kunta",
          "KWLS -- Malliyal Beat Range",
          "KWLS -- Mancha Kunta",
          "Kaleshwaram Project -- West Canal",
          "Kawal Tiger Reserve",
          "Raligadhpur Cheruvu",
          "Shivaram Crocodile Wildlife Sanctuary",
          "Vanavihar Urban Park, Chennur",
          "Varipeta Lake",
          "Venkatraopeth Lake",
        ],
      },
      {
        district: "Medak",
        localities: [
          "Chilipched",
          "Chitkul",
          "Dantepally Cheruvu (OBI)",
          "Dharmarajapally Lake",
          "Haldi Reservoir",
          "Kagazmaddur",
          "Medak Fort",
          "Narasapur Lake",
          "Narsapur",
          "Narsapur Forest Urban Park",
          "Narsapur Park",
          "Narsapur Reserve Forest",
          "Pocharam Reservoir",
          "Pocharam Wildlife Sanctuary",
          "Toopran Lake",
          "Yellamma Temple",
        ],
      },
      {
        district: "Medchal Malkajgiri",
        localities: [
          "ALWAL LAKE ( BATHUKAMMA CHERUVU)",
          "ANNARAYAN CHERUVU",
          "APJ Abdul Kalam Park",
          "Alankrita Resort, Hyderabad",
          "Ambar Cheruvu, Hyderabad",
          "Ammuguda Hills",
          "Anthaipally Lake",
          "Arundhati Nagar Lake",
          "BITS Pilani Hyderabad Campus",
          "Babuguda Lake",
          "Bhagyanagar Nandanavanam Deer Park",
          "Bommarasipet Lake",
          "Bon Cheruvu",
          "CRPF Camp ( Restricted Acess), Rangareddy",
          "Dammaiguda lake",
          "Devarayamjal Lake",
          "Dulapally",
          "Edulabad Lake",
          "Fox Sagar Lake",
          "Geological Survey of India",
          "HMT Urban Forest , Hyderabad",
          "Hakimpet Lake",
          "Hawking Pond",
          "IDPL Township, Balanagar",
          "Infosys Campus SEZ",
          "Kandlakoya Oxygen Park",
          "Kapra Lake",
          "Kowkoor Cheruvu",
          "Lake Near Forest Ridge",
          "MCRHRDI, Telangana",
          "Mandabad, Hyderabad",
          "NALSAR University of Law",
          "NISA/CISF",
          "Nizam Talab, Nizampet",
          "Nizampet road-Hill county road waterbody",
          "Oxyzone Urban Park, Dulapally, Medchal",
          "Pedda Cheruvu, Nacharam Hyderabad",
          "R K Puram Cheruvu, Secunderabad",
          "Ranganayaka IDL Lake, KPHB",
          "SA Palm Meadows",
          "Safilguda lake park",
          "Shamirpet Lake -- Backwaters",
          "Shamirpet Lake, Hyderabad",
          "T.S.Forest Academy",
          "Thumkunta Lake",
          "Thumukunta Lake ( near CRPF campus)",
          "Uddamarri Venkateshwara Swami Temple",
          "Uppal Muchikunda River",
          "Upparpally Lake",
          "Veduru Vanam",
          "Venellagada Cheruvu",
          "Yadgarpally lake",
          "Yapral Lake",
          "cherlapally lake",
          "yellampet reserve forest",
        ],
      },
      {
        district: "Mulugu",
        localities: [
          "Bogatha waterfalls",
          "Laknavaram",
          "Palem project",
          "Ramappa Lake",
          "Sri Hemachala Laxmi Narsimha Swamy Devalayam",
          "Tadvai Forest Camp",
        ],
      },
      {
        district: "Nagarkurnool",
        localities: [
          "Amrabad Tiger Reserve",
          "Dindi Reservoir",
          "Mallela Theertham",
          "Munnanur Check Post",
          "Octopus Viewpoint",
          "Prathapa Rudruni Kota",
          "Rasool Cheruvu",
          "Saleshwaram, Srisailam Highway",
          "Uma Maheswaram",
        ],
      },
      {
        district: "Nalgonda",
        localities: [
          "Akkampally Balancing Reservior",
          "Dasarigudem",
          "Devaracharla temple",
          "Musi Dam Backwaters",
          "Parvathala Cheruvu",
          "Pendlipakula Reservior, Ghaji Nagar",
          "Thatikol Cheruvu",
          "Vizag Colony Boating Center, Nalgonda",
        ],
      },
      {
        district: "Nirmal",
        localities: [
          "Aakonda lake, Kadam",
          "Bellal Cheruvu",
          "Chinna Bellal Godavari Ghat",
          "KWLS - Kalpakunta",
          "Kaddam Project Dam, Pandwapur, Telangana",
          "Kolamguda - Kaddam backwaters",
          "Medipally lake",
          "Mootapur Cheruvu, Nirmal, TS",
          "Turkam Cheruvu",
          "Venganna Cheruvu",
        ],
      },
      {
        district: "Nizamabad",
        localities: [
          "Chintala Cheruvu - Sirnapally",
          "Darmaram Cheruvu",
          "Kanteshwar, Nizamabad",
          "Keshapur Lake",
          "Mamidipalle, Nizamabad",
          "Manchippa forest/hills",
          "Pedda Cheruvu, Rudrur",
          "Rampur Thanda - Sirnapally",
          "SSR School, Jannepally, Telangana",
          "Sirnapally Waterfalls",
          "Sriramasagar Reservoir",
        ],
      },
      {
        district: "Peddapalli",
        localities: [
          "Garrepalli Cheruvu",
          "Sri Gowthameeshwara Temple, Manthani",
          "Sultanabad Cheruvu, Peddapalli",
          "Yellampally Project",
        ],
      },
      {
        district: "Rajanna Sircilla",
        localities: [
          "Mid Manair Reservoir",
          "Pottur Bridge - Manair Dam",
          "Upper Manair Resrvoir",
        ],
      },
      {
        district: "Ranga Reddy",
        localities: [
          "AIG Hospitals, Gachibowli",
          "ANGRAU (Acharya N G Ranga Agricultural University), Hyderabad",
          "Aga Khan Academy Hyderabad",
          "Agribiodiversity park, Hyderabad, Telangana, IN (17.318, 78.418)",
          "Arogya Sanjeevani Vanam, Hyderabad",
          "BNR Hills",
          "BT Cell 01",
          "BT Cell 02",
          "BT Cell 03",
          "BT Cell 04",
          "BT Cell 05",
          "BT Cell 06",
          "BT Cell 07",
          "BT Cell 08",
          "BT Cell 09",
          "BT Cell 10",
          "BT Cell 11",
          "BT Cell 12",
          "BT Cell 13",
          "BT Cell 14",
          "BT Cell 15",
          "BT Cell 16",
          "BT Cell 17",
          "BT Cell 18",
          "BT Cell 19",
          "BT Cell 20",
          "BT Cell 21",
          "Beforest Hyderabad Collective",
          "Bhadam farms",
          "Bhupatiraju Meadows",
          "Biodiversity Park, Hyderabad",
          "Boulder Hills",
          "CHIREC ISRP Campus",
          "CHIREC International School,Kondapur",
          "Chandana Cheruvu",
          "Chikur birding spot",
          "Chinnaravirala Musi bridge",
          "Dargah Hzt Syed Mir Hayat",
          "Durgam Cheruvu",
          "Durgam Cheruvu--Secret Lake Park",
          "Durgam Cheruvu--Southern side",
          "Ficus Garden",
          "Forest Trek Park",
          "Gachibowli Stadium",
          "Gandipet Landscape Park",
          "Gangaram Cheruvu",
          "Gautami Enclave Park",
          "Gopanpally Lake",
          "Gopi Cheruvu",
          "Gurukulam Ground - Gungurthy",
          "Heartyculture Nursery",
          "Himayat Sagar Lake",
          "Himayat Sagar Lake--Kothwalguda Eco Park",
          "Himayatsagar",
          "Hyderabad Airport",
          "Hyundai Motor India Engineering Pvt. Ltd",
          "IIL Quarters",
          "Ibrahim Cheruvu",
          "Ibrahimpatnam Lake",
          "Indian Institute of Rice Research",
          "Indian School of Business",
          "Injapur Lake",
          "Janwada Grasslands - Venugopal Temple Road",
          "Kanha Shanti Vanam",
          "Keshampet",
          "Khajaguda Hills",
          "Khajaguda Lake",
          "Khajaguda Talab - Gachibowli",
          "Kokapet Lake",
          "Kondapur Botanical Garden",
          "Kuntloor Cheruvu",
          "Kyra Wellness Resort, Sanghi",
          "Laboratory for the Conservation of Endangered Species (LaCONES)",
          "Lake Kamuni Shamshabad",
          "MANUU (Urdu University), Hyderabad",
          "Madinaguda Lake",
          "Mahavir Harina Vanasthali NP",
          "Malaka Cheruvu, Hyderabad",
          "Mantrala CHeruvu",
          "Masjidgadda Jungle Camp",
          "Meedikunta Lake",
          "Mir Alam Tank",
          "Miyapur Lake",
          "Mrugavani National Park",
          "Mundikunta Lake",
          "Mushkin Cheruvu",
          "Musi River Bridge near Narsingi ORR Exit",
          "Nagole-Tattiannaram Rd",
          "Nallagandla Lake",
          "Narasingi Nalla Cheruvu Lake",
          "Neknampur Lake Park",
          "Oakridge Pond",
          "Osman Sagar Lake",
          "Osman Sagar Lake -- Khanapur Side",
          "Osman Sagar Lake -- Venugopal Temple Side",
          "Pahadi Shareef (OBI)",
          "Pala Pitta Cycling Park",
          "Panchavati Park, Hyderabad",
          "Pasumamula Lake",
          "Peacock Lake, University of Hyderabad",
          "Peerancheruvu",
          "Ragannaguda  Lake, Nadergul",
          "Rain forest (Man-made), Kanha Shanti Vanam",
          "Rajendranagar",
          "Ramoji Film City",
          "Ramoji Film City-Indira Sagar",
          "SR Lake University of Hyderabad Campus",
          "SVP National Police Academy",
          "Sanjeevani Vanam, Hyderabad",
          "TIFR Hyderabad Campus",
          "Talakunta GHMC Park",
          "Thattikunta Maisamma temple",
          "Timberlake Shore - Itikini Cheruvu - Manchirevula -",
          "Timmidkunta (Gadwall) Lake",
          "US Consulate General, Hyderabad",
          "Umda Sagar Lake",
          "University of Hyderabad",
          "Vanasthali Hills",
          "Wipro Gopanpally Campus",
          "Woods @ Shamshabad - Miyawaki Forest",
          "Yerra kunta",
        ],
      },
      {
        district: "Sangareddy",
        localities: [
          "Ameenpur Lake -- Kingfisher Pond",
          "Ameenpur Lake, Hyderabad",
          "Anantha Padmanabha Swamy Temple -- Manjeera",
          "Anna Sagar Lake",
          "Aranya Permaculture Farm",
          "BHEL--Township@Hyderabad",
          "Chunambatti Thanda Forest Patch, Zaheerabad",
          "ICRISAT Campus",
          "ICRISAT Campus -- Mary P. Cummings Lake",
          "ICRISAT Campus -- Pelican Lake",
          "ICRISAT Campus -- Siri Sehgal Lake",
          "ICRISAT Campus -- Sunset Lake",
          "IIT Hyderabad",
          "Isnapur Cheruvu",
          "Jinnaram Medak Range",
          "Jogipet Lake",
          "Karkashpeerla lake , Sarjaraop",
          "Kistareddypet Lake",
          "Kodakanchi Lake",
          "Kusangi Lake",
          "Lakdaram Pedda Chervu",
          "Mallepally Lake",
          "Manjeera -- Backwaters Water Tank",
          "Manjeera -- Cheruvu Katta Road",
          "Manjeera -- Irgipally Route",
          "Manjeera -- Tallapally Lake",
          "Manjeera Wildlife Sanctuary",
          "Mogudampally Grasslands",
          "Mokila",
          "Mokila - Makhta Kunta Lake",
          "Nagulapallil lake near kollur",
          "Narsapur -- Medalamma Temple",
          "Patancheru Lake",
          "Pocharam Village - Near temple ( Chitkul road)",
          "RC Puram Colony Lake",
          "Rudraram Cheruvu",
          "Rudrarum Lake -- GITAM Hostel Side",
          "Singur  Reservoir - Raipally",
          "Singur Dam Reservoir, Medak",
          "Tellapur Lake",
          "Vaishnavi Mata Temple",
          "Woods @ Indresham",
          "Woxsen University",
          "ilapur cheruvu",
        ],
      },
      {
        district: "Siddipet",
        localities: [
          "Dharmaram Forest",
          "Forest College and Research Institute (FCRI)",
          "Government Degree College siddipet",
          "Ibrahimpur Cheruvu",
          "Konda Pochamma Reservoir",
          "Regulapalli Cheruvu",
          "Shanigaram Cheruvu",
          "Sherpally Village, Arbor Road Estate",
          "Vantimamidi Lakes",
          "Zapthi Nacharam Cheruvu",
          "gajwel",
        ],
      },
      {
        district: "Suryapet",
        localities: [
          "Bethavolu Cheruvu",
          "Kokiya Nayak Thanda Cheruvu",
          "Mamidala Cheruvu",
          "Musi Reservoir",
          "Pillalamarri Lake",
          "Sirikonda Pedda Cheruvu (సిరికొండ పెద్ద చెరువు),Sirikonda, Telangana",
          "Tirumalagiri Cheruvu, Mamidipalli",
          "Velishala Cheruvu, Malipuram",
        ],
      },
      {
        district: "Vikarabad",
        localities: [
          "Ananthagiri Hills, Vikarabad",
          "BT Cell 22",
          "BT Cell 23",
          "BT Cell 24",
          "BT Cell 25",
          "Bantwaram-Vikarabad",
          "Damagundam -- Grassland",
          "Damagundam -- Reserve Forest",
          "Kotepally Lake",
          "Laknapur Lake",
          "Laknapur Project",
          "Mittakondur Tank",
          "Mominpet Lake",
          "Parameshwara Hill Temple, Vikarabad",
          "Ramnathgudepalle Grassland",
          "Sarpanpally Lake",
          "Somaram Lake",
          "Sri Sai College of Dental Surgery & Hospital",
          "Yenkathala Grassland",
          "Yenkathala Grasslands -- Pedda Cheruvu",
        ],
      },
      {
        district: "Wanaparthy",
        localities: [
          "Atmakur Lake",
          "Gadwal Raja's Fort",
          "Jurala Reservoir",
          "Rajanagaram Lake 2",
          "Rajanagaram grassland",
          "Thirumalayya Gutta",
        ],
      },
      {
        district: "Warangal Rural",
        localities: [
          "Budharaopet Cheruvu",
          "Pakhal Lake",
          "Pakhala Ashoknagar",
          "Sannor SRHP Canal",
        ],
      },
      {
        district: "Warangal Urban",
        localities: [
          "Ammavaripeta Cheruvu",
          "Bhadrakali lake",
          "Dharmasagar Lake",
          "Kakatiya University",
          "Kazipet Railway Station wetland",
          "Keshavpur Lake",
          "Madikonda Lake, Warangal District",
          "National Institute of Technology (NIT) Warangal",
          "Pembarthy Cheruvu",
          "SR University",
          "Sri Bhadrakali Devastanam",
          "Vem Cheruvu",
          "Waddepally Lake",
        ],
      },
      {
        district: "Yadadri Bhuvanagiri",
        localities: [
          "Centre for Cellular and Molecular Biology (CCMB)--New Campus site",
          "Inkriyal Lake",
          "Kolanupaka Lake , Telangana, IN",
          "Pochampally",
          "Rachakonda Fort",
          "Rachakonda Fort Boundary",
          "Rayarao Peta Lake",
          "Vasaalamarri - Farm",
          "Vasaalamarri Grassland/ONE",
        ],
      },
    ],
  },
  {
    state: "Tripura",
    districts: [
      {
        district: "Dhalai",
        localities: [
          "Gumti WLS--Dumboor Lake (Gandachara)",
          "Jagabandhupara, Gandacherra",
          "Manu Railway Station",
        ],
      },
      {
        district: "Gomati",
        localities: [
          "Banduar 132 KV Sub-Station",
          "Banduar Brick Industry & Surrounds",
          "Chabimura Caves",
          "Deb Bari Reserve Forest",
          "Debatamura Reserve Forest",
          "Gomati River--Nograi Fields",
          "Gumti WLS",
          "Hurijala, Kakraban",
          "Kalyan Sagar, Matabari",
          "Nethaji Subhash Mahavidyalaya",
          "Sukhsagar Wetlands",
          "Tepania Eco Park",
        ],
      },
      {
        district: "Khowai",
        localities: [
          "Baramura Eco Park",
          "Baramura Hills (general area)",
          "Baramura Hills--Baramura Waterfall",
          "Gumti WLS--Nunachhara RF",
          "Khowai River--Kalyanpur Fields",
          "Khowai River--Moharchhara Zone",
          "Teliamura Railway Station",
        ],
      },
      {
        district: "North Tripura",
        localities: [
          "Churaibari Railway Station",
          "Dharmanagar Railway Station",
          "Govt Degree College, Dharmanagar",
          "Jampui Hills--Eden Tourist Lodge",
          "Jampui Hills--Phuldungsei",
          "Jampui Hills--Vanghmun",
          "Jampui Hills--Vanghmun Eco Park",
          "Jampui Hills--Vanghmun--F&G Sailo Birding Site",
          "Panisagar Railway Station",
          "Rowa WLS",
          "Unakoti Eco Park",
        ],
      },
      {
        district: "Sepahijala",
        localities: [
          "Boxanagar",
          "Chandi Park",
          "Dakshin Charilam",
          "Hurijala, Melaghar (OBI)",
          "Krishna Kishore Nagar Wetlands",
          "Melaghar (OBI)",
          "Melaghar, Tripura, IN (23.48, 91.32)",
          "Rudrasagar Lake",
          "Rudrasagar Lake--Neermahal",
          "Sepahijala WLS",
          "Sepahijala WLS -2",
          "Sepahijala WLS--Clouded Leopard NP",
          "Sepahijala WLS--Sepahijala Zoological Park",
        ],
      },
      {
        district: "South Tripura",
        localities: [
          "Trishna WLS (general area)",
          "Trishna WLS--Butterfly Park",
          "Trishna WLS--Eden of Bison",
          "Trishna WLS--Joychandrapur Ecotourism Zone",
        ],
      },
      {
        district: "Unakoti",
        localities: [
          "Ambedkar College, Fatikroy",
          "Kumarghat Railway Station",
          "Village in North Tripura (OBI)",
        ],
      },
      {
        district: "West Tripura",
        localities: [
          "132 KV Grid Sub-Station Residential Quarters",
          "Baramura Hills--Champabari",
          "Baramura Hills--Sitacherra Lake",
          "Baramura Hills--Subalsingh Forest",
          "Bhavan's Tripura Vidya Mandir",
          "Charulata Boutique Guest House",
          "Circuit House Agartala",
          "College of Agriculture, Lembucherra",
          "Heritage Park",
          "Holy Cross School and College",
          "IC Nagar--Ishanchandranagar Paddyfields",
          "IC Nagar--Pandabpur Eastern Woodlands",
          "IC Nagar--Pandabpur Paddyfields",
          "ICAR Research Complex",
          "Jamtala Paddyfields",
          "Jora Pukur Road",
          "Khejurbagan (OBI)",
          "Koko Tilla",
          "Kunjaban (OBI)",
          "Lembucherra (OBI)",
          "MBB College",
          "MBB College Lake",
          "Maharaja Bir Bikram Airport",
          "NIT Agartala",
          "Nischintapur Railway Station",
          "Oxygen Park",
          "Shani Mandir, Ram Nagar",
          "Tripura University",
          "Women's College, Agartala",
        ],
      },
    ],
  },
  {
    state: "Uttar Pradesh",
    districts: [
      {
        district: "Agra",
        localities: [
          "Agra Fort",
          "Agra Toll Plaza -- Farmlands",
          "Bateshwar Maharaj Temple",
          "Central jail",
          "Chambal Safari Lodge",
          "Chambal Wildlife Safari Lodge -- Mela Camp",
          "Colonel's Brightland Public School",
          "Fatehpur Sikri",
          "Hastinapur Wildlife Sanctuary",
          "Hotel Clarks Shiraz -- Gardens",
          "Jarar Village (OBI)",
          "Jaypee Palace Hotel, Agra",
          "KD Paliwal Park",
          "Mall Road, Agra IN-UP 27.16183, 78.02514",
          "Mehtab Bagh",
          "Mughal Hotel & Grounds",
          "National Chambal Sanctuary -- Chambal Ravines at Pinahat",
          "National Chambal Sanctuary -- Jaitpur",
          "National Chambal Sanctuary -- Nadgawan",
          "Poiya Ghat",
          "Rambagh Park",
          "Soor Sarovar Bird Sanctuary (Keetham Lake)",
          "St John’s college , Agra IN-UP",
          "Taj Mahal",
          "Taj Nature Walk",
          "Tomb of Akbar the Great, Agra",
          "Tomb of I'timād-ud-Daulah (Little Taj)",
          "Yamuna Expressway, Toll Plaza -- Farmlands",
          "Yamuna River Swara",
          "Yamuna River near Taj",
        ],
      },
      {
        district: "Aligarh",
        localities: [
          "Aligarh Fort",
          "Aligarh Muslim University (AMU)--General Area",
          "Aligarh Muslim University -- Abdullah Hall",
          "D.S. College Aligarh",
          "Fly Ash Storage Ground of Kasimpur Powerhouse",
          "Jawahar Park (Naqvi Park)",
          "Sheikha Jheel (IBA IN-UP-21)",
          "Shekha Bird Sanctuary",
        ],
      },
      {
        district: "Ambedkar Nagar",
        localities: [
          "Hawai Patti DM Office",
          "Upper Primary School Sarawan, Ramnagar",
        ],
      },
      {
        district: "Amethi",
        localities: [
          "Samaspur Bird Sanctuary -- Mamuni",
        ],
      },
      {
        district: "Amroha",
        localities: [
          "Amroha Railway Station",
          "Brajghat on Ganga -- East Bank",
          "Moradabad Bypass Road at Mohra",
        ],
      },
      {
        district: "Auraiya",
        localities: [
          "Phaphund Railway Station",
          "Yamuna Ghat--Auraiya",
        ],
      },
      {
        district: "Ayodhya",
        localities: [
          "Ayodhya Tent City",
          "Company Garden Park, Faizabad Cantt",
          "Faizabad Cantonment (Restricted Area) -- General Area",
          "Faizabad Cantonment -- Manjh Range",
          "Fatehpur Saraya Manjh",
          "Guptar Ghat",
          "Kaushalya Ghat and Manjha",
          "Majnai",
          "Manjha Kala on Ghaggra/Saryu River at Ayodha",
          "Manjha Range faizabad",
          "Mau Shivala Bazar wetland",
          "Ram Janki Mandir Demua Ghat",
          "Ramayana Theme Park -- General Area",
          "Ramayana Theme Park -- अमरूतहिया (Gauva Plantations)",
          "Samda Jheel (Panditpur Lake) Bird Sanctuary",
          "Saryu Majha, Naya Ghat, Ayodhya",
          "Saryu National Highway Bridge",
          "Sharda Canal, Samda -- Gohaniya",
        ],
      },
      {
        district: "Azamgarh",
        localities: [
          "Baba Baraila Tal",
          "Durvasha Dham",
          "Salona Tal",
          "Semari Kotia",
          "Yaduvanshi Bag Ambari",
        ],
      },
      {
        district: "Baghpat",
        localities: [
          "Yamuna Bridge oneastern peripheral express way",
        ],
      },
      {
        district: "Bahraich",
        localities: [
          "Chahlarighat -- Sisaiya churaman",
          "Crop Research Station, Ghaghraghat",
          "Ghagra Ghat -- Tappe Sipah on Bahraich side",
          "Golavaghat near Mari Mata Temple on Saryu river",
          "Katarniaghat Girwa Riverside",
          "Katerniaghat WLS -- General Area",
          "Katerniaghat WLS -- Katerniaghat FRH",
          "Katerniaghat Wildlife Sanctuary",
        ],
      },
      {
        district: "Ballia",
        localities: [
          "Beyasi Ballia Bridge",
          "Chandrashekhar Udyan",
          "Suraha Tal Ballia (IBA IN-UP-25)",
          "Van Vihar ( Surhatal)",
        ],
      },
      {
        district: "Balrampur",
        localities: [
          "Parvati Aranga (Arga) WLS -- General Area",
          "Suheldev Wildlife Sanctuary, Balrampur (OBI)",
          "Suhelwa (Suheldev) WLS -- Bhagwanpur Reservoir",
          "Suhelwa (Suheldev) WLS -- Chittaurgarh Reservoir",
          "Suhelwa (Suheldev) WLS -- Girgitahi Reservoir",
          "Suhelwa (Suheldev) WLS -- Janakpur FRH",
          "Suhelwa (Suheldev) WLS -- Jarwah FRH",
          "Suhelwa (Suheldev) WLS -- Khairman Reservoir",
          "Suhelwa (Suheldev) WLS -- Nandmahra FRH",
          "Suhelwa (Suheldev) WLS -- Pipra FRH (Hathiakunda Trail)",
          "Tapovan Farm Homestay",
        ],
      },
      {
        district: "Banda",
        localities: [
          "Banda University of Agriculture and Technology",
          "Chilla Ghat",
        ],
      },
      {
        district: "Barabanki",
        localities: [
          "Akauna -- Ghaggra River Banks",
          "Akauna -- Village Areas",
          "Behta Jungle",
          "Chaksar Wetland, Gangaganj",
          "Chowkaghat Area -- Bhavania Nulla",
          "Chowkaghat Area -- Lohati  Pasai Road",
          "Chowkaghat Area-- Bridge 393, near Chowkaghat Railway Stn. Barabanki",
          "Dewa Shareef Lake",
          "Ghaggra Ghat -- Tapasipah on Barabanki side",
          "Ghagra Ghat -- Durgarpur on Barabanki side",
          "Harakka Market",
          "Ibrahimpur Farm Fields",
          "Integral University Phase-III",
          "Khanwaha",
          "Kintoor on the Ghaghara River",
          "Kirkichi Jheel",
          "Murtazanagar Farm Fields",
          "Salarpur Wetland, Dewa Road",
          "Sursanda Link Road",
        ],
      },
      {
        district: "Bareilly",
        localities: [
          "Badrai Kuiyan, Bareily (OBI)",
          "Baheri (OBI)",
          "Bareilly Cantonment (OBI)",
          "Delapeer Pond",
          "Delapeer--Narayan Awas (OBI)",
          "Dohra Road Bareilly",
          "Fatehganj (OBI)",
          "Gandhi Udyan Bareilly",
          "Golf Course Bareilly Cantt",
          "Hajrat pur, aonla, bareilly",
          "ICAR Indian Veterinary Research Institute",
          "IVRI Farms, Bareilly (OBI)",
          "IVRI Izzatnagar",
          "Indian Veterinary Research Institute Bareilly",
          "Invertis University",
          "Kalapur, Pilibhit Bypass Road",
          "Kargaina (OBI)",
          "Kumra Village (OBI)",
          "Lal Fatak, Bareilly",
          "Mahanagar Silverstate area,Bhoor (Bareilly)",
          "Mundia Ahmed Nagar (OBI)",
          "Narayan Awas, Bareilly (OBI)",
          "Nawabganj (OBI)",
          "Nawgawan Jagir Village (OBI)",
          "Railway Bridge, Opposite to Akashvani, Bareilly",
          "Ramganga Dam -- Badaun Road",
          "Rohilkhand Medical College Campus and Outskirts",
          "Sainthal Urban and Farmland",
          "Saqlain Miyan Academy Bareilly",
          "Senthal Cemetry -- Forested Patch & Farmlands",
          "St Stephens Church Bareilly",
          "St. Xavier's College Campus",
          "St. Xavier's Primary School",
          "Tigra Village (OBI)",
          "Tigra Village and Fields",
          "Tilolia Village, Bareilly (OBI)",
          "Unchagaon (OBI)",
          "mahanagar colony",
        ],
      },
      {
        district: "Basti",
        localities: [
          "Mahso Khas",
          "Makhauda Dham",
        ],
      },
      {
        district: "Bhadohi",
        localities: [
          "Sitamarhi Ganga Banks",
        ],
      },
      {
        district: "Bijnor",
        localities: [
          "Balawali",
          "Bangla Village",
          "Bhaguwala -- Kashirampur on Bijnor-Haridwar bypass",
          "Ganga Barrage Bijnor",
          "Ganga Pushta Road, Ranjeetpur",
          "Gulalwali on Eastern Ganga Canal Road",
          "Haiderpur Wetlands -- Bijnor Zone",
          "Haiderpur Wetlands and Bijnor Barrage -- General Area",
          "Haiderpur wetland",
          "Harewali wetlands",
          "Jhandichaur",
          "Maluaa",
          "Najibabad",
          "Peeli Dam",
          "River Ganga, Bijnor (OBI)",
          "Rokhata Bijnor",
          "Thanda Rampur Chatha",
        ],
      },
      {
        district: "Budaun",
        localities: [
          "Badaun (OBI)",
          "Kachla (OBI)",
          "Padauliya -- Pond & Farmlands",
          "Social Forestry Division Budaun",
        ],
      },
      {
        district: "Bulandshahr",
        localities: [
          "Baragaon",
          "Ganga river (Ganges) at Narora Khader",
          "Niwari Khader",
        ],
      },
      {
        district: "Chandauli",
        localities: [
          "Chandraprabha WLS",
          "Chandraprabha WLS--Devdari Waterfall",
          "Pandit Deendayal Upadhyay (prev Mughal Sarai) Railway Junction",
          "River Karamnasa Birding Point",
        ],
      },
      {
        district: "Chitrakoot",
        localities: [
          "Gunta Dam, Raipura, Chitrakoot",
          "Lakshman Parvat, Chitrakoot",
          "Ram Ghat",
        ],
      },
      {
        district: "Deoria",
        localities: [
          "Bahora Dalpatpur",
          "Deoria Industrial Area",
          "Deoria Sadar Railway Station",
          "Dugdheswarnath Temple -- Forested Patch & Farmlands",
          "Gorra Oxbow Lake",
          "Rampurva Devi Temple",
        ],
      },
      {
        district: "Etah",
        localities: [
          "Patna Pakshi Vihar (Pundhir Bird sanctuary)  Etah",
        ],
      },
      {
        district: "Etawah",
        localities: [
          "Chambal River Sanctuary Etawah",
          "Chambal boating point",
          "Lion Safari Parks",
          "NCS--Bansari",
          "NCS--Barcholi",
          "NCS--Barecha",
          "NCS--Bhareh (Chambal Yamuna Sangam)",
          "NCS--Chhibroli",
          "NCS--Patharra",
          "NCS--Piproli Gadhiya",
          "NCS--Sahson",
          "NCS--Yamuna River--Pachnada",
          "National Chambal Sanctuary -- Bhareh Fort at Chambal Yamuna Confluence",
          "National Chambal Sancturay -- Yamuna River Simar",
          "Saifai village, Chambal, Uttar Pradesh",
          "Sarsai Nawar Jheel (Ramsar site)",
          "wetland south of Jaswantnagar (OBI)",
        ],
      },
      {
        district: "Farrukhabad",
        localities: [
          "Paliya Dudhwa National park",
        ],
      },
      {
        district: "Fatehpur",
        localities: [
          "Makrail Village (OBI)",
          "Om Ghat Bhitoura -- Ganga River & Floodplains",
        ],
      },
      {
        district: "Firozabad",
        localities: [
          "Anardevi Rajaram Inter College, Pratappur road,Shikohabad",
          "Firozabad Railway Station",
          "Hazratpur Wetlands (OBI)",
          "Old Aquaduct",
          "Sarus Crane Trail Nagla Chanda",
        ],
      },
      {
        district: "Gautam Buddha Nagar",
        localities: [
          "Alauda Jagir Village Pond",
          "Alawalpur pond (Beside Shiva Dhaba)",
          "Alpha 1 Park, Greater NOIDA",
          "Alpha 2 Park",
          "Amity University Campus, Noida",
          "Beel Akbarpur Wetland & Grassland",
          "Bhikanpur Wetlands (seasonal)",
          "Crowne Plaza, Greater NOIDA",
          "Dadri Wetland (Historical)",
          "Dankaur Village (OBI)",
          "Dhanauri Wetlands -- Dhanauri Kalan East",
          "Dhanauri Wetlands -- Dhankaur-Bhatta-Parsaul",
          "Dhanauri Wetlands -- Kherli Hafizpur (Dhanauri Kalan)",
          "Forest View Park, Sector 54, Noida",
          "Galgotias University",
          "Gaur Yamuna City, 16th Park view, Sector 19, Greater Noida",
          "Girdharpur Pond, Surajpur Kasna Rd",
          "Giridharpur (OBI)",
          "Greater Noida (OBI)",
          "HCL Campus Sector 126 NOIDA",
          "Harit Upvan sorkha",
          "Hasanpur Lake",
          "Jewar Canal -- Mukimpur Sivara",
          "Jhajhar lake (seasonal)",
          "LG Chowk Forest Greater Noida UP India",
          "Motipur, Yamuna Expressway",
          "NOIDA Biodiversity Park",
          "NOIDA, Gautam Budh Nagar (OBI)",
          "NTPC Dadri water bodies",
          "Nagli Bahrampur Noida UP/IN",
          "Nagli Bahrampur, Kidawali",
          "Nagli-Bahrampur Noida Yamuna Bank IN/Dl",
          "Noida International Airport Jewar",
          "Okhla Barrage",
          "Okhla Bird Sanctuary",
          "Okhla Bird Sanctuary (Tar Road)",
          "Okhla Bird Sanctuary Gate",
          "Okhla barrage Sand banks UP/IN",
          "Omaxe twin tower, Sector 50, Noida",
          "Radiant Academy, B Block, Sector 55, NOIDA",
          "Raipur Khadar, NOIDA (OBI)",
          "Sector 15A (OBI)- Noida",
          "Sector 23 Noida Uttar Pradesh",
          "Shiv Nadar School Noida",
          "Shiv Nadar University",
          "South East Noida -- Kulesara",
          "Step By Step School, Noida",
          "Surajpur Police line",
          "Surajpur Wetland & Natural Forest 2",
          "Surajpur Wetlands Bird Sanctuary",
          "Thasrana (OBI)",
          "Tusyana Village (OBI)",
          "Unitech Golf Course, Sector 97 NOIDA",
          "Ved Van Park",
          "Yeida City",
        ],
      },
      {
        district: "Ghaziabad",
        localities: [
          "City forest, Ghaziabad UP/IN",
          "Ghaziabad (OBI)",
          "Ghaziabad Railway Station",
          "Hindon Ghat on GT Road",
          "Hindon green area Ghaziabad",
          "Indira Priyadarshini Park",
          "Model Town Park, Ghaziabad",
          "Sewage treatment plant Indrapuram",
          "Sherpur fields (Niwari Rd), Modinagar",
          "Vasundhra Ashram",
          "Yamuna Floodplains Delhi  (Hiranki)  DL/IN",
        ],
      },
      {
        district: "Ghazipur",
        localities: [
          "Bara Mathiya Mandir",
          "Dildar Nagar Railway  Jn, Ghazipur, Uttar Pradesh",
        ],
      },
      {
        district: "Gonda",
        localities: [
          "Balha Rai Village, Agricultural Fields - Gonda",
          "Chandapur Oxbow Lake",
          "Parvati Aranga Bird Sanctuary -- General Area",
          "Tikri Reserve Forest -- Janki Nagar",
        ],
      },
      {
        district: "Gorakhpur",
        localities: [
          "Chilua Taal",
          "Deen Dayal Upadhyaya Gorakhpur University",
          "East bank of Rapti river, near north side of Rajghat Bridge",
          "Fertilizer Corporation of India -- Gardens & Forested Area",
          "Gorakhnath Temple",
          "Gorakhpur Rail Museum",
          "Gorakhpur Railway Station",
          "Kasso Taal, Baranagar",
          "Kushmi Jungle",
          "Madan Mohan Malaviya University of Technology, Gorakhpur",
          "Ramgarh Taal, Gorakhpur",
          "Sarus point Moharipur",
          "Shaheed Ashfaqullah Khan Prani Udyan (Gorakhpur Zoo)--General Area",
          "Shaheed Ashfaqullah Khan Prani Udyan (Gorakhpur Zoo)--Wetland Area",
          "Tarkulha Devi  Mata Mandir",
          "Vikas Nagar",
          "Vindhyavasini Park",
          "Vinod Van, Kasia - Gorakhpur Road, Jungle Ramgarh Urf Sarka,",
        ],
      },
      {
        district: "Hapur",
        localities: [
          "Ganga (Ganges) Snan Ghat, Garhmukteshwar",
        ],
      },
      {
        district: "Hardoi",
        localities: [
          "River Ramganga, Bareilly (OBI)",
          "Sandi Bird Sanctuary (OBI)",
          "Sandi Pakshi Vihar (Sandi Bird Sanctuary)",
        ],
      },
      {
        district: "Hathras",
        localities: [
          "Gopalpur sidhamai wetland",
          "Jaau-Bastoi Hathras",
          "Midhawali Wetland",
          "Nagla Kanch , Rati Ka Nagla Wetland",
        ],
      },
      {
        district: "Jalaun",
        localities: [
          "Kalpi Yamuna Bed",
        ],
      },
      {
        district: "Jaunpur",
        localities: [
          "Dandsawli Wetlands near Shahganj",
          "Gujra Tal, Khetasarai, Shahganj",
          "Manwa Tal",
          "Nawajgah Oyster pond, Jaunpur",
          "Sithuapara",
        ],
      },
      {
        district: "Jhansi",
        localities: [
          "Bharat Heavy Electricals Limited (BHEL), Jhansi",
          "Bharatpura on Betwa river bank",
          "Gadia Fatak, Khera",
          "Grassland Research Institute, Jhansi (OBI)",
          "ICAR-CAFRI, Jhansi",
          "Indian Grassland and Fodder Research Institute (IGFRI) Jhansi",
          "Jhansi (OBI)",
          "Jhansi Fort",
          "Pahuj Reservoir",
          "RLBCAU Fields -- Jhansi",
          "Sukma Dukma Dam",
        ],
      },
      {
        district: "Kannauj",
        localities: [
          "Lakh Bahosi Bird Sanctuary -- Bahosi Jheel",
          "Lakh Bahosi Bird Sanctuary -- Lakh Jheel",
          "Lakh Bahosi Bird Sanctuary — Jheel and surrounding",
        ],
      },
      {
        district: "Kanpur Nagar",
        localities: [
          "Billabong High International School",
          "Bithoor on the Ganges",
          "Chandra Shekhar Azad University of Agriculture & Technology",
          "Ganga Barrage Kanpur",
          "Ganga Canal Area (near IIT campus), Kanpur",
          "Ganga river banks at Shivrajpur, Kanpur",
          "Gangaghat -- Katarilodhwakhera",
          "Ganges River Bridge Marshes, Sitapur - Kanpur Road, Kanpur",
          "Green Cay Nature Center & Wetlands",
          "Harcourt Butler Technical University-Kanpur",
          "IIT Kanpur",
          "ISKCON Temple, Kanpur",
          "Indian Institute of Technology (IIT) Kanpur--Old RA Hostel",
          "J K temple Pandu Nagar",
          "JP Fertiliser Plant, Panki",
          "Jageshwar Temple Kanpur",
          "Jajmau Fort Kanpur",
          "Kanpur Airport",
          "Kanpur Boat Club",
          "Kanpur Zoo",
          "Kanpur Zoo Safari Trail",
          "LIC Satyameva Jayate Park, Vinayakpur, Sharda Nagar",
          "Maa Vaishnoi Park",
          "Magazine Ghat-Kanpur",
          "Moti Jheel Garden (Kargil Park), Kanpur Nagar",
          "Naramau Ganges",
          "National Sugar Institute, Kanpur -- Forest Area",
          "Ram Mandir (Bird Watching Point) on Ganges (Kanpur)",
          "Sakhrej ( Lower Ganga Canal )",
          "Utkarsh academy",
          "Vaishno Devi Temple WetAnd",
        ],
      },
      {
        district: "Kasganj",
        localities: [
          "Kashganj (OBI)",
        ],
      },
      {
        district: "Kushinagar",
        localities: [
          "Paniahwa gandak river",
          "Parinirvana Stupa",
          "Piparaicha Tal",
          "Ramkola Temple",
        ],
      },
      {
        district: "Lakhimpur Kheri",
        localities: [
          "Camp TigerLily",
          "Dudhwa  national park -- Sonaripur",
          "Dudhwa NP -- Bankey Tal (Sonaripur Range, Route #1)",
          "Dudhwa NP -- General Area",
          "Dudhwa NP -- Palia Range",
          "Dudhwa NP -- SD Singh Machan",
          "Dudhwa NP -- Satiana FRH",
          "Dudhwa NP -- Satiana Range (Route # 2)",
          "Dudhwa NP--Belraya Range",
          "Dudhwa NP--Dudhwa Mukhyalay (Headquarters)",
          "Dudhwa NP--Dudhwa Range",
          "Dudhwa NP--Main Campus - VIP Rest House",
          "Dudhwa NP--Mataiya Ghat",
          "Dudhwa NP--Rhino Enclosure Area",
          "Dudhwa NP--Sathiyana Range",
          "Dudhwa National Park & Tiger Reserve",
          "Dudhwa National Park -- Near watchtower main Dudhwa guest house",
          "Ghaghra River & Floodplains",
          "Gomti River , surrounding areas, Lakhimpur kheri",
          "Jaagir Manor, Dudhwa -- Orchards and Farmlands",
          "Janglinath baba mandir,Sharda River",
          "Kishanpur WLS -- General Area (Dudhwa NP Route#3 Chadi Taal)",
          "Mailani Railway Station",
          "Majula Taal Grassland",
          "Manjula Baba Fields",
          "Mohammadi, Kheri",
          "Nagariya Wetlands",
          "Nahar Bridge",
          "Phardhan Railway Station",
          "Sharda River",
          "South Kheri Forest (OBI)",
          "Tiger Tales Resort, Palia Kalan",
          "Vasalipur Grant",
        ],
      },
      {
        district: "Lalitpur",
        localities: [
          "Galitpur, Haryana (OBI)",
          "Mahaveer Swami Wildlife Sanctuary",
        ],
      },
      {
        district: "Lucknow",
        localities: [
          "Adhar Khera -- Open Fields, Farmlands and Forest area Near Adhar Khera",
          "Ambedkar Memorial Park- Lucknow",
          "Amity Lucknow Campus",
          "Babasaheb Bhimrao Ambedkar University Campus, Lucknow",
          "Babasaheb Bhimrao Amedkar University (BBAU) Lucknow -- Botanical Garden",
          "Bakshi Ka Talab -- Raitha Riverside",
          "Bara Imambara, Lucknow",
          "Bhuyia Mandir, Sarora Village",
          "Bijnor South Open Grounds and Scrub",
          "Butler Palace Colony",
          "CG City Wetland",
          "CG City Wetland -- Mastemau East of  Ekana Stadium",
          "Central Institute of Medicinal and Aromatic Plants (CIMAP)",
          "Chandrika Devi Temple",
          "Chaudhary Charan Singh International Airport",
          "Churheya - Scrubs and Grasslands",
          "Dr APJ Abdul Kalam Technical University Lucknow",
          "Dr Ram Manohar Lohia Park, Lucknow",
          "Dr Ram Manohar Lohiya National Law University",
          "Dudhara Oxbow Lake and Fields",
          "Dudhara, Itaunja. Lucknow",
          "Dugawan, Lucknow",
          "G20 Investor Summit Ground",
          "GRRC",
          "Ganga Aquarium, Canal Ring (VIP) Road, Lucknow",
          "Gaura - Scrubs & Grasslands (South)",
          "Gautam Buddha Park Gomti South Bank",
          "Ghuskar- Gomti and surrounding areas",
          "Gomti Bridge on IIM Road, Lucknow",
          "Gomti River North Bank (Birbal Sahni Marg)",
          "Gomti Riverfront Park",
          "Gomti Riverside G20 Road",
          "Gomti Weir East",
          "Gosainganj Wetlands -- Bakhari",
          "Gosainganj Wetlands -- Dhakawa (North) end",
          "Gosainganj Wetlands -- Dular Mau",
          "Gosainganj Wetlands -- Meesa",
          "Gosainganj Wetlands -- Sri Jharkhandeswar Baba Dham",
          "Gulala Ghat Gomti South Bank",
          "Hanuman Ji Mandir (Ramghat Kolwa)",
          "Hulas Khera--(Hulaskheda Fort) Archaeological Excavation Site & Oxbow Lake",
          "Hulas Khera--Khujehra Lake",
          "IIM Lucknow",
          "Inderjeet Khera",
          "Indian Institute of Management (IIM) Campus, Lucknow",
          "Indira Canal -- Sultanpur Road",
          "Indira Dam -- Meesa on the South Bank",
          "Indira Dam -- North Bank near Aqueduct",
          "Indira Dam -- Wetlands and reedbed near Dhakawa on south bank",
          "Integral University",
          "Jai Shree Ram Park",
          "Janeshwar Mishra Park",
          "Jugauli open forest & Lake",
          "Jyotiba Phule Zonal Park",
          "Kall Paschim (West) Road",
          "Kalli Paschim -- Kalpana Estate and Oxbow Lake",
          "Kalli Poorab Wetlands",
          "Kathauta Jheel",
          "Koko's Farm, Jabrauli",
          "Kukrail Forest and Gharial Park -- General Area",
          "Kukrail Gharial Park, Lucknow, Uttar Pradesh",
          "Kuria Ghat on Gomti River",
          "La Martinière Boys College (Lucknow)-- Campus Proper",
          "La Martinière Boys College -- Gomti West Bank",
          "Lakshman Mela grounds, Lucknow",
          "Lucknow (OBI)",
          "Lucknow Cantonment",
          "Lucknow Railway Station",
          "Lucknow University - New Campus at Janakipuram",
          "Lucknow University -- Old/Main Campus",
          "MEPTA Golf Course",
          "Maharaja Bijli Pasi Quila",
          "Malookpur Wetland",
          "Manikarnika Park (Neta Ji Mulayam Singh Yadav Park)",
          "Manyavar Shri Kanshiram Ji Eco Garden Park",
          "Moosa Bagh Forest, Hardoi Road, Lucknow",
          "Moti Jheel - Aishbagh Kabristan",
          "Musa Bagh Gomti South Bank",
          "National Bank Staff College (NBSC) Campus, Ashiyana",
          "National Botanical Research Institute (NBRI) Research Station, Banthra",
          "National Botanical Research Institute (NBRI)-1",
          "National Botanical Research Institute (NBRI)-2",
          "Nawab Wajid Ali Shah Zoological Garden (Lucknow Zoo)",
          "Nehru Enclave Forest",
          "Nilansh Theme Park and Water park",
          "Nishatganj Cemtery",
          "Pooran Pur Jheel, Mohanlalganj",
          "RDSO Stadium",
          "Rajkiya Udyan, Lucknow",
          "Ramabai Ambedkar Rally Sthal",
          "Ramlila Maidan and Herbal Vatika",
          "Residency Ruins Lucknow",
          "Riverfront Butler Rd",
          "Roberts Lines",
          "SGPGI Campus & Surroundings -- Deen Dayal Upadhyaya Park",
          "SGPGI Campus & Surroundings -- Open Fields and Swamp (Lucknow)",
          "SGPGI Campus & Surroundings -- Trauma Center",
          "SGPGI Campus & Surroundings--Campus Proper",
          "SGPGI Campus Surroundings - Agricultural Fields & Canal",
          "Sahara Estates Playground",
          "Saheed Park, Vipul Khand 5 Gomtinagar Lucknow",
          "Shaheed Zia Ul Haq Park, Khurram Nagar",
          "Shalimar park & surrounding area",
          "Sharda Canal -- Mohan Malihabad road",
          "Shri Ramswaroop Memorial College of Engineering and Management",
          "Somvanshi Park, Gomti Nagar",
          "Sri Siddh Bala Hanuman Ji Park",
          "Study Hall School, Lucknow",
          "Tellibagh",
          "UP Sainik School Lucknow",
        ],
      },
      {
        district: "Maharajganj",
        localities: [
          "Darjaniya Lake",
          "Jharvaliya, Nichlaul",
          "Lehra Temple",
          "Nautanwa",
          "Sohagi Barwa WILS -- Madhwalia FRH",
          "Sohagi Barwa WLS -- Baidauli Bankatti Jheel",
          "Sohagi Barwa WLS -- Deibhar FRH (North Chowk Range)",
          "Sohagi Barwa WLS -- Nichlaul FRH",
          "Sohagi Barwa WLS -- Pakadi FRH (Pakadi Range)",
          "Sohagi Barwa WLS--Kushwahwa FRH (South Chowk range)",
          "Sohagi Barwa WLS--Madhwaliia FRH",
        ],
      },
      {
        district: "Mahoba",
        localities: [
          "Bania Talab Mahanpur",
          "Kirat Sagar at Sharafipura",
          "Madan Sagar",
          "Vijay Sagar Bird Sanctuary",
        ],
      },
      {
        district: "Mainpuri",
        localities: [
          "Karhal Bypass Road, Karhal",
          "Khirongi (Lucknow-Agra Exp Way)",
          "Kirthua Ponds",
          "Mainpuri, UP (OBI)",
          "Saman Bird Sanctuary",
          "Sarus Crane Wetlands Saifai near  Kirthua",
        ],
      },
      {
        district: "Mathura",
        localities: [
          "Ajhai, Akbarpur",
          "Dholi pyau pond",
          "Gokul Dham",
          "Jodhpur Jhal Bird Sanctuary",
          "Keshi Ghat, Vrindavan",
          "Kosi Kalan East",
          "Kosi Khurd",
          "Mathura Railway Station",
          "Radharani Dham - Forest Area",
          "Raya Toll Booth Ponds near Jawra, Mathura",
          "Sonot Village pond",
          "Vrinda Devi Temple",
          "Vrindavan",
          "Wildlife SOS Elephant Conservation and Care Centre",
          "Yamuna River Bed at General ganj, Mathura",
          "mathura",
        ],
      },
      {
        district: "Mau",
        localities: [
          "Dohrighat",
          "Vandevi Dham",
        ],
      },
      {
        district: "Meerut",
        localities: [
          "Chaudhary Charan Singh University Meerut",
          "Dr. Shadi Lal College of Education, Sardhana Road, Meerut",
          "Gandhi Bagh (formerly known as Company Garden)",
          "Ganga Bridge- Manoharpur",
          "Ishwar Nagar Park Meerut",
          "Jani, Upper Ganges Canal",
          "Meerut Cantonment",
          "Meerut Cantt Railway Station",
          "Meerut Railway Station",
          "Overhead Water Tank, Khirwa Road, Shraddha Puri, Kankar Khera, Meerut",
          "Rustampur Bhikund, Hastinapur",
          "Victoria Park Meerut",
        ],
      },
      {
        district: "Mirzapur",
        localities: [
          "Banaras Hindu University (South campus)",
          "Chilh - Riverside",
          "Chuna Dari Waterfall",
          "Chunar Railway Junction (Mirzapur, Uttar Pradesh)",
          "Jagapatti village",
          "Jargo Dam, Mirzapur",
          "Jeonathpur Railway Station, (Mirzapur, Uttar Pradesh)",
          "Kaimur WLS -- Harra forest",
          "Lakhania -- Hills & Waterfall",
          "Maa Vindhyavaasini Biodiversity Park",
          "Mirzapur (Uttar Pradesh) Railway Station",
          "Pipari Dam on Belan River, Mirzapur",
          "Rajiv Gandhi South campus, Banaras Hindu University",
        ],
      },
      {
        district: "Moradabad",
        localities: [
          "Kashipur Moradabad Road (OBI)",
          "Missarwala on Moradabad Kashipur Road",
          "Moradabad Bypass Road",
          "Ramganga -- Deer Park on Rampur Road",
        ],
      },
      {
        district: "Muzaffarnagar",
        localities: [
          "Bamanheri Railway Station",
          "Haiderpur Farming Ponds",
          "Haiderpur Wetland--Ujaili Trail",
          "Haiderpur Wetlands -- Forest Trail",
          "Haiderpur Wetlands -- General Area",
          "Haiderpur Wetlands -- Madhya Ganga Canal Trail",
          "Haiderpur Wetlands -- Muzaffarnagar Zone",
          "Muzaffarnagar Railway Station",
        ],
      },
      {
        district: "Pilibhit",
        localities: [
          "Baba Ikottar Nath, Pooranpur Kurraiya",
          "Chaltua Ashram Gurdwara, Puranpur,",
          "Chuka Reservoir",
          "Haripur Forest Range, Pilibhit (OBI)",
          "Haripur Range Grasslands & Floodplains",
          "Pilibhit Tiger Reserve",
          "Pilibhit Tiger Reserve - Mahof Zone",
          "Pilibhit Tiger Reserve-- Mustafabad",
          "Yashwantri Temple Lake, Pilibhit",
        ],
      },
      {
        district: "Pratapgarh",
        localities: [
          "ATL ground Pratapgarh",
          "Agriculture - Horticulture department campus",
          "Gaighat on Sai River Pratapgarh -- South Bank",
          "Horticulture office campus",
          "Karanpursenani Nagar Bela pond -",
          "Khajohari",
          "Korahi Kunda Pratapgarh",
          "Pratapgarh Fort",
          "Pure Mohan, Pratapgarh",
          "Shivrajpur Gadwara Pratapgarh",
          "Shree Shani dev dham",
          "Sri Ram Temple Belha Devi on Sai River",
          "Tala Patti Pratapgarh",
        ],
      },
      {
        district: "Prayagraj",
        localities: [
          "Allahabad Fort",
          "Allahabad University",
          "Amilya Tarhar",
          "Arail",
          "Arail Ghat, Prayagraj",
          "Arail--Yamuna South Bank",
          "Asrawe Kalan",
          "Baghla Dam",
          "Bamrauli Kachhar - Farmlands & Floodplains",
          "Belwaniya Wetland Region",
          "Bhita",
          "Bisauna Lake",
          "Chakghat, Tons River -- Prayagraj",
          "Chandra Shekhar Azad Park (Company Garden)",
          "Chhatnag Ghat",
          "Dewari Gaon Lake",
          "GC CRPF Prayagraj",
          "Gadaiya Lonipar (Fields & Wetlands)",
          "Ganga River Below Phaphamau Bridge",
          "Ganga River Near Rasulabad",
          "Garuda Park",
          "Guleriya Dam",
          "Harish-Chandra Research Institute (restricted access)",
          "Indian Institute for Information Technology (IIIT)",
          "Kalidas Point",
          "Khusro Bagh",
          "Koraon Forest Range",
          "Koraon Road Bridge - Belan River",
          "Lota Ghat",
          "Mawaiya Uparhar",
          "McPherson Lake",
          "Meja Road Railway Station",
          "Mejha Forest Range -- Scrub Jungle",
          "Minto Park Allahabad",
          "Moon Canal--Sandwa Khurd",
          "Naini Forest Near TSL",
          "Nauriha Tarhar",
          "Phaphamau Barrage",
          "Piprawan Lake",
          "Planters Bungalow",
          "Prayagraj Airport",
          "Ram Sarovar Naini",
          "Rehi Taluka Baijala",
          "Sam Higginbottom University of Agricultural Technology and Sciences (SHUATS)",
          "Samrat Harsh Vardhan Ghat",
          "Semri Tarhar",
          "Shankargarh Forest",
          "Shri Nagvasuki Mandir",
          "Sonbhadri Wetland Region",
          "Tharwai Gaon",
          "Triveni Sangam",
          "Ulta Qila",
          "Yamuna Bank Saeedpur",
        ],
      },
      {
        district: "Raebareli",
        localities: [
          "Fatehpur Ganga Bridge",
          "Indira Gandhi Smarak Vanaspati Udyan",
          "Mahanandpur Open Fields",
          "Malhipur-Padera at Bacchrawan- Harchandpur Road",
          "Pakka Ghat Dalmau",
          "Rae Bareli District Nursery",
          "Rajapur Village on Maharaja Ganj Road",
          "Surjapur at Bacchrawan-- Sharda Canal and Reedbed",
          "Unnamed Low lying  Fields to be named after visit",
        ],
      },
      {
        district: "Rampur",
        localities: [
          "Bilaspur Railway Station",
          "Janu Nagar near Kemri",
        ],
      },
      {
        district: "Saharanpur",
        localities: [
          "Asli Bagh Saharanpur",
          "Badshahi Bagh Reserve Forest",
          "Deoband Railway Station",
          "Hathni Kund Barrage",
          "Mohand checkpost and vicinity (Reserve Forest)",
          "Saharanpur Railway Station",
          "Shakumbri Devi Mandir (Temple Nearby)",
        ],
      },
      {
        district: "Sant Kabir Nagar",
        localities: [
          "Bakhira Bird Sanctuary",
          "Bakhira Wildlife Sanctuary (Bakhira Taal)",
        ],
      },
      {
        district: "Shahjahanpur",
        localities: [
          "Atsalia Talaab",
          "Kakra Kakar Kand",
          "Millennium School, Shahjahanpur",
        ],
      },
      {
        district: "Shrawasti",
        localities: [
          "Bhaisahi Naala,Tulsipur - Sirsiya - Bilaspur Road, Gabbapur Kalan",
          "Bhinga Forest and Wetland",
          "Shrawasti Airport",
          "Suhelwa (Suheldev) WLS -- East Sohelwa FRH",
          "Suhelwa (Suheldev) WLS -- Motipur Reservoir",
          "Suhelwa (Suheldev) WLS -- Rampur Bund (Irrigation Reservoir)",
          "Suhelwa (Suheldev) WLS-- Sirsiya Dagmara Nala",
          "Vibhutinath Reservoir",
        ],
      },
      {
        district: "Sitapur",
        localities: [
          "Chahlari Ghat -- Chahlari",
          "Chahlarighat River Boating",
          "Raipur (Sitapur)",
          "Sarwarpur",
          "Sidhauli Railway Station",
          "Sitapur Railway Station",
          "Sitapur Shiksha Sansthan",
        ],
      },
      {
        district: "Sonbhadra",
        localities: [
          "Hathinala Biodiversity Park",
          "Jharo Kalan Dam",
          "Kaimoor Wildlife Sanctuary--Blackbuck Valley",
          "Myorpur Forest Range (OBI)",
          "Obra Rail Station Road",
        ],
      },
      {
        district: "Sultanpur",
        localities: [
          "Gomti River at Sita Kund",
          "Kamla Nehru Institute of Technology, Sultanpur",
          "Lambua Sultanpur",
          "Nirsahiya",
        ],
      },
      {
        district: "Unnao",
        localities: [
          "Firojpur Kalan",
          "Food King Plaza, Agra - Lucknow Expressway, Bhikharipur Patsia Gair",
          "Hanumangarhi",
          "Ma Kalika Mandir",
          "Nawabganj Bird Sanctuary -- Sanctuary Proper",
          "Nawabganj Bird Santuary -- Open Fields Unnao",
          "Ox Bow Lake, Maurawan",
          "Raukarna Banda Khera Route",
          "Sidhnath Temple Area",
        ],
      },
      {
        district: "Varanasi",
        localities: [
          "Assi Ghat",
          "Banaras Hindu University (BHU)",
          "Banaras Hindu University -- Ayurvedic Garden",
          "Benares Hindu University (BHU) Campus -- Agriculture Farm Air Strip Varanasi",
          "Beniya Bagh Park, Varanasi",
          "Botanical Garden, BHU Campus",
          "Chak Bansdev Bharthra",
          "Dashashwamedh Ghat, Varanasi",
          "Guleria Kothi Hotel - Ganges",
          "Harishchandra Ghat, Varanasi",
          "Kashi Vishwanath Temple",
          "Machodari Park, Rabindranath Tagore Rd. Varanasi",
          "Manikarnika  Ghat",
          "Manikarnika Ghat",
          "Nehru Park, Kennedy Rd, Varanasi",
          "Rajghat Besant School, Varanasi",
          "Sant Ravidas Park, Varanasi",
          "Saranath Lake",
          "Sarnath Deer Park",
          "Susuwahi Road",
          "Taj Ganges, Varanasi -- Garden",
          "Taj Nadesar Gardens",
          "Varanasi Airport, Babatpur",
          "Varanasi Fun City Daniyalpur Sona Talab",
          "Varuna Riverside Road",
        ],
      },
    ],
  },
  {
    state: "Uttarakhand",
    districts: [
      {
        district: "Almora",
        localities: [
          "Almora Town",
          "Anant Rasa - Sitlaketh Road",
          "Army Holiday Home, Ranikhet",
          "Babar Khola Village (Raniketh Almora Rd)",
          "Bhaunkhal",
          "Bineshwar Mahadev Temple, Binsar",
          "Binsar Forest Rest House",
          "Binsar Forest Retreat",
          "Binsar Sanctuary--Gaunap",
          "Binsar Wildlife Sanctuary,Almora",
          "Camp Forktail Creek Lodge",
          "Champanagar (OBI)",
          "Chaubatia",
          "Chaukhutiya - Ramganga River surroundings",
          "Chiliyanaula (OBI)",
          "Chimtakhal",
          "Club Mahindra Resort - Binsar Villa, Almora",
          "Corbett Jungle Inn Riverside forest camp--Mohaan",
          "Corbett NP- Lohachaur Tourism Zone",
          "Corbett NP--Bhakrakot",
          "Dalmoti Forest Range",
          "Dandeshwar",
          "Dhaulchhina",
          "Dotiyal (OBI)",
          "Durgadevi",
          "Dwarahat  Near YSS Ashram",
          "Forest near Kasar Devi Temple",
          "GBPNIHESD, Kosi-Katarmal, Almora",
          "Ghweri",
          "Holm Farm Heritage, Ranikhet",
          "Jageshwar",
          "Jageshwar--Van Serai",
          "Karchuli",
          "Kasar Devi--Balta Valley",
          "Kasar Devi--General",
          "Kausani",
          "Kausani Eco Park",
          "Khali Estate",
          "Kharkiya",
          "Kwarali Village",
          "Lebua Corbett Saraca Estate",
          "Maini's Hill Cottages",
          "Manela",
          "Manila",
          "Manila - Mandir Malla",
          "Manila Birding Lodge",
          "Marchula",
          "Mrig Vihar Zoo (Baldhauti)--Almora Zoo",
          "Mystic Mountain Resort",
          "Pant Kotuli",
          "Ranikhet (OBI)",
          "Ranikhet Dumpyard",
          "Rudradhari Waterfall",
          "Seraghat",
          "Shitalakhet KMVN",
          "Shitlaket",
          "The Dozen Oaks, Kayala",
          "The Himalayan Outback",
          "Vanghat",
          "Vriddha Jageshwar Dham",
          "Yogoda Satsanga Sakha Ashram -Dwarahat (Restricted access)",
          "welcom hotel by itc jim corbett",
        ],
      },
      {
        district: "Bageshwar",
        localities: [
          "Bageshwar",
          "Baijnath (OBI)",
          "Binsar Wildlife Sanctuary",
          "Dwali",
          "Gogina",
          "KMVN Kaushani, Uttarakhand",
          "Khati",
          "Phurkiya (Pindari Trek)",
          "Shikhar Mool Narayan Mandir",
          "TRH Phurkiya",
          "Wachham (Jaikuni/Base)",
        ],
      },
      {
        district: "Chamoli",
        localities: [
          "Akrot Ghetta Campsite",
          "Ansuya Devi Trek",
          "Anusuya Devi Mandir",
          "Auli",
          "Auli Lake",
          "Badhangarhi, Taal",
          "Bainoli",
          "Bedeni Bugiyal (OBI)",
          "Betla",
          "Bhagwa Basa",
          "Bhulkan",
          "Bhulkan (OBI)-- General Area",
          "Bhyudar",
          "Bulkana-Tungnath, Kedarnath Widlife Sanctuary",
          "Chopta- Riverside Resorts & camps",
          "Didna village",
          "Durmi",
          "Farkya Village",
          "Gairsain (OBI)",
          "Garur Ganga",
          "Gehroli Patal campsite",
          "Ghangaria (OBI)",
          "Ghangharia to Govindghat Rd",
          "Gopeshwar",
          "Govind Ghat",
          "Govindghat Hemkund Sahib trekking trail",
          "Gulling campsite",
          "Hanuman Chatti",
          "Hemkunt Sahib",
          "Joshimath (OBI)",
          "Joshimath FRH",
          "Kanchula Kharak, Kedarnath Wildlife Sanctuary",
          "Kedarnath WLS",
          "Khullara Campsite",
          "Kuari Pass (OBI)",
          "Lohajung, Base camp for Roopkund",
          "Mana Pass Road- Saraswati Glacier",
          "Mana Uttarkhand (OBI)",
          "Mandal-- Kedarnath WLS",
          "Mandal--General Area (OBI)",
          "Mandal--Herbal Research Centre",
          "Mohankhal- Kedarnath WLS",
          "Nanda Devi NP--General Area",
          "Near Badrinath (OBI)",
          "Niti",
          "Pangarbasa Chatti, Chopta,",
          "Pyura (OBI)",
          "Roopkund",
          "Shokharak",
          "Siran",
          "Tali Trail",
          "Talwari",
          "Urgam Valley",
          "Urgam Valley--Devgram",
          "Urgam Valley--Lyari Than",
          "Urgam Valley--Urgam",
          "Valley of Flowers National Park",
          "Vishnuprayag",
          "Wan village",
          "way towards Karnaprayag (OBI)",
        ],
      },
      {
        district: "Champawat",
        localities: [
          "Abbott Mount",
          "Banasur's Kila (Fort)",
          "Pancheshwar Fishing Retreat",
          "Poornagiri Hills, Danda Range",
          "Sharda Barrage, Banbasa",
          "Shree Krantheshwar Mahadeva Mandir Forest",
          "Tanakpur",
          "Tanakpur Dam",
          "Tea Garden,  Champawat",
        ],
      },
      {
        district: "Dehradun",
        localities: [
          "18 Mohini Road, Dalanwala",
          "Aam Wala",
          "Adhoiwala",
          "Aduwala Forest, Timli Range",
          "Asan Barrage Bird Sanctuary",
          "Asan Conservation Reserve",
          "Asan Conservation Reserve--Forest Trail",
          "Asan River – Badoni Bridge, Selaqui",
          "Asarodi, Ramgarh Range",
          "Assan Barrage",
          "Bajaj Institute of Learning",
          "Barkot Reserved Forest, Dehradun",
          "Benog WLS--Dhobhighat",
          "Benog WLS--Jwala Devi",
          "Between WII and Sal Patch",
          "Bhadraj",
          "Bhandari Bagh",
          "Bhilangana River--Bangai",
          "Bijapur",
          "Bijapur, Dehradun Cantonment",
          "Bodhigram Empowerment Centre",
          "Budher caves",
          "Burans Khanda",
          "CASFOS--North Hostel",
          "Chakrata",
          "Chakrata-- Gurudwara Trail",
          "Chakrata--Gwasa Bridge",
          "Chalang",
          "Chandra Nagar Road",
          "Chandrabani Chowk",
          "Chandrabani Reserved Forest",
          "Chandrabani-Karwapani Trail",
          "Chhaani Cafe",
          "Chilla Range--Ganga Bank",
          "Chowki Village (OBI)",
          "Circular Road, Dalanwala, Dehradun",
          "Cloud end--Dudhli village",
          "Cloud end--Estate",
          "Col Brown School",
          "Company Garden - Dhobighat Trail",
          "Convent  Rd",
          "Curzon Road, Dalanwala, Dehradun",
          "DEAL Colony",
          "DFO Chakrata Campus, Kalsi",
          "Dakpatthar--GMVN Rest House",
          "Dalai Hill--General Area",
          "Dalanwala, Eastern Canal Road",
          "Daudwala",
          "Dehradun (OBI)",
          "Dehradun Cantonment",
          "Dehradun District Court Campus",
          "Dehradun--Clock Tower",
          "Dehradun--Karwapani",
          "Dehradun--Mohkampur",
          "Dehradun--Panditwadi",
          "Dehradun--Railway Stations",
          "Deoban",
          "Dharampur, Dehradun",
          "Dindyali Homestay",
          "Doiwala",
          "Doon Hospital",
          "Doon Officers' Enclave, Chandrabani",
          "Doon PG College Of Agriculture Science And Technology, Shankerpur Hakumatpur",
          "Doon University Campus",
          "FRI--Botanical Garden",
          "Forest Research Institute (FRI), New Forest Campus",
          "Fulsani, Dehradun",
          "Galajwari-3",
          "Galjwari",
          "Ganga bank near Chilla",
          "Gangotri Vihar, Canal Road",
          "George Everest House  Mussoorie",
          "Guchhupani",
          "Guniyal Gaon",
          "Hanol",
          "Harbanswala Tea Estate, Dehradun",
          "Hathibarkala",
          "Hathipaon--George Everest",
          "Hathipaon--Lambi Dehar mines",
          "Himalayan Institute of Technology--Campus 2",
          "Himjyoti School",
          "Horawala",
          "Hydel Colony, Araghar",
          "IDPL Rishikesh",
          "IIP, Mohkumpur",
          "IRDE Residential Campus",
          "ISBT Dehradun",
          "ISBT Rishikesh, Uttarakhand,",
          "Indian Institute of Petroleum",
          "Indian Institute of Remote Sensing (IIRS), Dehradun",
          "Jabarkhet Nature Reserve",
          "Jaitanwala",
          "Jakhan",
          "Jamniwala",
          "Jamoliwala",
          "Jaswant Modern Senior Secondary School",
          "Jhajhra",
          "Jhanda Saheb Dehradun",
          "Jharipani",
          "John Martyn Memorial School",
          "Jolly Grant (OBI)",
          "Kachnar Homestay",
          "Kalu Sidh Temple, Dehradun (OBI)",
          "Kanasar",
          "Kansrao-Motichur road",
          "Karvapani sal forest (OBI)",
          "Karwapani",
          "Kasiga School",
          "Kaudiya/Gangabhogpur -- Talla",
          "Kedarpur",
          "Khadar New Colony",
          "Khalanga Reserved Forest",
          "Kharakhet",
          "Kimadi--Bhitar Wali",
          "Kolukhet",
          "Kotra Village",
          "LBSNAA To Company Bagh Trail",
          "LBSNAA to Waverley school",
          "LBSNAA--Happy valley to Polo grounds",
          "Lachhiwala",
          "Lakhwar",
          "Lal Bahadur Shastri National Academy of Administration (LBSNAA)--Main Campus",
          "Lal Tappad Dehradun-Haridwar Road",
          "Landour",
          "Landour--Hanifl Centre Woodstock",
          "MDDA Colony, Chandar Road, Adhoiwala",
          "Mahendra Vihar",
          "Maindrath",
          "Majra",
          "Maldevta",
          "Maldevta--Red Bridge",
          "Malsi--Deer Park and Dehradun Zoo",
          "Malsi--Reserve Forest",
          "Mangaluwala--Aradhana Greens society & Tibetan Colony",
          "Masrana-Tipli Dhar-Bataghat",
          "Mata Wala Bagh",
          "Mehuwala forest",
          "Morowala, Haridwar Bypass Road",
          "Mothorowala Rd",
          "Mount Fort Academy",
          "Mussoorie Town--General Area",
          "Mussoorie--Barlowganj",
          "Mussoorie--Camel's Back Road",
          "Mussoorie--Kincraig",
          "Mussoorie--Lal Tibba",
          "Mussoorie--Mossy Falls",
          "Nakraunda",
          "New Campus Bajaj Institute of Learning",
          "Outskirts of Doon University",
          "Outskirts of lacchiwala range",
          "Park Road, Laxman Chowk",
          "Polykids school",
          "Pritam Road",
          "Punarnava Wellness Resort",
          "Purkul Gaon",
          "Raipur",
          "Rajaji NP--Chilla Range",
          "Rajaji NP--Kansrao--restricted access",
          "Rajpur",
          "Rajpur Post office",
          "Rajpur Road Enclave, Dhoran",
          "Rajpur--Shahenshahi Ashram",
          "Rajpur-Mussoorie trail",
          "Rangers College",
          "Rishikesh (OBI)",
          "Rispana valley--Kairwan gaon",
          "River Asan near Herbertpur (OBI)",
          "Sahajpur",
          "Sahastradhara",
          "Sahastradhara--Majhara",
          "Sakya Hospital",
          "Sal Patch near WII, Dehradun",
          "Sarni",
          "Sauda Saroli, Thano Road",
          "Selaqui (Selakui)",
          "Shaheen Bagh Resort",
          "Sharp Memorial School for the Blind",
          "Shikhar Falls",
          "Shishya Public School (Restricted)",
          "Shiv Mandir--Danda Lakhaur",
          "Sigli",
          "Siyaram Sports And Badminton Academy",
          "Sodasaroli, Uttarakhand, IN (30.293, 78.132)",
          "Song Bridge, Raipur",
          "Song River Bridge Haridwar Road, Rishikesh,",
          "Songtsen Library, Kirsali",
          "Suwakholi",
          "Talai, Thano",
          "Tapkeshwar Mahadev Mandir",
          "Tapovan",
          "Than Gaon",
          "Thano",
          "Thano Reserve Forest",
          "The Doon School",
          "Timli Reserved Forest",
          "Tons Bridge, Bishtgaon",
          "Tons River (FRI Backyard)",
          "Tons Valley Forests (OBI)",
          "Tons river ( FRI backyard)",
          "Treebo Kanopy Greens",
          "Tula's Institute",
          "Tuntawala",
          "UPCL Ganeshpur",
          "Unison World School",
          "Unnamed Road, Dehradun, Uttarakhand, IN (30.261, 78.039)",
          "Vasant Vihar",
          "Virbhadra Barrage, Rishikesh",
          "Virbhadra, Rishikesh",
          "Vyas Ghat, Haripur Kalan",
          "Vyas Mandir--Haridwar",
          "WII--Pattiyonwala Road",
          "Walterre Resort",
          "Welham Boys' School",
          "Welham Girls' School",
          "Wildlife Institute of India (WII)",
          "Wildlife Institute of India (WII)--Nature Trail & Lake",
          "Wildlife Institute of India Residential Complex",
          "Woodstock school",
          "Zero Point to Darbar temple trail",
          "Zoological Survey Of India, Northern Regional Centre--Dehradun",
        ],
      },
      {
        district: "Haridwar",
        localities: [
          "Aalia Jungle Bandarjudh",
          "Amichand Gaushala",
          "Bhimgoda Barrage",
          "CPU Office, Sector 1, BHEL",
          "CPU Office, Sector 1, BHEL ( near pond)",
          "Chandi Devi Temple",
          "Chandi Ghat Haridwar",
          "Chiriyapur -- Dipo",
          "Gaindi Khata",
          "Gujjar Basti Mazar Trail",
          "Gujjar Basti, Gaindikhata",
          "Haridwar (General) (OBI)",
          "Haridwar Railway Station",
          "Haridwar University Gate, Upper Ganga Canal Rd",
          "Indian Institute of Technology (IIT) Roorkee",
          "Jattpura",
          "Jhilmil Jheel Conservation Reserve",
          "Jhilmil Jheel Conservation Reserve--Chhipiya",
          "Jhilmil Jheel conservation Reserve--Dasowali",
          "Kotawali",
          "Laksar Railway Junction",
          "Laldhang--Rasoolpur",
          "Mansa Devi Temple",
          "Nahar Pur Eastern Ganga Canal",
          "Nalowala",
          "New Shivalik Nagar Block-F",
          "Pili Range, Hardwar",
          "Railway Bridge Upper Ganga Canal Road, Roorkee,",
          "Rajaji NP- near guest house",
          "Rajaji NP--Luni",
          "Rajaji NP--Mohand range",
          "Rajaji NP--Ranipur Range",
          "Roorkee Laksar Road, Mutkarabad,",
          "Roorkee--Asaf Nagar",
          "Roshanabad",
          "Sajanpur Pili",
          "Shyampur",
          "Siddh Kuti (Gujjar Basti)",
          "Siddh Sot Shyampur  Forest Range, Uttarakhand,",
          "Sidhsot Van Gujjar Colony",
          "Simbal Sot Shyampur Forest Range",
          "Vishnu Ghat, Haridwar",
          "Yog Gram Haridwar",
        ],
      },
      {
        district: "Nainital",
        localities: [
          "Aahana Resort, Savaldeh, Ramnagar",
          "Alukhet Road",
          "Amdanda",
          "Ayan Jungle Lodge",
          "Ayarpatta",
          "BDJM Academy",
          "Baba Haidakhan, chakrata range",
          "Bagar Road, Pangot",
          "Bagar Talla",
          "Bajoon",
          "Balaut Resort",
          "Baldiyakhan",
          "Barati Rao",
          "Baret",
          "Bhagotpur Tariyal",
          "Bhalon",
          "Bhatrojkhan (OBI)",
          "Bhimtal",
          "Bhimtal--General Area",
          "Bhowali",
          "Bhumiyadhar",
          "Birder's Den Eco Friendly Resort",
          "Birders Den--Bhimtaal",
          "Birla Vidyamandir Campus ( near Mandir)",
          "Birla Vidyamandir Campus ( near the ground)",
          "Blue Magpie Homestay--Peora",
          "Bohra Koth",
          "Butterfly Research Centre- Bhimtal",
          "Camp Big Cat Corbett--Shekhar Corbett Safari Camp",
          "Camp Hornbill Kyari",
          "Camp Milieu",
          "Chaffi",
          "Chaffi (river bed)",
          "Chafi Bridge, Bhimtal",
          "Chanfi",
          "Cheer Point, Vinayak Forest (Pangot)",
          "Cheer Point--Pangot",
          "CheerPoint, Sigri",
          "Chhoi",
          "Chhoti Haldwani",
          "Child Sacred School Road (CSSR)",
          "China peak",
          "Corbett NP--Bijrani Guest House",
          "Corbett NP--Bijrani Range",
          "Corbett NP--Dhangarhi",
          "Corbett NP--Dhela",
          "Corbett NP--General",
          "Corbett River View Retreat, Garjiya, Ramnagar",
          "Corbett Riverside Resort, Dhikuli",
          "Darima",
          "Dhanachuli",
          "Dhanachuli -Birding point",
          "Dharampur Auliya",
          "Dhela",
          "Dhela Road Kanda Range",
          "Dhikuli",
          "Dudhkanie Dhar, Uttarakhand, IN (29.441, 79.588)",
          "G B Pant High Altitude Zoo",
          "Gaduppu, Banna Khera Range",
          "Gahna",
          "Gairal",
          "Gangachaur Village",
          "Garjiya",
          "Garjiya Devi Temple",
          "Garjiya Tourism Zone, Corbett Tiger Reserve",
          "Gaula River--Haldwani",
          "Ghatgarh (OBI)",
          "Ghuggu Kham",
          "Haathidangar",
          "Haldwani--Transport Nagar",
          "Hartola",
          "Hillwood Academy",
          "Himalayan Botanical Garden",
          "Himalayan Homestead",
          "I.V.R.I., Mukteshwar Campus",
          "IVRI Forest",
          "Incredible Birding Camp",
          "Incredible Birding Hide",
          "Jantwai Gaon",
          "Jeolikote",
          "Jeolikote--Camp Sparrow",
          "Jhoola Pul (Suspension Bridge), Garjiya, Ramnagar",
          "Jiling",
          "Jilling Estate, near Bhowali (OBI)",
          "Jim Corbett Radisson",
          "Jim's Jungle Retreat, Dhela",
          "Jungle Lore Birding Lodge",
          "KMVN Sigri",
          "Kafal House, Pangot",
          "Kainchi Temple",
          "Kaladhungi",
          "Kaladhungi Rd",
          "Kalapatal",
          "Kalyanpur",
          "Kathgodam",
          "Khurpatal",
          "Kiari Range",
          "Koshi River -- Girija Devi Temple",
          "Kosi Barrage, Ramnagar",
          "Kosi River",
          "Kotabagh",
          "Kotdwar Road, Ramnagar",
          "Kuleti",
          "Kumayoun",
          "Kumeriya RF (OBI)",
          "Kunja Kharak",
          "Kunjakharak",
          "Laduwarao",
          "Lal Ghar, Lweshal",
          "Land's End Trail",
          "Lweshal, Nayeli",
          "Maheshkhan--RF",
          "Mall Road--Nainital",
          "Mangoli",
          "Mehragaon",
          "Mohan",
          "Mukteshwar (OBI)",
          "Mukteshwar Dham Temple",
          "Mukteshwar--Sitla Forest",
          "Musabangar",
          "Naina Devi Jal Kund",
          "Naina Peak",
          "Naini Retreat",
          "Nainital",
          "Nainital Lake",
          "Nainital--Ayar Jungle Camp",
          "Nainital--China Peak",
          "Nainital--Kilbury, Pangot WLS",
          "Nainital--Niglat (OBI)",
          "Nal Damyanti Tal",
          "Nalni",
          "Nalni Estate, Nainital (OBI)",
          "Nanda Stone",
          "Nandhaur WLS--Chorgalia",
          "Nandhaur WLS--Nandhaur Range",
          "Nandhaur WLS-Machhli Van",
          "Narsinghpur Arera",
          "Nathuakhan",
          "Naukuchiatal",
          "Nayagaon",
          "Old Forest Campus",
          "PPP Homestay (Eco Harryman's homestay)",
          "Paatlidun Safari Lodge",
          "Pandaychore Road--Gaula River",
          "Pande Gaon (OBI)",
          "Pangoot Luxury Homes",
          "Pangot",
          "Pangot Forest Trail",
          "Pangot--Woodpecker Point",
          "Pathkote",
          "Patkot Village (OBI)",
          "Pawalgarh",
          "Pawalgarh Conservation Reserve",
          "Pawalgarh Conservation Reserve--Hathigaliyar",
          "Pawalgarh Conservation Reserve--Pawalgarh Village",
          "Pawalgarh-Bhandarpani Road",
          "Phanto Forest Rest House",
          "Phato Eco Tourism Zone",
          "Pinewood Cottages",
          "Prabhu's Bird Photography Hide",
          "Priya Bend",
          "Purna Tal",
          "Ramgarh",
          "Ramgarh--Gaon",
          "Ramnagar",
          "Ramnagar--Jungle Lore Resort",
          "Ramnagar--Kosi River",
          "Ramnagar--Quality Inn",
          "Ranibagh",
          "Ratta Forest",
          "Raye Khata (EGS Kendra)",
          "SRCM Himalayan Ashram, Satkhol",
          "Saitoli, Nainital",
          "Salari",
          "Sandani Gaja",
          "Sargakhet",
          "Sariyatal Lake",
          "SatTal Forest Resort",
          "Satbunga",
          "Sattal",
          "Sattal Studio Bird Watching Point",
          "Sattal, Hari Lama's camp",
          "Sattal--Christian Ashram Estate",
          "Sattal--Garur Tal",
          "Sattal--Lake",
          "Sawal Deh",
          "Shining Star School area",
          "Sigri",
          "Sigri jungle camp",
          "Sitabani Mandir",
          "Sitabani Wildlife Reserve",
          "Sonapani",
          "Sunderkhal, Nainital (OBI)",
          "Sunkiya Forest",
          "Suriyagaon",
          "Syamkhat",
          "Taj Corbett",
          "Tanda Range",
          "Teda",
          "Teda Forest, Ramnagar (OBI)",
          "Thanda Pani Gujjar Basti",
          "The Banyan Retreat",
          "Tiffin Top",
          "Tiger Camp",
          "Tirangi Resort",
          "Uttarakhand Forest Training Academy (UFTA) -- Pollinator Park (Restricted Access)",
          "Uttarakhand Open University Campus",
          "Uttarakhand forestry Training Academy",
          "Village Sathkol",
          "Vinayak",
          "Vinayak Point",
          "Wild Kumaon Bird Hide",
          "dhikala zone",
          "phato",
        ],
      },
      {
        district: "Pauri Garhwal",
        localities: [
          "Aamsaur",
          "Bharsar",
          "Bhulla Tal--Lansdowne",
          "Byasi",
          "Chamoli",
          "Chaukhamb, Lansdowne Forest Division",
          "Cheela Dam, cut for Vindhya Vasini temple",
          "Chilla-Rishikesh Canal Road",
          "Corbett NP--Dhikala",
          "Corbett NP--Jhirna Range",
          "Corbett NP--Kalagarh Dam Road",
          "Corbett--Saddle Dam",
          "Dhikala, Jim corbett",
          "Dhimki, Lansdowne Forest Division",
          "Dudhatoli village",
          "Dugadda, Kotdwar Uttarakhand,",
          "Eco Wild Camp Rajaji National Park",
          "Ekeshwar",
          "Halduparao FRH, Sonanadi",
          "Halduparao Forest Rest House",
          "Jamargadi Talli, Kotdwar",
          "Jamoon",
          "Jim Corbett Tiger Reserve",
          "Juee",
          "Kalagarh Tiger Reserve",
          "Kalagarh Tiger Reserve--Sona",
          "Kalagarh Tiger Reserve--Vatanvasa",
          "Kalaghar Tiger Reserve--Jungle Camp",
          "Kalaghar Tiger Reserve--Rathuwadhab",
          "Kalaghar Tigre Reserve--Mundiyapani FRH",
          "Kamarpatta",
          "Kanda",
          "Kaudiya/Gangabhogpur -- Rajaji NP",
          "Khirsu (OBI)",
          "Kolhu Chaur, Lansdowne Forest Division",
          "Kotdwar",
          "Kotdwar-Lansdowne road--S.B. Mount Resort",
          "Lal Darvaza, Lansdowne Forest Division",
          "Landsdowne Tip N Top",
          "Lansdowne",
          "Loha Siddh, Kimsar Road",
          "Lohachaur  Forest Rest House",
          "Magpie Cottage - Dhoutiyal",
          "Mandlu to Sheela Tonk",
          "Mota Mahadev Temple",
          "Nauri, Lansdowne Forest Division",
          "Nilkanth trek",
          "Nodi Dugadda",
          "Pakhro -- Kalaghar Tiger Reserve",
          "Patna Waterfall",
          "Patna waterfall, Rishikesh",
          "Pauri (OBI)",
          "Phoolchatti",
          "Rajaji NP",
          "Rajaji NP--Ganga Bhogpur",
          "Rajaji NP--Khara",
          "Rajaji NP--Rawasan Range",
          "Rami sera",
          "Rishikesh--Laxman Jhula",
          "Saneh Kotdwar",
          "Saneh, Lansdowne Forest Division",
          "Sheela Tonk",
          "Sidhbali Mandir, Kotdwar",
          "Sigaddi",
          "Sonanadi Range",
          "Sonanadi Wildlife Sanctuary",
          "Sural",
          "Takoli",
          "The Beatles Ashram",
          "Tip in Top, Lansdowne",
          "Vanghat--Deema Range",
          "Wild Brook, Gohari Range",
        ],
      },
      {
        district: "Pithoragarh",
        localities: [
          "ATS MUNSIYARI",
          "Adi-Kailash Trek (Malpa-Kuti and Nabhidang)",
          "Askote",
          "Balati Bend",
          "Baling Village, Darma Valley",
          "Betuli-Kalamuni Road",
          "Birthi Water Falls",
          "Birthi Waterfalls",
          "Budhi",
          "Chaukori",
          "Darma Valley",
          "Dharchula",
          "Ginni Bend",
          "Haat Kalika",
          "Himkhola",
          "Jauljibi",
          "Kajera--Forest Park",
          "Kalamuni Forest Trail",
          "Kalapani",
          "Khaliya--Bhujaani Camp",
          "Khaliya--Entrance To Bhujaani Camp",
          "Khaliya--top camp",
          "Kuti Village",
          "Kwiti",
          "Linthura, Pithoragarh",
          "Madkot-Munsyari road--Kirkhet",
          "Madkote",
          "Malla Sarmoli",
          "Mallikarjun School, Madkote",
          "Malpa",
          "Martoli",
          "Meenakshi Sadan, Near Hanuman Mandir",
          "Misty Mountain",
          "Misty Mountains, Jhaltola",
          "Munsiyari--Khalia Top",
          "Munsiyari--Mesar Kund",
          "Munsyari",
          "Munsyari--Bheema Wodeyar",
          "Munsyari--Thamri kund",
          "Munsyiari - Helipad",
          "Nabhidang",
          "Nabi",
          "Namik Village",
          "Nanda Devi Mandir",
          "Narayana Ashram",
          "Panchachulli Base Camp-Igloo Hut",
          "Pancheshwar",
          "Pangu",
          "Pithoragarh",
          "Sama",
          "Sarmoli",
          "Shankhdhura Forest",
        ],
      },
      {
        district: "Rudraprayag",
        localities: [
          "Agastmuni",
          "Ansuya",
          "Baniyakund",
          "Baniyari",
          "Beda sari",
          "Beeron",
          "Bunker House, Chopta",
          "Chirbatiya",
          "Chopta",
          "Chopta Valley (OBI)",
          "Deoriatal",
          "Dever",
          "Duggalbitta",
          "Gaurikund",
          "Ghimtoli",
          "Guptakashi",
          "Indiahikes Camp -- Sari",
          "Jim Corbett Memorial, Rudraprayag",
          "Kakragaad",
          "Kanakchauri",
          "Kanchula kharak",
          "Kanda Bhardar",
          "Kantha -- Sari",
          "Karthik Swami Temple",
          "Kedarnath",
          "Kund",
          "Madhyamaheshwar",
          "Madmaheshwar trek route",
          "Madola",
          "Magpie Jungle Camp,Chopta",
          "Makku Bend",
          "Makku Farm",
          "Makkumath",
          "Mandakini Bird Camp (OBI)",
          "Narkota",
          "Phata Guptkashi",
          "Pothiwasa (OBI)",
          "Ransi-Gaundar-Madmaheshwar",
          "Rudraprayag--Town",
          "Saari Village - Mahadev Mandir",
          "Sari",
          "Silgaon Bhardar",
          "Silli",
          "Syalsour",
          "Tungnath",
          "Ukhimath ( Chopta-Guptkashi)",
        ],
      },
      {
        district: "Tehri Garhwal",
        localities: [
          "Anand Kashi by the Ganges",
          "Buddha Kedar",
          "Camp Xterra, Dehradun (OBI)",
          "Chamba",
          "Devalsari",
          "Devalsari--Deodar Ecotourism & Research Centre (DERC)",
          "Devprayag",
          "Dhanaulti",
          "Dhaula Giri",
          "Dubra (around Sadhna Cottage)",
          "Ghansali",
          "JW Marriott Mussoorie",
          "Kanatal--Horticulture Fields",
          "Kanatal--Rausli Khal",
          "Kempty Waterfalls",
          "Kith, Uttarakhand,",
          "Koti colony",
          "Kunjapuri",
          "Kunjapuri-Tapovan Rishikesh",
          "Magra Forest Rest House",
          "Mahendrapur",
          "Naag Tibba Base Camp",
          "Nag Tibba",
          "Narendra Nagar",
          "New Tehri",
          "Pantwari Village",
          "Police Training Ground, Rishikesh",
          "Rajaji NP--Gohri Range",
          "Rishikesh--Neergarh Water Fall",
          "Rishikesh--Tapovan",
          "Srinagar, Joshimath (OBI)",
          "Surkanda Devi Temple, Chamba-Mussoorie Road",
          "Taj Rishikesh Resort & Spa",
          "Tehri Garhwal (OBI)",
          "Teva Village",
          "Thatyur  (OBI)",
          "Wondrous Camp",
        ],
      },
      {
        district: "Udham Singh Nagar",
        localities: [
          "Baigul Dam",
          "Baur (Haripura) Reservoir",
          "Baur Reservoir",
          "Dhaura Reservoir, Khatima (OBI)",
          "Dhimri Khatta Tanda Range,",
          "Dhora Barrage, Kichha, Uttarakhand, IN",
          "GB Pant University, Pantnagar",
          "GHS Dhusra",
          "Gk Convent Inter College (Restricted)",
          "Government Primary School (GHS Dhusra)",
          "Innovation Public School (Restricted)",
          "Kakra crocodile park",
          "Nanak Sagar Dam",
          "Nanak Sagar Dam--Machlijaala",
          "Nanakmatta Public School (Restricted)",
          "PPSVM Inter College Nanakmatta",
          "RK Matta Higher Sec. School (Restricted)",
          "Rudrapur (OBI)",
          "Sharada Sagar",
          "Shri Guru Nanak Academy (Restricted)",
          "Tumariya Reservoir",
        ],
      },
      {
        district: "Uttarkashi",
        localities: [
          "Assi Ganga--Kuflon",
          "Barkot",
          "Barkot Road, Tunalka",
          "Barnigad Forest Rest House",
          "Barsu",
          "Bhangeli Gidara Bugyal",
          "Bhatwari",
          "Byali",
          "Chaurangi Khal",
          "Chilurgad Camp",
          "Chinyalisour",
          "Dayara Bugyal",
          "Dayara Bugyal Trek--Gui",
          "Dharwa Top",
          "Dhauntri, Uttarkashi,",
          "Dodi Tal",
          "Gangotri",
          "Gangotri National Park--Bhojbasa",
          "Govind Pashu Vihar NP & Sanctuary",
          "Har Ki Doon",
          "Har-Ki-Dun",
          "Harsil",
          "Janki Chatti",
          "Kot Bangalow, Uttarkashi",
          "Laldevta  Camp",
          "Manpur, Uttarakashi",
          "Matli, Uttarkashi",
          "Mori",
          "Munda Ka Thatthar",
          "Nelang Valley",
          "Netwar",
          "Purola",
          "Purola--Devta Range",
          "Ruinsara Lake",
          "Sankri",
          "Taluka",
          "Thandi Uttarkashi",
          "Uttarkashi",
          "Yamunotri (OBI)",
        ],
      },
    ],
  },
  {
    state: "West Bengal",
    districts: [
      {
        district: "Alipurduar",
        localities: [
          "Barobisha",
          "Bhutan Ghat AD",
          "Buxa Birding Point",
          "Buxa Forest",
          "Buxa Hill Forest AD",
          "Buxa TR-28 Mile Busti AD",
          "Buxa Tiger Reserve",
          "Buxa Tiger Reserve AD",
          "Buxa Tiger Reserve--Buxa Fort AD",
          "Buxa Tiger Reserve--Chunavati AD",
          "Buxa Tiger Reserve--Ghoradunga AD",
          "Buxa Tiger Reserve--Jainti AD",
          "Buxa Tiger Reserve--Lepchakha AD",
          "Buxa Tiger Reserve--Oumchupani AD",
          "Buxa Tiger Reserve--Raimatang AD",
          "Buxa Tiger Reserve--Rajabhatkhawa AD",
          "Buxa Tiger Reserve--Tashi Gaon",
          "Buxa Tiger Reserve-Santrabari AD",
          "Dalsingpara Tea Garden AD",
          "Gadadhar River",
          "Hasimara AD",
          "Jaigoan AD",
          "Jaldapara NP--Chilapata Reserve Forest AD",
          "Jaldapara NP--General Area",
          "Jaldapara NP--Hollong AD",
          "Jaldapara NP--Jaldapara Tourist Lodge AD",
          "Jayanti River",
          "Jayanti, Alipurduar (OBI)",
          "Khairbari Tiger Rescue Center AD",
          "Rover's point,Buxa Tiger Reserve",
          "Samrat's Hide",
          "Sikia Jhora AD",
          "The Dooars (OBI)",
          "Uttar Chakoakheti",
        ],
      },
      {
        district: "Bankura",
        localities: [
          "Bamandihi--Damodar River Bank",
          "Bardi Pahar",
          "Basudebpur",
          "Basudebpur Runway",
          "Basudebpur chatal",
          "Beliatore",
          "Bhagalpur",
          "Bhat Pushkarini",
          "Biharinath Hill",
          "Biharinath Hill Base",
          "Biharinathparbat, Saltora Road, West Bengal, IN",
          "Deuli More",
          "Durgapur Barrage",
          "Durgapur Barrage--Riverbed",
          "Dwarakeswar River Bed",
          "Gangdua Dam",
          "Hariyalgara Forest Patch",
          "Jamuna Bandh",
          "Jhero",
          "Joypur Forest",
          "Kadam Deuli Dam",
          "KalaJharia Burning Ghat PAB",
          "Keshra",
          "Kharda road",
          "Lal Bandh",
          "Mejia--Damodar River Bank",
          "Mukutmanipur",
          "Mukutmanipur Dam",
          "Mukutmanipur Dam--Sibrampur",
          "Mukutmanipur Village",
          "Munia point",
          "Near Rabindra Bhawan, Burdwan",
          "Saharjora Forest",
          "Sarigari",
          "Shivarampur Pond",
          "Sonadaha",
          "Sonamui",
          "Srirampur--Damodar River Side",
          "Sushunia",
          "Sutan Forest",
        ],
      },
      {
        district: "Birbhum",
        localities: [
          "Ajay River Bed--Deuli",
          "Ajay river area",
          "Amar Kutir",
          "Bada Simulia--Ajay River",
          "Bagdola",
          "Bakreshwar Dam (Nil Nirjon)",
          "Bakreswar Dam--Bhonra",
          "Ballavpur WLS Jheel 1",
          "Ballavpur WLS Jheel 2",
          "Ballavpur WLS--General Area",
          "Ballavpur WLS--Jheel 3",
          "Belia",
          "Bidyadharpur",
          "Bidyadharpur--Kopai River Bank",
          "Binuria Canal",
          "Chowpahari Jungle Beside BABLI Wilderness Farm",
          "Chowpahari, Islambajar, Birbhum",
          "Dakshin Harirampur",
          "Dakshin Radhanagar--Ajay River Bank",
          "Daronda",
          "Debaipur",
          "Fullara Temple",
          "Gheropara--Ajay River Bank",
          "Haripur",
          "IOCL, Paschim Bahadurpur,",
          "Ilambazar Wood Fossil Park, Lakshmipur",
          "Illambazar Forest",
          "Jagadhari",
          "Jhil No 3, BWLS,Bolpur, West Bengal, IN (23.678, 87.664)",
          "Kankalitala Temple",
          "Lalbandh",
          "Lambodarpur",
          "Langulia--Mayurakshi Riverbed",
          "Lohagarh Math",
          "Mohidapur",
          "Nalateswari Temple",
          "Nandikeshwari Temple",
          "New Ash Pond Kachujor",
          "Paruldanga",
          "Parulia",
          "Paschim Bahadurpur (IOCL)",
          "Paschim Narayanpur",
          "Santiniketan Ashrama Campus",
          "Shyor Bithi Park",
          "Sonajhuri Forest",
          "Tarapith (OBI)",
          "Tilpara Barrage",
          "Udaypur",
          "Vinaya Bhavana",
        ],
      },
      {
        district: "Cooch Behar",
        localities: [
          "Cooch Behar Railway Station",
          "Ghughumari",
          "Rasik Bill Bird Sanctuary",
          "Sagar Dighi",
          "Sagardighi Ghat",
          "Sal Bagan Park",
          "Teesta riverbank near Joyee bridge",
          "Uttar Banga Krishi Viswavidyalaya",
        ],
      },
      {
        district: "Dakshin Dinajpur",
        localities: [
          "Kaldighi Park",
          "Kumarganj Forest",
          "Punarvabha Riverbed--Gangarampur",
          "Saraihat Bajedonor Farmlands",
        ],
      },
      {
        district: "Darjeeling",
        localities: [
          "8 Mile Market DG",
          "Ahaldara-Shelphu top DG",
          "Area Near Sevoke Railway Station DG",
          "Bagdogra Airport DG",
          "Baghora Road",
          "Bagora Forest DG",
          "Bamonpokhari Forest DG",
          "Barbotey Rock Garden",
          "Batasia Eco Garden",
          "Beltar River Road",
          "Bhalukhope View Point",
          "Bhikeybhanjan DG",
          "Bijanbari",
          "Bungkulung DG",
          "Camp, Rangli Forest",
          "Chitre DG",
          "Chitre to Meghma Trek Route",
          "Chunbhatti hill cart road",
          "Darjeeling Mahakal Temple",
          "Darjeeling Mall",
          "Darjeeling Mall Road",
          "Darjeeling--General Area DG",
          "Darjeeling--Himalayan Mountaineering Institute DG",
          "Dawaipani",
          "Dawaipani (Lebong and Mineral Spring Tea Garden)",
          "Dhotrey DG",
          "Dichenla homestay, Dawaipani",
          "Dowhill (OBI)",
          "Dudhia DG",
          "Fulbari Riverside",
          "Gairibas Old Jeep Road",
          "Gairibas Trekkers Hut",
          "Gangamaya Park",
          "Gayabari",
          "Ghoom Forest",
          "Ghoom forest",
          "Ghoom to Bijanbari road",
          "Ghum Railway Station",
          "Gidda Pahar",
          "Gitingey Tea Garden DG",
          "Glenburn Tea Estate",
          "Gorkhey DG",
          "Gulma Railway Station",
          "Gurdum DG",
          "Habre's Nest",
          "Happy Valley Tea Estate",
          "Hill Cart Road birding area (Paglajhora area)",
          "Hornbill View Point",
          "Jalapahar",
          "Jore Pokhri WLS DG",
          "Jorepokhri Tourist Lodge",
          "Kaiakata DG",
          "Kalijhora DG",
          "Kalipokhri",
          "Kalpokhri to Sandakphu Trek Route",
          "Kanchenjunga Stadium",
          "Karmi Farm, Kolbong",
          "Khopidara",
          "Khoribari Village",
          "Kurseong (OBI)",
          "Lamahatta",
          "Lamahatta Eco Park",
          "Lamahatta Garden DG",
          "Lameydhura (OBI)",
          "Lat-Kothi",
          "Latpanchar",
          "Latpanchar-  Shelpu-6th Mile Rd",
          "Latpanchar--Hornbillnest Homestay",
          "Latpanchar--Nursery area",
          "Latpanchar--Stream Area",
          "Latpanchar-Kalijhora Road",
          "Lepcha Jagat",
          "Lepchajagat",
          "Lloyd Botanical Garden",
          "Lodhoma DG",
          "Lopchu khasmahal",
          "Mahaldiram",
          "Mahaldiram Forest",
          "Mahaldiram Road",
          "Mahananda WLS--General Area DG",
          "Mahananda WLS--Latpanchar",
          "Mahananda WLS--Latpanchar Forest Rest House",
          "Mahananda WLS--Nurbong Tea Garden",
          "Mahananda WLS--Rongtong and Shivakhola Forest",
          "Mahananda WLS--Sevoke DG",
          "Mahananda WLS--Sittong DG",
          "Mahananda WLS--Sukna Forest DG",
          "Mahananda Wildlife Sanctuary",
          "Mahananda wildlife Sanctuary",
          "Majua Rangeet ,Sawaji Khola River DG",
          "Makai Bari Tea Garden",
          "Makaibari Tea Estate",
          "Mall Road",
          "Mana Hills",
          "Manebhanjang DG",
          "Maney bhanjyang forest busty",
          "Mayfair Tea Resort",
          "Mim Tea Garden",
          "Mirik Bustee DG",
          "Mirik DG-Thurbo Tea Garden",
          "Mirik Lake DG",
          "Mungpoo DG",
          "Mungpoo sunttlay",
          "North Bengal University (Restricted Access) DG",
          "Nurbang",
          "Padmaja Naidu Zoological Gardens",
          "Paglajhora Falls",
          "Paglajhora Forest",
          "Palmajua Forest Road DG",
          "Pankhabari, karseong",
          "Parmaguri",
          "Parrotbill point",
          "Pasupati Nagar (OBI)",
          "Peace pagoda Darjeeling",
          "Peshok DG",
          "Pine Forest, Lepchajagat",
          "Prakashnagar (OBI)",
          "Pulung Dong",
          "Pussimbing",
          "Rampuria",
          "Rampuria Forest Village",
          "Rangaroon Tea Garden",
          "Rangbul, Old Military Rd DG",
          "Rangli Forest",
          "Rohini, on the way to Darjeeling (OBI)",
          "Rongtong",
          "Rongtong railway station",
          "Salbari Grove",
          "Sandakhphu NP",
          "Sandakphu Trekker's Hut",
          "Sandakphu to Sabargram Trek Route",
          "Senchal WLS",
          "Senchal WLS--General Area",
          "Senchal WLS--Tiger Hill DG",
          "Senchal Wildlife Sanctuary",
          "Senchal Wildlife Sanctuary--Chatakpur DG",
          "Sepi Gaon",
          "Sepoy Dhura Tea Garden",
          "Shibkhola Forest",
          "Shivkhola, Mahananda WLS",
          "Shrubbery Nightingale Park",
          "Simring Tea Garden",
          "Singalila NP-- Kaiyakata",
          "Singalila NP--Gairibas DG",
          "Singalila NP--Gairibas,",
          "Singalila NP--General Area DG",
          "Singalila NP--Lamey Dhura",
          "Singalila NP--Tumling DG",
          "Singalila NP--between Sandakphu & Kalipokhri DG",
          "Singalila NP_Kalipokhri DG",
          "Singalila NP_Phalut DG",
          "Singalila NP_Tonglu DG",
          "Singla Bazar-Rangeet River",
          "Sipohidhura",
          "Sittong",
          "Sittong Khasmahal",
          "Srikhola",
          "State Highway 12, DG",
          "Sukhia Pokhri",
          "Sukhiapokhri-Manebhajang Road",
          "Sukna  Railway Station",
          "Tabakoshi",
          "Takdah (OBI)",
          "Takdah Homestay ( Mohan's)",
          "Tea Garden Nr Shivkhola Temple",
          "Tiger Hill Patridge Point",
          "Tinchule Forest",
          "Tinchuley Village",
          "Tinchuley Village DG",
          "Tindharia",
          "Triveni DG",
          "Trogon Point",
          "Tumling to Gairibans Trek Route",
        ],
      },
      {
        district: "Hooghly",
        localities: [
          "Altara Math",
          "Baba Tarakanath Temple, Tarakeshwar",
          "Baidyabati DVC Canal",
          "Balagarh",
          "Balarampur bridge",
          "Bally Khal",
          "Bandel Church",
          "Bandel Junction Adjacent Lake",
          "Bhasha Shahid Smarak",
          "Boshipota",
          "Bosipota- Red Munia zone",
          "Champarui (Chanparui)",
          "Chandan Nagar - Narua Joramandir Tala Ponds",
          "Chandanpur",
          "Dankuni Wetland",
          "Dey Ghat",
          "Dhopaghata birding spot",
          "Diara",
          "Diara Wetlands",
          "Dunlop Estate",
          "Erenga, Polba,",
          "Haripal (OBI)",
          "Hooghly Imambara",
          "Jirat",
          "Jora Ghat",
          "Kajla Dighi",
          "Kanaipur Bheri",
          "Khushiganj",
          "Land for Tata Project, Singur",
          "Malia Park",
          "Malipukur Pond",
          "Mankundu",
          "Mollarber",
          "Nabagram 1 no. ground",
          "Nikash Agro Patch",
          "Pond off Trauma Care Centre Rd",
          "Purushottampur",
          "Serampore (OBI)",
          "Serampore College Main Campus",
          "chinsurah farm",
        ],
      },
      {
        district: "Howrah",
        localities: [
          "Acharya Jagadish Chandra Bose National Botanic Gardens",
          "Alampur",
          "Alipur, Mathapara, Shyampur",
          "Amta Grasslands",
          "Bagnan--Rupnarayan River Front",
          "Bainan",
          "Bally",
          "Bandha Ghat",
          "Bangalpur",
          "BangalpurBPS (বাঙালপুর বোর্ড প্রাথমিক বিদ্যালয়)",
          "Belur Math",
          "Benapur",
          "Bokpota",
          "Chinra",
          "Dankuni Jheel",
          "Deulpur",
          "Deulpur Panchayat",
          "Dihimandalghat",
          "Don Bosco Pond",
          "Gadiara",
          "Garchumuk Deer Park",
          "Howrah General Area (OBI)",
          "Howrah Railway Station",
          "IIEST Shibpur",
          "Jagannath Ghat",
          "Janda (ডিহিভুরসুট জাঁন্দা ঘাট)",
          "Kalbansh",
          "Khaira",
          "Khajurnan",
          "Khajutti",
          "Khalna",
          "Khalna Lake (খালনা দীঘি)",
          "Kona Bheri",
          "Lalteghar",
          "Maheshpur, Ghoshpara, Uluberia",
          "Mahishrekha Forested Patch",
          "Mohishrekha, Bagnan",
          "Narit, Amta",
          "Nayachak",
          "Near Purano, Damodar Bandh",
          "Orphuli",
          "Pal Ghat",
          "Paschim Gazipur, Amta",
          "Pragati Pathagar (প্রগতি পাঠাগার)",
          "Santragachi Jheel (Lake)",
          "Sarat Sadan",
          "Shibpur Ferry Ghat",
          "Simultala Badh Road",
          "Uluberia Railway Station",
        ],
      },
      {
        district: "Jalpaiguri",
        localities: [
          "Ananda Chandra College",
          "Ananda Chandra College campus",
          "Apalchand Forest",
          "Baikunthapur Forest",
          "Batabari",
          "Bengal Safari",
          "Bhatikhana Wetlands JG",
          "Bhorer Alo",
          "Binnaguri Cantonment JG",
          "Chalsa PWD Bungalow",
          "Chapramari Forest Railway Level crossing",
          "Chapramari WLS--Chapramari Watchtower",
          "Chapramari Wildlife Sanctuary JG",
          "Chel Bridge",
          "Dhupjhora South Park",
          "Domohani Wetland JG",
          "Domohani Wetland-2",
          "Dreamland Resort Dakshin Dhupjhora JG",
          "Fulbari Area JG",
          "Fulbari Barage",
          "Fulbari Grassland",
          "Fulbari Wetlands JG",
          "Gajoldoba Road",
          "Gajoldoba Teesta Barrage",
          "Gora More Siliguri",
          "Gorumara Elephant Camp",
          "Gorumara Jungle Camp",
          "Gorumara NP JG",
          "Gorumara NP--Jatra Prasad Watch Tower",
          "Gorumara NP--Mahakal Trail",
          "Gorumara NP--Murti Forest JG",
          "Gorumara NP_Khunia Forest JG",
          "Gorumara NP_Murti Waterhole JG",
          "Gorumara National Park",
          "Gorumara National Park--Butterfly Garden JG",
          "Gorumara National Park--Medla Watch Tower JG",
          "Gorumara National Park_Upper Tendu Range JG",
          "Gourikon Wetlands",
          "Hornbill Nest Homestay",
          "Jalpaiguri JG",
          "Jalpaiguri Tea Garden",
          "Karala River Bank",
          "Lalitabari-Gajoldoba Road JG",
          "Lataguri (OBI)",
          "Lataguri JG",
          "Mainaguri Road Wetlands JG",
          "Mal Bazar JG",
          "Manabari JG",
          "Maynaguri (OBI)",
          "Moraghat Forest JG",
          "Murti River JG",
          "Murti-WB (OBI)",
          "Neora Jungle Camp",
          "Neora Valley--Samsing KP",
          "New Jalpaiguri Railway Station",
          "Phulbari Barrage, near Siliguri (OBI)",
          "Porajhar",
          "Ramsai JG",
          "Rangdhamali (OBI)",
          "Raninagar",
          "Salugara",
          "Silpasamiti Para,Near jigpa",
          "Sinclair's Retreat JG",
          "Teesta 14 no Spur",
          "Teesta Grassland",
          "Teesta Karala Meeting Point, Jalpaiguri",
          "Teesta Riverbank near Teesta Bridge, JG",
          "Teesta Riverbed--No. 10 spar",
          "Teesta Spar JG",
          "Teesta riverbed JG",
          "Tiyabon Resort Campus JG",
        ],
      },
      {
        district: "Jhargram",
        localities: [
          "Amjharna Birding Trail",
          "Amlashol Village",
          "Amlasol Kendgora School",
          "Amlasole School",
          "Bhasraghat, JGM",
          "Brindabanpur JGM",
          "Dhangi Kusum Waterfall",
          "Dubrajpur JGM",
          "Dulung River-Kanakdurga Temple (দুলুং নদী-কনকদুর্গা মন্দির)",
          "Ghagra Waterfalls",
          "Gondapal Farmlands",
          "Hatibari Forest",
          "Jamboni Rd JGM",
          "Jhargram Deer Park surroundings JGM",
          "Jhargram Railway Station",
          "Jhilli Pakhiralay JGM",
          "Kankabati PM",
          "Kankrajhore Village",
          "Kendua , JGM-Jamboni Rd",
          "Khandarani Lake",
          "Khechenda Dam JGM",
          "Krishnapur JGM",
          "Mayurjharna Elephant Reserve--General Area",
          "Nepura",
        ],
      },
      {
        district: "Kalimpong",
        localities: [
          "ASHALE, NEORA SOUTH RANGE,SAMSING BEAT",
          "Algarah",
          "Algarah-Lava Road KP",
          "Ashaley",
          "Bagrakot",
          "Bidyang",
          "Bindu KP",
          "Buddha Pada",
          "Changey Falls KP",
          "Changey Waterfalls",
          "Charkhole KP",
          "Chel Riverbed KP",
          "Chumirchen (OBI)",
          "Delo Hills KP",
          "Dhipdara Water Falls",
          "Doarkhola",
          "Doorkhola",
          "Doorkhola View Point",
          "Gairibas_Jaldhaka region KP",
          "Garubathan - Lava Road",
          "Git Kolbong KP",
          "Gorubathan",
          "Icche Gaon, KP",
          "Jhalong KP",
          "Jhandi,Kalimpong",
          "Jhandi-- Nim Khasmahal",
          "Jhandi--Upper Lungsel KP",
          "Jhusing Village",
          "Kaffir Forest KP",
          "Kalimpong - Algarah Road",
          "Khar Khola Village Playground",
          "Khoppi",
          "Kolakham Village KP",
          "Kolbong Forest KP",
          "Kumai Tea Garden KP",
          "Ladam Road",
          "Lava Forest, Neora Valley National Park",
          "Lava Rd",
          "Lava WB Forest Dept lodge",
          "Lava- Rishop Forest Road",
          "Lava--General Area KP",
          "Lava--Pushpa Homestay Bird Hide",
          "Lava-Kolakham Forest Road KP",
          "Lingsay Khasmahal, West Bengal, IN (27.171, 88.691)",
          "Lolegaon KP",
          "Lower Rishop Road, Lava KP",
          "Lungchu village",
          "Mahananda WLS KP",
          "Mairung Forest",
          "Mairungaon (Mayrong Forest)",
          "Mangal Dham Temple KP",
          "Milan Top KP",
          "Morgan House Tourist Lodge",
          "Mouchuki Forest Bungalow",
          "Mulkharka",
          "Mulkharka/Fusrey Lake",
          "Neora Valley Jungle Camp, Kolakham KP",
          "Neora Valley NP--Bhote Kharka KP",
          "Neora Valley NP--Chaudaferi Forest Camp KP",
          "Neora Valley NP--General Area",
          "Neora Valley NP--Suntalekhola KP",
          "Neora Valley-Kuwapani",
          "Nimbong Khasmahal KP",
          "Paporkheti",
          "Paren Jaldhaka",
          "Paren KP",
          "Pedong Forest KP",
          "Ralong Road",
          "Ramdhura",
          "Ramdhura KP",
          "Ramdhura Village",
          "Raset Road KP",
          "Rikisum",
          "Rishi road",
          "Rishop - 6th Mile Road",
          "Rishop Sunrise Point",
          "Rishop--General Area KP",
          "Sakam",
          "Sambiyong Tea Garden KP",
          "Samsing",
          "Sillery Gaon KP",
          "Sirishe Gaon Village",
          "Sunakhari Sherpa Homestay",
          "Teesta Dam Lake",
          "Teesta Low Dam III KP",
          "The Exotic Hide & Perch, Noam Forest, WB, IN",
          "Tiffin Dara",
          "Todeykhola Riverbed",
          "Upper Fagu Tea Garden KP",
          "Yalbong",
          "Zang Dhok Palri Monastery KP",
        ],
      },
      {
        district: "Kolkata",
        localities: [
          "Agriculture Horticultural Society",
          "Alipore Zoo",
          "Ballygunge Science College, University of Calcutta",
          "Belgachia Veterinary Ground",
          "Belgachia Villa",
          "Bhawanipur--River Bank of Adi Ganga",
          "Brace Bridge (Historical)",
          "Chandni Chowk, Kolkata",
          "Chetla Forest",
          "College Square",
          "Deshbandhu Park",
          "Eden Gardens",
          "Esplanade Bus Stand",
          "Harish Park",
          "Hatibagan (Kolkata)",
          "Judges Ghat",
          "Kashipur Ghat",
          "Kolkata Railway Station",
          "Kumartuli Park",
          "Maidan",
          "Mallick Ghat",
          "Millennium Park",
          "National Library",
          "New Alipore Triangular Park",
          "Nimtala Ghat",
          "Northern Park",
          "Orbit Pond",
          "Prinsep Ghat",
          "Rabindra Sarovar (including Lion's Safari Park)",
          "Rawdon Square",
          "Roypara Khelar Math",
          "St Paul's Cathedral",
          "Strand Bank Road",
          "Subhas Sarobar Park",
          "Subhash Sarobar",
          "Tala Park",
          "Taratala Nature Park",
          "Victoria Memorial",
        ],
      },
      {
        district: "Malda",
        localities: [
          "Aamjaam Tola Birding Area",
          "Adina Deer Park",
          "Atla Beel, Begunbari",
          "Baharal",
          "Bamangola",
          "Bara Beel and Mahan Beel",
          "Bara Sagardighi Fish Farm",
          "Bhatra Beel",
          "Bishnuprasad",
          "Bolatuli Beel",
          "Chhatra Beel",
          "Dahala Wetland",
          "Dari Doba Beel",
          "Dharampur",
          "Farakka Barrage--Kargil Chaur",
          "Farakka IBA Panchanandapur",
          "Firoz Minar",
          "Gour Road and Ruins Of Gour",
          "Hatimari Salbona Forest",
          "Jagjibanpur at Habibpur Block",
          "Jatradanga Forest",
          "Jote Gopal",
          "Kanturka",
          "Karja Danga Forest Beat",
          "Khorda Jalalpur",
          "Kumarganj",
          "Mahakalbona Beel",
          "Mahananda River",
          "Malda Aerodrome",
          "Malda District",
          "Malda Food park",
          "Malda Town",
          "Manikchak Ghat Road",
          "Manikchak, Mango Orchards Behind Sikkha Niketan HS",
          "Muchia Birding Site",
          "Nagri River between Boirgachi and Joyhat",
          "Nalagola",
          "Nawabganj Badonpur Birding Area",
          "Nawada",
          "Naya Bundh Wetland Complex (IBA)",
          "Pathar Khairan--Jamalpur Forest Beat",
          "Rabindra Bhavan",
          "Ramnagar--Fulahar Riverbank Malda",
          "Singabad Tilason",
          "Sohorol Forest, Rajadighi Forest Beat",
          "Sohorol Forest--Rajadighi Forest Beat",
        ],
      },
      {
        district: "Murshidabad",
        localities: [
          "Ahiron Wetland",
          "Andulia",
          "Ash Pond of Farakka Thermal Power Project",
          "Atchala Bagan (আটচালা বাগান)",
          "Augram",
          "Bachra Kamartala",
          "Barobigha Kobarkhana",
          "Bazarsau",
          "Bazarsau Railway Station adjacant area",
          "Bazarsau Talikhola",
          "Bhandardaha Bill",
          "Bhundar Kismat",
          "Bidupara",
          "Binpara",
          "Bishurpukur",
          "Catholic Church",
          "Chaltia Bil",
          "Char Babupur",
          "Charnarayanpur",
          "Chuanpore Power Station",
          "Chumarigacha",
          "Chumrigacha",
          "Chunapure",
          "Cossimbazar, Kati Ganga",
          "Dafarpur Bill",
          "Dakshin Hijal",
          "Dayanagar Kuthipara Oxbow Lake",
          "Dukhur Bil",
          "Farakka Barrage Tal Tola Ghat",
          "Farakka Barrrage",
          "Gajdhar para",
          "Gangarampur Village",
          "Gholla Beel",
          "Gorabajar",
          "Gorduara Land Registration office",
          "Gouripur Beel",
          "Hazarduari Palace",
          "Kadkhali",
          "Kalaberia",
          "Kalyanpur",
          "Kalyanpur Bogari Math",
          "Kamal Beel",
          "Kandi",
          "Kandi Bus Stand",
          "Karna Subarna bheel",
          "Katra masjid",
          "Khagraghat",
          "Khairamari Bill",
          "Kiriteswari Temple",
          "Korea",
          "Krishnanath College Ghat",
          "Lalbag Court Station",
          "Lalnagar",
          "Majhdiya",
          "Manganpara Char",
          "Matiara",
          "Mehedipur Bypass",
          "Monigram Ash Pond",
          "Motijheel park",
          "Nabagram",
          "Nonai Bridge",
          "Old Karbala",
          "Pakuria",
          "Patamari Village",
          "Pulinda",
          "Ramnagar Bachra Bill",
          "Rampara",
          "Sagardighi Ash Pond",
          "Sahajadpur",
          "Sahapur Beel (Beelkurul)",
          "Saktipur Sosan Ghat",
          "Sargachhi",
          "Sekedarpur Chorer Gaba",
          "Sheal mara bill",
          "Sheeal Lake",
          "Shibnagar Ferry Ghat",
          "Shipataluk",
          "Sujapur Oxbow Lake",
          "Sundalpur Ferry Ghat",
          "Sundoriya Bill",
          "Telkar Beel",
          "Tikli Char (টিকলি চর)",
        ],
      },
      {
        district: "Nadia",
        localities: [
          "Bahadurpur Forest",
          "Bahadurpur Reserve Forest",
          "Bahadurpur Village",
          "Bahirgachi",
          "Balakhana Estate, Maheshganj",
          "Bangabani Ghat,Nabadwip",
          "Bethuadahari WLS",
          "Dayer Bazar Forest",
          "Debagram Forest",
          "Haringhata power house",
          "Hijuli Forest",
          "ISKCON Temple Mayapur",
          "Indian Institute of Science Education and Research (IISER) Kolkata",
          "Jaguli Grassland",
          "Jaguli Woodland",
          "Jugpur Forest",
          "Kalyani Lake Park",
          "Kamalapur",
          "Khisma Forest",
          "Krishnanagar Rajbari",
          "Kulgachi Forest",
          "Kulia Jhill",
          "Mahisura",
          "Majherchar",
          "Mangaldeep Char",
          "Mayapur Ghat",
          "Nabadwip Ghat",
          "Nabadwip--Hooghly Bank",
          "Nayachar",
          "Nidaya ghat",
          "Patikabari",
          "Raghunathpur Forest",
          "Rawtara Oxbow lake",
          "Saheb Bagan",
          "Sambhunagar",
          "Shankarpur Forest",
        ],
      },
      {
        district: "North 24 Parganas",
        localities: [
          "AD Block Canal side Park",
          "Adamas University",
          "Aminpur",
          "Bagjola Military Camp",
          "Bally Bridge",
          "Bangaon Forested Patch",
          "Barasat Government College",
          "Barbaria Beel",
          "Barrackpore Dhobighat Adjacent area",
          "Bazetaraf",
          "Beliaghata Wetland",
          "Bibhutibhushan WLS",
          "Bonhoogly Lake",
          "Boro Bil",
          "Bortibeel",
          "Bortir Bil",
          "CCU- Kolkata Airport, 176/1A Maniktala Main Road, Kolkata, West Bengal, IN (22.642, 88.434)",
          "Cando Infospace",
          "Central Park (Banabitan)",
          "Corner Plot ST 706 x ST 777",
          "Dakshineswar Kali Temple",
          "Dhanyakuria, Nadia",
          "Duttabad,Salt Lake",
          "Eastland Jheel",
          "Eco Park",
          "Eco Park--Butterfly Garden",
          "Eco Urban Village",
          "Fatuapur - Milangarh",
          "Fishery Ponds beside Thakdari Road",
          "Guru Nanak College Campus",
          "Halisahar Railway Yard",
          "Hansia Bortir Beel",
          "Harinalaya Eco Park Zoo",
          "Hooghly, West Bengal (OBI)",
          "ISI Kolkata",
          "Jawahar Kunj",
          "Kadampukur Wetlands",
          "Kamalapur Jheel",
          "Kamarganti",
          "Kamduni",
          "Kharibari",
          "Kharibari (Rajarhat)",
          "Kheblir Beel",
          "Kolkata, West Bengal (OBI)",
          "Lake Town, Lake No 1",
          "Mahish Bathan",
          "Majumder Para Pond",
          "Mangal Pandey Park",
          "Mathura Bil",
          "Mitpukur",
          "Mudia",
          "Nalban Bheri",
          "Nandagarh, Barasat",
          "Navadarsha Co-operative Housing Society",
          "Netaji Colony",
          "Netaji Shubhash Chandra Bose International Airport",
          "New Barrackpore, Kolkata",
          "New Barrackpur, Kolkata",
          "Newtown-Muhammadpur Canalside",
          "Nicco Park",
          "P.R. Thakur Government College",
          "Patharghata",
          "Phase I Canal AK Block",
          "R.B.G. Mukherjee Road, Panihati",
          "Rajarhaat Canal Area Beside ST 380",
          "Rajarhat Grassland near Aliah University Bus Stop",
          "Rajarhat NKDA Park",
          "Rajarhat Wetland--Canal side only",
          "Rajarhat Wetland--Opposite New Stadium",
          "Rajarhat Wetlands I",
          "Rajarhat Wetlands--Near Jatragachhi Flyover",
          "Rajarhat Wetlands--Proposed Silicon Valley",
          "Sahapur",
          "Saheb Bagan Kadampukur New Town",
          "Samsernagar",
          "Sandeshkhali PWD Bunglow",
          "Sarojini Naidu College for Women",
          "Shanpukur Mathpara",
          "Shapoorji Complex",
          "Shribhumi, Kolkata (OBI)",
          "Vedic Village (OBI)",
          "Vedic Village Spa Resort",
          "Wireless Ground",
        ],
      },
      {
        district: "Paschim Bardhaman",
        localities: [
          "Ambuja Wetland PAB",
          "Andal Old Aerofield PAB",
          "Asansol Railway Station",
          "B. B. College, Asansol PAB",
          "Bhuta Buri Mandir",
          "Deul Forest",
          "Durgapur Government College",
          "Durgapur Steel Plant Airport PAB",
          "Faridpur",
          "Gandhi More PAB",
          "Garh Jungle",
          "Gunjan Ecological Park",
          "Gunjan ecological park PAB",
          "Hanuman Mandir Dam PAB",
          "Hirapur MCT Institution",
          "Karnail Singh Park PAB",
          "Kulti",
          "Madhaiganj Forest",
          "Madhaigunj Jagannathpur Old Runway",
          "Maithon Dam PAB",
          "Maithon Dam--Majhladi",
          "Mohishila Colony",
          "Mohon Kumar Mangalam Park PAB",
          "National Institute of Technology, Durgapur",
          "Pardaha PAB",
          "Sankarpur Outskirts, Durgapur PAB",
        ],
      },
      {
        district: "Paschim Medinipur",
        localities: [
          "Airbase ,Kharagpur PM",
          "Arabari PM",
          "Bandhi",
          "Barkola wetland",
          "Belia Farmlands",
          "Bhadutola Reserve Forest PM",
          "Birsingha PM",
          "Chowringee PM",
          "Cossye river bank PM",
          "Dalapatipur Village",
          "Ghuchisol PM",
          "Gokulpur",
          "Gopegarh PM",
          "Gymkhana Island",
          "Hijli Forest PM",
          "IIT-KGP Nalanda Complex Pond, WB-IN (22.318, 87.315)",
          "Indian Institute of Technology (IIT) Kharagpur",
          "Kangshabati River bank",
          "Keshiary PM",
          "Khajra",
          "Kharagpur Railway Station",
          "Koilash",
          "Kunjapur (OBI)",
          "Midnapur (OBI)",
          "Nandapur--Kapaleswari River Bank PM",
          "Parimal Kanan PM",
          "Rajagram PM",
          "Rampur (OBI)",
          "Rampur Village (OBI)",
          "Salua Forest Renge PM",
          "Sijua PM",
          "Tamlipara , School Bazar PM",
        ],
      },
      {
        district: "Purba Bardhaman",
        localities: [
          "Ajay Baandh",
          "Alefnagar",
          "Ambalgram--Shibai River Bank",
          "Aogram",
          "Ausgram",
          "Barshul Ferry Ghat PUB",
          "Barshul--Bajeshalepur",
          "Begor Mukh PUB",
          "Belun Village",
          "Borshul--Dakshin Gopalpur",
          "Choitpukur",
          "Department Of Zoology, Burdwan University",
          "Durga Ghat Chor (Behind Kalna Court)",
          "GGDC Mangalkote",
          "Harishaba Park",
          "Hedogora",
          "Idilpur",
          "Isufabad--DVC Canal Bank",
          "Jhamatpur Bahran",
          "Kalna Rajbari Ground",
          "Kankurhati--Ajay River Bank",
          "Karjana Pond (Pakhiralay Pond)",
          "Mahagama PUB",
          "Majkhanra",
          "Mettalar Char (mudflats)",
          "Mettalar Char, Kashthasali PUB",
          "Nazi Pukur - Burdwan",
          "Purbasthali Bird Sanctuary PUB",
          "Purbasthali Oxbow Lake",
          "Ramnabagan WLS",
          "Roop Sayar",
          "SIPHON DVC CANAL PUB",
          "Sadarghat Damodar River Bank PUB",
          "Tarabagh Officers Colony",
          "The University of Burdwan",
          "University Institute Of Technology",
          "University of Burdwan, Golapbag Campus",
        ],
      },
      {
        district: "Purba Medinipur",
        localities: [
          "Baguran Jalpai Beach",
          "Bakiput",
          "Begunbari",
          "Deulia Bheri",
          "Digha",
          "Digha Shankarpur estuary",
          "Diglabar",
          "Hijli Sea Beach",
          "Jaldha",
          "Kanai chatta",
          "Kotlauri Bhagabanpur",
          "Mandarmani",
          "Mandarmani--Fisherman's Beach",
          "Maroberia--Rupnarayan River Shamshankali Temple (শ্মশানকালী মন্দির)",
          "Mayachar",
          "Meidinagar Beach",
          "Moyna",
          "Panskura Railway Station",
          "Patanda (OBI)",
          "Pitambarchak (OBI)",
          "Sasan Kali Road",
          "Tajpur",
          "Tamluk",
          "Tamluk Steamer Ghat",
          "Vidyasagar Park",
        ],
      },
      {
        district: "Purulia",
        localities: [
          "Ajodhya Hill--General Area",
          "Ajodhya Hills Rd.",
          "Ajodhya Hills Road--Marang Buru View Point",
          "Ajodhya Hills, Purulia, West Bengal",
          "Asanpani",
          "Balrampur",
          "Bamni Falls",
          "Bara Panjania Hills",
          "Baranti Reservoir",
          "Bathandhi hills",
          "Brinchinath Dhaam",
          "Chemta, Jhalda (OBI)",
          "Chharra Airstrip",
          "Chharrah",
          "Duarsini",
          "Durga Bera Dam",
          "Forest Trail opp. Ajodhya Eco Nest",
          "Futiyari Dam",
          "Gajraidi",
          "Garh Panchkot--Lalpur",
          "Garpanchkot",
          "Garpanchkot WBFDC Nature Resort",
          "Jhalda",
          "Kuki Dam",
          "Kumari Dam",
          "Marble Lake",
          "Math Forest Resort",
          "Matha Forest",
          "Murguma Dam",
          "Pakhi Pahar",
          "Raghunathpur",
          "Rani Bandh",
          "Ranjandih Dam",
          "Saheb Bandh",
          "Sidho-Kanho-Birsha University",
          "Sindurpur Hill",
          "Sirkabad Sugar Cane Field",
          "Sirkabad/Kalabani Sugarcane Fields",
          "Sponsored Teachers Training College (Restricted)",
          "Telidih",
          "Telkupi",
          "Tenyasi--Dhol Buru",
          "Thurga Dam",
          "Turga Falls",
          "Upper Dam Crossing, Northward Dirt Road",
        ],
      },
      {
        district: "South 24 Parganas",
        localities: [
          "Ahalyanagar Wetland",
          "Akra Footghat Riverside",
          "Amlamethi Chaar",
          "Aquatica",
          "Bakkhali Beach",
          "Bakkhali Bus Stand",
          "Bakkhali Casuarina Grove",
          "Bakkhali Eco Park & Tents",
          "Bakkhali Village",
          "Bakkhali--Phalarope Pond",
          "Bali Island-Bali Village",
          "Ballygunge Station",
          "Baruipur Birding (Waterbird Area)",
          "Baruipur Marshes",
          "Bata Club",
          "Beach between Frasergunj and Bakkhali",
          "Behala Flying Club Road",
          "Bengal Badminton Academy",
          "Bhasha-Parbatipur Grassland",
          "Bonnie Camp",
          "Buderhat Lake",
          "Burirdabri",
          "Chak Garia Wetland",
          "Chintamani Kar Bird Sanctuary (CKBS)",
          "Chowbaga Canal Side Road",
          "Dhapa Garbage Dump",
          "Dhyan Ashram Wetland",
          "Dingelpota",
          "Dulki 24S",
          "Elachi",
          "Falta",
          "Fishery Ponds around Hatgachia and Dharmatala Pachuria",
          "Frazerganj Beach",
          "Frazergunj Village",
          "Ganga Joara Road",
          "Genexx Valley Community",
          "Ghoramara Island",
          "Gitanjali Park",
          "Gopalpur",
          "Gosaba Ferry Ghat",
          "Green View",
          "Halliday Island WLS--General Area",
          "Hanspukuria Joka Canal Rd",
          "Haridevpur Pukur",
          "Haripur Char",
          "Hatishala Wetlands (Behind ITC Infotech)",
          "Henry Island--Fishponds",
          "Henry Island--Mangroves & Beach",
          "Hindustan Park Pond",
          "Hussainpur Wetland",
          "Indian Institute of Management, Calcutta (IIM Calcutta)",
          "Jadavpur CR Colony",
          "Jadavpur University (Restricted Access)",
          "Jadu Mitra Colony Pond",
          "Jambu Dweep Sandbar",
          "Jharkhali",
          "Jharkhali dock",
          "Jodhpur Park",
          "Joka Chotokachari",
          "Joka Wetlands",
          "Joka Wetlands (Historical)",
          "Kalikapur Wetlands",
          "Kalisthan (Lalgunj) Beach",
          "Kargil Beach",
          "Koikhali (OBI)",
          "Lothian Island WLS--General Area",
          "Mallikpur Dakshin Hindupara",
          "Masjid Bari Road",
          "Master Society Marshes",
          "Matla River Bank, Canning",
          "Merlin Greens",
          "Mirania Bheri",
          "Monmohan park",
          "Mousuni Island Beach",
          "Mouth of Ganges",
          "Namkhana",
          "Narendrapur (OBI)",
          "Nepalganj",
          "Noorpur",
          "Nuner Bheri",
          "Oxidation Pond",
          "Pailan, Kolkata (OBI)",
          "Pakhiralay Village",
          "Pashchim Putiary Jheel",
          "Patibunia Beach",
          "Patuli",
          "Piyali Island Tourist Lodge",
          "Pond opposite Banbibi temple",
          "Raghabpur",
          "Raichak (OBI)",
          "Rajarhat New Town (OBI)",
          "Sagar Island",
          "Sankharipota",
          "Sarkarpool Wetland",
          "Sarsuna 3 no Jhill",
          "Satyajit Ray Film and Television Institute",
          "Science City",
          "Shaharhat",
          "Shahid Smriti Colony Wetland",
          "Shyamkhola",
          "Sonarpur, Kolkata (OBI)",
          "Sun City",
          "Sundarban Jungle Camp",
          "Sundarban NP--Bonnie Camp",
          "Sundarban Tiger Reserve--Dobanki Camp",
          "Sundarban Tiger Reserve--General Area",
          "Sundarban Tiger Reserve--Kendo Island",
          "Sundarbans NP--Sudhanyakhali Watch Tower",
          "Sundarbans Tiger Reserve - West",
          "Sunderbans Tiger Reserve--Chamta Camp",
          "Sundorban",
          "Survey Park",
          "Tollygunge Club",
          "Vidyasagar State General Hospital Pond",
          "Vijaygarh Jyotish Ray College",
          "Vivekananda College",
          "Wild Corridor Nature Study Centre",
        ],
      },
      {
        district: "Uttar Dinajpur",
        localities: [
          "Abdulghata",
          "Abdulghata Farmlands",
          "Abdulghata Forest",
          "Baharail Forest",
          "Dwiprajar Dighi",
          "Nehari Beel",
          "Raiganj Bird Sanctuary",
          "Raiganj Bypass",
          "Youth Hostel  (Karnajora)",
        ],
      },
    ],
  },
];
